[
  {
    "ID": "1",
    "nom_corrige2": "Martin Damphousse",
    "nom_famille": "Damphousse",
    "titre_genre2": "Maire",
    "remuneration": "100368",
    "allocation": "17546",
    "remuneration2": "94132",
    "allocation2": "0",
    "total": "212046",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "2",
    "nom_corrige2": "Valérie Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Mairesse",
    "remuneration": "121193",
    "allocation": "17492",
    "remuneration2": "73179",
    "allocation2": "0",
    "total": "211864",
    "ville": "Montréal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "3",
    "nom_corrige2": "Jonathan Tabarah",
    "nom_famille": "Tabarah",
    "titre_genre2": "Conseiller",
    "remuneration": "171580",
    "allocation": "17546",
    "remuneration2": "13187",
    "allocation2": "0",
    "total": "202313",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "4",
    "nom_corrige2": "Mathieu Traversy",
    "nom_famille": "Traversy",
    "titre_genre2": "Maire",
    "remuneration": "120788",
    "allocation": "17546",
    "remuneration2": "58612",
    "allocation2": "0",
    "total": "196947",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "5",
    "nom_corrige2": "Stéphane Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Maire",
    "remuneration": "114629",
    "allocation": "17546",
    "remuneration2": "64751",
    "allocation2": "0",
    "total": "196926",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "6",
    "nom_corrige2": "Bruno Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Maire",
    "remuneration": "176208",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "193754",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "7",
    "nom_corrige2": "Luc Rabouin",
    "nom_famille": "Rabouin",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "139115",
    "allocation": "17492",
    "remuneration2": "35000",
    "allocation2": "0",
    "total": "191607",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "8",
    "nom_corrige2": "Benoit Dorais",
    "nom_famille": "Dorais",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "166521",
    "allocation": "17492",
    "remuneration2": "7500",
    "allocation2": "0",
    "total": "191513",
    "ville": "Montréal",
    "arrondissement": "Sud-Ouest",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "9",
    "nom_corrige2": "Michel Angers",
    "nom_famille": "Angers",
    "titre_genre2": "Maire",
    "remuneration": "115540",
    "allocation": "17546",
    "remuneration2": "55765",
    "allocation2": "0",
    "total": "188851",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "10",
    "nom_corrige2": "Catherine Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Mairesse",
    "remuneration": "106462",
    "allocation": "17546",
    "remuneration2": "64751",
    "allocation2": "0",
    "total": "188759",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "11",
    "nom_corrige2": "Dominique Ollivier",
    "nom_famille": "Ollivier",
    "titre_genre2": "Conseillère",
    "remuneration": "135330",
    "allocation": "17492",
    "remuneration2": "35000",
    "allocation2": "0",
    "total": "187822",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "12",
    "nom_corrige2": "Évelyne Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Mairesse",
    "remuneration": "169202",
    "allocation": "17546",
    "remuneration2": "596",
    "allocation2": "0",
    "total": "187344",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "13",
    "nom_corrige2": "MIGUEL LEMIEUX",
    "nom_famille": "LEMIEUX",
    "titre_genre2": "Maire",
    "remuneration": "111039",
    "allocation": "17546",
    "remuneration2": "58700",
    "allocation2": "0",
    "total": "187285",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "14",
    "nom_corrige2": "Stéphanie Lacoste",
    "nom_famille": "Lacoste",
    "titre_genre2": "Mairesse",
    "remuneration": "126262",
    "allocation": "17546",
    "remuneration2": "40746",
    "allocation2": "0",
    "total": "184554",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "15",
    "nom_corrige2": "Gilles Lehouillier",
    "nom_famille": "Lehouillier",
    "titre_genre2": "Maire",
    "remuneration": "165285",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "182831",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "16",
    "nom_corrige2": "Doreen Assaad",
    "nom_famille": "Assaad",
    "titre_genre2": "Mairesse",
    "remuneration": "103144",
    "allocation": "17456",
    "remuneration2": "61195",
    "allocation2": "0",
    "total": "181795",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "17",
    "nom_corrige2": "Guillaume Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Maire",
    "remuneration": "94282",
    "allocation": "17546",
    "remuneration2": "69451",
    "allocation2": "0",
    "total": "181279",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "18",
    "nom_corrige2": "France Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Mairesse",
    "remuneration": "163595",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "181141",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "19",
    "nom_corrige2": "Caroline Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "163621",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "181113",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "20",
    "nom_corrige2": "Patrick Bousez",
    "nom_famille": "Bousez",
    "titre_genre2": "Maire",
    "remuneration": "18147",
    "allocation": "9073",
    "remuneration2": "143873",
    "allocation2": "8175",
    "total": "179268",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "21",
    "nom_corrige2": "Pierre Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Maire",
    "remuneration": "106076",
    "allocation": "17592",
    "remuneration2": "53575",
    "allocation2": "0",
    "total": "177243",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "22",
    "nom_corrige2": "Julie Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Mairesse",
    "remuneration": "159048",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "176642",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "23",
    "nom_corrige2": "Patrick Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Maire",
    "remuneration": "145751",
    "allocation": "17541",
    "remuneration2": "13062",
    "allocation2": "0",
    "total": "176354",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "24",
    "nom_corrige2": "Denis Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Maire",
    "remuneration": "88434",
    "allocation": "17546",
    "remuneration2": "68782",
    "allocation2": "0",
    "total": "174762",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "25",
    "nom_corrige2": "Émilie Thuillier",
    "nom_famille": "Thuillier",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "156561",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "174053",
    "ville": "Montréal",
    "arrondissement": "Ahuntsic-Cartierville",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "26",
    "nom_corrige2": "Marc Bourcier",
    "nom_famille": "Bourcier",
    "titre_genre2": "Maire",
    "remuneration": "153758",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "171304",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "27",
    "nom_corrige2": "Mario Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Maire",
    "remuneration": "98411",
    "allocation": "17546",
    "remuneration2": "54893",
    "allocation2": "0",
    "total": "170850",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "28",
    "nom_corrige2": "Éric Alan Caldwell",
    "nom_famille": "Caldwell",
    "titre_genre2": "Conseiller",
    "remuneration": "116978",
    "allocation": "17492",
    "remuneration2": "34800",
    "allocation2": "0",
    "total": "169270",
    "ville": "Montréal",
    "arrondissement": "Mercier - Hochelaga-Maisonneuve",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "29",
    "nom_corrige2": "Jean Lamarche",
    "nom_famille": "Lamarche",
    "titre_genre2": "Maire",
    "remuneration": "149912",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "167458",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "30",
    "nom_corrige2": "LIZA POULIN",
    "nom_famille": "POULIN",
    "titre_genre2": "Mairesse",
    "remuneration": "103996",
    "allocation": "17534",
    "remuneration2": "45163",
    "allocation2": "128",
    "total": "166821",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "31",
    "nom_corrige2": "Éric Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Maire",
    "remuneration": "108904",
    "allocation": "17543",
    "remuneration2": "40131",
    "allocation2": "0",
    "total": "166578",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "32",
    "nom_corrige2": "Eric Westram",
    "nom_famille": "Westram",
    "titre_genre2": "Maire",
    "remuneration": "70598",
    "allocation": "17546",
    "remuneration2": "76111",
    "allocation2": "0",
    "total": "164255",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "33",
    "nom_corrige2": "Julie Bourdon",
    "nom_famille": "Bourdon",
    "titre_genre2": "Mairesse",
    "remuneration": "120432",
    "allocation": "17543",
    "remuneration2": "24880",
    "allocation2": "0",
    "total": "162855",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "34",
    "nom_corrige2": "Sylvain Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "83298",
    "allocation": "17492",
    "remuneration2": "61191",
    "allocation2": "0",
    "total": "161981",
    "ville": "Montréal",
    "arrondissement": "Villeray - Saint-Michel - Parc-Extension",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "35",
    "nom_corrige2": "Guy Pilon",
    "nom_famille": "Pilon",
    "titre_genre2": "Maire",
    "remuneration": "116137",
    "allocation": "17546",
    "remuneration2": "17955",
    "allocation2": "9500",
    "total": "161138",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "36",
    "nom_corrige2": "Jean Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Maire",
    "remuneration": "106661",
    "allocation": "17546",
    "remuneration2": "35846",
    "allocation2": "0",
    "total": "160053",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "37",
    "nom_corrige2": "Maja Vodanovic",
    "nom_famille": "Vodanovic",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "142090",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "159582",
    "ville": "Montréal",
    "arrondissement": "Lachine",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "38",
    "nom_corrige2": "Robert Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseiller",
    "remuneration": "134370",
    "allocation": "17492",
    "remuneration2": "5500",
    "allocation2": "0",
    "total": "157362",
    "ville": "Montréal",
    "arrondissement": "Ville-Marie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "39",
    "nom_corrige2": "Marie-Andrée Mauger",
    "nom_famille": "Mauger",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "132721",
    "allocation": "17492",
    "remuneration2": "5500",
    "allocation2": "0",
    "total": "155713",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "40",
    "nom_corrige2": "Sophie Mauzerolle",
    "nom_famille": "Mauzerolle",
    "titre_genre2": "Conseillère",
    "remuneration": "132311",
    "allocation": "17492",
    "remuneration2": "3500",
    "allocation2": "0",
    "total": "153303",
    "ville": "Montréal",
    "arrondissement": "Ville-Marie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "41",
    "nom_corrige2": "Nicolas Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Maire",
    "remuneration": "114886",
    "allocation": "17546",
    "remuneration2": "19801",
    "allocation2": "0",
    "total": "152233",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "42",
    "nom_corrige2": "Magda Popeanu",
    "nom_famille": "Popeanu",
    "titre_genre2": "Conseillère",
    "remuneration": "133937",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "151429",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "43",
    "nom_corrige2": "Marie-Josée Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseillère",
    "remuneration": "133141",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "150687",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "44",
    "nom_corrige2": "Pierre-Luc Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "133141",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "150687",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "45",
    "nom_corrige2": "François Limoges",
    "nom_famille": "Limoges",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "111963",
    "allocation": "17492",
    "remuneration2": "21000",
    "allocation2": "0",
    "total": "150455",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "46",
    "nom_corrige2": "Pierre Lessard-Blais",
    "nom_famille": "Lessard-Blais",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "132786",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "150278",
    "ville": "Montréal",
    "arrondissement": "Mercier - Hochelaga-Maisonneuve",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "47",
    "nom_corrige2": "Affine Lwalalika",
    "nom_famille": "Lwalalika",
    "titre_genre2": "Conseillère",
    "remuneration": "132151",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "149697",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "48",
    "nom_corrige2": "Sylvain Joly",
    "nom_famille": "Joly",
    "titre_genre2": "Conseiller",
    "remuneration": "129859",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "147405",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "49",
    "nom_corrige2": "Christine Beaudette",
    "nom_famille": "Beaudette",
    "titre_genre2": "Mairesse",
    "remuneration": "103812",
    "allocation": "17546",
    "remuneration2": "24765",
    "allocation2": "0",
    "total": "146123",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "50",
    "nom_corrige2": "Pierre Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Maire",
    "remuneration": "63581",
    "allocation": "17546",
    "remuneration2": "64405",
    "allocation2": "0",
    "total": "145532",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "51",
    "nom_corrige2": "Andrée Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Mairesse",
    "remuneration": "118105",
    "allocation": "17546",
    "remuneration2": "8553",
    "allocation2": "0",
    "total": "144204",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "52",
    "nom_corrige2": "Sébastien Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Maire",
    "remuneration": "75898",
    "allocation": "17546",
    "remuneration2": "50404",
    "allocation2": "0",
    "total": "143848",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "53",
    "nom_corrige2": "Jules Dagenais",
    "nom_famille": "Dagenais",
    "titre_genre2": "Maire",
    "remuneration": "100861",
    "allocation": "15979",
    "remuneration2": "26669",
    "allocation2": "0",
    "total": "143509",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "54",
    "nom_corrige2": "Mathieu Maisonneuve",
    "nom_famille": "Maisonneuve",
    "titre_genre2": "Maire",
    "remuneration": "102500",
    "allocation": "17546",
    "remuneration2": "23350",
    "allocation2": "0",
    "total": "143396",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "55",
    "nom_corrige2": "Alan DeSousa",
    "nom_famille": "Desousa",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "99743",
    "allocation": "17492",
    "remuneration2": "26041",
    "allocation2": "0",
    "total": "143276",
    "ville": "Montréal",
    "arrondissement": "Saint-Laurent",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "56",
    "nom_corrige2": "Guy Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "122090",
    "allocation": "17496",
    "remuneration2": "3576",
    "allocation2": "0",
    "total": "143162",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "57",
    "nom_corrige2": "Alain Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseiller",
    "remuneration": "124680",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "142172",
    "ville": "Montréal",
    "arrondissement": "Sud-Ouest",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "58",
    "nom_corrige2": "Alex Norris",
    "nom_famille": "Norris",
    "titre_genre2": "Conseiller",
    "remuneration": "117582",
    "allocation": "17492",
    "remuneration2": "5500",
    "allocation2": "0",
    "total": "140574",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "59",
    "nom_corrige2": "Marjolaine Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "115023",
    "allocation": "17546",
    "remuneration2": "6000",
    "allocation2": "0",
    "total": "138569",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "60",
    "nom_corrige2": "Laurence Lavigne Lalonde",
    "nom_famille": "Lavigne",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "104268",
    "allocation": "17492",
    "remuneration2": "16000",
    "allocation2": "0",
    "total": "137760",
    "ville": "Montréal",
    "arrondissement": "Villeray - Saint-Michel - Parc-Extension",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "61",
    "nom_corrige2": "Gaétan Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Maire",
    "remuneration": "65528",
    "allocation": "17546",
    "remuneration2": "54112",
    "allocation2": "0",
    "total": "137186",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "62",
    "nom_corrige2": "Gracia Kasoki Katahwa",
    "nom_famille": "Kasoki",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "93400",
    "allocation": "17492",
    "remuneration2": "26016",
    "allocation2": "0",
    "total": "136908",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "63",
    "nom_corrige2": "Christian Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Maire",
    "remuneration": "71377",
    "allocation": "17546",
    "remuneration2": "47884",
    "allocation2": "0",
    "total": "136807",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "64",
    "nom_corrige2": "Frédéric Galantai",
    "nom_famille": "Galantai",
    "titre_genre2": "Maire",
    "remuneration": "84241",
    "allocation": "17546",
    "remuneration2": "23028",
    "allocation2": "11514",
    "total": "136329",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "65",
    "nom_corrige2": "ANTOINE TARDIF",
    "nom_famille": "TARDIF",
    "titre_genre2": "Maire",
    "remuneration": "111419",
    "allocation": "17532",
    "remuneration2": "6764",
    "allocation2": "0",
    "total": "135715",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "66",
    "nom_corrige2": "Ray Khalil",
    "nom_famille": "Khalil",
    "titre_genre2": "Conseiller",
    "remuneration": "117829",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "135375",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "67",
    "nom_corrige2": "Christian Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Maire",
    "remuneration": "92539",
    "allocation": "17546",
    "remuneration2": "25077",
    "allocation2": "0",
    "total": "135162",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "68",
    "nom_corrige2": "Martine Musau Muele",
    "nom_famille": "Musau",
    "titre_genre2": "Conseillère",
    "remuneration": "117549",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "135041",
    "ville": "Montréal",
    "arrondissement": "Villeray - Saint-Michel - Parc-Extension",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "69",
    "nom_corrige2": "Nathalie Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Mairesse",
    "remuneration": "101191",
    "allocation": "17551",
    "remuneration2": "15652",
    "allocation2": "0",
    "total": "134394",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "70",
    "nom_corrige2": "Ericka Alneus",
    "nom_famille": "Alneus",
    "titre_genre2": "Conseillère",
    "remuneration": "111006",
    "allocation": "17492",
    "remuneration2": "5500",
    "allocation2": "0",
    "total": "133998",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "71",
    "nom_corrige2": "Alvaro Cueto",
    "nom_famille": "Cueto",
    "titre_genre2": "Conseiller",
    "remuneration": "116152",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "133698",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "72",
    "nom_corrige2": "Marie Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseillère",
    "remuneration": "91053",
    "allocation": "17492",
    "remuneration2": "23500",
    "allocation2": "0",
    "total": "132045",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "73",
    "nom_corrige2": "Anne Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "74",
    "nom_corrige2": "Mélissa Coulombe-Leduc",
    "nom_famille": "Coulombe-Leduc",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "75",
    "nom_corrige2": "Alicia Despins",
    "nom_famille": "Despins",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "76",
    "nom_corrige2": "Claude Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "77",
    "nom_corrige2": "Maude Mercier Larouche",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "78",
    "nom_corrige2": "Catherine Vallières-Roland",
    "nom_famille": "Vallières-Roland",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "79",
    "nom_corrige2": "Steeve Verret",
    "nom_famille": "Verret",
    "titre_genre2": "Conseiller",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "80",
    "nom_corrige2": "Claude Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseiller",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "81",
    "nom_corrige2": "Marie-Pierre Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "82",
    "nom_corrige2": "Bianca Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseillère",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "83",
    "nom_corrige2": "Stevens Mélançon",
    "nom_famille": "Mélançon",
    "titre_genre2": "Conseiller",
    "remuneration": "114397",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131943",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "84",
    "nom_corrige2": "Dimitrios (Jim) Beis",
    "nom_famille": "Beis",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "114435",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131927",
    "ville": "Montréal",
    "arrondissement": "Pierrefonds-Roxboro",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "85",
    "nom_corrige2": "Aref Salem",
    "nom_famille": "Salem",
    "titre_genre2": "Conseiller",
    "remuneration": "114346",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "131838",
    "ville": "Montréal",
    "arrondissement": "Saint-Laurent",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "86",
    "nom_corrige2": "Nathalie Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseillère",
    "remuneration": "93957",
    "allocation": "17492",
    "remuneration2": "20000",
    "allocation2": "0",
    "total": "131449",
    "ville": "Montréal",
    "arrondissement": "Ahuntsic-Cartierville",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "87",
    "nom_corrige2": "Jocelyn Pauzé",
    "nom_famille": "Pauzé",
    "titre_genre2": "Conseiller",
    "remuneration": "103656",
    "allocation": "17492",
    "remuneration2": "10000",
    "allocation2": "0",
    "total": "131148",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "88",
    "nom_corrige2": "Julie Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Mairesse",
    "remuneration": "78000",
    "allocation": "17546",
    "remuneration2": "35580",
    "allocation2": "0",
    "total": "131126",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "89",
    "nom_corrige2": "André Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Maire",
    "remuneration": "103959",
    "allocation": "17546",
    "remuneration2": "9377",
    "allocation2": "0",
    "total": "130882",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "90",
    "nom_corrige2": "Jérôme Normand",
    "nom_famille": "Normand",
    "titre_genre2": "Conseiller",
    "remuneration": "91839",
    "allocation": "17492",
    "remuneration2": "21500",
    "allocation2": "0",
    "total": "130831",
    "ville": "Montréal",
    "arrondissement": "Ahuntsic-Cartierville",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "91",
    "nom_corrige2": "Normand Dyotte",
    "nom_famille": "Dyotte",
    "titre_genre2": "Maire",
    "remuneration": "89932",
    "allocation": "17546",
    "remuneration2": "23132",
    "allocation2": "0",
    "total": "130610",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "92",
    "nom_corrige2": "Josefina Blanco",
    "nom_famille": "Blanco",
    "titre_genre2": "Conseillère",
    "remuneration": "112555",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "130047",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "93",
    "nom_corrige2": "Luc Brisebois",
    "nom_famille": "Brisebois",
    "titre_genre2": "Maire",
    "remuneration": "107453",
    "allocation": "17546",
    "remuneration2": "4917",
    "allocation2": "0",
    "total": "129916",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "94",
    "nom_corrige2": "Diane Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Mairesse",
    "remuneration": "112105",
    "allocation": "17611",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "129716",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "95",
    "nom_corrige2": "Sylvie Beaumont",
    "nom_famille": "Beaumont",
    "titre_genre2": "Mairesse",
    "remuneration": "104093",
    "allocation": "14647",
    "remuneration2": "8014",
    "allocation2": "2899",
    "total": "129653",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "96",
    "nom_corrige2": "Céline Brindamour",
    "nom_famille": "Brindamour",
    "titre_genre2": "Mairesse",
    "remuneration": "107916",
    "allocation": "17546",
    "remuneration2": "2905",
    "allocation2": "0",
    "total": "128367",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "97",
    "nom_corrige2": "David Weiser",
    "nom_famille": "Weiser",
    "titre_genre2": "Conseiller",
    "remuneration": "110593",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "128139",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "98",
    "nom_corrige2": "Jacques Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseiller",
    "remuneration": "110333",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "127879",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "99",
    "nom_corrige2": "Stéphane Williams",
    "nom_famille": "Williams",
    "titre_genre2": "Maire",
    "remuneration": "83868",
    "allocation": "17546",
    "remuneration2": "25756",
    "allocation2": "0",
    "total": "127170",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "100",
    "nom_corrige2": "Guy Dumoulin",
    "nom_famille": "Dumoulin",
    "titre_genre2": "Conseiller",
    "remuneration": "108323",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "125869",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "101",
    "nom_corrige2": "Daniel Bourdon",
    "nom_famille": "Bourdon",
    "titre_genre2": "Maire",
    "remuneration": "75300",
    "allocation": "17546",
    "remuneration2": "32655",
    "allocation2": "0",
    "total": "125501",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "102",
    "nom_corrige2": "Claude Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Maire",
    "remuneration": "96112",
    "allocation": "17546",
    "remuneration2": "11829",
    "allocation2": "0",
    "total": "125487",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "103",
    "nom_corrige2": "Steeve Beaupré",
    "nom_famille": "Beaupré",
    "titre_genre2": "Maire",
    "remuneration": "101510",
    "allocation": "17546",
    "remuneration2": "6372",
    "allocation2": "0",
    "total": "125428",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "104",
    "nom_corrige2": "Jean-Claude Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Maire",
    "remuneration": "86696",
    "allocation": "17546",
    "remuneration2": "20558",
    "allocation2": "0",
    "total": "124800",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "105",
    "nom_corrige2": "Reine Bombo-Allara",
    "nom_famille": "Bombo-Allara",
    "titre_genre2": "Conseillère",
    "remuneration": "107074",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "124620",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "106",
    "nom_corrige2": "Anne St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Mairesse",
    "remuneration": "91547",
    "allocation": "17546",
    "remuneration2": "14693",
    "allocation2": "0",
    "total": "123786",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "107",
    "nom_corrige2": "Alia Hassan-Cournol",
    "nom_famille": "Hassan-Cournol",
    "titre_genre2": "Conseillère",
    "remuneration": "105473",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "122965",
    "ville": "Montréal",
    "arrondissement": "Mercier - Hochelaga-Maisonneuve",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "108",
    "nom_corrige2": "Jean Comtois",
    "nom_famille": "Comtois",
    "titre_genre2": "Maire",
    "remuneration": "74127",
    "allocation": "17546",
    "remuneration2": "31063",
    "allocation2": "0",
    "total": "122736",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "109",
    "nom_corrige2": "Nancy Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "105188",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "122680",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "110",
    "nom_corrige2": "Sébastien D'Astous",
    "nom_famille": "D'Astous",
    "titre_genre2": "Maire",
    "remuneration": "93702",
    "allocation": "17538",
    "remuneration2": "10800",
    "allocation2": "0",
    "total": "122040",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "111",
    "nom_corrige2": "Laura Palestini",
    "nom_famille": "Palestini",
    "titre_genre2": "Conseillère",
    "remuneration": "72176",
    "allocation": "17492",
    "remuneration2": "32345",
    "allocation2": "0",
    "total": "122013",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "112",
    "nom_corrige2": "Louis Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Maire",
    "remuneration": "91764",
    "allocation": "17546",
    "remuneration2": "12093",
    "allocation2": "0",
    "total": "121403",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "113",
    "nom_corrige2": "Patrick Melchior",
    "nom_famille": "Melchior",
    "titre_genre2": "Maire",
    "remuneration": "47707",
    "allocation": "17648",
    "remuneration2": "56010",
    "allocation2": "0",
    "total": "121365",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "114",
    "nom_corrige2": "SYLVAIN JUNEAU",
    "nom_famille": "JUNEAU",
    "titre_genre2": "Maire",
    "remuneration": "94257",
    "allocation": "17546",
    "remuneration2": "9499",
    "allocation2": "0",
    "total": "121302",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "115",
    "nom_corrige2": "Jocelyne Bates",
    "nom_famille": "Bates",
    "titre_genre2": "Mairesse",
    "remuneration": "97328",
    "allocation": "0",
    "remuneration2": "23599",
    "allocation2": "0",
    "total": "120927",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "116",
    "nom_corrige2": "Frédéric Broué",
    "nom_famille": "Broué",
    "titre_genre2": "Maire",
    "remuneration": "86390",
    "allocation": "17544",
    "remuneration2": "14027",
    "allocation2": "2345",
    "total": "120306",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "117",
    "nom_corrige2": "Vicki Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "102771",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "120263",
    "ville": "Montréal",
    "arrondissement": "Lachine",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "118",
    "nom_corrige2": "Peter Mcqueen",
    "nom_famille": "Mcqueen",
    "titre_genre2": "Conseiller",
    "remuneration": "79559",
    "allocation": "17492",
    "remuneration2": "22500",
    "allocation2": "0",
    "total": "119551",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "119",
    "nom_corrige2": "Alex Bottausci",
    "nom_famille": "Bottausci",
    "titre_genre2": "Maire",
    "remuneration": "83572",
    "allocation": "17541",
    "remuneration2": "17881",
    "allocation2": "0",
    "total": "118994",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "120",
    "nom_corrige2": "Michel Bissonnet",
    "nom_famille": "Bissonnet",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "101459",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "118951",
    "ville": "Montréal",
    "arrondissement": "Saint-Léonard",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "121",
    "nom_corrige2": "Sterling Downey",
    "nom_famille": "Downey",
    "titre_genre2": "Conseiller",
    "remuneration": "100804",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "118296",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "122",
    "nom_corrige2": "LOUIS OUELLET",
    "nom_famille": "OUELLET",
    "titre_genre2": "Maire",
    "remuneration": "17631",
    "allocation": "7180",
    "remuneration2": "79972",
    "allocation2": "13454",
    "total": "118237",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "123",
    "nom_corrige2": "Marc-André Guertin",
    "nom_famille": "Guertin",
    "titre_genre2": "Maire",
    "remuneration": "71617",
    "allocation": "17745",
    "remuneration2": "28313",
    "allocation2": "0",
    "total": "117675",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "124",
    "nom_corrige2": "André Guy",
    "nom_famille": "Guy",
    "titre_genre2": "Maire",
    "remuneration": "84831",
    "allocation": "17546",
    "remuneration2": "14608",
    "allocation2": "0",
    "total": "116985",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "125",
    "nom_corrige2": "Michel Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Maire",
    "remuneration": "99438",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "116984",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "126",
    "nom_corrige2": "Christine Black",
    "nom_famille": "Black",
    "titre_genre2": "Mairesse d'arrondissement",
    "remuneration": "99413",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "116905",
    "ville": "Montréal",
    "arrondissement": "Montréal-Nord",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "127",
    "nom_corrige2": "Nadine Viau",
    "nom_famille": "Viau",
    "titre_genre2": "Mairesse",
    "remuneration": "84183",
    "allocation": "17546",
    "remuneration2": "14083",
    "allocation2": "980",
    "total": "116792",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "128",
    "nom_corrige2": "Hélène Ringuet",
    "nom_famille": "Ringuet",
    "titre_genre2": "Conseillère",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36074",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "129",
    "nom_corrige2": "Marianne Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseillère",
    "remuneration": "93494",
    "allocation": "17492",
    "remuneration2": "5000",
    "allocation2": "0",
    "total": "115986",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "130",
    "nom_corrige2": "Paul Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Maire",
    "remuneration": "76795",
    "allocation": "17546",
    "remuneration2": "21535",
    "allocation2": "0",
    "total": "115876",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "131",
    "nom_corrige2": "Marc-Alexandre Brousseau",
    "nom_famille": "Brousseau",
    "titre_genre2": "Maire",
    "remuneration": "97444",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "114990",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "132",
    "nom_corrige2": "Despina Sourias",
    "nom_famille": "Sourias",
    "titre_genre2": "Conseillère",
    "remuneration": "89788",
    "allocation": "17492",
    "remuneration2": "7500",
    "allocation2": "0",
    "total": "114780",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "133",
    "nom_corrige2": "Isabelle Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "97034",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "114580",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "134",
    "nom_corrige2": "Brigitte Duchesneau",
    "nom_famille": "Duchesneau",
    "titre_genre2": "Conseillère",
    "remuneration": "97034",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "114580",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "135",
    "nom_corrige2": "Serge Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "97034",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "114580",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "136",
    "nom_corrige2": "Amélie Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseillère",
    "remuneration": "97034",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "114580",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "137",
    "nom_corrige2": "Georges Bourelle",
    "nom_famille": "Bourelle",
    "titre_genre2": "Maire",
    "remuneration": "66678",
    "allocation": "17546",
    "remuneration2": "30051",
    "allocation2": "0",
    "total": "114275",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "138",
    "nom_corrige2": "Paul Sarrazin",
    "nom_famille": "Sarrazin",
    "titre_genre2": "Maire",
    "remuneration": "23441",
    "allocation": "11721",
    "remuneration2": "73185",
    "allocation2": "5825",
    "total": "114172",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "139",
    "nom_corrige2": "Lise Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Mairesse",
    "remuneration": "56419",
    "allocation": "17473",
    "remuneration2": "39989",
    "allocation2": "0",
    "total": "113881",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "140",
    "nom_corrige2": "Geneviève Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Mairesse",
    "remuneration": "58554",
    "allocation": "17543",
    "remuneration2": "35995",
    "allocation2": "324",
    "total": "112416",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "141",
    "nom_corrige2": "Pierre-Luc Bellerose",
    "nom_famille": "Bellerose",
    "titre_genre2": "Maire",
    "remuneration": "69897",
    "allocation": "17546",
    "remuneration2": "24970",
    "allocation2": "0",
    "total": "112413",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "142",
    "nom_corrige2": "Tim Thomas",
    "nom_famille": "Thomas",
    "titre_genre2": "Maire",
    "remuneration": "80848",
    "allocation": "17456",
    "remuneration2": "14079",
    "allocation2": "0",
    "total": "112383",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "143",
    "nom_corrige2": "Jean-François Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "94517",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "112063",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "144",
    "nom_corrige2": "Louis Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "94517",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "112063",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "145",
    "nom_corrige2": "Bruno Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "17762",
    "allocation": "8881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26643",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "146",
    "nom_corrige2": "Alexandra Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Mairesse",
    "remuneration": "80553",
    "allocation": "17546",
    "remuneration2": "12633",
    "allocation2": "0",
    "total": "110732",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "147",
    "nom_corrige2": "Joé Deslauriers",
    "nom_famille": "Deslauriers",
    "titre_genre2": "Maire",
    "remuneration": "73570",
    "allocation": "17546",
    "remuneration2": "19326",
    "allocation2": "0",
    "total": "110442",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "148",
    "nom_corrige2": "Pierre Guénard",
    "nom_famille": "Guénard",
    "titre_genre2": "Maire",
    "remuneration": "61840",
    "allocation": "17546",
    "remuneration2": "20675",
    "allocation2": "10338",
    "total": "110399",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "149",
    "nom_corrige2": "Daniel Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "92445",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "109991",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "150",
    "nom_corrige2": "BERNARD GAUDREAU",
    "nom_famille": "GAUDREAU",
    "titre_genre2": "Maire",
    "remuneration": "25469",
    "allocation": "12734",
    "remuneration2": "66559",
    "allocation2": "5163",
    "total": "109925",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "151",
    "nom_corrige2": "Yves Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Maire",
    "remuneration": "71704",
    "allocation": "17546",
    "remuneration2": "20534",
    "allocation2": "0",
    "total": "109784",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "152",
    "nom_corrige2": "Véronique Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "85299",
    "allocation": "17492",
    "remuneration2": "6000",
    "allocation2": "0",
    "total": "108791",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "153",
    "nom_corrige2": "Luc Gibbons",
    "nom_famille": "Gibbons",
    "titre_genre2": "Maire",
    "remuneration": "85260",
    "allocation": "17546",
    "remuneration2": "5906",
    "allocation2": "0",
    "total": "108712",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "154",
    "nom_corrige2": "Michel Gibson",
    "nom_famille": "Gibson",
    "titre_genre2": "Maire",
    "remuneration": "65724",
    "allocation": "17546",
    "remuneration2": "25313",
    "allocation2": "0",
    "total": "108583",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "155",
    "nom_corrige2": "Gaétan Pageau",
    "nom_famille": "Pageau",
    "titre_genre2": "Maire",
    "remuneration": "90942",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "108488",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "156",
    "nom_corrige2": "Mario Bastille",
    "nom_famille": "Bastille",
    "titre_genre2": "Maire",
    "remuneration": "78863",
    "allocation": "17546",
    "remuneration2": "11604",
    "allocation2": "0",
    "total": "108013",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "157",
    "nom_corrige2": "Chantal Rossi",
    "nom_famille": "Rossi",
    "titre_genre2": "Conseillère",
    "remuneration": "90337",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "107829",
    "ville": "Montréal",
    "arrondissement": "Montréal-Nord",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "158",
    "nom_corrige2": "Véronique Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseillère",
    "remuneration": "90025",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "107571",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "159",
    "nom_corrige2": "Laurent Desbois",
    "nom_famille": "Desbois",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "89683",
    "allocation": "17588",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "107271",
    "ville": "Montréal",
    "arrondissement": "Outremont",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "160",
    "nom_corrige2": "Virginie Journeau",
    "nom_famille": "Journeau",
    "titre_genre2": "Conseillère",
    "remuneration": "82590",
    "allocation": "17492",
    "remuneration2": "7000",
    "allocation2": "0",
    "total": "107082",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "161",
    "nom_corrige2": "Geneviève Héon",
    "nom_famille": "Héon",
    "titre_genre2": "Conseillère",
    "remuneration": "52762",
    "allocation": "17546",
    "remuneration2": "36600",
    "allocation2": "0",
    "total": "106908",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "162",
    "nom_corrige2": "Stéphane Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "89153",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "106645",
    "ville": "Montréal",
    "arrondissement": "Ile-Bizard - Sainte-Geneviève",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "163",
    "nom_corrige2": "Serge Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Maire",
    "remuneration": "82400",
    "allocation": "17546",
    "remuneration2": "6587",
    "allocation2": "0",
    "total": "106533",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "164",
    "nom_corrige2": "Julie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "83259",
    "allocation": "17492",
    "remuneration2": "5500",
    "allocation2": "0",
    "total": "106251",
    "ville": "Montréal",
    "arrondissement": "Ahuntsic-Cartierville",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "165",
    "nom_corrige2": "Sylvie Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Mairesse",
    "remuneration": "62089",
    "allocation": "17546",
    "remuneration2": "26507",
    "allocation2": "0",
    "total": "106142",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "166",
    "nom_corrige2": "Lisa Christensen",
    "nom_famille": "Christensen",
    "titre_genre2": "Conseillère",
    "remuneration": "88582",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "106074",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "167",
    "nom_corrige2": "Christopher Von Roretz",
    "nom_famille": "Von",
    "titre_genre2": "Conseiller",
    "remuneration": "27638",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41457",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "168",
    "nom_corrige2": "Lucie Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Mairesse",
    "remuneration": "79562",
    "allocation": "17546",
    "remuneration2": "6297",
    "allocation2": "2609",
    "total": "106014",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "169",
    "nom_corrige2": "Sandra Desmeules",
    "nom_famille": "Desmeules",
    "titre_genre2": "Conseillère",
    "remuneration": "86879",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "104425",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "170",
    "nom_corrige2": "Dominic Perri",
    "nom_famille": "Perri",
    "titre_genre2": "Conseiller",
    "remuneration": "86684",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "104176",
    "ville": "Montréal",
    "arrondissement": "Saint-Léonard",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "171",
    "nom_corrige2": "Christine Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "85439",
    "allocation": "17546",
    "remuneration2": "687",
    "allocation2": "0",
    "total": "103672",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "172",
    "nom_corrige2": "Nicholas Borne",
    "nom_famille": "Borne",
    "titre_genre2": "Conseiller",
    "remuneration": "85439",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "102985",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "173",
    "nom_corrige2": "Jacques Gariépy",
    "nom_famille": "Gariépy",
    "titre_genre2": "Maire",
    "remuneration": "70931",
    "allocation": "17546",
    "remuneration2": "13807",
    "allocation2": "0",
    "total": "102284",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "174",
    "nom_corrige2": "Richard Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "68590",
    "allocation": "17492",
    "remuneration2": "16000",
    "allocation2": "0",
    "total": "102082",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "175",
    "nom_corrige2": "Isabelle Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "84470",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "102016",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "176",
    "nom_corrige2": "Carl Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "84267",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "101813",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "177",
    "nom_corrige2": "Jacques Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Maire",
    "remuneration": "48045",
    "allocation": "17546",
    "remuneration2": "36008",
    "allocation2": "0",
    "total": "101599",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "178",
    "nom_corrige2": "Gilles Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "84042",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "101588",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "179",
    "nom_corrige2": "Steve Dorval",
    "nom_famille": "Dorval",
    "titre_genre2": "Conseiller",
    "remuneration": "37452",
    "allocation": "17546",
    "remuneration2": "46406",
    "allocation2": "0",
    "total": "101404",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "180",
    "nom_corrige2": "SCOTT PEARCE",
    "nom_famille": "PEARCE",
    "titre_genre2": "Maire",
    "remuneration": "32970",
    "allocation": "16485",
    "remuneration2": "50827",
    "allocation2": "1061",
    "total": "101343",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "181",
    "nom_corrige2": "Michèle Lalonde",
    "nom_famille": "Lalonde",
    "titre_genre2": "Mairesse",
    "remuneration": "68868",
    "allocation": "16957",
    "remuneration2": "14916",
    "allocation2": "0",
    "total": "100741",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "182",
    "nom_corrige2": "Danielle Berthold",
    "nom_famille": "Berthold",
    "titre_genre2": "Conseillère",
    "remuneration": "82205",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "99751",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "183",
    "nom_corrige2": "Benoit Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Conseiller",
    "remuneration": "82181",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "99673",
    "ville": "Montréal",
    "arrondissement": "Pierrefonds-Roxboro",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "184",
    "nom_corrige2": "Alain Dubuc",
    "nom_famille": "Dubuc",
    "titre_genre2": "Maire",
    "remuneration": "64327",
    "allocation": "17546",
    "remuneration2": "17661",
    "allocation2": "0",
    "total": "99534",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "185",
    "nom_corrige2": "Sébastien Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Maire",
    "remuneration": "45794",
    "allocation": "17542",
    "remuneration2": "35886",
    "allocation2": "0",
    "total": "99222",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "186",
    "nom_corrige2": "Luis Miranda",
    "nom_famille": "Miranda",
    "titre_genre2": "Maire d'arrondissement",
    "remuneration": "81497",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "98989",
    "ville": "Montréal",
    "arrondissement": "Anjou",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "187",
    "nom_corrige2": "Mary Deros",
    "nom_famille": "Deros",
    "titre_genre2": "Conseillère",
    "remuneration": "81121",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "98613",
    "ville": "Montréal",
    "arrondissement": "Villeray - Saint-Michel - Parc-Extension",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "188",
    "nom_corrige2": "Suzanne Dauphin",
    "nom_famille": "Dauphin",
    "titre_genre2": "Mairesse",
    "remuneration": "55806",
    "allocation": "17546",
    "remuneration2": "24970",
    "allocation2": "0",
    "total": "98322",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "189",
    "nom_corrige2": "Danie Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Mairesse",
    "remuneration": "63201",
    "allocation": "17546",
    "remuneration2": "17541",
    "allocation2": "0",
    "total": "98288",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "190",
    "nom_corrige2": "Mario Aubé",
    "nom_famille": "Aubé",
    "titre_genre2": "Conseiller",
    "remuneration": "80096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "97642",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "191",
    "nom_corrige2": "Mitchell Brownstein",
    "nom_famille": "Brownstein",
    "titre_genre2": "Maire",
    "remuneration": "67795",
    "allocation": "17545",
    "remuneration2": "12237",
    "allocation2": "0",
    "total": "97577",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "192",
    "nom_corrige2": "Maeva Vilain",
    "nom_famille": "Vilain",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "79926",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "97418",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "193",
    "nom_corrige2": "Mathieu Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Maire",
    "remuneration": "48108",
    "allocation": "17543",
    "remuneration2": "31633",
    "allocation2": "0",
    "total": "97284",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "194",
    "nom_corrige2": "ALAIN BELLEMARE",
    "nom_famille": "BELLEMARE",
    "titre_genre2": "Maire",
    "remuneration": "33508",
    "allocation": "16754",
    "remuneration2": "45771",
    "allocation2": "792",
    "total": "96825",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "195",
    "nom_corrige2": "Effie Giannou",
    "nom_famille": "Giannou",
    "titre_genre2": "Conseillère",
    "remuneration": "79192",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "96684",
    "ville": "Montréal",
    "arrondissement": "Ahuntsic-Cartierville",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "196",
    "nom_corrige2": "Michel Jasmin",
    "nom_famille": "Jasmin",
    "titre_genre2": "Maire",
    "remuneration": "52595",
    "allocation": "17546",
    "remuneration2": "26142",
    "allocation2": "0",
    "total": "96283",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "197",
    "nom_corrige2": "Yvon Chiasson",
    "nom_famille": "Chiasson",
    "titre_genre2": "Maire",
    "remuneration": "53458",
    "allocation": "17401",
    "remuneration2": "24728",
    "allocation2": "473",
    "total": "96060",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "198",
    "nom_corrige2": "Anne-Marie Sigouin",
    "nom_famille": "Sigouin",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "78147",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "95639",
    "ville": "Montréal",
    "arrondissement": "Sud-Ouest",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "199",
    "nom_corrige2": "Rolande Balma",
    "nom_famille": "Balma",
    "titre_genre2": "Conseillère",
    "remuneration": "78030",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "95576",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "200",
    "nom_corrige2": "Aline Dib",
    "nom_famille": "Dib",
    "titre_genre2": "Conseillère",
    "remuneration": "56699",
    "allocation": "17546",
    "remuneration2": "21200",
    "allocation2": "0",
    "total": "95445",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "201",
    "nom_corrige2": "Manon Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Mairesse",
    "remuneration": "77457",
    "allocation": "17543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "95000",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "202",
    "nom_corrige2": "Abdelhaq Sari",
    "nom_famille": "Sari",
    "titre_genre2": "Conseiller",
    "remuneration": "77051",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "94543",
    "ville": "Montréal",
    "arrondissement": "Montréal-Nord",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "203",
    "nom_corrige2": "Jocelyne Frédéric Gauthier",
    "nom_famille": "Frédéric",
    "titre_genre2": "Conseillère",
    "remuneration": "34259",
    "allocation": "16890",
    "remuneration2": "42500",
    "allocation2": "656",
    "total": "94305",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "204",
    "nom_corrige2": "Daphney Colin",
    "nom_famille": "Colin",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "76771",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "94263",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "205",
    "nom_corrige2": "Claude Comeau",
    "nom_famille": "Comeau",
    "titre_genre2": "Maire",
    "remuneration": "64332",
    "allocation": "17546",
    "remuneration2": "12302",
    "allocation2": "0",
    "total": "94180",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "206",
    "nom_corrige2": "Xavier-Antoine Lalande",
    "nom_famille": "Lalande",
    "titre_genre2": "Maire",
    "remuneration": "47760",
    "allocation": "17546",
    "remuneration2": "28840",
    "allocation2": "0",
    "total": "94146",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "207",
    "nom_corrige2": "Olive Kamanyana",
    "nom_famille": "Kamanyana",
    "titre_genre2": "Conseillère",
    "remuneration": "76380",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "93926",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "208",
    "nom_corrige2": "Steven Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "76345",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "93891",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "209",
    "nom_corrige2": "Martin Ferron",
    "nom_famille": "Ferron",
    "titre_genre2": "Maire",
    "remuneration": "76024",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "93570",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "210",
    "nom_corrige2": "Sonny Moroz",
    "nom_famille": "Moroz",
    "titre_genre2": "Conseiller",
    "remuneration": "76055",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "93547",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "211",
    "nom_corrige2": "Patricia Boudreault-Bruyère",
    "nom_famille": "Boudreault-Bruyère",
    "titre_genre2": "Conseillère",
    "remuneration": "75075",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "92621",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "212",
    "nom_corrige2": "Jackie Smith",
    "nom_famille": "Smith",
    "titre_genre2": "Conseillère",
    "remuneration": "75075",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "92621",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "213",
    "nom_corrige2": "Eric Ralph Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "75075",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "92621",
    "ville": "Québec",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "556066"
  },
  {
    "ID": "214",
    "nom_corrige2": "Marc Laurin",
    "nom_famille": "Laurin",
    "titre_genre2": "Maire",
    "remuneration": "68854",
    "allocation": "17543",
    "remuneration2": "5092",
    "allocation2": "0",
    "total": "91489",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "215",
    "nom_corrige2": "Marie-Claude Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "73628",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "91120",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "216",
    "nom_corrige2": "François Robillard",
    "nom_famille": "Robillard",
    "titre_genre2": "Maire",
    "remuneration": "73371",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "90917",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "217",
    "nom_corrige2": "Edmond Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "73301",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "90847",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "218",
    "nom_corrige2": "Robert Bibeau",
    "nom_famille": "Bibeau",
    "titre_genre2": "Maire",
    "remuneration": "48181",
    "allocation": "17546",
    "remuneration2": "24970",
    "allocation2": "0",
    "total": "90697",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "219",
    "nom_corrige2": "Lysa Bélaïcha",
    "nom_famille": "Bélaïcha",
    "titre_genre2": "Conseillère",
    "remuneration": "57252",
    "allocation": "17546",
    "remuneration2": "15675",
    "allocation2": "0",
    "total": "90473",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "220",
    "nom_corrige2": "Michaël Pilote",
    "nom_famille": "Pilote",
    "titre_genre2": "Maire",
    "remuneration": "55019",
    "allocation": "17534",
    "remuneration2": "10515",
    "allocation2": "7010",
    "total": "90078",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "221",
    "nom_corrige2": "Tiffany-Lee Norris Parent",
    "nom_famille": "Norris",
    "titre_genre2": "Conseillère",
    "remuneration": "72115",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89661",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "222",
    "nom_corrige2": "Christina Smith",
    "nom_famille": "Smith",
    "titre_genre2": "Mairesse",
    "remuneration": "72047",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89593",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "223",
    "nom_corrige2": "Réjean Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseiller",
    "remuneration": "71883",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89429",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "224",
    "nom_corrige2": "Michel Turner",
    "nom_famille": "Turner",
    "titre_genre2": "Conseiller",
    "remuneration": "71883",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89429",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "225",
    "nom_corrige2": "Ann Jeffrey",
    "nom_famille": "Jeffrey",
    "titre_genre2": "Conseillère",
    "remuneration": "71883",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89429",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "226",
    "nom_corrige2": "Laurence Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseillère",
    "remuneration": "71885",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "89377",
    "ville": "Montréal",
    "arrondissement": "Rosemont-La Petite-Patrie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "227",
    "nom_corrige2": "Alexandre Warnet",
    "nom_famille": "Warnet",
    "titre_genre2": "Conseiller",
    "remuneration": "56699",
    "allocation": "17546",
    "remuneration2": "14979",
    "allocation2": "0",
    "total": "89224",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "228",
    "nom_corrige2": "Josué Corvil",
    "nom_famille": "Corvil",
    "titre_genre2": "Conseiller",
    "remuneration": "71457",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88949",
    "ville": "Montréal",
    "arrondissement": "Villeray - Saint-Michel - Parc-Extension",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "229",
    "nom_corrige2": "Sandra El-Helou",
    "nom_famille": "El-Helou",
    "titre_genre2": "Conseillère",
    "remuneration": "61259",
    "allocation": "17546",
    "remuneration2": "10000",
    "allocation2": "0",
    "total": "88805",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "230",
    "nom_corrige2": "Eddy Métivier",
    "nom_famille": "Métivier",
    "titre_genre2": "Maire",
    "remuneration": "70847",
    "allocation": "17880",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88727",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "231",
    "nom_corrige2": "Julien Hénault-Ratelle",
    "nom_famille": "Hénault-Ratelle",
    "titre_genre2": "Conseiller",
    "remuneration": "71188",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88680",
    "ville": "Montréal",
    "arrondissement": "Mercier - Hochelaga-Maisonneuve",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "232",
    "nom_corrige2": "Denis Girouard",
    "nom_famille": "Girouard",
    "titre_genre2": "Conseiller",
    "remuneration": "71074",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88620",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "233",
    "nom_corrige2": "Marc-Antoine Azouz",
    "nom_famille": "Azouz",
    "titre_genre2": "Conseiller",
    "remuneration": "55822",
    "allocation": "17546",
    "remuneration2": "15223",
    "allocation2": "0",
    "total": "88591",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "234",
    "nom_corrige2": "Andrée Hénault",
    "nom_famille": "Hénault",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "70942",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88434",
    "ville": "Montréal",
    "arrondissement": "Anjou",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "235",
    "nom_corrige2": "YVES DAGENAIS",
    "nom_famille": "DAGENAIS",
    "titre_genre2": "Maire",
    "remuneration": "51469",
    "allocation": "17546",
    "remuneration2": "19227",
    "allocation2": "0",
    "total": "88242",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "236",
    "nom_corrige2": "Jean-Marie Lachapelle",
    "nom_famille": "Lachapelle",
    "titre_genre2": "Maire",
    "remuneration": "45756",
    "allocation": "17546",
    "remuneration2": "24880",
    "allocation2": "0",
    "total": "88182",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "237",
    "nom_corrige2": "Catherine Clément-Talbot",
    "nom_famille": "Clément-Talbot",
    "titre_genre2": "Conseillère",
    "remuneration": "70687",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88179",
    "ville": "Montréal",
    "arrondissement": "Pierrefonds-Roxboro",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "238",
    "nom_corrige2": "Giovanni Rapanà",
    "nom_famille": "Rapanà",
    "titre_genre2": "Conseiller",
    "remuneration": "70625",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "88117",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "239",
    "nom_corrige2": "Laure Letarte-Lavoie",
    "nom_famille": "Letarte-Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "65670",
    "allocation": "17546",
    "remuneration2": "4899",
    "allocation2": "0",
    "total": "88115",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "240",
    "nom_corrige2": "Caroline Murray",
    "nom_famille": "Murray",
    "titre_genre2": "Conseillère",
    "remuneration": "70279",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87825",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "241",
    "nom_corrige2": "Louis Sabourin",
    "nom_famille": "Sabourin",
    "titre_genre2": "Conseiller",
    "remuneration": "70256",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87802",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "242",
    "nom_corrige2": "Anik Des Marais",
    "nom_famille": "Des",
    "titre_genre2": "Conseillère",
    "remuneration": "70211",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87757",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "243",
    "nom_corrige2": "Benoit Gratton",
    "nom_famille": "Gratton",
    "titre_genre2": "Conseiller",
    "remuneration": "70211",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87703",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "244",
    "nom_corrige2": "Jean Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "70156",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87702",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "245",
    "nom_corrige2": "Vana Nazarian",
    "nom_famille": "Nazarian",
    "titre_genre2": "Conseillère",
    "remuneration": "70179",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87671",
    "ville": "Montréal",
    "arrondissement": "Saint-Laurent",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "246",
    "nom_corrige2": "Peter J. Malouf",
    "nom_famille": "Malouf",
    "titre_genre2": "Maire",
    "remuneration": "70013",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87559",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "247",
    "nom_corrige2": "Craig Sauvé",
    "nom_famille": "Sauvé",
    "titre_genre2": "Conseiller",
    "remuneration": "70021",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87513",
    "ville": "Montréal",
    "arrondissement": "Sud-Ouest",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "248",
    "nom_corrige2": "Gilles Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Maire",
    "remuneration": "47002",
    "allocation": "17546",
    "remuneration2": "22903",
    "allocation2": "0",
    "total": "87451",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "249",
    "nom_corrige2": "Fernanda Luz",
    "nom_famille": "Luz",
    "titre_genre2": "Conseillère",
    "remuneration": "69876",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87422",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "250",
    "nom_corrige2": "Jeremy Levi",
    "nom_famille": "Levi",
    "titre_genre2": "Maire",
    "remuneration": "57847",
    "allocation": "17546",
    "remuneration2": "11987",
    "allocation2": "0",
    "total": "87380",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "251",
    "nom_corrige2": "Benoit Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "39424",
    "allocation": "17546",
    "remuneration2": "30400",
    "allocation2": "0",
    "total": "87370",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "252",
    "nom_corrige2": "Angela Gentile",
    "nom_famille": "Gentile",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "69858",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87350",
    "ville": "Montréal",
    "arrondissement": "Saint-Léonard",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "253",
    "nom_corrige2": "PIERRE LEFRANÇOIS",
    "nom_famille": "LEFRANÇOIS",
    "titre_genre2": "Maire",
    "remuneration": "30019",
    "allocation": "15009",
    "remuneration2": "39566",
    "allocation2": "2638",
    "total": "87232",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "254",
    "nom_corrige2": "Alba Zuniga Ramos",
    "nom_famille": "Zuniga",
    "titre_genre2": "Conseillère",
    "remuneration": "69719",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87211",
    "ville": "Montréal",
    "arrondissement": "Mercier - Hochelaga-Maisonneuve",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "255",
    "nom_corrige2": "Stephanie Valenzuela",
    "nom_famille": "Valenzuela",
    "titre_genre2": "Conseillère",
    "remuneration": "69577",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "87069",
    "ville": "Montréal",
    "arrondissement": "Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "256",
    "nom_corrige2": "Sylvain Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseiller",
    "remuneration": "50002",
    "allocation": "17546",
    "remuneration2": "19500",
    "allocation2": "0",
    "total": "87048",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "257",
    "nom_corrige2": "Jocelyn Blondin",
    "nom_famille": "Blondin",
    "titre_genre2": "Conseiller",
    "remuneration": "69203",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "86749",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "258",
    "nom_corrige2": "René Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "35092",
    "allocation": "17546",
    "remuneration2": "33768",
    "allocation2": "0",
    "total": "86406",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "259",
    "nom_corrige2": "Michel Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseiller",
    "remuneration": "68740",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "86286",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "260",
    "nom_corrige2": "Geneviève Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Mairesse",
    "remuneration": "68707",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "86253",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "261",
    "nom_corrige2": "Robert Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "59859",
    "allocation": "17546",
    "remuneration2": "8800",
    "allocation2": "0",
    "total": "86205",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "262",
    "nom_corrige2": "Nathalie Delisle",
    "nom_famille": "Delisle",
    "titre_genre2": "Conseillère",
    "remuneration": "52572",
    "allocation": "17546",
    "remuneration2": "16025",
    "allocation2": "0",
    "total": "86143",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "263",
    "nom_corrige2": "Geneviève La Roche",
    "nom_famille": "La",
    "titre_genre2": "Conseillère",
    "remuneration": "60464",
    "allocation": "17546",
    "remuneration2": "8001",
    "allocation2": "0",
    "total": "86011",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "264",
    "nom_corrige2": "Isabelle N. Miron",
    "nom_famille": "Miron",
    "titre_genre2": "Conseillère",
    "remuneration": "68140",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "85686",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "265",
    "nom_corrige2": "Steve Moran",
    "nom_famille": "Moran",
    "titre_genre2": "Conseiller",
    "remuneration": "68140",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "85686",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "266",
    "nom_corrige2": "Nathalie-Ann Pelchat",
    "nom_famille": "Pelchat",
    "titre_genre2": "Mairesse",
    "remuneration": "68072",
    "allocation": "17540",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "85612",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "267",
    "nom_corrige2": "Michel Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseiller",
    "remuneration": "66099",
    "allocation": "17594",
    "remuneration2": "1563",
    "allocation2": "0",
    "total": "85256",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "268",
    "nom_corrige2": "Marc Denault",
    "nom_famille": "Denault",
    "titre_genre2": "Conseiller",
    "remuneration": "54148",
    "allocation": "17546",
    "remuneration2": "13338",
    "allocation2": "0",
    "total": "85032",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "269",
    "nom_corrige2": "Joanie Bellerose",
    "nom_famille": "Bellerose",
    "titre_genre2": "Conseillère",
    "remuneration": "62570",
    "allocation": "17546",
    "remuneration2": "4899",
    "allocation2": "0",
    "total": "85015",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "270",
    "nom_corrige2": "Maud Allaire",
    "nom_famille": "Allaire",
    "titre_genre2": "Mairesse",
    "remuneration": "45491",
    "allocation": "17548",
    "remuneration2": "21967",
    "allocation2": "0",
    "total": "85006",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "271",
    "nom_corrige2": "Alicia Lacasse-Brunet",
    "nom_famille": "Lacasse-Brunet",
    "titre_genre2": "Conseillère",
    "remuneration": "67234",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "84780",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "272",
    "nom_corrige2": "Enrique Machado",
    "nom_famille": "Machado",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "66519",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "84011",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "273",
    "nom_corrige2": "Kevin Armstrong",
    "nom_famille": "Armstrong",
    "titre_genre2": "Conseiller",
    "remuneration": "66104",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "83698",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "274",
    "nom_corrige2": "Martin Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "66099",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "83693",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "275",
    "nom_corrige2": "Kaïla A. Munro",
    "nom_famille": "Munro",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "66173",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "83665",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "276",
    "nom_corrige2": "Luc Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Maire",
    "remuneration": "68122",
    "allocation": "14892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "83014",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "277",
    "nom_corrige2": "Virginie Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "3689",
    "allocation": "1844",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5533",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "278",
    "nom_corrige2": "Michèle Flannery",
    "nom_famille": "Flannery",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "65339",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "82831",
    "ville": "Montréal",
    "arrondissement": "Lachine",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "279",
    "nom_corrige2": "Benoit Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Maire",
    "remuneration": "52000",
    "allocation": "17546",
    "remuneration2": "13207",
    "allocation2": "0",
    "total": "82753",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "280",
    "nom_corrige2": "Serge Sasseville",
    "nom_famille": "Sasseville",
    "titre_genre2": "Conseiller",
    "remuneration": "65065",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "82557",
    "ville": "Montréal",
    "arrondissement": "Ville-Marie",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "281",
    "nom_corrige2": "Raïs Kibonge",
    "nom_famille": "Kibonge",
    "titre_genre2": "Conseiller",
    "remuneration": "63290",
    "allocation": "17546",
    "remuneration2": "1430",
    "allocation2": "0",
    "total": "82266",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "282",
    "nom_corrige2": "Lisette Maillé",
    "nom_famille": "Maillé",
    "titre_genre2": "Mairesse",
    "remuneration": "40650",
    "allocation": "17546",
    "remuneration2": "24068",
    "allocation2": "0",
    "total": "82264",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "283",
    "nom_corrige2": "Christelle Lefèvre",
    "nom_famille": "Lefèvre",
    "titre_genre2": "Conseiller",
    "remuneration": "62570",
    "allocation": "17546",
    "remuneration2": "2144",
    "allocation2": "0",
    "total": "82260",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "284",
    "nom_corrige2": "Annie Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseiller",
    "remuneration": "64713",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "82259",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "285",
    "nom_corrige2": "Patrick Marquès",
    "nom_famille": "Marquès",
    "titre_genre2": "Maire",
    "remuneration": "51560",
    "allocation": "17546",
    "remuneration2": "12873",
    "allocation2": "0",
    "total": "81979",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "286",
    "nom_corrige2": "CHRISTIAN CÔTÉ",
    "nom_famille": "CÔTÉ",
    "titre_genre2": "Maire",
    "remuneration": "10139",
    "allocation": "5082",
    "remuneration2": "40049",
    "allocation2": "26699",
    "total": "81969",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "287",
    "nom_corrige2": "Yannick Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "48409",
    "allocation": "17546",
    "remuneration2": "16000",
    "allocation2": "0",
    "total": "81955",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "288",
    "nom_corrige2": "Patricia Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "40549",
    "allocation": "17546",
    "remuneration2": "23760",
    "allocation2": "0",
    "total": "81855",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "289",
    "nom_corrige2": "Michel Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "62690",
    "allocation": "17594",
    "remuneration2": "1509",
    "allocation2": "0",
    "total": "81793",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "290",
    "nom_corrige2": "Flavia Alexandra Novac",
    "nom_famille": "Novac",
    "titre_genre2": "Conseiller",
    "remuneration": "56699",
    "allocation": "17546",
    "remuneration2": "7500",
    "allocation2": "0",
    "total": "81745",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "291",
    "nom_corrige2": "Bettyna Belizaire",
    "nom_famille": "Belizaire",
    "titre_genre2": "Conseiller",
    "remuneration": "64166",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "81712",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "292",
    "nom_corrige2": "Martin Dulac",
    "nom_famille": "Dulac",
    "titre_genre2": "Maire",
    "remuneration": "31051",
    "allocation": "15526",
    "remuneration2": "33051",
    "allocation2": "2020",
    "total": "81648",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "293",
    "nom_corrige2": "Simon Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Maire",
    "remuneration": "59678",
    "allocation": "18352",
    "remuneration2": "3042",
    "allocation2": "0",
    "total": "81072",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "294",
    "nom_corrige2": "Mike Duggan",
    "nom_famille": "Duggan",
    "titre_genre2": "Conseiller",
    "remuneration": "63296",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "80842",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "295",
    "nom_corrige2": "Paola Hawa",
    "nom_famille": "Hawa",
    "titre_genre2": "Maire",
    "remuneration": "37220",
    "allocation": "17546",
    "remuneration2": "26052",
    "allocation2": "0",
    "total": "80818",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "296",
    "nom_corrige2": "Catherine Boileau",
    "nom_famille": "Boileau",
    "titre_genre2": "Conseiller",
    "remuneration": "58369",
    "allocation": "17546",
    "remuneration2": "4899",
    "allocation2": "0",
    "total": "80814",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "297",
    "nom_corrige2": "Roch Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Maire",
    "remuneration": "59212",
    "allocation": "17546",
    "remuneration2": "4007",
    "allocation2": "0",
    "total": "80765",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "298",
    "nom_corrige2": "Jacques Cleary",
    "nom_famille": "Cleary",
    "titre_genre2": "Conseiller",
    "remuneration": "62690",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "80284",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "299",
    "nom_corrige2": "Carl Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "62690",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "80284",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "300",
    "nom_corrige2": "Raynald Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "62690",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "80284",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "301",
    "nom_corrige2": "Bertrand Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "49549",
    "allocation": "17546",
    "remuneration2": "12842",
    "allocation2": "0",
    "total": "79937",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "302",
    "nom_corrige2": "Alain Otto",
    "nom_famille": "Otto",
    "titre_genre2": "Conseiller",
    "remuneration": "16122",
    "allocation": "8061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24183",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "303",
    "nom_corrige2": "Vasilios Karidogiannis",
    "nom_famille": "Karidogiannis",
    "titre_genre2": "Conseiller",
    "remuneration": "33779",
    "allocation": "16890",
    "remuneration2": "28300",
    "allocation2": "656",
    "total": "79625",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "304",
    "nom_corrige2": "Marie-Eve Couturier",
    "nom_famille": "Couturier",
    "titre_genre2": "Conseillère",
    "remuneration": "44397",
    "allocation": "17546",
    "remuneration2": "17600",
    "allocation2": "0",
    "total": "79543",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "305",
    "nom_corrige2": "Younes Boukala",
    "nom_famille": "Boukala",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "61686",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "79178",
    "ville": "Montréal",
    "arrondissement": "Lachine",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "306",
    "nom_corrige2": "Gilles Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Maire",
    "remuneration": "35179",
    "allocation": "17546",
    "remuneration2": "26142",
    "allocation2": "0",
    "total": "78867",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "307",
    "nom_corrige2": "Suzanne De Larochellière",
    "nom_famille": "De",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "61335",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78827",
    "ville": "Montréal",
    "arrondissement": "Saint-Léonard",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "308",
    "nom_corrige2": "Claude Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Maire",
    "remuneration": "48604",
    "allocation": "17546",
    "remuneration2": "12493",
    "allocation2": "145",
    "total": "78788",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "309",
    "nom_corrige2": "Valérie Patreau",
    "nom_famille": "Patreau",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "61260",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78752",
    "ville": "Montréal",
    "arrondissement": "Outremont",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "310",
    "nom_corrige2": "Josée Troilo",
    "nom_famille": "Troilo",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "61260",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78752",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "311",
    "nom_corrige2": "Benoit Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Maire",
    "remuneration": "61158",
    "allocation": "17496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78654",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "312",
    "nom_corrige2": "Paul Gingues",
    "nom_famille": "Gingues",
    "titre_genre2": "Conseiller",
    "remuneration": "61031",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78577",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "313",
    "nom_corrige2": "Sylvain Roberge",
    "nom_famille": "Roberge",
    "titre_genre2": "Maire",
    "remuneration": "63500",
    "allocation": "15000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78500",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "314",
    "nom_corrige2": "Mindy Pollak",
    "nom_famille": "Pollak",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "60962",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78454",
    "ville": "Montréal",
    "arrondissement": "Outremont",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "315",
    "nom_corrige2": "Audrey Boisjoly",
    "nom_famille": "Boisjoly",
    "titre_genre2": "Mairesse",
    "remuneration": "60728",
    "allocation": "17543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78271",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "316",
    "nom_corrige2": "Sylvain Payant",
    "nom_famille": "Payant",
    "titre_genre2": "Maire",
    "remuneration": "22176",
    "allocation": "11088",
    "remuneration2": "37927",
    "allocation2": "6998",
    "total": "78189",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "317",
    "nom_corrige2": "Jean Marc Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "60648",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "78140",
    "ville": "Montréal",
    "arrondissement": "Montréal-Nord",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "318",
    "nom_corrige2": "Raymond Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseiller",
    "remuneration": "55866",
    "allocation": "17546",
    "remuneration2": "4389",
    "allocation2": "0",
    "total": "77801",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "319",
    "nom_corrige2": "Louise Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "52682",
    "allocation": "17492",
    "remuneration2": "7500",
    "allocation2": "0",
    "total": "77674",
    "ville": "Montréal",
    "arrondissement": "Pierrefonds-Roxboro",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "320",
    "nom_corrige2": "PIERRE RENAUD",
    "nom_famille": "RENAUD",
    "titre_genre2": "Maire",
    "remuneration": "50000",
    "allocation": "17535",
    "remuneration2": "9878",
    "allocation2": "0",
    "total": "77413",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "321",
    "nom_corrige2": "NORMAND GRENIER",
    "nom_famille": "GRENIER",
    "titre_genre2": "Maire",
    "remuneration": "49403",
    "allocation": "17546",
    "remuneration2": "10450",
    "allocation2": "0",
    "total": "77399",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "322",
    "nom_corrige2": "Pascale Mongrain",
    "nom_famille": "Mongrain",
    "titre_genre2": "Mairesse",
    "remuneration": "44161",
    "allocation": "17546",
    "remuneration2": "15508",
    "allocation2": "0",
    "total": "77215",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "323",
    "nom_corrige2": "Sylvie Gagnon-Breton",
    "nom_famille": "Gagnon-Breton",
    "titre_genre2": "Mairesse",
    "remuneration": "48168",
    "allocation": "17550",
    "remuneration2": "11174",
    "allocation2": "0",
    "total": "76892",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "324",
    "nom_corrige2": "Pierre Brabant",
    "nom_famille": "Brabant",
    "titre_genre2": "Conseiller",
    "remuneration": "39299",
    "allocation": "16890",
    "remuneration2": "20000",
    "allocation2": "656",
    "total": "76845",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "325",
    "nom_corrige2": "Simon Madore",
    "nom_famille": "Madore",
    "titre_genre2": "Maire",
    "remuneration": "50091",
    "allocation": "17546",
    "remuneration2": "9146",
    "allocation2": "0",
    "total": "76783",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "326",
    "nom_corrige2": "Martin Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Maire",
    "remuneration": "47160",
    "allocation": "17697",
    "remuneration2": "11761",
    "allocation2": "0",
    "total": "76618",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "327",
    "nom_corrige2": "Jean-Claude Léveillée",
    "nom_famille": "Léveillée",
    "titre_genre2": "Maire",
    "remuneration": "47288",
    "allocation": "17540",
    "remuneration2": "7346",
    "allocation2": "3673",
    "total": "75847",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "328",
    "nom_corrige2": "Claude Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "55245",
    "allocation": "17594",
    "remuneration2": "2874",
    "allocation2": "0",
    "total": "75713",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "329",
    "nom_corrige2": "Cecilia Macedo",
    "nom_famille": "Macedo",
    "titre_genre2": "Conseillère",
    "remuneration": "58139",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "75685",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "330",
    "nom_corrige2": "Jacques Cohen",
    "nom_famille": "Cohen",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "58072",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "75564",
    "ville": "Montréal",
    "arrondissement": "Saint-Laurent",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "331",
    "nom_corrige2": "Marie Sterlin",
    "nom_famille": "Sterlin",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "58029",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "75521",
    "ville": "Montréal",
    "arrondissement": "Plateau-Mont-Royal",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "332",
    "nom_corrige2": "Yvon Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Maire",
    "remuneration": "47200",
    "allocation": "17546",
    "remuneration2": "10045",
    "allocation2": "0",
    "total": "74791",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "333",
    "nom_corrige2": "Jimmy Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "55852",
    "allocation": "17594",
    "remuneration2": "1250",
    "allocation2": "0",
    "total": "74696",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "334",
    "nom_corrige2": "Karl Ferraro",
    "nom_famille": "Ferraro",
    "titre_genre2": "Conseiller",
    "remuneration": "56992",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "74538",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "335",
    "nom_corrige2": "Camil Turmel",
    "nom_famille": "Turmel",
    "titre_genre2": "Maire",
    "remuneration": "23986",
    "allocation": "11993",
    "remuneration2": "25657",
    "allocation2": "12829",
    "total": "74465",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "336",
    "nom_corrige2": "Bernard Bigras-Denis",
    "nom_famille": "Bigras-Denis",
    "titre_genre2": "Maire",
    "remuneration": "56855",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "74401",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "337",
    "nom_corrige2": "Pierre Dolbec",
    "nom_famille": "Dolbec",
    "titre_genre2": "Maire",
    "remuneration": "49592",
    "allocation": "17546",
    "remuneration2": "7228",
    "allocation2": "0",
    "total": "74366",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "338",
    "nom_corrige2": "Cathy Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Mairesse",
    "remuneration": "50012",
    "allocation": "17546",
    "remuneration2": "6800",
    "allocation2": "0",
    "total": "74358",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "339",
    "nom_corrige2": "Arij El Korbi",
    "nom_famille": "El",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "56821",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "74313",
    "ville": "Montréal",
    "arrondissement": "Saint-Léonard",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "340",
    "nom_corrige2": "Gilles Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Maire",
    "remuneration": "45444",
    "allocation": "17546",
    "remuneration2": "11294",
    "allocation2": "0",
    "total": "74284",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "341",
    "nom_corrige2": "Louise Lortie",
    "nom_famille": "Lortie",
    "titre_genre2": "Conseillère",
    "remuneration": "56699",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "74245",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "342",
    "nom_corrige2": "Christian Marin",
    "nom_famille": "Marin",
    "titre_genre2": "Maire",
    "remuneration": "38677",
    "allocation": "11006",
    "remuneration2": "17616",
    "allocation2": "6540",
    "total": "73839",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "343",
    "nom_corrige2": "Nancy Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseillère",
    "remuneration": "56268",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "73814",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "344",
    "nom_corrige2": "Bruno Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "51357",
    "allocation": "17142",
    "remuneration2": "3438",
    "allocation2": "1644",
    "total": "73581",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "345",
    "nom_corrige2": "Sébastien Marcil",
    "nom_famille": "Marcil",
    "titre_genre2": "Maire",
    "remuneration": "29258",
    "allocation": "14629",
    "remuneration2": "26142",
    "allocation2": "2917",
    "total": "72946",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "346",
    "nom_corrige2": "Benoit Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "55430",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "72922",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "347",
    "nom_corrige2": "Roger Auger",
    "nom_famille": "Aubert",
    "titre_genre2": "Conseiller",
    "remuneration": "50831",
    "allocation": "17546",
    "remuneration2": "4389",
    "allocation2": "0",
    "total": "72766",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "348",
    "nom_corrige2": "Pascal Quevillon",
    "nom_famille": "Quevillon",
    "titre_genre2": "Maire",
    "remuneration": "42454",
    "allocation": "17546",
    "remuneration2": "12607",
    "allocation2": "0",
    "total": "72607",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "349",
    "nom_corrige2": "Michel Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Maire",
    "remuneration": "6671",
    "allocation": "3336",
    "remuneration2": "48386",
    "allocation2": "14164",
    "total": "72557",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "350",
    "nom_corrige2": "Hugues Grimard",
    "nom_famille": "Grimard",
    "titre_genre2": "Maire",
    "remuneration": "33047",
    "allocation": "16523",
    "remuneration2": "21762",
    "allocation2": "1200",
    "total": "72532",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "351",
    "nom_corrige2": "Claude Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Conseiller",
    "remuneration": "54078",
    "allocation": "17546",
    "remuneration2": "834",
    "allocation2": "0",
    "total": "72458",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "352",
    "nom_corrige2": "Micheline Rouleau",
    "nom_famille": "Rouleau",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "54948",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "72440",
    "ville": "Montréal",
    "arrondissement": "Lachine",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "353",
    "nom_corrige2": "Nathalie Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseillère",
    "remuneration": "37410",
    "allocation": "17367",
    "remuneration2": "17 600",
    "allocation2": "0",
    "total": "72377",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "354",
    "nom_corrige2": "Beny Masella",
    "nom_famille": "Masella",
    "titre_genre2": "Maire",
    "remuneration": "32960",
    "allocation": "16480",
    "remuneration2": "21737",
    "allocation2": "1088",
    "total": "72265",
    "ville": "Montréal-Ouest",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5389"
  },
  {
    "ID": "355",
    "nom_corrige2": "Luc Dostaler",
    "nom_famille": "Dostaler",
    "titre_genre2": "Maire",
    "remuneration": "25776",
    "allocation": "12888",
    "remuneration2": "28731",
    "allocation2": "4822",
    "total": "72217",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "356",
    "nom_corrige2": "Bernard Landreville",
    "nom_famille": "Landreville",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "8800",
    "allocation2": "0",
    "total": "71953",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "357",
    "nom_corrige2": "Mario Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Maire",
    "remuneration": "41629",
    "allocation": "17546",
    "remuneration2": "8453",
    "allocation2": "4227",
    "total": "71855",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "358",
    "nom_corrige2": "Nathalie Pierre-Antoine",
    "nom_famille": "Pierre-Antoine",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "53895",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "71387",
    "ville": "Montréal",
    "arrondissement": "Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "359",
    "nom_corrige2": "Anny Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseillère",
    "remuneration": "40549",
    "allocation": "17546",
    "remuneration2": "13227",
    "allocation2": "0",
    "total": "71322",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "360",
    "nom_corrige2": "Marc Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "52443",
    "allocation": "17594",
    "remuneration2": "1250",
    "allocation2": "0",
    "total": "71287",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "361",
    "nom_corrige2": "Valérie Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseillère",
    "remuneration": "53709",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "71255",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "362",
    "nom_corrige2": "Claude Duplain",
    "nom_famille": "Duplain",
    "titre_genre2": "Maire",
    "remuneration": "44798",
    "allocation": "17546",
    "remuneration2": "5749",
    "allocation2": "2875",
    "total": "70968",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "363",
    "nom_corrige2": "Hélène Dauphinais",
    "nom_famille": "Dauphinais",
    "titre_genre2": "Conseillère",
    "remuneration": "53381",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "70927",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "364",
    "nom_corrige2": "Seta Topouzian",
    "nom_famille": "Topouzian",
    "titre_genre2": "Conseillère",
    "remuneration": "33379",
    "allocation": "16890",
    "remuneration2": "20000",
    "allocation2": "656",
    "total": "70925",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "365",
    "nom_corrige2": "Michèle Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "40549",
    "allocation": "17546",
    "remuneration2": "12650",
    "allocation2": "0",
    "total": "70745",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "366",
    "nom_corrige2": "Louise Lebrun",
    "nom_famille": "Lebrun",
    "titre_genre2": "Mairesse",
    "remuneration": "30173",
    "allocation": "6127",
    "remuneration2": "22837",
    "allocation2": "11419",
    "total": "70556",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "367",
    "nom_corrige2": "MARCEL GAUDREAU",
    "nom_famille": "GAUDREAU",
    "titre_genre2": "Maire",
    "remuneration": "31668",
    "allocation": "13768",
    "remuneration2": "16586",
    "allocation2": "8293",
    "total": "70315",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "368",
    "nom_corrige2": "Réjean Gouin",
    "nom_famille": "Gouin",
    "titre_genre2": "Maire",
    "remuneration": "35807",
    "allocation": "17903",
    "remuneration2": "11000",
    "allocation2": "5500",
    "total": "70210",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "369",
    "nom_corrige2": "Yves Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "47824",
    "allocation": "17546",
    "remuneration2": "4827",
    "allocation2": "0",
    "total": "70197",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "370",
    "nom_corrige2": "Charles Brochu",
    "nom_famille": "Brochu",
    "titre_genre2": "Maire",
    "remuneration": "52596",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "70142",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "371",
    "nom_corrige2": "Vicky Mokas",
    "nom_famille": "Mokas",
    "titre_genre2": "Conseillère",
    "remuneration": "43720",
    "allocation": "17546",
    "remuneration2": "8800",
    "allocation2": "0",
    "total": "70066",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "372",
    "nom_corrige2": "Mireille Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseillère",
    "remuneration": "52443",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "70037",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "373",
    "nom_corrige2": "Michel Thiffault",
    "nom_famille": "Thiffault",
    "titre_genre2": "Conseiller",
    "remuneration": "52443",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "70037",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "374",
    "nom_corrige2": "Serge Bonin",
    "nom_famille": "Bonin",
    "titre_genre2": "Conseiller",
    "remuneration": "52452",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69998",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "375",
    "nom_corrige2": "Jeannot Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseiller",
    "remuneration": "52452",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69998",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "376",
    "nom_corrige2": "Karine Lavertu",
    "nom_famille": "Lavertu",
    "titre_genre2": "Conseillère",
    "remuneration": "52452",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69998",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "377",
    "nom_corrige2": "Fleur Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseillère",
    "remuneration": "52452",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69998",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "378",
    "nom_corrige2": "André Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "52184",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69730",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "379",
    "nom_corrige2": "Éric Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "51667",
    "allocation": "17883",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "69550",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "380",
    "nom_corrige2": "Lise Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "40549",
    "allocation": "17546",
    "remuneration2": "11379",
    "allocation2": "0",
    "total": "69474",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "381",
    "nom_corrige2": "Pierre Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Maire",
    "remuneration": "46732",
    "allocation": "15577",
    "remuneration2": "5025",
    "allocation2": "1943",
    "total": "69277",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "382",
    "nom_corrige2": "Annie Gagnier",
    "nom_famille": "Gagnier",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "51486",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68978",
    "ville": "Montréal",
    "arrondissement": "Saint-Laurent",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "383",
    "nom_corrige2": "Benoit Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Maire",
    "remuneration": "42454",
    "allocation": "17546",
    "remuneration2": "8930",
    "allocation2": "0",
    "total": "68930",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "384",
    "nom_corrige2": "Michel Couturier",
    "nom_famille": "Couturier",
    "titre_genre2": "Maire",
    "remuneration": "41967",
    "allocation": "17546",
    "remuneration2": "9329",
    "allocation2": "0",
    "total": "68842",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "385",
    "nom_corrige2": "Josyanne Forest",
    "nom_famille": "Forest",
    "titre_genre2": "Mairesse",
    "remuneration": "26735",
    "allocation": "13367",
    "remuneration2": "19977",
    "allocation2": "8713",
    "total": "68792",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "386",
    "nom_corrige2": "Germain Majeau",
    "nom_famille": "Majeau",
    "titre_genre2": "Maire",
    "remuneration": "26622",
    "allocation": "13311",
    "remuneration2": "24558",
    "allocation2": "4235",
    "total": "68726",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "387",
    "nom_corrige2": "Daniel Aucoin",
    "nom_famille": "Aucoin",
    "titre_genre2": "Conseiller",
    "remuneration": "42445",
    "allocation": "17546",
    "remuneration2": "8657",
    "allocation2": "0",
    "total": "68648",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "388",
    "nom_corrige2": "Tan Shan Li",
    "nom_famille": "Li",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "51057",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68549",
    "ville": "Montréal",
    "arrondissement": "Sud-Ouest",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "389",
    "nom_corrige2": "Chahi (Sharkie) Tarakjian",
    "nom_famille": "Tarakjian",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "50998",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68490",
    "ville": "Montréal",
    "arrondissement": "Pierrefonds-Roxboro",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "390",
    "nom_corrige2": "LUC CAYER",
    "nom_famille": "CAYER",
    "titre_genre2": "Maire",
    "remuneration": "21029",
    "allocation": "10514",
    "remuneration2": "22632",
    "allocation2": "14296",
    "total": "68471",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "391",
    "nom_corrige2": "Michel Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "50875",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68367",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "392",
    "nom_corrige2": "Daniela Romano",
    "nom_famille": "Romano",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "50874",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68366",
    "ville": "Montréal",
    "arrondissement": "LaSalle",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "393",
    "nom_corrige2": "Philippe Thermidor",
    "nom_famille": "Thermidor",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "50874",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "68366",
    "ville": "Montréal",
    "arrondissement": "Montréal-Nord",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "394",
    "nom_corrige2": "Eugène Jolicoeur",
    "nom_famille": "Jolicoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "36549",
    "allocation": "17546",
    "remuneration2": "14267",
    "allocation2": "0",
    "total": "68362",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "395",
    "nom_corrige2": "Sophie Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseillère",
    "remuneration": "49678",
    "allocation": "17456",
    "remuneration2": "1170",
    "allocation2": "0",
    "total": "68304",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "396",
    "nom_corrige2": "Marc Louis-Seize",
    "nom_famille": "Louis-Seize",
    "titre_genre2": "Maire",
    "remuneration": "26355",
    "allocation": "13178",
    "remuneration2": "28615",
    "allocation2": "0",
    "total": "68148",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "397",
    "nom_corrige2": "Julie Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Mairesse",
    "remuneration": "44764",
    "allocation": "17546",
    "remuneration2": "5675",
    "allocation2": "0",
    "total": "67985",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "398",
    "nom_corrige2": "Richard Desormiers",
    "nom_famille": "Desormiers",
    "titre_genre2": "Maire",
    "remuneration": "34482",
    "allocation": "15456",
    "remuneration2": "17903",
    "allocation2": "83",
    "total": "67924",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "399",
    "nom_corrige2": "Dominique Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Mairesse",
    "remuneration": "40893",
    "allocation": "20446",
    "remuneration2": "6543",
    "allocation2": "0",
    "total": "67882",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "400",
    "nom_corrige2": "Jean-Marc Crevier",
    "nom_famille": "Crevier",
    "titre_genre2": "Conseiller",
    "remuneration": "49613",
    "allocation": "17594",
    "remuneration2": "548",
    "allocation2": "0",
    "total": "67755",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "401",
    "nom_corrige2": "Mélanie Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Mairesse",
    "remuneration": "35360",
    "allocation": "17626",
    "remuneration2": "12705",
    "allocation2": "1851",
    "total": "67542",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "402",
    "nom_corrige2": "Sonia Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Mairesse",
    "remuneration": "41037",
    "allocation": "17546",
    "remuneration2": "8930",
    "allocation2": "0",
    "total": "67513",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "403",
    "nom_corrige2": "Stéphane Béland",
    "nom_famille": "Béland",
    "titre_genre2": "Conseiller",
    "remuneration": "26564",
    "allocation": "13282",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39846",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "404",
    "nom_corrige2": "Marie-Claude Frigault",
    "nom_famille": "Frigault",
    "titre_genre2": "Mairesse",
    "remuneration": "37031",
    "allocation": "15063",
    "remuneration2": "12667",
    "allocation2": "2483",
    "total": "67244",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "405",
    "nom_corrige2": "Darllie Pierre-Louis",
    "nom_famille": "Pierre-Louis",
    "titre_genre2": "Conseillère",
    "remuneration": "36549",
    "allocation": "17546",
    "remuneration2": "13035",
    "allocation2": "0",
    "total": "67130",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "406",
    "nom_corrige2": "Claudia Abaunza",
    "nom_famille": "Abaunza",
    "titre_genre2": "Conseillère",
    "remuneration": "49342",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "66888",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "407",
    "nom_corrige2": "Serge Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "49034",
    "allocation": "17594",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "66628",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "408",
    "nom_corrige2": "Dominic Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Maire",
    "remuneration": "48460",
    "allocation": "9210",
    "remuneration2": "7483",
    "allocation2": "1248",
    "total": "66401",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "409",
    "nom_corrige2": "Isabelle Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Mairesse",
    "remuneration": "48954",
    "allocation": "17239",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "66193",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "410",
    "nom_corrige2": "Marc L'Heureux",
    "nom_famille": "L'Heureux",
    "titre_genre2": "Maire",
    "remuneration": "12151",
    "allocation": "6075",
    "remuneration2": "36028",
    "allocation2": "11711",
    "total": "65965",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "411",
    "nom_corrige2": "Olivier Dumais",
    "nom_famille": "Dumais",
    "titre_genre2": "Maire",
    "remuneration": "38899",
    "allocation": "20470",
    "remuneration2": "4255",
    "allocation2": "2128",
    "total": "65752",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "412",
    "nom_corrige2": "Yves Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Maire",
    "remuneration": "18915",
    "allocation": "9457",
    "remuneration2": "29272",
    "allocation2": "8089",
    "total": "65733",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "413",
    "nom_corrige2": "Brent Montgomery",
    "nom_famille": "Montgomery",
    "titre_genre2": "Maire",
    "remuneration": "42976",
    "allocation": "18207",
    "remuneration2": "4483",
    "allocation2": "0",
    "total": "65666",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "414",
    "nom_corrige2": "Tina Delvecchio",
    "nom_famille": "Delvecchio",
    "titre_genre2": "Conseillère",
    "remuneration": "48142",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "65598",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "415",
    "nom_corrige2": "Heidi Ektvedt",
    "nom_famille": "Ektvedt",
    "titre_genre2": "Mairesse",
    "remuneration": "31329",
    "allocation": "15664",
    "remuneration2": "16592",
    "allocation2": "1893",
    "total": "65478",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "416",
    "nom_corrige2": "Yvon Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Maire",
    "remuneration": "5689",
    "allocation": "2845",
    "remuneration2": "37996",
    "allocation2": "18824",
    "total": "65354",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "417",
    "nom_corrige2": "Bernard Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Maire",
    "remuneration": "16423",
    "allocation": "6774",
    "remuneration2": "34090",
    "allocation2": "7982",
    "total": "65269",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "418",
    "nom_corrige2": "Sarah Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Mairesse",
    "remuneration": "40738",
    "allocation": "18943",
    "remuneration2": "5556",
    "allocation2": "0",
    "total": "65237",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "419",
    "nom_corrige2": "Magalie Queval",
    "nom_famille": "Queval",
    "titre_genre2": "Conseillère",
    "remuneration": "32005",
    "allocation": "16002",
    "remuneration2": "15675",
    "allocation2": "1544",
    "total": "65226",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "420",
    "nom_corrige2": "Francine Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Mairesse",
    "remuneration": "47606",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "65152",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "421",
    "nom_corrige2": "Carl Miguel Maldonado",
    "nom_famille": "Maldonado",
    "titre_genre2": "Conseiller",
    "remuneration": "47480",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "65026",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "422",
    "nom_corrige2": "Anne Barabé",
    "nom_famille": "Barabé",
    "titre_genre2": "Conseillère",
    "remuneration": "37982",
    "allocation": "17546",
    "remuneration2": "9450",
    "allocation2": "0",
    "total": "64978",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "423",
    "nom_corrige2": "René Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Maire",
    "remuneration": "15046",
    "allocation": "7524",
    "remuneration2": "32282",
    "allocation2": "10023",
    "total": "64875",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "424",
    "nom_corrige2": "Michel Corbeil",
    "nom_famille": "Corbeil",
    "titre_genre2": "Conseiller",
    "remuneration": "47213",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "64759",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "425",
    "nom_corrige2": "Sylvie Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Mairesse",
    "remuneration": "47099",
    "allocation": "17543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "64642",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "426",
    "nom_corrige2": "Jonathan Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Maire",
    "remuneration": "37673",
    "allocation": "18837",
    "remuneration2": "8074",
    "allocation2": "0",
    "total": "64584",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "427",
    "nom_corrige2": "Alain Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Maire",
    "remuneration": "48702",
    "allocation": "15858",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "64560",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "428",
    "nom_corrige2": "Brigitte Collin",
    "nom_famille": "Collin",
    "titre_genre2": "Conseillère",
    "remuneration": "26593",
    "allocation": "12097",
    "remuneration2": "17634",
    "allocation2": "8205",
    "total": "64529",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "429",
    "nom_corrige2": "Marie Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "46864",
    "allocation": "17524",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "64388",
    "ville": "Montréal",
    "arrondissement": "Outremont",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "430",
    "nom_corrige2": "Jonathan Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Maire",
    "remuneration": "52678",
    "allocation": "11378",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "64056",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "431",
    "nom_corrige2": "Christian Gaudette",
    "nom_famille": "Gaudette",
    "titre_genre2": "Conseiller",
    "remuneration": "42116",
    "allocation": "17456",
    "remuneration2": "4410",
    "allocation2": "0",
    "total": "63982",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "432",
    "nom_corrige2": "Daniel Lucier",
    "nom_famille": "Lucier",
    "titre_genre2": "Conseiller",
    "remuneration": "41709",
    "allocation": "17456",
    "remuneration2": "4680",
    "allocation2": "0",
    "total": "63845",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "433",
    "nom_corrige2": "Vincent Deguise",
    "nom_famille": "Deguise",
    "titre_genre2": "Maire",
    "remuneration": "37541",
    "allocation": "17546",
    "remuneration2": "8622",
    "allocation2": "0",
    "total": "63709",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "434",
    "nom_corrige2": "Caroline Braun",
    "nom_famille": "Braun",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "46139",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63631",
    "ville": "Montréal",
    "arrondissement": "Outremont",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "435",
    "nom_corrige2": "Richard Burcombe",
    "nom_famille": "Burcombe",
    "titre_genre2": "Maire",
    "remuneration": "31836",
    "allocation": "15919",
    "remuneration2": "14216",
    "allocation2": "1628",
    "total": "63599",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "436",
    "nom_corrige2": "Marc-André Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "37410",
    "allocation": "17367",
    "remuneration2": "8800",
    "allocation2": "0",
    "total": "63577",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "437",
    "nom_corrige2": "Pierre Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Maire",
    "remuneration": "25764",
    "allocation": "12882",
    "remuneration2": "16587",
    "allocation2": "8293",
    "total": "63526",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "438",
    "nom_corrige2": "Sylvain Brazeau",
    "nom_famille": "Brazeau",
    "titre_genre2": "Maire",
    "remuneration": "33584",
    "allocation": "16792",
    "remuneration2": "11399",
    "allocation2": "1748",
    "total": "63523",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "439",
    "nom_corrige2": "Céline-Audrey Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "45895",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63387",
    "ville": "Montréal",
    "arrondissement": "Verdun",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "440",
    "nom_corrige2": "Melissa Monk",
    "nom_famille": "Monk",
    "titre_genre2": "Conseillère",
    "remuneration": "25666",
    "allocation": "12833",
    "remuneration2": "20095",
    "allocation2": "4713",
    "total": "63307",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "441",
    "nom_corrige2": "Luc Rhéaume",
    "nom_famille": "Rhéaume",
    "titre_genre2": "Conseiller",
    "remuneration": "45668",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63214",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "442",
    "nom_corrige2": "Richard Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "45690",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63182",
    "ville": "Montréal",
    "arrondissement": "Anjou",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "443",
    "nom_corrige2": "Kristine Marsolais",
    "nom_famille": "Marsolais",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "45690",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63182",
    "ville": "Montréal",
    "arrondissement": "Anjou",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "444",
    "nom_corrige2": "Raymond Masse",
    "nom_famille": "Masse",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "445",
    "nom_corrige2": "Jacques Prescott",
    "nom_famille": "Prescott",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "446",
    "nom_corrige2": "Karine Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseillère",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "447",
    "nom_corrige2": "Martine Roux",
    "nom_famille": "Roux",
    "titre_genre2": "Conseillère",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "448",
    "nom_corrige2": "Jennifer Robillard",
    "nom_famille": "Robillard",
    "titre_genre2": "Conseillère",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "449",
    "nom_corrige2": "Martine Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseillère",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "450",
    "nom_corrige2": "Kevin Buteau",
    "nom_famille": "Buteau",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "451",
    "nom_corrige2": "Normand Urbain",
    "nom_famille": "Urbain",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "452",
    "nom_corrige2": "Joubert Simon",
    "nom_famille": "Simon",
    "titre_genre2": "Conseiller",
    "remuneration": "45607",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63153",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "453",
    "nom_corrige2": "Michel Milette",
    "nom_famille": "Milette",
    "titre_genre2": "Conseiller",
    "remuneration": "42970",
    "allocation": "16687",
    "remuneration2": "3462",
    "allocation2": "0",
    "total": "63119",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "454",
    "nom_corrige2": "Suzanne Marceau",
    "nom_famille": "Marceau",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "45569",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63061",
    "ville": "Montréal",
    "arrondissement": "Ile-Bizard - Sainte-Geneviève",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "455",
    "nom_corrige2": "Mathieu Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "45605",
    "allocation": "17401",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "63006",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "456",
    "nom_corrige2": "Sonia Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "45262",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62808",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "457",
    "nom_corrige2": "Steve Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Maire",
    "remuneration": "31325",
    "allocation": "12875",
    "remuneration2": "16281",
    "allocation2": "2311",
    "total": "62792",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "458",
    "nom_corrige2": "Gilles Daraiche",
    "nom_famille": "Daraiche",
    "titre_genre2": "Maire",
    "remuneration": "45243",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62789",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "459",
    "nom_corrige2": "SERGE PAQUETTE",
    "nom_famille": "PAQUETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "45216",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62750",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "460",
    "nom_corrige2": "Andrée Kronström",
    "nom_famille": "Kronström",
    "titre_genre2": "Conseillère",
    "remuneration": "47877",
    "allocation": "14622",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62499",
    "ville": "Lévis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "154091"
  },
  {
    "ID": "461",
    "nom_corrige2": "PATRICK MARINEAU",
    "nom_famille": "MARINEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "44899",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62433",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "462",
    "nom_corrige2": "STÉPHANE BERTRAND",
    "nom_famille": "BERTRAND",
    "titre_genre2": "Conseiller",
    "remuneration": "44873",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62407",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "463",
    "nom_corrige2": "Francine Charles",
    "nom_famille": "Charles",
    "titre_genre2": "Conseillère",
    "remuneration": "44778",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62319",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "464",
    "nom_corrige2": "Chloe Hutchison",
    "nom_famille": "Hutchison",
    "titre_genre2": "Mairesse",
    "remuneration": "28979",
    "allocation": "14489",
    "remuneration2": "15693",
    "allocation2": "3036",
    "total": "62197",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "465",
    "nom_corrige2": "Daniel Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "43853",
    "allocation": "17546",
    "remuneration2": "707",
    "allocation2": "0",
    "total": "62106",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "466",
    "nom_corrige2": "Michel Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Conseiller",
    "remuneration": "44553",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "62094",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "467",
    "nom_corrige2": "Gino Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Maire",
    "remuneration": "31200",
    "allocation": "15600",
    "remuneration2": "13207",
    "allocation2": "1946",
    "total": "61953",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "468",
    "nom_corrige2": "Claude Larochelle",
    "nom_famille": "Larochelle",
    "titre_genre2": "Conseiller",
    "remuneration": "33779",
    "allocation": "16890",
    "remuneration2": "10500",
    "allocation2": "656",
    "total": "61825",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "469",
    "nom_corrige2": "Jacynthe Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Mairesse",
    "remuneration": "10795",
    "allocation": "5397",
    "remuneration2": "30407",
    "allocation2": "15203",
    "total": "61802",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "470",
    "nom_corrige2": "Mélanie Royer-Couture",
    "nom_famille": "Royer-Couture",
    "titre_genre2": "Mairesse",
    "remuneration": "28470",
    "allocation": "14235",
    "remuneration2": "13206",
    "allocation2": "5878",
    "total": "61789",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "471",
    "nom_corrige2": "Lori Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseillère",
    "remuneration": "40351",
    "allocation": "17546",
    "remuneration2": "3777",
    "allocation2": "0",
    "total": "61674",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "472",
    "nom_corrige2": "Odile Comeau",
    "nom_famille": "Comeau",
    "titre_genre2": "Mairesse",
    "remuneration": "14560",
    "allocation": "5509",
    "remuneration2": "27716",
    "allocation2": "13858",
    "total": "61643",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "473",
    "nom_corrige2": "Caroline Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Mairesse",
    "remuneration": "39309",
    "allocation": "17546",
    "remuneration2": "4525",
    "allocation2": "0",
    "total": "61380",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "474",
    "nom_corrige2": "Marie Josée Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "43747",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "61203",
    "ville": "Montréal",
    "arrondissement": "Anjou",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "475",
    "nom_corrige2": "Jean-Marie Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Maire",
    "remuneration": "15895",
    "allocation": "7947",
    "remuneration2": "27477",
    "allocation2": "9599",
    "total": "60918",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "476",
    "nom_corrige2": "Héloïse Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "43253",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "60799",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "477",
    "nom_corrige2": "Mylène Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseillère",
    "remuneration": "43253",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "60799",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "478",
    "nom_corrige2": "Jonathan V. Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Maire",
    "remuneration": "22949",
    "allocation": "11474",
    "remuneration2": "24261",
    "allocation2": "2098",
    "total": "60782",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "479",
    "nom_corrige2": "Gilles Salvas",
    "nom_famille": "Salvas",
    "titre_genre2": "Maire",
    "remuneration": "14346",
    "allocation": "7173",
    "remuneration2": "26064",
    "allocation2": "12898",
    "total": "60481",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "480",
    "nom_corrige2": "Isabelle Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Mairesse",
    "remuneration": "43000",
    "allocation": "17401",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "60401",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "481",
    "nom_corrige2": "Isabelle Duchesne",
    "nom_famille": "Duchesne",
    "titre_genre2": "Conseillère",
    "remuneration": "42277",
    "allocation": "17546",
    "remuneration2": "566",
    "allocation2": "0",
    "total": "60389",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "482",
    "nom_corrige2": "MARIE-CLAUDE COLLIN",
    "nom_famille": "COLLIN",
    "titre_genre2": "Conseillère",
    "remuneration": "42718",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "60252",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "483",
    "nom_corrige2": "Stéphanie Quintal",
    "nom_famille": "Quintal",
    "titre_genre2": "Conseillère",
    "remuneration": "42479",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59935",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "484",
    "nom_corrige2": "Paul Labranche",
    "nom_famille": "Labranche",
    "titre_genre2": "Maire",
    "remuneration": "14055",
    "allocation": "7028",
    "remuneration2": "35376",
    "allocation2": "3454",
    "total": "59913",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "485",
    "nom_corrige2": "Patrick Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "42440",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59896",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "486",
    "nom_corrige2": "Isabelle Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Mairesse",
    "remuneration": "28634",
    "allocation": "14650",
    "remuneration2": "11000",
    "allocation2": "5500",
    "total": "59784",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "487",
    "nom_corrige2": "Cathy Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "41711",
    "allocation": "17546",
    "remuneration2": "483",
    "allocation2": "0",
    "total": "59740",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "488",
    "nom_corrige2": "Frank Pappas",
    "nom_famille": "Pappas",
    "titre_genre2": "Maire",
    "remuneration": "30780",
    "allocation": "15396",
    "remuneration2": "12493",
    "allocation2": "1066",
    "total": "59735",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "489",
    "nom_corrige2": "MARIE-CLAUDE PERRON",
    "nom_famille": "PERRON",
    "titre_genre2": "Conseillère",
    "remuneration": "42174",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59708",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "490",
    "nom_corrige2": "DAVID MALENFANT",
    "nom_famille": "MALENFANT",
    "titre_genre2": "Conseiller",
    "remuneration": "42174",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59708",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "491",
    "nom_corrige2": "STÉPHANE DUFOUR",
    "nom_famille": "DUFOUR",
    "titre_genre2": "Conseiller",
    "remuneration": "42174",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59708",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "492",
    "nom_corrige2": "Éric Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Maire",
    "remuneration": "37651",
    "allocation": "16586",
    "remuneration2": "4487",
    "allocation2": "959",
    "total": "59683",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "493",
    "nom_corrige2": "Lise Poissant",
    "nom_famille": "Poissant",
    "titre_genre2": "Mairesse",
    "remuneration": "20811",
    "allocation": "7556",
    "remuneration2": "22529",
    "allocation2": "8546",
    "total": "59442",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "494",
    "nom_corrige2": "Sylvie Bureau",
    "nom_famille": "Bureau",
    "titre_genre2": "Mairesse",
    "remuneration": "31867",
    "allocation": "16316",
    "remuneration2": "7476",
    "allocation2": "3783",
    "total": "59442",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "495",
    "nom_corrige2": "Catherine Lassonde",
    "nom_famille": "Lassonde",
    "titre_genre2": "Conseillère",
    "remuneration": "41824",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59370",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "496",
    "nom_corrige2": "Ghislaine Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Mairesse",
    "remuneration": "16115",
    "allocation": "8057",
    "remuneration2": "26142",
    "allocation2": "9046",
    "total": "59360",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "497",
    "nom_corrige2": "Pierre Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Maire",
    "remuneration": "17663",
    "allocation": "8064",
    "remuneration2": "22396",
    "allocation2": "11198",
    "total": "59321",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "498",
    "nom_corrige2": "François Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "499",
    "nom_corrige2": "Robert Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Conseiller",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "500",
    "nom_corrige2": "Guylaine Coursol",
    "nom_famille": "Coursol",
    "titre_genre2": "Conseillère",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "501",
    "nom_corrige2": "Isabelle Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "502",
    "nom_corrige2": "Marc Laurin",
    "nom_famille": "Laurin",
    "titre_genre2": "Conseiller",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "503",
    "nom_corrige2": "Catherine Maréchal",
    "nom_famille": "Maréchal",
    "titre_genre2": "Conseillère",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "504",
    "nom_corrige2": "Émilie Derganc",
    "nom_famille": "Derganc",
    "titre_genre2": "Conseillère",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "505",
    "nom_corrige2": "Roxanne Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "41773",
    "allocation": "17541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59314",
    "ville": "Mirabel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "64032"
  },
  {
    "ID": "506",
    "nom_corrige2": "Alexandre Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseiller",
    "remuneration": "41759",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59305",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "507",
    "nom_corrige2": "Guy Simon",
    "nom_famille": "Simon",
    "titre_genre2": "Maire",
    "remuneration": "16667",
    "allocation": "9054",
    "remuneration2": "22361",
    "allocation2": "11180",
    "total": "59262",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "508",
    "nom_corrige2": "Louise Boudrias",
    "nom_famille": "Boudrias",
    "titre_genre2": "Conseillère",
    "remuneration": "46768",
    "allocation": "12485",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59253",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "509",
    "nom_corrige2": "PHILIPPE MAGNENAT",
    "nom_famille": "MAGNENAT",
    "titre_genre2": "Conseiller",
    "remuneration": "41679",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59213",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "510",
    "nom_corrige2": "FRANCIS ALLAIRE",
    "nom_famille": "ALLAIRE",
    "titre_genre2": "Conseiller",
    "remuneration": "41679",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59213",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "511",
    "nom_corrige2": "NICOLE RUEL",
    "nom_famille": "RUEL",
    "titre_genre2": "Conseillère",
    "remuneration": "41679",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59213",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "512",
    "nom_corrige2": "MICHÈLE MURRAY",
    "nom_famille": "MURRAY",
    "titre_genre2": "Conseillère",
    "remuneration": "41679",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59213",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "513",
    "nom_corrige2": "Antoine Assaf",
    "nom_famille": "Assaf",
    "titre_genre2": "Conseiller",
    "remuneration": "41709",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59165",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "514",
    "nom_corrige2": "Josée Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseillère",
    "remuneration": "41576",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59122",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "515",
    "nom_corrige2": "Sarah Saint-Cyr Lanoie",
    "nom_famille": "Saint-Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "41504",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "59050",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "516",
    "nom_corrige2": "Jacynthe Prince",
    "nom_famille": "Prince",
    "titre_genre2": "Conseillère",
    "remuneration": "41396",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "58942",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "517",
    "nom_corrige2": "JEAN-FRANÇOIS PINARD",
    "nom_famille": "PINARD",
    "titre_genre2": "Conseiller",
    "remuneration": "41379",
    "allocation": "17534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "58913",
    "ville": "Blainville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "62643"
  },
  {
    "ID": "518",
    "nom_corrige2": "Jean-François Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Maire",
    "remuneration": "23702",
    "allocation": "10298",
    "remuneration2": "17619",
    "allocation2": "7248",
    "total": "58867",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "519",
    "nom_corrige2": "Danielle Myrand",
    "nom_famille": "Myrand",
    "titre_genre2": "Conseillère d'arrondissement",
    "remuneration": "41271",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "58763",
    "ville": "Montréal",
    "arrondissement": "Ile-Bizard - Sainte-Geneviève",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "520",
    "nom_corrige2": "Lise Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "35290",
    "allocation": "17546",
    "remuneration2": "5850",
    "allocation2": "0",
    "total": "58686",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "521",
    "nom_corrige2": "Suzanne Boulais",
    "nom_famille": "Boulais",
    "titre_genre2": "Mairesse",
    "remuneration": "21536",
    "allocation": "10098",
    "remuneration2": "19437",
    "allocation2": "7447",
    "total": "58518",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "522",
    "nom_corrige2": "Eric Normandin",
    "nom_famille": "Normandin",
    "titre_genre2": "Conseiller",
    "remuneration": "24816",
    "allocation": "12410",
    "remuneration2": "15850",
    "allocation2": "5136",
    "total": "58212",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "523",
    "nom_corrige2": "Michel Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Maire",
    "remuneration": "15309",
    "allocation": "7655",
    "remuneration2": "25350",
    "allocation2": "9891",
    "total": "58205",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "524",
    "nom_corrige2": "Christine Mcaleer",
    "nom_famille": "Mcaleer",
    "titre_genre2": "Mairesse",
    "remuneration": "31727",
    "allocation": "15864",
    "remuneration2": "7035",
    "allocation2": "3518",
    "total": "58144",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "525",
    "nom_corrige2": "Éric Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "40549",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "58095",
    "ville": "Mascouche",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "53009"
  },
  {
    "ID": "526",
    "nom_corrige2": "Julie Brisebois",
    "nom_famille": "Brisebois",
    "titre_genre2": "Mairesse",
    "remuneration": "17546",
    "allocation": "8773",
    "remuneration2": "23013",
    "allocation2": "8744",
    "total": "58076",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "527",
    "nom_corrige2": "Luc Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseiller",
    "remuneration": "40176",
    "allocation": "17546",
    "remuneration2": "315",
    "allocation2": "0",
    "total": "58037",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "528",
    "nom_corrige2": "Nathacha Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Mairesse",
    "remuneration": "29969",
    "allocation": "12985",
    "remuneration2": "10025",
    "allocation2": "5013",
    "total": "57992",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "529",
    "nom_corrige2": "André Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Maire",
    "remuneration": "30930",
    "allocation": "15228",
    "remuneration2": "7932",
    "allocation2": "3754",
    "total": "57844",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "530",
    "nom_corrige2": "Mélanie Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseillère",
    "remuneration": "40266",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57812",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "531",
    "nom_corrige2": "Johane Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "40176",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57722",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "532",
    "nom_corrige2": "Barbara Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "40176",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57722",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "533",
    "nom_corrige2": "Carole Léger",
    "nom_famille": "Léger",
    "titre_genre2": "Conseillère",
    "remuneration": "39523",
    "allocation": "17546",
    "remuneration2": "566",
    "allocation2": "0",
    "total": "57635",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "534",
    "nom_corrige2": "Julie Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseillère",
    "remuneration": "39994",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57540",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "535",
    "nom_corrige2": "Daniel Kaeser",
    "nom_famille": "Kaeser",
    "titre_genre2": "Conseiller",
    "remuneration": "39904",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57450",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "536",
    "nom_corrige2": "Pascal Binet",
    "nom_famille": "Binet",
    "titre_genre2": "Maire",
    "remuneration": "36538",
    "allocation": "15865",
    "remuneration2": "3363",
    "allocation2": "1681",
    "total": "57447",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "537",
    "nom_corrige2": "Armando Melo",
    "nom_famille": "Melo",
    "titre_genre2": "Conseiller",
    "remuneration": "39858",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57404",
    "ville": "Sainte-Thérèse",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "26702"
  },
  {
    "ID": "538",
    "nom_corrige2": "Raouf Absi",
    "nom_famille": "Absi",
    "titre_genre2": "Conseiller",
    "remuneration": "39818",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57364",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "539",
    "nom_corrige2": "Jocelyn Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Maire",
    "remuneration": "22090",
    "allocation": "16035",
    "remuneration2": "11045",
    "allocation2": "8017",
    "total": "57187",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "540",
    "nom_corrige2": "Jonathan Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "39436",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "56982",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "541",
    "nom_corrige2": "Véronique Venne",
    "nom_famille": "Venne",
    "titre_genre2": "Mairesse",
    "remuneration": "13679",
    "allocation": "6839",
    "remuneration2": "25640",
    "allocation2": "10707",
    "total": "56865",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "542",
    "nom_corrige2": "RAYMOND NOËL",
    "nom_famille": "NOËL",
    "titre_genre2": "Maire",
    "remuneration": "25719",
    "allocation": "12859",
    "remuneration2": "16963",
    "allocation2": "1086",
    "total": "56627",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "543",
    "nom_corrige2": "Kévin Maurice",
    "nom_famille": "Maurice",
    "titre_genre2": "Maire",
    "remuneration": "28459",
    "allocation": "14230",
    "remuneration2": "9120",
    "allocation2": "4560",
    "total": "56369",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "544",
    "nom_corrige2": "Jean-Philippe Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseiller",
    "remuneration": "38806",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "56352",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "545",
    "nom_corrige2": "Guy Veillette",
    "nom_famille": "Veillette",
    "titre_genre2": "Maire",
    "remuneration": "13007",
    "allocation": "6504",
    "remuneration2": "24560",
    "allocation2": "12280",
    "total": "56351",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "546",
    "nom_corrige2": "Mario Sévigny",
    "nom_famille": "Sévigny",
    "titre_genre2": "Conseiller",
    "remuneration": "38146",
    "allocation": "17546",
    "remuneration2": "566",
    "allocation2": "0",
    "total": "56258",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "547",
    "nom_corrige2": "Paul Barriault",
    "nom_famille": "Barriault",
    "titre_genre2": "Maire",
    "remuneration": "38711",
    "allocation": "17401",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "56112",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "548",
    "nom_corrige2": "Sylvain Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Maire",
    "remuneration": "16667",
    "allocation": "8333",
    "remuneration2": "21719",
    "allocation2": "9218",
    "total": "55937",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "549",
    "nom_corrige2": "Dany Quirion",
    "nom_famille": "Quirion",
    "titre_genre2": "Maire",
    "remuneration": "12800",
    "allocation": "5125",
    "remuneration2": "25494",
    "allocation2": "12320",
    "total": "55739",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "550",
    "nom_corrige2": "Marc-André Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseiller",
    "remuneration": "38146",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "55692",
    "ville": "Drummondville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "81551"
  },
  {
    "ID": "551",
    "nom_corrige2": "Anna Guarnieri",
    "nom_famille": "Guarnieri",
    "titre_genre2": "Conseillère",
    "remuneration": "37946",
    "allocation": "17368",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "55314",
    "ville": "Terrebonne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "122098"
  },
  {
    "ID": "552",
    "nom_corrige2": "Richard Belhumeur",
    "nom_famille": "Belhumeur",
    "titre_genre2": "Maire",
    "remuneration": "30121",
    "allocation": "15061",
    "remuneration2": "6636",
    "allocation2": "3318",
    "total": "55136",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "553",
    "nom_corrige2": "Stephen Matthews",
    "nom_famille": "Matthews",
    "titre_genre2": "Maire",
    "remuneration": "20918",
    "allocation": "10459",
    "remuneration2": "15810",
    "allocation2": "7900",
    "total": "55087",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "554",
    "nom_corrige2": "Mathieu Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "555",
    "nom_corrige2": "Claude Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Maire",
    "remuneration": "27178",
    "allocation": "12914",
    "remuneration2": "9889",
    "allocation2": "4945",
    "total": "54926",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "556",
    "nom_corrige2": "France Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Mairesse",
    "remuneration": "36778",
    "allocation": "14075",
    "remuneration2": "4035",
    "allocation2": "0",
    "total": "54888",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "557",
    "nom_corrige2": "Richard Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "37335",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54791",
    "ville": "Montréal",
    "arrondissement": "Ile-Bizard - Sainte-Geneviève",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "558",
    "nom_corrige2": "Simon Giard",
    "nom_famille": "Giard",
    "titre_genre2": "Maire",
    "remuneration": "14553",
    "allocation": "7277",
    "remuneration2": "21741",
    "allocation2": "11121",
    "total": "54692",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "559",
    "nom_corrige2": "Daniel Cournoyer",
    "nom_famille": "Cournoyer",
    "titre_genre2": "Conseiller",
    "remuneration": "28837",
    "allocation": "14418",
    "remuneration2": "8259",
    "allocation2": "3128",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "560",
    "nom_corrige2": "Pascale Albernhe-Lahaie",
    "nom_famille": "Albernhe-Lahaie",
    "titre_genre2": "Conseillère",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "561",
    "nom_corrige2": "François Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "562",
    "nom_corrige2": "Maryse Bellemare",
    "nom_famille": "Bellemare",
    "titre_genre2": "Conseillère",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "563",
    "nom_corrige2": "Jonathan Bradley",
    "nom_famille": "Bradley",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "564",
    "nom_corrige2": "Dany Carpentier",
    "nom_famille": "Carpentier",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "565",
    "nom_corrige2": "Pierre-Luc Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "566",
    "nom_corrige2": "Alain Lafontaine",
    "nom_famille": "Lafontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "567",
    "nom_corrige2": "Pierre Montreuil",
    "nom_famille": "Montreuil",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "568",
    "nom_corrige2": "Sabrina Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "569",
    "nom_corrige2": "Luc Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "570",
    "nom_corrige2": "Geneviève Auclair",
    "nom_famille": "Auclair",
    "titre_genre2": "Conseillère",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "571",
    "nom_corrige2": "Richard W. Dober",
    "nom_famille": "Dober",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "572",
    "nom_corrige2": "René Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "37096",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54642",
    "ville": "Trois-Rivières",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "142598"
  },
  {
    "ID": "573",
    "nom_corrige2": "Alain Wilson",
    "nom_famille": "Wilson",
    "titre_genre2": "Conseiller d'arrondissement",
    "remuneration": "37156",
    "allocation": "17456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54612",
    "ville": "Montréal",
    "arrondissement": "Ile-Bizard - Sainte-Geneviève",
    "region_adm": "Montréal",
    "population": "1800055"
  },
  {
    "ID": "574",
    "nom_corrige2": "Michael C. Turcot",
    "nom_famille": "Turcot",
    "titre_genre2": "Maire",
    "remuneration": "29748",
    "allocation": "13899",
    "remuneration2": "7292",
    "allocation2": "3646",
    "total": "54585",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "575",
    "nom_corrige2": "Kevin Boyle",
    "nom_famille": "Boyle",
    "titre_genre2": "Maire",
    "remuneration": "17484",
    "allocation": "8742",
    "remuneration2": "19509",
    "allocation2": "8804",
    "total": "54539",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "576",
    "nom_corrige2": "Denis Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Maire",
    "remuneration": "31311",
    "allocation": "15655",
    "remuneration2": "6208",
    "allocation2": "1364",
    "total": "54538",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "577",
    "nom_corrige2": "Karine Laramée",
    "nom_famille": "Laramée",
    "titre_genre2": "Conseillère",
    "remuneration": "36690",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54236",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "578",
    "nom_corrige2": "Jean-François Hecq",
    "nom_famille": "Hecq",
    "titre_genre2": "Conseiller",
    "remuneration": "36690",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54236",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "579",
    "nom_corrige2": "Simon Sesto Cifola",
    "nom_famille": "Sesto",
    "titre_genre2": "Conseiller",
    "remuneration": "36617",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54163",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "580",
    "nom_corrige2": "Pierre Lortie",
    "nom_famille": "Lortie",
    "titre_genre2": "Conseiller",
    "remuneration": "37054",
    "allocation": "16992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "54046",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "581",
    "nom_corrige2": "Maude Whittom",
    "nom_famille": "Whittom",
    "titre_genre2": "Conseillère",
    "remuneration": "36413",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "53959",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "582",
    "nom_corrige2": "Pascal Théroux",
    "nom_famille": "Théroux",
    "titre_genre2": "Maire",
    "remuneration": "26667",
    "allocation": "13333",
    "remuneration2": "11471",
    "allocation2": "2445",
    "total": "53916",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "583",
    "nom_corrige2": "Jérémy Dion Bernard",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "1560",
    "allocation2": "780",
    "total": "38414",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "584",
    "nom_corrige2": "Michelle Hui",
    "nom_famille": "Hui",
    "titre_genre2": "Conseillère",
    "remuneration": "36550",
    "allocation": "17163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "53713",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "585",
    "nom_corrige2": "Camille Joli-Coeur",
    "nom_famille": "Joli-Coeur",
    "titre_genre2": "Conseillère",
    "remuneration": "35880",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "53426",
    "ville": "Boisbriand",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "28122"
  },
  {
    "ID": "586",
    "nom_corrige2": "Johnny Salera",
    "nom_famille": "Salera",
    "titre_genre2": "Maire",
    "remuneration": "31467",
    "allocation": "15733",
    "remuneration2": "4066",
    "allocation2": "2033",
    "total": "53299",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "587",
    "nom_corrige2": "KARL LACOUVÉE",
    "nom_famille": "LACOUVÉE",
    "titre_genre2": "Maire",
    "remuneration": "24375",
    "allocation": "12187",
    "remuneration2": "9901",
    "allocation2": "6805",
    "total": "53268",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "588",
    "nom_corrige2": "Pierre Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Maire",
    "remuneration": "24300",
    "allocation": "12150",
    "remuneration2": "11138",
    "allocation2": "5569",
    "total": "53157",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "589",
    "nom_corrige2": "François Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseiller",
    "remuneration": "40987",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "58533",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "590",
    "nom_corrige2": "Michel Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Maire",
    "remuneration": "23452",
    "allocation": "11726",
    "remuneration2": "11832",
    "allocation2": "5820",
    "total": "52830",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "591",
    "nom_corrige2": "Émilie Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Mairesse",
    "remuneration": "24000",
    "allocation": "12000",
    "remuneration2": "11137",
    "allocation2": "5569",
    "total": "52706",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "592",
    "nom_corrige2": "Denis Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "37514",
    "allocation": "14621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "52135",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "593",
    "nom_corrige2": "Aglaia Revelakis",
    "nom_famille": "Revelakis",
    "titre_genre2": "Conseillère",
    "remuneration": "34739",
    "allocation": "17370",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "52109",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "594",
    "nom_corrige2": "Mario Frigon",
    "nom_famille": "Frigon",
    "titre_genre2": "Maire",
    "remuneration": "23401",
    "allocation": "11700",
    "remuneration2": "11250",
    "allocation2": "5625",
    "total": "51976",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "595",
    "nom_corrige2": "Jacques Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Maire",
    "remuneration": "24765",
    "allocation": "12382",
    "remuneration2": "9878",
    "allocation2": "4939",
    "total": "51964",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "596",
    "nom_corrige2": "Isabelle Piché",
    "nom_famille": "Piché",
    "titre_genre2": "Conseillère",
    "remuneration": "34499",
    "allocation": "17250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "51749",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "597",
    "nom_corrige2": "Claude Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Maire",
    "remuneration": "27066",
    "allocation": "13533",
    "remuneration2": "7101",
    "allocation2": "3551",
    "total": "51251",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "598",
    "nom_corrige2": "Henri Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Maire",
    "remuneration": "34075",
    "allocation": "17038",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "51113",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "599",
    "nom_corrige2": "Carl Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseiller",
    "remuneration": "37225",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "51094",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "600",
    "nom_corrige2": "Mario Lasalle",
    "nom_famille": "Lasalle",
    "titre_genre2": "Maire",
    "remuneration": "22231",
    "allocation": "11115",
    "remuneration2": "11679",
    "allocation2": "5839",
    "total": "50864",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "601",
    "nom_corrige2": "Pierre Janecek",
    "nom_famille": "Janecek",
    "titre_genre2": "Maire",
    "remuneration": "21766",
    "allocation": "10883",
    "remuneration2": "12111",
    "allocation2": "6056",
    "total": "50816",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "602",
    "nom_corrige2": "Jean-Yves Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Maire",
    "remuneration": "20000",
    "allocation": "10000",
    "remuneration2": "13837",
    "allocation2": "6919",
    "total": "50756",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "603",
    "nom_corrige2": "BRUNO TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Maire",
    "remuneration": "33825",
    "allocation": "16913",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50738",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "604",
    "nom_corrige2": "Paolo Galati",
    "nom_famille": "Galati",
    "titre_genre2": "Conseiller",
    "remuneration": "33779",
    "allocation": "16890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50669",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "605",
    "nom_corrige2": "Achille Cifelli",
    "nom_famille": "Cifelli",
    "titre_genre2": "Conseiller",
    "remuneration": "33779",
    "allocation": "16890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50669",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "606",
    "nom_corrige2": "David De Cotis",
    "nom_famille": "De",
    "titre_genre2": "Conseiller",
    "remuneration": "33779",
    "allocation": "16890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50669",
    "ville": "Laval",
    "arrondissement": "",
    "region_adm": "Laval",
    "population": "446369"
  },
  {
    "ID": "607",
    "nom_corrige2": "Michel Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "10988",
    "allocation": "5494",
    "remuneration2": "451",
    "allocation2": "225",
    "total": "17158",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "608",
    "nom_corrige2": "Claudio Benedetti",
    "nom_famille": "Benedetti",
    "titre_genre2": "Conseiller",
    "remuneration": "33739",
    "allocation": "16870",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50609",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "609",
    "nom_corrige2": "Xixi Li",
    "nom_famille": "Li",
    "titre_genre2": "Conseillère",
    "remuneration": "33739",
    "allocation": "16870",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50609",
    "ville": "Brossard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "91693"
  },
  {
    "ID": "610",
    "nom_corrige2": "Claire Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseillère",
    "remuneration": "34298",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50330",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "611",
    "nom_corrige2": "Pierre Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Maire",
    "remuneration": "7348",
    "allocation": "3674",
    "remuneration2": "26142",
    "allocation2": "13071",
    "total": "50235",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "612",
    "nom_corrige2": "Sébastien Gaudette",
    "nom_famille": "Gaudette",
    "titre_genre2": "Conseiller",
    "remuneration": "34038",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50070",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "613",
    "nom_corrige2": "Marco Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "34038",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50070",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "614",
    "nom_corrige2": "Félix Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "615",
    "nom_corrige2": "Stéphane Giard",
    "nom_famille": "Giard",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "616",
    "nom_corrige2": "Paul Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "617",
    "nom_corrige2": "Alain Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "618",
    "nom_corrige2": "François Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "619",
    "nom_corrige2": "Geneviève Rheault",
    "nom_famille": "Rheault",
    "titre_genre2": "Conseillère",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "620",
    "nom_corrige2": "Robert Riel",
    "nom_famille": "Riel",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "621",
    "nom_corrige2": "Denyse Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "622",
    "nom_corrige2": "Robert Vincent",
    "nom_famille": "Vincent",
    "titre_genre2": "Conseiller",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "623",
    "nom_corrige2": "Catherine Baudin",
    "nom_famille": "Baudin",
    "titre_genre2": "Conseillère",
    "remuneration": "33340",
    "allocation": "16670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "50010",
    "ville": "Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "70823"
  },
  {
    "ID": "624",
    "nom_corrige2": "Bernard Thompson",
    "nom_famille": "Thompson",
    "titre_genre2": "Maire",
    "remuneration": "11509",
    "allocation": "5754",
    "remuneration2": "21739",
    "allocation2": "10869",
    "total": "49871",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "625",
    "nom_corrige2": "André Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Maire",
    "remuneration": "25338",
    "allocation": "12669",
    "remuneration2": "7567",
    "allocation2": "3784",
    "total": "49358",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "626",
    "nom_corrige2": "Jean-Guy Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Maire",
    "remuneration": "25867",
    "allocation": "12933",
    "remuneration2": "7010",
    "allocation2": "3505",
    "total": "49315",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "627",
    "nom_corrige2": "Jacques Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Maire",
    "remuneration": "27378",
    "allocation": "13689",
    "remuneration2": "5475",
    "allocation2": "2738",
    "total": "49280",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "628",
    "nom_corrige2": "Andrée Brosseau",
    "nom_famille": "Brosseau",
    "titre_genre2": "Mairesse",
    "remuneration": "25090",
    "allocation": "12545",
    "remuneration2": "11570",
    "allocation2": "0",
    "total": "49205",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "629",
    "nom_corrige2": "Sylvie Major",
    "nom_famille": "Major",
    "titre_genre2": "Conseillère",
    "remuneration": "34299",
    "allocation": "14387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48686",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "630",
    "nom_corrige2": "Amélie Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "30272",
    "allocation": "15136",
    "remuneration2": "2165",
    "allocation2": "1083",
    "total": "48656",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "631",
    "nom_corrige2": "Claude Dalpé",
    "nom_famille": "Dalpé",
    "titre_genre2": "Conseiller",
    "remuneration": "30272",
    "allocation": "15136",
    "remuneration2": "1956",
    "allocation2": "978",
    "total": "48342",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "632",
    "nom_corrige2": "Steve Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Maire",
    "remuneration": "30790",
    "allocation": "17545",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48335",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "633",
    "nom_corrige2": "Chantale Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Mairesse",
    "remuneration": "26648",
    "allocation": "12324",
    "remuneration2": "6602",
    "allocation2": "2754",
    "total": "48328",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "634",
    "nom_corrige2": "Jean Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "635",
    "nom_corrige2": "Marianne Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseillère",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "636",
    "nom_corrige2": "Jérémie Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseiller",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "637",
    "nom_corrige2": "Patricia Poissant",
    "nom_famille": "Poissant",
    "titre_genre2": "Conseillère",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "638",
    "nom_corrige2": "Lyne Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseillère",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "639",
    "nom_corrige2": "Jessica Racine-Lehoux",
    "nom_famille": "Racine-Lehoux",
    "titre_genre2": "Conseillère",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "640",
    "nom_corrige2": "François Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "641",
    "nom_corrige2": "Annie Surprenant",
    "nom_famille": "Surprenant",
    "titre_genre2": "Conseillère",
    "remuneration": "32220",
    "allocation": "16032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48252",
    "ville": "Saint-Jean-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "100188"
  },
  {
    "ID": "642",
    "nom_corrige2": "Josette Allard-Gignac",
    "nom_famille": "Allard-Gignac",
    "titre_genre2": "Conseillère",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "643",
    "nom_corrige2": "Lucie De Bons",
    "nom_famille": "De",
    "titre_genre2": "Conseillère",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "644",
    "nom_corrige2": "Jean-Yves Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "645",
    "nom_corrige2": "Nancy Déziel",
    "nom_famille": "Déziel",
    "titre_genre2": "Conseillère",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "646",
    "nom_corrige2": "Guy Arseneault",
    "nom_famille": "Arseneault",
    "titre_genre2": "Conseiller",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "647",
    "nom_corrige2": "Jacinthe Campagna",
    "nom_famille": "Campagna",
    "titre_genre2": "Conseillère",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "648",
    "nom_corrige2": "Louis-Jean Garceau",
    "nom_famille": "Garceau",
    "titre_genre2": "Conseiller",
    "remuneration": "32144",
    "allocation": "16072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "48216",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "649",
    "nom_corrige2": "Vincent Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Maire",
    "remuneration": "29209",
    "allocation": "14605",
    "remuneration2": "2960",
    "allocation2": "1417",
    "total": "48191",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "650",
    "nom_corrige2": "Jean-René Carrière",
    "nom_famille": "Carrière",
    "titre_genre2": "Maire",
    "remuneration": "24912",
    "allocation": "12456",
    "remuneration2": "7200",
    "allocation2": "3600",
    "total": "48168",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "651",
    "nom_corrige2": "Lyne Boulanger",
    "nom_famille": "Boulanger",
    "titre_genre2": "Mairesse",
    "remuneration": "29645",
    "allocation": "14385",
    "remuneration2": "2749",
    "allocation2": "1375",
    "total": "48154",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "652",
    "nom_corrige2": "Mario Chrétien",
    "nom_famille": "Chrétien",
    "titre_genre2": "Conseiller",
    "remuneration": "32054",
    "allocation": "15941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47995",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "653",
    "nom_corrige2": "Luc Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseiller",
    "remuneration": "31884",
    "allocation": "15942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47826",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "654",
    "nom_corrige2": "Louise Allie",
    "nom_famille": "Allie",
    "titre_genre2": "Conseillère",
    "remuneration": "30543",
    "allocation": "15271",
    "remuneration2": "1264",
    "allocation2": "632",
    "total": "47710",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "655",
    "nom_corrige2": "Marcella Davis Gerrish",
    "nom_famille": "Davis",
    "titre_genre2": "Mairesse",
    "remuneration": "27967",
    "allocation": "13875",
    "remuneration2": "3850",
    "allocation2": "1842",
    "total": "47534",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "656",
    "nom_corrige2": "Sylvie Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "30272",
    "allocation": "15136",
    "remuneration2": "1372",
    "allocation2": "686",
    "total": "47466",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "657",
    "nom_corrige2": "Julie Simoneau",
    "nom_famille": "Simoneau",
    "titre_genre2": "Conseillère",
    "remuneration": "34286",
    "allocation": "13037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47323",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "658",
    "nom_corrige2": "Vincent Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller",
    "remuneration": "32526",
    "allocation": "14707",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47233",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "659",
    "nom_corrige2": "Steve Mador",
    "nom_famille": "Mador",
    "titre_genre2": "Maire",
    "remuneration": "25769",
    "allocation": "12885",
    "remuneration2": "8573",
    "allocation2": "0",
    "total": "47227",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "660",
    "nom_corrige2": "Serge Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Maire",
    "remuneration": "26266",
    "allocation": "13133",
    "remuneration2": "5213",
    "allocation2": "2606",
    "total": "47218",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "661",
    "nom_corrige2": "Julie Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "31921",
    "allocation": "15271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47192",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "662",
    "nom_corrige2": "Karim-André Laz",
    "nom_famille": "Laz",
    "titre_genre2": "Conseiller",
    "remuneration": "31921",
    "allocation": "15271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47192",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "663",
    "nom_corrige2": "Corina Lupu",
    "nom_famille": "Lupu",
    "titre_genre2": "Mairesse",
    "remuneration": "19376",
    "allocation": "9688",
    "remuneration2": "12057",
    "allocation2": "6028",
    "total": "47149",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "664",
    "nom_corrige2": "Alain Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "25612",
    "allocation": "10088",
    "remuneration2": "7625",
    "allocation2": "3812",
    "total": "47137",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "665",
    "nom_corrige2": "Sébastien Hallé",
    "nom_famille": "Hallé",
    "titre_genre2": "Conseiller",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "16989",
    "allocation2": "0",
    "total": "47000",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "666",
    "nom_corrige2": "Luc Marsan",
    "nom_famille": "Marsan",
    "titre_genre2": "Conseiller",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "667",
    "nom_corrige2": "François Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseiller",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "668",
    "nom_corrige2": "Jasmine Sharma",
    "nom_famille": "Sharma",
    "titre_genre2": "Conseillère",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "669",
    "nom_corrige2": "Karine Lechasseur",
    "nom_famille": "Lechasseur",
    "titre_genre2": "Conseillère",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "670",
    "nom_corrige2": "Diane Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "671",
    "nom_corrige2": "Gabriel Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "672",
    "nom_corrige2": "Paul Dumoulin",
    "nom_famille": "Dumoulin",
    "titre_genre2": "Conseiller",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "673",
    "nom_corrige2": "Paul M. Normand",
    "nom_famille": "Normand",
    "titre_genre2": "Conseiller",
    "remuneration": "31303",
    "allocation": "15652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46955",
    "ville": "Vaudreuil-Dorion",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "43228"
  },
  {
    "ID": "674",
    "nom_corrige2": "Louise Arpin",
    "nom_famille": "Arpin",
    "titre_genre2": "Mairesse",
    "remuneration": "23021",
    "allocation": "11510",
    "remuneration2": "8249",
    "allocation2": "4125",
    "total": "46905",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "675",
    "nom_corrige2": "Martin Dubreuil",
    "nom_famille": "Dubreuil",
    "titre_genre2": "Conseiller",
    "remuneration": "30543",
    "allocation": "15271",
    "remuneration2": "543",
    "allocation2": "272",
    "total": "46629",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "676",
    "nom_corrige2": "Laurent Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Maire",
    "remuneration": "17096",
    "allocation": "8548",
    "remuneration2": "13980",
    "allocation2": "6990",
    "total": "46614",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "677",
    "nom_corrige2": "Yves Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "29787",
    "allocation": "14894",
    "remuneration2": "1202",
    "allocation2": "601",
    "total": "46484",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "678",
    "nom_corrige2": "Nathalie Ayotte",
    "nom_famille": "Ayotte",
    "titre_genre2": "Conseillère",
    "remuneration": "38554",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46450",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "679",
    "nom_corrige2": "JEAN SIMARD",
    "nom_famille": "SIMARD",
    "titre_genre2": "Conseiller",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "16364",
    "allocation2": "0",
    "total": "46381",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "680",
    "nom_corrige2": "Colette Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "3127",
    "allocation2": "1564",
    "total": "46298",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "681",
    "nom_corrige2": "Jean-Pierre Charuest",
    "nom_famille": "Charuest",
    "titre_genre2": "Maire",
    "remuneration": "25873",
    "allocation": "12937",
    "remuneration2": "7463",
    "allocation2": "0",
    "total": "46273",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "682",
    "nom_corrige2": "Dominique Laverdure",
    "nom_famille": "Laverdure",
    "titre_genre2": "Conseillère",
    "remuneration": "30800",
    "allocation": "15400",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46200",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "683",
    "nom_corrige2": "Isabelle Bleau",
    "nom_famille": "Bleau",
    "titre_genre2": "Conseillère",
    "remuneration": "40284",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "57830",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "684",
    "nom_corrige2": "Germain Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "24737",
    "allocation": "12368",
    "remuneration2": "5683",
    "allocation2": "3364",
    "total": "46152",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "685",
    "nom_corrige2": "YANNICK FRÉCHETTE",
    "nom_famille": "FRÉCHETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "826",
    "allocation2": "413",
    "total": "46132",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "686",
    "nom_corrige2": "Daniel Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "30629",
    "allocation": "15315",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "46111",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "687",
    "nom_corrige2": "Guylaine Lejeune",
    "nom_famille": "Lejeune",
    "titre_genre2": "Conseillère",
    "remuneration": "29101",
    "allocation": "14551",
    "remuneration2": "1638",
    "allocation2": "819",
    "total": "46109",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "688",
    "nom_corrige2": "Pierre Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "1448",
    "allocation2": "0",
    "total": "46000",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "689",
    "nom_corrige2": "Bernard Barré",
    "nom_famille": "Barré",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "1331",
    "allocation2": "50",
    "total": "45933",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "690",
    "nom_corrige2": "Nathalie Lemaire",
    "nom_famille": "Lemaire",
    "titre_genre2": "Mairesse",
    "remuneration": "25711",
    "allocation": "12855",
    "remuneration2": "4978",
    "allocation2": "2381",
    "total": "45925",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "691",
    "nom_corrige2": "Jacques Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "33295",
    "allocation": "12606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45901",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "692",
    "nom_corrige2": "André Marion",
    "nom_famille": "Marion",
    "titre_genre2": "Conseiller",
    "remuneration": "33295",
    "allocation": "12606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45901",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "693",
    "nom_corrige2": "Éric Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Maire",
    "remuneration": "25487",
    "allocation": "11636",
    "remuneration2": "5842",
    "allocation2": "2921",
    "total": "45886",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "694",
    "nom_corrige2": "BENOIT GAUTHIER",
    "nom_famille": "GAUTHIER",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "635",
    "allocation2": "318",
    "total": "45846",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "695",
    "nom_corrige2": "Renée Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseillère",
    "remuneration": "31462",
    "allocation": "15271",
    "remuneration2": "748",
    "allocation2": "0",
    "total": "47481",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "696",
    "nom_corrige2": "Michel Péloquin",
    "nom_famille": "Péloquin",
    "titre_genre2": "Maire",
    "remuneration": "21343",
    "allocation": "10671",
    "remuneration2": "10186",
    "allocation2": "3486",
    "total": "45686",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "697",
    "nom_corrige2": "Micheline Barriault",
    "nom_famille": "Barriault",
    "titre_genre2": "Mairesse",
    "remuneration": "23100",
    "allocation": "11550",
    "remuneration2": "7325",
    "allocation2": "3663",
    "total": "45638",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "698",
    "nom_corrige2": "MICHAEL PROVENCHER",
    "nom_famille": "PROVENCHER",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "445",
    "allocation2": "222",
    "total": "45560",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "699",
    "nom_corrige2": "ALEXANDRE CÔTÉ",
    "nom_famille": "CÔTÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "381",
    "allocation2": "191",
    "total": "45465",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "700",
    "nom_corrige2": "YANICK POISSON",
    "nom_famille": "POISSON",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "381",
    "allocation2": "191",
    "total": "45465",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "701",
    "nom_corrige2": "Laurence Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "5793",
    "allocation2": "2571",
    "total": "45380",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "702",
    "nom_corrige2": "MARC MORIN",
    "nom_famille": "MORIN",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "318",
    "allocation2": "159",
    "total": "45370",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "703",
    "nom_corrige2": "Patrick Bouillé",
    "nom_famille": "Bouillé",
    "titre_genre2": "Maire",
    "remuneration": "26463",
    "allocation": "13230",
    "remuneration2": "3833",
    "allocation2": "1829",
    "total": "45355",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "704",
    "nom_corrige2": "Marie Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Mairesse",
    "remuneration": "25802",
    "allocation": "12481",
    "remuneration2": "4753",
    "allocation2": "2273",
    "total": "45309",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "705",
    "nom_corrige2": "PATRICK PAULIN",
    "nom_famille": "PAULIN",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "254",
    "allocation2": "127",
    "total": "45274",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "706",
    "nom_corrige2": "Jason Morrison",
    "nom_famille": "Morrison",
    "titre_genre2": "Maire",
    "remuneration": "21000",
    "allocation": "10500",
    "remuneration2": "9120",
    "allocation2": "4560",
    "total": "45180",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "707",
    "nom_corrige2": "Mickey Max Guttman",
    "nom_famille": "Guttman",
    "titre_genre2": "Conseiller",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "5690",
    "allocation2": "2403",
    "total": "45109",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "708",
    "nom_corrige2": "Philip Panet-Raymond",
    "nom_famille": "Panet-Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "26425",
    "allocation": "13212",
    "remuneration2": "3596",
    "allocation2": "1798",
    "total": "45031",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "709",
    "nom_corrige2": "Cynthia Harrisson-Tessier",
    "nom_famille": "Harrisson-Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "30000",
    "allocation": "15000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45000",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "710",
    "nom_corrige2": "Chantal Lortie",
    "nom_famille": "Lortie",
    "titre_genre2": "Conseillère",
    "remuneration": "30000",
    "allocation": "15000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45000",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "711",
    "nom_corrige2": "CAROLINE PILON",
    "nom_famille": "PILON",
    "titre_genre2": "Conseillère",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44893",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "712",
    "nom_corrige2": "JAMES CASEY",
    "nom_famille": "CASEY",
    "titre_genre2": "Conseiller",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44893",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "713",
    "nom_corrige2": "CHANTAL MOREAU",
    "nom_famille": "MOREAU",
    "titre_genre2": "Conseillère",
    "remuneration": "29929",
    "allocation": "14964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44893",
    "ville": "Victoriaville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "48461"
  },
  {
    "ID": "714",
    "nom_corrige2": "Frédéric Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "5568",
    "allocation2": "2784",
    "total": "44852",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "715",
    "nom_corrige2": "Pierre Desaulniers",
    "nom_famille": "Desaulniers",
    "titre_genre2": "Maire",
    "remuneration": "23254",
    "allocation": "11627",
    "remuneration2": "6641",
    "allocation2": "3321",
    "total": "44843",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "716",
    "nom_corrige2": "Annie Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "290",
    "allocation2": "0",
    "total": "44842",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "717",
    "nom_corrige2": "Bernard Marion",
    "nom_famille": "Marion",
    "titre_genre2": "Maire",
    "remuneration": "6981",
    "allocation": "3491",
    "remuneration2": "34312",
    "allocation2": "0",
    "total": "44784",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "718",
    "nom_corrige2": "Robert Benoît",
    "nom_famille": "Benoît",
    "titre_genre2": "Maire",
    "remuneration": "22807",
    "allocation": "11402",
    "remuneration2": "10476",
    "allocation2": "0",
    "total": "44685",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "719",
    "nom_corrige2": "Véronique Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "5452",
    "allocation2": "2726",
    "total": "44678",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "720",
    "nom_corrige2": "Jacques Laurendeau",
    "nom_famille": "Laurendeau",
    "titre_genre2": "Conseiller",
    "remuneration": "30547",
    "allocation": "13027",
    "remuneration2": "1091",
    "allocation2": "0",
    "total": "44665",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "721",
    "nom_corrige2": "Marie Ève Plante-Hébert",
    "nom_famille": "Plante-Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "31549",
    "allocation": "13037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44586",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "722",
    "nom_corrige2": "Guylain Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "723",
    "nom_corrige2": "David-Olivier Huard",
    "nom_famille": "Huard",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "724",
    "nom_corrige2": "David Bousquet",
    "nom_famille": "Bousquet",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "725",
    "nom_corrige2": "Donald Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "726",
    "nom_corrige2": "Jeannot Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "727",
    "nom_corrige2": "Claire Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseillère",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "728",
    "nom_corrige2": "André Arpin",
    "nom_famille": "Arpin",
    "titre_genre2": "Conseiller",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "729",
    "nom_corrige2": "Mélanie Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "29701",
    "allocation": "14851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44552",
    "ville": "Saint-Hyacinthe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "58732"
  },
  {
    "ID": "730",
    "nom_corrige2": "Karine Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseillère",
    "remuneration": "31495",
    "allocation": "13037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44532",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "731",
    "nom_corrige2": "Louis Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "5335",
    "allocation2": "2668",
    "total": "44503",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "732",
    "nom_corrige2": "Christian Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Maire",
    "remuneration": "19789",
    "allocation": "9151",
    "remuneration2": "10355",
    "allocation2": "5177",
    "total": "44472",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "733",
    "nom_corrige2": "Mario Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Maire",
    "remuneration": "13531",
    "allocation": "27062",
    "remuneration2": "2584",
    "allocation2": "1292",
    "total": "44469",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "734",
    "nom_corrige2": "Kelly Thorstad-Cullen",
    "nom_famille": "Thorstad-Cullen",
    "titre_genre2": "Conseillère",
    "remuneration": "29629",
    "allocation": "14814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44443",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "735",
    "nom_corrige2": "Gustave Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Maire",
    "remuneration": "26273",
    "allocation": "10424",
    "remuneration2": "6358",
    "allocation2": "1364",
    "total": "44419",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "736",
    "nom_corrige2": "Josée Marc-Aurèle",
    "nom_famille": "Marc-Aurèle",
    "titre_genre2": "Conseillère",
    "remuneration": "29596",
    "allocation": "14798",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44394",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "737",
    "nom_corrige2": "Howard Sauvé",
    "nom_famille": "Sauvé",
    "titre_genre2": "Maire",
    "remuneration": "16690",
    "allocation": "8346",
    "remuneration2": "12900",
    "allocation2": "6450",
    "total": "44386",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "738",
    "nom_corrige2": "Vincent Chatel",
    "nom_famille": "Chatel",
    "titre_genre2": "Conseiller",
    "remuneration": "29581",
    "allocation": "14789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44370",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "739",
    "nom_corrige2": "Isabelle Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseillère",
    "remuneration": "29554",
    "allocation": "14692",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44246",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "740",
    "nom_corrige2": "Lynda Paul",
    "nom_famille": "Paul",
    "titre_genre2": "Conseillère",
    "remuneration": "29554",
    "allocation": "14692",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44246",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "741",
    "nom_corrige2": "Pierre Barrette",
    "nom_famille": "Barrette",
    "titre_genre2": "Conseiller",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "3312",
    "allocation2": "1656",
    "total": "44233",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "742",
    "nom_corrige2": "Robert Portugais",
    "nom_famille": "Portugais",
    "titre_genre2": "Conseiller",
    "remuneration": "29384",
    "allocation": "14691",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44075",
    "ville": "Saint-Lin-Laurentides",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "25452"
  },
  {
    "ID": "743",
    "nom_corrige2": "Jacqueline Boubane",
    "nom_famille": "Boubane",
    "titre_genre2": "Conseillère",
    "remuneration": "38371",
    "allocation": "17546",
    "remuneration2": "390",
    "allocation2": "0",
    "total": "56307",
    "ville": "Boucherville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "42425"
  },
  {
    "ID": "744",
    "nom_corrige2": "Patrick Archambault",
    "nom_famille": "Archambault",
    "titre_genre2": "Conseiller",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "3148",
    "allocation2": "1574",
    "total": "43987",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "745",
    "nom_corrige2": "Pierre Moras",
    "nom_famille": "Moras",
    "titre_genre2": "Conseiller",
    "remuneration": "26788",
    "allocation": "13394",
    "remuneration2": "2680",
    "allocation2": "1124",
    "total": "43986",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "746",
    "nom_corrige2": "André Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Maire",
    "remuneration": "17408",
    "allocation": "8704",
    "remuneration2": "11832",
    "allocation2": "5916",
    "total": "43860",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "747",
    "nom_corrige2": "Jean-François Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseiller",
    "remuneration": "27638",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41457",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "748",
    "nom_corrige2": "René Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseiller",
    "remuneration": "29156",
    "allocation": "14578",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43734",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "749",
    "nom_corrige2": "Gilles Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseiller",
    "remuneration": "28997",
    "allocation": "14498",
    "remuneration2": "111",
    "allocation2": "56",
    "total": "43662",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "750",
    "nom_corrige2": "Eric Stork",
    "nom_famille": "Stork",
    "titre_genre2": "Conseiller",
    "remuneration": "29041",
    "allocation": "14520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43561",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "751",
    "nom_corrige2": "Bruno Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "29041",
    "allocation": "14520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43561",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "752",
    "nom_corrige2": "Jean-Guy Hamelin",
    "nom_famille": "Hamelin",
    "titre_genre2": "Maire",
    "remuneration": "23100",
    "allocation": "11550",
    "remuneration2": "5922",
    "allocation2": "2966",
    "total": "43538",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "753",
    "nom_corrige2": "Robert Pufahl",
    "nom_famille": "Pufahl",
    "titre_genre2": "Maire",
    "remuneration": "22252",
    "allocation": "11127",
    "remuneration2": "6699",
    "allocation2": "3350",
    "total": "43428",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "754",
    "nom_corrige2": "Paul Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseiller",
    "remuneration": "29041",
    "allocation": "14520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43561",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "755",
    "nom_corrige2": "Chantal Renaud",
    "nom_famille": "Renaud",
    "titre_genre2": "Conseillère",
    "remuneration": "34489",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43284",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "756",
    "nom_corrige2": "Normand Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "11734",
    "allocation": "5867",
    "remuneration2": "21186",
    "allocation2": "4454",
    "total": "43241",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "757",
    "nom_corrige2": "Samuelle Ramsay-Houle",
    "nom_famille": "Ramsay-Houle",
    "titre_genre2": "Conseillère",
    "remuneration": "28734",
    "allocation": "14367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43101",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "758",
    "nom_corrige2": "Bertrand Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Maire",
    "remuneration": "18973",
    "allocation": "9486",
    "remuneration2": "9751",
    "allocation2": "4876",
    "total": "43086",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "759",
    "nom_corrige2": "Jean Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "30898",
    "allocation": "11087",
    "remuneration2": "875",
    "allocation2": "0",
    "total": "42860",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "760",
    "nom_corrige2": "Anne Scott",
    "nom_famille": "Scott",
    "titre_genre2": "Conseillère",
    "remuneration": "28533",
    "allocation": "14263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42796",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "761",
    "nom_corrige2": "Joël Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "448",
    "allocation2": "224",
    "total": "42672",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "762",
    "nom_corrige2": "PATRICK RANCOURT",
    "nom_famille": "RANCOURT",
    "titre_genre2": "Conseiller",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "763",
    "nom_corrige2": "JEAN-MARC ROCHON",
    "nom_famille": "ROCHON",
    "titre_genre2": "Conseiller",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "764",
    "nom_corrige2": "NORMAND AMESSE",
    "nom_famille": "AMESSE",
    "titre_genre2": "Conseiller",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "765",
    "nom_corrige2": "LYNE LEFEBVRE",
    "nom_famille": "LEFEBVRE",
    "titre_genre2": "Conseillère",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "766",
    "nom_corrige2": "FRANCE CHENAIL",
    "nom_famille": "CHENAIL",
    "titre_genre2": "Conseillère",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "767",
    "nom_corrige2": "STÉPHANE LEDUC",
    "nom_famille": "LEDUC",
    "titre_genre2": "Conseiller",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "768",
    "nom_corrige2": "SOPHIE SIROIS-PERRAS",
    "nom_famille": "SIROIS-PERRAS",
    "titre_genre2": "Conseillère",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "769",
    "nom_corrige2": "JEAN-FRANÇOIS GIROUX",
    "nom_famille": "GIROUX",
    "titre_genre2": "Conseiller",
    "remuneration": "28441",
    "allocation": "14220",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42661",
    "ville": "Salaberry-de-Valleyfield",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "44838"
  },
  {
    "ID": "770",
    "nom_corrige2": "André Camirand",
    "nom_famille": "Camirand",
    "titre_genre2": "Conseiller",
    "remuneration": "28079",
    "allocation": "14040",
    "remuneration2": "333",
    "allocation2": "167",
    "total": "42619",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "771",
    "nom_corrige2": "Daniel Pilon",
    "nom_famille": "Pilon",
    "titre_genre2": "Conseiller",
    "remuneration": "31117",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42613",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "772",
    "nom_corrige2": "Maryon Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Maire",
    "remuneration": "22560",
    "allocation": "11280",
    "remuneration2": "5909",
    "allocation2": "2820",
    "total": "42569",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "773",
    "nom_corrige2": "Stéphanie Nantel",
    "nom_famille": "Nantel",
    "titre_genre2": "Conseillère",
    "remuneration": "28341",
    "allocation": "14171",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42512",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "774",
    "nom_corrige2": "Louis Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "4290",
    "allocation2": "2145",
    "total": "42509",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "775",
    "nom_corrige2": "François Le Borgne",
    "nom_famille": "Le",
    "titre_genre2": "Conseiller",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "262",
    "allocation2": "0",
    "total": "42446",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "776",
    "nom_corrige2": "MARIO LANGEVIN",
    "nom_famille": "LANGEVIN",
    "titre_genre2": "Maire",
    "remuneration": "18371",
    "allocation": "9186",
    "remuneration2": "9878",
    "allocation2": "4939",
    "total": "42374",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "777",
    "nom_corrige2": "Michel Bourdeau",
    "nom_famille": "Bourdeau",
    "titre_genre2": "Maire",
    "remuneration": "21444",
    "allocation": "10723",
    "remuneration2": "7137",
    "allocation2": "3066",
    "total": "42370",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "778",
    "nom_corrige2": "Christian Huard",
    "nom_famille": "Huard",
    "titre_genre2": "Conseiller",
    "remuneration": "28243",
    "allocation": "14121",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42364",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "779",
    "nom_corrige2": "Eric Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "28243",
    "allocation": "14121",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42364",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "780",
    "nom_corrige2": "Lucie Bisson",
    "nom_famille": "Bisson",
    "titre_genre2": "Conseillère",
    "remuneration": "28243",
    "allocation": "14121",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42364",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "781",
    "nom_corrige2": "Sylvie Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "42359",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "782",
    "nom_corrige2": "Natalie Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseillère",
    "remuneration": "26393",
    "allocation": "12097",
    "remuneration2": "2555",
    "allocation2": "1278",
    "total": "42323",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "783",
    "nom_corrige2": "Gaëtan Castilloux",
    "nom_famille": "Castilloux",
    "titre_genre2": "Maire",
    "remuneration": "22358",
    "allocation": "11179",
    "remuneration2": "5821",
    "allocation2": "2911",
    "total": "42269",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "784",
    "nom_corrige2": "Susan Rasmussen",
    "nom_famille": "Rasmussen",
    "titre_genre2": "Conseillère",
    "remuneration": "28146",
    "allocation": "14075",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42221",
    "ville": "Longueuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "253629"
  },
  {
    "ID": "785",
    "nom_corrige2": "Arlene Bryant",
    "nom_famille": "Bryant",
    "titre_genre2": "Conseillère",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "786",
    "nom_corrige2": "Éric Corbeil",
    "nom_famille": "Corbeil",
    "titre_genre2": "Conseiller",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "787",
    "nom_corrige2": "Luc Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "788",
    "nom_corrige2": "Barry Doyle",
    "nom_famille": "Doyle",
    "titre_genre2": "Conseiller",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "789",
    "nom_corrige2": "Marie-Louise Kerneis",
    "nom_famille": "Kerneis",
    "titre_genre2": "Conseillère",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "790",
    "nom_corrige2": "Lucie Laberge",
    "nom_famille": "Laberge",
    "titre_genre2": "Conseillère",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "791",
    "nom_corrige2": "Mike Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "28123",
    "allocation": "14061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42184",
    "ville": "Châteauguay",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "51614"
  },
  {
    "ID": "792",
    "nom_corrige2": "Sylvie Mallette",
    "nom_famille": "Mallette",
    "titre_genre2": "Conseillère",
    "remuneration": "29414",
    "allocation": "12729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42143",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "793",
    "nom_corrige2": "Chantale Boudrias",
    "nom_famille": "Boudrias",
    "titre_genre2": "Conseillère",
    "remuneration": "27925",
    "allocation": "13962",
    "remuneration2": "111",
    "allocation2": "56",
    "total": "42054",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "794",
    "nom_corrige2": "Julie Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Mairesse",
    "remuneration": "16521",
    "allocation": "8261",
    "remuneration2": "11866",
    "allocation2": "5359",
    "total": "42007",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "795",
    "nom_corrige2": "Tyler Cook",
    "nom_famille": "Cook",
    "titre_genre2": "Conseiller",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42000",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "796",
    "nom_corrige2": "Billie-Jeanne Graton",
    "nom_famille": "Graton",
    "titre_genre2": "Conseillère",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42000",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "797",
    "nom_corrige2": "Catherine Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42000",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "798",
    "nom_corrige2": "Guylaine Lyras",
    "nom_famille": "Lyras",
    "titre_genre2": "Conseillère",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42000",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "799",
    "nom_corrige2": "Roxanne Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseillère",
    "remuneration": "28000",
    "allocation": "14000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42000",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "800",
    "nom_corrige2": "Caroline Decaluwe",
    "nom_famille": "Decaluwe",
    "titre_genre2": "Conseillère",
    "remuneration": "30492",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41988",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "801",
    "nom_corrige2": "Luc Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Conseiller",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "245",
    "allocation2": "123",
    "total": "41975",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "802",
    "nom_corrige2": "Gino Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Maire",
    "remuneration": "27884",
    "allocation": "13941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41825",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "803",
    "nom_corrige2": "Brent Cowan",
    "nom_famille": "Cowan",
    "titre_genre2": "Conseiller",
    "remuneration": "27865",
    "allocation": "13932",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41797",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "804",
    "nom_corrige2": "Tara Stainforth",
    "nom_famille": "Stainforth",
    "titre_genre2": "Conseillère",
    "remuneration": "27865",
    "allocation": "13932",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41797",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "805",
    "nom_corrige2": "Erin Tedford",
    "nom_famille": "Tedford",
    "titre_genre2": "Conseillère",
    "remuneration": "27865",
    "allocation": "13932",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41797",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "806",
    "nom_corrige2": "Solange Morneau",
    "nom_famille": "Morneau",
    "titre_genre2": "Mairesse",
    "remuneration": "24250",
    "allocation": "12125",
    "remuneration2": "3644",
    "allocation2": "1721",
    "total": "41740",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "807",
    "nom_corrige2": "Marc Doret",
    "nom_famille": "Doret",
    "titre_genre2": "Maire",
    "remuneration": "111806",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "129352",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "808",
    "nom_corrige2": "Daniel Goyer",
    "nom_famille": "Goyer",
    "titre_genre2": "Conseiller",
    "remuneration": "29107",
    "allocation": "12595",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41702",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "809",
    "nom_corrige2": "Marc-André Savaria",
    "nom_famille": "Savaria",
    "titre_genre2": "Conseiller",
    "remuneration": "26393",
    "allocation": "12097",
    "remuneration2": "2152",
    "allocation2": "978",
    "total": "41620",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "810",
    "nom_corrige2": "Yves Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Maire",
    "remuneration": "29728",
    "allocation": "11891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41619",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "811",
    "nom_corrige2": "Justin Carey",
    "nom_famille": "Carey",
    "titre_genre2": "Conseiller",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41607",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "812",
    "nom_corrige2": "Jean-François Molnar",
    "nom_famille": "Molnar",
    "titre_genre2": "Conseiller",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41607",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "813",
    "nom_corrige2": "Serge Savoie",
    "nom_famille": "Savoie",
    "titre_genre2": "Conseiller",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41607",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "814",
    "nom_corrige2": "Jean-Philippe Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41607",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "815",
    "nom_corrige2": "Annie Legendre",
    "nom_famille": "Legendre",
    "titre_genre2": "Conseillère",
    "remuneration": "27738",
    "allocation": "13869",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41607",
    "ville": "Chambly",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31462"
  },
  {
    "ID": "816",
    "nom_corrige2": "Rodrigue Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseiller",
    "remuneration": "29105",
    "allocation": "12280",
    "remuneration2": "132",
    "allocation2": "66",
    "total": "41583",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "817",
    "nom_corrige2": "Nicole Duchastel",
    "nom_famille": "Duchastel",
    "titre_genre2": "Conseillère",
    "remuneration": "27638",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41457",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "818",
    "nom_corrige2": "Pascal Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Conseiller",
    "remuneration": "27638",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41457",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "819",
    "nom_corrige2": "Paul Trudeau",
    "nom_famille": "Trudeau",
    "titre_genre2": "Conseiller",
    "remuneration": "27914",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41733",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "820",
    "nom_corrige2": "Mario Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseiller",
    "remuneration": "27635",
    "allocation": "13818",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41453",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "821",
    "nom_corrige2": "Timothy Watchorn",
    "nom_famille": "Watchorn",
    "titre_genre2": "Maire",
    "remuneration": "27630",
    "allocation": "13815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41445",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "822",
    "nom_corrige2": "Jean-Paul Descoeurs",
    "nom_famille": "Descoeurs",
    "titre_genre2": "Maire",
    "remuneration": "22074",
    "allocation": "11037",
    "remuneration2": "5495",
    "allocation2": "2747",
    "total": "41353",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "823",
    "nom_corrige2": "Denis Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Maire",
    "remuneration": "10688",
    "allocation": "5344",
    "remuneration2": "16867",
    "allocation2": "8434",
    "total": "41333",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "824",
    "nom_corrige2": "Chantal Goyette",
    "nom_famille": "Goyette",
    "titre_genre2": "Conseillère",
    "remuneration": "27485",
    "allocation": "13737",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41222",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "825",
    "nom_corrige2": "Marie-Josée Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseillère",
    "remuneration": "27485",
    "allocation": "13737",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41222",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "826",
    "nom_corrige2": "Mélanie Roldan",
    "nom_famille": "Roldan",
    "titre_genre2": "Conseillère",
    "remuneration": "27485",
    "allocation": "13737",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41222",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "827",
    "nom_corrige2": "Jean-Michel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "27485",
    "allocation": "13737",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41222",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "828",
    "nom_corrige2": "Kevin Vocino",
    "nom_famille": "Vocino",
    "titre_genre2": "Conseiller",
    "remuneration": "27485",
    "allocation": "13737",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41222",
    "ville": "Candiac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "23685"
  },
  {
    "ID": "829",
    "nom_corrige2": "Line Fréchette",
    "nom_famille": "Fréchette",
    "titre_genre2": "Mairesse",
    "remuneration": "13078",
    "allocation": "6539",
    "remuneration2": "14316",
    "allocation2": "7158",
    "total": "41091",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "830",
    "nom_corrige2": "David Lemelin",
    "nom_famille": "Lemelin",
    "titre_genre2": "Conseiller",
    "remuneration": "27352",
    "allocation": "13676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "41028",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "831",
    "nom_corrige2": "François Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Maire",
    "remuneration": "18264",
    "allocation": "9133",
    "remuneration2": "9014",
    "allocation2": "4508",
    "total": "40919",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "832",
    "nom_corrige2": "Sébastien Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseiller",
    "remuneration": "28480",
    "allocation": "12017",
    "remuneration2": "265",
    "allocation2": "132",
    "total": "40894",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "833",
    "nom_corrige2": "Johanne Di Cesare",
    "nom_famille": "Di",
    "titre_genre2": "Conseillère",
    "remuneration": "27253",
    "allocation": "13626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40879",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "834",
    "nom_corrige2": "Patrice Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "835",
    "nom_corrige2": "Marc Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseiller",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "836",
    "nom_corrige2": "Isabelle Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "837",
    "nom_corrige2": "Raymond Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseiller",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "838",
    "nom_corrige2": "Yves Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "839",
    "nom_corrige2": "Isabelle Mattioli",
    "nom_famille": "Mattioli",
    "titre_genre2": "Conseillère",
    "remuneration": "28527",
    "allocation": "12312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40839",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "840",
    "nom_corrige2": "Vicki Emard",
    "nom_famille": "Emard",
    "titre_genre2": "Mairesse",
    "remuneration": "27222",
    "allocation": "13611",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40833",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "841",
    "nom_corrige2": "Pierre Thauvette",
    "nom_famille": "Thauvette",
    "titre_genre2": "Maire",
    "remuneration": "18366",
    "allocation": "9218",
    "remuneration2": "8820",
    "allocation2": "4410",
    "total": "40814",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "842",
    "nom_corrige2": "Guy Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Maire",
    "remuneration": "27198",
    "allocation": "13599",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40797",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "843",
    "nom_corrige2": "Stéphane Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Maire",
    "remuneration": "23679",
    "allocation": "11675",
    "remuneration2": "3567",
    "allocation2": "1784",
    "total": "40705",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "844",
    "nom_corrige2": "Eugène Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Maire",
    "remuneration": "21226",
    "allocation": "10613",
    "remuneration2": "5862",
    "allocation2": "2931",
    "total": "40632",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "845",
    "nom_corrige2": "Cynthia Homan",
    "nom_famille": "Homan",
    "titre_genre2": "Conseillère",
    "remuneration": "29629",
    "allocation": "14814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "44443",
    "ville": "Pointe-Claire",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "34548"
  },
  {
    "ID": "846",
    "nom_corrige2": "Ghislain Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Maire",
    "remuneration": "25282",
    "allocation": "12641",
    "remuneration2": "1715",
    "allocation2": "858",
    "total": "40496",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "847",
    "nom_corrige2": "Bertrand Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "26547",
    "allocation": "13027",
    "remuneration2": "909",
    "allocation2": "0",
    "total": "40483",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "848",
    "nom_corrige2": "Sylvain Casavant",
    "nom_famille": "Casavant",
    "titre_genre2": "Maire",
    "remuneration": "20297",
    "allocation": "9900",
    "remuneration2": "6856",
    "allocation2": "3429",
    "total": "40482",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "849",
    "nom_corrige2": "Sylvain Cazes",
    "nom_famille": "Cazes",
    "titre_genre2": "Conseiller",
    "remuneration": "27032",
    "allocation": "13434",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40466",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "850",
    "nom_corrige2": "Natalia Zuluaga Puyana",
    "nom_famille": "Zuluaga",
    "titre_genre2": "Conseillère",
    "remuneration": "26934",
    "allocation": "13467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "40401",
    "ville": "Saint-Constant",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31000"
  },
  {
    "ID": "851",
    "nom_corrige2": "KIMBERLY MEYER",
    "nom_famille": "MEYER",
    "titre_genre2": "Mairesse",
    "remuneration": "22960",
    "allocation": "11480",
    "remuneration2": "3907",
    "allocation2": "1954",
    "total": "40301",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "852",
    "nom_corrige2": "Lyne Rémillard",
    "nom_famille": "Rémillard",
    "titre_genre2": "Conseillère",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "599",
    "allocation2": "300",
    "total": "40164",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "853",
    "nom_corrige2": "Francis Le Chatelier",
    "nom_famille": "Le",
    "titre_genre2": "Conseiller",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "15850",
    "allocation2": "0",
    "total": "40154",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "854",
    "nom_corrige2": "Luc Cauchon",
    "nom_famille": "Cauchon",
    "titre_genre2": "Maire",
    "remuneration": "17426",
    "allocation": "8713",
    "remuneration2": "9239",
    "allocation2": "4620",
    "total": "39998",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "855",
    "nom_corrige2": "Ginette Gauvin",
    "nom_famille": "Gauvin",
    "titre_genre2": "Mairesse",
    "remuneration": "21175",
    "allocation": "10587",
    "remuneration2": "5470",
    "allocation2": "2735",
    "total": "39967",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "856",
    "nom_corrige2": "Benoît Guèvremont",
    "nom_famille": "Guèvremont",
    "titre_genre2": "Conseiller",
    "remuneration": "25819",
    "allocation": "12672",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38491",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "857",
    "nom_corrige2": "Guy Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Maire",
    "remuneration": "20210",
    "allocation": "10641",
    "remuneration2": "6047",
    "allocation2": "2925",
    "total": "39823",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "858",
    "nom_corrige2": "Sylvie Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseillère",
    "remuneration": "25344",
    "allocation": "12672",
    "remuneration2": "423",
    "allocation2": "211",
    "total": "38650",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "859",
    "nom_corrige2": "Luc Drapeau",
    "nom_famille": "Drapeau",
    "titre_genre2": "Conseiller",
    "remuneration": "28377",
    "allocation": "14189",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "42566",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "860",
    "nom_corrige2": "Patrick Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "26544",
    "allocation": "13037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39581",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "861",
    "nom_corrige2": "Paule Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "26537",
    "allocation": "13037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39574",
    "ville": "La Prairie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "26460"
  },
  {
    "ID": "862",
    "nom_corrige2": "Yves Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Maire",
    "remuneration": "26364",
    "allocation": "13192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39556",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "863",
    "nom_corrige2": "Gaétan Marcil",
    "nom_famille": "Marcil",
    "titre_genre2": "Conseiller",
    "remuneration": "24193",
    "allocation": "12097",
    "remuneration2": "2152",
    "allocation2": "1076",
    "total": "39518",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "864",
    "nom_corrige2": "Vincent Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Conseiller",
    "remuneration": "31921",
    "allocation": "15271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "47192",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "865",
    "nom_corrige2": "Jody Stone",
    "nom_famille": "Stone",
    "titre_genre2": "Maire",
    "remuneration": "18251",
    "allocation": "9125",
    "remuneration2": "8033",
    "allocation2": "3894",
    "total": "39303",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "866",
    "nom_corrige2": "Martin Lajeunesse",
    "nom_famille": "Lajeunesse",
    "titre_genre2": "Conseiller",
    "remuneration": "55635",
    "allocation": "17546",
    "remuneration2": "3770",
    "allocation2": "0",
    "total": "76951",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "867",
    "nom_corrige2": "Martine Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Conseillère",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39265",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "868",
    "nom_corrige2": "Jocelyn Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39265",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "869",
    "nom_corrige2": "Diane D. Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "26177",
    "allocation": "13088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39265",
    "ville": "Lorraine",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "9715"
  },
  {
    "ID": "870",
    "nom_corrige2": "Francis Corbeil",
    "nom_famille": "Corbeil",
    "titre_genre2": "Maire",
    "remuneration": "20000",
    "allocation": "10000",
    "remuneration2": "6167",
    "allocation2": "3083",
    "total": "39250",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "871",
    "nom_corrige2": "Marc Tassé",
    "nom_famille": "Tassé",
    "titre_genre2": "Conseiller",
    "remuneration": "26772",
    "allocation": "12398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39170",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "872",
    "nom_corrige2": "Josée Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseillère",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "873",
    "nom_corrige2": "Nathalie Laporte",
    "nom_famille": "Laporte",
    "titre_genre2": "Conseillère",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "874",
    "nom_corrige2": "Samuel Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "875",
    "nom_corrige2": "Sébastien Bélair",
    "nom_famille": "Bélair",
    "titre_genre2": "Conseiller",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "876",
    "nom_corrige2": "Jean-Noël Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "877",
    "nom_corrige2": "Jean-François Rompré",
    "nom_famille": "Rompré",
    "titre_genre2": "Conseiller",
    "remuneration": "26054",
    "allocation": "13027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39081",
    "ville": "Magog",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "28300"
  },
  {
    "ID": "878",
    "nom_corrige2": "Charlotte Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "3823",
    "allocation2": "1911",
    "total": "39013",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "879",
    "nom_corrige2": "Hugo Berthelet",
    "nom_famille": "Berthelet",
    "titre_genre2": "Conseiller",
    "remuneration": "26601",
    "allocation": "12384",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38985",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "880",
    "nom_corrige2": "Jean-Guy Galipeau",
    "nom_famille": "Galipeau",
    "titre_genre2": "Maire",
    "remuneration": "22747",
    "allocation": "10732",
    "remuneration2": "3588",
    "allocation2": "1794",
    "total": "38861",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "881",
    "nom_corrige2": "Martin Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseiller",
    "remuneration": "31002",
    "allocation": "15271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "46273",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "882",
    "nom_corrige2": "Geneviève  Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseillère",
    "remuneration": "25793",
    "allocation": "12097",
    "remuneration2": "591",
    "allocation2": "295",
    "total": "38776",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "883",
    "nom_corrige2": "Stéphane Biron",
    "nom_famille": "Biron",
    "titre_genre2": "Conseiller",
    "remuneration": "21957",
    "allocation": "8782",
    "remuneration2": "7050",
    "allocation2": "917",
    "total": "38706",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "884",
    "nom_corrige2": "Richard Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Maire",
    "remuneration": "19404",
    "allocation": "9462",
    "remuneration2": "6527",
    "allocation2": "3264",
    "total": "38657",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "885",
    "nom_corrige2": "Réjean Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "27166",
    "allocation": "11462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38628",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "886",
    "nom_corrige2": "François Sylvestre",
    "nom_famille": "Sylvestre",
    "titre_genre2": "Conseiller",
    "remuneration": "29807",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38602",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "887",
    "nom_corrige2": "Ronald Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "33295",
    "allocation": "12606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45901",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "888",
    "nom_corrige2": "Louise Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseillère",
    "remuneration": "31264",
    "allocation": "15599",
    "remuneration2": "15742",
    "allocation2": "1947",
    "total": "64552",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "889",
    "nom_corrige2": "Jocelyn Mondou",
    "nom_famille": "Mondou",
    "titre_genre2": "Conseiller",
    "remuneration": "25344",
    "allocation": "12672",
    "remuneration2": "847",
    "allocation2": "423",
    "total": "39286",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "890",
    "nom_corrige2": "Isabelle Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "891",
    "nom_corrige2": "Martin Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "892",
    "nom_corrige2": "Annick Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseillère",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "893",
    "nom_corrige2": "Sylvain Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "894",
    "nom_corrige2": "Marie Levert",
    "nom_famille": "Levert",
    "titre_genre2": "Conseillère",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "895",
    "nom_corrige2": "Michel LeBlanc",
    "nom_famille": "LeBlanc",
    "titre_genre2": "Conseiller",
    "remuneration": "38315",
    "allocation": "0",
    "remuneration2": "167",
    "allocation2": "0",
    "total": "38482",
    "ville": "Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17374"
  },
  {
    "ID": "896",
    "nom_corrige2": "Marie-Elaine Pitre",
    "nom_famille": "Pitre",
    "titre_genre2": "Conseillère",
    "remuneration": "25553",
    "allocation": "12776",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38329",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "897",
    "nom_corrige2": "Luc Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Maire",
    "remuneration": "17210",
    "allocation": "8605",
    "remuneration2": "8282",
    "allocation2": "4141",
    "total": "38238",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "898",
    "nom_corrige2": "Gabriel Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Maire",
    "remuneration": "20849",
    "allocation": "10424",
    "remuneration2": "4602",
    "allocation2": "2301",
    "total": "38176",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "899",
    "nom_corrige2": "Claire Mailhot",
    "nom_famille": "Mailhot",
    "titre_genre2": "Conseillère",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "227",
    "allocation2": "114",
    "total": "38096",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "900",
    "nom_corrige2": "Jacques Lapensée",
    "nom_famille": "Lapensée",
    "titre_genre2": "Conseiller",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "227",
    "allocation2": "114",
    "total": "38096",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "901",
    "nom_corrige2": "Lisyane Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "25391",
    "allocation": "12696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38087",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "902",
    "nom_corrige2": "Mélanie Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "903",
    "nom_corrige2": "Mélanie Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "904",
    "nom_corrige2": "Julie Carré",
    "nom_famille": "Carré",
    "titre_genre2": "Conseillère",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "905",
    "nom_corrige2": "Dave Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Conseiller",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "906",
    "nom_corrige2": "Jocelyn Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "907",
    "nom_corrige2": "Grégory Thorez",
    "nom_famille": "Thorez",
    "titre_genre2": "Conseiller",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "908",
    "nom_corrige2": "Philippe Cousineau Morin",
    "nom_famille": "Cousineau",
    "titre_genre2": "Conseiller",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "909",
    "nom_corrige2": "Cécilia Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "26744",
    "allocation": "11284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38028",
    "ville": "Rimouski",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "50036"
  },
  {
    "ID": "910",
    "nom_corrige2": "Dominique Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "27144",
    "allocation": "12672",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "39816",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "911",
    "nom_corrige2": "Carla Brown",
    "nom_famille": "Brown",
    "titre_genre2": "Conseillère",
    "remuneration": "25338",
    "allocation": "12669",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38007",
    "ville": "Rosemère",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14535"
  },
  {
    "ID": "912",
    "nom_corrige2": "Michel Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "25751",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37809",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "913",
    "nom_corrige2": "Valérie Assouline",
    "nom_famille": "Assouline",
    "titre_genre2": "Conseillère",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "539",
    "allocation2": "228",
    "total": "37783",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "914",
    "nom_corrige2": "Alexandre Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Maire",
    "remuneration": "25178",
    "allocation": "12589",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37767",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "915",
    "nom_corrige2": "Tatiana Contreras",
    "nom_famille": "Contreras",
    "titre_genre2": "Conseillère",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37755",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "916",
    "nom_corrige2": "Michel Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37755",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "917",
    "nom_corrige2": "Nicolas Robillard",
    "nom_famille": "Robillard",
    "titre_genre2": "Conseiller",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37755",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "918",
    "nom_corrige2": "Jocelyne Corbeil",
    "nom_famille": "Corbeil",
    "titre_genre2": "Conseillère",
    "remuneration": "25170",
    "allocation": "12585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37755",
    "ville": "Bromont",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "11757"
  },
  {
    "ID": "919",
    "nom_corrige2": "Daniel Tétreault",
    "nom_famille": "Tétreault",
    "titre_genre2": "Maire",
    "remuneration": "8187",
    "allocation": "4093",
    "remuneration2": "16864",
    "allocation2": "8566",
    "total": "37710",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "920",
    "nom_corrige2": "Martin Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Maire",
    "remuneration": "25049",
    "allocation": "12525",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37574",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "921",
    "nom_corrige2": "Ian Lacharité",
    "nom_famille": "Lacharité",
    "titre_genre2": "Maire",
    "remuneration": "20760",
    "allocation": "9909",
    "remuneration2": "4560",
    "allocation2": "2280",
    "total": "37509",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "922",
    "nom_corrige2": "Yan Major",
    "nom_famille": "Major",
    "titre_genre2": "Conseiller",
    "remuneration": "25428",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37486",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "923",
    "nom_corrige2": "Gino Moretti",
    "nom_famille": "Moretti",
    "titre_genre2": "Maire",
    "remuneration": "16560",
    "allocation": "8280",
    "remuneration2": "8420",
    "allocation2": "4210",
    "total": "37470",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "924",
    "nom_corrige2": "Marie-Hélène Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Mairesse",
    "remuneration": "18840",
    "allocation": "9420",
    "remuneration2": "6123",
    "allocation2": "3061",
    "total": "37444",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "925",
    "nom_corrige2": "Alain Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Maire",
    "remuneration": "17737",
    "allocation": "8869",
    "remuneration2": "7240",
    "allocation2": "3486",
    "total": "37332",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "926",
    "nom_corrige2": "Germain Grenon",
    "nom_famille": "Grenon",
    "titre_genre2": "Maire",
    "remuneration": "24868",
    "allocation": "12434",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37302",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "927",
    "nom_corrige2": "Roger Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Maire",
    "remuneration": "13744",
    "allocation": "6872",
    "remuneration2": "10879",
    "allocation2": "5787",
    "total": "37282",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "928",
    "nom_corrige2": "MAJELLA PICHETTE",
    "nom_famille": "PICHETTE",
    "titre_genre2": "Maire",
    "remuneration": "16106",
    "allocation": "1303",
    "remuneration2": "13206",
    "allocation2": "6603",
    "total": "37218",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "929",
    "nom_corrige2": "Jack Edery",
    "nom_famille": "Edery",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "930",
    "nom_corrige2": "Leon Elfassy",
    "nom_famille": "Elfassy",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "931",
    "nom_corrige2": "Michael Goldwax",
    "nom_famille": "Goldwax",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "932",
    "nom_corrige2": "Harvey Shaffer",
    "nom_famille": "Shaffer",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "933",
    "nom_corrige2": "Jason Farber",
    "nom_famille": "Farber",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "934",
    "nom_corrige2": "Warren Budning",
    "nom_famille": "Budning",
    "titre_genre2": "Conseiller",
    "remuneration": "25801",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37218",
    "ville": "Hampstead",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "7372"
  },
  {
    "ID": "935",
    "nom_corrige2": "Chantal Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "24897",
    "allocation": "12237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37134",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "936",
    "nom_corrige2": "Dave Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Maire",
    "remuneration": "19722",
    "allocation": "9862",
    "remuneration2": "4972",
    "allocation2": "2486",
    "total": "37042",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "937",
    "nom_corrige2": "Gaétan Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "34571",
    "allocation": "10490",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "45061",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "938",
    "nom_corrige2": "Errol Johnson",
    "nom_famille": "Johnson",
    "titre_genre2": "Conseiller",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37016",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "939",
    "nom_corrige2": "Tanya Toledano",
    "nom_famille": "Toledano",
    "titre_genre2": "Conseillère",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37016",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "940",
    "nom_corrige2": "Morris Vesely",
    "nom_famille": "Vesely",
    "titre_genre2": "Conseiller",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37016",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "941",
    "nom_corrige2": "Ryan Brownstein",
    "nom_famille": "Brownstein",
    "titre_genre2": "Conseiller",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37016",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "942",
    "nom_corrige2": "Anastasia Assimakopoulos",
    "nom_famille": "Assimakopoulos",
    "titre_genre2": "Conseillère",
    "remuneration": "24678",
    "allocation": "12338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37016",
    "ville": "Dollard-des-Ormeaux",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "49908"
  },
  {
    "ID": "943",
    "nom_corrige2": "Michel Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "28434",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "37000",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "944",
    "nom_corrige2": "Claude Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Maire",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "16320",
    "allocation2": "2673",
    "total": "36993",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "945",
    "nom_corrige2": "Yves Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "233",
    "allocation2": "116",
    "total": "36849",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "946",
    "nom_corrige2": "Julie Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Mairesse",
    "remuneration": "15484",
    "allocation": "7742",
    "remuneration2": "9080",
    "allocation2": "4539",
    "total": "36845",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "947",
    "nom_corrige2": "Pierre Tétrault",
    "nom_famille": "Tétrault",
    "titre_genre2": "Maire",
    "remuneration": "20640",
    "allocation": "10320",
    "remuneration2": "3904",
    "allocation2": "1952",
    "total": "36816",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "948",
    "nom_corrige2": "Alex Brisebois-Proulx",
    "nom_famille": "Brisebois-Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "949",
    "nom_corrige2": "Marc-André Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "950",
    "nom_corrige2": "Priscilla Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseillère",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "951",
    "nom_corrige2": "Francis Limoges",
    "nom_famille": "Limoges",
    "titre_genre2": "Conseiller",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "952",
    "nom_corrige2": "Julie Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "953",
    "nom_corrige2": "Line Surprenant",
    "nom_famille": "Surprenant",
    "titre_genre2": "Conseillère",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "954",
    "nom_corrige2": "Claire Wallot",
    "nom_famille": "Wallot",
    "titre_genre2": "Conseillère",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "955",
    "nom_corrige2": "Loïc B. Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseiller",
    "remuneration": "24430",
    "allocation": "12215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36645",
    "ville": "Sainte-Marthe-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "20922"
  },
  {
    "ID": "956",
    "nom_corrige2": "Nathalie Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseillère",
    "remuneration": "24385",
    "allocation": "12193",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36578",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "957",
    "nom_corrige2": "Sylvain Marinier",
    "nom_famille": "Marinier",
    "titre_genre2": "Conseiller",
    "remuneration": "24385",
    "allocation": "12193",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36578",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "958",
    "nom_corrige2": "Brigitte Voss",
    "nom_famille": "Voss",
    "titre_genre2": "Conseillère",
    "remuneration": "24385",
    "allocation": "12193",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36578",
    "ville": "Sainte-Agathe-des-Monts",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11537"
  },
  {
    "ID": "959",
    "nom_corrige2": "François Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseiller",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36500",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "960",
    "nom_corrige2": "Bianka Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseillère",
    "remuneration": "25612",
    "allocation": "10888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36500",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "961",
    "nom_corrige2": "Pierre Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Maire",
    "remuneration": "16648",
    "allocation": "8324",
    "remuneration2": "7664",
    "allocation2": "3832",
    "total": "36468",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "962",
    "nom_corrige2": "Lina Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Mairesse",
    "remuneration": "24311",
    "allocation": "12155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36466",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "963",
    "nom_corrige2": "Guillaume Carignan",
    "nom_famille": "Carignan",
    "titre_genre2": "Conseiller",
    "remuneration": "22210",
    "allocation": "11105",
    "remuneration2": "2005",
    "allocation2": "1003",
    "total": "36323",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "964",
    "nom_corrige2": "Chantal Routhier",
    "nom_famille": "Routhier",
    "titre_genre2": "Conseillère",
    "remuneration": "53126",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "70672",
    "ville": "Repentigny",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "88088"
  },
  {
    "ID": "965",
    "nom_corrige2": "Benoit Duval",
    "nom_famille": "Duval",
    "titre_genre2": "Conseiller",
    "remuneration": "24193",
    "allocation": "12097",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36290",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "966",
    "nom_corrige2": "Carine Durocher",
    "nom_famille": "Durocher",
    "titre_genre2": "Conseillère",
    "remuneration": "24193",
    "allocation": "12097",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36290",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "967",
    "nom_corrige2": "Guillaume Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "24193",
    "allocation": "12097",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36290",
    "ville": "Varennes",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "21584"
  },
  {
    "ID": "968",
    "nom_corrige2": "Lyne Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "24173",
    "allocation": "12087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36260",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "969",
    "nom_corrige2": "Marianne Dessureault",
    "nom_famille": "Dessureault",
    "titre_genre2": "Conseillère",
    "remuneration": "24173",
    "allocation": "12087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36260",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "970",
    "nom_corrige2": "Marie-Josée Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseillère",
    "remuneration": "24173",
    "allocation": "12087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36260",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "971",
    "nom_corrige2": "Norman St-Amour",
    "nom_famille": "St-Amour",
    "titre_genre2": "Conseiller",
    "remuneration": "24173",
    "allocation": "12087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36260",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "972",
    "nom_corrige2": "Louis Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseiller",
    "remuneration": "24173",
    "allocation": "12087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36260",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4469"
  },
  {
    "ID": "973",
    "nom_corrige2": "Guy Benjamin",
    "nom_famille": "Benjamin",
    "titre_genre2": "Maire",
    "remuneration": "19764",
    "allocation": "9462",
    "remuneration2": "4651",
    "allocation2": "2326",
    "total": "36203",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "974",
    "nom_corrige2": "Jean-Paul Dahm",
    "nom_famille": "Dahm",
    "titre_genre2": "Conseiller",
    "remuneration": "24117",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36175",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "975",
    "nom_corrige2": "Mario Bordeleau",
    "nom_famille": "Bordeleau",
    "titre_genre2": "Conseiller",
    "remuneration": "24117",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36175",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "976",
    "nom_corrige2": "Denis Marcil",
    "nom_famille": "Marcil",
    "titre_genre2": "Conseiller",
    "remuneration": "24117",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36175",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "977",
    "nom_corrige2": "Robert Schloesser",
    "nom_famille": "Schloesser",
    "titre_genre2": "Conseiller",
    "remuneration": "24117",
    "allocation": "12058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36175",
    "ville": "Montréal-Est",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "4456"
  },
  {
    "ID": "978",
    "nom_corrige2": "Ludovic Grisé Farand",
    "nom_famille": "Grisé",
    "titre_genre2": "Maire",
    "remuneration": "72147",
    "allocation": "17546",
    "remuneration2": "26609",
    "allocation2": "0",
    "total": "116302",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "979",
    "nom_corrige2": "Marc-André Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36074",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "980",
    "nom_corrige2": "Mathieu Marcil",
    "nom_famille": "Marcil",
    "titre_genre2": "Conseiller",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36074",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "981",
    "nom_corrige2": "Nancy Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseillère",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36074",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "982",
    "nom_corrige2": "Audrée Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseillère",
    "remuneration": "25612",
    "allocation": "10088",
    "remuneration2": "233",
    "allocation2": "116",
    "total": "36049",
    "ville": "Alma",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "31038"
  },
  {
    "ID": "983",
    "nom_corrige2": "Hélène Boulanger",
    "nom_famille": "Boulanger",
    "titre_genre2": "Mairesse",
    "remuneration": "24000",
    "allocation": "12000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "36000",
    "ville": "L'Île-d'Anticosti",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "203"
  },
  {
    "ID": "984",
    "nom_corrige2": "Daniel Camden",
    "nom_famille": "Camden",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "985",
    "nom_corrige2": "Sylvie Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseillère",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "986",
    "nom_corrige2": "Guillaume Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "987",
    "nom_corrige2": "Claudette Carignan",
    "nom_famille": "Carignan",
    "titre_genre2": "Conseillère",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "988",
    "nom_corrige2": "Réal Beauchamp",
    "nom_famille": "Beauchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "989",
    "nom_corrige2": "Yves Drolet",
    "nom_famille": "Drolet",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "990",
    "nom_corrige2": "Sébastien Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "991",
    "nom_corrige2": "Cédric Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "992",
    "nom_corrige2": "Benjamin Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "993",
    "nom_corrige2": "Stéphane Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "23945",
    "allocation": "11973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35918",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "994",
    "nom_corrige2": "LOUIS BÉRARD",
    "nom_famille": "BÉRARD",
    "titre_genre2": "Maire",
    "remuneration": "17360",
    "allocation": "8692",
    "remuneration2": "6572",
    "allocation2": "3286",
    "total": "35910",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "995",
    "nom_corrige2": "Sophie Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseillère",
    "remuneration": "24392",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35888",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "996",
    "nom_corrige2": "Alain Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "27227",
    "allocation": "8613",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35840",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "997",
    "nom_corrige2": "Serge Péloquin",
    "nom_famille": "Péloquin",
    "titre_genre2": "Maire",
    "remuneration": "53245",
    "allocation": "9037",
    "remuneration2": "5128",
    "allocation2": "0",
    "total": "67410",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "998",
    "nom_corrige2": "SYLVAIN RAYMOND",
    "nom_famille": "RAYMOND",
    "titre_genre2": "Maire",
    "remuneration": "24397",
    "allocation": "11350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35747",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "999",
    "nom_corrige2": "Claude Ferguson",
    "nom_famille": "Ferguson",
    "titre_genre2": "Conseiller",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "7560",
    "allocation2": "3780",
    "total": "35644",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1000",
    "nom_corrige2": "Michel Verreault",
    "nom_famille": "Verreault",
    "titre_genre2": "Conseiller",
    "remuneration": "23698",
    "allocation": "11849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35547",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1001",
    "nom_corrige2": "Jason Ball",
    "nom_famille": "Ball",
    "titre_genre2": "Conseiller",
    "remuneration": "23966",
    "allocation": "11398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35364",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1002",
    "nom_corrige2": "Serge Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "26549",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35344",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "1003",
    "nom_corrige2": "Gaétan Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Maire",
    "remuneration": "23541",
    "allocation": "11770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35311",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "1004",
    "nom_corrige2": "Antoine Tayar",
    "nom_famille": "Tayar",
    "titre_genre2": "Conseiller",
    "remuneration": "23692",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35188",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "1005",
    "nom_corrige2": "Julie Halde",
    "nom_famille": "Halde",
    "titre_genre2": "Conseillère",
    "remuneration": "23692",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35188",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "1006",
    "nom_corrige2": "Alain Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Maire",
    "remuneration": "17341",
    "allocation": "8671",
    "remuneration2": "6100",
    "allocation2": "3050",
    "total": "35162",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "1007",
    "nom_corrige2": "Stéphane Joyal",
    "nom_famille": "Joyal",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1008",
    "nom_corrige2": "Dominic Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1009",
    "nom_corrige2": "Carla Pierre-Paul",
    "nom_famille": "Pierre-Paul",
    "titre_genre2": "Conseillère",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1010",
    "nom_corrige2": "Michel Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1011",
    "nom_corrige2": "Marc-Antoine Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1012",
    "nom_corrige2": "Mario Fauteux",
    "nom_famille": "Fauteux",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1013",
    "nom_corrige2": "Martin Pigeon",
    "nom_famille": "Pigeon",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1014",
    "nom_corrige2": "Nathalie Lasalle",
    "nom_famille": "Lasalle",
    "titre_genre2": "Conseillère",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1015",
    "nom_corrige2": "Jean Junior Désormeaux",
    "nom_famille": "Désormeaux",
    "titre_genre2": "Conseiller",
    "remuneration": "23416",
    "allocation": "11708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35124",
    "ville": "Saint-Jérôme",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "82061"
  },
  {
    "ID": "1016",
    "nom_corrige2": "Joëlle Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "26319",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "35114",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "1017",
    "nom_corrige2": "Herman Herbers",
    "nom_famille": "Herbers",
    "titre_genre2": "Maire",
    "remuneration": "17614",
    "allocation": "8807",
    "remuneration2": "5789",
    "allocation2": "2894",
    "total": "35104",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "1018",
    "nom_corrige2": "Denis Miousse",
    "nom_famille": "Miousse",
    "titre_genre2": "Conseiller",
    "remuneration": "22889",
    "allocation": "11445",
    "remuneration2": "486",
    "allocation2": "243",
    "total": "35063",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1019",
    "nom_corrige2": "Alain Quirion",
    "nom_famille": "Quirion",
    "titre_genre2": "Maire",
    "remuneration": "19885",
    "allocation": "9720",
    "remuneration2": "3540",
    "allocation2": "1770",
    "total": "34915",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "1020",
    "nom_corrige2": "Isabelle Poulet",
    "nom_famille": "Poulet",
    "titre_genre2": "Conseillère",
    "remuneration": "22086",
    "allocation": "11043",
    "remuneration2": "1174",
    "allocation2": "587",
    "total": "34890",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "1021",
    "nom_corrige2": "Pier-Luc Laurin",
    "nom_famille": "Laurin",
    "titre_genre2": "Conseiller",
    "remuneration": "26312",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34878",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "1022",
    "nom_corrige2": "Daniel Boisclair",
    "nom_famille": "Boisclair",
    "titre_genre2": "Maire",
    "remuneration": "20336",
    "allocation": "10293",
    "remuneration2": "2143",
    "allocation2": "2072",
    "total": "34844",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "1023",
    "nom_corrige2": "Michel Larochelle",
    "nom_famille": "Larochelle",
    "titre_genre2": "Maire",
    "remuneration": "21118",
    "allocation": "10559",
    "remuneration2": "2096",
    "allocation2": "1048",
    "total": "34821",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "1024",
    "nom_corrige2": "Guillaume Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Maire",
    "remuneration": "19820",
    "allocation": "9910",
    "remuneration2": "3354",
    "allocation2": "1677",
    "total": "34761",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "1025",
    "nom_corrige2": "Daniel Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Maire",
    "remuneration": "14689",
    "allocation": "7242",
    "remuneration2": "8541",
    "allocation2": "4278",
    "total": "34750",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "1026",
    "nom_corrige2": "Michel Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "18786",
    "allocation": "9393",
    "remuneration2": "4426",
    "allocation2": "2058",
    "total": "34663",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "1027",
    "nom_corrige2": "Margaret Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "23021",
    "allocation": "11511",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34532",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1028",
    "nom_corrige2": "Maya Chammas",
    "nom_famille": "Chammas",
    "titre_genre2": "Conseillère",
    "remuneration": "22992",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34488",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "1029",
    "nom_corrige2": "Maryam Kamali Nezhad",
    "nom_famille": "Kamali",
    "titre_genre2": "Conseillère",
    "remuneration": "22992",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34488",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "1030",
    "nom_corrige2": "Sébastien Dreyfuss",
    "nom_famille": "Dreyfuss",
    "titre_genre2": "Conseiller",
    "remuneration": "22992",
    "allocation": "11496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34488",
    "ville": "Mont-Royal",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "21439"
  },
  {
    "ID": "1031",
    "nom_corrige2": "Marilyn Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Mairesse",
    "remuneration": "22983",
    "allocation": "11491",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34474",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "1032",
    "nom_corrige2": "Mario St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Maire",
    "remuneration": "15256",
    "allocation": "7628",
    "remuneration2": "7694",
    "allocation2": "3847",
    "total": "34425",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "1033",
    "nom_corrige2": "Claude Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "25580",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34375",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "1034",
    "nom_corrige2": "Richard Chartrand",
    "nom_famille": "Chartrand",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1035",
    "nom_corrige2": "Pierre Casavant",
    "nom_famille": "Casavant",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1036",
    "nom_corrige2": "Michel Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1037",
    "nom_corrige2": "Brian Trainor",
    "nom_famille": "Trainor",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1038",
    "nom_corrige2": "Donald Andrews",
    "nom_famille": "Andrews",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1039",
    "nom_corrige2": "David Hill",
    "nom_famille": "Hill",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1040",
    "nom_corrige2": "Tanja Minisini",
    "nom_famille": "Minisini",
    "titre_genre2": "Conseillère",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1041",
    "nom_corrige2": "Marc Émond",
    "nom_famille": "Émond",
    "titre_genre2": "Conseiller",
    "remuneration": "22903",
    "allocation": "11451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34354",
    "ville": "Saint-Lazare",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22773"
  },
  {
    "ID": "1042",
    "nom_corrige2": "Yves Charlebois",
    "nom_famille": "Charlebois",
    "titre_genre2": "Maire",
    "remuneration": "14805",
    "allocation": "7403",
    "remuneration2": "8094",
    "allocation2": "4047",
    "total": "34349",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "1043",
    "nom_corrige2": "Pierre Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Conseiller",
    "remuneration": "25747",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34313",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "1044",
    "nom_corrige2": "Patrick Bonvouloir",
    "nom_famille": "Bonvouloir",
    "titre_genre2": "Maire",
    "remuneration": "13371",
    "allocation": "6685",
    "remuneration2": "9485",
    "allocation2": "4760",
    "total": "34301",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "1045",
    "nom_corrige2": "Donna Salvati",
    "nom_famille": "Salvati",
    "titre_genre2": "Mairesse",
    "remuneration": "22833",
    "allocation": "11417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34250",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "1046",
    "nom_corrige2": "Mary Gallery",
    "nom_famille": "Gallery",
    "titre_genre2": "Conseillère",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1047",
    "nom_corrige2": "Kathleen Kez",
    "nom_famille": "Kez",
    "titre_genre2": "Conseillère",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1048",
    "nom_corrige2": "Conrad Peart",
    "nom_famille": "Peart",
    "titre_genre2": "Conseiller",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1049",
    "nom_corrige2": "Antonio D'Amico",
    "nom_famille": "D'Amico",
    "titre_genre2": "Conseiller",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1050",
    "nom_corrige2": "Matt Aronson",
    "nom_famille": "Aronson",
    "titre_genre2": "Conseiller",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1051",
    "nom_corrige2": "Anitra Bostock",
    "nom_famille": "Bostock",
    "titre_genre2": "Conseillère",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1052",
    "nom_corrige2": "Jeff Shamie",
    "nom_famille": "Shamie",
    "titre_genre2": "Conseiller",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1053",
    "nom_corrige2": "Elisabeth Roux",
    "nom_famille": "Roux",
    "titre_genre2": "Conseillère",
    "remuneration": "22967",
    "allocation": "11281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34248",
    "ville": "Westmount",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19938"
  },
  {
    "ID": "1054",
    "nom_corrige2": "Yoland Émond",
    "nom_famille": "Émond",
    "titre_genre2": "Maire",
    "remuneration": "24065",
    "allocation": "10081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34146",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "1055",
    "nom_corrige2": "Carole Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Mairesse",
    "remuneration": "12331",
    "allocation": "6165",
    "remuneration2": "10413",
    "allocation2": "5206",
    "total": "34115",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "1056",
    "nom_corrige2": "Pascal Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Maire",
    "remuneration": "19272",
    "allocation": "9636",
    "remuneration2": "3430",
    "allocation2": "1715",
    "total": "34053",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "1057",
    "nom_corrige2": "Yves Winter",
    "nom_famille": "Winter",
    "titre_genre2": "Maire",
    "remuneration": "17228",
    "allocation": "8614",
    "remuneration2": "5470",
    "allocation2": "2735",
    "total": "34047",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "1058",
    "nom_corrige2": "Robert Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Maire",
    "remuneration": "18347",
    "allocation": "9174",
    "remuneration2": "4344",
    "allocation2": "2172",
    "total": "34037",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "1059",
    "nom_corrige2": "JEAN-MARIE MERCIER",
    "nom_famille": "MERCIER",
    "titre_genre2": "Maire",
    "remuneration": "22654",
    "allocation": "11327",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33981",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "1060",
    "nom_corrige2": "Francine Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Mairesse",
    "remuneration": "22628",
    "allocation": "11314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33942",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "1061",
    "nom_corrige2": "Pascal Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseiller",
    "remuneration": "22626",
    "allocation": "11313",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33939",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "1062",
    "nom_corrige2": "David Pharand",
    "nom_famille": "Pharand",
    "titre_genre2": "Maire",
    "remuneration": "17108",
    "allocation": "8554",
    "remuneration2": "5475",
    "allocation2": "2738",
    "total": "33875",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "1063",
    "nom_corrige2": "Mélanie Dorion",
    "nom_famille": "Dorion",
    "titre_genre2": "Conseillère",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "364",
    "allocation2": "182",
    "total": "33825",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1064",
    "nom_corrige2": "Ronald Cross",
    "nom_famille": "Cross",
    "titre_genre2": "Maire",
    "remuneration": "22544",
    "allocation": "11272",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33816",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "1065",
    "nom_corrige2": "Manon Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "24946",
    "allocation": "8795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33741",
    "ville": "Val-des-Monts",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "13061"
  },
  {
    "ID": "1066",
    "nom_corrige2": "Stéphane Breault",
    "nom_famille": "Breault",
    "titre_genre2": "Conseiller",
    "remuneration": "20474",
    "allocation": "10237",
    "remuneration2": "2000",
    "allocation2": "1000",
    "total": "33711",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1067",
    "nom_corrige2": "Guy Adam",
    "nom_famille": "Adam",
    "titre_genre2": "Maire",
    "remuneration": "16755",
    "allocation": "8377",
    "remuneration2": "5632",
    "allocation2": "2816",
    "total": "33580",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "1068",
    "nom_corrige2": "Carole Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseillère",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "182",
    "allocation2": "91",
    "total": "33552",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1069",
    "nom_corrige2": "John Morson",
    "nom_famille": "Morson",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1070",
    "nom_corrige2": "Luciano Piciacchia",
    "nom_famille": "Piciacchia",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1071",
    "nom_corrige2": "Stephen Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1072",
    "nom_corrige2": "Domenico Zito",
    "nom_famille": "Zito",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1073",
    "nom_corrige2": "Michael Brown",
    "nom_famille": "Brown",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1074",
    "nom_corrige2": "Paul Dufort",
    "nom_famille": "Dufort",
    "titre_genre2": "Conseiller",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1075",
    "nom_corrige2": "Karen Cliffe",
    "nom_famille": "Cliffe",
    "titre_genre2": "Conseillère",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1076",
    "nom_corrige2": "Nancy Kokinasidis",
    "nom_famille": "Kokinasidis",
    "titre_genre2": "Conseillère",
    "remuneration": "22362",
    "allocation": "11181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33543",
    "ville": "Kirkland",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19930"
  },
  {
    "ID": "1077",
    "nom_corrige2": "Josée Brunet",
    "nom_famille": "Brunet",
    "titre_genre2": "Mairesse",
    "remuneration": "22747",
    "allocation": "10784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33531",
    "ville": "Rivière-Saint-Jean",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "211"
  },
  {
    "ID": "1078",
    "nom_corrige2": "Yvon Bourassa",
    "nom_famille": "Bourassa",
    "titre_genre2": "Maire",
    "remuneration": "14197",
    "allocation": "7098",
    "remuneration2": "8038",
    "allocation2": "4019",
    "total": "33352",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "1079",
    "nom_corrige2": "Christian Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Maire",
    "remuneration": "13180",
    "allocation": "6590",
    "remuneration2": "9042",
    "allocation2": "4521",
    "total": "33333",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "1080",
    "nom_corrige2": "Annie Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "22210",
    "allocation": "11105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33315",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "1081",
    "nom_corrige2": "Jasmine Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "22210",
    "allocation": "11105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33315",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "1082",
    "nom_corrige2": "Marion Lamothe",
    "nom_famille": "Lamothe",
    "titre_genre2": "Conseiller",
    "remuneration": "22210",
    "allocation": "11105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33315",
    "ville": "Bécancour",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "14733"
  },
  {
    "ID": "1083",
    "nom_corrige2": "DENIS TASSÉ",
    "nom_famille": "TASSÉ",
    "titre_genre2": "Maire",
    "remuneration": "16833",
    "allocation": "8267",
    "remuneration2": "5459",
    "allocation2": "2729",
    "total": "33288",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "1084",
    "nom_corrige2": "Guy Berthe",
    "nom_famille": "Berthe",
    "titre_genre2": "Conseiller",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33279",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1085",
    "nom_corrige2": "Élisabeth Chevalier",
    "nom_famille": "Chevalier",
    "titre_genre2": "Conseillère",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33279",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1086",
    "nom_corrige2": "Daniel Guérault",
    "nom_famille": "Guérault",
    "titre_genre2": "Conseiller",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33279",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1087",
    "nom_corrige2": "Mélissa Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "22186",
    "allocation": "11093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33279",
    "ville": "Sept-Îles",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "24973"
  },
  {
    "ID": "1088",
    "nom_corrige2": "Joey Leckman",
    "nom_famille": "Leckman",
    "titre_genre2": "Conseiller",
    "remuneration": "24683",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33249",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "1089",
    "nom_corrige2": "Daniel Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Maire",
    "remuneration": "19769",
    "allocation": "9884",
    "remuneration2": "2370",
    "allocation2": "1185",
    "total": "33208",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "1090",
    "nom_corrige2": "Amélie Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseillère",
    "remuneration": "18143",
    "allocation": "9071",
    "remuneration2": "3968",
    "allocation2": "1984",
    "total": "33166",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "1091",
    "nom_corrige2": "Maxime Proulx-Cadieux",
    "nom_famille": "Proulx-Cadieux",
    "titre_genre2": "Maire",
    "remuneration": "24966",
    "allocation": "0",
    "remuneration2": "5459",
    "allocation2": "2729",
    "total": "33154",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "1092",
    "nom_corrige2": "David Newell",
    "nom_famille": "Newell",
    "titre_genre2": "Conseiller",
    "remuneration": "23023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "33034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1093",
    "nom_corrige2": "Martin Dumaresq",
    "nom_famille": "Dumaresq",
    "titre_genre2": "Maire",
    "remuneration": "13035",
    "allocation": "6517",
    "remuneration2": "8932",
    "allocation2": "4466",
    "total": "32950",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "1094",
    "nom_corrige2": "Normand Latreille",
    "nom_famille": "Latreille",
    "titre_genre2": "Conseiller",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "1496",
    "allocation2": "748",
    "total": "32886",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1095",
    "nom_corrige2": "Pierre Flamand",
    "nom_famille": "Flamand",
    "titre_genre2": "Maire",
    "remuneration": "21855",
    "allocation": "10927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32782",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "1096",
    "nom_corrige2": "André Ibghy",
    "nom_famille": "Ibghy",
    "titre_genre2": "Maire",
    "remuneration": "21855",
    "allocation": "10927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32782",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "1097",
    "nom_corrige2": "Michèle Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseillère",
    "remuneration": "21877",
    "allocation": "9751",
    "remuneration2": "1046",
    "allocation2": "0",
    "total": "32674",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "1098",
    "nom_corrige2": "Manon Robitaille",
    "nom_famille": "Robitaille",
    "titre_genre2": "Conseillère",
    "remuneration": "21679",
    "allocation": "10839",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32518",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1099",
    "nom_corrige2": "Louis Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseiller",
    "remuneration": "21670",
    "allocation": "10835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32505",
    "ville": "Rouyn-Noranda",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "43097"
  },
  {
    "ID": "1100",
    "nom_corrige2": "Kimberly Chan",
    "nom_famille": "Chan",
    "titre_genre2": "Conseillère",
    "remuneration": "23447",
    "allocation": "9006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32453",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1101",
    "nom_corrige2": "Normand St-Amour",
    "nom_famille": "St-Amour",
    "titre_genre2": "Maire",
    "remuneration": "21628",
    "allocation": "10814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32442",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "1102",
    "nom_corrige2": "Stéphane Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Maire",
    "remuneration": "12079",
    "allocation": "6417",
    "remuneration2": "9271",
    "allocation2": "4635",
    "total": "32402",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "1103",
    "nom_corrige2": "Sara Dupras",
    "nom_famille": "Dupras",
    "titre_genre2": "Conseillère",
    "remuneration": "23739",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32305",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "1104",
    "nom_corrige2": "Mathieu Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Maire",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "12389",
    "allocation2": "1811",
    "total": "32200",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "1105",
    "nom_corrige2": "Diane Sirard",
    "nom_famille": "Sirard",
    "titre_genre2": "Mairesse",
    "remuneration": "21465",
    "allocation": "10732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32197",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "1106",
    "nom_corrige2": "Marcel Piacrd",
    "nom_famille": "Piacrd",
    "titre_genre2": "Maire",
    "remuneration": "14577",
    "allocation": "7288",
    "remuneration2": "6899",
    "allocation2": "3405",
    "total": "32169",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "1107",
    "nom_corrige2": "Sylvie Dionne-Raymond",
    "nom_famille": "Dionne-Raymond",
    "titre_genre2": "Mairesse",
    "remuneration": "6480",
    "allocation": "3240",
    "remuneration2": "14910",
    "allocation2": "7453",
    "total": "32083",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "1108",
    "nom_corrige2": "Denyse Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Mairesse",
    "remuneration": "17922",
    "allocation": "8961",
    "remuneration2": "3456",
    "allocation2": "1740",
    "total": "32079",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "1109",
    "nom_corrige2": "Robert Julien",
    "nom_famille": "Julien",
    "titre_genre2": "Conseiller",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "900",
    "allocation2": "0",
    "total": "32079",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1110",
    "nom_corrige2": "Jean-Luc Barthe",
    "nom_famille": "Barthe",
    "titre_genre2": "Maire",
    "remuneration": "21631",
    "allocation": "10425",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "32056",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "1111",
    "nom_corrige2": "Mathieu Daviault",
    "nom_famille": "Daviault",
    "titre_genre2": "Conseiller",
    "remuneration": "18875",
    "allocation": "9438",
    "remuneration2": "2421",
    "allocation2": "1210",
    "total": "31944",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1112",
    "nom_corrige2": "Gaétan Guindon",
    "nom_famille": "Guindon",
    "titre_genre2": "Maire",
    "remuneration": "21282",
    "allocation": "10557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31839",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "1113",
    "nom_corrige2": "Marcel Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Maire",
    "remuneration": "17932",
    "allocation": "8966",
    "remuneration2": "3180",
    "allocation2": "1595",
    "total": "31673",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "1114",
    "nom_corrige2": "Alexandre Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Maire",
    "remuneration": "7421",
    "allocation": "3453",
    "remuneration2": "13858",
    "allocation2": "6928",
    "total": "31660",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "1115",
    "nom_corrige2": "Claire Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Mairesse",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "9055",
    "allocation2": "4527",
    "total": "31582",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "1116",
    "nom_corrige2": "Mireille Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseillère",
    "remuneration": "21055",
    "allocation": "10527",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31582",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1117",
    "nom_corrige2": "Micheline Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Mairesse",
    "remuneration": "15581",
    "allocation": "7790",
    "remuneration2": "5409",
    "allocation2": "2763",
    "total": "31543",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "1118",
    "nom_corrige2": "Anita Ouellet Castonguay",
    "nom_famille": "Ouellet",
    "titre_genre2": "Mairesse",
    "remuneration": "12456",
    "allocation": "6553",
    "remuneration2": "8344",
    "allocation2": "4172",
    "total": "31525",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "1119",
    "nom_corrige2": "Jessy Croteau",
    "nom_famille": "Croteau",
    "titre_genre2": "Conseiller",
    "remuneration": "21000",
    "allocation": "10500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31500",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1120",
    "nom_corrige2": "Jean-François Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Maire",
    "remuneration": "14109",
    "allocation": "7055",
    "remuneration2": "6868",
    "allocation2": "3434",
    "total": "31466",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "1121",
    "nom_corrige2": "Denise Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Mairesse",
    "remuneration": "14200",
    "allocation": "6700",
    "remuneration2": "6936",
    "allocation2": "3468",
    "total": "31304",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "1122",
    "nom_corrige2": "Claude Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Maire",
    "remuneration": "20817",
    "allocation": "10409",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31226",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "1123",
    "nom_corrige2": "Mario Groleau",
    "nom_famille": "Groleau",
    "titre_genre2": "Maire",
    "remuneration": "16369",
    "allocation": "8185",
    "remuneration2": "4440",
    "allocation2": "2220",
    "total": "31214",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "1124",
    "nom_corrige2": "Hugo Mc Dermott",
    "nom_famille": "Mc",
    "titre_genre2": "Maire",
    "remuneration": "13622",
    "allocation": "6561",
    "remuneration2": "7340",
    "allocation2": "3670",
    "total": "31193",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "1125",
    "nom_corrige2": "Mario Brunet",
    "nom_famille": "Brunet",
    "titre_genre2": "Conseiller",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31179",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1126",
    "nom_corrige2": "Martin Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31179",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1127",
    "nom_corrige2": "Nathalie Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31179",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1128",
    "nom_corrige2": "Pierre Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Conseiller",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31179",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1129",
    "nom_corrige2": "Annie Quenneville",
    "nom_famille": "Quenneville",
    "titre_genre2": "Conseillère",
    "remuneration": "20786",
    "allocation": "10393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31179",
    "ville": "Amos",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "12675"
  },
  {
    "ID": "1130",
    "nom_corrige2": "Paul Kushner",
    "nom_famille": "Kushner",
    "titre_genre2": "Maire",
    "remuneration": "19619",
    "allocation": "8722",
    "remuneration2": "1887",
    "allocation2": "943",
    "total": "31171",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "1131",
    "nom_corrige2": "Peter Zytynsky",
    "nom_famille": "Zytynsky",
    "titre_genre2": "Maire",
    "remuneration": "14091",
    "allocation": "7046",
    "remuneration2": "6652",
    "allocation2": "3325",
    "total": "31114",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "1132",
    "nom_corrige2": "Daniel Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Maire",
    "remuneration": "12349",
    "allocation": "6174",
    "remuneration2": "8677",
    "allocation2": "3875",
    "total": "31075",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "1133",
    "nom_corrige2": "Josée Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1134",
    "nom_corrige2": "Yvan Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseiller",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1135",
    "nom_corrige2": "Émilie Rémillard",
    "nom_famille": "Rémillard",
    "titre_genre2": "Conseillère",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1136",
    "nom_corrige2": "Luc Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1137",
    "nom_corrige2": "Anthony Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1138",
    "nom_corrige2": "Adam Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseiller",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1139",
    "nom_corrige2": "Jean Yves Angers",
    "nom_famille": "Angers",
    "titre_genre2": "Conseiller",
    "remuneration": "20609",
    "allocation": "10305",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30914",
    "ville": "Thetford Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "25884"
  },
  {
    "ID": "1140",
    "nom_corrige2": "Réjean Rajotte",
    "nom_famille": "Rajotte",
    "titre_genre2": "Maire",
    "remuneration": "14451",
    "allocation": "7225",
    "remuneration2": "6100",
    "allocation2": "3050",
    "total": "30826",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "1141",
    "nom_corrige2": "Gaby Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Maire",
    "remuneration": "17290",
    "allocation": "8645",
    "remuneration2": "3229",
    "allocation2": "1614",
    "total": "30778",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "1142",
    "nom_corrige2": "Robert Vyncke",
    "nom_famille": "Vyncke",
    "titre_genre2": "Maire",
    "remuneration": "15861",
    "allocation": "7931",
    "remuneration2": "4651",
    "allocation2": "2326",
    "total": "30769",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "1143",
    "nom_corrige2": "Geneviève Dubuc",
    "nom_famille": "Dubuc",
    "titre_genre2": "Conseillère",
    "remuneration": "20502",
    "allocation": "10251",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1144",
    "nom_corrige2": "Oren Sebag",
    "nom_famille": "Sebag",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1145",
    "nom_corrige2": "Dida Berku",
    "nom_famille": "Berku",
    "titre_genre2": "Conseillère",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1146",
    "nom_corrige2": "Steven Erdelyi",
    "nom_famille": "Erdelyi",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1147",
    "nom_corrige2": "Sidney Benizri",
    "nom_famille": "Benizri",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1148",
    "nom_corrige2": "Andee Shuster",
    "nom_famille": "Shuster",
    "titre_genre2": "Conseillère",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1149",
    "nom_corrige2": "Mike Cohen",
    "nom_famille": "Cohen",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1150",
    "nom_corrige2": "Mitch Kujavsky",
    "nom_famille": "Kujavsky",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1151",
    "nom_corrige2": "Lior Azerad",
    "nom_famille": "Azerad",
    "titre_genre2": "Conseiller",
    "remuneration": "20501",
    "allocation": "10252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30753",
    "ville": "Côte-Saint-Luc",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "35419"
  },
  {
    "ID": "1152",
    "nom_corrige2": "Réal Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Maire",
    "remuneration": "18000",
    "allocation": "9000",
    "remuneration2": "2479",
    "allocation2": "1239",
    "total": "30718",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "1153",
    "nom_corrige2": "Yves Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Maire",
    "remuneration": "16649",
    "allocation": "8324",
    "remuneration2": "3827",
    "allocation2": "1913",
    "total": "30713",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "1154",
    "nom_corrige2": "David Christopher",
    "nom_famille": "Christopher",
    "titre_genre2": "Maire",
    "remuneration": "15824",
    "allocation": "7912",
    "remuneration2": "4639",
    "allocation2": "2320",
    "total": "30695",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "1155",
    "nom_corrige2": "Jennifer Garfat",
    "nom_famille": "Garfat",
    "titre_genre2": "Conseillère",
    "remuneration": "19899",
    "allocation": "10776",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30675",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "1156",
    "nom_corrige2": "Carole Viau",
    "nom_famille": "Viau",
    "titre_genre2": "Conseillère",
    "remuneration": "20436",
    "allocation": "10218",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30654",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1157",
    "nom_corrige2": "Yves Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Conseiller",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30642",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1158",
    "nom_corrige2": "Émilie Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30642",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1159",
    "nom_corrige2": "Claudie Lacelle",
    "nom_famille": "Lacelle",
    "titre_genre2": "Conseillère",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30642",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1160",
    "nom_corrige2": "Véronie Whear",
    "nom_famille": "Whear",
    "titre_genre2": "Conseillère",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30642",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1161",
    "nom_corrige2": "Suzanne Parisé",
    "nom_famille": "Parisé",
    "titre_genre2": "Conseillère",
    "remuneration": "20428",
    "allocation": "10214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30642",
    "ville": "Mont-Laurier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14562"
  },
  {
    "ID": "1162",
    "nom_corrige2": "Richard Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Maire",
    "remuneration": "12076",
    "allocation": "12076",
    "remuneration2": "6487",
    "allocation2": "0",
    "total": "30639",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "1163",
    "nom_corrige2": "Daniel Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Maire",
    "remuneration": "18380",
    "allocation": "9102",
    "remuneration2": "2068",
    "allocation2": "1034",
    "total": "30584",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "1164",
    "nom_corrige2": "Diane Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseillère",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "1430",
    "allocation2": "715",
    "total": "30525",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1165",
    "nom_corrige2": "Sylvie Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseillère",
    "remuneration": "20338",
    "allocation": "10169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30507",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1166",
    "nom_corrige2": "Jean-Benoit Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Maire",
    "remuneration": "19333",
    "allocation": "9667",
    "remuneration2": "976",
    "allocation2": "488",
    "total": "30464",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "1167",
    "nom_corrige2": "Mario Lyonnais",
    "nom_famille": "Lyonnais",
    "titre_genre2": "Maire",
    "remuneration": "8198",
    "allocation": "2666",
    "remuneration2": "13057",
    "allocation2": "6528",
    "total": "30449",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "1168",
    "nom_corrige2": "Ginette Gagné-Stoklosa",
    "nom_famille": "Gagné-Stoklosa",
    "titre_genre2": "Conseillère",
    "remuneration": "20293",
    "allocation": "10147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30440",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1169",
    "nom_corrige2": "Daniel Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Conseiller",
    "remuneration": "19077",
    "allocation": "9539",
    "remuneration2": "1200",
    "allocation2": "600",
    "total": "30416",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "1170",
    "nom_corrige2": "Maryse Collette",
    "nom_famille": "Collette",
    "titre_genre2": "Mairesse",
    "remuneration": "15825",
    "allocation": "7912",
    "remuneration2": "4427",
    "allocation2": "2214",
    "total": "30378",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "1171",
    "nom_corrige2": "Louise Brais",
    "nom_famille": "Brais",
    "titre_genre2": "Conseillère",
    "remuneration": "21441",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30361",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1172",
    "nom_corrige2": "André Ducharme",
    "nom_famille": "Ducharme",
    "titre_genre2": "Conseiller",
    "remuneration": "20543",
    "allocation": "9770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30313",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1173",
    "nom_corrige2": "Francis Marcoux",
    "nom_famille": "Marcoux",
    "titre_genre2": "Conseiller",
    "remuneration": "20543",
    "allocation": "9770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30313",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1174",
    "nom_corrige2": "Christine Baudinet",
    "nom_famille": "Baudinet",
    "titre_genre2": "Conseillère",
    "remuneration": "20543",
    "allocation": "9770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30313",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1175",
    "nom_corrige2": "Cynthia Sherrer",
    "nom_famille": "Sherrer",
    "titre_genre2": "Conseillère",
    "remuneration": "20543",
    "allocation": "9770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30313",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1176",
    "nom_corrige2": "Emilie Hébert-Larue",
    "nom_famille": "Hébert-Larue",
    "titre_genre2": "Conseillère",
    "remuneration": "20543",
    "allocation": "9770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30313",
    "ville": "Potton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1961"
  },
  {
    "ID": "1177",
    "nom_corrige2": "Caroline Vinet",
    "nom_famille": "Vinet",
    "titre_genre2": "Conseillère",
    "remuneration": "20195",
    "allocation": "10098",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30293",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1178",
    "nom_corrige2": "Johanne Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Mairesse",
    "remuneration": "11560",
    "allocation": "5780",
    "remuneration2": "8633",
    "allocation2": "4316",
    "total": "30289",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "1179",
    "nom_corrige2": "Éric Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Maire",
    "remuneration": "18123",
    "allocation": "9062",
    "remuneration2": "2066",
    "allocation2": "1033",
    "total": "30284",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "1180",
    "nom_corrige2": "Claude Rollin",
    "nom_famille": "Rollin",
    "titre_genre2": "Conseiller",
    "remuneration": "20185",
    "allocation": "10093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30278",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1181",
    "nom_corrige2": "Benoit Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Conseiller",
    "remuneration": "20117",
    "allocation": "10059",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30176",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1182",
    "nom_corrige2": "DENY LÉPINE",
    "nom_famille": "LÉPINE",
    "titre_genre2": "Maire",
    "remuneration": "15425",
    "allocation": "7963",
    "remuneration2": "4593",
    "allocation2": "2192",
    "total": "30173",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "1183",
    "nom_corrige2": "Gaston Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Maire",
    "remuneration": "15000",
    "allocation": "7500",
    "remuneration2": "6297",
    "allocation2": "1364",
    "total": "30161",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "1184",
    "nom_corrige2": "Mariane Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Mairesse",
    "remuneration": "17508",
    "allocation": "8754",
    "remuneration2": "2584",
    "allocation2": "1292",
    "total": "30138",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "1185",
    "nom_corrige2": "Jean Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1186",
    "nom_corrige2": "Tom Redmond",
    "nom_famille": "Redmond",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1187",
    "nom_corrige2": "Jean-Pierre Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1188",
    "nom_corrige2": "Olivier Duval",
    "nom_famille": "Duval",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1189",
    "nom_corrige2": "Renaud Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1190",
    "nom_corrige2": "Serge Thomassin",
    "nom_famille": "Thomassin",
    "titre_genre2": "Conseiller",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1191",
    "nom_corrige2": "Manon Bougie",
    "nom_famille": "Bougie",
    "titre_genre2": "Conseillère",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1192",
    "nom_corrige2": "Esther Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "20084",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30126",
    "ville": "Saint-Georges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "33704"
  },
  {
    "ID": "1193",
    "nom_corrige2": "Odette Filion",
    "nom_famille": "Filion",
    "titre_genre2": "Conseillère",
    "remuneration": "20083",
    "allocation": "10042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30125",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1194",
    "nom_corrige2": "Alain Jobin",
    "nom_famille": "Jobin",
    "titre_genre2": "Maire",
    "remuneration": "10833",
    "allocation": "5416",
    "remuneration2": "9453",
    "allocation2": "4342",
    "total": "30044",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "1195",
    "nom_corrige2": "Peggy Alexopoulos",
    "nom_famille": "Alexopoulos",
    "titre_genre2": "Conseillère",
    "remuneration": "20023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1196",
    "nom_corrige2": "Dominique Godin",
    "nom_famille": "Godin",
    "titre_genre2": "Conseillère",
    "remuneration": "20023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1197",
    "nom_corrige2": "Robert Mercuri",
    "nom_famille": "Mercuri",
    "titre_genre2": "Conseiller",
    "remuneration": "20023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1198",
    "nom_corrige2": "Roger Moss",
    "nom_famille": "Moss",
    "titre_genre2": "Conseiller",
    "remuneration": "20023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1199",
    "nom_corrige2": "Martin St-Jean",
    "nom_famille": "St-Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "20023",
    "allocation": "10011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30034",
    "ville": "Beaconsfield",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19755"
  },
  {
    "ID": "1200",
    "nom_corrige2": "YANNICK LEBRASSEUR",
    "nom_famille": "LEBRASSEUR",
    "titre_genre2": "Conseiller",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30017",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "1201",
    "nom_corrige2": "CHANTAL BROCHU",
    "nom_famille": "BROCHU",
    "titre_genre2": "Conseillère",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30017",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "1202",
    "nom_corrige2": "MARTIN MARANDA",
    "nom_famille": "MARANDA",
    "titre_genre2": "Conseiller",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30017",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "1203",
    "nom_corrige2": "MARIE-JOSÉE TARDIF",
    "nom_famille": "TARDIF",
    "titre_genre2": "Conseillère",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30017",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "1204",
    "nom_corrige2": "ERIC FISET",
    "nom_famille": "FISET",
    "titre_genre2": "Conseiller",
    "remuneration": "20011",
    "allocation": "10006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30017",
    "ville": "Saint-Augustin-de-Desmaures",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "20213"
  },
  {
    "ID": "1205",
    "nom_corrige2": "Charles Guérard",
    "nom_famille": "Guérard",
    "titre_genre2": "Conseiller",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30011",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "1206",
    "nom_corrige2": "Isabelle Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30011",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "1207",
    "nom_corrige2": "johanne Laurin",
    "nom_famille": "Laurin",
    "titre_genre2": "Conseillère",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30011",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "1208",
    "nom_corrige2": "Josée Ossio",
    "nom_famille": "Ossio",
    "titre_genre2": "Conseillère",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30011",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "1209",
    "nom_corrige2": "Nicolas Dubuc Saint-Gelais",
    "nom_famille": "Dubuc",
    "titre_genre2": "Conseiller",
    "remuneration": "20007",
    "allocation": "10004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30011",
    "ville": "L'Ancienne-Lorette",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "16777"
  },
  {
    "ID": "1210",
    "nom_corrige2": "Alain Maheux",
    "nom_famille": "Maheux",
    "titre_genre2": "Maire",
    "remuneration": "15028",
    "allocation": "7514",
    "remuneration2": "4942",
    "allocation2": "2471",
    "total": "29955",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "1211",
    "nom_corrige2": "Jocelyne Lyrette",
    "nom_famille": "Lyrette",
    "titre_genre2": "Mairesse",
    "remuneration": "19950",
    "allocation": "9975",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29925",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "1212",
    "nom_corrige2": "Steve Laberge",
    "nom_famille": "Laberge",
    "titre_genre2": "Maire",
    "remuneration": "13743",
    "allocation": "6872",
    "remuneration2": "6173",
    "allocation2": "3087",
    "total": "29875",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "1213",
    "nom_corrige2": "Sylvain Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Maire",
    "remuneration": "15210",
    "allocation": "7605",
    "remuneration2": "4689",
    "allocation2": "2344",
    "total": "29848",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "1214",
    "nom_corrige2": "Alain Gamache",
    "nom_famille": "Gamache",
    "titre_genre2": "Maire",
    "remuneration": "12559",
    "allocation": "6280",
    "remuneration2": "7300",
    "allocation2": "3650",
    "total": "29789",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "1215",
    "nom_corrige2": "Michèle Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "21191",
    "allocation": "8566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29757",
    "ville": "Prévost",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14060"
  },
  {
    "ID": "1216",
    "nom_corrige2": "Nathalie Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Mairesse",
    "remuneration": "14702",
    "allocation": "7351",
    "remuneration2": "7703",
    "allocation2": "0",
    "total": "29756",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "1217",
    "nom_corrige2": "Lucien Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Maire",
    "remuneration": "16224",
    "allocation": "8113",
    "remuneration2": "3590",
    "allocation2": "1800",
    "total": "29727",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "1218",
    "nom_corrige2": "Gérard Bruneau",
    "nom_famille": "Bruneau",
    "titre_genre2": "Maire",
    "remuneration": "19808",
    "allocation": "9904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29712",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "1219",
    "nom_corrige2": "Vicky Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Conseillère",
    "remuneration": "18875",
    "allocation": "9438",
    "remuneration2": "1370",
    "allocation2": "0",
    "total": "29683",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1220",
    "nom_corrige2": "Natalia Pereira",
    "nom_famille": "Pereira",
    "titre_genre2": "Conseillère",
    "remuneration": "19752",
    "allocation": "9539",
    "remuneration2": "230",
    "allocation2": "115",
    "total": "29636",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "1221",
    "nom_corrige2": "Vincent Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "9888",
    "allocation": "4944",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14832",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "1222",
    "nom_corrige2": "Luc Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "19702",
    "allocation": "9851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29553",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1223",
    "nom_corrige2": "Marie-José Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseillère",
    "remuneration": "19702",
    "allocation": "9851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29553",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1224",
    "nom_corrige2": "Rosa Borreggine",
    "nom_famille": "Borreggine",
    "titre_genre2": "Conseillère",
    "remuneration": "19702",
    "allocation": "9851",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29553",
    "ville": "Saint-Sauveur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11597"
  },
  {
    "ID": "1225",
    "nom_corrige2": "Paul-André David",
    "nom_famille": "David",
    "titre_genre2": "Maire",
    "remuneration": "19666",
    "allocation": "9833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29499",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "1226",
    "nom_corrige2": "Mario Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Maire",
    "remuneration": "12016",
    "allocation": "6008",
    "remuneration2": "7625",
    "allocation2": "3812",
    "total": "29461",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "1227",
    "nom_corrige2": "Diane Morneau",
    "nom_famille": "Morneau",
    "titre_genre2": "Conseillère",
    "remuneration": "19637",
    "allocation": "9819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29456",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1228",
    "nom_corrige2": "Denis Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Conseiller",
    "remuneration": "19621",
    "allocation": "9811",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29432",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1229",
    "nom_corrige2": "Denis Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "19621",
    "allocation": "9811",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29432",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1230",
    "nom_corrige2": "Lisette Falker",
    "nom_famille": "Falker",
    "titre_genre2": "Conseillère",
    "remuneration": "19073",
    "allocation": "9536",
    "remuneration2": "527",
    "allocation2": "264",
    "total": "29400",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1231",
    "nom_corrige2": "Enock-Robin Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "19579",
    "allocation": "9790",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29369",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1232",
    "nom_corrige2": "CHANTAL LACHAINE",
    "nom_famille": "LACHAINE",
    "titre_genre2": "Conseillère",
    "remuneration": "21675",
    "allocation": "7538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29213",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1233",
    "nom_corrige2": "Aryane Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseillère",
    "remuneration": "19465",
    "allocation": "9733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29198",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1234",
    "nom_corrige2": "Christopher Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "20289",
    "allocation": "8874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29163",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1235",
    "nom_corrige2": "Dany Brosseau",
    "nom_famille": "Brosseau",
    "titre_genre2": "Conseiller",
    "remuneration": "20241",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29161",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1236",
    "nom_corrige2": "Véronique Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Conseillère",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1237",
    "nom_corrige2": "Pierre Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseiller",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1238",
    "nom_corrige2": "Isabelle Hardy",
    "nom_famille": "Hardy",
    "titre_genre2": "Conseillère",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1239",
    "nom_corrige2": "Marc-Olivier Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1240",
    "nom_corrige2": "Sébastien Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1241",
    "nom_corrige2": "Keven Renière",
    "nom_famille": "Renière",
    "titre_genre2": "Conseiller",
    "remuneration": "19400",
    "allocation": "9700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29100",
    "ville": "Sainte-Anne-des-Plaines",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "15905"
  },
  {
    "ID": "1242",
    "nom_corrige2": "Micheline Groulx Stabile",
    "nom_famille": "Groulx",
    "titre_genre2": "Conseillère",
    "remuneration": "19350",
    "allocation": "9675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29025",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1243",
    "nom_corrige2": "Frédéric Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseiller",
    "remuneration": "19350",
    "allocation": "9675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29025",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1244",
    "nom_corrige2": "Michel Mendes",
    "nom_famille": "Mendes",
    "titre_genre2": "Conseiller",
    "remuneration": "19350",
    "allocation": "9675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29025",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1245",
    "nom_corrige2": "Erik Johnson",
    "nom_famille": "Johnson",
    "titre_genre2": "Conseiller",
    "remuneration": "19350",
    "allocation": "9675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29025",
    "ville": "Deux-Montagnes",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18394"
  },
  {
    "ID": "1246",
    "nom_corrige2": "Marie-Dominique Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "20091",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29011",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1247",
    "nom_corrige2": "Jean-François Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "20091",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "29011",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1248",
    "nom_corrige2": "Pierre Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Maire",
    "remuneration": "19317",
    "allocation": "9658",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28975",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "1249",
    "nom_corrige2": "Julie Jolivette",
    "nom_famille": "Jolivette",
    "titre_genre2": "Mairesse",
    "remuneration": "9971",
    "allocation": "4986",
    "remuneration2": "9319",
    "allocation2": "4659",
    "total": "28935",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "1250",
    "nom_corrige2": "Martin Leprohon",
    "nom_famille": "Leprohon",
    "titre_genre2": "Conseiller",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "1033",
    "allocation2": "516",
    "total": "28906",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1251",
    "nom_corrige2": "Michelle Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseillère",
    "remuneration": "19268",
    "allocation": "9634",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28902",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1252",
    "nom_corrige2": "Robert Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "17690",
    "allocation": "8845",
    "remuneration2": "1576",
    "allocation2": "788",
    "total": "28899",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1253",
    "nom_corrige2": "Jacques Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Maire",
    "remuneration": "26919",
    "allocation": "1962",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28881",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "1254",
    "nom_corrige2": "Dany Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "18875",
    "allocation": "9438",
    "remuneration2": "366",
    "allocation2": "183",
    "total": "28862",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1255",
    "nom_corrige2": "Sylvain Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Maire",
    "remuneration": "9982",
    "allocation": "4991",
    "remuneration2": "9239",
    "allocation2": "4620",
    "total": "28832",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "1256",
    "nom_corrige2": "Enrico Valente",
    "nom_famille": "Valente",
    "titre_genre2": "Conseiller",
    "remuneration": "20694",
    "allocation": "8124",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28818",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1257",
    "nom_corrige2": "Denis Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "19450",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28799",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1258",
    "nom_corrige2": "Richard Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Maire",
    "remuneration": "10891",
    "allocation": "5446",
    "remuneration2": "8078",
    "allocation2": "4343",
    "total": "28758",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "1259",
    "nom_corrige2": "Benoist Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseiller",
    "remuneration": "19159",
    "allocation": "9580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28739",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1260",
    "nom_corrige2": "Gilbert Guérette",
    "nom_famille": "Guérette",
    "titre_genre2": "Conseiller",
    "remuneration": "19159",
    "allocation": "9580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28739",
    "ville": "Bois-des-Filion",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "10480"
  },
  {
    "ID": "1261",
    "nom_corrige2": "Michel Pronovost",
    "nom_famille": "Pronovost",
    "titre_genre2": "Conseiller",
    "remuneration": "19890",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28737",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1262",
    "nom_corrige2": "Diane Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseillère",
    "remuneration": "19791",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28711",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1263",
    "nom_corrige2": "Bruno Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "19152",
    "allocation": "9539",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28691",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "1264",
    "nom_corrige2": "Isabelle Thibeault",
    "nom_famille": "Thibeault",
    "titre_genre2": "Conseillère",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "1173",
    "allocation2": "587",
    "total": "28617",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1265",
    "nom_corrige2": "Normand Pigeon",
    "nom_famille": "Pigeon",
    "titre_genre2": "Conseiller",
    "remuneration": "19077",
    "allocation": "9539",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28616",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "1266",
    "nom_corrige2": "Jean Fournel",
    "nom_famille": "Fournel",
    "titre_genre2": "Conseiller",
    "remuneration": "19077",
    "allocation": "9539",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28616",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "1267",
    "nom_corrige2": "Francine Ranger",
    "nom_famille": "Ranger",
    "titre_genre2": "Conseillère",
    "remuneration": "19073",
    "allocation": "9536",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28609",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1268",
    "nom_corrige2": "Marie-Pier Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseillère",
    "remuneration": "19073",
    "allocation": "9536",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28609",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1269",
    "nom_corrige2": "Huguette Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Mairesse",
    "remuneration": "13375",
    "allocation": "6688",
    "remuneration2": "5683",
    "allocation2": "2842",
    "total": "28588",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "1270",
    "nom_corrige2": "Guillaume Lirette-Gélinas",
    "nom_famille": "Lirette-Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "19098",
    "allocation": "9476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28574",
    "ville": "Sherbrooke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "175114"
  },
  {
    "ID": "1271",
    "nom_corrige2": "Robert Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Conseiller",
    "remuneration": "19013",
    "allocation": "9506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28519",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1272",
    "nom_corrige2": "Jocelyn Guévremont",
    "nom_famille": "Guévremont",
    "titre_genre2": "Conseiller",
    "remuneration": "19013",
    "allocation": "9506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28519",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1273",
    "nom_corrige2": "Chantal Riopel",
    "nom_famille": "Riopel",
    "titre_genre2": "Conseillère",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1274",
    "nom_corrige2": "Jean-Sébastien Hénault",
    "nom_famille": "Hénault",
    "titre_genre2": "Conseiller",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1275",
    "nom_corrige2": "Louise Savignac",
    "nom_famille": "Savignac",
    "titre_genre2": "Conseillère",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1276",
    "nom_corrige2": "Denis Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1277",
    "nom_corrige2": "Robert Groulx",
    "nom_famille": "Groulx",
    "titre_genre2": "Conseiller",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1278",
    "nom_corrige2": "Janie Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "19375",
    "allocation": "9087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28462",
    "ville": "Saint-Charles-Borromée",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15437"
  },
  {
    "ID": "1279",
    "nom_corrige2": "Michèle Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseillère",
    "remuneration": "29990",
    "allocation": "13011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43001",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "1280",
    "nom_corrige2": "Éric Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "19590",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28437",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1281",
    "nom_corrige2": "Clément Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "19590",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28437",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1282",
    "nom_corrige2": "Dorys Duchesne",
    "nom_famille": "Duchesne",
    "titre_genre2": "Conseillère",
    "remuneration": "19590",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28437",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1283",
    "nom_corrige2": "François Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "19590",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28437",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1284",
    "nom_corrige2": "Claude Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "19590",
    "allocation": "8847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28437",
    "ville": "La Tuque",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "10929"
  },
  {
    "ID": "1285",
    "nom_corrige2": "Jean-Guy Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Maire",
    "remuneration": "10009",
    "allocation": "5004",
    "remuneration2": "8949",
    "allocation2": "4474",
    "total": "28436",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "1286",
    "nom_corrige2": "Denis Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Conseiller",
    "remuneration": "18953",
    "allocation": "9476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28429",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1287",
    "nom_corrige2": "Dominic Labrie",
    "nom_famille": "Labrie",
    "titre_genre2": "Conseiller",
    "remuneration": "19689",
    "allocation": "8724",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28413",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1288",
    "nom_corrige2": "Cybèle Wilson",
    "nom_famille": "Wilson",
    "titre_genre2": "Conseillère",
    "remuneration": "19689",
    "allocation": "8724",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28413",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1289",
    "nom_corrige2": "Annie Payant",
    "nom_famille": "Payant",
    "titre_genre2": "Conseillère",
    "remuneration": "19491",
    "allocation": "8920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28411",
    "ville": "Saint-Rémi",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "9259"
  },
  {
    "ID": "1290",
    "nom_corrige2": "Luc Beauséjour",
    "nom_famille": "Beauséjour",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1291",
    "nom_corrige2": "Claude St-Cyr",
    "nom_famille": "St-Cyr",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1292",
    "nom_corrige2": "Alexandre Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1293",
    "nom_corrige2": "Cédric Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1294",
    "nom_corrige2": "Patrick Lasalle",
    "nom_famille": "Lasalle",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1295",
    "nom_corrige2": "Richard Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1296",
    "nom_corrige2": "Muriel Lafarge",
    "nom_famille": "Lafarge",
    "titre_genre2": "Conseillère",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1297",
    "nom_corrige2": "Claudia Bertinotti",
    "nom_famille": "Bertinotti",
    "titre_genre2": "Conseillère",
    "remuneration": "18937",
    "allocation": "9469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28406",
    "ville": "Joliette",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "22098"
  },
  {
    "ID": "1298",
    "nom_corrige2": "Denise Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseillère",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28380",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1299",
    "nom_corrige2": "Sam Ierfino",
    "nom_famille": "Ierfino",
    "titre_genre2": "Conseiller",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28380",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1300",
    "nom_corrige2": "René Lecavalier",
    "nom_famille": "Lecavalier",
    "titre_genre2": "Conseiller",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28380",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1301",
    "nom_corrige2": "Hugo Gendreau",
    "nom_famille": "Gendreau",
    "titre_genre2": "Conseiller",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28380",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1302",
    "nom_corrige2": "Claudine Girouard-Morel",
    "nom_famille": "Girouard-Morel",
    "titre_genre2": "Conseillère",
    "remuneration": "18920",
    "allocation": "9460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28380",
    "ville": "Pincourt",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15338"
  },
  {
    "ID": "1303",
    "nom_corrige2": "David Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "1005",
    "allocation2": "502",
    "total": "28364",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1304",
    "nom_corrige2": "Pascal Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "18893",
    "allocation": "9446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28339",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1305",
    "nom_corrige2": "Charles Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Maire",
    "remuneration": "17318",
    "allocation": "8659",
    "remuneration2": "1573",
    "allocation2": "787",
    "total": "28337",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "1306",
    "nom_corrige2": "France Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "18875",
    "allocation": "9438",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28313",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1307",
    "nom_corrige2": "Serge Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Maire",
    "remuneration": "14496",
    "allocation": "7216",
    "remuneration2": "4354",
    "allocation2": "2185",
    "total": "28251",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "1308",
    "nom_corrige2": "Anne Charlot-Mayrand",
    "nom_famille": "Charlot-Mayrand",
    "titre_genre2": "Conseillère",
    "remuneration": "18833",
    "allocation": "9416",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28249",
    "ville": "Lavaltrie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "15578"
  },
  {
    "ID": "1309",
    "nom_corrige2": "Raymond Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Maire",
    "remuneration": "16176",
    "allocation": "8088",
    "remuneration2": "2644",
    "allocation2": "1327",
    "total": "28235",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "1310",
    "nom_corrige2": "Gabrielle Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseillère",
    "remuneration": "18875",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28224",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1311",
    "nom_corrige2": "Marc Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "18758",
    "allocation": "9379",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28137",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1312",
    "nom_corrige2": "Gabrielle Brisebois",
    "nom_famille": "Brisebois",
    "titre_genre2": "Conseillère",
    "remuneration": "18758",
    "allocation": "9379",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28137",
    "ville": "Montmagny",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "11063"
  },
  {
    "ID": "1313",
    "nom_corrige2": "Kim Comeau",
    "nom_famille": "Comeau",
    "titre_genre2": "Conseiller",
    "remuneration": "18698",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28047",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1314",
    "nom_corrige2": "Nancy Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "18698",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28047",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1315",
    "nom_corrige2": "Pierre-Yves L'Heureux",
    "nom_famille": "L'Heureux",
    "titre_genre2": "Conseiller",
    "remuneration": "18698",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28047",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1316",
    "nom_corrige2": "Marc Deslauriers",
    "nom_famille": "Deslauriers",
    "titre_genre2": "Conseiller",
    "remuneration": "18698",
    "allocation": "9349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28047",
    "ville": "L'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11547"
  },
  {
    "ID": "1317",
    "nom_corrige2": "Luce Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseillère",
    "remuneration": "16208",
    "allocation": "8104",
    "remuneration2": "2479",
    "allocation2": "1239",
    "total": "28030",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1318",
    "nom_corrige2": "ALAIN GOYETTE",
    "nom_famille": "GOYETTE",
    "titre_genre2": "Maire",
    "remuneration": "11670",
    "allocation": "5835",
    "remuneration2": "6953",
    "allocation2": "3477",
    "total": "27935",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "1319",
    "nom_corrige2": "Mylène Allary",
    "nom_famille": "Allary",
    "titre_genre2": "Conseillère",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1320",
    "nom_corrige2": "Nicole Chevalier",
    "nom_famille": "Chevalier",
    "titre_genre2": "Conseillère",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1321",
    "nom_corrige2": "Jean-Guy Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1322",
    "nom_corrige2": "Stéphanie Godin",
    "nom_famille": "Godin",
    "titre_genre2": "Conseillère",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1323",
    "nom_corrige2": "Marie-Christine Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseillère",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1324",
    "nom_corrige2": "Régis Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseiller",
    "remuneration": "18602",
    "allocation": "9301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27903",
    "ville": "Notre-Dame-des-Prairies",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9632"
  },
  {
    "ID": "1325",
    "nom_corrige2": "Julie Bourgoin",
    "nom_famille": "Bourgoin",
    "titre_genre2": "Conseillère",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "2340",
    "allocation2": "1170",
    "total": "27814",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1326",
    "nom_corrige2": "Sara Vigneau",
    "nom_famille": "Vigneau",
    "titre_genre2": "Conseillère",
    "remuneration": "19786",
    "allocation": "8015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27801",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "1327",
    "nom_corrige2": "Daniel Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "17285",
    "allocation": "8642",
    "remuneration2": "1217",
    "allocation2": "608",
    "total": "27752",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1328",
    "nom_corrige2": "Jocelyne Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Mairesse",
    "remuneration": "18431",
    "allocation": "9216",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27647",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "1329",
    "nom_corrige2": "Roland Montpetit",
    "nom_famille": "Montpetit",
    "titre_genre2": "Maire",
    "remuneration": "18412",
    "allocation": "9206",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27618",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "1330",
    "nom_corrige2": "Mélodie Georget",
    "nom_famille": "Georget",
    "titre_genre2": "Conseillère",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "742",
    "allocation2": "0",
    "total": "27599",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1331",
    "nom_corrige2": "Pierre-Étienne Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "19654",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27550",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1332",
    "nom_corrige2": "Lise Boulianne",
    "nom_famille": "Boulianne",
    "titre_genre2": "Mairesse",
    "remuneration": "18724",
    "allocation": "8822",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27546",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "1333",
    "nom_corrige2": "Fernand Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "19598",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27494",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1334",
    "nom_corrige2": "Guy Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseiller",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "134",
    "allocation2": "0",
    "total": "27491",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1335",
    "nom_corrige2": "Olivier Cameron-Chevrier",
    "nom_famille": "Cameron-Chevrier",
    "titre_genre2": "Conseiller",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "83",
    "allocation2": "42",
    "total": "27482",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1336",
    "nom_corrige2": "Yvan Pinsonneault",
    "nom_famille": "Pinsonneault",
    "titre_genre2": "Maire",
    "remuneration": "13900",
    "allocation": "6950",
    "remuneration2": "4398",
    "allocation2": "2199",
    "total": "27447",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "1337",
    "nom_corrige2": "JOSÉE PAQUETTE",
    "nom_famille": "PAQUETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "19212",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27446",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1338",
    "nom_corrige2": "Yvon Pepin",
    "nom_famille": "Pepin",
    "titre_genre2": "Conseiller",
    "remuneration": "18281",
    "allocation": "9140",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27421",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "1339",
    "nom_corrige2": "Rita Jain",
    "nom_famille": "Jain",
    "titre_genre2": "Conseillère",
    "remuneration": "18639",
    "allocation": "8724",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27363",
    "ville": "Chelsea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "8337"
  },
  {
    "ID": "1340",
    "nom_corrige2": "Kim Méthot",
    "nom_famille": "Méthot",
    "titre_genre2": "Conseillère",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27357",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1341",
    "nom_corrige2": "Denis Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseiller",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27357",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1342",
    "nom_corrige2": "Laurie-Line Lallemand-Raymond",
    "nom_famille": "Lallemand-Raymond",
    "titre_genre2": "Conseillère",
    "remuneration": "18238",
    "allocation": "9119",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27357",
    "ville": "Saint-Basile-le-Grand",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "17500"
  },
  {
    "ID": "1343",
    "nom_corrige2": "Françoise Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Mairesse",
    "remuneration": "13710",
    "allocation": "6855",
    "remuneration2": "6740",
    "allocation2": "0",
    "total": "27305",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "1344",
    "nom_corrige2": "Micheline Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Mairesse",
    "remuneration": "17700",
    "allocation": "1136",
    "remuneration2": "5599",
    "allocation2": "2799",
    "total": "27234",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "1345",
    "nom_corrige2": "Loïc Blancquaert",
    "nom_famille": "Blancquaert",
    "titre_genre2": "Conseiller",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "1950",
    "allocation2": "975",
    "total": "27229",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1346",
    "nom_corrige2": "Sylvain Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Maire",
    "remuneration": "18150",
    "allocation": "9075",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "27225",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "1347",
    "nom_corrige2": "Danielle Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Mairesse",
    "remuneration": "10404",
    "allocation": "5202",
    "remuneration2": "8095",
    "allocation2": "3511",
    "total": "27212",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "1348",
    "nom_corrige2": "Steven Larose",
    "nom_famille": "Larose",
    "titre_genre2": "Maire",
    "remuneration": "12511",
    "allocation": "6255",
    "remuneration2": "5529",
    "allocation2": "2870",
    "total": "27165",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "1349",
    "nom_corrige2": "Gaston Donovan",
    "nom_famille": "Donovan",
    "titre_genre2": "Maire",
    "remuneration": "12654",
    "allocation": "6327",
    "remuneration2": "5409",
    "allocation2": "2733",
    "total": "27123",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "1350",
    "nom_corrige2": "Gaston Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Maire",
    "remuneration": "13770",
    "allocation": "7776",
    "remuneration2": "3714",
    "allocation2": "1857",
    "total": "27117",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "1351",
    "nom_corrige2": "Vinciane Peeters",
    "nom_famille": "Peeters",
    "titre_genre2": "Mairesse",
    "remuneration": "15089",
    "allocation": "7544",
    "remuneration2": "3020",
    "allocation2": "1444",
    "total": "27097",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "1352",
    "nom_corrige2": "Raymond Francoeur",
    "nom_famille": "Francoeur",
    "titre_genre2": "Maire",
    "remuneration": "20697",
    "allocation": "4235",
    "remuneration2": "2117",
    "allocation2": "0",
    "total": "27049",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "1353",
    "nom_corrige2": "Marie-Noëlle Bhérer",
    "nom_famille": "Bhérer",
    "titre_genre2": "Mairesse",
    "remuneration": "18797",
    "allocation": "8172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26969",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "1354",
    "nom_corrige2": "Marcel Leboeuf",
    "nom_famille": "Leboeuf",
    "titre_genre2": "Conseiller",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26857",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1355",
    "nom_corrige2": "Gaston Meilleur",
    "nom_famille": "Meilleur",
    "titre_genre2": "Conseiller",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26857",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1356",
    "nom_corrige2": "Claude Rainville",
    "nom_famille": "Rainville",
    "titre_genre2": "Conseiller",
    "remuneration": "17905",
    "allocation": "8952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26857",
    "ville": "Mont-Saint-Hilaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "19415"
  },
  {
    "ID": "1357",
    "nom_corrige2": "Marc-André Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Conseiller",
    "remuneration": "18904",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26800",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1358",
    "nom_corrige2": "Julie Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Mairesse",
    "remuneration": "14550",
    "allocation": "6990",
    "remuneration2": "3493",
    "allocation2": "1746",
    "total": "26779",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "1359",
    "nom_corrige2": "Étienne Urbain",
    "nom_famille": "Urbain",
    "titre_genre2": "Conseiller",
    "remuneration": "18151",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26731",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1360",
    "nom_corrige2": "Joël Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Conseiller",
    "remuneration": "26459",
    "allocation": "13230",
    "remuneration2": "6599",
    "allocation2": "3300",
    "total": "49588",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "1361",
    "nom_corrige2": "Vincent Lanteigne",
    "nom_famille": "Lanteigne",
    "titre_genre2": "Conseiller",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "3176",
    "allocation2": "1333",
    "total": "26691",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1362",
    "nom_corrige2": "Yvon Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Maire",
    "remuneration": "10339",
    "allocation": "5168",
    "remuneration2": "7435",
    "allocation2": "3718",
    "total": "26660",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "1363",
    "nom_corrige2": "Sylvie Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseillère",
    "remuneration": "14637",
    "allocation": "7319",
    "remuneration2": "3133",
    "allocation2": "1566",
    "total": "26655",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1364",
    "nom_corrige2": "Jean Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "11973",
    "allocation": "5986",
    "remuneration2": "6517",
    "allocation2": "2173",
    "total": "26649",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "1365",
    "nom_corrige2": "Jean Kristov Carpentier",
    "nom_famille": "Carpentier",
    "titre_genre2": "Conseiller",
    "remuneration": "17762",
    "allocation": "8881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26643",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1366",
    "nom_corrige2": "Josianne Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseillère",
    "remuneration": "17762",
    "allocation": "8881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26643",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1367",
    "nom_corrige2": "Kimberly St-Denis",
    "nom_famille": "St-Denis",
    "titre_genre2": "Conseillère",
    "remuneration": "17762",
    "allocation": "8881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26643",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1368",
    "nom_corrige2": "Raymond Rougeau",
    "nom_famille": "Rougeau",
    "titre_genre2": "Maire",
    "remuneration": "76578",
    "allocation": "17540",
    "remuneration2": "16706",
    "allocation2": "0",
    "total": "110824",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1369",
    "nom_corrige2": "Raynald Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "17762",
    "allocation": "8881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26643",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1370",
    "nom_corrige2": "Stéphanie Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseillère",
    "remuneration": "22766",
    "allocation": "11383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "34149",
    "ville": "Rawdon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "12393"
  },
  {
    "ID": "1371",
    "nom_corrige2": "Adam Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Maire",
    "remuneration": "14441",
    "allocation": "7221",
    "remuneration2": "3249",
    "allocation2": "1624",
    "total": "26535",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "1372",
    "nom_corrige2": "Marie-Eve Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseillère",
    "remuneration": "17690",
    "allocation": "8845",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26535",
    "ville": "Saint-Amable",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "13587"
  },
  {
    "ID": "1373",
    "nom_corrige2": "CLÉMENT MARCOUX",
    "nom_famille": "MARCOUX",
    "titre_genre2": "Maire",
    "remuneration": "17687",
    "allocation": "8843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26530",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "1374",
    "nom_corrige2": "Caroline Rosetti",
    "nom_famille": "Rosetti",
    "titre_genre2": "Mairesse",
    "remuneration": "12665",
    "allocation": "6332",
    "remuneration2": "4933",
    "allocation2": "2467",
    "total": "26397",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "1375",
    "nom_corrige2": "Vincent Beckert",
    "nom_famille": "Beckert",
    "titre_genre2": "Maire",
    "remuneration": "12656",
    "allocation": "6282",
    "remuneration2": "4972",
    "allocation2": "2486",
    "total": "26396",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "1376",
    "nom_corrige2": "Gilles Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Maire",
    "remuneration": "12970",
    "allocation": "6260",
    "remuneration2": "6142",
    "allocation2": "989",
    "total": "26361",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "1377",
    "nom_corrige2": "Germain Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Maire",
    "remuneration": "14024",
    "allocation": "7013",
    "remuneration2": "3536",
    "allocation2": "1768",
    "total": "26341",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "1378",
    "nom_corrige2": "Daniel Millette",
    "nom_famille": "Millette",
    "titre_genre2": "Conseiller",
    "remuneration": "17752",
    "allocation": "8586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26338",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1379",
    "nom_corrige2": "Louis-Marie Bastille",
    "nom_famille": "Bastille",
    "titre_genre2": "Maire",
    "remuneration": "8712",
    "allocation": "4363",
    "remuneration2": "9179",
    "allocation2": "4080",
    "total": "26334",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "1380",
    "nom_corrige2": "Isabel Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "17722",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26302",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1381",
    "nom_corrige2": "Marie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "17532",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26298",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1382",
    "nom_corrige2": "François Boily",
    "nom_famille": "Boily",
    "titre_genre2": "Conseiller",
    "remuneration": "17532",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26298",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1383",
    "nom_corrige2": "Jacinthe Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "17532",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26298",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1384",
    "nom_corrige2": "Lorne Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseiller",
    "remuneration": "17532",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26298",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1385",
    "nom_corrige2": "Lucie Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseillère",
    "remuneration": "17532",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26298",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1386",
    "nom_corrige2": "Pierre Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "7875",
    "allocation2": "3399",
    "total": "26274",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "1387",
    "nom_corrige2": "RÉAL RYAN",
    "nom_famille": "RYAN",
    "titre_genre2": "Maire",
    "remuneration": "18309",
    "allocation": "7960",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26269",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "1388",
    "nom_corrige2": "MICHEL AUGER",
    "nom_famille": "AUGER",
    "titre_genre2": "Conseiller",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1389",
    "nom_corrige2": "SERGE SIMARD",
    "nom_famille": "SIMARD",
    "titre_genre2": "Conseiller",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1390",
    "nom_corrige2": "NANCY PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseillère",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1391",
    "nom_corrige2": "CHRISTIAN BLOUIN",
    "nom_famille": "BLOUIN",
    "titre_genre2": "Conseiller",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1392",
    "nom_corrige2": "MICHEL BEAUMONT",
    "nom_famille": "BEAUMONT",
    "titre_genre2": "Conseiller",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1393",
    "nom_corrige2": "MICHÈLE ABDELNOUR",
    "nom_famille": "ABDELNOUR",
    "titre_genre2": "Conseillère",
    "remuneration": "17500",
    "allocation": "8750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26250",
    "ville": "Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3935"
  },
  {
    "ID": "1394",
    "nom_corrige2": "ALAIN GIROUX",
    "nom_famille": "GIROUX",
    "titre_genre2": "Conseiller",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "9120",
    "allocation2": "4560",
    "total": "26214",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "1395",
    "nom_corrige2": "Donald Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Maire",
    "remuneration": "17497",
    "allocation": "8714",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26211",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "1396",
    "nom_corrige2": "Dominique Bellemare",
    "nom_famille": "Bellemare",
    "titre_genre2": "Conseiller",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1397",
    "nom_corrige2": "Mario Charette",
    "nom_famille": "Charette",
    "titre_genre2": "Conseiller",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1398",
    "nom_corrige2": "Manon Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseillère",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1399",
    "nom_corrige2": "Francis Laberge",
    "nom_famille": "Laberge",
    "titre_genre2": "Conseiller",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1400",
    "nom_corrige2": "Jocelyne Rajotte",
    "nom_famille": "Rajotte",
    "titre_genre2": "Conseillère",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1401",
    "nom_corrige2": "Alain Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "17466",
    "allocation": "8733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26199",
    "ville": "Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "14412"
  },
  {
    "ID": "1402",
    "nom_corrige2": "Pierre Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Maire",
    "remuneration": "17457",
    "allocation": "8728",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26185",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "1403",
    "nom_corrige2": "Mylène Labre",
    "nom_famille": "Labre",
    "titre_genre2": "Mairesse",
    "remuneration": "12190",
    "allocation": "6095",
    "remuneration2": "5249",
    "allocation2": "2622",
    "total": "26156",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "1404",
    "nom_corrige2": "Christiane Wilson",
    "nom_famille": "Wilson",
    "titre_genre2": "Conseillère",
    "remuneration": "17556",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26136",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1405",
    "nom_corrige2": "Bruno-Pierre Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseiller",
    "remuneration": "17409",
    "allocation": "8705",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26114",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1406",
    "nom_corrige2": "Frédéric Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "17396",
    "allocation": "8698",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26094",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1407",
    "nom_corrige2": "Jean-François Robillard",
    "nom_famille": "Robillard",
    "titre_genre2": "Conseiller",
    "remuneration": "17582",
    "allocation": "8496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26078",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1408",
    "nom_corrige2": "Stéphane Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "17371",
    "allocation": "8686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26057",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "1409",
    "nom_corrige2": "Jean-Yves Boulianne",
    "nom_famille": "Boulianne",
    "titre_genre2": "Conseiller",
    "remuneration": "14637",
    "allocation": "7319",
    "remuneration2": "2728",
    "allocation2": "1364",
    "total": "26048",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1410",
    "nom_corrige2": "Arielle Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseillère",
    "remuneration": "17538",
    "allocation": "8475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "26013",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1411",
    "nom_corrige2": "Patrice Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Maire",
    "remuneration": "11627",
    "allocation": "5813",
    "remuneration2": "5712",
    "allocation2": "2856",
    "total": "26008",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "1412",
    "nom_corrige2": "Mélanie Gobeille",
    "nom_famille": "Gobeille",
    "titre_genre2": "Conseillère",
    "remuneration": "17330",
    "allocation": "8665",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25995",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "1413",
    "nom_corrige2": "Serge Lemyre",
    "nom_famille": "Lemyre",
    "titre_genre2": "Maire",
    "remuneration": "12444",
    "allocation": "6222",
    "remuneration2": "4873",
    "allocation2": "2436",
    "total": "25975",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "1414",
    "nom_corrige2": "Christian Hould",
    "nom_famille": "Hould",
    "titre_genre2": "Conseiller",
    "remuneration": "17308",
    "allocation": "8654",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25962",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "1415",
    "nom_corrige2": "Yves Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "18484",
    "allocation": "7343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25827",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1416",
    "nom_corrige2": "Guy Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Maire",
    "remuneration": "17212",
    "allocation": "8606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25818",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "1417",
    "nom_corrige2": "Stéphanie Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "17180",
    "allocation": "8590",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25770",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1418",
    "nom_corrige2": "Edith Labrosse",
    "nom_famille": "Labrosse",
    "titre_genre2": "Conseillère",
    "remuneration": "17180",
    "allocation": "8590",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25770",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1419",
    "nom_corrige2": "Luc Laforge",
    "nom_famille": "Laforge",
    "titre_genre2": "Conseiller",
    "remuneration": "17180",
    "allocation": "8590",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25770",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1420",
    "nom_corrige2": "Daniel St-Jean",
    "nom_famille": "St-Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "17180",
    "allocation": "8590",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25770",
    "ville": "Carignan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11931"
  },
  {
    "ID": "1421",
    "nom_corrige2": "Roger Chevarie",
    "nom_famille": "Chevarie",
    "titre_genre2": "Conseiller",
    "remuneration": "17746",
    "allocation": "8015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25761",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "1422",
    "nom_corrige2": "Hugues Lafrance",
    "nom_famille": "Lafrance",
    "titre_genre2": "Conseiller",
    "remuneration": "17746",
    "allocation": "8015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25761",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "1423",
    "nom_corrige2": "Richard Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "17746",
    "allocation": "8015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25761",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "1424",
    "nom_corrige2": "Benoît Arseneau",
    "nom_famille": "Arseneau",
    "titre_genre2": "Conseiller",
    "remuneration": "17746",
    "allocation": "8015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25761",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "1425",
    "nom_corrige2": "Sandra Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "17160",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25740",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1426",
    "nom_corrige2": "Valérie Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "17160",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25740",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1427",
    "nom_corrige2": "Ayla Scriven",
    "nom_famille": "Scriven",
    "titre_genre2": "Conseillère",
    "remuneration": "17160",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25740",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1428",
    "nom_corrige2": "Jessica Raby-Beaulieu",
    "nom_famille": "Raby-Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "17160",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25740",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1429",
    "nom_corrige2": "Danielle Deraîche",
    "nom_famille": "Deraîche",
    "titre_genre2": "Conseillère",
    "remuneration": "17160",
    "allocation": "8580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25740",
    "ville": "Saint-Colomban",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "18443"
  },
  {
    "ID": "1430",
    "nom_corrige2": "JENNIFER OUELLETTE",
    "nom_famille": "OUELLETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "19272",
    "allocation": "6449",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25721",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1431",
    "nom_corrige2": "Benjamin Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1432",
    "nom_corrige2": "Maxime Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1433",
    "nom_corrige2": "Èveline Laverdière",
    "nom_famille": "Laverdière",
    "titre_genre2": "Conseillère",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1434",
    "nom_corrige2": "Sylvie Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1435",
    "nom_corrige2": "Martin Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1436",
    "nom_corrige2": "Yvon Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseiller",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1437",
    "nom_corrige2": "Jean St-Jules",
    "nom_famille": "St-Jules",
    "titre_genre2": "Conseiller",
    "remuneration": "17104",
    "allocation": "8552",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25656",
    "ville": "Val-d'Or",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "33032"
  },
  {
    "ID": "1438",
    "nom_corrige2": "Mario Gaumont",
    "nom_famille": "Gaumont",
    "titre_genre2": "Conseiller",
    "remuneration": "18402",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25655",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1439",
    "nom_corrige2": "Dominique Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Mairesse",
    "remuneration": "10873",
    "allocation": "5437",
    "remuneration2": "6224",
    "allocation2": "3112",
    "total": "25646",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "1440",
    "nom_corrige2": "Richard Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "17288",
    "allocation": "8354",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25642",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1441",
    "nom_corrige2": "Rémi Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "5374",
    "allocation2": "2687",
    "total": "25525",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "1442",
    "nom_corrige2": "Michel Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Maire",
    "remuneration": "23879",
    "allocation": "1610",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25489",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "1443",
    "nom_corrige2": "Denis Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Maire",
    "remuneration": "16650",
    "allocation": "8808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25458",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "1444",
    "nom_corrige2": "Alain Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseiller",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1445",
    "nom_corrige2": "Sylvain Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1446",
    "nom_corrige2": "Lysandre St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseillère",
    "remuneration": "31464",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "31464",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1447",
    "nom_corrige2": "Marc Rainville",
    "nom_famille": "Rainville",
    "titre_genre2": "Conseiller",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1448",
    "nom_corrige2": "Michel Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1449",
    "nom_corrige2": "Alain Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseiller",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1450",
    "nom_corrige2": "Carole Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseillère",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1451",
    "nom_corrige2": "Joannie Lajeunesse",
    "nom_famille": "Lajeunesse",
    "titre_genre2": "Conseillère",
    "remuneration": "16923",
    "allocation": "8470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25393",
    "ville": "Baie-Comeau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "20799"
  },
  {
    "ID": "1452",
    "nom_corrige2": "François Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Conseiller",
    "remuneration": "17404",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25300",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1453",
    "nom_corrige2": "Michel Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "17404",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25300",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1454",
    "nom_corrige2": "Pierre Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Maire",
    "remuneration": "9509",
    "allocation": "4755",
    "remuneration2": "7335",
    "allocation2": "3668",
    "total": "25267",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "1455",
    "nom_corrige2": "Pascal Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Maire",
    "remuneration": "14530",
    "allocation": "7282",
    "remuneration2": "2278",
    "allocation2": "1140",
    "total": "25230",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "1456",
    "nom_corrige2": "Alexandre Laganière",
    "nom_famille": "Laganière",
    "titre_genre2": "Conseiller",
    "remuneration": "17007",
    "allocation": "8218",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25225",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1457",
    "nom_corrige2": "Claude Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Maire",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "6560",
    "allocation2": "3751",
    "total": "25194",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "1458",
    "nom_corrige2": "Luc Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Maire",
    "remuneration": "9263",
    "allocation": "4631",
    "remuneration2": "7514",
    "allocation2": "3757",
    "total": "25165",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "1459",
    "nom_corrige2": "Mario Hamilton",
    "nom_famille": "Hamilton",
    "titre_genre2": "Conseiller",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1460",
    "nom_corrige2": "Nelson Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1461",
    "nom_corrige2": "Nelson Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1462",
    "nom_corrige2": "André Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseiller",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1463",
    "nom_corrige2": "Marc Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseiller",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1464",
    "nom_corrige2": "Lucie Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "17328",
    "allocation": "7826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "25154",
    "ville": "Matane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "14000"
  },
  {
    "ID": "1465",
    "nom_corrige2": "Steven Neil",
    "nom_famille": "Neil",
    "titre_genre2": "Maire",
    "remuneration": "10729",
    "allocation": "5365",
    "remuneration2": "5920",
    "allocation2": "2960",
    "total": "24974",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "1466",
    "nom_corrige2": "Robert Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Maire",
    "remuneration": "14160",
    "allocation": "7080",
    "remuneration2": "2467",
    "allocation2": "1233",
    "total": "24940",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "1467",
    "nom_corrige2": "Bernard Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "4392",
    "allocation2": "2196",
    "total": "24886",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1468",
    "nom_corrige2": "Dany Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "4392",
    "allocation2": "2196",
    "total": "24886",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1469",
    "nom_corrige2": "David Huggins-Daines",
    "nom_famille": "Huggins-Daines",
    "titre_genre2": "Conseiller",
    "remuneration": "16742",
    "allocation": "8090",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24832",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1470",
    "nom_corrige2": "Gaëtan Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "16742",
    "allocation": "8090",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24832",
    "ville": "Sainte-Adèle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14856"
  },
  {
    "ID": "1471",
    "nom_corrige2": "Laurent Phoenix",
    "nom_famille": "Phoenix",
    "titre_genre2": "Maire",
    "remuneration": "11416",
    "allocation": "5708",
    "remuneration2": "5120",
    "allocation2": "2560",
    "total": "24804",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "1472",
    "nom_corrige2": "Claude Thibodeau",
    "nom_famille": "Thibodeau",
    "titre_genre2": "Maire",
    "remuneration": "15000",
    "allocation": "7500",
    "remuneration2": "1524",
    "allocation2": "762",
    "total": "24786",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "1473",
    "nom_corrige2": "Marie-France Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseillère",
    "remuneration": "16503",
    "allocation": "8252",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24755",
    "ville": "Cowansville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "16272"
  },
  {
    "ID": "1474",
    "nom_corrige2": "Luc Diotte",
    "nom_famille": "Diotte",
    "titre_genre2": "Maire",
    "remuneration": "13576",
    "allocation": "6788",
    "remuneration2": "2899",
    "allocation2": "1450",
    "total": "24713",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "1475",
    "nom_corrige2": "SERGE DESJARDINS",
    "nom_famille": "DESJARDINS",
    "titre_genre2": "Conseiller",
    "remuneration": "16468",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24702",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1476",
    "nom_corrige2": "SYLVAIN CREVIER",
    "nom_famille": "CREVIER",
    "titre_genre2": "Conseiller",
    "remuneration": "16468",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24702",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1477",
    "nom_corrige2": "LUCIE GAUDREAULT",
    "nom_famille": "GAUDREAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "16468",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24702",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1478",
    "nom_corrige2": "JOE FALCI",
    "nom_famille": "FALCI",
    "titre_genre2": "Conseiller",
    "remuneration": "16468",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24702",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1479",
    "nom_corrige2": "PAULINE LAVOIE-DUBÉ",
    "nom_famille": "LAVOIE-DUBÉ",
    "titre_genre2": "Conseillère",
    "remuneration": "16468",
    "allocation": "8234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24702",
    "ville": "Charlemagne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6357"
  },
  {
    "ID": "1480",
    "nom_corrige2": "Yves Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Maire",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "4433",
    "allocation2": "2267",
    "total": "24700",
    "ville": "Lac-Sergent",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "549"
  },
  {
    "ID": "1481",
    "nom_corrige2": "Annick Corbeil",
    "nom_famille": "Corbeil",
    "titre_genre2": "Mairesse",
    "remuneration": "10840",
    "allocation": "5420",
    "remuneration2": "5613",
    "allocation2": "2806",
    "total": "24679",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "1482",
    "nom_corrige2": "Martin Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Maire",
    "remuneration": "16446",
    "allocation": "8223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24669",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "1483",
    "nom_corrige2": "Terry Lafleur",
    "nom_famille": "Lafleur",
    "titre_genre2": "Maire",
    "remuneration": "13080",
    "allocation": "6540",
    "remuneration2": "3326",
    "allocation2": "1672",
    "total": "24618",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "1484",
    "nom_corrige2": "YVES BOYER",
    "nom_famille": "BOYER",
    "titre_genre2": "Maire",
    "remuneration": "18952",
    "allocation": "5580",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24532",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "1485",
    "nom_corrige2": "Francine Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Mairesse",
    "remuneration": "16296",
    "allocation": "8230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24526",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "1486",
    "nom_corrige2": "Nicole Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseillère",
    "remuneration": "16570",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24466",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1487",
    "nom_corrige2": "Ginette Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Mairesse",
    "remuneration": "12806",
    "allocation": "6403",
    "remuneration2": "3636",
    "allocation2": "1616",
    "total": "24461",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "1488",
    "nom_corrige2": "Annie Mainville",
    "nom_famille": "Mainville",
    "titre_genre2": "Conseillère",
    "remuneration": "16541",
    "allocation": "7896",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24437",
    "ville": "L'Assomption",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "24202"
  },
  {
    "ID": "1489",
    "nom_corrige2": "Claude H Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Maire",
    "remuneration": "11380",
    "allocation": "5690",
    "remuneration2": "5964",
    "allocation2": "1382",
    "total": "24416",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "1490",
    "nom_corrige2": "Francis Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Maire",
    "remuneration": "16272",
    "allocation": "8137",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24409",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "1491",
    "nom_corrige2": "RÉJEAN CARLE",
    "nom_famille": "CARLE",
    "titre_genre2": "Maire",
    "remuneration": "16211",
    "allocation": "8106",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24317",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "1492",
    "nom_corrige2": "Alexandrine Lamoureux-Salvas",
    "nom_famille": "Lamoureux-Salvas",
    "titre_genre2": "Conseillère",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24304",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1493",
    "nom_corrige2": "Liette Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24304",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1494",
    "nom_corrige2": "Virginie Dostie-Toupin",
    "nom_famille": "Dostie-Toupin",
    "titre_genre2": "Conseillère",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24304",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1495",
    "nom_corrige2": "Stéphanie Verreault",
    "nom_famille": "Verreault",
    "titre_genre2": "Conseillère",
    "remuneration": "16203",
    "allocation": "8101",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24304",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "22789"
  },
  {
    "ID": "1496",
    "nom_corrige2": "Stéphane Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Maire",
    "remuneration": "11504",
    "allocation": "5752",
    "remuneration2": "4663",
    "allocation2": "2332",
    "total": "24251",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "1497",
    "nom_corrige2": "Jessika Lacombe",
    "nom_famille": "Lacombe",
    "titre_genre2": "Mairesse",
    "remuneration": "13162",
    "allocation": "6581",
    "remuneration2": "2996",
    "allocation2": "1498",
    "total": "24237",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "1498",
    "nom_corrige2": "Jean-Félipe Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "18439",
    "allocation": "5796",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24235",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1499",
    "nom_corrige2": "Rosaire Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Maire",
    "remuneration": "13432",
    "allocation": "6686",
    "remuneration2": "2918",
    "allocation2": "1159",
    "total": "24195",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "1500",
    "nom_corrige2": "Stéphane Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1501",
    "nom_corrige2": "Stéphanie Felx",
    "nom_famille": "Felx",
    "titre_genre2": "Conseillère",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1502",
    "nom_corrige2": "Tony Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseiller",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1503",
    "nom_corrige2": "Philippe Drolet",
    "nom_famille": "Drolet",
    "titre_genre2": "Conseiller",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1504",
    "nom_corrige2": "Bernard Mallet",
    "nom_famille": "Mallet",
    "titre_genre2": "Conseiller",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1505",
    "nom_corrige2": "Martin Laplaine",
    "nom_famille": "Laplaine",
    "titre_genre2": "Conseiller",
    "remuneration": "16129",
    "allocation": "8064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24193",
    "ville": "Mercier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "15239"
  },
  {
    "ID": "1506",
    "nom_corrige2": "Claude Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "16122",
    "allocation": "8061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24183",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "1507",
    "nom_corrige2": "Daniel Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "16122",
    "allocation": "8061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24183",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "1508",
    "nom_corrige2": "Denis Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Maire",
    "remuneration": "62401",
    "allocation": "17401",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "79802",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "1509",
    "nom_corrige2": "Gilbert Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "16122",
    "allocation": "8061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24183",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "1510",
    "nom_corrige2": "Pierre Alexandre Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "18810",
    "allocation": "9405",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28215",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "1511",
    "nom_corrige2": "SONIA TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseillère",
    "remuneration": "16638",
    "allocation": "7538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24176",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1512",
    "nom_corrige2": "SERGE ALARIE",
    "nom_famille": "ALARIE",
    "titre_genre2": "Conseiller",
    "remuneration": "16638",
    "allocation": "7538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24176",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1513",
    "nom_corrige2": "ALAIN LEFIÈVRE",
    "nom_famille": "LEFIÈVRE",
    "titre_genre2": "Conseiller",
    "remuneration": "16638",
    "allocation": "7538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24176",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1514",
    "nom_corrige2": "BRUNO PLOURDE",
    "nom_famille": "PLOURDE",
    "titre_genre2": "Conseiller",
    "remuneration": "16638",
    "allocation": "7538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24176",
    "ville": "Saint-Hippolyte",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11488"
  },
  {
    "ID": "1515",
    "nom_corrige2": "Martine Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "14885",
    "allocation": "7442",
    "remuneration2": "1217",
    "allocation2": "608",
    "total": "24152",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1516",
    "nom_corrige2": "Johanne Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Mairesse",
    "remuneration": "9000",
    "allocation": "4500",
    "remuneration2": "10567",
    "allocation2": "0",
    "total": "24067",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "1517",
    "nom_corrige2": "Christian David",
    "nom_famille": "David",
    "titre_genre2": "Conseiller",
    "remuneration": "16039",
    "allocation": "8019",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24058",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1518",
    "nom_corrige2": "Virginie Filiatrault",
    "nom_famille": "Filiatrault",
    "titre_genre2": "Conseillère",
    "remuneration": "16039",
    "allocation": "8019",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24058",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1519",
    "nom_corrige2": "Aline Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "16039",
    "allocation": "8019",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24058",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1520",
    "nom_corrige2": "Guylaine Cyr-Desforges",
    "nom_famille": "Cyr-Desforges",
    "titre_genre2": "Conseillère",
    "remuneration": "16039",
    "allocation": "8019",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24058",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1521",
    "nom_corrige2": "Gaetan Larose",
    "nom_famille": "Larose",
    "titre_genre2": "Conseiller",
    "remuneration": "16039",
    "allocation": "8019",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24058",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1522",
    "nom_corrige2": "Tom Arnold",
    "nom_famille": "Arnold",
    "titre_genre2": "Maire",
    "remuneration": "16118",
    "allocation": "7884",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "24002",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "1523",
    "nom_corrige2": "Mario Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "12210",
    "allocation": "6105",
    "remuneration2": "3727",
    "allocation2": "1864",
    "total": "23906",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "1524",
    "nom_corrige2": "Colette Quevillon",
    "nom_famille": "Quevillon",
    "titre_genre2": "Mairesse",
    "remuneration": "15909",
    "allocation": "7955",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23864",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "1525",
    "nom_corrige2": "Robert Bertrand",
    "nom_famille": "Bertrand",
    "titre_genre2": "Maire",
    "remuneration": "15907",
    "allocation": "7953",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23860",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "1526",
    "nom_corrige2": "Chantal Amstad",
    "nom_famille": "Amstad",
    "titre_genre2": "Conseillère",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1527",
    "nom_corrige2": "André Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1528",
    "nom_corrige2": "Steeve Drapeau",
    "nom_famille": "Drapeau",
    "titre_genre2": "Conseiller",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1529",
    "nom_corrige2": "Nelson Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseiller",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1530",
    "nom_corrige2": "Edith Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseillère",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1531",
    "nom_corrige2": "Carl Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "15881",
    "allocation": "7940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23821",
    "ville": "Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "20176"
  },
  {
    "ID": "1532",
    "nom_corrige2": "Gaston Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Conseiller",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "4505",
    "allocation2": "2253",
    "total": "23808",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "1533",
    "nom_corrige2": "Josée Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Mairesse",
    "remuneration": "10457",
    "allocation": "5229",
    "remuneration2": "5602",
    "allocation2": "2490",
    "total": "23778",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "1534",
    "nom_corrige2": "Daniel Campbell",
    "nom_famille": "Campbell",
    "titre_genre2": "Conseiller",
    "remuneration": "16437",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23756",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1535",
    "nom_corrige2": "Nathalie Depeault",
    "nom_famille": "Depeault",
    "titre_genre2": "Conseillère",
    "remuneration": "16437",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23756",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1536",
    "nom_corrige2": "David Vincent",
    "nom_famille": "Vincent",
    "titre_genre2": "Maire",
    "remuneration": "6326",
    "allocation": "3163",
    "remuneration2": "9488",
    "allocation2": "4744",
    "total": "23721",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "1537",
    "nom_corrige2": "François Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Maire",
    "remuneration": "9000",
    "allocation": "4500",
    "remuneration2": "6813",
    "allocation2": "3406",
    "total": "23719",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "1538",
    "nom_corrige2": "PIERRE RENAUD",
    "nom_famille": "RENAUD",
    "titre_genre2": "Maire",
    "remuneration": "10393",
    "allocation": "5197",
    "remuneration2": "5409",
    "allocation2": "2704",
    "total": "23703",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "1539",
    "nom_corrige2": "Johanne Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseillère",
    "remuneration": "15765",
    "allocation": "7882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23647",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "1540",
    "nom_corrige2": "Claudie Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseillère",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "4392",
    "allocation2": "2196",
    "total": "23638",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "1541",
    "nom_corrige2": "Martin Thibert",
    "nom_famille": "Thibert",
    "titre_genre2": "Maire",
    "remuneration": "16046",
    "allocation": "2909",
    "remuneration2": "3110",
    "allocation2": "1561",
    "total": "23626",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "1542",
    "nom_corrige2": "Patrick Lecuyer",
    "nom_famille": "Lecuyer",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1543",
    "nom_corrige2": "Éric Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1544",
    "nom_corrige2": "Jonathan Anderson",
    "nom_famille": "Anderson",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1545",
    "nom_corrige2": "Jean-Pierre Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1546",
    "nom_corrige2": "Yannick Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1547",
    "nom_corrige2": "Paul Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "15999",
    "allocation": "7621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23620",
    "ville": "Saint-Zotique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10001"
  },
  {
    "ID": "1548",
    "nom_corrige2": "Nathalie Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "17104",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23556",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1549",
    "nom_corrige2": "Meggie Ritchie",
    "nom_famille": "Ritchie",
    "titre_genre2": "Conseillère",
    "remuneration": "15697",
    "allocation": "7849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23546",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1550",
    "nom_corrige2": "Raynald Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "15697",
    "allocation": "7849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23546",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1551",
    "nom_corrige2": "Josée Collin",
    "nom_famille": "Collin",
    "titre_genre2": "Conseillère",
    "remuneration": "15697",
    "allocation": "7849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23546",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1552",
    "nom_corrige2": "Pierre-Luc Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "15697",
    "allocation": "7849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23546",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1553",
    "nom_corrige2": "Gaétan Deraiche",
    "nom_famille": "Deraiche",
    "titre_genre2": "Conseiller",
    "remuneration": "15697",
    "allocation": "7849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23546",
    "ville": "Chandler",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "7405"
  },
  {
    "ID": "1554",
    "nom_corrige2": "Guy Jubinville",
    "nom_famille": "Jubinville",
    "titre_genre2": "Conseiller",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "900",
    "allocation2": "0",
    "total": "23499",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1555",
    "nom_corrige2": "Gilbert Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Maire",
    "remuneration": "11366",
    "allocation": "5425",
    "remuneration2": "4462",
    "allocation2": "2231",
    "total": "23484",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "1556",
    "nom_corrige2": "Dominic Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "14610",
    "allocation": "8766",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23376",
    "ville": "Lac-Beauport",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8372"
  },
  {
    "ID": "1557",
    "nom_corrige2": "Robert (Bob) Lesage",
    "nom_famille": "Lesage",
    "titre_genre2": "Conseiller",
    "remuneration": "29927",
    "allocation": "13819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43746",
    "ville": "Dorval",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "19993"
  },
  {
    "ID": "1558",
    "nom_corrige2": "Sylvain Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "17389",
    "allocation": "5796",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23185",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1559",
    "nom_corrige2": "Stephane Garneau",
    "nom_famille": "Garneau",
    "titre_genre2": "Maire",
    "remuneration": "14051",
    "allocation": "7025",
    "remuneration2": "1392",
    "allocation2": "696",
    "total": "23164",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "1560",
    "nom_corrige2": "Gervais Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Maire",
    "remuneration": "8014",
    "allocation": "3927",
    "remuneration2": "7475",
    "allocation2": "3738",
    "total": "23154",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "1561",
    "nom_corrige2": "Richard Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "15536",
    "allocation": "7569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23105",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1562",
    "nom_corrige2": "Guy Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Maire",
    "remuneration": "7231",
    "allocation": "3616",
    "remuneration2": "8161",
    "allocation2": "4081",
    "total": "23089",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "1563",
    "nom_corrige2": "Thomas Lavallee",
    "nom_famille": "Lavallee",
    "titre_genre2": "Conseiller",
    "remuneration": "15393",
    "allocation": "7696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "23089",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1564",
    "nom_corrige2": "Stéphane Beauchemin",
    "nom_famille": "Beauchemin",
    "titre_genre2": "Maire",
    "remuneration": "13286",
    "allocation": "6136",
    "remuneration2": "2414",
    "allocation2": "1207",
    "total": "23043",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "1565",
    "nom_corrige2": "Hugette Larose",
    "nom_famille": "Larose",
    "titre_genre2": "Conseillère",
    "remuneration": "13424",
    "allocation": "6712",
    "remuneration2": "1936",
    "allocation2": "926",
    "total": "22998",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "1566",
    "nom_corrige2": "Denis Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Maire",
    "remuneration": "6556",
    "allocation": "3278",
    "remuneration2": "8861",
    "allocation2": "4282",
    "total": "22977",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "1567",
    "nom_corrige2": "Louis Coutu",
    "nom_famille": "Coutu",
    "titre_genre2": "Maire",
    "remuneration": "8479",
    "allocation": "4374",
    "remuneration2": "6730",
    "allocation2": "3365",
    "total": "22948",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "1568",
    "nom_corrige2": "GÉRARD VANDAL",
    "nom_famille": "VANDAL",
    "titre_genre2": "Maire",
    "remuneration": "10043",
    "allocation": "5018",
    "remuneration2": "5252",
    "allocation2": "2626",
    "total": "22939",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "1569",
    "nom_corrige2": "Gilles Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "15661",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22914",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1570",
    "nom_corrige2": "Joan Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseillère",
    "remuneration": "15422",
    "allocation": "7470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22892",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "1571",
    "nom_corrige2": "Rolland Camiré",
    "nom_famille": "Camiré",
    "titre_genre2": "Maire",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "3252",
    "allocation2": "1626",
    "total": "22878",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "1572",
    "nom_corrige2": "Louis-George Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Maire",
    "remuneration": "12085",
    "allocation": "6042",
    "remuneration2": "3568",
    "allocation2": "1159",
    "total": "22854",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "1573",
    "nom_corrige2": "Jacques Dostie",
    "nom_famille": "Dostie",
    "titre_genre2": "Conseiller",
    "remuneration": "15535",
    "allocation": "7318",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22853",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1574",
    "nom_corrige2": "Réal Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Maire",
    "remuneration": "15738",
    "allocation": "4239",
    "remuneration2": "1905",
    "allocation2": "953",
    "total": "22835",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "1575",
    "nom_corrige2": "Pascal Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Maire",
    "remuneration": "15218",
    "allocation": "7612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22830",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "1576",
    "nom_corrige2": "Nancy Lehoux",
    "nom_famille": "Lehoux",
    "titre_genre2": "Mairesse",
    "remuneration": "12140",
    "allocation": "6070",
    "remuneration2": "3048",
    "allocation2": "1524",
    "total": "22782",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "1577",
    "nom_corrige2": "René Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "15485",
    "allocation": "7293",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22778",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1578",
    "nom_corrige2": "Linda Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Maire",
    "remuneration": "7142",
    "allocation": "3571",
    "remuneration2": "8039",
    "allocation2": "4020",
    "total": "22772",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "1579",
    "nom_corrige2": "Normand Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "15649",
    "allocation": "7097",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22746",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "1580",
    "nom_corrige2": "Denis Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Maire",
    "remuneration": "12486",
    "allocation": "6242",
    "remuneration2": "2678",
    "allocation2": "1339",
    "total": "22745",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "1581",
    "nom_corrige2": "Huguette Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseillère",
    "remuneration": "15385",
    "allocation": "7293",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22678",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1582",
    "nom_corrige2": "Daniel Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Maire",
    "remuneration": "11421",
    "allocation": "5710",
    "remuneration2": "3675",
    "allocation2": "1837",
    "total": "22643",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "1583",
    "nom_corrige2": "France Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseillère",
    "remuneration": "14638",
    "allocation": "7319",
    "remuneration2": "432",
    "allocation2": "216",
    "total": "22605",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "1584",
    "nom_corrige2": "Guylaine Blouin",
    "nom_famille": "Blouin",
    "titre_genre2": "Conseillère",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22599",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1585",
    "nom_corrige2": "Sylviane Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseillère",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22599",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1586",
    "nom_corrige2": "Vincent Brochu",
    "nom_famille": "Brochu",
    "titre_genre2": "Conseiller",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22599",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1587",
    "nom_corrige2": "Gaétan Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseiller",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22599",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1588",
    "nom_corrige2": "Denis Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "15066",
    "allocation": "7533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22599",
    "ville": "Coaticook",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "9008"
  },
  {
    "ID": "1589",
    "nom_corrige2": "Johanne Delage",
    "nom_famille": "Delage",
    "titre_genre2": "Mairesse",
    "remuneration": "11540",
    "allocation": "5770",
    "remuneration2": "3489",
    "allocation2": "1745",
    "total": "22544",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "1590",
    "nom_corrige2": "Daniel Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "15016",
    "allocation": "7508",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22524",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "1591",
    "nom_corrige2": "Nicolas Pentassuglia",
    "nom_famille": "Pentassuglia",
    "titre_genre2": "Maire",
    "remuneration": "15013",
    "allocation": "7507",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22520",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "1592",
    "nom_corrige2": "Simon Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "12071",
    "allocation": "6036",
    "remuneration2": "2970",
    "allocation2": "1421",
    "total": "22498",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "1593",
    "nom_corrige2": "Derek Dagenais-Guy",
    "nom_famille": "Dagenais-Guy",
    "titre_genre2": "Conseiller",
    "remuneration": "15672",
    "allocation": "6786",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22458",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1594",
    "nom_corrige2": "Marguerite Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Mairesse",
    "remuneration": "7590",
    "allocation": "3795",
    "remuneration2": "7374",
    "allocation2": "3686",
    "total": "22445",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "1595",
    "nom_corrige2": "Robert Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Maire",
    "remuneration": "14952",
    "allocation": "7476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22428",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "1596",
    "nom_corrige2": "Lynne Colquhoun",
    "nom_famille": "Colquhoun",
    "titre_genre2": "Conseillère",
    "remuneration": "14885",
    "allocation": "7442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22327",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1597",
    "nom_corrige2": "Vincent Guillot",
    "nom_famille": "Guillot",
    "titre_genre2": "Conseiller",
    "remuneration": "14885",
    "allocation": "7442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22327",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1598",
    "nom_corrige2": "Jean-François Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "14885",
    "allocation": "7442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22327",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1599",
    "nom_corrige2": "Marie-Pierre Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseillère",
    "remuneration": "14885",
    "allocation": "7442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22327",
    "ville": "Boischatel",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8957"
  },
  {
    "ID": "1600",
    "nom_corrige2": "Éric Bourdeau",
    "nom_famille": "Bourdeau",
    "titre_genre2": "Conseiller",
    "remuneration": "14874",
    "allocation": "7437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22311",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1601",
    "nom_corrige2": "Pierre Lépicier",
    "nom_famille": "Lépicier",
    "titre_genre2": "Conseiller",
    "remuneration": "15832",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22290",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1602",
    "nom_corrige2": "Claude Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Maire",
    "remuneration": "14909",
    "allocation": "7355",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22264",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "1603",
    "nom_corrige2": "Danielle Beaupré",
    "nom_famille": "Beaupré",
    "titre_genre2": "Conseillère",
    "remuneration": "15005",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22258",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1604",
    "nom_corrige2": "Raynald Duguay",
    "nom_famille": "Duguay",
    "titre_genre2": "Conseiller",
    "remuneration": "15005",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22258",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1605",
    "nom_corrige2": "Suzanne Rhéaume",
    "nom_famille": "Rhéaume",
    "titre_genre2": "Mairesse",
    "remuneration": "14830",
    "allocation": "7415",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22245",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "1606",
    "nom_corrige2": "Michaël Vangansbeck",
    "nom_famille": "Vangansbeck",
    "titre_genre2": "Conseiller",
    "remuneration": "14791",
    "allocation": "7395",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22186",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "1607",
    "nom_corrige2": "Alexandre Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "14791",
    "allocation": "7395",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22186",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "1608",
    "nom_corrige2": "Alain Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22182",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1609",
    "nom_corrige2": "Nancy Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseillère",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22182",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1610",
    "nom_corrige2": "Sylvie Messier",
    "nom_famille": "Messier",
    "titre_genre2": "Conseillère",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22182",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1611",
    "nom_corrige2": "Émilie St-Onge",
    "nom_famille": "St-Onge",
    "titre_genre2": "Conseillère",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22182",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1612",
    "nom_corrige2": "Gabrielle Garand",
    "nom_famille": "Garand",
    "titre_genre2": "Conseillère",
    "remuneration": "14788",
    "allocation": "7394",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22182",
    "ville": "Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7972"
  },
  {
    "ID": "1613",
    "nom_corrige2": "Daniel Camiré",
    "nom_famille": "Camiré",
    "titre_genre2": "Conseiller",
    "remuneration": "14922",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22175",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1614",
    "nom_corrige2": "Jean-Claude Malenfant",
    "nom_famille": "Malenfant",
    "titre_genre2": "Maire",
    "remuneration": "12496",
    "allocation": "6248",
    "remuneration2": "2282",
    "allocation2": "1141",
    "total": "22167",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "1615",
    "nom_corrige2": "Vincent Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Maire",
    "remuneration": "13377",
    "allocation": "6689",
    "remuneration2": "1334",
    "allocation2": "667",
    "total": "22067",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "1616",
    "nom_corrige2": "Robert Auclair",
    "nom_famille": "Auclair",
    "titre_genre2": "Conseiller",
    "remuneration": "14891",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22064",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1617",
    "nom_corrige2": "Pierre Brien",
    "nom_famille": "Brien",
    "titre_genre2": "Conseiller",
    "remuneration": "14891",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22064",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1618",
    "nom_corrige2": "André Rainville",
    "nom_famille": "Rainville",
    "titre_genre2": "Conseiller",
    "remuneration": "14873",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "22046",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1619",
    "nom_corrige2": "Patrick Péloquin",
    "nom_famille": "Péloquin",
    "titre_genre2": "Conseiller",
    "remuneration": "36913",
    "allocation": "14165",
    "remuneration2": "697",
    "allocation2": "348",
    "total": "52123",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "1620",
    "nom_corrige2": "GUY-JULIEN MAYNÉ",
    "nom_famille": "MAYNÉ",
    "titre_genre2": "Maire",
    "remuneration": "14651",
    "allocation": "7326",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21977",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "1621",
    "nom_corrige2": "Patricia Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Mairesse",
    "remuneration": "12119",
    "allocation": "6059",
    "remuneration2": "2479",
    "allocation2": "1319",
    "total": "21976",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "1622",
    "nom_corrige2": "Carolyne Aubin",
    "nom_famille": "Aubin",
    "titre_genre2": "Conseillère",
    "remuneration": "14638",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21957",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "1623",
    "nom_corrige2": "Chantal McMahon",
    "nom_famille": "McMahon",
    "titre_genre2": "Conseillère",
    "remuneration": "14638",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21957",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "1624",
    "nom_corrige2": "Dominic Massé",
    "nom_famille": "Massé",
    "titre_genre2": "Conseiller",
    "remuneration": "14638",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21957",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "1625",
    "nom_corrige2": "Denis Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseiller",
    "remuneration": "14638",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21957",
    "ville": "Nicolet",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "8510"
  },
  {
    "ID": "1626",
    "nom_corrige2": "Claude Benjamin",
    "nom_famille": "Benjamin",
    "titre_genre2": "Conseiller",
    "remuneration": "14637",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21956",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1627",
    "nom_corrige2": "Olivier Surprenant",
    "nom_famille": "Surprenant",
    "titre_genre2": "Conseiller",
    "remuneration": "14637",
    "allocation": "7319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21956",
    "ville": "Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "10889"
  },
  {
    "ID": "1628",
    "nom_corrige2": "Myriam Cabana",
    "nom_famille": "Cabana",
    "titre_genre2": "Mairesse",
    "remuneration": "9156",
    "allocation": "4578",
    "remuneration2": "5475",
    "allocation2": "2738",
    "total": "21947",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "1629",
    "nom_corrige2": "Jacques David",
    "nom_famille": "David",
    "titre_genre2": "Maire",
    "remuneration": "10805",
    "allocation": "5403",
    "remuneration2": "3806",
    "allocation2": "1903",
    "total": "21917",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "1630",
    "nom_corrige2": "Denis Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "14585",
    "allocation": "7293",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21878",
    "ville": "Lac-Mégantic",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5646"
  },
  {
    "ID": "1631",
    "nom_corrige2": "Donald Rheault",
    "nom_famille": "Rheault",
    "titre_genre2": "Maire",
    "remuneration": "14578",
    "allocation": "7289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21867",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "1632",
    "nom_corrige2": "Mélanie Malouin",
    "nom_famille": "Malouin",
    "titre_genre2": "Conseillère",
    "remuneration": "14666",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21839",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1633",
    "nom_corrige2": "Camil Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Maire",
    "remuneration": "10249",
    "allocation": "3250",
    "remuneration2": "1373",
    "allocation2": "6886",
    "total": "21758",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "1634",
    "nom_corrige2": "Roger Vignola",
    "nom_famille": "Vignola",
    "titre_genre2": "Conseiller",
    "remuneration": "14505",
    "allocation": "7253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21758",
    "ville": "Port-Cartier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "6498"
  },
  {
    "ID": "1635",
    "nom_corrige2": "Louise Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "14566",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21739",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1636",
    "nom_corrige2": "MARIO LEBLANC",
    "nom_famille": "LEBLANC",
    "titre_genre2": "Maire",
    "remuneration": "14472",
    "allocation": "7236",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21708",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "1637",
    "nom_corrige2": "Hugo Guénette",
    "nom_famille": "Guénette",
    "titre_genre2": "Conseiller",
    "remuneration": "14817",
    "allocation": "6888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21705",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "1638",
    "nom_corrige2": "Marc Gaudreau",
    "nom_famille": "Gaudreau",
    "titre_genre2": "Conseiller",
    "remuneration": "14452",
    "allocation": "7226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21678",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "1639",
    "nom_corrige2": "Nathalie Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseillère",
    "remuneration": "14445",
    "allocation": "7222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21667",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1640",
    "nom_corrige2": "Michel Brière",
    "nom_famille": "Brière",
    "titre_genre2": "Conseiller",
    "remuneration": "14445",
    "allocation": "7222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21667",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1641",
    "nom_corrige2": "Denis Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Maire",
    "remuneration": "11010",
    "allocation": "5505",
    "remuneration2": "3430",
    "allocation2": "1715",
    "total": "21660",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "1642",
    "nom_corrige2": "Laval Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Maire",
    "remuneration": "8981",
    "allocation": "4491",
    "remuneration2": "5452",
    "allocation2": "2726",
    "total": "21650",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "1643",
    "nom_corrige2": "Léo-Paul Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Maire",
    "remuneration": "10902",
    "allocation": "5451",
    "remuneration2": "4570",
    "allocation2": "712",
    "total": "21635",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "1644",
    "nom_corrige2": "Jocelyn Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Maire",
    "remuneration": "10050",
    "allocation": "5025",
    "remuneration2": "4345",
    "allocation2": "2173",
    "total": "21593",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "1645",
    "nom_corrige2": "Raymond Bureau",
    "nom_famille": "Bureau",
    "titre_genre2": "Conseiller",
    "remuneration": "14393",
    "allocation": "7196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21589",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1646",
    "nom_corrige2": "Maureen Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "14393",
    "allocation": "7196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21589",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1647",
    "nom_corrige2": "Dorothy Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseillère",
    "remuneration": "14393",
    "allocation": "7196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21589",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1648",
    "nom_corrige2": "David Hogan",
    "nom_famille": "Hogan",
    "titre_genre2": "Conseiller",
    "remuneration": "14393",
    "allocation": "7196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21589",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1649",
    "nom_corrige2": "Shelley MacDougall",
    "nom_famille": "MacDougall",
    "titre_genre2": "Conseillère",
    "remuneration": "14393",
    "allocation": "7196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21589",
    "ville": "Saint-Gabriel-de-Valcartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3767"
  },
  {
    "ID": "1650",
    "nom_corrige2": "Philippe Gasse",
    "nom_famille": "Gasse",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "160",
    "allocation2": "80",
    "total": "21579",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1651",
    "nom_corrige2": "Lise Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Mairesse",
    "remuneration": "9291",
    "allocation": "4444",
    "remuneration2": "4631",
    "allocation2": "3171",
    "total": "21537",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "1652",
    "nom_corrige2": "Yves Boissonneault",
    "nom_famille": "Boissonneault",
    "titre_genre2": "Maire",
    "remuneration": "10670",
    "allocation": "3292",
    "remuneration2": "5039",
    "allocation2": "2520",
    "total": "21521",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "1653",
    "nom_corrige2": "Rémi Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "14347",
    "allocation": "7173",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21520",
    "ville": "Waterloo",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5318"
  },
  {
    "ID": "1654",
    "nom_corrige2": "Vanessa Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Mairesse",
    "remuneration": "12682",
    "allocation": "6341",
    "remuneration2": "1662",
    "allocation2": "831",
    "total": "21516",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "1655",
    "nom_corrige2": "Gilles Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Maire",
    "remuneration": "11961",
    "allocation": "5981",
    "remuneration2": "3539",
    "allocation2": "0",
    "total": "21481",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "1656",
    "nom_corrige2": "Michel Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Maire",
    "remuneration": "14265",
    "allocation": "7132",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21397",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "1657",
    "nom_corrige2": "Jean Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Maire",
    "remuneration": "10270",
    "allocation": "5135",
    "remuneration2": "3990",
    "allocation2": "1995",
    "total": "21390",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "1658",
    "nom_corrige2": "Natacha Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseillère",
    "remuneration": "12275",
    "allocation": "6138",
    "remuneration2": "2552",
    "allocation2": "425",
    "total": "21390",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "1659",
    "nom_corrige2": "ESTELLE MUZZI",
    "nom_famille": "MUZZI",
    "titre_genre2": "Mairesse",
    "remuneration": "14258",
    "allocation": "7129",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21387",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "1660",
    "nom_corrige2": "Raynald Houde",
    "nom_famille": "Houde",
    "titre_genre2": "Conseiller",
    "remuneration": "14230",
    "allocation": "7115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21345",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1661",
    "nom_corrige2": "Sylvain Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseiller",
    "remuneration": "14230",
    "allocation": "7115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21345",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1662",
    "nom_corrige2": "Nathalie Laprade",
    "nom_famille": "Laprade",
    "titre_genre2": "Conseillère",
    "remuneration": "14230",
    "allocation": "7115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21345",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1663",
    "nom_corrige2": "Josée Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseillère",
    "remuneration": "14230",
    "allocation": "7115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21345",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1664",
    "nom_corrige2": "Martin Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Conseiller",
    "remuneration": "14230",
    "allocation": "7115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21345",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1665",
    "nom_corrige2": "Claude Renaud",
    "nom_famille": "Renaud",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21339",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1666",
    "nom_corrige2": "Fernand Lirette",
    "nom_famille": "Lirette",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21339",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1667",
    "nom_corrige2": "Benoit Voyer",
    "nom_famille": "Voyer",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21339",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1668",
    "nom_corrige2": "Pierre Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21339",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1669",
    "nom_corrige2": "Yvan Barrette",
    "nom_famille": "Barrette",
    "titre_genre2": "Conseiller",
    "remuneration": "14226",
    "allocation": "7113",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21339",
    "ville": "Saint-Raymond",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "11388"
  },
  {
    "ID": "1670",
    "nom_corrige2": "Harold Poisson",
    "nom_famille": "Poisson",
    "titre_genre2": "Maire",
    "remuneration": "10911",
    "allocation": "5456",
    "remuneration2": "3303",
    "allocation2": "1651",
    "total": "21321",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "1671",
    "nom_corrige2": "Jeam-Marc Chevalier",
    "nom_famille": "Chevalier",
    "titre_genre2": "Maire",
    "remuneration": "8754",
    "allocation": "4377",
    "remuneration2": "5442",
    "allocation2": "2721",
    "total": "21294",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "1672",
    "nom_corrige2": "Laurier Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "2439",
    "allocation2": "1220",
    "total": "21248",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1673",
    "nom_corrige2": "Mathieu Bisson",
    "nom_famille": "Bisson",
    "titre_genre2": "Conseiller",
    "remuneration": "14161",
    "allocation": "7080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21241",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1674",
    "nom_corrige2": "François Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "14161",
    "allocation": "7080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21241",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1675",
    "nom_corrige2": "Richard Kirouac",
    "nom_famille": "Kirouac",
    "titre_genre2": "Maire",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "8194",
    "allocation2": "4097",
    "total": "21210",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "1676",
    "nom_corrige2": "Serge Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Maire",
    "remuneration": "9759",
    "allocation": "4880",
    "remuneration2": "4345",
    "allocation2": "2172",
    "total": "21156",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "1677",
    "nom_corrige2": "Pierre Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1678",
    "nom_corrige2": "Claude Bérard",
    "nom_famille": "Bérard",
    "titre_genre2": "Conseiller",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1679",
    "nom_corrige2": "Maggy Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseillère",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1680",
    "nom_corrige2": "Claude Dansereau",
    "nom_famille": "Dansereau",
    "titre_genre2": "Conseiller",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1681",
    "nom_corrige2": "Karine Messier",
    "nom_famille": "Messier",
    "titre_genre2": "Conseillère",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1682",
    "nom_corrige2": "Pierre-Olivier Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "14100",
    "allocation": "7050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21150",
    "ville": "Contrecoeur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "10174"
  },
  {
    "ID": "1683",
    "nom_corrige2": "Jean-Louis Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Maire",
    "remuneration": "10427",
    "allocation": "5213",
    "remuneration2": "3663",
    "allocation2": "1842",
    "total": "21145",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "1684",
    "nom_corrige2": "Sébastien Renaud",
    "nom_famille": "Renaud",
    "titre_genre2": "Conseiller",
    "remuneration": "14095",
    "allocation": "7048",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21143",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1685",
    "nom_corrige2": "Dominic Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "14084",
    "allocation": "7042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21126",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "1686",
    "nom_corrige2": "Charles Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseiller",
    "remuneration": "14084",
    "allocation": "7042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21126",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "1687",
    "nom_corrige2": "Guillaume Plamondon",
    "nom_famille": "Plamondon",
    "titre_genre2": "Conseiller",
    "remuneration": "14084",
    "allocation": "7042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21126",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "1688",
    "nom_corrige2": "Marc Simoneau",
    "nom_famille": "Simoneau",
    "titre_genre2": "Maire",
    "remuneration": "8880",
    "allocation": "4460",
    "remuneration2": "5188",
    "allocation2": "2594",
    "total": "21122",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "1689",
    "nom_corrige2": "Lucie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Mairesse",
    "remuneration": "8500",
    "allocation": "3750",
    "remuneration2": "5892",
    "allocation2": "2956",
    "total": "21098",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "1690",
    "nom_corrige2": "RÉJEAN LAGACÉ",
    "nom_famille": "LAGACÉ",
    "titre_genre2": "Maire",
    "remuneration": "13982",
    "allocation": "7070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21052",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "1691",
    "nom_corrige2": "Guylaine Aubin",
    "nom_famille": "Aubin",
    "titre_genre2": "Mairesse",
    "remuneration": "10937",
    "allocation": "5470",
    "remuneration2": "3095",
    "allocation2": "1547",
    "total": "21049",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "1692",
    "nom_corrige2": "LUC LALONDE",
    "nom_famille": "LALONDE",
    "titre_genre2": "Maire",
    "remuneration": "14171",
    "allocation": "6846",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "21017",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "1693",
    "nom_corrige2": "Christian Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Maire",
    "remuneration": "8574",
    "allocation": "4287",
    "remuneration2": "5417",
    "allocation2": "2708",
    "total": "20986",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "1694",
    "nom_corrige2": "Marcel Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Maire",
    "remuneration": "12375",
    "allocation": "6000",
    "remuneration2": "1715",
    "allocation2": "857",
    "total": "20947",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "1695",
    "nom_corrige2": "Line Légaré",
    "nom_famille": "Légaré",
    "titre_genre2": "Conseillère",
    "remuneration": "14152",
    "allocation": "6786",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20938",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1696",
    "nom_corrige2": "Eugénie Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseillère",
    "remuneration": "14152",
    "allocation": "6786",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20938",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1697",
    "nom_corrige2": "Bryan Dunaj",
    "nom_famille": "Dunaj",
    "titre_genre2": "Conseiller",
    "remuneration": "14152",
    "allocation": "6786",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20938",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1698",
    "nom_corrige2": "Meighen Vaillancourt-Campeau",
    "nom_famille": "Vaillancourt-Campeau",
    "titre_genre2": "Conseillère",
    "remuneration": "14152",
    "allocation": "6786",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20938",
    "ville": "Saint-Adolphe-d'Howard",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3880"
  },
  {
    "ID": "1699",
    "nom_corrige2": "Darling Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "13950",
    "allocation": "6975",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20925",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1700",
    "nom_corrige2": "Andréa Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Mairesse",
    "remuneration": "12614",
    "allocation": "6336",
    "remuneration2": "1287",
    "allocation2": "644",
    "total": "20881",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "1701",
    "nom_corrige2": "Keven Ouellet Lévesque",
    "nom_famille": "Ouellet",
    "titre_genre2": "Maire",
    "remuneration": "8820",
    "allocation": "4219",
    "remuneration2": "6433",
    "allocation2": "1364",
    "total": "20836",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "1702",
    "nom_corrige2": "Guy Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "13877",
    "allocation": "6938",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20815",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1703",
    "nom_corrige2": "Lina Moisan",
    "nom_famille": "Moisan",
    "titre_genre2": "Conseillère",
    "remuneration": "13877",
    "allocation": "6938",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20815",
    "ville": "Pont-Rouge",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "10869"
  },
  {
    "ID": "1704",
    "nom_corrige2": "Johanne Joannette",
    "nom_famille": "Joannette",
    "titre_genre2": "Conseillère",
    "remuneration": "15270",
    "allocation": "5529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20799",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1705",
    "nom_corrige2": "Raymond Bisaillon",
    "nom_famille": "Bisaillon",
    "titre_genre2": "Conseiller",
    "remuneration": "15270",
    "allocation": "5529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20799",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1706",
    "nom_corrige2": "Christyan Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Maire",
    "remuneration": "13867",
    "allocation": "6920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20787",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "1707",
    "nom_corrige2": "Martin Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "15577",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20769",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1708",
    "nom_corrige2": "Valérie Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseillère",
    "remuneration": "15577",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20769",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1709",
    "nom_corrige2": "Marc Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "15577",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20769",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1710",
    "nom_corrige2": "Christine Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Conseillère",
    "remuneration": "15577",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20769",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6742"
  },
  {
    "ID": "1711",
    "nom_corrige2": "YVAN CHAREST",
    "nom_famille": "CHAREST",
    "titre_genre2": "Maire",
    "remuneration": "9899",
    "allocation": "4949",
    "remuneration2": "3921",
    "allocation2": "1960",
    "total": "20729",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "1712",
    "nom_corrige2": "Ève Darmana",
    "nom_famille": "Darmana",
    "titre_genre2": "Conseillère",
    "remuneration": "13800",
    "allocation": "6900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20700",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1713",
    "nom_corrige2": "Carl Marcoux",
    "nom_famille": "Marcoux",
    "titre_genre2": "Maire",
    "remuneration": "11316",
    "allocation": "5658",
    "remuneration2": "2479",
    "allocation2": "1239",
    "total": "20692",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "1714",
    "nom_corrige2": "Donald Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Maire",
    "remuneration": "7378",
    "allocation": "3689",
    "remuneration2": "6414",
    "allocation2": "3207",
    "total": "20688",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "1715",
    "nom_corrige2": "Claude Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "13730",
    "allocation": "6865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20595",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1716",
    "nom_corrige2": "Nicole Boilard",
    "nom_famille": "Boilard",
    "titre_genre2": "Conseillère",
    "remuneration": "13730",
    "allocation": "6865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20595",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1717",
    "nom_corrige2": "Eddy Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "13730",
    "allocation": "6865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20595",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1718",
    "nom_corrige2": "Steve Rouleau",
    "nom_famille": "Rouleau",
    "titre_genre2": "Conseiller",
    "remuneration": "13730",
    "allocation": "6865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20595",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1719",
    "nom_corrige2": "Marco Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "13730",
    "allocation": "6865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20595",
    "ville": "Sainte-Marie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "13550"
  },
  {
    "ID": "1720",
    "nom_corrige2": "Helene Daneau",
    "nom_famille": "Daneau",
    "titre_genre2": "Mairesse",
    "remuneration": "11087",
    "allocation": "5543",
    "remuneration2": "2631",
    "allocation2": "1315",
    "total": "20576",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "1721",
    "nom_corrige2": "Steve Lanciaux",
    "nom_famille": "Lanciaux",
    "titre_genre2": "Maire",
    "remuneration": "9109",
    "allocation": "4555",
    "remuneration2": "6900",
    "allocation2": "0",
    "total": "20564",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "1722",
    "nom_corrige2": "Richard Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "13164",
    "allocation": "6582",
    "remuneration2": "508",
    "allocation2": "254",
    "total": "20508",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "1723",
    "nom_corrige2": "Jean Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Maire",
    "remuneration": "11282",
    "allocation": "5641",
    "remuneration2": "2383",
    "allocation2": "1192",
    "total": "20498",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "1724",
    "nom_corrige2": "James Johnston",
    "nom_famille": "Johnston",
    "titre_genre2": "Maire",
    "remuneration": "10852",
    "allocation": "5426",
    "remuneration2": "2809",
    "allocation2": "1405",
    "total": "20492",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "1725",
    "nom_corrige2": "Jean-Maurice Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Maire",
    "remuneration": "13635",
    "allocation": "6815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20450",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "1726",
    "nom_corrige2": "Gray Forster",
    "nom_famille": "Forster",
    "titre_genre2": "Maire",
    "remuneration": "10889",
    "allocation": "5445",
    "remuneration2": "2704",
    "allocation2": "1362",
    "total": "20400",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "1727",
    "nom_corrige2": "Lucie Dagenais",
    "nom_famille": "Dagenais",
    "titre_genre2": "Mairesse",
    "remuneration": "13592",
    "allocation": "6796",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20388",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "1728",
    "nom_corrige2": "Marc-Antoine Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "12847",
    "allocation": "6423",
    "remuneration2": "744",
    "allocation2": "372",
    "total": "20386",
    "ville": "Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8769"
  },
  {
    "ID": "1729",
    "nom_corrige2": "Patrice Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Maire",
    "remuneration": "8734",
    "allocation": "4367",
    "remuneration2": "4826",
    "allocation2": "2413",
    "total": "20340",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "1730",
    "nom_corrige2": "Véronique Stock",
    "nom_famille": "Stock",
    "titre_genre2": "Mairesse",
    "remuneration": "11332",
    "allocation": "5666",
    "remuneration2": "2206",
    "allocation2": "1055",
    "total": "20259",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "1731",
    "nom_corrige2": "Céline Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "13500",
    "allocation": "6750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20250",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1732",
    "nom_corrige2": "Sylvie Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseillère",
    "remuneration": "12384",
    "allocation": "6192",
    "remuneration2": "1112",
    "allocation2": "556",
    "total": "20244",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1733",
    "nom_corrige2": "Johnny Piszar",
    "nom_famille": "Piszar",
    "titre_genre2": "Maire",
    "remuneration": "7826",
    "allocation": "3913",
    "remuneration2": "5616",
    "allocation2": "2808",
    "total": "20163",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "1734",
    "nom_corrige2": "Daniel Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Maire",
    "remuneration": "9022",
    "allocation": "4511",
    "remuneration2": "4415",
    "allocation2": "2207",
    "total": "20155",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "1735",
    "nom_corrige2": "David Lépine",
    "nom_famille": "Lépine",
    "titre_genre2": "Maire",
    "remuneration": "13430",
    "allocation": "6715",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20145",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "1736",
    "nom_corrige2": "Audrey Sénéchal",
    "nom_famille": "Sénéchal",
    "titre_genre2": "Mairesse",
    "remuneration": "5290",
    "allocation": "2645",
    "remuneration2": "8135",
    "allocation2": "4067",
    "total": "20137",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "1737",
    "nom_corrige2": "Raymond Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Maire",
    "remuneration": "13423",
    "allocation": "6711",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20134",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "1738",
    "nom_corrige2": "Julie Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseillère",
    "remuneration": "13404",
    "allocation": "6702",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20106",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1739",
    "nom_corrige2": "Any-Pier Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseillère",
    "remuneration": "13404",
    "allocation": "6702",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20106",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1740",
    "nom_corrige2": "Daniel Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseiller",
    "remuneration": "13511",
    "allocation": "6578",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20089",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1741",
    "nom_corrige2": "Luc Verner",
    "nom_famille": "Verner",
    "titre_genre2": "Conseiller",
    "remuneration": "13348",
    "allocation": "6674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20022",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1742",
    "nom_corrige2": "Martin Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "13348",
    "allocation": "6674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20022",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1743",
    "nom_corrige2": "Pierre Pharand",
    "nom_famille": "Pharand",
    "titre_genre2": "Conseiller",
    "remuneration": "13348",
    "allocation": "6674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20022",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1744",
    "nom_corrige2": "Anne-Marie Arcand",
    "nom_famille": "Arcand",
    "titre_genre2": "Conseillère",
    "remuneration": "13348",
    "allocation": "6674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20022",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1745",
    "nom_corrige2": "Karine Roy-Tremblay",
    "nom_famille": "Roy-Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "13348",
    "allocation": "6674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20022",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "6574"
  },
  {
    "ID": "1746",
    "nom_corrige2": "Jean-Guy (Gus) Cournoyer",
    "nom_famille": "Cournoyer",
    "titre_genre2": "Conseiller",
    "remuneration": "12495",
    "allocation": "6247",
    "remuneration2": "847",
    "allocation2": "423",
    "total": "20012",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1747",
    "nom_corrige2": "Michel Thorn",
    "nom_famille": "Thorn",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1748",
    "nom_corrige2": "Régent Aubertin",
    "nom_famille": "Aubertin",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1749",
    "nom_corrige2": "Alexandre Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1750",
    "nom_corrige2": "Marie-Josée Archetto",
    "nom_famille": "Archetto",
    "titre_genre2": "Conseillère",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1751",
    "nom_corrige2": "Yannick Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1752",
    "nom_corrige2": "Jérémie Bourque",
    "nom_famille": "Bourque",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1753",
    "nom_corrige2": "Steve Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1754",
    "nom_corrige2": "Philippe Aubin-Steben",
    "nom_famille": "Aubin-Steben",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1755",
    "nom_corrige2": "Cécile Desnoyers",
    "nom_famille": "Desnoyers",
    "titre_genre2": "Conseillère",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1756",
    "nom_corrige2": "Karine Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Oka",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6123"
  },
  {
    "ID": "1757",
    "nom_corrige2": "Rachel Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseillère",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1758",
    "nom_corrige2": "Karl Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseiller",
    "remuneration": "13333",
    "allocation": "6667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "20000",
    "ville": "Saint-Joseph-du-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7338"
  },
  {
    "ID": "1759",
    "nom_corrige2": "Saül Branco",
    "nom_famille": "Branco",
    "titre_genre2": "Conseiller",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1760",
    "nom_corrige2": "Mario Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseiller",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1761",
    "nom_corrige2": "Lynn Chiasson",
    "nom_famille": "Chiasson",
    "titre_genre2": "Conseillère",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1762",
    "nom_corrige2": "Sophie Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1763",
    "nom_corrige2": "Ysabel Lafrance",
    "nom_famille": "Lafrance",
    "titre_genre2": "Conseillère",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1764",
    "nom_corrige2": "Martin Comeau",
    "nom_famille": "Comeau",
    "titre_genre2": "Conseiller",
    "remuneration": "13330",
    "allocation": "6666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19996",
    "ville": "Shannon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "6640"
  },
  {
    "ID": "1765",
    "nom_corrige2": "Maryse Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "13534",
    "allocation": "6395",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19929",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1766",
    "nom_corrige2": "Alexandre Mantha",
    "nom_famille": "Mantha",
    "titre_genre2": "Conseiller",
    "remuneration": "13278",
    "allocation": "6639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19917",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1767",
    "nom_corrige2": "Yves Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Maire",
    "remuneration": "13247",
    "allocation": "6630",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19877",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "1768",
    "nom_corrige2": "Matthew MacDonald-Charbonneau",
    "nom_famille": "MacDonald-Charbonneau",
    "titre_genre2": "Maire",
    "remuneration": "7840",
    "allocation": "3920",
    "remuneration2": "5409",
    "allocation2": "2704",
    "total": "19873",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "1769",
    "nom_corrige2": "Dominique Mahé",
    "nom_famille": "Mahé",
    "titre_genre2": "Conseiller",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1770",
    "nom_corrige2": "Hélène Joseph",
    "nom_famille": "Joseph",
    "titre_genre2": "Conseillère",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1771",
    "nom_corrige2": "André Sabourin",
    "nom_famille": "Sabourin",
    "titre_genre2": "Conseiller",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1772",
    "nom_corrige2": "Sébastien Cottinet",
    "nom_famille": "Cottinet",
    "titre_genre2": "Conseiller",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1773",
    "nom_corrige2": "Yannick Plamondon",
    "nom_famille": "Plamondon",
    "titre_genre2": "Conseiller",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1774",
    "nom_corrige2": "Gaétane St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Conseillère",
    "remuneration": "13247",
    "allocation": "6624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19871",
    "ville": "Stoneham-et-Tewkesbury",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "9702"
  },
  {
    "ID": "1775",
    "nom_corrige2": "Jean-François Giasson",
    "nom_famille": "Giasson",
    "titre_genre2": "Conseiller",
    "remuneration": "13225",
    "allocation": "6612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19837",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "1776",
    "nom_corrige2": "Rachel Goupil",
    "nom_famille": "Goupil",
    "titre_genre2": "Mairesse",
    "remuneration": "9649",
    "allocation": "4825",
    "remuneration2": "3565",
    "allocation2": "1782",
    "total": "19821",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "1777",
    "nom_corrige2": "Elizabeth Ulin",
    "nom_famille": "Ulin",
    "titre_genre2": "Conseillère",
    "remuneration": "13186",
    "allocation": "6593",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19779",
    "ville": "Montréal-Ouest",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5389"
  },
  {
    "ID": "1778",
    "nom_corrige2": "Maria Torres",
    "nom_famille": "Torres",
    "titre_genre2": "Conseillère",
    "remuneration": "13186",
    "allocation": "6593",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19779",
    "ville": "Montréal-Ouest",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5389"
  },
  {
    "ID": "1779",
    "nom_corrige2": "Lauren Small-Pennefather",
    "nom_famille": "Small-Pennefather",
    "titre_genre2": "Conseillère",
    "remuneration": "13186",
    "allocation": "6593",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19779",
    "ville": "Montréal-Ouest",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5389"
  },
  {
    "ID": "1780",
    "nom_corrige2": "Colleen Feeney",
    "nom_famille": "Feeney",
    "titre_genre2": "Conseillère",
    "remuneration": "13186",
    "allocation": "6593",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19779",
    "ville": "Montréal-Ouest",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5389"
  },
  {
    "ID": "1781",
    "nom_corrige2": "Jean Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Maire",
    "remuneration": "13185",
    "allocation": "6592",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19777",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "1782",
    "nom_corrige2": "Shane Beauchamp",
    "nom_famille": "Beauchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "13172",
    "allocation": "6586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19758",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1783",
    "nom_corrige2": "Véronique Aubin",
    "nom_famille": "Aubin",
    "titre_genre2": "Mairesse",
    "remuneration": "13618",
    "allocation": "6139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19757",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "1784",
    "nom_corrige2": "Bernard Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Maire",
    "remuneration": "8991",
    "allocation": "4495",
    "remuneration2": "4178",
    "allocation2": "2089",
    "total": "19753",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "1785",
    "nom_corrige2": "Pierre Audesse",
    "nom_famille": "Audesse",
    "titre_genre2": "Conseiller",
    "remuneration": "11819",
    "allocation": "7927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19746",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "1786",
    "nom_corrige2": "PATRICK LAVOIE",
    "nom_famille": "LAVOIE",
    "titre_genre2": "Maire",
    "remuneration": "13154",
    "allocation": "6577",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19731",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "1787",
    "nom_corrige2": "Lucie Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "13151",
    "allocation": "6575",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19726",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1788",
    "nom_corrige2": "Louise Bourassa",
    "nom_famille": "Bourassa",
    "titre_genre2": "Conseillère",
    "remuneration": "13151",
    "allocation": "6575",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19726",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1789",
    "nom_corrige2": "DENIS DION",
    "nom_famille": "DION",
    "titre_genre2": "Maire",
    "remuneration": "13134",
    "allocation": "6567",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19701",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "1790",
    "nom_corrige2": "Nancy Mignault",
    "nom_famille": "Mignault",
    "titre_genre2": "Mairesse",
    "remuneration": "21547",
    "allocation": "10773",
    "remuneration2": "14919",
    "allocation2": "7460",
    "total": "54699",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "1791",
    "nom_corrige2": "Yves Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Maire",
    "remuneration": "13110",
    "allocation": "6555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19665",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "1792",
    "nom_corrige2": "Gaston Duchesne",
    "nom_famille": "Duchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "200",
    "allocation2": "100",
    "total": "19652",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1793",
    "nom_corrige2": "Claude Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseiller",
    "remuneration": "12540",
    "allocation": "6270",
    "remuneration2": "619",
    "allocation2": "187",
    "total": "19616",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "1794",
    "nom_corrige2": "Mathilde Péloquin-Guay",
    "nom_famille": "Péloquin-Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "13050",
    "allocation": "6525",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19575",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1795",
    "nom_corrige2": "Mark D Goldman",
    "nom_famille": "Goldman",
    "titre_genre2": "Conseiller",
    "remuneration": "13050",
    "allocation": "6525",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19575",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1796",
    "nom_corrige2": "Chantal Chartrand",
    "nom_famille": "Chartrand",
    "titre_genre2": "Conseillère",
    "remuneration": "13046",
    "allocation": "6523",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19569",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1797",
    "nom_corrige2": "Gaétan Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "13024",
    "allocation": "6512",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19536",
    "ville": "Saint-Calixte",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7162"
  },
  {
    "ID": "1798",
    "nom_corrige2": "Jacques Portelance",
    "nom_famille": "Portelance",
    "titre_genre2": "Conseiller",
    "remuneration": "12170",
    "allocation": "6085",
    "remuneration2": "841",
    "allocation2": "421",
    "total": "19517",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "1799",
    "nom_corrige2": "Simon Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "13004",
    "allocation": "6503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19507",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1800",
    "nom_corrige2": "Ariane Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "13004",
    "allocation": "6503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19507",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1801",
    "nom_corrige2": "Jacques Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseiller",
    "remuneration": "13004",
    "allocation": "6503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19507",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1802",
    "nom_corrige2": "Gilles Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Maire",
    "remuneration": "7908",
    "allocation": "3058",
    "remuneration2": "5670",
    "allocation2": "2835",
    "total": "19471",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "1803",
    "nom_corrige2": "Yves Arcouette",
    "nom_famille": "Arcouette",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19439",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1804",
    "nom_corrige2": "Annie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "13910",
    "allocation": "5529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19439",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1805",
    "nom_corrige2": "André Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Maire",
    "remuneration": "10927",
    "allocation": "5463",
    "remuneration2": "2030",
    "allocation2": "1015",
    "total": "19435",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "1806",
    "nom_corrige2": "Michel Claveau",
    "nom_famille": "Claveau",
    "titre_genre2": "Maire",
    "remuneration": "19391",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19391",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "1807",
    "nom_corrige2": "Jean-Guy Beaudet",
    "nom_famille": "Beaudet",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "2917",
    "allocation2": "1458",
    "total": "19375",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "1808",
    "nom_corrige2": "Luc Ducharme",
    "nom_famille": "Ducharme",
    "titre_genre2": "Conseiller",
    "remuneration": "12915",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19373",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1809",
    "nom_corrige2": "Patrice Ayotte",
    "nom_famille": "Ayotte",
    "titre_genre2": "Conseiller",
    "remuneration": "12915",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19373",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1810",
    "nom_corrige2": "Daniel Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Conseiller",
    "remuneration": "12915",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19373",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1811",
    "nom_corrige2": "Sophie Lajeunesse",
    "nom_famille": "Lajeunesse",
    "titre_genre2": "Conseillère",
    "remuneration": "12915",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19373",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1812",
    "nom_corrige2": "Ingrid Haegeman",
    "nom_famille": "Haegeman",
    "titre_genre2": "Conseillère",
    "remuneration": "12915",
    "allocation": "6458",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19373",
    "ville": "Saint-Félix-de-Valois",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "7034"
  },
  {
    "ID": "1813",
    "nom_corrige2": "Marc Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1814",
    "nom_corrige2": "Kevin Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1815",
    "nom_corrige2": "Charles Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1816",
    "nom_corrige2": "Alain Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1817",
    "nom_corrige2": "Archie Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1818",
    "nom_corrige2": "Yves Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "13910",
    "allocation": "5455",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19365",
    "ville": "Rigaud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8284"
  },
  {
    "ID": "1819",
    "nom_corrige2": "Marie-Ève Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseillère",
    "remuneration": "12904",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19356",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1820",
    "nom_corrige2": "Sylvain Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseiller",
    "remuneration": "12904",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19356",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1821",
    "nom_corrige2": "Charlotte Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseillère",
    "remuneration": "12904",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19356",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1822",
    "nom_corrige2": "Jonathan Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "12904",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19356",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1823",
    "nom_corrige2": "Charles Arseneault",
    "nom_famille": "Arseneault",
    "titre_genre2": "Conseiller",
    "remuneration": "12904",
    "allocation": "6452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19356",
    "ville": "Havre-Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "3396"
  },
  {
    "ID": "1824",
    "nom_corrige2": "Ghislain Boily",
    "nom_famille": "Boily",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19352",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1825",
    "nom_corrige2": "Annie Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19352",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1826",
    "nom_corrige2": "Xavier Bessone",
    "nom_famille": "Bessone",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19352",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1827",
    "nom_corrige2": "Michel Fiset",
    "nom_famille": "Fiset",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19352",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1828",
    "nom_corrige2": "Jean-François Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19352",
    "ville": "Baie-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7257"
  },
  {
    "ID": "1829",
    "nom_corrige2": "Nico Gervais",
    "nom_famille": "Gervais",
    "titre_genre2": "Maire",
    "remuneration": "13069",
    "allocation": "6234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19303",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "1830",
    "nom_corrige2": "Marc-André Sévigny",
    "nom_famille": "Sévigny",
    "titre_genre2": "Conseiller",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "127",
    "allocation2": "63",
    "total": "19282",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1831",
    "nom_corrige2": "André Longchamps",
    "nom_famille": "Longchamps",
    "titre_genre2": "Maire",
    "remuneration": "12565",
    "allocation": "6644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19209",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "1832",
    "nom_corrige2": "Jacques Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Conseiller",
    "remuneration": "12805",
    "allocation": "6403",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19208",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1833",
    "nom_corrige2": "Deborah Stewart",
    "nom_famille": "Stewart",
    "titre_genre2": "Mairesse",
    "remuneration": "5972",
    "allocation": "2976",
    "remuneration2": "6837",
    "allocation2": "3418",
    "total": "19203",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "1834",
    "nom_corrige2": "Ghislaine M.-Hudon",
    "nom_famille": "M.-Hudon",
    "titre_genre2": "Mairesse",
    "remuneration": "12797",
    "allocation": "6399",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19196",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "1835",
    "nom_corrige2": "Bruno Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "12550",
    "allocation": "5529",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "19165",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1836",
    "nom_corrige2": "CLAUDE VIEL",
    "nom_famille": "VIEL",
    "titre_genre2": "Maire",
    "remuneration": "8795",
    "allocation": "4398",
    "remuneration2": "3973",
    "allocation2": "1987",
    "total": "19153",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "1837",
    "nom_corrige2": "Christian Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Maire",
    "remuneration": "9900",
    "allocation": "4950",
    "remuneration2": "2856",
    "allocation2": "1428",
    "total": "19134",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "1838",
    "nom_corrige2": "Mona Beaulac",
    "nom_famille": "Beaulac",
    "titre_genre2": "Conseillère",
    "remuneration": "9213",
    "allocation": "3957",
    "remuneration2": "3968",
    "allocation2": "1984",
    "total": "19122",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "1839",
    "nom_corrige2": "Jean-Marie Dugas",
    "nom_famille": "Dugas",
    "titre_genre2": "Maire",
    "remuneration": "9738",
    "allocation": "4869",
    "remuneration2": "3004",
    "allocation2": "1502",
    "total": "19113",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "1840",
    "nom_corrige2": "Isabelle Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1841",
    "nom_corrige2": "Victor Dingman",
    "nom_famille": "Dingman",
    "titre_genre2": "Conseiller",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1842",
    "nom_corrige2": "Bernard Jeansonne",
    "nom_famille": "Jeansonne",
    "titre_genre2": "Conseiller",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1843",
    "nom_corrige2": "Pierre Henrichon",
    "nom_famille": "Henrichon",
    "titre_genre2": "Conseiller",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1844",
    "nom_corrige2": "François Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1845",
    "nom_corrige2": "Claire Rocher",
    "nom_famille": "Rocher",
    "titre_genre2": "Conseillère",
    "remuneration": "12734",
    "allocation": "6367",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19101",
    "ville": "Austin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1727"
  },
  {
    "ID": "1846",
    "nom_corrige2": "SIMON SHEEHY",
    "nom_famille": "SHEEHY",
    "titre_genre2": "Conseiller",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "4241",
    "allocation2": "2120",
    "total": "19096",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "1847",
    "nom_corrige2": "Louis Bienvenu",
    "nom_famille": "Bienvenu",
    "titre_genre2": "Conseiller",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19092",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1848",
    "nom_corrige2": "Martin Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19092",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1849",
    "nom_corrige2": "Gilbert Lefort",
    "nom_famille": "Lefort",
    "titre_genre2": "Conseiller",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19092",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1850",
    "nom_corrige2": "David Jourdain",
    "nom_famille": "Jourdain",
    "titre_genre2": "Conseiller",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19092",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1851",
    "nom_corrige2": "Geneviève Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseillère",
    "remuneration": "12728",
    "allocation": "6364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19092",
    "ville": "Marieville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11620"
  },
  {
    "ID": "1852",
    "nom_corrige2": "Denis Darveau",
    "nom_famille": "Darveau",
    "titre_genre2": "Conseiller",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1853",
    "nom_corrige2": "Isabelle Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1854",
    "nom_corrige2": "Sylvain Destrempes",
    "nom_famille": "Destrempes",
    "titre_genre2": "Conseiller",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1855",
    "nom_corrige2": "Amélie Lebrun",
    "nom_famille": "Lebrun",
    "titre_genre2": "Conseillère",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1856",
    "nom_corrige2": "Jean-François Frenière",
    "nom_famille": "Frenière",
    "titre_genre2": "Conseiller",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1857",
    "nom_corrige2": "Pierre Lahaie",
    "nom_famille": "Lahaie",
    "titre_genre2": "Conseiller",
    "remuneration": "16153",
    "allocation": "2926",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19079",
    "ville": "Berthierville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4330"
  },
  {
    "ID": "1858",
    "nom_corrige2": "Jules Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Maire",
    "remuneration": "8675",
    "allocation": "4337",
    "remuneration2": "5327",
    "allocation2": "712",
    "total": "19051",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "1859",
    "nom_corrige2": "Mike Touzin",
    "nom_famille": "Touzin",
    "titre_genre2": "Conseiller",
    "remuneration": "12834",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19026",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1860",
    "nom_corrige2": "David Auclair",
    "nom_famille": "Auclair",
    "titre_genre2": "Maire",
    "remuneration": "10571",
    "allocation": "4916",
    "remuneration2": "2262",
    "allocation2": "1273",
    "total": "19022",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "1861",
    "nom_corrige2": "Danielle Lanciaux",
    "nom_famille": "Lanciaux",
    "titre_genre2": "Conseillère",
    "remuneration": "12673",
    "allocation": "6336",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "19009",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "1862",
    "nom_corrige2": "Simon Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Maire",
    "remuneration": "12663",
    "allocation": "6332",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18995",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "1863",
    "nom_corrige2": "Richard Bousquet",
    "nom_famille": "Bousquet",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18994",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1864",
    "nom_corrige2": "Jacques Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18994",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1865",
    "nom_corrige2": "Alain Brisson",
    "nom_famille": "Brisson",
    "titre_genre2": "Conseiller",
    "remuneration": "12901",
    "allocation": "6093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18994",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1866",
    "nom_corrige2": "Roxane Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "12901",
    "allocation": "6093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18994",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1867",
    "nom_corrige2": "Martine Javelas",
    "nom_famille": "Javelas",
    "titre_genre2": "Conseillère",
    "remuneration": "12901",
    "allocation": "6093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18994",
    "ville": "Orford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5189"
  },
  {
    "ID": "1868",
    "nom_corrige2": "Thomas Vandor",
    "nom_famille": "Vandor",
    "titre_genre2": "Conseiller",
    "remuneration": "12605",
    "allocation": "6303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18908",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1869",
    "nom_corrige2": "Jean-Marc Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1870",
    "nom_corrige2": "Ginette Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseillère",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1871",
    "nom_corrige2": "André Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Conseiller",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1872",
    "nom_corrige2": "Mayane Cyr Paradis",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1873",
    "nom_corrige2": "Rémi Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1874",
    "nom_corrige2": "Pascale Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseillère",
    "remuneration": "12597",
    "allocation": "6299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18896",
    "ville": "Témiscouata-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "5088"
  },
  {
    "ID": "1875",
    "nom_corrige2": "David Watson McKay",
    "nom_famille": "Watson",
    "titre_genre2": "Maire",
    "remuneration": "8786",
    "allocation": "3958",
    "remuneration2": "4076",
    "allocation2": "2036",
    "total": "18856",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "1876",
    "nom_corrige2": "FRANÇOIS-PIERRE NADEAU",
    "nom_famille": "NADEAU",
    "titre_genre2": "Maire",
    "remuneration": "12567",
    "allocation": "6283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18850",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "1877",
    "nom_corrige2": "Prescylla Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseillère",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1878",
    "nom_corrige2": "Jason Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1879",
    "nom_corrige2": "Daniel Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseiller",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1880",
    "nom_corrige2": "Alexandre D'Amour",
    "nom_famille": "D'Amour",
    "titre_genre2": "Conseiller",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1881",
    "nom_corrige2": "Jean-Pierre Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseiller",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1882",
    "nom_corrige2": "Denis Désaulniers",
    "nom_famille": "Désaulniers",
    "titre_genre2": "Conseiller",
    "remuneration": "12558",
    "allocation": "6279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18837",
    "ville": "Saint-Apollinaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "8116"
  },
  {
    "ID": "1883",
    "nom_corrige2": "Jean-François Théberge",
    "nom_famille": "Théberge",
    "titre_genre2": "Conseiller",
    "remuneration": "12400",
    "allocation": "6200",
    "remuneration2": "137",
    "allocation2": "69",
    "total": "18806",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1884",
    "nom_corrige2": "Claude-Philippe Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseiller",
    "remuneration": "12528",
    "allocation": "6264",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18792",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "1885",
    "nom_corrige2": "Gérald Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "12564",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18756",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1886",
    "nom_corrige2": "Sophie Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseillère",
    "remuneration": "12495",
    "allocation": "6247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18742",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1887",
    "nom_corrige2": "Michel Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseiller",
    "remuneration": "12495",
    "allocation": "6247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18742",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1888",
    "nom_corrige2": "Ginette Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseillère",
    "remuneration": "12495",
    "allocation": "6247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18742",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1889",
    "nom_corrige2": "Éric Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseiller",
    "remuneration": "12218",
    "allocation": "6109",
    "remuneration2": "254",
    "allocation2": "127",
    "total": "18708",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "1890",
    "nom_corrige2": "Robert Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "10869",
    "allocation": "5434",
    "remuneration2": "1683",
    "allocation2": "719",
    "total": "18705",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "1891",
    "nom_corrige2": "Jean-François Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "9844",
    "allocation": "4922",
    "remuneration2": "2618",
    "allocation2": "1309",
    "total": "18693",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "1892",
    "nom_corrige2": "Christiane Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseillère",
    "remuneration": "12620",
    "allocation": "6067",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18687",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1893",
    "nom_corrige2": "ROGER ROY",
    "nom_famille": "ROY",
    "titre_genre2": "Conseiller",
    "remuneration": "10006",
    "allocation": "5003",
    "remuneration2": "2433",
    "allocation2": "1217",
    "total": "18659",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "1894",
    "nom_corrige2": "Daniel Racette",
    "nom_famille": "Racette",
    "titre_genre2": "Maire",
    "remuneration": "9648",
    "allocation": "4828",
    "remuneration2": "2783",
    "allocation2": "1395",
    "total": "18654",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "1895",
    "nom_corrige2": "Michel-Henri Goyette",
    "nom_famille": "Goyette",
    "titre_genre2": "Maire",
    "remuneration": "6900",
    "allocation": "3450",
    "remuneration2": "8263",
    "allocation2": "0",
    "total": "18613",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "1896",
    "nom_corrige2": "Mélanie Gladu",
    "nom_famille": "Gladu",
    "titre_genre2": "Conseillère",
    "remuneration": "12408",
    "allocation": "6204",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18612",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1897",
    "nom_corrige2": "Pierre St-Louis",
    "nom_famille": "St-Louis",
    "titre_genre2": "Conseiller",
    "remuneration": "12408",
    "allocation": "6204",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18612",
    "ville": "Saint-Joseph-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1664"
  },
  {
    "ID": "1898",
    "nom_corrige2": "Ryan Young",
    "nom_famille": "Young",
    "titre_genre2": "Conseiller",
    "remuneration": "12524",
    "allocation": "6084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18608",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1899",
    "nom_corrige2": "Jean-Pierre Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Conseiller",
    "remuneration": "12524",
    "allocation": "6084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18608",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1900",
    "nom_corrige2": "Yvan Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseiller",
    "remuneration": "12524",
    "allocation": "6084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18608",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1901",
    "nom_corrige2": "Denis Gignac",
    "nom_famille": "Gignac",
    "titre_genre2": "Conseiller",
    "remuneration": "12524",
    "allocation": "6084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18608",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1902",
    "nom_corrige2": "Thomas Broad",
    "nom_famille": "Broad",
    "titre_genre2": "Conseiller",
    "remuneration": "12524",
    "allocation": "6084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18608",
    "ville": "Sainte-Anne-de-Bellevue",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "5026"
  },
  {
    "ID": "1903",
    "nom_corrige2": "Martin Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Maire",
    "remuneration": "9724",
    "allocation": "4862",
    "remuneration2": "2662",
    "allocation2": "1330",
    "total": "18578",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "1904",
    "nom_corrige2": "Gilles Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseiller",
    "remuneration": "12384",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18576",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1905",
    "nom_corrige2": "Françoise Hogue Plante",
    "nom_famille": "Hogue",
    "titre_genre2": "Conseillère",
    "remuneration": "12384",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18576",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1906",
    "nom_corrige2": "Alain Pichette",
    "nom_famille": "Pichette",
    "titre_genre2": "Conseiller",
    "remuneration": "12384",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18576",
    "ville": "Louiseville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "7272"
  },
  {
    "ID": "1907",
    "nom_corrige2": "Corey Spence",
    "nom_famille": "Spence",
    "titre_genre2": "Maire",
    "remuneration": "12384",
    "allocation": "6192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18576",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "1908",
    "nom_corrige2": "Norman Young",
    "nom_famille": "Young",
    "titre_genre2": "Maire",
    "remuneration": "12368",
    "allocation": "6184",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18552",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "1909",
    "nom_corrige2": "Guy Brousseau",
    "nom_famille": "Brousseau",
    "titre_genre2": "Maire",
    "remuneration": "10224",
    "allocation": "4719",
    "remuneration2": "2421",
    "allocation2": "1185",
    "total": "18549",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "1910",
    "nom_corrige2": "Stephen Ovans",
    "nom_famille": "Ovans",
    "titre_genre2": "Conseiller",
    "remuneration": "12355",
    "allocation": "6178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18533",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1911",
    "nom_corrige2": "Jacques Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Maire",
    "remuneration": "12350",
    "allocation": "6175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18525",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "1912",
    "nom_corrige2": "Hugo Lajoie",
    "nom_famille": "Lajoie",
    "titre_genre2": "Conseiller",
    "remuneration": "20624",
    "allocation": "10312",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "30936",
    "ville": "Lachute",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "14794"
  },
  {
    "ID": "1913",
    "nom_corrige2": "Vincent More",
    "nom_famille": "More",
    "titre_genre2": "Maire",
    "remuneration": "7825",
    "allocation": "3912",
    "remuneration2": "4695",
    "allocation2": "2087",
    "total": "18519",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "1914",
    "nom_corrige2": "Michel Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "9582",
    "allocation": "4791",
    "remuneration2": "2735",
    "allocation2": "1368",
    "total": "18476",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "1915",
    "nom_corrige2": "Alain Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseiller",
    "remuneration": "13204",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18396",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "1916",
    "nom_corrige2": "Guy Lafleur",
    "nom_famille": "Lafleur",
    "titre_genre2": "Maire",
    "remuneration": "10597",
    "allocation": "5058",
    "remuneration2": "1805",
    "allocation2": "902",
    "total": "18362",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "1917",
    "nom_corrige2": "Nicole Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Mairesse",
    "remuneration": "12240",
    "allocation": "6120",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18360",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "1918",
    "nom_corrige2": "Denis Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Maire",
    "remuneration": "13752",
    "allocation": "4583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18335",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "1919",
    "nom_corrige2": "Mathieu Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseiller",
    "remuneration": "12210",
    "allocation": "6105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18315",
    "ville": "La Minerve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1335"
  },
  {
    "ID": "1920",
    "nom_corrige2": "Michel Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18298",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1921",
    "nom_corrige2": "Jean-Philippe Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18298",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1922",
    "nom_corrige2": "Josée Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseillère",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18298",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1923",
    "nom_corrige2": "Gilles Saulnier",
    "nom_famille": "Saulnier",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18298",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "1924",
    "nom_corrige2": "Alexandre L. Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "12199",
    "allocation": "6099",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18298",
    "ville": "Saint-Félicien",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "10226"
  },
  {
    "ID": "1925",
    "nom_corrige2": "Gilles St-Jean",
    "nom_famille": "St-Jean",
    "titre_genre2": "Maire",
    "remuneration": "8388",
    "allocation": "4194",
    "remuneration2": "3792",
    "allocation2": "1896",
    "total": "18270",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "1926",
    "nom_corrige2": "Jean-Roch Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Maire",
    "remuneration": "5616",
    "allocation": "2808",
    "remuneration2": "6564",
    "allocation2": "3282",
    "total": "18270",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "1927",
    "nom_corrige2": "Suzie Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Mairesse",
    "remuneration": "8600",
    "allocation": "4420",
    "remuneration2": "3481",
    "allocation2": "1741",
    "total": "18242",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "1928",
    "nom_corrige2": "Kimberley Barrington",
    "nom_famille": "Barrington",
    "titre_genre2": "Conseillère",
    "remuneration": "12155",
    "allocation": "6078",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18233",
    "ville": "Ormstown",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3999"
  },
  {
    "ID": "1929",
    "nom_corrige2": "Gilbert Dardel",
    "nom_famille": "Dardel",
    "titre_genre2": "Maire",
    "remuneration": "6720",
    "allocation": "3362",
    "remuneration2": "5425",
    "allocation2": "2713",
    "total": "18220",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "1930",
    "nom_corrige2": "René Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Maire",
    "remuneration": "6687",
    "allocation": "3346",
    "remuneration2": "5406",
    "allocation2": "2703",
    "total": "18142",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "1931",
    "nom_corrige2": "François Bessette",
    "nom_famille": "Bessette",
    "titre_genre2": "Conseiller",
    "remuneration": "12220",
    "allocation": "5900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18120",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1932",
    "nom_corrige2": "Mélanie Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "12924",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18116",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "1933",
    "nom_corrige2": "Pierre Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Maire",
    "remuneration": "12098",
    "allocation": "5999",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18097",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "1934",
    "nom_corrige2": "Carl De Montigny",
    "nom_famille": "De",
    "titre_genre2": "Conseiller",
    "remuneration": "11728",
    "allocation": "5864",
    "remuneration2": "500",
    "allocation2": "0",
    "total": "18092",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "1935",
    "nom_corrige2": "Pierrette Lajoie",
    "nom_famille": "Lajoie",
    "titre_genre2": "Conseillère",
    "remuneration": "12550",
    "allocation": "5529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18079",
    "ville": "Acton Vale",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7871"
  },
  {
    "ID": "1936",
    "nom_corrige2": "Marc Girard Alleyn",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "12021",
    "allocation": "6010",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18031",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "1937",
    "nom_corrige2": "Bruno Gattuso",
    "nom_famille": "Gattuso",
    "titre_genre2": "Conseiller",
    "remuneration": "11634",
    "allocation": "5820",
    "remuneration2": "372",
    "allocation2": "186",
    "total": "18012",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "1938",
    "nom_corrige2": "Jacqueline Plourde Croisetière",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseillère",
    "remuneration": "12000",
    "allocation": "6000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "18000",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1939",
    "nom_corrige2": "Martin J. Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "7916",
    "allocation": "3958",
    "remuneration2": "4062",
    "allocation2": "2031",
    "total": "17967",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "1940",
    "nom_corrige2": "Sylvain Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Maire",
    "remuneration": "7541",
    "allocation": "3771",
    "remuneration2": "4430",
    "allocation2": "2220",
    "total": "17962",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "1941",
    "nom_corrige2": "Magalie Taillon",
    "nom_famille": "Taillon",
    "titre_genre2": "Conseillère",
    "remuneration": "11227",
    "allocation": "5587",
    "remuneration2": "748",
    "allocation2": "374",
    "total": "17936",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "1942",
    "nom_corrige2": "Maxime Roberge",
    "nom_famille": "Roberge",
    "titre_genre2": "Conseiller",
    "remuneration": "10900",
    "allocation": "5200",
    "remuneration2": "1217",
    "allocation2": "608",
    "total": "17925",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "1943",
    "nom_corrige2": "Gervais Darisse",
    "nom_famille": "Darisse",
    "titre_genre2": "Maire",
    "remuneration": "8175",
    "allocation": "2724",
    "remuneration2": "5238",
    "allocation2": "1769",
    "total": "17906",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "1944",
    "nom_corrige2": "Kevin Mitchell",
    "nom_famille": "Mitchell",
    "titre_genre2": "Conseiller",
    "remuneration": "8385",
    "allocation": "4192",
    "remuneration2": "3551",
    "allocation2": "1775",
    "total": "17903",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "1945",
    "nom_corrige2": "Gilles Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1946",
    "nom_corrige2": "Annie Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1947",
    "nom_corrige2": "Robin Guy",
    "nom_famille": "Guy",
    "titre_genre2": "Conseiller",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1948",
    "nom_corrige2": "Jean-Pierre Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseiller",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1949",
    "nom_corrige2": "Alain Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1950",
    "nom_corrige2": "Denis Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "11933",
    "allocation": "5966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17899",
    "ville": "Mont-Joli",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6357"
  },
  {
    "ID": "1951",
    "nom_corrige2": "JEAN TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseiller",
    "remuneration": "7487",
    "allocation": "2393",
    "remuneration2": "5335",
    "allocation2": "2667",
    "total": "17882",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "1952",
    "nom_corrige2": "Barbara Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseillère",
    "remuneration": "11896",
    "allocation": "5948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17844",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1953",
    "nom_corrige2": "Jean-Philippe Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "12611",
    "allocation": "5225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17836",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "1954",
    "nom_corrige2": "Stephen Rowland",
    "nom_famille": "Rowland",
    "titre_genre2": "Conseiller",
    "remuneration": "13087",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17830",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "1955",
    "nom_corrige2": "Dona Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "9441",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17824",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1956",
    "nom_corrige2": "Manon Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "9441",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17824",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1957",
    "nom_corrige2": "Michel Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "9441",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17824",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1958",
    "nom_corrige2": "Michel Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "9441",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17824",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1959",
    "nom_corrige2": "Vicky Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseillère",
    "remuneration": "9441",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17824",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1960",
    "nom_corrige2": "Patrick Beauchamp",
    "nom_famille": "Beauchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "11879",
    "allocation": "5939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17818",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1961",
    "nom_corrige2": "Serge Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "11879",
    "allocation": "5939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17818",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1962",
    "nom_corrige2": "Samuel Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "11879",
    "allocation": "5939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17818",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1963",
    "nom_corrige2": "Robert Gladu",
    "nom_famille": "Gladu",
    "titre_genre2": "Maire",
    "remuneration": "8767",
    "allocation": "4383",
    "remuneration2": "3110",
    "allocation2": "1555",
    "total": "17815",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "1964",
    "nom_corrige2": "Dany Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "1870",
    "allocation2": "935",
    "total": "17805",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "1965",
    "nom_corrige2": "Julie Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseillère",
    "remuneration": "11857",
    "allocation": "5929",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17786",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "1966",
    "nom_corrige2": "Michel St-Amour",
    "nom_famille": "St-Amour",
    "titre_genre2": "Conseiller",
    "remuneration": "11860",
    "allocation": "5900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17760",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1967",
    "nom_corrige2": "Guy Bond",
    "nom_famille": "Bond",
    "titre_genre2": "Maire",
    "remuneration": "9222",
    "allocation": "4611",
    "remuneration2": "2589",
    "allocation2": "1295",
    "total": "17717",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "1968",
    "nom_corrige2": "Sylvie Lemonde",
    "nom_famille": "Lemonde",
    "titre_genre2": "Conseillère",
    "remuneration": "11811",
    "allocation": "5906",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17717",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "1969",
    "nom_corrige2": "Léonard Labrie",
    "nom_famille": "Labrie",
    "titre_genre2": "Maire",
    "remuneration": "11257",
    "allocation": "6447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17704",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "1970",
    "nom_corrige2": "Michel Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Conseiller",
    "remuneration": "11800",
    "allocation": "5900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17700",
    "ville": "Saint-Damien",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2238"
  },
  {
    "ID": "1971",
    "nom_corrige2": "Daniel-Luc Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "12504",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17696",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "1972",
    "nom_corrige2": "Denis Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "10313",
    "allocation": "4673",
    "remuneration2": "1807",
    "allocation2": "903",
    "total": "17696",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "1973",
    "nom_corrige2": "Pierre Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Maire",
    "remuneration": "5888",
    "allocation": "2944",
    "remuneration2": "7497",
    "allocation2": "1364",
    "total": "17693",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "1974",
    "nom_corrige2": "Hervé Provencher",
    "nom_famille": "Provencher",
    "titre_genre2": "Maire",
    "remuneration": "8847",
    "allocation": "4403",
    "remuneration2": "2958",
    "allocation2": "1479",
    "total": "17687",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "1975",
    "nom_corrige2": "Richard Handfield",
    "nom_famille": "Handfield",
    "titre_genre2": "Conseiller",
    "remuneration": "11789",
    "allocation": "5895",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17684",
    "ville": "Pointe-Calumet",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "6377"
  },
  {
    "ID": "1976",
    "nom_corrige2": "Guy Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Maire",
    "remuneration": "7735",
    "allocation": "3867",
    "remuneration2": "4051",
    "allocation2": "2025",
    "total": "17678",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "1977",
    "nom_corrige2": "Myriam Belley",
    "nom_famille": "Belley",
    "titre_genre2": "Conseillère",
    "remuneration": "11776",
    "allocation": "5889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17665",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1978",
    "nom_corrige2": "Richard Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Conseiller",
    "remuneration": "11776",
    "allocation": "5889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17665",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1979",
    "nom_corrige2": "Simon Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "11776",
    "allocation": "5889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17665",
    "ville": "Sainte-Anne-des-Monts",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "6359"
  },
  {
    "ID": "1980",
    "nom_corrige2": "Nicole Carignan-Lefebvre",
    "nom_famille": "Carignan-Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "30079",
    "allocation": "13052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "43131",
    "ville": "Saint-Eustache",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "46434"
  },
  {
    "ID": "1981",
    "nom_corrige2": "Jean-Robert Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17589",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1982",
    "nom_corrige2": "Danis Beauvillier",
    "nom_famille": "Beauvillier",
    "titre_genre2": "Conseiller",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17589",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1983",
    "nom_corrige2": "Serge Bizier",
    "nom_famille": "Bizier",
    "titre_genre2": "Conseiller",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17589",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1984",
    "nom_corrige2": "Martine Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseillère",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17589",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1985",
    "nom_corrige2": "Claude Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "11726",
    "allocation": "5863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17589",
    "ville": "Princeville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "6537"
  },
  {
    "ID": "1986",
    "nom_corrige2": "Stéphane Amireault",
    "nom_famille": "Amireault",
    "titre_genre2": "Conseiller",
    "remuneration": "9204",
    "allocation": "8383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17587",
    "ville": "L'Épiphanie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "9132"
  },
  {
    "ID": "1987",
    "nom_corrige2": "Marie-Christine Moore",
    "nom_famille": "Moore",
    "titre_genre2": "Conseillère",
    "remuneration": "11692",
    "allocation": "5876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17568",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "1988",
    "nom_corrige2": "Frédéric Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "10869",
    "allocation": "5434",
    "remuneration2": "843",
    "allocation2": "421",
    "total": "17567",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "1989",
    "nom_corrige2": "Estelle Labelle",
    "nom_famille": "Labelle",
    "titre_genre2": "Conseillère",
    "remuneration": "11709",
    "allocation": "5854",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17563",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "1990",
    "nom_corrige2": "Peter MacLaurin",
    "nom_famille": "MacLaurin",
    "titre_genre2": "Conseiller",
    "remuneration": "11706",
    "allocation": "5853",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17559",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "1991",
    "nom_corrige2": "Johnny Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1992",
    "nom_corrige2": "Luc Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1993",
    "nom_corrige2": "Stéphanie Drainville",
    "nom_famille": "Drainville",
    "titre_genre2": "Conseillère",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1994",
    "nom_corrige2": "Sonia Bruneau",
    "nom_famille": "Bruneau",
    "titre_genre2": "Conseillère",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1995",
    "nom_corrige2": "Emilien Cotton",
    "nom_famille": "Cotton",
    "titre_genre2": "Conseiller",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1996",
    "nom_corrige2": "Martin Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseiller",
    "remuneration": "13500",
    "allocation": "4027",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17527",
    "ville": "Saint-Jean-de-Matha",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4811"
  },
  {
    "ID": "1997",
    "nom_corrige2": "Robert Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Maire",
    "remuneration": "8944",
    "allocation": "5132",
    "remuneration2": "2269",
    "allocation2": "1135",
    "total": "17480",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "1998",
    "nom_corrige2": "Pierre-Olivier Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17464",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "1999",
    "nom_corrige2": "Stéphane Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17464",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "2000",
    "nom_corrige2": "Guylaine Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseillère",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17464",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "2001",
    "nom_corrige2": "Stéphane Houde",
    "nom_famille": "Houde",
    "titre_genre2": "Conseiller",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17464",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "2002",
    "nom_corrige2": "Caroline Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseillère",
    "remuneration": "11643",
    "allocation": "5821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17464",
    "ville": "Dolbeau-Mistassini",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "13934"
  },
  {
    "ID": "2003",
    "nom_corrige2": "Denis Nault",
    "nom_famille": "Nault",
    "titre_genre2": "Conseiller",
    "remuneration": "11627",
    "allocation": "5813",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17440",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "2004",
    "nom_corrige2": "Sophie Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseillère",
    "remuneration": "11627",
    "allocation": "5813",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17440",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "2005",
    "nom_corrige2": "Sonny Consantineau",
    "nom_famille": "Consantineau",
    "titre_genre2": "Conseiller",
    "remuneration": "11627",
    "allocation": "5813",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17440",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "2006",
    "nom_corrige2": "Derek Grilli",
    "nom_famille": "Grilli",
    "titre_genre2": "Maire",
    "remuneration": "8660",
    "allocation": "4330",
    "remuneration2": "2955",
    "allocation2": "1477",
    "total": "17422",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "2007",
    "nom_corrige2": "Christine Gaudet",
    "nom_famille": "Gaudet",
    "titre_genre2": "Mairesse",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "4321",
    "allocation2": "1061",
    "total": "17382",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "2008",
    "nom_corrige2": "Gilles Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Maire",
    "remuneration": "9000",
    "allocation": "4500",
    "remuneration2": "2718",
    "allocation2": "1159",
    "total": "17377",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "2009",
    "nom_corrige2": "François Fréchette",
    "nom_famille": "Fréchette",
    "titre_genre2": "Maire",
    "remuneration": "7338",
    "allocation": "3669",
    "remuneration2": "4239",
    "allocation2": "2119",
    "total": "17365",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "2010",
    "nom_corrige2": "Jean-Pierre Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Maire",
    "remuneration": "11576",
    "allocation": "5788",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17364",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "2011",
    "nom_corrige2": "Michel Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Maire",
    "remuneration": "9445",
    "allocation": "4722",
    "remuneration2": "2119",
    "allocation2": "1059",
    "total": "17345",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "2012",
    "nom_corrige2": "Jeremy Page",
    "nom_famille": "Page",
    "titre_genre2": "Conseiller",
    "remuneration": "11559",
    "allocation": "5779",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17338",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "2013",
    "nom_corrige2": "Benoît Bouthillette",
    "nom_famille": "Bouthillette",
    "titre_genre2": "Conseiller",
    "remuneration": "11555",
    "allocation": "5778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17333",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "2014",
    "nom_corrige2": "Louise Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "12012",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17318",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2015",
    "nom_corrige2": "Lee Patterson",
    "nom_famille": "Patterson",
    "titre_genre2": "Conseiller",
    "remuneration": "12012",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17318",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2016",
    "nom_corrige2": "Leigh MacLeod",
    "nom_famille": "MacLeod",
    "titre_genre2": "Conseillère",
    "remuneration": "11541",
    "allocation": "5770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17311",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "2017",
    "nom_corrige2": "Louise Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseillère",
    "remuneration": "11541",
    "allocation": "5770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17311",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "2018",
    "nom_corrige2": "Carole Patenaude",
    "nom_famille": "Patenaude",
    "titre_genre2": "Conseillère",
    "remuneration": "11541",
    "allocation": "5770",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17311",
    "ville": "Morin-Heights",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4906"
  },
  {
    "ID": "2019",
    "nom_corrige2": "Eric Mageau",
    "nom_famille": "Mageau",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "1538",
    "allocation2": "769",
    "total": "17307",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2020",
    "nom_corrige2": "Jeannot Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Maire",
    "remuneration": "9615",
    "allocation": "4807",
    "remuneration2": "1917",
    "allocation2": "958",
    "total": "17297",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "2021",
    "nom_corrige2": "Alexandre Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "10400",
    "allocation": "5200",
    "remuneration2": "1115",
    "allocation2": "558",
    "total": "17273",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "2022",
    "nom_corrige2": "Gaétan Graveline",
    "nom_famille": "Graveline",
    "titre_genre2": "Conseiller",
    "remuneration": "11507",
    "allocation": "5753",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17260",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2023",
    "nom_corrige2": "Sarah-Josée Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseillère",
    "remuneration": "11487",
    "allocation": "5743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17230",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2024",
    "nom_corrige2": "André Brisson",
    "nom_famille": "Brisson",
    "titre_genre2": "Conseiller",
    "remuneration": "9672",
    "allocation": "4836",
    "remuneration2": "700",
    "allocation2": "0",
    "total": "15208",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "2025",
    "nom_corrige2": "Jocelyn Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Maire",
    "remuneration": "8904",
    "allocation": "4452",
    "remuneration2": "2532",
    "allocation2": "1266",
    "total": "17154",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "2026",
    "nom_corrige2": "Diane Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "6672",
    "allocation": "3046",
    "remuneration2": "4939",
    "allocation2": "2470",
    "total": "17127",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2027",
    "nom_corrige2": "Jean Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Maire",
    "remuneration": "11416",
    "allocation": "5708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17124",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "2028",
    "nom_corrige2": "Jean-Guy Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "10993",
    "allocation": "5496",
    "remuneration2": "421",
    "allocation2": "211",
    "total": "17121",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "2029",
    "nom_corrige2": "Richard Francoeur",
    "nom_famille": "Francoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "11409",
    "allocation": "5704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17113",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2030",
    "nom_corrige2": "Pierre Saillant",
    "nom_famille": "Saillant",
    "titre_genre2": "Maire",
    "remuneration": "7540",
    "allocation": "3934",
    "remuneration2": "3944",
    "allocation2": "1672",
    "total": "17090",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "2031",
    "nom_corrige2": "Pascal Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17050",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "2032",
    "nom_corrige2": "Esther St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseillère",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17050",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "2033",
    "nom_corrige2": "Nicole Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseillère",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17050",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "2034",
    "nom_corrige2": "Germain Maltais",
    "nom_famille": "Maltais",
    "titre_genre2": "Conseiller",
    "remuneration": "11366",
    "allocation": "5684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17050",
    "ville": "Roberval",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "9888"
  },
  {
    "ID": "2035",
    "nom_corrige2": "Lucien Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Maire",
    "remuneration": "6955",
    "allocation": "3477",
    "remuneration2": "4488",
    "allocation2": "2126",
    "total": "17046",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "2036",
    "nom_corrige2": "Denis Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Maire",
    "remuneration": "8863",
    "allocation": "4432",
    "remuneration2": "2485",
    "allocation2": "1243",
    "total": "17023",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "2037",
    "nom_corrige2": "Gilles Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Maire",
    "remuneration": "7013",
    "allocation": "3508",
    "remuneration2": "4333",
    "allocation2": "2166",
    "total": "17020",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "2038",
    "nom_corrige2": "Lucy Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "11712",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "17018",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2039",
    "nom_corrige2": "Guy Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "8303",
    "allocation": "4152",
    "remuneration2": "3008",
    "allocation2": "1504",
    "total": "16967",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "2040",
    "nom_corrige2": "Guy Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseiller",
    "remuneration": "11277",
    "allocation": "5638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16915",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "2041",
    "nom_corrige2": "Manon Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseillère",
    "remuneration": "11277",
    "allocation": "5638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16915",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "2042",
    "nom_corrige2": "Christian Lachaine",
    "nom_famille": "Lachaine",
    "titre_genre2": "Conseiller",
    "remuneration": "11277",
    "allocation": "5638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16915",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "2043",
    "nom_corrige2": "Stéphan Schwab",
    "nom_famille": "Schwab",
    "titre_genre2": "Conseiller",
    "remuneration": "11277",
    "allocation": "5638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16915",
    "ville": "Val-David",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "5653"
  },
  {
    "ID": "2044",
    "nom_corrige2": "Lisa Cadorette",
    "nom_famille": "Cadorette",
    "titre_genre2": "Conseillère",
    "remuneration": "10667",
    "allocation": "5333",
    "remuneration2": "900",
    "allocation2": "0",
    "total": "16900",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2045",
    "nom_corrige2": "Isabelle Forcier",
    "nom_famille": "Forcier",
    "titre_genre2": "Conseillère",
    "remuneration": "11252",
    "allocation": "5626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16878",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "2046",
    "nom_corrige2": "Andréanne Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseillère",
    "remuneration": "11252",
    "allocation": "5626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16878",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "2047",
    "nom_corrige2": "Caroline Payer",
    "nom_famille": "Payer",
    "titre_genre2": "Conseillère",
    "remuneration": "11252",
    "allocation": "5626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16878",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "2048",
    "nom_corrige2": "Sylvie Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Mairesse",
    "remuneration": "8997",
    "allocation": "4499",
    "remuneration2": "2248",
    "allocation2": "1124",
    "total": "16868",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "2049",
    "nom_corrige2": "Michel Joly",
    "nom_famille": "Joly",
    "titre_genre2": "Conseiller",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2050",
    "nom_corrige2": "François Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2051",
    "nom_corrige2": "Myriam Sauvé",
    "nom_famille": "Sauvé",
    "titre_genre2": "Conseillère",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2052",
    "nom_corrige2": "Josée Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2053",
    "nom_corrige2": "Véronique Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2054",
    "nom_corrige2": "Claude Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseiller",
    "remuneration": "11242",
    "allocation": "5621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16863",
    "ville": "Les Coteaux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5880"
  },
  {
    "ID": "2055",
    "nom_corrige2": "Pamela B. Steen",
    "nom_famille": "Steen",
    "titre_genre2": "Mairesse",
    "remuneration": "6469",
    "allocation": "3235",
    "remuneration2": "6733",
    "allocation2": "400",
    "total": "16837",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "2056",
    "nom_corrige2": "Madeleine Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "11217",
    "allocation": "5608",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16825",
    "ville": "Maniwaki",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3854"
  },
  {
    "ID": "2057",
    "nom_corrige2": "YVON ASSELIN",
    "nom_famille": "ASSELIN",
    "titre_genre2": "Maire",
    "remuneration": "8731",
    "allocation": "4366",
    "remuneration2": "2479",
    "allocation2": "1239",
    "total": "16815",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "2058",
    "nom_corrige2": "JACINTHE BREAULT",
    "nom_famille": "BREAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2059",
    "nom_corrige2": "MANNIX MARION",
    "nom_famille": "MARION",
    "titre_genre2": "Conseiller",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2060",
    "nom_corrige2": "DOMINIQUE MONDOR",
    "nom_famille": "MONDOR",
    "titre_genre2": "Conseiller",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2061",
    "nom_corrige2": "ALEXANDRA LEMAY",
    "nom_famille": "LEMAY",
    "titre_genre2": "Conseillère",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2062",
    "nom_corrige2": "MÉLANIE DESJARDINS",
    "nom_famille": "DESJARDINS",
    "titre_genre2": "Conseillère",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2063",
    "nom_corrige2": "MARC PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseiller",
    "remuneration": "11169",
    "allocation": "5585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16754",
    "ville": "Saint-Paul",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "6749"
  },
  {
    "ID": "2064",
    "nom_corrige2": "Denis Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Maire",
    "remuneration": "8569",
    "allocation": "4284",
    "remuneration2": "2584",
    "allocation2": "1292",
    "total": "16729",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "2065",
    "nom_corrige2": "Patrick Darsigny",
    "nom_famille": "Darsigny",
    "titre_genre2": "Conseiller",
    "remuneration": "5015",
    "allocation": "2507",
    "remuneration2": "6100",
    "allocation2": "3050",
    "total": "16672",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "2066",
    "nom_corrige2": "Luce Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Conseillère",
    "remuneration": "12360",
    "allocation": "6180",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "18899",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2067",
    "nom_corrige2": "C. Jennifer Pearson-Millar",
    "nom_famille": "Pearson-Millar",
    "titre_genre2": "Conseillère",
    "remuneration": "11100",
    "allocation": "5550",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16650",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2068",
    "nom_corrige2": "Patrick Ouvrard",
    "nom_famille": "Ouvrard",
    "titre_genre2": "Conseiller",
    "remuneration": "11312",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16618",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2069",
    "nom_corrige2": "MARQUIS BEDARD",
    "nom_famille": "BEDARD",
    "titre_genre2": "Maire",
    "remuneration": "9250",
    "allocation": "4624",
    "remuneration2": "1822",
    "allocation2": "911",
    "total": "16607",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "2070",
    "nom_corrige2": "Sébastien Bourget",
    "nom_famille": "Bourget",
    "titre_genre2": "Maire",
    "remuneration": "9172",
    "allocation": "4586",
    "remuneration2": "1893",
    "allocation2": "946",
    "total": "16597",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "2071",
    "nom_corrige2": "Marcel Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "10995",
    "allocation": "5498",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16493",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2072",
    "nom_corrige2": "Archill Gladu",
    "nom_famille": "Gladu",
    "titre_genre2": "Maire",
    "remuneration": "6480",
    "allocation": "3240",
    "remuneration2": "4494",
    "allocation2": "2247",
    "total": "16461",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "2073",
    "nom_corrige2": "Pascal Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Maire",
    "remuneration": "6941",
    "allocation": "3470",
    "remuneration2": "4023",
    "allocation2": "2012",
    "total": "16446",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "2074",
    "nom_corrige2": "Vincent Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "10963",
    "allocation": "5482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16445",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "2075",
    "nom_corrige2": "Alain Vouligny",
    "nom_famille": "Vouligny",
    "titre_genre2": "Maire",
    "remuneration": "9070",
    "allocation": "2623",
    "remuneration2": "3758",
    "allocation2": "917",
    "total": "16368",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "2076",
    "nom_corrige2": "Philippe Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Maire",
    "remuneration": "7627",
    "allocation": "3459",
    "remuneration2": "3509",
    "allocation2": "1755",
    "total": "16350",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "2077",
    "nom_corrige2": "René Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "10899",
    "allocation": "5449",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16348",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "2078",
    "nom_corrige2": "Benoît Yergeau",
    "nom_famille": "Yergeau",
    "titre_genre2": "Maire",
    "remuneration": "6764",
    "allocation": "3380",
    "remuneration2": "4136",
    "allocation2": "2068",
    "total": "16348",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "2079",
    "nom_corrige2": "Pierre Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseiller",
    "remuneration": "10899",
    "allocation": "5449",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16348",
    "ville": "Val-des-Sources",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "7086"
  },
  {
    "ID": "2080",
    "nom_corrige2": "Nancy Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseillère",
    "remuneration": "10890",
    "allocation": "5445",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16335",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2081",
    "nom_corrige2": "Simon Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseiller",
    "remuneration": "10890",
    "allocation": "5445",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16335",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2082",
    "nom_corrige2": "Julie Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseillère",
    "remuneration": "10890",
    "allocation": "5445",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16335",
    "ville": "Lac-Supérieur",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1953"
  },
  {
    "ID": "2083",
    "nom_corrige2": "Lina Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Mairesse",
    "remuneration": "10884",
    "allocation": "5442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16326",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "2084",
    "nom_corrige2": "Sylvie Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseillère",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "909",
    "allocation2": "454",
    "total": "16324",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2085",
    "nom_corrige2": "Pierre Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Conseiller",
    "remuneration": "11012",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16318",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2086",
    "nom_corrige2": "Lise Roy Guillemette",
    "nom_famille": "Roy",
    "titre_genre2": "Mairesse",
    "remuneration": "10872",
    "allocation": "5436",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16308",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "2087",
    "nom_corrige2": "François Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "10869",
    "allocation": "5434",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16303",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "2088",
    "nom_corrige2": "Tanya Czinkan",
    "nom_famille": "Czinkan",
    "titre_genre2": "Conseillère",
    "remuneration": "10869",
    "allocation": "5434",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16303",
    "ville": "McMasterville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5894"
  },
  {
    "ID": "2089",
    "nom_corrige2": "Michel Denicourt",
    "nom_famille": "Denicourt",
    "titre_genre2": "Conseiller",
    "remuneration": "10187",
    "allocation": "4673",
    "remuneration2": "932",
    "allocation2": "466",
    "total": "16258",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "2090",
    "nom_corrige2": "Lina Courtois",
    "nom_famille": "Courtois",
    "titre_genre2": "Conseillère",
    "remuneration": "10823",
    "allocation": "5412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16235",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "2091",
    "nom_corrige2": "Gilles Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Maire",
    "remuneration": "4520",
    "allocation": "2260",
    "remuneration2": "5498",
    "allocation2": "3946",
    "total": "16224",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "2092",
    "nom_corrige2": "Madeleine Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "11024",
    "allocation": "5192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16216",
    "ville": "Gracefield",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2618"
  },
  {
    "ID": "2093",
    "nom_corrige2": "GILLES DROLET",
    "nom_famille": "DROLET",
    "titre_genre2": "Maire",
    "remuneration": "10152",
    "allocation": "4895",
    "remuneration2": "858",
    "allocation2": "286",
    "total": "16191",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2094",
    "nom_corrige2": "STEEVES MATHIEU",
    "nom_famille": "MATHIEU",
    "titre_genre2": "Conseiller",
    "remuneration": "8711",
    "allocation": "4355",
    "remuneration2": "2076",
    "allocation2": "1038",
    "total": "16180",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2095",
    "nom_corrige2": "Patricia Sévigny",
    "nom_famille": "Sévigny",
    "titre_genre2": "Conseillère",
    "remuneration": "10776",
    "allocation": "5387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16163",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "2096",
    "nom_corrige2": "Ginette Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Mairesse",
    "remuneration": "5849",
    "allocation": "2925",
    "remuneration2": "4917",
    "allocation2": "2458",
    "total": "16149",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "2097",
    "nom_corrige2": "Pierre Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Maire",
    "remuneration": "6837",
    "allocation": "3419",
    "remuneration2": "5177",
    "allocation2": "712",
    "total": "16145",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "2098",
    "nom_corrige2": "Michel Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "10271",
    "allocation": "4673",
    "remuneration2": "777",
    "allocation2": "388",
    "total": "16109",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "2099",
    "nom_corrige2": "Sylvain Toupin",
    "nom_famille": "Toupin",
    "titre_genre2": "Conseiller",
    "remuneration": "10699",
    "allocation": "5350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16049",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "2100",
    "nom_corrige2": "François Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2101",
    "nom_corrige2": "Jean-François Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2102",
    "nom_corrige2": "Denis Forest",
    "nom_famille": "Forest",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2103",
    "nom_corrige2": "Simon Chapleau",
    "nom_famille": "Chapleau",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2104",
    "nom_corrige2": "Michel Lachapelle",
    "nom_famille": "Lachapelle",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2105",
    "nom_corrige2": "Claude Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "10694",
    "allocation": "5347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16041",
    "ville": "Saint-Jacques",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4560"
  },
  {
    "ID": "2106",
    "nom_corrige2": "Claude Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "8618",
    "allocation": "4311",
    "remuneration2": "2068",
    "allocation2": "1034",
    "total": "16031",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "2107",
    "nom_corrige2": "Jean Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Maire",
    "remuneration": "10667",
    "allocation": "5333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16000",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "2108",
    "nom_corrige2": "Rémi Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Maire",
    "remuneration": "10667",
    "allocation": "5333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "16000",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "2109",
    "nom_corrige2": "Benoit Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "6634",
    "allocation": "3317",
    "remuneration2": "4533",
    "allocation2": "1511",
    "total": "15995",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "2110",
    "nom_corrige2": "Peter Manning",
    "nom_famille": "Manning",
    "titre_genre2": "Maire",
    "remuneration": "8595",
    "allocation": "4297",
    "remuneration2": "2069",
    "allocation2": "1034",
    "total": "15995",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "2111",
    "nom_corrige2": "Danièle Provencher",
    "nom_famille": "Provencher",
    "titre_genre2": "Mairesse",
    "remuneration": "8745",
    "allocation": "4373",
    "remuneration2": "1917",
    "allocation2": "958",
    "total": "15993",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "2112",
    "nom_corrige2": "Elaine A. Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Conseillère",
    "remuneration": "10651",
    "allocation": "5325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15976",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2113",
    "nom_corrige2": "Nicole Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "550",
    "allocation2": "375",
    "total": "15925",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "2114",
    "nom_corrige2": "Shelley Judge",
    "nom_famille": "Judge",
    "titre_genre2": "Conseillère",
    "remuneration": "10612",
    "allocation": "5306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15918",
    "ville": "Lac-Brome",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "6085"
  },
  {
    "ID": "2115",
    "nom_corrige2": "Pierre Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Maire",
    "remuneration": "8640",
    "allocation": "4320",
    "remuneration2": "1967",
    "allocation2": "984",
    "total": "15911",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "2116",
    "nom_corrige2": "Antoni Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "600",
    "allocation2": "300",
    "total": "15900",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "2117",
    "nom_corrige2": "Patrick Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseiller",
    "remuneration": "25388",
    "allocation": "12694",
    "remuneration2": "1673",
    "allocation2": "837",
    "total": "40592",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "2118",
    "nom_corrige2": "LUCIE GAUTHIER",
    "nom_famille": "GAUTHIER",
    "titre_genre2": "Conseillère",
    "remuneration": "10524",
    "allocation": "5262",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15786",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2119",
    "nom_corrige2": "Francis Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Maire",
    "remuneration": "9364",
    "allocation": "4682",
    "remuneration2": "1160",
    "allocation2": "580",
    "total": "15786",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "2120",
    "nom_corrige2": "Jean Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "10497",
    "allocation": "5249",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15746",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "2121",
    "nom_corrige2": "Sylvain Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "9884",
    "allocation": "4992",
    "remuneration2": "834",
    "allocation2": "0",
    "total": "15710",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2122",
    "nom_corrige2": "René Laverdière",
    "nom_famille": "Laverdière",
    "titre_genre2": "Maire",
    "remuneration": "10453",
    "allocation": "5227",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15680",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "2123",
    "nom_corrige2": "Hervey Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "9984",
    "allocation": "4992",
    "remuneration2": "675",
    "allocation2": "0",
    "total": "15651",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2124",
    "nom_corrige2": "Josiane Appleby",
    "nom_famille": "Appleby",
    "titre_genre2": "Mairesse",
    "remuneration": "10432",
    "allocation": "5216",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15648",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "2125",
    "nom_corrige2": "Camil Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Maire",
    "remuneration": "7839",
    "allocation": "3920",
    "remuneration2": "2566",
    "allocation2": "1283",
    "total": "15608",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "2126",
    "nom_corrige2": "Éric Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "10400",
    "allocation": "5200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15600",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "2127",
    "nom_corrige2": "Vincent Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseiller",
    "remuneration": "10400",
    "allocation": "5200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15600",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "2128",
    "nom_corrige2": "Christine Pleau",
    "nom_famille": "Pleau",
    "titre_genre2": "Conseillère",
    "remuneration": "10400",
    "allocation": "5200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15600",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "2129",
    "nom_corrige2": "Guylaine Lefrançois",
    "nom_famille": "Lefrançois",
    "titre_genre2": "Conseillère",
    "remuneration": "10400",
    "allocation": "5200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15600",
    "ville": "Château-Richer",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4571"
  },
  {
    "ID": "2130",
    "nom_corrige2": "Marc-André Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "10359",
    "allocation": "5180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15539",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "2131",
    "nom_corrige2": "FRANÇOIS PARENTEAU",
    "nom_famille": "PARENTEAU",
    "titre_genre2": "Maire",
    "remuneration": "6783",
    "allocation": "3392",
    "remuneration2": "3540",
    "allocation2": "1770",
    "total": "15485",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "2132",
    "nom_corrige2": "Louise Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseillère",
    "remuneration": "10304",
    "allocation": "5152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15456",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "2133",
    "nom_corrige2": "Richard Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "10295",
    "allocation": "5147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15442",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2134",
    "nom_corrige2": "Luc Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "10295",
    "allocation": "5147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15442",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2135",
    "nom_corrige2": "Pier-Luc Denoncourt",
    "nom_famille": "Denoncourt",
    "titre_genre2": "Conseiller",
    "remuneration": "10295",
    "allocation": "5147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15442",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2136",
    "nom_corrige2": "Égide Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseiller",
    "remuneration": "10295",
    "allocation": "5147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15442",
    "ville": "Amqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "6255"
  },
  {
    "ID": "2137",
    "nom_corrige2": "Jean-Pierre Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseiller",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "319",
    "allocation2": "159",
    "total": "15439",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2138",
    "nom_corrige2": "Majorie Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseillère",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2139",
    "nom_corrige2": "Debra Margles",
    "nom_famille": "Margles",
    "titre_genre2": "Conseillère",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2140",
    "nom_corrige2": "Alexander Weil",
    "nom_famille": "Weil",
    "titre_genre2": "Conseiller",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2141",
    "nom_corrige2": "Alain Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2142",
    "nom_corrige2": "Charles Coulson",
    "nom_famille": "Coulson",
    "titre_genre2": "Conseiller",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2143",
    "nom_corrige2": "Annemarie Masson",
    "nom_famille": "Masson",
    "titre_genre2": "Conseillère",
    "remuneration": "10260",
    "allocation": "5136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15396",
    "ville": "Estérel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "232"
  },
  {
    "ID": "2144",
    "nom_corrige2": "Jacques Laprise",
    "nom_famille": "Laprise",
    "titre_genre2": "Maire",
    "remuneration": "9175",
    "allocation": "4500",
    "remuneration2": "1144",
    "allocation2": "572",
    "total": "15391",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "2145",
    "nom_corrige2": "Magella Roussel",
    "nom_famille": "Roussel",
    "titre_genre2": "Maire",
    "remuneration": "5916",
    "allocation": "2958",
    "remuneration2": "6503",
    "allocation2": "0",
    "total": "15377",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "2146",
    "nom_corrige2": "Alain Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseiller",
    "remuneration": "10232",
    "allocation": "5116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15348",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2147",
    "nom_corrige2": "Mario Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "10232",
    "allocation": "5116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15348",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2148",
    "nom_corrige2": "Daniel Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "10232",
    "allocation": "5116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15348",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2149",
    "nom_corrige2": "Solange Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseillère",
    "remuneration": "10232",
    "allocation": "5116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15348",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2150",
    "nom_corrige2": "Ana Rosa Mariscal",
    "nom_famille": "Mariscal",
    "titre_genre2": "Conseillère",
    "remuneration": "10232",
    "allocation": "5116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15348",
    "ville": "Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5336"
  },
  {
    "ID": "2151",
    "nom_corrige2": "Bruno Bonesso",
    "nom_famille": "Bonesso",
    "titre_genre2": "Maire",
    "remuneration": "6809",
    "allocation": "3405",
    "remuneration2": "4414",
    "allocation2": "712",
    "total": "15340",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "2152",
    "nom_corrige2": "Marcel Gaumond",
    "nom_famille": "Gaumond",
    "titre_genre2": "Conseiller",
    "remuneration": "9389",
    "allocation": "4563",
    "remuneration2": "909",
    "allocation2": "454",
    "total": "15315",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2153",
    "nom_corrige2": "Gaston Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "10206",
    "allocation": "5103",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15309",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2154",
    "nom_corrige2": "Denis Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseiller",
    "remuneration": "10206",
    "allocation": "5103",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15309",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2155",
    "nom_corrige2": "CHRISTINA PINARD",
    "nom_famille": "PINARD",
    "titre_genre2": "Conseillère",
    "remuneration": "9652",
    "allocation": "4787",
    "remuneration2": "644",
    "allocation2": "215",
    "total": "15298",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2156",
    "nom_corrige2": "Denise Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "1872",
    "allocation2": "935",
    "total": "15292",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2157",
    "nom_corrige2": "Mario Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Maire",
    "remuneration": "6654",
    "allocation": "3327",
    "remuneration2": "4570",
    "allocation2": "712",
    "total": "15263",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "2158",
    "nom_corrige2": "Réjean Mégré",
    "nom_famille": "Mégré",
    "titre_genre2": "Conseiller",
    "remuneration": "10171",
    "allocation": "5086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15257",
    "ville": "Compton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3302"
  },
  {
    "ID": "2159",
    "nom_corrige2": "Catherine Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseillère",
    "remuneration": "10249",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15249",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2160",
    "nom_corrige2": "Renaud Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseiller",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "225",
    "allocation2": "113",
    "total": "15246",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2161",
    "nom_corrige2": "Mathieu Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Conseiller",
    "remuneration": "10161",
    "allocation": "5081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15242",
    "ville": "Otterburn Park",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "8624"
  },
  {
    "ID": "2162",
    "nom_corrige2": "FÉLIX LABERGE",
    "nom_famille": "LABERGE",
    "titre_genre2": "Conseiller",
    "remuneration": "10226",
    "allocation": "5003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15229",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "2163",
    "nom_corrige2": "Julie Pressé",
    "nom_famille": "Pressé",
    "titre_genre2": "Mairesse",
    "remuneration": "5776",
    "allocation": "2788",
    "remuneration2": "4436",
    "allocation2": "2218",
    "total": "15218",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "2164",
    "nom_corrige2": "WILLIAM ST-CYR",
    "nom_famille": "ST-CYR",
    "titre_genre2": "Conseiller",
    "remuneration": "10206",
    "allocation": "5003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15209",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "2165",
    "nom_corrige2": "Daisy Drudge",
    "nom_famille": "Drudge",
    "titre_genre2": "Conseillère",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2166",
    "nom_corrige2": "Jacques Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "10199",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15199",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2167",
    "nom_corrige2": "Viviane De Bock",
    "nom_famille": "De",
    "titre_genre2": "Conseillère",
    "remuneration": "10199",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15199",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2168",
    "nom_corrige2": "Bernard Duchesne",
    "nom_famille": "Duchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "10199",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15199",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2169",
    "nom_corrige2": "Rachel Grégoire",
    "nom_famille": "Grégoire",
    "titre_genre2": "Conseillère",
    "remuneration": "10126",
    "allocation": "5063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15189",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "2170",
    "nom_corrige2": "Suzie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Mairesse",
    "remuneration": "7779",
    "allocation": "4279",
    "remuneration2": "2068",
    "allocation2": "1034",
    "total": "15160",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "2171",
    "nom_corrige2": "Michel Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseiller",
    "remuneration": "10053",
    "allocation": "5027",
    "remuneration2": "50",
    "allocation2": "25",
    "total": "15155",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2172",
    "nom_corrige2": "François Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "10149",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2173",
    "nom_corrige2": "Gilles Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2174",
    "nom_corrige2": "Martin Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2175",
    "nom_corrige2": "Bruno Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2176",
    "nom_corrige2": "Roland Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2177",
    "nom_corrige2": "Normand Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2178",
    "nom_corrige2": "Jean-François Maltais",
    "nom_famille": "Maltais",
    "titre_genre2": "Conseiller",
    "remuneration": "10099",
    "allocation": "5050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "La Malbaie",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8387"
  },
  {
    "ID": "2179",
    "nom_corrige2": "Israel Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "10149",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15149",
    "ville": "Petite-Rivière-Saint-François",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "960"
  },
  {
    "ID": "2180",
    "nom_corrige2": "Sylvain Vidal",
    "nom_famille": "Vidal",
    "titre_genre2": "Conseiller",
    "remuneration": "10810",
    "allocation": "4324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15134",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "2181",
    "nom_corrige2": "Micheline Beaudet",
    "nom_famille": "Beaudet",
    "titre_genre2": "Conseillère",
    "remuneration": "10810",
    "allocation": "4324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15134",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "2182",
    "nom_corrige2": "Manon Provencher",
    "nom_famille": "Provencher",
    "titre_genre2": "Conseillère",
    "remuneration": "10810",
    "allocation": "4324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15134",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "2183",
    "nom_corrige2": "Marc-Antoine Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "10810",
    "allocation": "4324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15134",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "2184",
    "nom_corrige2": "Bernard Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "10810",
    "allocation": "4324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15134",
    "ville": "Saint-Agapit",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4605"
  },
  {
    "ID": "2185",
    "nom_corrige2": "Pierre Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "10088",
    "allocation": "5043",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15131",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2186",
    "nom_corrige2": "Jean-Marc Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Maire",
    "remuneration": "8559",
    "allocation": "4280",
    "remuneration2": "1517",
    "allocation2": "759",
    "total": "15115",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "2187",
    "nom_corrige2": "Myriam Derome",
    "nom_famille": "Derome",
    "titre_genre2": "Conseillère",
    "remuneration": "10065",
    "allocation": "5033",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15098",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "2188",
    "nom_corrige2": "Guy St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Maire",
    "remuneration": "6778",
    "allocation": "3669",
    "remuneration2": "3099",
    "allocation2": "1550",
    "total": "15096",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "2189",
    "nom_corrige2": "Alain Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2190",
    "nom_corrige2": "Luc Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2191",
    "nom_corrige2": "Claude Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2192",
    "nom_corrige2": "Nichèle Compartino",
    "nom_famille": "Compartino",
    "titre_genre2": "Conseillère",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2193",
    "nom_corrige2": "Jonathan Mattson",
    "nom_famille": "Mattson",
    "titre_genre2": "Conseiller",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2194",
    "nom_corrige2": "Stéphane Hudon",
    "nom_famille": "Hudon",
    "titre_genre2": "Conseiller",
    "remuneration": "10045",
    "allocation": "5023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15068",
    "ville": "Chibougamau",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "7315"
  },
  {
    "ID": "2195",
    "nom_corrige2": "Daniel Pinsonneault",
    "nom_famille": "Pinsonneault",
    "titre_genre2": "Conseiller",
    "remuneration": "10023",
    "allocation": "5011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15034",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2196",
    "nom_corrige2": "Mathieu Thomassin",
    "nom_famille": "Thomassin",
    "titre_genre2": "Conseiller",
    "remuneration": "10022",
    "allocation": "5011",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15033",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "2197",
    "nom_corrige2": "Jacques Bienvenue",
    "nom_famille": "Bienvenue",
    "titre_genre2": "Conseiller",
    "remuneration": "10355",
    "allocation": "4673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15028",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "2198",
    "nom_corrige2": "Joanie Généreux",
    "nom_famille": "Généreux",
    "titre_genre2": "Conseillère",
    "remuneration": "10229",
    "allocation": "4673",
    "remuneration2": "78",
    "allocation2": "39",
    "total": "15019",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "2199",
    "nom_corrige2": "Jean Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "10030",
    "allocation": "4986",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15016",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2200",
    "nom_corrige2": "Maxime Villemaire",
    "nom_famille": "Villemaire",
    "titre_genre2": "Conseiller",
    "remuneration": "10010",
    "allocation": "5005",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15015",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "2201",
    "nom_corrige2": "Sylvain Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "10998",
    "allocation": "3933",
    "remuneration2": "79",
    "allocation2": "0",
    "total": "15010",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2202",
    "nom_corrige2": "DIANE GIGUÈRE",
    "nom_famille": "GIGUÈRE",
    "titre_genre2": "Conseillère",
    "remuneration": "10006",
    "allocation": "5003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15009",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "2203",
    "nom_corrige2": "CHANTALE GAGNON",
    "nom_famille": "GAGNON",
    "titre_genre2": "Conseillère",
    "remuneration": "10006",
    "allocation": "5003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15009",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "2204",
    "nom_corrige2": "MICHEL LABERGE",
    "nom_famille": "LABERGE",
    "titre_genre2": "Conseiller",
    "remuneration": "10006",
    "allocation": "5003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15009",
    "ville": "L'Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3993"
  },
  {
    "ID": "2205",
    "nom_corrige2": "Jean-Roger Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2206",
    "nom_corrige2": "René Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "2207",
    "nom_corrige2": "Denis Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "2208",
    "nom_corrige2": "Guillaume Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "2209",
    "nom_corrige2": "Michel Champigny",
    "nom_famille": "Champigny",
    "titre_genre2": "Conseiller",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "East Angus",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3982"
  },
  {
    "ID": "2210",
    "nom_corrige2": "Hazen Whittom",
    "nom_famille": "Whittom",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "2211",
    "nom_corrige2": "Claudie Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseillère",
    "remuneration": "10313",
    "allocation": "4673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14986",
    "ville": "Saint-Césaire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "6051"
  },
  {
    "ID": "2212",
    "nom_corrige2": "Évans Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseiller",
    "remuneration": "9984",
    "allocation": "4992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14976",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2213",
    "nom_corrige2": "Luc Maltais",
    "nom_famille": "Maltais",
    "titre_genre2": "Conseiller",
    "remuneration": "9984",
    "allocation": "4992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14976",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2214",
    "nom_corrige2": "Renée-Claude Pichette",
    "nom_famille": "Pichette",
    "titre_genre2": "Conseillère",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14961",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2215",
    "nom_corrige2": "Francyne Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14961",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2216",
    "nom_corrige2": "Francis Bellemare",
    "nom_famille": "Bellemare",
    "titre_genre2": "Conseiller",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14961",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2217",
    "nom_corrige2": "Danie Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "9974",
    "allocation": "4987",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14961",
    "ville": "Donnacona",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "7663"
  },
  {
    "ID": "2218",
    "nom_corrige2": "Pierre Brosseau",
    "nom_famille": "Brosseau",
    "titre_genre2": "Maire",
    "remuneration": "6442",
    "allocation": "3221",
    "remuneration2": "3531",
    "allocation2": "1766",
    "total": "14960",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "2219",
    "nom_corrige2": "Gérald Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Maire",
    "remuneration": "8814",
    "allocation": "4407",
    "remuneration2": "1144",
    "allocation2": "572",
    "total": "14937",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "2220",
    "nom_corrige2": "Anick Campeau",
    "nom_famille": "Campeau",
    "titre_genre2": "Conseillère",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14908",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2221",
    "nom_corrige2": "Stéphanie Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseillère",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14908",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2222",
    "nom_corrige2": "Caroline Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseillère",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14908",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2223",
    "nom_corrige2": "Dave Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseiller",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14908",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2224",
    "nom_corrige2": "Germain Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "9939",
    "allocation": "4969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14908",
    "ville": "Saint-Lambert-de-Lauzon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "7004"
  },
  {
    "ID": "2225",
    "nom_corrige2": "Daniel Barrette",
    "nom_famille": "Barrette",
    "titre_genre2": "Maire",
    "remuneration": "10000",
    "allocation": "4898",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14898",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "2226",
    "nom_corrige2": "Renée Thiboutot",
    "nom_famille": "Thiboutot",
    "titre_genre2": "Conseillère",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2227",
    "nom_corrige2": "Steve Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2228",
    "nom_corrige2": "Réjean Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2229",
    "nom_corrige2": "Pierre Bourget",
    "nom_famille": "Bourget",
    "titre_genre2": "Conseiller",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2230",
    "nom_corrige2": "Victor Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2231",
    "nom_corrige2": "Karine Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseillère",
    "remuneration": "9929",
    "allocation": "4964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14893",
    "ville": "La Sarre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "7201"
  },
  {
    "ID": "2232",
    "nom_corrige2": "Marcel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2233",
    "nom_corrige2": "Mario Guérin",
    "nom_famille": "Guérin",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2234",
    "nom_corrige2": "Claude Poupart",
    "nom_famille": "Poupart",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2235",
    "nom_corrige2": "Mario Isabelle",
    "nom_famille": "Isabelle",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2236",
    "nom_corrige2": "Patrick Phaneuf",
    "nom_famille": "Phaneuf",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2237",
    "nom_corrige2": "Patrice Lirette",
    "nom_famille": "Lirette",
    "titre_genre2": "Conseiller",
    "remuneration": "9922",
    "allocation": "4961",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14883",
    "ville": "Saint-Michel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3693"
  },
  {
    "ID": "2238",
    "nom_corrige2": "Patricia Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseillère",
    "remuneration": "9884",
    "allocation": "4992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14876",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2239",
    "nom_corrige2": "Martin Voyer",
    "nom_famille": "Voyer",
    "titre_genre2": "Conseiller",
    "remuneration": "9884",
    "allocation": "4992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14876",
    "ville": "Métabetchouan-Lac-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3955"
  },
  {
    "ID": "2240",
    "nom_corrige2": "AGNES MCKELL",
    "nom_famille": "MCKELL",
    "titre_genre2": "Mairesse",
    "remuneration": "9989",
    "allocation": "4882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14871",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "2241",
    "nom_corrige2": "Annie Sylvestre",
    "nom_famille": "Sylvestre",
    "titre_genre2": "Conseillère",
    "remuneration": "9909",
    "allocation": "4954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14863",
    "ville": "Saint-Cuthbert",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1929"
  },
  {
    "ID": "2242",
    "nom_corrige2": "NAJAT TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseillère",
    "remuneration": "9887",
    "allocation": "4943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14830",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2243",
    "nom_corrige2": "VALÉRIE ROY",
    "nom_famille": "ROY",
    "titre_genre2": "Conseillère",
    "remuneration": "9887",
    "allocation": "4943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14830",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2244",
    "nom_corrige2": "ELISABETH BOILY",
    "nom_famille": "BOILY",
    "titre_genre2": "Conseillère",
    "remuneration": "9887",
    "allocation": "4943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14830",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2245",
    "nom_corrige2": "André Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "9383",
    "allocation": "4691",
    "remuneration2": "500",
    "allocation2": "250",
    "total": "14824",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "2246",
    "nom_corrige2": "Charles-André Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseiller",
    "remuneration": "9864",
    "allocation": "4932",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14796",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "2247",
    "nom_corrige2": "Martine Verville",
    "nom_famille": "Verville",
    "titre_genre2": "Mairesse",
    "remuneration": "4888",
    "allocation": "2444",
    "remuneration2": "4972",
    "allocation2": "2486",
    "total": "14790",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "2248",
    "nom_corrige2": "Nadia Bissada",
    "nom_famille": "Bissada",
    "titre_genre2": "Conseillère",
    "remuneration": "9849",
    "allocation": "4925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14774",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "2249",
    "nom_corrige2": "Brigitte Chartrand",
    "nom_famille": "Chartrand",
    "titre_genre2": "Conseillère",
    "remuneration": "9849",
    "allocation": "4925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14774",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "2250",
    "nom_corrige2": "Stephen Gruber",
    "nom_famille": "Gruber",
    "titre_genre2": "Conseiller",
    "remuneration": "9849",
    "allocation": "4925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14774",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "2251",
    "nom_corrige2": "Wanda Lowensteyn",
    "nom_famille": "Lowensteyn",
    "titre_genre2": "Conseillère",
    "remuneration": "9849",
    "allocation": "4925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14774",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "2252",
    "nom_corrige2": "MÉLISSA THÉBERGE",
    "nom_famille": "THÉBERGE",
    "titre_genre2": "Conseillère",
    "remuneration": "9844",
    "allocation": "4922",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14766",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2253",
    "nom_corrige2": "Jean Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Maire",
    "remuneration": "8195",
    "allocation": "4097",
    "remuneration2": "2471",
    "allocation2": "0",
    "total": "14763",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "2254",
    "nom_corrige2": "Anik Corminboeuf",
    "nom_famille": "Corminboeuf",
    "titre_genre2": "Mairesse",
    "remuneration": "5957",
    "allocation": "2979",
    "remuneration2": "2318",
    "allocation2": "3478",
    "total": "14732",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "2255",
    "nom_corrige2": "SYLVAIN MOREL",
    "nom_famille": "MOREL",
    "titre_genre2": "Conseiller",
    "remuneration": "9820",
    "allocation": "4910",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14730",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2256",
    "nom_corrige2": "RICHARD CARON",
    "nom_famille": "CARON",
    "titre_genre2": "Maire",
    "remuneration": "7488",
    "allocation": "3744",
    "remuneration2": "2318",
    "allocation2": "1159",
    "total": "14709",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "2257",
    "nom_corrige2": "Donald Kenny",
    "nom_famille": "Kenny",
    "titre_genre2": "Maire",
    "remuneration": "6876",
    "allocation": "3279",
    "remuneration2": "4553",
    "allocation2": "0",
    "total": "14708",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "2258",
    "nom_corrige2": "Mélanie Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseillère",
    "remuneration": "9800",
    "allocation": "4900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14700",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2259",
    "nom_corrige2": "Jeannot Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "4727",
    "allocation": "2435",
    "remuneration2": "5019",
    "allocation2": "2510",
    "total": "14691",
    "ville": "Saint-Joseph-des-Érables",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "423"
  },
  {
    "ID": "2260",
    "nom_corrige2": "Rachelle Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Mairesse",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "3561",
    "allocation2": "1582",
    "total": "14638",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "2261",
    "nom_corrige2": "PETER VILLENEUVE",
    "nom_famille": "VILLENEUVE",
    "titre_genre2": "Conseiller",
    "remuneration": "9753",
    "allocation": "4877",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14630",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2262",
    "nom_corrige2": "Sylvain Payette",
    "nom_famille": "Payette",
    "titre_genre2": "Conseiller",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2263",
    "nom_corrige2": "Richard Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2264",
    "nom_corrige2": "Sylvie Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseillère",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2265",
    "nom_corrige2": "Antoine Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2266",
    "nom_corrige2": "Nadine Desforges",
    "nom_famille": "Desforges",
    "titre_genre2": "Conseillère",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2267",
    "nom_corrige2": "Carole Brisebois Vendette",
    "nom_famille": "Brisebois",
    "titre_genre2": "Conseiller",
    "remuneration": "9751",
    "allocation": "4876",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14627",
    "ville": "Saint-Roch-de-l'Achigan",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5725"
  },
  {
    "ID": "2268",
    "nom_corrige2": "Nathalie Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Mairesse",
    "remuneration": "7397",
    "allocation": "3699",
    "remuneration2": "2318",
    "allocation2": "1159",
    "total": "14573",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "2269",
    "nom_corrige2": "SARA PERREAULT",
    "nom_famille": "PERREAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "9687",
    "allocation": "4879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14566",
    "ville": "Saint-Honoré",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "6612"
  },
  {
    "ID": "2270",
    "nom_corrige2": "Drew Somerville",
    "nom_famille": "Somerville",
    "titre_genre2": "Maire",
    "remuneration": "6715",
    "allocation": "2137",
    "remuneration2": "3802",
    "allocation2": "1906",
    "total": "14560",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "2271",
    "nom_corrige2": "Andrew Etheridge",
    "nom_famille": "Etheridge",
    "titre_genre2": "Maire",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2272",
    "nom_corrige2": "Dany Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2273",
    "nom_corrige2": "Jarvin Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2274",
    "nom_corrige2": "Gabrielle Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Mairesse",
    "remuneration": "10000",
    "allocation": "5000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "2275",
    "nom_corrige2": "Guillaume Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "9669",
    "allocation": "4835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14504",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "2276",
    "nom_corrige2": "Daren Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2277",
    "nom_corrige2": "Douglas Smith",
    "nom_famille": "Smith",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2278",
    "nom_corrige2": "Mark Gray",
    "nom_famille": "Gray",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2279",
    "nom_corrige2": "Peter Mate",
    "nom_famille": "Mate",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2280",
    "nom_corrige2": "Reid Thompson",
    "nom_famille": "Thompson",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2281",
    "nom_corrige2": "Benoît Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "9659",
    "allocation": "4830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14489",
    "ville": "Hudson",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5614"
  },
  {
    "ID": "2282",
    "nom_corrige2": "Chantale Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "9593",
    "allocation": "4797",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14390",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2283",
    "nom_corrige2": "Patrice Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Maire",
    "remuneration": "7674",
    "allocation": "3837",
    "remuneration2": "1905",
    "allocation2": "953",
    "total": "14369",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "2284",
    "nom_corrige2": "Stéphane Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Conseiller",
    "remuneration": "9333",
    "allocation": "4667",
    "remuneration2": "300",
    "allocation2": "0",
    "total": "14300",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2285",
    "nom_corrige2": "Nicole Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseillère",
    "remuneration": "1478",
    "allocation": "739",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2217",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "2286",
    "nom_corrige2": "Réal Ducharme",
    "nom_famille": "Ducharme",
    "titre_genre2": "Conseiller",
    "remuneration": "9504",
    "allocation": "4752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14256",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2287",
    "nom_corrige2": "Dominique Majeau",
    "nom_famille": "Majeau",
    "titre_genre2": "Conseiller",
    "remuneration": "9500",
    "allocation": "4750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14250",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "2288",
    "nom_corrige2": "Alain Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseiller",
    "remuneration": "9500",
    "allocation": "4750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14250",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "2289",
    "nom_corrige2": "Camille Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2290",
    "nom_corrige2": "Stéphane Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseiller",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2291",
    "nom_corrige2": "Vincent Villemure",
    "nom_famille": "Villemure",
    "titre_genre2": "Conseiller",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2292",
    "nom_corrige2": "Marc Magny",
    "nom_famille": "Magny",
    "titre_genre2": "Conseiller",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2293",
    "nom_corrige2": "Claude Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2294",
    "nom_corrige2": "Éric Ennis",
    "nom_famille": "Ennis",
    "titre_genre2": "Conseiller",
    "remuneration": "9490",
    "allocation": "4745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14235",
    "ville": "Saint-Ferréol-les-Neiges",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3646"
  },
  {
    "ID": "2295",
    "nom_corrige2": "Martine Renaud",
    "nom_famille": "Renaud",
    "titre_genre2": "Conseillère",
    "remuneration": "9486",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14229",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "2296",
    "nom_corrige2": "Pierre Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Conseiller",
    "remuneration": "9486",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14229",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "2297",
    "nom_corrige2": "Marilou Laurin",
    "nom_famille": "Laurin",
    "titre_genre2": "Conseillère",
    "remuneration": "9486",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14229",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "2298",
    "nom_corrige2": "Louis Quevillon",
    "nom_famille": "Quevillon",
    "titre_genre2": "Conseiller",
    "remuneration": "9486",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14229",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "2299",
    "nom_corrige2": "André Junior Florestal",
    "nom_famille": "Florestal",
    "titre_genre2": "Conseiller",
    "remuneration": "9486",
    "allocation": "4743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14229",
    "ville": "Brownsburg-Chatham",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "7772"
  },
  {
    "ID": "2300",
    "nom_corrige2": "Richard Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Maire",
    "remuneration": "7900",
    "allocation": "3950",
    "remuneration2": "1561",
    "allocation2": "780",
    "total": "14191",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "2301",
    "nom_corrige2": "Christian Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Maire",
    "remuneration": "9443",
    "allocation": "4721",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14164",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "2302",
    "nom_corrige2": "Pierre Chamberland",
    "nom_famille": "Chamberland",
    "titre_genre2": "Maire",
    "remuneration": "9412",
    "allocation": "4706",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14118",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "2303",
    "nom_corrige2": "Marcel Beaubien",
    "nom_famille": "Beaubien",
    "titre_genre2": "Maire",
    "remuneration": "9410",
    "allocation": "4705",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14115",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "2304",
    "nom_corrige2": "Patrick Clowerey",
    "nom_famille": "Clowerey",
    "titre_genre2": "Conseiller",
    "remuneration": "8743",
    "allocation": "4372",
    "remuneration2": "667",
    "allocation2": "333",
    "total": "14115",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2305",
    "nom_corrige2": "Daniel Gélineau",
    "nom_famille": "Gélineau",
    "titre_genre2": "Maire",
    "remuneration": "5333",
    "allocation": "3717",
    "remuneration2": "3375",
    "allocation2": "1687",
    "total": "14112",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "2306",
    "nom_corrige2": "Jean-Marc Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Maire",
    "remuneration": "7218",
    "allocation": "3609",
    "remuneration2": "2175",
    "allocation2": "1087",
    "total": "14089",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "2307",
    "nom_corrige2": "Alain Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Maire",
    "remuneration": "7803",
    "allocation": "3902",
    "remuneration2": "1589",
    "allocation2": "795",
    "total": "14089",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "2308",
    "nom_corrige2": "Yves Duval",
    "nom_famille": "Duval",
    "titre_genre2": "Conseiller",
    "remuneration": "10622",
    "allocation": "3447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14069",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2309",
    "nom_corrige2": "Martin Bellefroid",
    "nom_famille": "Bellefroid",
    "titre_genre2": "Maire",
    "remuneration": "9369",
    "allocation": "4685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14054",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "2310",
    "nom_corrige2": "Jacques Bourassa",
    "nom_famille": "Bourassa",
    "titre_genre2": "Conseiller",
    "remuneration": "9358",
    "allocation": "4679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14037",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2311",
    "nom_corrige2": "Jo-Ann Quérel",
    "nom_famille": "Quérel",
    "titre_genre2": "Conseillère",
    "remuneration": "9342",
    "allocation": "4671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14013",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "2312",
    "nom_corrige2": "Tania Ann Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "9342",
    "allocation": "4671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14013",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "2313",
    "nom_corrige2": "Jacques Darche",
    "nom_famille": "Darche",
    "titre_genre2": "Conseiller",
    "remuneration": "9342",
    "allocation": "4671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14013",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "2314",
    "nom_corrige2": "Lucie Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseillère",
    "remuneration": "9342",
    "allocation": "4671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14013",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "2315",
    "nom_corrige2": "Luc Belanger",
    "nom_famille": "Belanger",
    "titre_genre2": "Conseiller",
    "remuneration": "9342",
    "allocation": "4671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14013",
    "ville": "Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5619"
  },
  {
    "ID": "2316",
    "nom_corrige2": "Frédéric Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Maire",
    "remuneration": "9335",
    "allocation": "4663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13998",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "2317",
    "nom_corrige2": "Roland Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Maire",
    "remuneration": "9330",
    "allocation": "4665",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13995",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "2318",
    "nom_corrige2": "Danye Anctil",
    "nom_famille": "Anctil",
    "titre_genre2": "Maire",
    "remuneration": "4732",
    "allocation": "2366",
    "remuneration2": "4373",
    "allocation2": "2516",
    "total": "13987",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "2319",
    "nom_corrige2": "Luce Bouley",
    "nom_famille": "Bouley",
    "titre_genre2": "Conseillère",
    "remuneration": "9314",
    "allocation": "4657",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13971",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2320",
    "nom_corrige2": "Marie-Claude Létourneau-Larose",
    "nom_famille": "Létourneau-Larose",
    "titre_genre2": "Conseillère",
    "remuneration": "9314",
    "allocation": "4657",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13971",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2321",
    "nom_corrige2": "Yvon Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Maire",
    "remuneration": "4889",
    "allocation": "2445",
    "remuneration2": "4590",
    "allocation2": "2040",
    "total": "13964",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "2322",
    "nom_corrige2": "Emmanuelle Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "9398",
    "allocation": "4563",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13961",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2323",
    "nom_corrige2": "Léo Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Maire",
    "remuneration": "7195",
    "allocation": "3597",
    "remuneration2": "2109",
    "allocation2": "1055",
    "total": "13956",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "2324",
    "nom_corrige2": "Michael Tuppert",
    "nom_famille": "Tuppert",
    "titre_genre2": "Conseiller",
    "remuneration": "9389",
    "allocation": "4563",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13952",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2325",
    "nom_corrige2": "Manon Huard",
    "nom_famille": "Huard",
    "titre_genre2": "Conseillère",
    "remuneration": "9389",
    "allocation": "4563",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13952",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2326",
    "nom_corrige2": "Roxane Boutet",
    "nom_famille": "Boutet",
    "titre_genre2": "Conseillère",
    "remuneration": "9389",
    "allocation": "4563",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13952",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2327",
    "nom_corrige2": "Lucie Nicolas",
    "nom_famille": "Nicolas",
    "titre_genre2": "Conseillère",
    "remuneration": "9295",
    "allocation": "4647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13942",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2328",
    "nom_corrige2": "Léopold Briand",
    "nom_famille": "Briand",
    "titre_genre2": "Conseiller",
    "remuneration": "9295",
    "allocation": "4647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13942",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2329",
    "nom_corrige2": "Denis Anderson",
    "nom_famille": "Anderson",
    "titre_genre2": "Conseiller",
    "remuneration": "9295",
    "allocation": "4647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13942",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2330",
    "nom_corrige2": "Carol Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Conseiller",
    "remuneration": "9295",
    "allocation": "4647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13942",
    "ville": "Grande-Rivière",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3427"
  },
  {
    "ID": "2331",
    "nom_corrige2": "Benoit Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Maire",
    "remuneration": "5647",
    "allocation": "2823",
    "remuneration2": "3638",
    "allocation2": "1819",
    "total": "13927",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "2332",
    "nom_corrige2": "Hervé Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Maire",
    "remuneration": "9408",
    "allocation": "4502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13910",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "2333",
    "nom_corrige2": "Myriam Deroy",
    "nom_famille": "Deroy",
    "titre_genre2": "Conseiller",
    "remuneration": "9345",
    "allocation": "4563",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13908",
    "ville": "Fossambault-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2323"
  },
  {
    "ID": "2334",
    "nom_corrige2": "Roger Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "13889",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2335",
    "nom_corrige2": "Alain Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Maire",
    "remuneration": "6915",
    "allocation": "3458",
    "remuneration2": "2321",
    "allocation2": "1160",
    "total": "13854",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "2336",
    "nom_corrige2": "André Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "9224",
    "allocation": "4612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13836",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2337",
    "nom_corrige2": "Jean Morency",
    "nom_famille": "Morency",
    "titre_genre2": "Maire",
    "remuneration": "8485",
    "allocation": "4367",
    "remuneration2": "622",
    "allocation2": "311",
    "total": "13785",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "2338",
    "nom_corrige2": "Lynda Tétreault",
    "nom_famille": "Tétreault",
    "titre_genre2": "Mairesse",
    "remuneration": "7102",
    "allocation": "3551",
    "remuneration2": "2076",
    "allocation2": "1038",
    "total": "13767",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "2339",
    "nom_corrige2": "Hélène Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "8667",
    "allocation": "4333",
    "remuneration2": "478",
    "allocation2": "239",
    "total": "13717",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2340",
    "nom_corrige2": "Yves S. Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "9107",
    "allocation": "4554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13661",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2341",
    "nom_corrige2": "Richard Harland",
    "nom_famille": "Harland",
    "titre_genre2": "Conseiller",
    "remuneration": "9106",
    "allocation": "4553",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13659",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2342",
    "nom_corrige2": "Nicolas Bottreau",
    "nom_famille": "Bottreau",
    "titre_genre2": "Conseiller",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2343",
    "nom_corrige2": "Noémie Biardeau",
    "nom_famille": "Biardeau",
    "titre_genre2": "Conseillère",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2344",
    "nom_corrige2": "Annick Laviolette",
    "nom_famille": "Laviolette",
    "titre_genre2": "Conseillère",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2345",
    "nom_corrige2": "Vincent Normandeau",
    "nom_famille": "Normandeau",
    "titre_genre2": "Conseiller",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2346",
    "nom_corrige2": "Isabelle Laramée",
    "nom_famille": "Laramée",
    "titre_genre2": "Conseillère",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2347",
    "nom_corrige2": "Julie Marchildon",
    "nom_famille": "Marchildon",
    "titre_genre2": "Conseillère",
    "remuneration": "9073",
    "allocation": "4537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13610",
    "ville": "Labelle",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2537"
  },
  {
    "ID": "2348",
    "nom_corrige2": "FRANÇOIS MARCOTTE",
    "nom_famille": "MARCOTTE",
    "titre_genre2": "Maire",
    "remuneration": "9069",
    "allocation": "4535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13604",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "2349",
    "nom_corrige2": "Michel Colpron",
    "nom_famille": "Colpron",
    "titre_genre2": "Maire",
    "remuneration": "6763",
    "allocation": "3381",
    "remuneration2": "2282",
    "allocation2": "1141",
    "total": "13567",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "2350",
    "nom_corrige2": "ALAIN VEILLEUX",
    "nom_famille": "VEILLEUX",
    "titre_genre2": "Maire",
    "remuneration": "7527",
    "allocation": "3763",
    "remuneration2": "1517",
    "allocation2": "759",
    "total": "13566",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "2351",
    "nom_corrige2": "Pierre Le Blanc",
    "nom_famille": "Le",
    "titre_genre2": "Conseiller",
    "remuneration": "9263",
    "allocation": "3957",
    "remuneration2": "227",
    "allocation2": "114",
    "total": "13561",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "2352",
    "nom_corrige2": "Sylvie Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "1552",
    "allocation2": "0",
    "total": "13552",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2353",
    "nom_corrige2": "Robert Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Conseiller",
    "remuneration": "10097",
    "allocation": "3447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13544",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2354",
    "nom_corrige2": "Marcel Charpentier",
    "nom_famille": "Charpentier",
    "titre_genre2": "Conseiller",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13530",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2355",
    "nom_corrige2": "Alain Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13530",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2356",
    "nom_corrige2": "Josée Pérusse",
    "nom_famille": "Pérusse",
    "titre_genre2": "Conseiller",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13530",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2357",
    "nom_corrige2": "Daphné Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseillère",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13530",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2358",
    "nom_corrige2": "Cindy Duquette St-Louis",
    "nom_famille": "Duquette",
    "titre_genre2": "Conseillère",
    "remuneration": "4510",
    "allocation": "9020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13530",
    "ville": "Cookshire-Eaton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "5523"
  },
  {
    "ID": "2359",
    "nom_corrige2": "Sylvain Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "9018",
    "allocation": "4509",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13527",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2360",
    "nom_corrige2": "Alain Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseiller",
    "remuneration": "9018",
    "allocation": "4509",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13527",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2361",
    "nom_corrige2": "Miguel Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Maire",
    "remuneration": "7346",
    "allocation": "3833",
    "remuneration2": "1547",
    "allocation2": "774",
    "total": "13500",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "2362",
    "nom_corrige2": "René Guimond",
    "nom_famille": "Guimond",
    "titre_genre2": "Maire",
    "remuneration": "6862",
    "allocation": "3433",
    "remuneration2": "2127",
    "allocation2": "1064",
    "total": "13486",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "2363",
    "nom_corrige2": "Chantal Crête",
    "nom_famille": "Crête",
    "titre_genre2": "Conseillère",
    "remuneration": "8990",
    "allocation": "4495",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13485",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2364",
    "nom_corrige2": "Stéphane Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Conseiller",
    "remuneration": "9076",
    "allocation": "4405",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13481",
    "ville": "Sainte-Catherine-de-Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2773"
  },
  {
    "ID": "2365",
    "nom_corrige2": "Éric Chartier",
    "nom_famille": "Chartier",
    "titre_genre2": "Maire",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "1985",
    "allocation2": "993",
    "total": "13478",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "2366",
    "nom_corrige2": "Kimberly Meyer",
    "nom_famille": "Meyer",
    "titre_genre2": "Conseillère",
    "remuneration": "8984",
    "allocation": "4492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13476",
    "ville": "Mont-Tremblant",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "11121"
  },
  {
    "ID": "2367",
    "nom_corrige2": "François Gagné-Bérubé",
    "nom_famille": "Gagné-Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "8881",
    "allocation": "4440",
    "remuneration2": "97",
    "allocation2": "49",
    "total": "13467",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2368",
    "nom_corrige2": "Isabel Boulay",
    "nom_famille": "Boulay",
    "titre_genre2": "Conseillère",
    "remuneration": "7775",
    "allocation": "3887",
    "remuneration2": "1200",
    "allocation2": "600",
    "total": "13462",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2369",
    "nom_corrige2": "DENIS PAGÉ",
    "nom_famille": "PAGÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "8975",
    "allocation": "4487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13462",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2370",
    "nom_corrige2": "Claude Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Maire",
    "remuneration": "6492",
    "allocation": "3246",
    "remuneration2": "2186",
    "allocation2": "1520",
    "total": "13444",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "2371",
    "nom_corrige2": "Mélissa Lord",
    "nom_famille": "Lord",
    "titre_genre2": "Mairesse",
    "remuneration": "9024",
    "allocation": "4401",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13425",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "2372",
    "nom_corrige2": "Jacques Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Maire",
    "remuneration": "7045",
    "allocation": "3523",
    "remuneration2": "1867",
    "allocation2": "933",
    "total": "13368",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "2373",
    "nom_corrige2": "Michel Rhéaume",
    "nom_famille": "Rhéaume",
    "titre_genre2": "Conseiller",
    "remuneration": "8896",
    "allocation": "4448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13344",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2374",
    "nom_corrige2": "Michel Bazinet",
    "nom_famille": "Bazinet",
    "titre_genre2": "Conseiller",
    "remuneration": "7611",
    "allocation": "3806",
    "remuneration2": "1900",
    "allocation2": "0",
    "total": "13317",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2375",
    "nom_corrige2": "Gaétan Lacelle",
    "nom_famille": "Lacelle",
    "titre_genre2": "Conseiller",
    "remuneration": "8877",
    "allocation": "4438",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13315",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2376",
    "nom_corrige2": "Bruno Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Maire",
    "remuneration": "5261",
    "allocation": "2131",
    "remuneration2": "3940",
    "allocation2": "1970",
    "total": "13302",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "2377",
    "nom_corrige2": "ANDRÉ SIMARD",
    "nom_famille": "SIMARD",
    "titre_genre2": "Maire",
    "remuneration": "8843",
    "allocation": "4422",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13265",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "2378",
    "nom_corrige2": "Hélène St-Cyr",
    "nom_famille": "St-Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "8836",
    "allocation": "4418",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13254",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2379",
    "nom_corrige2": "Robert Laperrière",
    "nom_famille": "Laperrière",
    "titre_genre2": "Conseiller",
    "remuneration": "9793",
    "allocation": "3447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13240",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2380",
    "nom_corrige2": "Gerry Clark",
    "nom_famille": "Clark",
    "titre_genre2": "Conseiller",
    "remuneration": "7367",
    "allocation": "3684",
    "remuneration2": "1456",
    "allocation2": "728",
    "total": "13235",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2381",
    "nom_corrige2": "Martine Brouard",
    "nom_famille": "Brouard",
    "titre_genre2": "Mairesse",
    "remuneration": "7055",
    "allocation": "3527",
    "remuneration2": "1766",
    "allocation2": "883",
    "total": "13231",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "2382",
    "nom_corrige2": "Marie-Josée Lamothe",
    "nom_famille": "Lamothe",
    "titre_genre2": "Conseillère",
    "remuneration": "9263",
    "allocation": "3957",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13220",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "2383",
    "nom_corrige2": "Dominic Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseiller",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2384",
    "nom_corrige2": "Annie Dubeau",
    "nom_famille": "Dubeau",
    "titre_genre2": "Conseillère",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2385",
    "nom_corrige2": "Claude Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2386",
    "nom_corrige2": "Gilles Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseiller",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2387",
    "nom_corrige2": "Katherine Ramacieri L'Heureux",
    "nom_famille": "Ramacieri",
    "titre_genre2": "Conseillère",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2388",
    "nom_corrige2": "Nathalie Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Conseillère",
    "remuneration": "8393",
    "allocation": "4826",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13219",
    "ville": "Verchères",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5844"
  },
  {
    "ID": "2389",
    "nom_corrige2": "Denis Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseiller",
    "remuneration": "8795",
    "allocation": "4398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13193",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2390",
    "nom_corrige2": "Joseph Kula",
    "nom_famille": "Kula",
    "titre_genre2": "Conseiller",
    "remuneration": "8795",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13192",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2391",
    "nom_corrige2": "Benoit Thibeault",
    "nom_famille": "Thibeault",
    "titre_genre2": "Conseiller",
    "remuneration": "8795",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13192",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2392",
    "nom_corrige2": "Marie Segleski",
    "nom_famille": "Segleski",
    "titre_genre2": "Conseillère",
    "remuneration": "8795",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13192",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2393",
    "nom_corrige2": "Brigitte Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "8795",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13192",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2394",
    "nom_corrige2": "Joëlle Kergoat",
    "nom_famille": "Kergoat",
    "titre_genre2": "Conseillère",
    "remuneration": "9755",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14152",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2395",
    "nom_corrige2": "Raphael Ciccariello",
    "nom_famille": "Ciccariello",
    "titre_genre2": "Conseiller",
    "remuneration": "9275",
    "allocation": "4397",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13672",
    "ville": "La Macaza",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1153"
  },
  {
    "ID": "2396",
    "nom_corrige2": "Alain Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Maire",
    "remuneration": "5190",
    "allocation": "2595",
    "remuneration2": "3593",
    "allocation2": "1796",
    "total": "13174",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "2397",
    "nom_corrige2": "Daniel Audette",
    "nom_famille": "Audette",
    "titre_genre2": "Conseiller",
    "remuneration": "9213",
    "allocation": "3957",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13170",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "2398",
    "nom_corrige2": "SÉBASTIEN LÉVESQUE",
    "nom_famille": "LÉVESQUE",
    "titre_genre2": "Maire",
    "remuneration": "8771",
    "allocation": "4386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13157",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "2399",
    "nom_corrige2": "Réjean Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Maire",
    "remuneration": "4586",
    "allocation": "2293",
    "remuneration2": "4182",
    "allocation2": "2090",
    "total": "13151",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "2400",
    "nom_corrige2": "Guy Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Maire",
    "remuneration": "8760",
    "allocation": "4380",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13140",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "2401",
    "nom_corrige2": "Julien Normand",
    "nom_famille": "Normand",
    "titre_genre2": "Maire",
    "remuneration": "8750",
    "allocation": "4375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13125",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "2402",
    "nom_corrige2": "Rémi Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "8746",
    "allocation": "4373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13119",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2403",
    "nom_corrige2": "Pierre Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "8717",
    "allocation": "4359",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13076",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2404",
    "nom_corrige2": "Patrick Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "8712",
    "allocation": "4356",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13068",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2405",
    "nom_corrige2": "Robin Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "13059",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13059",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "2406",
    "nom_corrige2": "Pascal Vermette",
    "nom_famille": "Vermette",
    "titre_genre2": "Conseiller",
    "remuneration": "13059",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13059",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "2407",
    "nom_corrige2": "Lyne Clermont",
    "nom_famille": "Clermont",
    "titre_genre2": "Conseillère",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "254",
    "allocation2": "127",
    "total": "13050",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2408",
    "nom_corrige2": "Luc Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "8647",
    "allocation": "3447",
    "remuneration2": "950",
    "allocation2": "0",
    "total": "13044",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2409",
    "nom_corrige2": "Sylvie Cassar",
    "nom_famille": "Cassar",
    "titre_genre2": "Conseillère",
    "remuneration": "8695",
    "allocation": "4348",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13043",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2410",
    "nom_corrige2": "Rodrigue Saint-Laurent",
    "nom_famille": "Saint-Laurent",
    "titre_genre2": "Conseiller",
    "remuneration": "8691",
    "allocation": "4346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13037",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2411",
    "nom_corrige2": "Simon St-Hilaire",
    "nom_famille": "St-Hilaire",
    "titre_genre2": "Conseiller",
    "remuneration": "8668",
    "allocation": "4334",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "13002",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "2412",
    "nom_corrige2": "Sarah McAlden",
    "nom_famille": "McAlden",
    "titre_genre2": "Conseillère",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2413",
    "nom_corrige2": "Chantal St-Martin",
    "nom_famille": "St-Martin",
    "titre_genre2": "Conseillère",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2414",
    "nom_corrige2": "Patrice Boislard",
    "nom_famille": "Boislard",
    "titre_genre2": "Conseiller",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2415",
    "nom_corrige2": "Chantal Nault",
    "nom_famille": "Nault",
    "titre_genre2": "Conseillère",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2416",
    "nom_corrige2": "Jean-François Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2417",
    "nom_corrige2": "Sylvain Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "8656",
    "allocation": "4328",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12984",
    "ville": "Saint-Germain-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5048"
  },
  {
    "ID": "2418",
    "nom_corrige2": "Marie-Pier Tougas-Dupuis",
    "nom_famille": "Tougas-Dupuis",
    "titre_genre2": "Conseillère",
    "remuneration": "9013",
    "allocation": "3957",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12970",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "2419",
    "nom_corrige2": "Marilou Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseillère",
    "remuneration": "8642",
    "allocation": "4321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12963",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2420",
    "nom_corrige2": "YANNICK BÉDARD",
    "nom_famille": "BÉDARD",
    "titre_genre2": "Conseiller",
    "remuneration": "8635",
    "allocation": "4317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12952",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2421",
    "nom_corrige2": "Hossein Falsafi",
    "nom_famille": "Falsafi",
    "titre_genre2": "Conseiller",
    "remuneration": "8632",
    "allocation": "4316",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12948",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2422",
    "nom_corrige2": "David Monette",
    "nom_famille": "Monette",
    "titre_genre2": "Conseiller",
    "remuneration": "8628",
    "allocation": "4314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12942",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "2423",
    "nom_corrige2": "Fréderic Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "8617",
    "allocation": "4308",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12925",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2424",
    "nom_corrige2": "DANIEL DODIER",
    "nom_famille": "DODIER",
    "titre_genre2": "Conseiller",
    "remuneration": "8427",
    "allocation": "4470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12897",
    "ville": "Stoke",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3240"
  },
  {
    "ID": "2425",
    "nom_corrige2": "Jacques Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseiller",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2426",
    "nom_corrige2": "Jean-Guy Mongrain",
    "nom_famille": "Mongrain",
    "titre_genre2": "Conseiller",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2427",
    "nom_corrige2": "Marylène Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseillère",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2428",
    "nom_corrige2": "Julie Régis",
    "nom_famille": "Régis",
    "titre_genre2": "Conseillère",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2429",
    "nom_corrige2": "Daniel Duchemin",
    "nom_famille": "Duchemin",
    "titre_genre2": "Conseiller",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2430",
    "nom_corrige2": "Clément Pratte",
    "nom_famille": "Pratte",
    "titre_genre2": "Conseiller",
    "remuneration": "8592",
    "allocation": "4296",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12888",
    "ville": "Notre-Dame-du-Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "6413"
  },
  {
    "ID": "2431",
    "nom_corrige2": "Pierre Imbault",
    "nom_famille": "Imbault",
    "titre_genre2": "Conseiller",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2432",
    "nom_corrige2": "Julie Soulard",
    "nom_famille": "Soulard",
    "titre_genre2": "Conseillère",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2433",
    "nom_corrige2": "Audrey Hottin",
    "nom_famille": "Hottin",
    "titre_genre2": "Conseillère",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2434",
    "nom_corrige2": "Daniel Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2435",
    "nom_corrige2": "Réjean Marcheterre-Riopel",
    "nom_famille": "Marcheterre-Riopel",
    "titre_genre2": "Conseiller",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2436",
    "nom_corrige2": "Jessica Laforest-Robitaille",
    "nom_famille": "Laforest-Robitaille",
    "titre_genre2": "Conseillère",
    "remuneration": "8590",
    "allocation": "4295",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12885",
    "ville": "Saint-Sulpice",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3413"
  },
  {
    "ID": "2437",
    "nom_corrige2": "Yves Gnocchini",
    "nom_famille": "Gnocchini",
    "titre_genre2": "Conseiller",
    "remuneration": "8913",
    "allocation": "3957",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12870",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2684"
  },
  {
    "ID": "2438",
    "nom_corrige2": "ERIC LESSARD",
    "nom_famille": "LESSARD",
    "titre_genre2": "Conseiller",
    "remuneration": "8760",
    "allocation": "4110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12870",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2439",
    "nom_corrige2": "Luc Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Maire",
    "remuneration": "6374",
    "allocation": "3187",
    "remuneration2": "2205",
    "allocation2": "1102",
    "total": "12868",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "2440",
    "nom_corrige2": "CLAIRE RIOUX",
    "nom_famille": "RIOUX",
    "titre_genre2": "Mairesse",
    "remuneration": "6408",
    "allocation": "3408",
    "remuneration2": "2032",
    "allocation2": "1016",
    "total": "12864",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "2441",
    "nom_corrige2": "Maurice Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseiller",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2442",
    "nom_corrige2": "Lucie Lanteigne",
    "nom_famille": "Lanteigne",
    "titre_genre2": "Conseillère",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2443",
    "nom_corrige2": "Carol Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2444",
    "nom_corrige2": "Patrick McDonald",
    "nom_famille": "McDonald",
    "titre_genre2": "Conseiller",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2445",
    "nom_corrige2": "Charles Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2446",
    "nom_corrige2": "Yves Boileau",
    "nom_famille": "Boileau",
    "titre_genre2": "Conseiller",
    "remuneration": "8570",
    "allocation": "4285",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12855",
    "ville": "Eastman",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2363"
  },
  {
    "ID": "2447",
    "nom_corrige2": "Sylvain Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseiller",
    "remuneration": "8946",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12825",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2448",
    "nom_corrige2": "Éric Émond",
    "nom_famille": "Émond",
    "titre_genre2": "Conseiller",
    "remuneration": "8946",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12825",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2449",
    "nom_corrige2": "Patrice Paillé",
    "nom_famille": "Paillé",
    "titre_genre2": "Conseiller",
    "remuneration": "8921",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12800",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2450",
    "nom_corrige2": "Simon Brunelle",
    "nom_famille": "Brunelle",
    "titre_genre2": "Maire",
    "remuneration": "5650",
    "allocation": "2702",
    "remuneration2": "2950",
    "allocation2": "1475",
    "total": "12777",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "2451",
    "nom_corrige2": "Christelle Brassard",
    "nom_famille": "Brassard",
    "titre_genre2": "Conseillère",
    "remuneration": "8513",
    "allocation": "4257",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12770",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2452",
    "nom_corrige2": "Roxanne Lajoie",
    "nom_famille": "Lajoie",
    "titre_genre2": "Conseillère",
    "remuneration": "8513",
    "allocation": "4257",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12770",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2453",
    "nom_corrige2": "Georges Belec",
    "nom_famille": "Belec",
    "titre_genre2": "Conseiller",
    "remuneration": "8513",
    "allocation": "4257",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12770",
    "ville": "La Conception",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1524"
  },
  {
    "ID": "2454",
    "nom_corrige2": "Nicole Généreux",
    "nom_famille": "Généreux",
    "titre_genre2": "Mairesse",
    "remuneration": "6000",
    "allocation": "2791",
    "remuneration2": "2818",
    "allocation2": "1159",
    "total": "12768",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "2455",
    "nom_corrige2": "Frédéric Lizotte",
    "nom_famille": "Lizotte",
    "titre_genre2": "Maire",
    "remuneration": "6024",
    "allocation": "3012",
    "remuneration2": "2568",
    "allocation2": "1159",
    "total": "12763",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "2456",
    "nom_corrige2": "Maryse Gaudreau",
    "nom_famille": "Gaudreau",
    "titre_genre2": "Conseillère",
    "remuneration": "8095",
    "allocation": "4048",
    "remuneration2": "400",
    "allocation2": "200",
    "total": "12743",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2457",
    "nom_corrige2": "SERGE BEAULIEU",
    "nom_famille": "BEAULIEU",
    "titre_genre2": "Conseiller",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12735",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "2458",
    "nom_corrige2": "LUC BERTRAND",
    "nom_famille": "BERTRAND",
    "titre_genre2": "Conseiller",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12735",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "2459",
    "nom_corrige2": "LUC DELISLE",
    "nom_famille": "DELISLE",
    "titre_genre2": "Conseiller",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12735",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "2460",
    "nom_corrige2": "ANNE-SOPHIE PAQUET",
    "nom_famille": "PAQUET",
    "titre_genre2": "Conseillère",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12735",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "2461",
    "nom_corrige2": "DENISE THIBAULT",
    "nom_famille": "THIBAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "8490",
    "allocation": "4245",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12735",
    "ville": "Neuville",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "4669"
  },
  {
    "ID": "2462",
    "nom_corrige2": "Miriame Dubuc-Perras",
    "nom_famille": "Dubuc-Perras",
    "titre_genre2": "Conseillère",
    "remuneration": "8480",
    "allocation": "4239",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12719",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2463",
    "nom_corrige2": "René Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "8453",
    "allocation": "4227",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12680",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2464",
    "nom_corrige2": "Louis Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "8783",
    "allocation": "3891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12674",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2465",
    "nom_corrige2": "François Boisjoly",
    "nom_famille": "Boisjoly",
    "titre_genre2": "Conseiller",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12669",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2466",
    "nom_corrige2": "Josée Castonguay",
    "nom_famille": "Castonguay",
    "titre_genre2": "Conseillère",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12669",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2467",
    "nom_corrige2": "Martin Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12669",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2468",
    "nom_corrige2": "Marie-Ève Mondor",
    "nom_famille": "Mondor",
    "titre_genre2": "Conseillère",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12669",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2469",
    "nom_corrige2": "Lucie Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "8446",
    "allocation": "4223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12669",
    "ville": "Lanoraie",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "5458"
  },
  {
    "ID": "2470",
    "nom_corrige2": "Jason Carrière",
    "nom_famille": "Carrière",
    "titre_genre2": "Conseiller",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2471",
    "nom_corrige2": "Robin Pilon",
    "nom_famille": "Pilon",
    "titre_genre2": "Conseiller",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2472",
    "nom_corrige2": "Mélanie Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseillère",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2473",
    "nom_corrige2": "Daniel Lafleur",
    "nom_famille": "Lafleur",
    "titre_genre2": "Conseiller",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2474",
    "nom_corrige2": "Jean Denis",
    "nom_famille": "Denis",
    "titre_genre2": "Conseiller",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2475",
    "nom_corrige2": "Philippe Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "8509",
    "allocation": "4133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12642",
    "ville": "Thurso",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "3043"
  },
  {
    "ID": "2476",
    "nom_corrige2": "Sylvain Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "8405",
    "allocation": "4202",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12607",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "2477",
    "nom_corrige2": "Michel Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseiller",
    "remuneration": "8405",
    "allocation": "4202",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12607",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "2478",
    "nom_corrige2": "Éric Blanchette-Ouellet",
    "nom_famille": "Blanchette-Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "8405",
    "allocation": "4202",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12607",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "2479",
    "nom_corrige2": "Jocelyn Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "8405",
    "allocation": "4202",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12607",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "2480",
    "nom_corrige2": "Pierre-Olivier Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "8405",
    "allocation": "4202",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12607",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "2481",
    "nom_corrige2": "Marc-Olivier Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "8399",
    "allocation": "4200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12599",
    "ville": "Beloeil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "24806"
  },
  {
    "ID": "2482",
    "nom_corrige2": "Danielle Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "8393",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12575",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2483",
    "nom_corrige2": "David-Lee Amos",
    "nom_famille": "Amos",
    "titre_genre2": "Conseiller",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2484",
    "nom_corrige2": "François Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseiller",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2485",
    "nom_corrige2": "Alain Laprade",
    "nom_famille": "Laprade",
    "titre_genre2": "Conseiller",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2486",
    "nom_corrige2": "Isabelle Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseillère",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2487",
    "nom_corrige2": "Christine Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseillère",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2488",
    "nom_corrige2": "Patrick Delforge",
    "nom_famille": "Delforge",
    "titre_genre2": "Conseiller",
    "remuneration": "8363",
    "allocation": "4182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12545",
    "ville": "Coteau-du-Lac",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "7627"
  },
  {
    "ID": "2489",
    "nom_corrige2": "ANIK KOROSEC",
    "nom_famille": "KOROSEC",
    "titre_genre2": "Conseillère",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12534",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "2490",
    "nom_corrige2": "ANSELMO MARANDOLA",
    "nom_famille": "MARANDOLA",
    "titre_genre2": "Conseiller",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12534",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "2491",
    "nom_corrige2": "SHIRLEY ROY",
    "nom_famille": "ROY",
    "titre_genre2": "Conseillère",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12534",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "2492",
    "nom_corrige2": "SAKINA KHAN",
    "nom_famille": "KHAN",
    "titre_genre2": "Conseillère",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12534",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "2493",
    "nom_corrige2": "DANIEL LEDUC",
    "nom_famille": "LEDUC",
    "titre_genre2": "Conseiller",
    "remuneration": "8356",
    "allocation": "4178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12534",
    "ville": "Gore",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2277"
  },
  {
    "ID": "2494",
    "nom_corrige2": "Roch Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "8350",
    "allocation": "4175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12525",
    "ville": "Lambton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1695"
  },
  {
    "ID": "2495",
    "nom_corrige2": "Mario Prévost",
    "nom_famille": "Prévost",
    "titre_genre2": "Conseiller",
    "remuneration": "8746",
    "allocation": "3775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12521",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2496",
    "nom_corrige2": "Alain Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2497",
    "nom_corrige2": "Jean-Simon Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2498",
    "nom_corrige2": "Régis Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2499",
    "nom_corrige2": "Sylvie Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2500",
    "nom_corrige2": "Michael Otis",
    "nom_famille": "Otis",
    "titre_genre2": "Maire",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "2501",
    "nom_corrige2": "Esteban Figueroa",
    "nom_famille": "Figueroa",
    "titre_genre2": "Conseiller",
    "remuneration": "8323",
    "allocation": "4162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12485",
    "ville": "Carleton-sur-Mer",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "4190"
  },
  {
    "ID": "2502",
    "nom_corrige2": "Annie Gentesse",
    "nom_famille": "Gentesse",
    "titre_genre2": "Conseillère",
    "remuneration": "8595",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12474",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2503",
    "nom_corrige2": "Pierre Lavigne",
    "nom_famille": "Lavigne",
    "titre_genre2": "Conseiller",
    "remuneration": "8571",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12450",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2504",
    "nom_corrige2": "Mélanie Hotte",
    "nom_famille": "Hotte",
    "titre_genre2": "Conseillère",
    "remuneration": "8292",
    "allocation": "4152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12444",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2505",
    "nom_corrige2": "Michel Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "8292",
    "allocation": "4152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12444",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2506",
    "nom_corrige2": "Sophie Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseillère",
    "remuneration": "8292",
    "allocation": "4152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12444",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2507",
    "nom_corrige2": "Marc Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "8292",
    "allocation": "4152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12444",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2508",
    "nom_corrige2": "Véronique Filion",
    "nom_famille": "Filion",
    "titre_genre2": "Conseillère",
    "remuneration": "8292",
    "allocation": "4152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12444",
    "ville": "Saint-André-Avellin",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "4029"
  },
  {
    "ID": "2509",
    "nom_corrige2": "Gérald Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2510",
    "nom_corrige2": "André Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2511",
    "nom_corrige2": "Geneviève Migneault",
    "nom_famille": "Migneault",
    "titre_genre2": "Conseillère",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2512",
    "nom_corrige2": "Marc-André Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2513",
    "nom_corrige2": "Pierre Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2514",
    "nom_corrige2": "Richard Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "8288",
    "allocation": "4144",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12432",
    "ville": "Saint-David-de-Falardeau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2957"
  },
  {
    "ID": "2515",
    "nom_corrige2": "Jacques Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseiller",
    "remuneration": "8283",
    "allocation": "4142",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12425",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2516",
    "nom_corrige2": "Guy Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "8133",
    "allocation": "4067",
    "remuneration2": "72",
    "allocation2": "145",
    "total": "12417",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2517",
    "nom_corrige2": "Daniel Choquette",
    "nom_famille": "Choquette",
    "titre_genre2": "Conseiller",
    "remuneration": "7533",
    "allocation": "3766",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "12385",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2518",
    "nom_corrige2": "Manon Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseillère",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2519",
    "nom_corrige2": "Martin Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2520",
    "nom_corrige2": "Lucie Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2521",
    "nom_corrige2": "Amélie Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2522",
    "nom_corrige2": "Caroline Nicole",
    "nom_famille": "Nicole",
    "titre_genre2": "Conseillère",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2523",
    "nom_corrige2": "Hubert Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "8255",
    "allocation": "4127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12382",
    "ville": "Sainte-Anne-de-Beaupré",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2989"
  },
  {
    "ID": "2524",
    "nom_corrige2": "Sylvain Masson",
    "nom_famille": "Masson",
    "titre_genre2": "Conseiller",
    "remuneration": "8496",
    "allocation": "3879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12375",
    "ville": "Saint-Cyrille-de-Wendover",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "5073"
  },
  {
    "ID": "2525",
    "nom_corrige2": "Diana-Joy Davies",
    "nom_famille": "Davies",
    "titre_genre2": "Conseillère",
    "remuneration": "8518",
    "allocation": "3847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12365",
    "ville": "Les Îles-de-la-Madeleine",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "12711"
  },
  {
    "ID": "2526",
    "nom_corrige2": "ANDRÉE DUBÉ",
    "nom_famille": "DUBÉ",
    "titre_genre2": "Mairesse",
    "remuneration": "8242",
    "allocation": "4121",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12363",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "2527",
    "nom_corrige2": "Robert Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Maire",
    "remuneration": "8236",
    "allocation": "4118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12354",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "2528",
    "nom_corrige2": "Jean Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseiller",
    "remuneration": "8231",
    "allocation": "4116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12347",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2529",
    "nom_corrige2": "Eric Sauvageau",
    "nom_famille": "Sauvageau",
    "titre_genre2": "Conseiller",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "319",
    "allocation2": "152",
    "total": "12333",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2530",
    "nom_corrige2": "Ghislain Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseiller",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2531",
    "nom_corrige2": "Christine Bleau",
    "nom_famille": "Bleau",
    "titre_genre2": "Conseillère",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2532",
    "nom_corrige2": "Mario Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2533",
    "nom_corrige2": "Marthe Tardif",
    "nom_famille": "Tardif",
    "titre_genre2": "Conseillère",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2534",
    "nom_corrige2": "Serge Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Conseiller",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2535",
    "nom_corrige2": "David Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "8216",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12324",
    "ville": "Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4193"
  },
  {
    "ID": "2536",
    "nom_corrige2": "Jacques Bogenez",
    "nom_famille": "Bogenez",
    "titre_genre2": "Conseiller",
    "remuneration": "8215",
    "allocation": "4108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12323",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2305"
  },
  {
    "ID": "2537",
    "nom_corrige2": "Katherine Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "8203",
    "allocation": "4102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12305",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2538",
    "nom_corrige2": "Chantal Thérien",
    "nom_famille": "Thérien",
    "titre_genre2": "Conseillère",
    "remuneration": "8200",
    "allocation": "4100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12300",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2539",
    "nom_corrige2": "Suzie Radermaker",
    "nom_famille": "Radermaker",
    "titre_genre2": "Conseillère",
    "remuneration": "8200",
    "allocation": "4100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12300",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2540",
    "nom_corrige2": "René Lalande",
    "nom_famille": "Lalande",
    "titre_genre2": "Conseiller",
    "remuneration": "8200",
    "allocation": "4100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12300",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2541",
    "nom_corrige2": "Luc Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseiller",
    "remuneration": "8200",
    "allocation": "4100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12300",
    "ville": "Nominingue",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2185"
  },
  {
    "ID": "2542",
    "nom_corrige2": "André-Marcel Évéquoz",
    "nom_famille": "Évéquoz",
    "titre_genre2": "Maire",
    "remuneration": "8187",
    "allocation": "4093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12280",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "2543",
    "nom_corrige2": "Caroline Champoux",
    "nom_famille": "Champoux",
    "titre_genre2": "Conseillère",
    "remuneration": "8805",
    "allocation": "3447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12252",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2544",
    "nom_corrige2": "Roger Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Maire",
    "remuneration": "5511",
    "allocation": "2756",
    "remuneration2": "2818",
    "allocation2": "1159",
    "total": "12244",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "2545",
    "nom_corrige2": "Nathalie Bresse",
    "nom_famille": "Bresse",
    "titre_genre2": "Mairesse",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "1186",
    "allocation2": "543",
    "total": "12229",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2546",
    "nom_corrige2": "Neil Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Maire",
    "remuneration": "8395",
    "allocation": "3833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12228",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "2547",
    "nom_corrige2": "André Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2548",
    "nom_corrige2": "Christiane Choinière",
    "nom_famille": "Choinière",
    "titre_genre2": "Conseillère",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2549",
    "nom_corrige2": "Serge Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2550",
    "nom_corrige2": "Pascal Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseiller",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2551",
    "nom_corrige2": "Sylvain Hainault",
    "nom_famille": "Hainault",
    "titre_genre2": "Conseiller",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2552",
    "nom_corrige2": "Nathalie Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "8145",
    "allocation": "4073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12218",
    "ville": "Roxton Pond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4580"
  },
  {
    "ID": "2553",
    "nom_corrige2": "Jacques Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Maire",
    "remuneration": "8135",
    "allocation": "4068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12203",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "2554",
    "nom_corrige2": "Bertrand Prévost",
    "nom_famille": "Prévost",
    "titre_genre2": "Maire",
    "remuneration": "6085",
    "allocation": "3043",
    "remuneration2": "2030",
    "allocation2": "1015",
    "total": "12173",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "2555",
    "nom_corrige2": "Josée Deslongchamps",
    "nom_famille": "Deslongchamps",
    "titre_genre2": "Conseillère",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2556",
    "nom_corrige2": "Abel Mandeville",
    "nom_famille": "Mandeville",
    "titre_genre2": "Conseiller",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2557",
    "nom_corrige2": "Cindy Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2558",
    "nom_corrige2": "Laurie Soulard",
    "nom_famille": "Soulard",
    "titre_genre2": "Conseillère",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2559",
    "nom_corrige2": "Ghislain Brunet",
    "nom_famille": "Brunet",
    "titre_genre2": "Conseiller",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2560",
    "nom_corrige2": "Manon Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "8104",
    "allocation": "4052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12156",
    "ville": "Macamic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2688"
  },
  {
    "ID": "2561",
    "nom_corrige2": "Daniel Braün",
    "nom_famille": "Braün",
    "titre_genre2": "Conseiller",
    "remuneration": "8134",
    "allocation": "4015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12149",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "2562",
    "nom_corrige2": "Lucie Vignola",
    "nom_famille": "Vignola",
    "titre_genre2": "Conseillère",
    "remuneration": "8079",
    "allocation": "4039",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12118",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2563",
    "nom_corrige2": "André Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Conseiller",
    "remuneration": "8079",
    "allocation": "4039",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12118",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2564",
    "nom_corrige2": "Julie-Anne Cousineau",
    "nom_famille": "Cousineau",
    "titre_genre2": "Conseillère",
    "remuneration": "8079",
    "allocation": "4039",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12118",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2565",
    "nom_corrige2": "André Bussière",
    "nom_famille": "Bussière",
    "titre_genre2": "Conseiller",
    "remuneration": "8073",
    "allocation": "4037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12110",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2566",
    "nom_corrige2": "Charles Mallette",
    "nom_famille": "Mallette",
    "titre_genre2": "Conseiller",
    "remuneration": "8073",
    "allocation": "4037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12110",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2567",
    "nom_corrige2": "GINO CANUEL",
    "nom_famille": "CANUEL",
    "titre_genre2": "Maire",
    "remuneration": "8204",
    "allocation": "3902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12106",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "2568",
    "nom_corrige2": "LISE BERNIER",
    "nom_famille": "BERNIER",
    "titre_genre2": "Conseillère",
    "remuneration": "8092",
    "allocation": "4005",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12097",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2569",
    "nom_corrige2": "Manon Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseillère",
    "remuneration": "8134",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12076",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2570",
    "nom_corrige2": "Isabelle Brisson",
    "nom_famille": "Brisson",
    "titre_genre2": "Conseillère",
    "remuneration": "8134",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12076",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2571",
    "nom_corrige2": "Natalia Czarnecka",
    "nom_famille": "Czarnecka",
    "titre_genre2": "Conseillère",
    "remuneration": "8134",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12076",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2572",
    "nom_corrige2": "Carl Woodbury",
    "nom_famille": "Woodbury",
    "titre_genre2": "Conseiller",
    "remuneration": "8134",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12076",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2573",
    "nom_corrige2": "Patrice Deslongchamps",
    "nom_famille": "Deslongchamps",
    "titre_genre2": "Conseiller",
    "remuneration": "8134",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12076",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2574",
    "nom_corrige2": "Greg Vaughan",
    "nom_famille": "Vaughan",
    "titre_genre2": "Maire",
    "remuneration": "8164",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12069",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "2575",
    "nom_corrige2": "Jude Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "8044",
    "allocation": "4022",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12066",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2576",
    "nom_corrige2": "Johanne Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseillère",
    "remuneration": "8030",
    "allocation": "4015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12045",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2577",
    "nom_corrige2": "Mario Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Maire",
    "remuneration": "8016",
    "allocation": "4008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12024",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "2578",
    "nom_corrige2": "Isabelle Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseillère",
    "remuneration": "8003",
    "allocation": "4002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12005",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2579",
    "nom_corrige2": "Céline Langlais",
    "nom_famille": "Langlais",
    "titre_genre2": "Conseillère",
    "remuneration": "8003",
    "allocation": "4002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12005",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2580",
    "nom_corrige2": "Francis Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "8003",
    "allocation": "4002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12005",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2581",
    "nom_corrige2": "Josée Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseillère",
    "remuneration": "8003",
    "allocation": "4002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12005",
    "ville": "Saint-Pascal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "3476"
  },
  {
    "ID": "2582",
    "nom_corrige2": "Gina Castelli",
    "nom_famille": "Castelli",
    "titre_genre2": "Conseillère",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2583",
    "nom_corrige2": "Alain Marc Rondeau",
    "nom_famille": "Rondeau",
    "titre_genre2": "Conseiller",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Ascot Corner",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3479"
  },
  {
    "ID": "2584",
    "nom_corrige2": "Steven Laprise",
    "nom_famille": "Laprise",
    "titre_genre2": "Maire",
    "remuneration": "9000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "2585",
    "nom_corrige2": "Gilles Arbour",
    "nom_famille": "Arbour",
    "titre_genre2": "Conseiller",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2586",
    "nom_corrige2": "Marilyne Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2587",
    "nom_corrige2": "Serge Forest",
    "nom_famille": "Forest",
    "titre_genre2": "Conseiller",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2588",
    "nom_corrige2": "Mélanie Laberge",
    "nom_famille": "Laberge",
    "titre_genre2": "Conseillère",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2589",
    "nom_corrige2": "Pierre Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2590",
    "nom_corrige2": "Yanick Langlais",
    "nom_famille": "Langlais",
    "titre_genre2": "Conseiller",
    "remuneration": "8000",
    "allocation": "4000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "12000",
    "ville": "Sainte-Marcelline-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1805"
  },
  {
    "ID": "2591",
    "nom_corrige2": "Claire Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Mairesse",
    "remuneration": "6367",
    "allocation": "5628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11995",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "2592",
    "nom_corrige2": "François Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "7980",
    "allocation": "3990",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11970",
    "ville": "Sainte-Barbe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1724"
  },
  {
    "ID": "2593",
    "nom_corrige2": "Patrick Barry",
    "nom_famille": "Barry",
    "titre_genre2": "Conseiller",
    "remuneration": "8586",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11952",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2594",
    "nom_corrige2": "Alexandre Bastien",
    "nom_famille": "Bastien",
    "titre_genre2": "Maire",
    "remuneration": "7692",
    "allocation": "3845",
    "remuneration2": "269",
    "allocation2": "135",
    "total": "11941",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "2595",
    "nom_corrige2": "MARTIN TOURIGNY",
    "nom_famille": "TOURIGNY",
    "titre_genre2": "Maire",
    "remuneration": "6749",
    "allocation": "3375",
    "remuneration2": "1207",
    "allocation2": "603",
    "total": "11934",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "2596",
    "nom_corrige2": "Nicolas Ste-Croix",
    "nom_famille": "Ste-Croix",
    "titre_genre2": "Conseiller",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2597",
    "nom_corrige2": "Doris Réhel",
    "nom_famille": "Réhel",
    "titre_genre2": "Conseillère",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2598",
    "nom_corrige2": "Allyson Cahill-Vibert",
    "nom_famille": "Cahill-Vibert",
    "titre_genre2": "Conseillère",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2599",
    "nom_corrige2": "Jonathan Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2600",
    "nom_corrige2": "Shanna Roussy",
    "nom_famille": "Roussy",
    "titre_genre2": "Conseillère",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2601",
    "nom_corrige2": "Michel Rail",
    "nom_famille": "Rail",
    "titre_genre2": "Conseiller",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2602",
    "nom_corrige2": "Yannick Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2603",
    "nom_corrige2": "Gaétane Hautcoeur",
    "nom_famille": "Hautcoeur",
    "titre_genre2": "Conseillère",
    "remuneration": "7956",
    "allocation": "3978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11934",
    "ville": "Percé",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3103"
  },
  {
    "ID": "2604",
    "nom_corrige2": "Denis Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Conseiller",
    "remuneration": "7984",
    "allocation": "3942",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11926",
    "ville": "Grenville-sur-la-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3009"
  },
  {
    "ID": "2605",
    "nom_corrige2": "Stéphan Denis",
    "nom_famille": "Denis",
    "titre_genre2": "Conseiller",
    "remuneration": "7949",
    "allocation": "3974",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11923",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "2606",
    "nom_corrige2": "Nathalie Gamelin",
    "nom_famille": "Gamelin",
    "titre_genre2": "Conseillère",
    "remuneration": "6132",
    "allocation": "5094",
    "remuneration2": "600",
    "allocation2": "90",
    "total": "11916",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2607",
    "nom_corrige2": "LAURENCE HAMEL",
    "nom_famille": "HAMEL",
    "titre_genre2": "Conseillère",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2608",
    "nom_corrige2": "ALEXANDRE DESROCHERS",
    "nom_famille": "DESROCHERS",
    "titre_genre2": "Conseiller",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2609",
    "nom_corrige2": "BRUNO PAQUETTE",
    "nom_famille": "PAQUETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2610",
    "nom_corrige2": "ALAIN GAUCHER",
    "nom_famille": "GAUCHER",
    "titre_genre2": "Conseiller",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2611",
    "nom_corrige2": "Clifford Lancaster",
    "nom_famille": "Lancaster",
    "titre_genre2": "Conseiller",
    "remuneration": "7943",
    "allocation": "3972",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2612",
    "nom_corrige2": "Gérard Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "7943",
    "allocation": "3972",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Richmond",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3357"
  },
  {
    "ID": "2613",
    "nom_corrige2": "JADE CHOINIÈRE-PINARD",
    "nom_famille": "CHOINIÈRE-PINARD",
    "titre_genre2": "Conseillère",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2614",
    "nom_corrige2": "ÉRIC LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "8132",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11915",
    "ville": "Saint-Blaise-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2154"
  },
  {
    "ID": "2615",
    "nom_corrige2": "Jean-Côme Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Maire",
    "remuneration": "7921",
    "allocation": "3960",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11881",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "2616",
    "nom_corrige2": "Marianne Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11862",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2617",
    "nom_corrige2": "Sylvain Ouimet",
    "nom_famille": "Ouimet",
    "titre_genre2": "Conseiller",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11862",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2618",
    "nom_corrige2": "Jean Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11862",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2619",
    "nom_corrige2": "Martin Renauld",
    "nom_famille": "Renauld",
    "titre_genre2": "Conseiller",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11862",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2620",
    "nom_corrige2": "Gaetan Garneau",
    "nom_famille": "Garneau",
    "titre_genre2": "Conseiller",
    "remuneration": "7908",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11862",
    "ville": "Deschambault-Grondines",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2317"
  },
  {
    "ID": "2621",
    "nom_corrige2": "André Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Maire",
    "remuneration": "7907",
    "allocation": "3954",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11861",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "2622",
    "nom_corrige2": "Denis Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2623",
    "nom_corrige2": "Marc-Aurèle Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2624",
    "nom_corrige2": "Sylvie Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2625",
    "nom_corrige2": "François Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseiller",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2626",
    "nom_corrige2": "Jo-Annie Castilloux",
    "nom_famille": "Castilloux",
    "titre_genre2": "Conseillère",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2627",
    "nom_corrige2": "Marie-Ève Allain",
    "nom_famille": "Allain",
    "titre_genre2": "Conseillère",
    "remuneration": "7904",
    "allocation": "3952",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11856",
    "ville": "Port-Daniel-Gascons",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2281"
  },
  {
    "ID": "2628",
    "nom_corrige2": "Marcel Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "7804",
    "allocation": "4026",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11830",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "2629",
    "nom_corrige2": "Karine Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseillère",
    "remuneration": "6930",
    "allocation": "2616",
    "remuneration2": "1517",
    "allocation2": "759",
    "total": "11822",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "2630",
    "nom_corrige2": "Benoit Pilotto",
    "nom_famille": "Pilotto",
    "titre_genre2": "Maire",
    "remuneration": "4993",
    "allocation": "2496",
    "remuneration2": "3168",
    "allocation2": "1159",
    "total": "11816",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "2631",
    "nom_corrige2": "Bertrand Taillefer",
    "nom_famille": "Taillefer",
    "titre_genre2": "Conseiller",
    "remuneration": "7872",
    "allocation": "3936",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11808",
    "ville": "Notre-Dame-de-la-Merci",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1057"
  },
  {
    "ID": "2632",
    "nom_corrige2": "FRANCE JUTRAS",
    "nom_famille": "JUTRAS",
    "titre_genre2": "Conseillère",
    "remuneration": "7886",
    "allocation": "3901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11787",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2633",
    "nom_corrige2": "Mélanie Dupré",
    "nom_famille": "Dupré",
    "titre_genre2": "Conseillère",
    "remuneration": "9002",
    "allocation": "2778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11780",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2634",
    "nom_corrige2": "Ian Gray",
    "nom_famille": "Gray",
    "titre_genre2": "Conseiller",
    "remuneration": "7845",
    "allocation": "3922",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11767",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2635",
    "nom_corrige2": "Jules Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Maire",
    "remuneration": "7843",
    "allocation": "3921",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11764",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "2636",
    "nom_corrige2": "Jean Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2637",
    "nom_corrige2": "Frédéric Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Conseiller",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2638",
    "nom_corrige2": "Annie Neveu",
    "nom_famille": "Neveu",
    "titre_genre2": "Conseillère",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2639",
    "nom_corrige2": "Éliane Neveu",
    "nom_famille": "Neveu",
    "titre_genre2": "Conseillère",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2640",
    "nom_corrige2": "Joachim Larochelle-Courchesne",
    "nom_famille": "Larochelle-Courchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2641",
    "nom_corrige2": "Roxane Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "7818",
    "allocation": "3909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11727",
    "ville": "Saint-Ambroise-de-Kildare",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4329"
  },
  {
    "ID": "2642",
    "nom_corrige2": "Yvon Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "1512",
    "allocation2": "756",
    "total": "11724",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "2643",
    "nom_corrige2": "Ginette Prieur",
    "nom_famille": "Prieur",
    "titre_genre2": "Conseillère",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2644",
    "nom_corrige2": "Sylvain Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2645",
    "nom_corrige2": "Jacqueline Lussier Meunier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2646",
    "nom_corrige2": "Pierre Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2647",
    "nom_corrige2": "Sylvain Goyette",
    "nom_famille": "Goyette",
    "titre_genre2": "Conseiller",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2648",
    "nom_corrige2": "Johanna Fehlmann",
    "nom_famille": "Fehlmann",
    "titre_genre2": "Conseillère",
    "remuneration": "7810",
    "allocation": "3905",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11715",
    "ville": "Sainte-Cécile-de-Milton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2298"
  },
  {
    "ID": "2649",
    "nom_corrige2": "Simon Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Maire",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "1802",
    "allocation2": "901",
    "total": "11703",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "2650",
    "nom_corrige2": "LOUIS MONTPELLIER",
    "nom_famille": "MONTPELLIER",
    "titre_genre2": "Conseiller",
    "remuneration": "8352",
    "allocation": "3350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11702",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2651",
    "nom_corrige2": "Guylaine Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseillère",
    "remuneration": "7783",
    "allocation": "3891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11674",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2652",
    "nom_corrige2": "Michel Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseiller",
    "remuneration": "7783",
    "allocation": "3891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11674",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2653",
    "nom_corrige2": "Frédéric Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "7783",
    "allocation": "3891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11674",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2654",
    "nom_corrige2": "Audrey Marie Sergerie",
    "nom_famille": "Sergerie",
    "titre_genre2": "Conseillère",
    "remuneration": "7783",
    "allocation": "3891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11674",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "2655",
    "nom_corrige2": "Josée Paquette-Bougie",
    "nom_famille": "Paquette-Bougie",
    "titre_genre2": "Conseillère",
    "remuneration": "7775",
    "allocation": "3887",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11662",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2656",
    "nom_corrige2": "René Allen",
    "nom_famille": "Allen",
    "titre_genre2": "Maire",
    "remuneration": "5409",
    "allocation": "2667",
    "remuneration2": "2376",
    "allocation2": "1188",
    "total": "11640",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "2657",
    "nom_corrige2": "Marie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "7700",
    "allocation": "3850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11550",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2658",
    "nom_corrige2": "Victor Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseiller",
    "remuneration": "7700",
    "allocation": "3850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11550",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2659",
    "nom_corrige2": "Joël Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "7700",
    "allocation": "3850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11550",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2660",
    "nom_corrige2": "Sandra Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseillère",
    "remuneration": "7700",
    "allocation": "3850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11550",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2661",
    "nom_corrige2": "Ovila Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseiller",
    "remuneration": "7700",
    "allocation": "3850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11550",
    "ville": "Sainte-Luce",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2746"
  },
  {
    "ID": "2662",
    "nom_corrige2": "LOUIS HARVEY",
    "nom_famille": "HARVEY",
    "titre_genre2": "Conseiller",
    "remuneration": "7787",
    "allocation": "2393",
    "remuneration2": "894",
    "allocation2": "447",
    "total": "11521",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "2663",
    "nom_corrige2": "Pascale Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Mairesse",
    "remuneration": "5662",
    "allocation": "2769",
    "remuneration2": "2099",
    "allocation2": "944",
    "total": "11474",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "2664",
    "nom_corrige2": "Marie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "7734",
    "allocation": "3728",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11462",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2665",
    "nom_corrige2": "Mario Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Maire",
    "remuneration": "7535",
    "allocation": "3924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11459",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "2666",
    "nom_corrige2": "Cheryl Brazeau",
    "nom_famille": "Brazeau",
    "titre_genre2": "Conseillère",
    "remuneration": "7636",
    "allocation": "3817",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11453",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2667",
    "nom_corrige2": "MARIO LEFEBVRE",
    "nom_famille": "LEFEBVRE",
    "titre_genre2": "Maire",
    "remuneration": "4693",
    "allocation": "2346",
    "remuneration2": "3484",
    "allocation2": "916",
    "total": "11439",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "2668",
    "nom_corrige2": "Jocelyn Isabelle",
    "nom_famille": "Isabelle",
    "titre_genre2": "Conseiller",
    "remuneration": "7623",
    "allocation": "3811",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11434",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2669",
    "nom_corrige2": "Marie-Andrée Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "7618",
    "allocation": "3809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11427",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "2670",
    "nom_corrige2": "Pierre Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseiller",
    "remuneration": "7611",
    "allocation": "3805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11416",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2671",
    "nom_corrige2": "Marie-Josée Brodeur",
    "nom_famille": "Brodeur",
    "titre_genre2": "Conseillère",
    "remuneration": "7611",
    "allocation": "3805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11416",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2672",
    "nom_corrige2": "Daniel Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseiller",
    "remuneration": "7611",
    "allocation": "3805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11416",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2673",
    "nom_corrige2": "Annick Léveillé",
    "nom_famille": "Léveillé",
    "titre_genre2": "Conseillère",
    "remuneration": "7611",
    "allocation": "3805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11416",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2674",
    "nom_corrige2": "Sylvain Loiselle",
    "nom_famille": "Loiselle",
    "titre_genre2": "Conseiller",
    "remuneration": "7611",
    "allocation": "3805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11416",
    "ville": "Val-Morin",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3127"
  },
  {
    "ID": "2675",
    "nom_corrige2": "Lynda Graham",
    "nom_famille": "Graham",
    "titre_genre2": "Conseillère",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2676",
    "nom_corrige2": "Marc-André Blain",
    "nom_famille": "Blain",
    "titre_genre2": "Conseiller",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2677",
    "nom_corrige2": "Thérèse Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseillère",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2678",
    "nom_corrige2": "Alan Pavilanis",
    "nom_famille": "Pavilanis",
    "titre_genre2": "Conseiller",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2679",
    "nom_corrige2": "Carole Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseillère",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2680",
    "nom_corrige2": "Marie-José Auclair",
    "nom_famille": "Auclair",
    "titre_genre2": "Conseillère",
    "remuneration": "7603",
    "allocation": "3802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11405",
    "ville": "Sutton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4442"
  },
  {
    "ID": "2681",
    "nom_corrige2": "Claude Vadnais",
    "nom_famille": "Vadnais",
    "titre_genre2": "Conseiller",
    "remuneration": "7452",
    "allocation": "3732",
    "remuneration2": "145",
    "allocation2": "72",
    "total": "11401",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "2682",
    "nom_corrige2": "Mylène Neault",
    "nom_famille": "Neault",
    "titre_genre2": "Conseillère",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2683",
    "nom_corrige2": "Marc-Olivier Habel",
    "nom_famille": "Habel",
    "titre_genre2": "Conseiller",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2684",
    "nom_corrige2": "Alex Papineau",
    "nom_famille": "Papineau",
    "titre_genre2": "Conseiller",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2685",
    "nom_corrige2": "Carmen Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2686",
    "nom_corrige2": "Sophie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Sainte-Croix",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2647"
  },
  {
    "ID": "2687",
    "nom_corrige2": "Claudette Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Mairesse",
    "remuneration": "7600",
    "allocation": "3800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11400",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "2688",
    "nom_corrige2": "Bernard St-Gelais",
    "nom_famille": "St-Gelais",
    "titre_genre2": "Maire",
    "remuneration": "7755",
    "allocation": "3644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11399",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "2689",
    "nom_corrige2": "Adèle Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "7595",
    "allocation": "3798",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11393",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2690",
    "nom_corrige2": "Francine Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Mairesse",
    "remuneration": "6077",
    "allocation": "3038",
    "remuneration2": "1517",
    "allocation2": "759",
    "total": "11391",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "2691",
    "nom_corrige2": "Natacha Garneau-Tremblay",
    "nom_famille": "Garneau-Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "994",
    "allocation2": "497",
    "total": "11391",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2692",
    "nom_corrige2": "John Bradley",
    "nom_famille": "Bradley",
    "titre_genre2": "Conseiller",
    "remuneration": "6088",
    "allocation": "3044",
    "remuneration2": "1497",
    "allocation2": "748",
    "total": "11377",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "2693",
    "nom_corrige2": "Claude Laporte",
    "nom_famille": "Laporte",
    "titre_genre2": "Conseiller",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2694",
    "nom_corrige2": "Isabel Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseillère",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2695",
    "nom_corrige2": "Sylvie Frigon",
    "nom_famille": "Frigon",
    "titre_genre2": "Conseillère",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2696",
    "nom_corrige2": "Étienne Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2697",
    "nom_corrige2": "Véronique Payette",
    "nom_famille": "Payette",
    "titre_genre2": "Conseillère",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2698",
    "nom_corrige2": "Pascale Dupaul",
    "nom_famille": "Dupaul",
    "titre_genre2": "Conseillère",
    "remuneration": "7574",
    "allocation": "3787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11361",
    "ville": "Crabtree",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "4267"
  },
  {
    "ID": "2699",
    "nom_corrige2": "Jean Duhaime",
    "nom_famille": "Duhaime",
    "titre_genre2": "Conseiller",
    "remuneration": "6132",
    "allocation": "4806",
    "remuneration2": "420",
    "allocation2": "0",
    "total": "11358",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2700",
    "nom_corrige2": "Julien Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "7566",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11349",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2701",
    "nom_corrige2": "Nathalie Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "7566",
    "allocation": "3783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11349",
    "ville": "Terrasse-Vaudreuil",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1995"
  },
  {
    "ID": "2702",
    "nom_corrige2": "Mario Archambault",
    "nom_famille": "Archambault",
    "titre_genre2": "Conseiller",
    "remuneration": "7551",
    "allocation": "3775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11326",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2703",
    "nom_corrige2": "Jacques Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseiller",
    "remuneration": "7551",
    "allocation": "3775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11326",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2704",
    "nom_corrige2": "Louise Théorêt",
    "nom_famille": "Théorêt",
    "titre_genre2": "Conseillère",
    "remuneration": "7551",
    "allocation": "3775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11326",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2705",
    "nom_corrige2": "Raymond Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "7551",
    "allocation": "3775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11326",
    "ville": "Saint-Stanislas-de-Kostka",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2008"
  },
  {
    "ID": "2706",
    "nom_corrige2": "Daniel Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Maire",
    "remuneration": "4027",
    "allocation": "2013",
    "remuneration2": "4570",
    "allocation2": "712",
    "total": "11322",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "2707",
    "nom_corrige2": "Lise Julien",
    "nom_famille": "Julien",
    "titre_genre2": "Conseillère",
    "remuneration": "6607",
    "allocation": "3303",
    "remuneration2": "909",
    "allocation2": "454",
    "total": "11273",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2708",
    "nom_corrige2": "Pierre Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "7509",
    "allocation": "3754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11263",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "2709",
    "nom_corrige2": "François Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "7509",
    "allocation": "3754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11263",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "2710",
    "nom_corrige2": "Francine Craig",
    "nom_famille": "Craig",
    "titre_genre2": "Conseillère",
    "remuneration": "7509",
    "allocation": "3754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11263",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "2711",
    "nom_corrige2": "Virginie Arbour Trépanier",
    "nom_famille": "Arbour",
    "titre_genre2": "Conseillère",
    "remuneration": "7509",
    "allocation": "3754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11263",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "2712",
    "nom_corrige2": "André Ste-Marie",
    "nom_famille": "Ste-Marie",
    "titre_genre2": "Conseiller",
    "remuneration": "3619",
    "allocation": "1809",
    "remuneration2": "4166",
    "allocation2": "1661",
    "total": "11255",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "2713",
    "nom_corrige2": "Paquerette Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Mairesse",
    "remuneration": "7499",
    "allocation": "3749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11248",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "2714",
    "nom_corrige2": "Liane Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseillère",
    "remuneration": "7583",
    "allocation": "3651",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11234",
    "ville": "Rivière-Saint-Jean",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "211"
  },
  {
    "ID": "2715",
    "nom_corrige2": "Normand Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "7583",
    "allocation": "3651",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11234",
    "ville": "Rivière-Saint-Jean",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "211"
  },
  {
    "ID": "2716",
    "nom_corrige2": "Alex Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseiller",
    "remuneration": "7583",
    "allocation": "3651",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11234",
    "ville": "Rivière-Saint-Jean",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "211"
  },
  {
    "ID": "2717",
    "nom_corrige2": "Lola Lebrasseur",
    "nom_famille": "Lebrasseur",
    "titre_genre2": "Conseillère",
    "remuneration": "7583",
    "allocation": "3651",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11234",
    "ville": "Rivière-Saint-Jean",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "211"
  },
  {
    "ID": "2718",
    "nom_corrige2": "Danièle Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "10546",
    "allocation": "685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11231",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "2719",
    "nom_corrige2": "Jean-Pierre Querry",
    "nom_famille": "Querry",
    "titre_genre2": "Conseiller",
    "remuneration": "7458",
    "allocation": "3729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11187",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2720",
    "nom_corrige2": "Jean Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseiller",
    "remuneration": "7458",
    "allocation": "3729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11187",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2721",
    "nom_corrige2": "Jacques Rivière",
    "nom_famille": "Rivière",
    "titre_genre2": "Conseiller",
    "remuneration": "7458",
    "allocation": "3729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11187",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2722",
    "nom_corrige2": "Yves Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Conseiller",
    "remuneration": "7441",
    "allocation": "3720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11161",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2723",
    "nom_corrige2": "Christine Gougeon",
    "nom_famille": "Gougeon",
    "titre_genre2": "Conseillère",
    "remuneration": "7441",
    "allocation": "3720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11161",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2724",
    "nom_corrige2": "Patrick Vizien",
    "nom_famille": "Vizien",
    "titre_genre2": "Conseiller",
    "remuneration": "7441",
    "allocation": "3720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11161",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2725",
    "nom_corrige2": "René-Carl Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "7441",
    "allocation": "3720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11161",
    "ville": "Sainte-Marie-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2955"
  },
  {
    "ID": "2726",
    "nom_corrige2": "Daniel Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseiller",
    "remuneration": "7702",
    "allocation": "3447",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11149",
    "ville": "Amherst",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1633"
  },
  {
    "ID": "2727",
    "nom_corrige2": "Guy Burelle",
    "nom_famille": "Burelle",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2728",
    "nom_corrige2": "Gaétan Bayeur",
    "nom_famille": "Bayeur",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2729",
    "nom_corrige2": "Léo Soulières",
    "nom_famille": "Soulières",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2730",
    "nom_corrige2": "Guy Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2731",
    "nom_corrige2": "Alain Laferrière",
    "nom_famille": "Laferrière",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2732",
    "nom_corrige2": "René Daveau",
    "nom_famille": "Daveau",
    "titre_genre2": "Conseiller",
    "remuneration": "7418",
    "allocation": "3709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11127",
    "ville": "Sainte-Geneviève-de-Berthier",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2369"
  },
  {
    "ID": "2733",
    "nom_corrige2": "Chantal Scapino",
    "nom_famille": "Scapino",
    "titre_genre2": "Conseillère",
    "remuneration": "7442",
    "allocation": "3684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11126",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2734",
    "nom_corrige2": "Michel Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Maire",
    "remuneration": "7407",
    "allocation": "3704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11111",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "2735",
    "nom_corrige2": "Jean-François Lauzier",
    "nom_famille": "Lauzier",
    "titre_genre2": "Conseiller",
    "remuneration": "11074",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11074",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "2736",
    "nom_corrige2": "Réjean Gamelin",
    "nom_famille": "Gamelin",
    "titre_genre2": "Conseiller",
    "remuneration": "6132",
    "allocation": "4654",
    "remuneration2": "180",
    "allocation2": "90",
    "total": "11056",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2737",
    "nom_corrige2": "Julie James",
    "nom_famille": "James",
    "titre_genre2": "Conseillère",
    "remuneration": "7367",
    "allocation": "3684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11051",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2738",
    "nom_corrige2": "Daniel St-Onge",
    "nom_famille": "St-Onge",
    "titre_genre2": "Conseiller",
    "remuneration": "7367",
    "allocation": "3684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11051",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2739",
    "nom_corrige2": "Robert Dewar",
    "nom_famille": "Dewar",
    "titre_genre2": "Conseiller",
    "remuneration": "7367",
    "allocation": "3684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11051",
    "ville": "Harrington",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "925"
  },
  {
    "ID": "2740",
    "nom_corrige2": "Gilles Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "8125",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11045",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "2741",
    "nom_corrige2": "Sébastien Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "9804",
    "allocation": "826",
    "remuneration2": "413",
    "allocation2": "0",
    "total": "11043",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "2742",
    "nom_corrige2": "Yanick Beauchemin",
    "nom_famille": "Beauchemin",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "1851",
    "allocation2": "926",
    "total": "11038",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "2743",
    "nom_corrige2": "Anik Bois",
    "nom_famille": "Bois",
    "titre_genre2": "Conseillère",
    "remuneration": "7358",
    "allocation": "3679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11037",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2744",
    "nom_corrige2": "Manon Bastien Couturier",
    "nom_famille": "Bastien",
    "titre_genre2": "Conseillère",
    "remuneration": "7358",
    "allocation": "3679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11037",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2745",
    "nom_corrige2": "Gilles Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "7358",
    "allocation": "3679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11037",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2746",
    "nom_corrige2": "Don Saliba",
    "nom_famille": "Saliba",
    "titre_genre2": "Conseiller",
    "remuneration": "7358",
    "allocation": "3679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11037",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2747",
    "nom_corrige2": "Jocelyn Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "7358",
    "allocation": "3679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11037",
    "ville": "Lac-Simon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1079"
  },
  {
    "ID": "2748",
    "nom_corrige2": "Karine St-Germain",
    "nom_famille": "St-Germain",
    "titre_genre2": "Conseillère",
    "remuneration": "7659",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11025",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2749",
    "nom_corrige2": "MARTIN VAN WINDEN",
    "nom_famille": "VAN",
    "titre_genre2": "Conseiller",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2750",
    "nom_corrige2": "MICHEL MONETTE",
    "nom_famille": "MONETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2751",
    "nom_corrige2": "MAURICE BOISSY",
    "nom_famille": "BOISSY",
    "titre_genre2": "Conseiller",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2752",
    "nom_corrige2": "GÉRARD DUMESNIL",
    "nom_famille": "DUMESNIL",
    "titre_genre2": "Conseiller",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2753",
    "nom_corrige2": "JEAN-FRANÇOIS BOIRE",
    "nom_famille": "BOIRE",
    "titre_genre2": "Conseiller",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2754",
    "nom_corrige2": "JOSIANE SURPRENANT",
    "nom_famille": "SURPRENANT",
    "titre_genre2": "Conseillère",
    "remuneration": "7335",
    "allocation": "3667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11002",
    "ville": "Saint-Cyprien-de-Napierville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2101"
  },
  {
    "ID": "2755",
    "nom_corrige2": "Myriam Lambert-Dumas",
    "nom_famille": "Lambert-Dumas",
    "titre_genre2": "Conseillère",
    "remuneration": "7064",
    "allocation": "3372",
    "remuneration2": "375",
    "allocation2": "187",
    "total": "10998",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "2756",
    "nom_corrige2": "Kevin Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseiller",
    "remuneration": "10588",
    "allocation": "5294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "15882",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "2757",
    "nom_corrige2": "Sylvie Tourangeau",
    "nom_famille": "Tourangeau",
    "titre_genre2": "Conseillère",
    "remuneration": "6440",
    "allocation": "3220",
    "remuneration2": "884",
    "allocation2": "442",
    "total": "10986",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "2758",
    "nom_corrige2": "Pierre-Luc Guertin",
    "nom_famille": "Guertin",
    "titre_genre2": "Conseiller",
    "remuneration": "7536",
    "allocation": "3442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10978",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2759",
    "nom_corrige2": "Maylis Toulouse",
    "nom_famille": "Toulouse",
    "titre_genre2": "Conseillère",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "10972",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2760",
    "nom_corrige2": "Jean-Paul Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "858",
    "allocation2": "429",
    "total": "10953",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "2761",
    "nom_corrige2": "Fernand Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "7298",
    "allocation": "3649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10947",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "2762",
    "nom_corrige2": "Evelyne Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseillère",
    "remuneration": "7502",
    "allocation": "3442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10944",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2763",
    "nom_corrige2": "Michelle Thomas",
    "nom_famille": "Thomas",
    "titre_genre2": "Conseillère",
    "remuneration": "7285",
    "allocation": "3642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10927",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2764",
    "nom_corrige2": "Éric Paiement",
    "nom_famille": "Paiement",
    "titre_genre2": "Conseiller",
    "remuneration": "7285",
    "allocation": "3642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10927",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2765",
    "nom_corrige2": "Serge Piché",
    "nom_famille": "Piché",
    "titre_genre2": "Conseiller",
    "remuneration": "7285",
    "allocation": "3642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10927",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2766",
    "nom_corrige2": "Alain Lachaine",
    "nom_famille": "Lachaine",
    "titre_genre2": "Conseiller",
    "remuneration": "7285",
    "allocation": "3642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10927",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2767",
    "nom_corrige2": "Genevieve Brisebois",
    "nom_famille": "Brisebois",
    "titre_genre2": "Conseillère",
    "remuneration": "7285",
    "allocation": "3642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10927",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2768",
    "nom_corrige2": "Bruno Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Maire",
    "remuneration": "7274",
    "allocation": "3637",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10911",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "2769",
    "nom_corrige2": "Jocelyne Louis-Seize",
    "nom_famille": "Louis-Seize",
    "titre_genre2": "Conseillère",
    "remuneration": "7256",
    "allocation": "3638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10894",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "2770",
    "nom_corrige2": "Gérard Litalien",
    "nom_famille": "Litalien",
    "titre_genre2": "Maire",
    "remuneration": "7248",
    "allocation": "3637",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10885",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "2771",
    "nom_corrige2": "Jules Brunelle-Marineau",
    "nom_famille": "Brunelle-Marineau",
    "titre_genre2": "Conseiller",
    "remuneration": "7251",
    "allocation": "3626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10877",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "2772",
    "nom_corrige2": "Guillaume Brais",
    "nom_famille": "Brais",
    "titre_genre2": "Conseiller",
    "remuneration": "7251",
    "allocation": "3626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10877",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "2773",
    "nom_corrige2": "François Desaulniers",
    "nom_famille": "Desaulniers",
    "titre_genre2": "Conseiller",
    "remuneration": "7251",
    "allocation": "3626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10877",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "2774",
    "nom_corrige2": "Florencia Saravia",
    "nom_famille": "Saravia",
    "titre_genre2": "Conseillère",
    "remuneration": "7251",
    "allocation": "3626",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10877",
    "ville": "Dunham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3606"
  },
  {
    "ID": "2775",
    "nom_corrige2": "Simon Carrier-Tanguay",
    "nom_famille": "Carrier-Tanguay",
    "titre_genre2": "Maire",
    "remuneration": "4057",
    "allocation": "2240",
    "remuneration2": "3039",
    "allocation2": "1519",
    "total": "10855",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "2776",
    "nom_corrige2": "Luc Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Conseiller",
    "remuneration": "7234",
    "allocation": "3617",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10851",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2777",
    "nom_corrige2": "Marie Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseillère",
    "remuneration": "7234",
    "allocation": "3617",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10851",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2778",
    "nom_corrige2": "Dany Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseiller",
    "remuneration": "7234",
    "allocation": "3617",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10851",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2779",
    "nom_corrige2": "André Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "7500",
    "allocation": "3350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10850",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "2780",
    "nom_corrige2": "Louis-Charles Guertin",
    "nom_famille": "Guertin",
    "titre_genre2": "Conseiller",
    "remuneration": "7435",
    "allocation": "3408",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10843",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2781",
    "nom_corrige2": "Jean-Guy Deblois",
    "nom_famille": "Deblois",
    "titre_genre2": "Maire",
    "remuneration": "6207",
    "allocation": "3103",
    "remuneration2": "1011",
    "allocation2": "506",
    "total": "10827",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "2782",
    "nom_corrige2": "Mélanie Mayer",
    "nom_famille": "Mayer",
    "titre_genre2": "Conseillère",
    "remuneration": "7217",
    "allocation": "3609",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10826",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2783",
    "nom_corrige2": "Sébastien Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "7217",
    "allocation": "3609",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10826",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2784",
    "nom_corrige2": "Claude Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "7217",
    "allocation": "3609",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10826",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2785",
    "nom_corrige2": "Jacques Loiselle",
    "nom_famille": "Loiselle",
    "titre_genre2": "Conseiller",
    "remuneration": "7217",
    "allocation": "3609",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10826",
    "ville": "Ville-Marie",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2452"
  },
  {
    "ID": "2786",
    "nom_corrige2": "Kevin Patenaude",
    "nom_famille": "Patenaude",
    "titre_genre2": "Conseiller",
    "remuneration": "7453",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10819",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2787",
    "nom_corrige2": "Denise Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2788",
    "nom_corrige2": "Danielle Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseillère",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2789",
    "nom_corrige2": "Carolyne Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2790",
    "nom_corrige2": "Mireille Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseillère",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2791",
    "nom_corrige2": "Bertrand Quesnel",
    "nom_famille": "Quesnel",
    "titre_genre2": "Conseiller",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2792",
    "nom_corrige2": "René De La Sablonnière",
    "nom_famille": "De",
    "titre_genre2": "Conseiller",
    "remuneration": "7209",
    "allocation": "3605",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10814",
    "ville": "Chute-Saint-Philippe",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1018"
  },
  {
    "ID": "2793",
    "nom_corrige2": "Fernand Major",
    "nom_famille": "Major",
    "titre_genre2": "Maire",
    "remuneration": "7200",
    "allocation": "3600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10800",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "2794",
    "nom_corrige2": "Vincent Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "24049",
    "allocation": "12025",
    "remuneration2": "1660",
    "allocation2": "830",
    "total": "38564",
    "ville": "Saint-Bruno-de-Montarville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "27147"
  },
  {
    "ID": "2795",
    "nom_corrige2": "Michel Cliche",
    "nom_famille": "Cliche",
    "titre_genre2": "Maire",
    "remuneration": "7183",
    "allocation": "3592",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10775",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "2796",
    "nom_corrige2": "Paul Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Conseiller",
    "remuneration": "7183",
    "allocation": "3591",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10774",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2797",
    "nom_corrige2": "Nicolas Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "7183",
    "allocation": "3591",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10774",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2798",
    "nom_corrige2": "Guy St-Arnauld",
    "nom_famille": "St-Arnauld",
    "titre_genre2": "Conseiller",
    "remuneration": "7183",
    "allocation": "3591",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10774",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2799",
    "nom_corrige2": "Line Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "7183",
    "allocation": "3591",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10774",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2800",
    "nom_corrige2": "Marc Bastien",
    "nom_famille": "Bastien",
    "titre_genre2": "Conseiller",
    "remuneration": "7183",
    "allocation": "3591",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10774",
    "ville": "Saint-Étienne-des-Grès",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "4693"
  },
  {
    "ID": "2801",
    "nom_corrige2": "Christian Valois",
    "nom_famille": "Valois",
    "titre_genre2": "Conseiller",
    "remuneration": "7494",
    "allocation": "3276",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10770",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2802",
    "nom_corrige2": "Pamela Dow",
    "nom_famille": "Dow",
    "titre_genre2": "Conseillère",
    "remuneration": "7176",
    "allocation": "3588",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10764",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2803",
    "nom_corrige2": "Maryse Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseillère",
    "remuneration": "7176",
    "allocation": "3588",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10764",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2804",
    "nom_corrige2": "Natalie Clark",
    "nom_famille": "Clark",
    "titre_genre2": "Conseillère",
    "remuneration": "7176",
    "allocation": "3588",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10764",
    "ville": "New Richmond",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "3873"
  },
  {
    "ID": "2805",
    "nom_corrige2": "François Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseiller",
    "remuneration": "7089",
    "allocation": "3669",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10758",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "2806",
    "nom_corrige2": "Guyda Deblois",
    "nom_famille": "Deblois",
    "titre_genre2": "Conseiller",
    "remuneration": "5742",
    "allocation": "2871",
    "remuneration2": "1426",
    "allocation2": "713",
    "total": "10752",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "2807",
    "nom_corrige2": "Michel Venne",
    "nom_famille": "Venne",
    "titre_genre2": "Conseiller",
    "remuneration": "7167",
    "allocation": "3583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10750",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2808",
    "nom_corrige2": "Yvon Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "7167",
    "allocation": "3583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10750",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2809",
    "nom_corrige2": "Jocelyn Mélançon",
    "nom_famille": "Mélançon",
    "titre_genre2": "Conseiller",
    "remuneration": "7164",
    "allocation": "3582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10746",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "2810",
    "nom_corrige2": "Daniel Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseiller",
    "remuneration": "6132",
    "allocation": "4506",
    "remuneration2": "45",
    "allocation2": "62",
    "total": "10745",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2811",
    "nom_corrige2": "Diane Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "796",
    "allocation2": "398",
    "total": "10734",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "2812",
    "nom_corrige2": "Jean-Claude Ratelle",
    "nom_famille": "Ratelle",
    "titre_genre2": "Conseiller",
    "remuneration": "7149",
    "allocation": "3574",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10723",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2813",
    "nom_corrige2": "Sébastien Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "7149",
    "allocation": "3574",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10723",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2814",
    "nom_corrige2": "Richard Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "7149",
    "allocation": "3574",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10723",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2815",
    "nom_corrige2": "Sylvain Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "7149",
    "allocation": "3574",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10723",
    "ville": "Ferme-Neuve",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "2792"
  },
  {
    "ID": "2816",
    "nom_corrige2": "Simon Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseiller",
    "remuneration": "10711",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10711",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "2817",
    "nom_corrige2": "Anny Boisjoli",
    "nom_famille": "Boisjoli",
    "titre_genre2": "Conseillère",
    "remuneration": "6132",
    "allocation": "4566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10698",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2818",
    "nom_corrige2": "Mélanie Genesse",
    "nom_famille": "Genesse",
    "titre_genre2": "Conseillère",
    "remuneration": "6305",
    "allocation": "4153",
    "remuneration2": "158",
    "allocation2": "79",
    "total": "10695",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "2819",
    "nom_corrige2": "Daniel Valois",
    "nom_famille": "Valois",
    "titre_genre2": "Conseiller",
    "remuneration": "7281",
    "allocation": "3408",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10689",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2820",
    "nom_corrige2": "Béatrice Cardin",
    "nom_famille": "Cardin",
    "titre_genre2": "Conseillère",
    "remuneration": "7124",
    "allocation": "3562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10686",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2821",
    "nom_corrige2": "Luc Arseneault",
    "nom_famille": "Arseneault",
    "titre_genre2": "Conseiller",
    "remuneration": "7121",
    "allocation": "3560",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10681",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "2822",
    "nom_corrige2": "Chantal Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseillère",
    "remuneration": "7121",
    "allocation": "3560",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10681",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "2823",
    "nom_corrige2": "Sylvain Arseneault",
    "nom_famille": "Arseneault",
    "titre_genre2": "Conseiller",
    "remuneration": "7121",
    "allocation": "3560",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10681",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "2824",
    "nom_corrige2": "André Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "7121",
    "allocation": "3560",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10681",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "2825",
    "nom_corrige2": "Dominique Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3200",
    "remuneration2": "318",
    "allocation2": "159",
    "total": "10677",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "2826",
    "nom_corrige2": "Benoit Bibeau",
    "nom_famille": "Bibeau",
    "titre_genre2": "Conseiller",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2827",
    "nom_corrige2": "Guy Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseiller",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2828",
    "nom_corrige2": "Myriam Cournoyer",
    "nom_famille": "Cournoyer",
    "titre_genre2": "Conseillère",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2829",
    "nom_corrige2": "Vincent Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2830",
    "nom_corrige2": "Roger Soulières",
    "nom_famille": "Soulières",
    "titre_genre2": "Conseiller",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2831",
    "nom_corrige2": "Mario Cardin",
    "nom_famille": "Cardin",
    "titre_genre2": "Conseiller",
    "remuneration": "7114",
    "allocation": "3557",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10671",
    "ville": "Sainte-Anne-de-Sorel",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2795"
  },
  {
    "ID": "2832",
    "nom_corrige2": "Julie Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseillère",
    "remuneration": "7299",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10665",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2833",
    "nom_corrige2": "Gilles Courchesne",
    "nom_famille": "Courchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "7257",
    "allocation": "3408",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10665",
    "ville": "Saint-Ignace-de-Loyola",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2204"
  },
  {
    "ID": "2834",
    "nom_corrige2": "Karina Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "6607",
    "allocation": "3303",
    "remuneration2": "479",
    "allocation2": "240",
    "total": "10629",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2835",
    "nom_corrige2": "Ghislain Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Maire",
    "remuneration": "7080",
    "allocation": "3540",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10620",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "2836",
    "nom_corrige2": "Jean-Denis Patenaude",
    "nom_famille": "Patenaude",
    "titre_genre2": "Conseiller",
    "remuneration": "7076",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10614",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2837",
    "nom_corrige2": "Pierre Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10613",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2838",
    "nom_corrige2": "Daniel Sabourin",
    "nom_famille": "Sabourin",
    "titre_genre2": "Conseiller",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10613",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2839",
    "nom_corrige2": "Denis Rondeau",
    "nom_famille": "Rondeau",
    "titre_genre2": "Conseiller",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10613",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2840",
    "nom_corrige2": "Olivier Paiement",
    "nom_famille": "Paiement",
    "titre_genre2": "Conseiller",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10613",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2841",
    "nom_corrige2": "Daniel Groleau",
    "nom_famille": "Groleau",
    "titre_genre2": "Conseiller",
    "remuneration": "7075",
    "allocation": "3538",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10613",
    "ville": "Weedon",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2785"
  },
  {
    "ID": "2842",
    "nom_corrige2": "Richard Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "7098",
    "allocation": "3514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10612",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2843",
    "nom_corrige2": "Paul Brouillard",
    "nom_famille": "Brouillard",
    "titre_genre2": "Conseiller",
    "remuneration": "7098",
    "allocation": "3514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10612",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2844",
    "nom_corrige2": "Pascale-Sophie Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "7098",
    "allocation": "3514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10612",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2845",
    "nom_corrige2": "Paulette Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseillère",
    "remuneration": "7098",
    "allocation": "3514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10612",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2846",
    "nom_corrige2": "ODILE ROY",
    "nom_famille": "ROY",
    "titre_genre2": "Conseillère",
    "remuneration": "7071",
    "allocation": "3535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10606",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "2847",
    "nom_corrige2": "Larry Quigley",
    "nom_famille": "Quigley",
    "titre_genre2": "Maire",
    "remuneration": "5776",
    "allocation": "3008",
    "remuneration2": "1199",
    "allocation2": "600",
    "total": "10583",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "2848",
    "nom_corrige2": "Sylvain Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseiller",
    "remuneration": "7045",
    "allocation": "3523",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10568",
    "ville": "Adstock",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3073"
  },
  {
    "ID": "2849",
    "nom_corrige2": "Bertrand Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "7040",
    "allocation": "3520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10560",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2850",
    "nom_corrige2": "Johanne Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "7040",
    "allocation": "3520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10560",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2851",
    "nom_corrige2": "Réjean Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "7040",
    "allocation": "3520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10560",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2852",
    "nom_corrige2": "Dominique Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "7040",
    "allocation": "3520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10560",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2853",
    "nom_corrige2": "Sarah Bellavance",
    "nom_famille": "Bellavance",
    "titre_genre2": "Conseillère",
    "remuneration": "7040",
    "allocation": "3520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10560",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2854",
    "nom_corrige2": "Chantale Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "180",
    "allocation2": "147",
    "total": "10550",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2855",
    "nom_corrige2": "Daniel Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseiller",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "149",
    "allocation2": "74",
    "total": "10548",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2856",
    "nom_corrige2": "Guy Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseiller",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "135",
    "allocation2": "172",
    "total": "10530",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2857",
    "nom_corrige2": "Denis Bourgault",
    "nom_famille": "Bourgault",
    "titre_genre2": "Conseiller",
    "remuneration": "6935",
    "allocation": "3593",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10528",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "2858",
    "nom_corrige2": "Sylvie Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "7226",
    "allocation": "3302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10528",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2859",
    "nom_corrige2": "SCOTT MITCHELL",
    "nom_famille": "MITCHELL",
    "titre_genre2": "Conseiller",
    "remuneration": "7016",
    "allocation": "3508",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10524",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "2860",
    "nom_corrige2": "Philippe Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2861",
    "nom_corrige2": "Bill Gauley",
    "nom_famille": "Gauley",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2862",
    "nom_corrige2": "Allan Page",
    "nom_famille": "Page",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2863",
    "nom_corrige2": "Pierre Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2864",
    "nom_corrige2": "Jay Brothers",
    "nom_famille": "Brothers",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2865",
    "nom_corrige2": "Gilles Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseiller",
    "remuneration": "7000",
    "allocation": "3500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10500",
    "ville": "Wentworth",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "584"
  },
  {
    "ID": "2866",
    "nom_corrige2": "Alphé St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Maire",
    "remuneration": "6997",
    "allocation": "3498",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10495",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "2867",
    "nom_corrige2": "JEAN-GUY LEVASSEUR",
    "nom_famille": "LEVASSEUR",
    "titre_genre2": "Conseiller",
    "remuneration": "7013",
    "allocation": "3475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10488",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2868",
    "nom_corrige2": "Cynthia Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Mairesse",
    "remuneration": "6722",
    "allocation": "3760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10482",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "2869",
    "nom_corrige2": "Joan Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "6981",
    "allocation": "3491",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10472",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "2870",
    "nom_corrige2": "Pierre Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "6966",
    "allocation": "3483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10449",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2871",
    "nom_corrige2": "Jacques Decoeur",
    "nom_famille": "Decoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "6966",
    "allocation": "3483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10449",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2872",
    "nom_corrige2": "Audrey Paquette Poulin",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseillère",
    "remuneration": "6966",
    "allocation": "3483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10449",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2873",
    "nom_corrige2": "Michael Steimer",
    "nom_famille": "Steimer",
    "titre_genre2": "Conseiller",
    "remuneration": "6966",
    "allocation": "3483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10449",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2874",
    "nom_corrige2": "Stephane Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "6986",
    "allocation": "3462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10448",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "2875",
    "nom_corrige2": "CÉCILE COMTOIS",
    "nom_famille": "COMTOIS",
    "titre_genre2": "Conseillère",
    "remuneration": "6964",
    "allocation": "3482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10446",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "2876",
    "nom_corrige2": "MICHELINE BEAULIEU",
    "nom_famille": "BEAULIEU",
    "titre_genre2": "Conseillère",
    "remuneration": "6964",
    "allocation": "3482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10446",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "2877",
    "nom_corrige2": "ANDRÉ LEROUX",
    "nom_famille": "LEROUX",
    "titre_genre2": "Conseiller",
    "remuneration": "6964",
    "allocation": "3482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10446",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "2878",
    "nom_corrige2": "DENIS CHAMPAGNE",
    "nom_famille": "CHAMPAGNE",
    "titre_genre2": "Conseiller",
    "remuneration": "6964",
    "allocation": "3482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10446",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "2879",
    "nom_corrige2": "VANESSA BEAULIEU",
    "nom_famille": "BEAULIEU",
    "titre_genre2": "Conseillère",
    "remuneration": "6964",
    "allocation": "3482",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10446",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "2880",
    "nom_corrige2": "Daniel Forgues",
    "nom_famille": "Forgues",
    "titre_genre2": "Conseiller",
    "remuneration": "6971",
    "allocation": "3462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10433",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "2881",
    "nom_corrige2": "jacques Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "6971",
    "allocation": "3462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10433",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "2882",
    "nom_corrige2": "Mario Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "6970",
    "allocation": "3462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10432",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "2883",
    "nom_corrige2": "Emile Malo Bonin",
    "nom_famille": "Malo",
    "titre_genre2": "Conseiller",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "582",
    "allocation2": "291",
    "total": "10413",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "2884",
    "nom_corrige2": "VICTOR BOULAY",
    "nom_famille": "BOULAY",
    "titre_genre2": "Conseiller",
    "remuneration": "6876",
    "allocation": "3530",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10406",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2885",
    "nom_corrige2": "Vivian Beausoleil",
    "nom_famille": "Beausoleil",
    "titre_genre2": "Conseillère",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2886",
    "nom_corrige2": "Manon Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseillère",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2887",
    "nom_corrige2": "Nicole Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2888",
    "nom_corrige2": "Bruce Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2889",
    "nom_corrige2": "Denis Desroches",
    "nom_famille": "Desroches",
    "titre_genre2": "Conseiller",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2890",
    "nom_corrige2": "Alain Prescott",
    "nom_famille": "Prescott",
    "titre_genre2": "Conseiller",
    "remuneration": "6921",
    "allocation": "3460",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10381",
    "ville": "Saint-Gabriel-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2766"
  },
  {
    "ID": "2891",
    "nom_corrige2": "Patrick Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "7860",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10379",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "2892",
    "nom_corrige2": "Linda Marleau",
    "nom_famille": "Marleau",
    "titre_genre2": "Conseillère",
    "remuneration": "6919",
    "allocation": "3459",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10378",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2893",
    "nom_corrige2": "France Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Mairesse",
    "remuneration": "6905",
    "allocation": "3453",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10358",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "2894",
    "nom_corrige2": "Lisa Collard",
    "nom_famille": "Collard",
    "titre_genre2": "Conseillère",
    "remuneration": "6990",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10356",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2895",
    "nom_corrige2": "Jean-Luc Dulude",
    "nom_famille": "Dulude",
    "titre_genre2": "Conseiller",
    "remuneration": "7818",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10337",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "2896",
    "nom_corrige2": "Dany St-Amant",
    "nom_famille": "St-Amant",
    "titre_genre2": "Conseiller",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10325",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2897",
    "nom_corrige2": "Vicky Bombardier",
    "nom_famille": "Bombardier",
    "titre_genre2": "Conseillère",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10325",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2898",
    "nom_corrige2": "Dany Boyer",
    "nom_famille": "Boyer",
    "titre_genre2": "Conseiller",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10325",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2899",
    "nom_corrige2": "Julien Bussières",
    "nom_famille": "Bussières",
    "titre_genre2": "Conseiller",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10325",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2900",
    "nom_corrige2": "Marie-Claire Tétreault",
    "nom_famille": "Tétreault",
    "titre_genre2": "Conseillère",
    "remuneration": "6885",
    "allocation": "3440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10325",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2213"
  },
  {
    "ID": "2901",
    "nom_corrige2": "CHRISTIAN MASSÉ",
    "nom_famille": "MASSÉ",
    "titre_genre2": "Maire",
    "remuneration": "6854",
    "allocation": "3427",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10281",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "2902",
    "nom_corrige2": "André Pâquet",
    "nom_famille": "Pâquet",
    "titre_genre2": "Maire",
    "remuneration": "6849",
    "allocation": "3424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10273",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "2903",
    "nom_corrige2": "MADELEINE PAQUETTE",
    "nom_famille": "PAQUETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "6911",
    "allocation": "3350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10261",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2904",
    "nom_corrige2": "GUY MARTEL",
    "nom_famille": "MARTEL",
    "titre_genre2": "Conseiller",
    "remuneration": "6911",
    "allocation": "3350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10261",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2905",
    "nom_corrige2": "HÉLÈNE CREVIER",
    "nom_famille": "CREVIER",
    "titre_genre2": "Conseillère",
    "remuneration": "6876",
    "allocation": "3350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10226",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2906",
    "nom_corrige2": "Raymonde Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10223",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2907",
    "nom_corrige2": "Pierre Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10223",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2908",
    "nom_corrige2": "Charles-Antoine Fauteux",
    "nom_famille": "Fauteux",
    "titre_genre2": "Conseiller",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10223",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2909",
    "nom_corrige2": "Michael Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "6920",
    "allocation": "3303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10223",
    "ville": "Wickham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2713"
  },
  {
    "ID": "2910",
    "nom_corrige2": "Yves Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "6132",
    "allocation": "4066",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10198",
    "ville": "Saint-François-du-Lac",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2014"
  },
  {
    "ID": "2911",
    "nom_corrige2": "Jessica Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseillère",
    "remuneration": "6966",
    "allocation": "3228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10194",
    "ville": "Saint-André-d'Argenteuil",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3029"
  },
  {
    "ID": "2912",
    "nom_corrige2": "Louise Allaire",
    "nom_famille": "Allaire",
    "titre_genre2": "Conseillère",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2913",
    "nom_corrige2": "Danio Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2914",
    "nom_corrige2": "Véronique Perrier",
    "nom_famille": "Perrier",
    "titre_genre2": "Conseillère",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2915",
    "nom_corrige2": "Francine Trottier",
    "nom_famille": "Trottier",
    "titre_genre2": "Conseillère",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2916",
    "nom_corrige2": "René Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseiller",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2917",
    "nom_corrige2": "Marie-Pier Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "6787",
    "allocation": "3393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "Senneterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2730"
  },
  {
    "ID": "2918",
    "nom_corrige2": "KEVEN RENAUD",
    "nom_famille": "RENAUD",
    "titre_genre2": "Conseiller",
    "remuneration": "7787",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10180",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "2919",
    "nom_corrige2": "Marc Gratton",
    "nom_famille": "Gratton",
    "titre_genre2": "Conseiller",
    "remuneration": "6802",
    "allocation": "3368",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10170",
    "ville": "Denholm",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "475"
  },
  {
    "ID": "2920",
    "nom_corrige2": "Rolande Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseillère",
    "remuneration": "6774",
    "allocation": "3387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10161",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "2921",
    "nom_corrige2": "Jean Laniel",
    "nom_famille": "Laniel",
    "titre_genre2": "Conseiller",
    "remuneration": "6764",
    "allocation": "3382",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10146",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "2922",
    "nom_corrige2": "Pierrick Gripon",
    "nom_famille": "Gripon",
    "titre_genre2": "Conseiller",
    "remuneration": "6761",
    "allocation": "3381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10142",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2930"
  },
  {
    "ID": "2923",
    "nom_corrige2": "Denis Dugas",
    "nom_famille": "Dugas",
    "titre_genre2": "Conseiller",
    "remuneration": "5913",
    "allocation": "2956",
    "remuneration2": "847",
    "allocation2": "423",
    "total": "10139",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "2924",
    "nom_corrige2": "Roger Lalonde",
    "nom_famille": "Lalonde",
    "titre_genre2": "Conseiller",
    "remuneration": "6443",
    "allocation": "3229",
    "remuneration2": "300",
    "allocation2": "150",
    "total": "10122",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "2925",
    "nom_corrige2": "Marc-Olivier Racette",
    "nom_famille": "Racette",
    "titre_genre2": "Conseiller",
    "remuneration": "6743",
    "allocation": "3372",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10115",
    "ville": "Saint-Christophe-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "3131"
  },
  {
    "ID": "2926",
    "nom_corrige2": "Pascal Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "6646",
    "allocation": "3462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10108",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "2927",
    "nom_corrige2": "Claudia Drogue",
    "nom_famille": "Drogue",
    "titre_genre2": "Conseillère",
    "remuneration": "6732",
    "allocation": "3366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10098",
    "ville": "Mont-Saint-Grégoire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3296"
  },
  {
    "ID": "2928",
    "nom_corrige2": "Louise Magnan",
    "nom_famille": "Magnan",
    "titre_genre2": "Conseillère",
    "remuneration": "6528",
    "allocation": "3333",
    "remuneration2": "160",
    "allocation2": "76",
    "total": "10097",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "2929",
    "nom_corrige2": "SABIN WESTERBERG",
    "nom_famille": "WESTERBERG",
    "titre_genre2": "Conseiller",
    "remuneration": "7687",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10080",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "2930",
    "nom_corrige2": "MICHEL HARVEY",
    "nom_famille": "HARVEY",
    "titre_genre2": "Conseiller",
    "remuneration": "7687",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10080",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "2931",
    "nom_corrige2": "Marc Gaudreau",
    "nom_famille": "Gaudreau",
    "titre_genre2": "Conseiller",
    "remuneration": "6488",
    "allocation": "3295",
    "remuneration2": "270",
    "allocation2": "0",
    "total": "10053",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "2932",
    "nom_corrige2": "Henri Pariseau",
    "nom_famille": "Pariseau",
    "titre_genre2": "Maire",
    "remuneration": "2475",
    "allocation": "1238",
    "remuneration2": "6339",
    "allocation2": "0",
    "total": "10052",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "2933",
    "nom_corrige2": "Simon Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "6694",
    "allocation": "3347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10041",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "2934",
    "nom_corrige2": "Guylaine Rajotte",
    "nom_famille": "Rajotte",
    "titre_genre2": "Conseillère",
    "remuneration": "6686",
    "allocation": "3343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10029",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "2935",
    "nom_corrige2": "Pascale Duquette",
    "nom_famille": "Duquette",
    "titre_genre2": "Conseillère",
    "remuneration": "6678",
    "allocation": "3339",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "10017",
    "ville": "Lac-des-Écorces",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3025"
  },
  {
    "ID": "2936",
    "nom_corrige2": "Gabrielle Lavigne",
    "nom_famille": "Lavigne",
    "titre_genre2": "Conseillère",
    "remuneration": "6650",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9975",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "2937",
    "nom_corrige2": "Sylvain Loranger",
    "nom_famille": "Loranger",
    "titre_genre2": "Conseiller",
    "remuneration": "6650",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9975",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "2938",
    "nom_corrige2": "Monique Allaire",
    "nom_famille": "Allaire",
    "titre_genre2": "Conseillère",
    "remuneration": "6650",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9975",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "2939",
    "nom_corrige2": "Martin Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "6650",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9975",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "2940",
    "nom_corrige2": "Isabelle Brunet",
    "nom_famille": "Brunet",
    "titre_genre2": "Conseillère",
    "remuneration": "6650",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9975",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "2941",
    "nom_corrige2": "Ghyslain Maheu",
    "nom_famille": "Maheu",
    "titre_genre2": "Conseiller",
    "remuneration": "6649",
    "allocation": "3299",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9948",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "2942",
    "nom_corrige2": "Patricia Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseillère",
    "remuneration": "6393",
    "allocation": "2109",
    "remuneration2": "957",
    "allocation2": "478",
    "total": "9937",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "2943",
    "nom_corrige2": "Jean-François Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "5966",
    "allocation": "2988",
    "remuneration2": "652",
    "allocation2": "326",
    "total": "9932",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "2944",
    "nom_corrige2": "Martial Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3304",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9911",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2945",
    "nom_corrige2": "Mathias Piché",
    "nom_famille": "Piché",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3304",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9911",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2946",
    "nom_corrige2": "Annie Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseillère",
    "remuneration": "6607",
    "allocation": "3304",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9911",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2947",
    "nom_corrige2": "Denys Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9910",
    "ville": "Saint-Basile",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2730"
  },
  {
    "ID": "2948",
    "nom_corrige2": "Stéphane Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2949",
    "nom_corrige2": "Donald Jacob",
    "nom_famille": "Jacob",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2950",
    "nom_corrige2": "Mario Massicotte",
    "nom_famille": "Massicotte",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2951",
    "nom_corrige2": "Yannick Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2952",
    "nom_corrige2": "Sophie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2953",
    "nom_corrige2": "Michel Beaumier",
    "nom_famille": "Beaumier",
    "titre_genre2": "Conseiller",
    "remuneration": "6607",
    "allocation": "3301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9908",
    "ville": "Saint-Maurice",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "3689"
  },
  {
    "ID": "2954",
    "nom_corrige2": "Karine Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9900",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2955",
    "nom_corrige2": "Valéry Casavant",
    "nom_famille": "Casavant",
    "titre_genre2": "Conseillère",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9900",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2956",
    "nom_corrige2": "Ghislain Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseiller",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9900",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2957",
    "nom_corrige2": "Martin Loiselle",
    "nom_famille": "Loiselle",
    "titre_genre2": "Conseiller",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9900",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2958",
    "nom_corrige2": "Pierre-Yves Viens",
    "nom_famille": "Viens",
    "titre_genre2": "Conseiller",
    "remuneration": "6600",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9900",
    "ville": "Saint-Mathias-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "4648"
  },
  {
    "ID": "2959",
    "nom_corrige2": "Pascal Cauchon",
    "nom_famille": "Cauchon",
    "titre_genre2": "Conseiller",
    "remuneration": "6555",
    "allocation": "3333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9888",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "2960",
    "nom_corrige2": "NELLIE FLEURY",
    "nom_famille": "FLEURY",
    "titre_genre2": "Conseillère",
    "remuneration": "7487",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9880",
    "ville": "L'Ascension-de-Notre-Seigneur",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2152"
  },
  {
    "ID": "2961",
    "nom_corrige2": "Guy Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseiller",
    "remuneration": "6581",
    "allocation": "3291",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9872",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "2962",
    "nom_corrige2": "PIERRE RAYMOND",
    "nom_famille": "RAYMOND",
    "titre_genre2": "Conseiller",
    "remuneration": "6650",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9869",
    "ville": "Montpellier",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1098"
  },
  {
    "ID": "2963",
    "nom_corrige2": "Jean-Philippe Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "6628",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9868",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "2964",
    "nom_corrige2": "Claude Deblois",
    "nom_famille": "Deblois",
    "titre_genre2": "Conseiller",
    "remuneration": "6628",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9868",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "2965",
    "nom_corrige2": "Rémi Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "6628",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9868",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "2966",
    "nom_corrige2": "Cathy Bisson",
    "nom_famille": "Bisson",
    "titre_genre2": "Conseillère",
    "remuneration": "6628",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9868",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "2967",
    "nom_corrige2": "Alain Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "6628",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9868",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "2968",
    "nom_corrige2": "Charles Brochu",
    "nom_famille": "Brochu",
    "titre_genre2": "Conseiller",
    "remuneration": "6564",
    "allocation": "3282",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9846",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "2969",
    "nom_corrige2": "MANON JOLIN",
    "nom_famille": "JOLIN",
    "titre_genre2": "Conseillère",
    "remuneration": "6579",
    "allocation": "3262",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9841",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "2970",
    "nom_corrige2": "Pierre Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "5549",
    "allocation": "2775",
    "remuneration2": "1010",
    "allocation2": "505",
    "total": "9839",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "2971",
    "nom_corrige2": "Jean-Yves Carrière",
    "nom_famille": "Carrière",
    "titre_genre2": "Conseiller",
    "remuneration": "6555",
    "allocation": "3277",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9832",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2972",
    "nom_corrige2": "Christian Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "6555",
    "allocation": "3277",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9832",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2973",
    "nom_corrige2": "Francine Dutrisac",
    "nom_famille": "Dutrisac",
    "titre_genre2": "Conseillère",
    "remuneration": "6555",
    "allocation": "3277",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9832",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2974",
    "nom_corrige2": "Robert Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseiller",
    "remuneration": "6555",
    "allocation": "3277",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9832",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2975",
    "nom_corrige2": "Michel Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "6555",
    "allocation": "3277",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9832",
    "ville": "Papineauville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "2359"
  },
  {
    "ID": "2976",
    "nom_corrige2": "Sylvie Duchesneau",
    "nom_famille": "Duchesneau",
    "titre_genre2": "Conseillère",
    "remuneration": "9804",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9804",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "2977",
    "nom_corrige2": "Jean-François Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "9804",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9804",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "2978",
    "nom_corrige2": "Alexandre Binette",
    "nom_famille": "Binette",
    "titre_genre2": "Maire",
    "remuneration": "6733",
    "allocation": "3067",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9800",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "2979",
    "nom_corrige2": "Bernard Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "6298",
    "allocation": "3150",
    "remuneration2": "350",
    "allocation2": "0",
    "total": "9798",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "2980",
    "nom_corrige2": "PETER RICHARDSON",
    "nom_famille": "RICHARDSON",
    "titre_genre2": "Conseiller",
    "remuneration": "6530",
    "allocation": "3265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9795",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2981",
    "nom_corrige2": "JEAN CLOUTIER",
    "nom_famille": "CLOUTIER",
    "titre_genre2": "Conseiller",
    "remuneration": "6530",
    "allocation": "3265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9795",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2982",
    "nom_corrige2": "BARBARA MCDONALD",
    "nom_famille": "MCDONALD",
    "titre_genre2": "Conseillère",
    "remuneration": "6530",
    "allocation": "3265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9795",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2983",
    "nom_corrige2": "PHILIPPE COUTURE",
    "nom_famille": "COUTURE",
    "titre_genre2": "Conseiller",
    "remuneration": "6530",
    "allocation": "3265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9795",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2984",
    "nom_corrige2": "CHRISTIAN DE VARENNES",
    "nom_famille": "DE",
    "titre_genre2": "Conseiller",
    "remuneration": "6530",
    "allocation": "3265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9795",
    "ville": "Lac-Tremblant-Nord",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "60"
  },
  {
    "ID": "2985",
    "nom_corrige2": "Francis Cassidy",
    "nom_famille": "Cassidy",
    "titre_genre2": "Conseiller",
    "remuneration": "6524",
    "allocation": "3262",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9786",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "2986",
    "nom_corrige2": "Simon Valcourt",
    "nom_famille": "Valcourt",
    "titre_genre2": "Conseiller",
    "remuneration": "5407",
    "allocation": "2704",
    "remuneration2": "1108",
    "allocation2": "553",
    "total": "9772",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "2987",
    "nom_corrige2": "Daniel Magnan",
    "nom_famille": "Magnan",
    "titre_genre2": "Conseiller",
    "remuneration": "6510",
    "allocation": "3255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9765",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2988",
    "nom_corrige2": "Sylvie Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseillère",
    "remuneration": "6510",
    "allocation": "3255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9765",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2989",
    "nom_corrige2": "Catherine Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseillère",
    "remuneration": "6510",
    "allocation": "3255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9765",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2990",
    "nom_corrige2": "Alexy Vezeau",
    "nom_famille": "Vezeau",
    "titre_genre2": "Conseiller",
    "remuneration": "6510",
    "allocation": "3255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9765",
    "ville": "Malartic",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "3356"
  },
  {
    "ID": "2991",
    "nom_corrige2": "Stéphane Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Maire",
    "remuneration": "4124",
    "allocation": "2162",
    "remuneration2": "2318",
    "allocation2": "1159",
    "total": "9763",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "2992",
    "nom_corrige2": "Claude Gaucher",
    "nom_famille": "Gaucher",
    "titre_genre2": "Conseiller",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "9756",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "2993",
    "nom_corrige2": "Géraldine Veilleux-Perron",
    "nom_famille": "Veilleux-Perron",
    "titre_genre2": "Conseillère",
    "remuneration": "6492",
    "allocation": "3246",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9738",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "2994",
    "nom_corrige2": "Shirley Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "6389",
    "allocation": "3333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9722",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "2995",
    "nom_corrige2": "Mathieu Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "6672",
    "allocation": "3046",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9718",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2996",
    "nom_corrige2": "Michel Crevier",
    "nom_famille": "Crevier",
    "titre_genre2": "Conseiller",
    "remuneration": "6672",
    "allocation": "3046",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9718",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2997",
    "nom_corrige2": "Mario Desmeules",
    "nom_famille": "Desmeules",
    "titre_genre2": "Conseiller",
    "remuneration": "6672",
    "allocation": "3046",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9718",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2998",
    "nom_corrige2": "Évelyne Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "6672",
    "allocation": "3046",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9718",
    "ville": "Les Éboulements",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1463"
  },
  {
    "ID": "2999",
    "nom_corrige2": "Sylvie Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "6473",
    "allocation": "3236",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9709",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "3000",
    "nom_corrige2": "François Dubeau",
    "nom_famille": "Dubeau",
    "titre_genre2": "Conseiller",
    "remuneration": "6470",
    "allocation": "3234",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9704",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "3001",
    "nom_corrige2": "Louis Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "6370",
    "allocation": "3333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9703",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "3002",
    "nom_corrige2": "Mario Montambault",
    "nom_famille": "Montambault",
    "titre_genre2": "Conseiller",
    "remuneration": "6370",
    "allocation": "3333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9703",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "3003",
    "nom_corrige2": "Mario St-Louis",
    "nom_famille": "St-Louis",
    "titre_genre2": "Maire",
    "remuneration": "6461",
    "allocation": "3231",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9692",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "3004",
    "nom_corrige2": "Michel Alliette",
    "nom_famille": "Alliette",
    "titre_genre2": "Conseiller",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "100",
    "allocation2": "50",
    "total": "9690",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "3005",
    "nom_corrige2": "Michel Roch",
    "nom_famille": "Roch",
    "titre_genre2": "Conseiller",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3006",
    "nom_corrige2": "Philippe Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3007",
    "nom_corrige2": "Russ St-Germain",
    "nom_famille": "St-Germain",
    "titre_genre2": "Conseiller",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3008",
    "nom_corrige2": "Olivier Hamel",
    "nom_famille": "Hamel",
    "titre_genre2": "Conseiller",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3009",
    "nom_corrige2": "Edward Claxton",
    "nom_famille": "Claxton",
    "titre_genre2": "Conseiller",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3010",
    "nom_corrige2": "Élise A. Latour",
    "nom_famille": "Latour",
    "titre_genre2": "Conseillère",
    "remuneration": "6459",
    "allocation": "3229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9688",
    "ville": "Lac-des-Seize-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "159"
  },
  {
    "ID": "3011",
    "nom_corrige2": "Isabelle Beaurivage",
    "nom_famille": "Beaurivage",
    "titre_genre2": "Conseillère",
    "remuneration": "6372",
    "allocation": "3311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9683",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "3012",
    "nom_corrige2": "Marie-Lou Darveau",
    "nom_famille": "Darveau",
    "titre_genre2": "Conseillère",
    "remuneration": "6372",
    "allocation": "3311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9683",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "3013",
    "nom_corrige2": "Julie Leblond",
    "nom_famille": "Leblond",
    "titre_genre2": "Conseillère",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9666",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "3014",
    "nom_corrige2": "André Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9666",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "3015",
    "nom_corrige2": "Darrell Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9666",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "3016",
    "nom_corrige2": "Rénald Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9666",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "3017",
    "nom_corrige2": "Samantha Jalbert Paré",
    "nom_famille": "Jalbert",
    "titre_genre2": "Conseillère",
    "remuneration": "6444",
    "allocation": "3222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9666",
    "ville": "East Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2232"
  },
  {
    "ID": "3018",
    "nom_corrige2": "Raynald Stockless",
    "nom_famille": "Stockless",
    "titre_genre2": "Conseiller",
    "remuneration": "9133",
    "allocation": "528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9661",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "3019",
    "nom_corrige2": "Benjamin Crawford",
    "nom_famille": "Crawford",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3020",
    "nom_corrige2": "Bertrand Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3021",
    "nom_corrige2": "André Valiquette",
    "nom_famille": "Valiquette",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3022",
    "nom_corrige2": "Alain Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3023",
    "nom_corrige2": "Jean-Louis Soulard",
    "nom_famille": "Soulard",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3024",
    "nom_corrige2": "Steve Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseiller",
    "remuneration": "6439",
    "allocation": "3219",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9658",
    "ville": "Témiscaming",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "2343"
  },
  {
    "ID": "3025",
    "nom_corrige2": "Sabryna Barabé-Favreau",
    "nom_famille": "Barabé-Favreau",
    "titre_genre2": "Conseillère",
    "remuneration": "7117",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "3026",
    "nom_corrige2": "Noëlla Comtois",
    "nom_famille": "Comtois",
    "titre_genre2": "Conseillère",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3027",
    "nom_corrige2": "Amélie Hinse",
    "nom_famille": "Hinse",
    "titre_genre2": "Conseillère",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3028",
    "nom_corrige2": "Patricia Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseillère",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3029",
    "nom_corrige2": "Martin Vaudreuil",
    "nom_famille": "Vaudreuil",
    "titre_genre2": "Conseiller",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3030",
    "nom_corrige2": "Céline Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Conseillère",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3031",
    "nom_corrige2": "Marie-Josée Boissonneault",
    "nom_famille": "Boissonneault",
    "titre_genre2": "Conseillère",
    "remuneration": "6424",
    "allocation": "3212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9636",
    "ville": "Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "4949"
  },
  {
    "ID": "3032",
    "nom_corrige2": "Johnny Izzi",
    "nom_famille": "Izzi",
    "titre_genre2": "Conseiller",
    "remuneration": "5887",
    "allocation": "2696",
    "remuneration2": "974",
    "allocation2": "78",
    "total": "9635",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3033",
    "nom_corrige2": "Michel Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Conseiller",
    "remuneration": "6296",
    "allocation": "3333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9629",
    "ville": "Saint-Ubalde",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1508"
  },
  {
    "ID": "3034",
    "nom_corrige2": "Jean-Yves Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Maire",
    "remuneration": "6400",
    "allocation": "3200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9600",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "3035",
    "nom_corrige2": "Peter Dopelhamer",
    "nom_famille": "Dopelhamer",
    "titre_genre2": "Conseiller",
    "remuneration": "6369",
    "allocation": "3191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9560",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "3036",
    "nom_corrige2": "Emmanuel Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9540",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "3037",
    "nom_corrige2": "Patrick Girouard",
    "nom_famille": "Girouard",
    "titre_genre2": "Conseiller",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9540",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "3038",
    "nom_corrige2": "André Filion",
    "nom_famille": "Filion",
    "titre_genre2": "Conseiller",
    "remuneration": "6360",
    "allocation": "3180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9540",
    "ville": "Sainte-Madeleine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2294"
  },
  {
    "ID": "3039",
    "nom_corrige2": "Guy Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "9008",
    "allocation": "514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9522",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "3040",
    "nom_corrige2": "Alex Bouthillette",
    "nom_famille": "Bouthillette",
    "titre_genre2": "Conseiller",
    "remuneration": "6332",
    "allocation": "3166",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9498",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "3041",
    "nom_corrige2": "Gilles Prairie",
    "nom_famille": "Prairie",
    "titre_genre2": "Conseiller",
    "remuneration": "7231",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9496",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3042",
    "nom_corrige2": "Gaétan Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9495",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3043",
    "nom_corrige2": "Nicole Massicotte",
    "nom_famille": "Massicotte",
    "titre_genre2": "Conseillère",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9495",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3044",
    "nom_corrige2": "Claude Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9495",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3045",
    "nom_corrige2": "Suzanne Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseillère",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9495",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3046",
    "nom_corrige2": "Donald Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "6330",
    "allocation": "3165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9495",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3047",
    "nom_corrige2": "Jean-Pierre Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "6315",
    "allocation": "3157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9472",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3048",
    "nom_corrige2": "Normand Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Maire",
    "remuneration": "6312",
    "allocation": "3156",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9468",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "3049",
    "nom_corrige2": "Claude Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "6228",
    "allocation": "3240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9468",
    "ville": "Saint-Gédéon-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2184"
  },
  {
    "ID": "3050",
    "nom_corrige2": "Réjean Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "6119",
    "allocation": "2996",
    "remuneration2": "230",
    "allocation2": "115",
    "total": "9460",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3051",
    "nom_corrige2": "Paul Lavallière",
    "nom_famille": "Lavallière",
    "titre_genre2": "Conseiller",
    "remuneration": "6305",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9457",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "3052",
    "nom_corrige2": "François Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "6305",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9457",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "3053",
    "nom_corrige2": "Christian Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Conseiller",
    "remuneration": "6305",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9457",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "3054",
    "nom_corrige2": "Jean-François Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "6305",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9457",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "3055",
    "nom_corrige2": "Julie Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Conseillère",
    "remuneration": "6305",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9457",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2040"
  },
  {
    "ID": "3056",
    "nom_corrige2": "Claude Durand",
    "nom_famille": "Durand",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9456",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "3057",
    "nom_corrige2": "Jean-Lorrain Lafond",
    "nom_famille": "Lafond",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9456",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "3058",
    "nom_corrige2": "Gilles Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9456",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "3059",
    "nom_corrige2": "Louis-Vincent Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9456",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "3060",
    "nom_corrige2": "Michaël Tousignant",
    "nom_famille": "Tousignant",
    "titre_genre2": "Conseiller",
    "remuneration": "6304",
    "allocation": "3152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9456",
    "ville": "Saint-Pierre-les-Becquets",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1126"
  },
  {
    "ID": "3061",
    "nom_corrige2": "Olivier Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "6298",
    "allocation": "3150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9448",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "3062",
    "nom_corrige2": "Brigitte Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "6298",
    "allocation": "3150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9448",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "3063",
    "nom_corrige2": "Linda Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseillère",
    "remuneration": "6298",
    "allocation": "3150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9448",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "3064",
    "nom_corrige2": "Lucienne Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Conseillère",
    "remuneration": "6298",
    "allocation": "3150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9448",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "3065",
    "nom_corrige2": "Louis André Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Conseiller",
    "remuneration": "6295",
    "allocation": "3153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9448",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "3066",
    "nom_corrige2": "Richard Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "6219",
    "allocation": "3035",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "9405",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3067",
    "nom_corrige2": "Gina Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "6267",
    "allocation": "3134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9401",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "3068",
    "nom_corrige2": "Isabelle Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseillère",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3069",
    "nom_corrige2": "Luc A. Bonneau",
    "nom_famille": "Bonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3070",
    "nom_corrige2": "Brigitte Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseillère",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3071",
    "nom_corrige2": "Nathalie Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseillère",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3072",
    "nom_corrige2": "Vincent Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseiller",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3073",
    "nom_corrige2": "Mario Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseiller",
    "remuneration": "6266",
    "allocation": "3133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9399",
    "ville": "Saint-Prime",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2817"
  },
  {
    "ID": "3074",
    "nom_corrige2": "Marc Bureau",
    "nom_famille": "Bureau",
    "titre_genre2": "Conseiller",
    "remuneration": "7296",
    "allocation": "2092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9388",
    "ville": "Gatineau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "292281"
  },
  {
    "ID": "3075",
    "nom_corrige2": "Richard Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "6250",
    "allocation": "3124",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9374",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "3076",
    "nom_corrige2": "Daniel Enright",
    "nom_famille": "Enright",
    "titre_genre2": "Conseiller",
    "remuneration": "6098",
    "allocation": "3049",
    "remuneration2": "149",
    "allocation2": "74",
    "total": "9370",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "3077",
    "nom_corrige2": "Marie-Céline Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "6245",
    "allocation": "3122",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9367",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3078",
    "nom_corrige2": "Amélie Audet Moisan",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "6241",
    "allocation": "3121",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9362",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "3079",
    "nom_corrige2": "Lynda Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseillère",
    "remuneration": "6319",
    "allocation": "3035",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9354",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3080",
    "nom_corrige2": "Julie Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "6319",
    "allocation": "3035",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9354",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3081",
    "nom_corrige2": "André Woodbury",
    "nom_famille": "Woodbury",
    "titre_genre2": "Conseiller",
    "remuneration": "6221",
    "allocation": "3115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9336",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "3082",
    "nom_corrige2": "Jean-Sébastien Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseiller",
    "remuneration": "6213",
    "allocation": "3107",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9320",
    "ville": "Saint-Denis-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "4852"
  },
  {
    "ID": "3083",
    "nom_corrige2": "Deborah Bishop",
    "nom_famille": "Bishop",
    "titre_genre2": "Conseillère",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3084",
    "nom_corrige2": "Harvey Stevens",
    "nom_famille": "Stevens",
    "titre_genre2": "Conseiller",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3085",
    "nom_corrige2": "Nicholas Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3086",
    "nom_corrige2": "Valérie Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3087",
    "nom_corrige2": "Philip Dutil",
    "nom_famille": "Dutil",
    "titre_genre2": "Conseiller",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3088",
    "nom_corrige2": "Sandra Harrison",
    "nom_famille": "Harrison",
    "titre_genre2": "Conseillère",
    "remuneration": "6204",
    "allocation": "3102",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9306",
    "ville": "Stanstead",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2893"
  },
  {
    "ID": "3089",
    "nom_corrige2": "Isabelle Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseillère",
    "remuneration": "6182",
    "allocation": "2767",
    "remuneration2": "230",
    "allocation2": "115",
    "total": "9294",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3090",
    "nom_corrige2": "Éric Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseiller",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "1923",
    "allocation2": "961",
    "total": "9284",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "3091",
    "nom_corrige2": "André Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9280",
    "ville": "Grenville",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1840"
  },
  {
    "ID": "3092",
    "nom_corrige2": "Richard Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3093",
    "nom_corrige2": "Gervais Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3094",
    "nom_corrige2": "Julie Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseillère",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3095",
    "nom_corrige2": "Michel L'Heureux",
    "nom_famille": "L'Heureux",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3096",
    "nom_corrige2": "François Robitaille",
    "nom_famille": "Robitaille",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3097",
    "nom_corrige2": "Bruno Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseiller",
    "remuneration": "6184",
    "allocation": "3092",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9276",
    "ville": "Saint-Henri",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "5939"
  },
  {
    "ID": "3098",
    "nom_corrige2": "Danielle Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseillère",
    "remuneration": "6219",
    "allocation": "3035",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9254",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3099",
    "nom_corrige2": "Daniel Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "6194",
    "allocation": "3035",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9229",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3100",
    "nom_corrige2": "Gilles Sénécal",
    "nom_famille": "Sénécal",
    "titre_genre2": "Conseiller",
    "remuneration": "6150",
    "allocation": "3074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9224",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "3101",
    "nom_corrige2": "Francis Lacelle",
    "nom_famille": "Lacelle",
    "titre_genre2": "Conseiller",
    "remuneration": "6150",
    "allocation": "3074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9224",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "3102",
    "nom_corrige2": "Jonathan Bock",
    "nom_famille": "Bock",
    "titre_genre2": "Conseiller",
    "remuneration": "6146",
    "allocation": "3073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9219",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "3103",
    "nom_corrige2": "Jonathan Beauchamp",
    "nom_famille": "Beauchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "6146",
    "allocation": "3073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9219",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "3104",
    "nom_corrige2": "Alexandre Le Blanc",
    "nom_famille": "Le",
    "titre_genre2": "Conseiller",
    "remuneration": "6146",
    "allocation": "3073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9219",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "3105",
    "nom_corrige2": "Sylvie Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseillère",
    "remuneration": "6146",
    "allocation": "3073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9219",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "3106",
    "nom_corrige2": "Julie Theriault",
    "nom_famille": "Theriault",
    "titre_genre2": "Mairesse",
    "remuneration": "6295",
    "allocation": "2916",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9211",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "3107",
    "nom_corrige2": "Alain Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseiller",
    "remuneration": "5392",
    "allocation": "2696",
    "remuneration2": "1097",
    "allocation2": "0",
    "total": "9185",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3108",
    "nom_corrige2": "BRUNO GUILBAULT",
    "nom_famille": "GUILBAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3109",
    "nom_corrige2": "LUCIE RACINE",
    "nom_famille": "RACINE",
    "titre_genre2": "Conseillère",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3110",
    "nom_corrige2": "MARIE-CLAUDE BOURBEAU",
    "nom_famille": "BOURBEAU",
    "titre_genre2": "Conseillère",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3111",
    "nom_corrige2": "PASCAL VERREAULT",
    "nom_famille": "VERREAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3112",
    "nom_corrige2": "LAURENCE ROBERT",
    "nom_famille": "ROBERT",
    "titre_genre2": "Conseillère",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3113",
    "nom_corrige2": "SIMON-PIERRE CARON-LABRANCHE",
    "nom_famille": "CARON-LABRANCHE",
    "titre_genre2": "Conseiller",
    "remuneration": "6123",
    "allocation": "3062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9185",
    "ville": "Saint-Joachim",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1430"
  },
  {
    "ID": "3114",
    "nom_corrige2": "Jimmy Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3115",
    "nom_corrige2": "Bruno Montminy",
    "nom_famille": "Montminy",
    "titre_genre2": "Conseiller",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3116",
    "nom_corrige2": "Patricia St-Hilaire",
    "nom_famille": "St-Hilaire",
    "titre_genre2": "Conseillère",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3117",
    "nom_corrige2": "Carole Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3118",
    "nom_corrige2": "Gérard Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3119",
    "nom_corrige2": "Yvan Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "6116",
    "allocation": "3057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9173",
    "ville": "Saint-Gilles",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2914"
  },
  {
    "ID": "3120",
    "nom_corrige2": "Rémy Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "6099",
    "allocation": "3050",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9149",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3121",
    "nom_corrige2": "Guylaine Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "6075",
    "allocation": "3074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9149",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "3122",
    "nom_corrige2": "Marie-Claude Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseillère",
    "remuneration": "6088",
    "allocation": "3044",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9132",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "3123",
    "nom_corrige2": "Réal Déry",
    "nom_famille": "Déry",
    "titre_genre2": "Conseiller",
    "remuneration": "6088",
    "allocation": "3044",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9132",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "3124",
    "nom_corrige2": "Maurice Rolland",
    "nom_famille": "Rolland",
    "titre_genre2": "Conseiller",
    "remuneration": "6088",
    "allocation": "3044",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9132",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "3125",
    "nom_corrige2": "Annie Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseillère",
    "remuneration": "6088",
    "allocation": "3044",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9132",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "3126",
    "nom_corrige2": "Cédric Lecompte Laberge",
    "nom_famille": "Lecompte",
    "titre_genre2": "Conseiller",
    "remuneration": "6119",
    "allocation": "2996",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9115",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3127",
    "nom_corrige2": "Daniel Laflèche",
    "nom_famille": "Laflèche",
    "titre_genre2": "Conseiller",
    "remuneration": "6119",
    "allocation": "2996",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9115",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3128",
    "nom_corrige2": "France Rivet",
    "nom_famille": "Rivet",
    "titre_genre2": "Conseillère",
    "remuneration": "6119",
    "allocation": "2996",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9115",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3129",
    "nom_corrige2": "Majolaine Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseillère",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "9113",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3130",
    "nom_corrige2": "Pierre Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Maire",
    "remuneration": "6065",
    "allocation": "3033",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9098",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "3131",
    "nom_corrige2": "André Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "6052",
    "allocation": "3026",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9078",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "3132",
    "nom_corrige2": "Mélanie Bourgault",
    "nom_famille": "Bourgault",
    "titre_genre2": "Mairesse",
    "remuneration": "6050",
    "allocation": "3026",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9076",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "3133",
    "nom_corrige2": "Martin Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseiller",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3134",
    "nom_corrige2": "François Pichette",
    "nom_famille": "Pichette",
    "titre_genre2": "Conseiller",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3135",
    "nom_corrige2": "Nathalie Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseillère",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3136",
    "nom_corrige2": "Patrick Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3137",
    "nom_corrige2": "Nancy Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseillère",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3138",
    "nom_corrige2": "Véronique Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseillère",
    "remuneration": "6050",
    "allocation": "3025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9075",
    "ville": "Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "2009"
  },
  {
    "ID": "3139",
    "nom_corrige2": "Dérek O'Hearn",
    "nom_famille": "O'Hearn",
    "titre_genre2": "Conseiller",
    "remuneration": "5774",
    "allocation": "1927",
    "remuneration2": "894",
    "allocation2": "447",
    "total": "9042",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "3140",
    "nom_corrige2": "Andrew J. Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "6006",
    "allocation": "3034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9040",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "3141",
    "nom_corrige2": "Julie Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseillère",
    "remuneration": "5974",
    "allocation": "2988",
    "remuneration2": "50",
    "allocation2": "25",
    "total": "9037",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3142",
    "nom_corrige2": "Daniel Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Maire",
    "remuneration": "6024",
    "allocation": "3012",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9036",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "3143",
    "nom_corrige2": "Audrey Mailhot",
    "nom_famille": "Mailhot",
    "titre_genre2": "Conseillère",
    "remuneration": "6014",
    "allocation": "3007",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9021",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "3144",
    "nom_corrige2": "Francis Malenfant",
    "nom_famille": "Malenfant",
    "titre_genre2": "Conseiller",
    "remuneration": "6014",
    "allocation": "3007",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9021",
    "ville": "Cleveland",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1615"
  },
  {
    "ID": "3145",
    "nom_corrige2": "Julie Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "6045",
    "allocation": "2959",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9004",
    "ville": "Rivière-Beaudette",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3146",
    "nom_corrige2": "Diane Rhéaume",
    "nom_famille": "Rhéaume",
    "titre_genre2": "Conseillère",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3147",
    "nom_corrige2": "Hélène Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseillère",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3148",
    "nom_corrige2": "Antoine Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3149",
    "nom_corrige2": "Jean-François Allen",
    "nom_famille": "Allen",
    "titre_genre2": "Conseiller",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3150",
    "nom_corrige2": "Daniel Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3151",
    "nom_corrige2": "Cindy Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Saint-Isidore",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3313"
  },
  {
    "ID": "3152",
    "nom_corrige2": "Diane Pinet",
    "nom_famille": "Pinet",
    "titre_genre2": "Conseillère",
    "remuneration": "6000",
    "allocation": "3000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9000",
    "ville": "Lac-Sergent",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "549"
  },
  {
    "ID": "3153",
    "nom_corrige2": "SERGE PERREAULT",
    "nom_famille": "PERREAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "254",
    "allocation2": "127",
    "total": "8967",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3154",
    "nom_corrige2": "Jacinthe Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3155",
    "nom_corrige2": "Renald Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3156",
    "nom_corrige2": "Jean-Claude Gaudreau",
    "nom_famille": "Gaudreau",
    "titre_genre2": "Conseiller",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3157",
    "nom_corrige2": "Mathieu-Olivier St-Louis",
    "nom_famille": "St-Louis",
    "titre_genre2": "Conseiller",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3158",
    "nom_corrige2": "Régis Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseiller",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3159",
    "nom_corrige2": "Marie-Eve Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseillère",
    "remuneration": "5977",
    "allocation": "2989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8966",
    "ville": "Cap-Chat",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2452"
  },
  {
    "ID": "3160",
    "nom_corrige2": "Jean Thifault",
    "nom_famille": "Thifault",
    "titre_genre2": "Conseiller",
    "remuneration": "5974",
    "allocation": "2988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8962",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3161",
    "nom_corrige2": "Jocelyn Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "5974",
    "allocation": "2988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8962",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3162",
    "nom_corrige2": "Natalie Gareau",
    "nom_famille": "Gareau",
    "titre_genre2": "Conseillère",
    "remuneration": "5974",
    "allocation": "2988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8962",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3163",
    "nom_corrige2": "Richard Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "5974",
    "allocation": "2988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8962",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3164",
    "nom_corrige2": "André Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "5974",
    "allocation": "2987",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8961",
    "ville": "Stratford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "3165",
    "nom_corrige2": "Jacques Mayer",
    "nom_famille": "Mayer",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "3000",
    "allocation2": "1500",
    "total": "8952",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "3166",
    "nom_corrige2": "Annie Chevalier",
    "nom_famille": "Chevalier",
    "titre_genre2": "Conseillère",
    "remuneration": "8468",
    "allocation": "454",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8922",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "3167",
    "nom_corrige2": "Suzanne Croteau",
    "nom_famille": "Croteau",
    "titre_genre2": "Conseillère",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3168",
    "nom_corrige2": "Marc Legros",
    "nom_famille": "Legros",
    "titre_genre2": "Conseiller",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3169",
    "nom_corrige2": "Jessika Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseillère",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3170",
    "nom_corrige2": "William Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3171",
    "nom_corrige2": "Denis Pérusse",
    "nom_famille": "Pérusse",
    "titre_genre2": "Conseiller",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3172",
    "nom_corrige2": "Ghislain Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "5946",
    "allocation": "2973",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8919",
    "ville": "Laurier-Station",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2738"
  },
  {
    "ID": "3173",
    "nom_corrige2": "André Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "5928",
    "allocation": "2964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8892",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3174",
    "nom_corrige2": "Audrey Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "5504",
    "allocation": "2752",
    "remuneration2": "419",
    "allocation2": "209",
    "total": "8884",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "3175",
    "nom_corrige2": "François Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Maire",
    "remuneration": "4253",
    "allocation": "2126",
    "remuneration2": "1662",
    "allocation2": "831",
    "total": "8872",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "3176",
    "nom_corrige2": "René Courtemanche",
    "nom_famille": "Courtemanche",
    "titre_genre2": "Conseiller",
    "remuneration": "5913",
    "allocation": "2956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8869",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3177",
    "nom_corrige2": "Guy Nadon",
    "nom_famille": "Nadon",
    "titre_genre2": "Conseiller",
    "remuneration": "5913",
    "allocation": "2956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8869",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3178",
    "nom_corrige2": "Martin Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseiller",
    "remuneration": "5913",
    "allocation": "2956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8869",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3179",
    "nom_corrige2": "Martin Evangéliste",
    "nom_famille": "Evangéliste",
    "titre_genre2": "Conseiller",
    "remuneration": "5913",
    "allocation": "2956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8869",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "3180",
    "nom_corrige2": "Maurice Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "7059",
    "allocation": "1355",
    "remuneration2": "289",
    "allocation2": "144",
    "total": "8847",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "3181",
    "nom_corrige2": "Isabelle Thibeault",
    "nom_famille": "Thibeault",
    "titre_genre2": "Conseillère",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3182",
    "nom_corrige2": "Édith Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseillère",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3183",
    "nom_corrige2": "Tommy Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseiller",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3184",
    "nom_corrige2": "Guillaume Painchaud",
    "nom_famille": "Painchaud",
    "titre_genre2": "Conseiller",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3185",
    "nom_corrige2": "Charline Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3186",
    "nom_corrige2": "Nick St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "5897",
    "allocation": "2949",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8846",
    "ville": "Albanel",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2229"
  },
  {
    "ID": "3187",
    "nom_corrige2": "Martin Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseiller",
    "remuneration": "5172",
    "allocation": "2586",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "8844",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3188",
    "nom_corrige2": "Pascal Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Maire",
    "remuneration": "5894",
    "allocation": "2947",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8841",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "3189",
    "nom_corrige2": "Richard Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "5892",
    "allocation": "2946",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8838",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "3190",
    "nom_corrige2": "Sandra Cardin",
    "nom_famille": "Cardin",
    "titre_genre2": "Conseillère",
    "remuneration": "5887",
    "allocation": "2944",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8831",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "3191",
    "nom_corrige2": "Gilbert Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Conseiller",
    "remuneration": "6137",
    "allocation": "2683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8820",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "3192",
    "nom_corrige2": "Ginette Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Mairesse",
    "remuneration": "5880",
    "allocation": "2940",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8820",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "3193",
    "nom_corrige2": "Gaétan Jodoin",
    "nom_famille": "Jodoin",
    "titre_genre2": "Conseiller",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "100",
    "allocation2": "50",
    "total": "8820",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "3194",
    "nom_corrige2": "Serge Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Conseiller",
    "remuneration": "5876",
    "allocation": "2938",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8814",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "3195",
    "nom_corrige2": "David Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3196",
    "nom_corrige2": "Gaston Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3197",
    "nom_corrige2": "Molly Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Conseillère",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3198",
    "nom_corrige2": "Richard Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseiller",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3199",
    "nom_corrige2": "Pierre Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3200",
    "nom_corrige2": "Jean-Charles Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "5874",
    "allocation": "2937",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8811",
    "ville": "Bonaventure",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "2739"
  },
  {
    "ID": "3201",
    "nom_corrige2": "Jacques Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "6393",
    "allocation": "2109",
    "remuneration2": "300",
    "allocation2": "0",
    "total": "8802",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "3202",
    "nom_corrige2": "Barry Ardis",
    "nom_famille": "Ardis",
    "titre_genre2": "Conseiller",
    "remuneration": "4693",
    "allocation": "2347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7040",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "3203",
    "nom_corrige2": "Marie-Josée Deaudelin",
    "nom_famille": "Deaudelin",
    "titre_genre2": "Conseillère",
    "remuneration": "5856",
    "allocation": "2928",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8784",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "3204",
    "nom_corrige2": "Georges-Etienne Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseiller",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "100",
    "allocation2": "50",
    "total": "8784",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3205",
    "nom_corrige2": "JOSÉE LECLAIR",
    "nom_famille": "LECLAIR",
    "titre_genre2": "Conseillère",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "127",
    "allocation2": "64",
    "total": "8777",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3206",
    "nom_corrige2": "Dennis Dicks",
    "nom_famille": "Dicks",
    "titre_genre2": "Conseiller",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3207",
    "nom_corrige2": "Christopher Jackson",
    "nom_famille": "Jackson",
    "titre_genre2": "Conseiller",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3208",
    "nom_corrige2": "Michelle Jackson Trepanier",
    "nom_famille": "Jackson",
    "titre_genre2": "Conseillère",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3209",
    "nom_corrige2": "Stephen Lee",
    "nom_famille": "Lee",
    "titre_genre2": "Conseiller",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3210",
    "nom_corrige2": "Pierre Matuszewski",
    "nom_famille": "Matuszewski",
    "titre_genre2": "Conseiller",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3211",
    "nom_corrige2": "Tanya Narang",
    "nom_famille": "Narang",
    "titre_genre2": "Conseillère",
    "remuneration": "5849",
    "allocation": "2924",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8773",
    "ville": "Senneville",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "1003"
  },
  {
    "ID": "3212",
    "nom_corrige2": "Julie Paiement",
    "nom_famille": "Paiement",
    "titre_genre2": "Conseillère",
    "remuneration": "5840",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8760",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "3213",
    "nom_corrige2": "Jacques Rodgers",
    "nom_famille": "Rodgers",
    "titre_genre2": "Conseiller",
    "remuneration": "5840",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8760",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "3214",
    "nom_corrige2": "Éric Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "5840",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8760",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "3215",
    "nom_corrige2": "Annie Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "5840",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8760",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "3216",
    "nom_corrige2": "Rodrigue Lacourcière",
    "nom_famille": "Lacourcière",
    "titre_genre2": "Conseiller",
    "remuneration": "5840",
    "allocation": "2920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8760",
    "ville": "Grand-Remous",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1212"
  },
  {
    "ID": "3217",
    "nom_corrige2": "NATHAN KAISER",
    "nom_famille": "KAISER",
    "titre_genre2": "Conseiller",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3218",
    "nom_corrige2": "SONIA CHIASSON",
    "nom_famille": "CHIASSON",
    "titre_genre2": "Conseillère",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3219",
    "nom_corrige2": "MARIE-CHRISTINE LAFFORGUE",
    "nom_famille": "LAFFORGUE",
    "titre_genre2": "Conseillère",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3220",
    "nom_corrige2": "OWEN MACCALLUM",
    "nom_famille": "MACCALLUM",
    "titre_genre2": "Conseiller",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3221",
    "nom_corrige2": "RANDY R. SMITH",
    "nom_famille": "SMITH",
    "titre_genre2": "Conseiller",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3222",
    "nom_corrige2": "MELISSA GUSHUE",
    "nom_famille": "GUSHUE",
    "titre_genre2": "Conseillère",
    "remuneration": "6103",
    "allocation": "2653",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8756",
    "ville": "Noyan",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1589"
  },
  {
    "ID": "3223",
    "nom_corrige2": "Domenica Guzzo",
    "nom_famille": "Guzzo",
    "titre_genre2": "Conseillère",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8754",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3224",
    "nom_corrige2": "Isabelle Bibeau",
    "nom_famille": "Bibeau",
    "titre_genre2": "Conseillère",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8754",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3225",
    "nom_corrige2": "Réjean Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8754",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3226",
    "nom_corrige2": "Vincent Dodier",
    "nom_famille": "Dodier",
    "titre_genre2": "Conseiller",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8754",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3227",
    "nom_corrige2": "Réjean Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "5836",
    "allocation": "2918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8754",
    "ville": "Dudswell",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1873"
  },
  {
    "ID": "3228",
    "nom_corrige2": "Norman Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "6226",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8745",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "3229",
    "nom_corrige2": "Gérald Ranger",
    "nom_famille": "Ranger",
    "titre_genre2": "Conseiller",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3230",
    "nom_corrige2": "Marie-Chantal Laberge",
    "nom_famille": "Laberge",
    "titre_genre2": "Conseillère",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3231",
    "nom_corrige2": "Éric Pinard",
    "nom_famille": "Pinard",
    "titre_genre2": "Conseiller",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3232",
    "nom_corrige2": "Daniel Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3233",
    "nom_corrige2": "Liette Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseillère",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3234",
    "nom_corrige2": "Mélanie Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "72",
    "allocation2": "36",
    "total": "8742",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3235",
    "nom_corrige2": "Léon Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "5828",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8742",
    "ville": "Léry",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2451"
  },
  {
    "ID": "3236",
    "nom_corrige2": "Marie-Claude Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "8302",
    "allocation": "436",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8738",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "3237",
    "nom_corrige2": "Pierre Venne",
    "nom_famille": "Venne",
    "titre_genre2": "Conseiller",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3238",
    "nom_corrige2": "Mélanie Mainville",
    "nom_famille": "Mainville",
    "titre_genre2": "Conseillère",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3239",
    "nom_corrige2": "Marthe Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3240",
    "nom_corrige2": "François Fruhauf",
    "nom_famille": "Fruhauf",
    "titre_genre2": "Conseiller",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3241",
    "nom_corrige2": "Claire Sarrazin",
    "nom_famille": "Sarrazin",
    "titre_genre2": "Conseillère",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3242",
    "nom_corrige2": "Gaétan Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseiller",
    "remuneration": "5819",
    "allocation": "2909",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8728",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3080"
  },
  {
    "ID": "3243",
    "nom_corrige2": "Yves Taillon",
    "nom_famille": "Taillon",
    "titre_genre2": "Conseiller",
    "remuneration": "5816",
    "allocation": "2908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8724",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "3244",
    "nom_corrige2": "Jean-Philippe Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "5838",
    "allocation": "2882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8720",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "3245",
    "nom_corrige2": "Dominique Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "5838",
    "allocation": "2882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8720",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "3246",
    "nom_corrige2": "Jacques Robitaille",
    "nom_famille": "Robitaille",
    "titre_genre2": "Conseiller",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3247",
    "nom_corrige2": "Maurice Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseiller",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3248",
    "nom_corrige2": "Geneviève Henry",
    "nom_famille": "Henry",
    "titre_genre2": "Conseillère",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3249",
    "nom_corrige2": "Marie Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseillère",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3250",
    "nom_corrige2": "Claudia Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseillère",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3251",
    "nom_corrige2": "Agnès Derouin",
    "nom_famille": "Derouin",
    "titre_genre2": "Conseillère",
    "remuneration": "5803",
    "allocation": "2901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8704",
    "ville": "Saint-Thomas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3621"
  },
  {
    "ID": "3252",
    "nom_corrige2": "Laurent Barsalou",
    "nom_famille": "Barsalou",
    "titre_genre2": "Conseiller",
    "remuneration": "5815",
    "allocation": "2857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8672",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3253",
    "nom_corrige2": "Patrice Schoune",
    "nom_famille": "Schoune",
    "titre_genre2": "Conseiller",
    "remuneration": "5815",
    "allocation": "2857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8672",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3254",
    "nom_corrige2": "Ghislaine Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8670",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "3255",
    "nom_corrige2": "Yvon Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseiller",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8670",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "3256",
    "nom_corrige2": "Yves Monast",
    "nom_famille": "Monast",
    "titre_genre2": "Conseiller",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8670",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "3257",
    "nom_corrige2": "Guy Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseiller",
    "remuneration": "5780",
    "allocation": "2890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8670",
    "ville": "Saint-Damase",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2574"
  },
  {
    "ID": "3258",
    "nom_corrige2": "Anne Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Conseillère",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3259",
    "nom_corrige2": "Annie Galipeau",
    "nom_famille": "Galipeau",
    "titre_genre2": "Conseillère",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3260",
    "nom_corrige2": "Charles Rondeau",
    "nom_famille": "Rondeau",
    "titre_genre2": "Conseiller",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3261",
    "nom_corrige2": "Yves St-Jacques",
    "nom_famille": "St-Jacques",
    "titre_genre2": "Conseiller",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3262",
    "nom_corrige2": "Marie-Anne Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseillère",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3263",
    "nom_corrige2": "André Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseiller",
    "remuneration": "5777",
    "allocation": "2888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8665",
    "ville": "Messines",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1711"
  },
  {
    "ID": "3264",
    "nom_corrige2": "JEAN-SÉBASTIEN BERGERON",
    "nom_famille": "BERGERON",
    "titre_genre2": "Maire",
    "remuneration": "5019",
    "allocation": "2500",
    "remuneration2": "858",
    "allocation2": "286",
    "total": "8663",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "3265",
    "nom_corrige2": "Alain Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3266",
    "nom_corrige2": "Jean-François Marois",
    "nom_famille": "Marois",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3267",
    "nom_corrige2": "Claude Jolicoeur",
    "nom_famille": "Jolicoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3268",
    "nom_corrige2": "Germain Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3269",
    "nom_corrige2": "Martial Matteau",
    "nom_famille": "Matteau",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3270",
    "nom_corrige2": "Daniel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5773",
    "allocation": "2886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8659",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3271",
    "nom_corrige2": "Sylvie Van Dersmissen",
    "nom_famille": "Van",
    "titre_genre2": "Conseillère",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "374",
    "allocation2": "0",
    "total": "8635",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3272",
    "nom_corrige2": "François Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "5756",
    "allocation": "2878",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8634",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3273",
    "nom_corrige2": "Jean Provost",
    "nom_famille": "Provost",
    "titre_genre2": "Conseiller",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8634",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3274",
    "nom_corrige2": "Myriam Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Conseillère",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8634",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3275",
    "nom_corrige2": "Frédéric Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8634",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3276",
    "nom_corrige2": "Rosaire Phaneuf",
    "nom_famille": "Phaneuf",
    "titre_genre2": "Conseiller",
    "remuneration": "5755",
    "allocation": "2879",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8634",
    "ville": "La Présentation",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2595"
  },
  {
    "ID": "3277",
    "nom_corrige2": "André Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Maire",
    "remuneration": "4670",
    "allocation": "2335",
    "remuneration2": "1084",
    "allocation2": "542",
    "total": "8631",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "3278",
    "nom_corrige2": "Pascal Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseiller",
    "remuneration": "5738",
    "allocation": "2882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8620",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "3279",
    "nom_corrige2": "Fernand Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "5738",
    "allocation": "2882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8620",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "3280",
    "nom_corrige2": "Danie Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "5738",
    "allocation": "2882",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8620",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "3281",
    "nom_corrige2": "Mario Guimont",
    "nom_famille": "Guimont",
    "titre_genre2": "Maire",
    "remuneration": "5755",
    "allocation": "2863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8618",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "3282",
    "nom_corrige2": "Pascal Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "5743",
    "allocation": "2872",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8615",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3283",
    "nom_corrige2": "Lise Anctil",
    "nom_famille": "Anctil",
    "titre_genre2": "Conseillère",
    "remuneration": "6153",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8605",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3284",
    "nom_corrige2": "Martine Bachand",
    "nom_famille": "Bachand",
    "titre_genre2": "Conseillère",
    "remuneration": "5736",
    "allocation": "2868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8604",
    "ville": "Saint-Liboire",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3111"
  },
  {
    "ID": "3285",
    "nom_corrige2": "Serge Ennis",
    "nom_famille": "Ennis",
    "titre_genre2": "Conseiller",
    "remuneration": "6393",
    "allocation": "2109",
    "remuneration2": "100",
    "allocation2": "0",
    "total": "8602",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "3286",
    "nom_corrige2": "Julie Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "6077",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8596",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "3287",
    "nom_corrige2": "Martine Monette",
    "nom_famille": "Monette",
    "titre_genre2": "Conseillère",
    "remuneration": "6077",
    "allocation": "2519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8596",
    "ville": "Saint-Mathieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2378"
  },
  {
    "ID": "3288",
    "nom_corrige2": "MARIE-CLAUDE AYOTTE",
    "nom_famille": "AYOTTE",
    "titre_genre2": "Conseillère",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8586",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3289",
    "nom_corrige2": "PIERRE COUTU",
    "nom_famille": "COUTU",
    "titre_genre2": "Conseiller",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8586",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3290",
    "nom_corrige2": "Benoît Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8586",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3291",
    "nom_corrige2": "OLIVIER GUILBERT CHOINIÈRE",
    "nom_famille": "GUILBERT",
    "titre_genre2": "Conseiller",
    "remuneration": "5724",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8586",
    "ville": "Sainte-Élisabeth",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1477"
  },
  {
    "ID": "3292",
    "nom_corrige2": "Gilles Payer",
    "nom_famille": "Payer",
    "titre_genre2": "Conseiller",
    "remuneration": "5723",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8585",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3293",
    "nom_corrige2": "Michel Longtin",
    "nom_famille": "Longtin",
    "titre_genre2": "Conseiller",
    "remuneration": "5723",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8585",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3294",
    "nom_corrige2": "Raymond Bisson",
    "nom_famille": "Bisson",
    "titre_genre2": "Conseiller",
    "remuneration": "5723",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8585",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3295",
    "nom_corrige2": "Noël Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "5723",
    "allocation": "2862",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8585",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3296",
    "nom_corrige2": "Éric Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "6180",
    "allocation": "2217",
    "remuneration2": "187",
    "allocation2": "0",
    "total": "8584",
    "ville": "Saguenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "147952"
  },
  {
    "ID": "3297",
    "nom_corrige2": "François Lalonde",
    "nom_famille": "Lalonde",
    "titre_genre2": "Conseiller",
    "remuneration": "5715",
    "allocation": "2857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8572",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3298",
    "nom_corrige2": "Annie Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseillère",
    "remuneration": "5715",
    "allocation": "2857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8572",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3299",
    "nom_corrige2": "Maxime Gamelin",
    "nom_famille": "Gamelin",
    "titre_genre2": "Conseiller",
    "remuneration": "5715",
    "allocation": "2857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8572",
    "ville": "Saint-Polycarpe",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2564"
  },
  {
    "ID": "3300",
    "nom_corrige2": "Solange Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "5699",
    "allocation": "2850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8549",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3301",
    "nom_corrige2": "Bernard Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "5699",
    "allocation": "2850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8549",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3302",
    "nom_corrige2": "Josée Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseillère",
    "remuneration": "5699",
    "allocation": "2850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8549",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3137"
  },
  {
    "ID": "3303",
    "nom_corrige2": "Marc Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseiller",
    "remuneration": "5699",
    "allocation": "2849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8548",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "3304",
    "nom_corrige2": "Michael Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "5699",
    "allocation": "2849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8548",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "3305",
    "nom_corrige2": "Paul Dénommé",
    "nom_famille": "Dénommé",
    "titre_genre2": "Conseiller",
    "remuneration": "5699",
    "allocation": "2849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8548",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "3306",
    "nom_corrige2": "Gérard Lacaille",
    "nom_famille": "Lacaille",
    "titre_genre2": "Conseiller",
    "remuneration": "5699",
    "allocation": "2849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8548",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "3307",
    "nom_corrige2": "Marielle Cousineau Fortin",
    "nom_famille": "Cousineau",
    "titre_genre2": "Conseillère",
    "remuneration": "5699",
    "allocation": "2849",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8548",
    "ville": "Blue Sea",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "680"
  },
  {
    "ID": "3308",
    "nom_corrige2": "Marc Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "5693",
    "allocation": "2847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8540",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3309",
    "nom_corrige2": "Denise Corneau",
    "nom_famille": "Corneau",
    "titre_genre2": "Conseillère",
    "remuneration": "5693",
    "allocation": "2846",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8539",
    "ville": "Duhamel",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "502"
  },
  {
    "ID": "3310",
    "nom_corrige2": "Sébastien Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseiller",
    "remuneration": "5208",
    "allocation": "3325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8533",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3311",
    "nom_corrige2": "René Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "5601",
    "allocation": "2800",
    "remuneration2": "72",
    "allocation2": "36",
    "total": "8509",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "3312",
    "nom_corrige2": "Steven Minty",
    "nom_famille": "Minty",
    "titre_genre2": "Conseiller",
    "remuneration": "6393",
    "allocation": "2109",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8502",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "3313",
    "nom_corrige2": "Pierre Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3314",
    "nom_corrige2": "Robert Beaudreault",
    "nom_famille": "Beaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3315",
    "nom_corrige2": "Robert Vallée",
    "nom_famille": "Vallée",
    "titre_genre2": "Conseiller",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3316",
    "nom_corrige2": "Sophie Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3317",
    "nom_corrige2": "Luc Bertrand",
    "nom_famille": "Bertrand",
    "titre_genre2": "Conseiller",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3318",
    "nom_corrige2": "Lise Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "5667",
    "allocation": "2833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8500",
    "ville": "Saint-Ours",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1780"
  },
  {
    "ID": "3319",
    "nom_corrige2": "Geneviève Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "579",
    "allocation2": "290",
    "total": "8497",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3320",
    "nom_corrige2": "Joël Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "5662",
    "allocation": "2831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8493",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3321",
    "nom_corrige2": "Sophie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "4981",
    "allocation": "2414",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "8481",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3322",
    "nom_corrige2": "ANDRÉ DÉSILETS",
    "nom_famille": "DÉSILETS",
    "titre_genre2": "Conseiller",
    "remuneration": "6511",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8467",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3323",
    "nom_corrige2": "Patrice Pinard",
    "nom_famille": "Pinard",
    "titre_genre2": "Conseiller",
    "remuneration": "5890",
    "allocation": "2570",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8460",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3324",
    "nom_corrige2": "Jocelyne Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "5159",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8459",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3325",
    "nom_corrige2": "Claude Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseiller",
    "remuneration": "5159",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8459",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3326",
    "nom_corrige2": "Yvon Sauvageau",
    "nom_famille": "Sauvageau",
    "titre_genre2": "Conseiller",
    "remuneration": "5159",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8459",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3327",
    "nom_corrige2": "Mireille LeBlanc",
    "nom_famille": "LeBlanc",
    "titre_genre2": "Conseillère",
    "remuneration": "5158",
    "allocation": "3300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8458",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3328",
    "nom_corrige2": "Serge Kirouac",
    "nom_famille": "Kirouac",
    "titre_genre2": "Conseiller",
    "remuneration": "5636",
    "allocation": "2818",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8454",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3329",
    "nom_corrige2": "Karl Hunting",
    "nom_famille": "Hunting",
    "titre_genre2": "Conseiller",
    "remuneration": "5634",
    "allocation": "2817",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8451",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3330",
    "nom_corrige2": "Benoît Huberdeau",
    "nom_famille": "Huberdeau",
    "titre_genre2": "Conseiller",
    "remuneration": "5634",
    "allocation": "2817",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8451",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "3331",
    "nom_corrige2": "Louis-Philippe Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseiller",
    "remuneration": "5632",
    "allocation": "2816",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8448",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "3332",
    "nom_corrige2": "Jean-Pierre Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "6060",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8446",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3333",
    "nom_corrige2": "Réal Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3334",
    "nom_corrige2": "Sonia Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3335",
    "nom_corrige2": "Pierluc Brousseau",
    "nom_famille": "Brousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3336",
    "nom_corrige2": "Amélie Sauvé",
    "nom_famille": "Sauvé",
    "titre_genre2": "Conseillère",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3337",
    "nom_corrige2": "Catherine Blouin",
    "nom_famille": "Blouin",
    "titre_genre2": "Conseillère",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3338",
    "nom_corrige2": "Martin Filion",
    "nom_famille": "Filion",
    "titre_genre2": "Conseiller",
    "remuneration": "5630",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8445",
    "ville": "Matagami",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1305"
  },
  {
    "ID": "3339",
    "nom_corrige2": "Sébastien Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "5629",
    "allocation": "2815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8444",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "3340",
    "nom_corrige2": "Réjean Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseiller",
    "remuneration": "5625",
    "allocation": "2813",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8438",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "3341",
    "nom_corrige2": "Pierre Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseiller",
    "remuneration": "5742",
    "allocation": "2696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8438",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3342",
    "nom_corrige2": "Sonya Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "5996",
    "allocation": "2423",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8419",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "3343",
    "nom_corrige2": "Jean-Edmond Caouette",
    "nom_famille": "Caouette",
    "titre_genre2": "Conseiller",
    "remuneration": "5610",
    "allocation": "2805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8415",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3344",
    "nom_corrige2": "Stéphanie Martin-Gauthier",
    "nom_famille": "Martin-Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "5609",
    "allocation": "2803",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8412",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "3345",
    "nom_corrige2": "Patrick Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Maire",
    "remuneration": "5604",
    "allocation": "2802",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8406",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "3346",
    "nom_corrige2": "Marjolaine Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseillère",
    "remuneration": "5601",
    "allocation": "2801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8402",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "3347",
    "nom_corrige2": "Karine Dalpé",
    "nom_famille": "Dalpé",
    "titre_genre2": "Conseillère",
    "remuneration": "5601",
    "allocation": "2800",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8401",
    "ville": "Saint-Hugues",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1370"
  },
  {
    "ID": "3348",
    "nom_corrige2": "CHRISTIAN TISLUCK",
    "nom_famille": "TISLUCK",
    "titre_genre2": "Conseiller",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "2000",
    "allocation2": "1334",
    "total": "8399",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "3349",
    "nom_corrige2": "Marylin Shallow",
    "nom_famille": "Shallow",
    "titre_genre2": "Conseillère",
    "remuneration": "5683",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8395",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "3350",
    "nom_corrige2": "DENIS CROTEAU",
    "nom_famille": "CROTEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "1296",
    "allocation2": "0",
    "total": "8388",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3351",
    "nom_corrige2": "Pierre Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3352",
    "nom_corrige2": "Gaétan Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3353",
    "nom_corrige2": "Pauline Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseillère",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3354",
    "nom_corrige2": "Evelyne Gallet",
    "nom_famille": "Gallet",
    "titre_genre2": "Conseillère",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3355",
    "nom_corrige2": "Chantal Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3356",
    "nom_corrige2": "Jonathan Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "5591",
    "allocation": "2795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8386",
    "ville": "Cap-Saint-Ignace",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3132"
  },
  {
    "ID": "3357",
    "nom_corrige2": "Sonya Pronovost",
    "nom_famille": "Pronovost",
    "titre_genre2": "Conseillère",
    "remuneration": "5110",
    "allocation": "3275",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8385",
    "ville": "Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2010"
  },
  {
    "ID": "3358",
    "nom_corrige2": "Gaétan Lafond",
    "nom_famille": "Lafond",
    "titre_genre2": "Conseiller",
    "remuneration": "5584",
    "allocation": "2792",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8376",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3359",
    "nom_corrige2": "Gordon Barnett",
    "nom_famille": "Barnett",
    "titre_genre2": "Conseiller",
    "remuneration": "5584",
    "allocation": "2792",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8376",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3360",
    "nom_corrige2": "Michel Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Conseiller",
    "remuneration": "5452",
    "allocation": "2914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8366",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "3361",
    "nom_corrige2": "Christian Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseiller",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3362",
    "nom_corrige2": "Diane Imonti",
    "nom_famille": "Imonti",
    "titre_genre2": "Conseillère",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3363",
    "nom_corrige2": "Mélanie Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3364",
    "nom_corrige2": "Anne-Marie Meyran",
    "nom_famille": "Meyran",
    "titre_genre2": "Conseillère",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3365",
    "nom_corrige2": "Annie Meilleur",
    "nom_famille": "Meilleur",
    "titre_genre2": "Conseillère",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3366",
    "nom_corrige2": "Michel Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseiller",
    "remuneration": "7959",
    "allocation": "393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8352",
    "ville": "Kiamika",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "822"
  },
  {
    "ID": "3367",
    "nom_corrige2": "Yvon Arnold",
    "nom_famille": "Arnold",
    "titre_genre2": "Conseiller",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3368",
    "nom_corrige2": "Julie Léveillée",
    "nom_famille": "Léveillée",
    "titre_genre2": "Conseillère",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3369",
    "nom_corrige2": "Dawn Charles",
    "nom_famille": "Charles",
    "titre_genre2": "Conseillère",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3370",
    "nom_corrige2": "Cassandre Lescarbeau",
    "nom_famille": "Lescarbeau",
    "titre_genre2": "Conseillère",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3371",
    "nom_corrige2": "Diane Bélair",
    "nom_famille": "Bélair",
    "titre_genre2": "Conseillère",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3372",
    "nom_corrige2": "Francis Léger",
    "nom_famille": "Léger",
    "titre_genre2": "Conseiller",
    "remuneration": "5564",
    "allocation": "2781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8345",
    "ville": "Mille-Isles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1787"
  },
  {
    "ID": "3373",
    "nom_corrige2": "Simon Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "5556",
    "allocation": "2778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8334",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3374",
    "nom_corrige2": "Christopher Sherrington",
    "nom_famille": "Sherrington",
    "titre_genre2": "Conseiller",
    "remuneration": "5555",
    "allocation": "2778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8333",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3375",
    "nom_corrige2": "Vivianne Bleau",
    "nom_famille": "Bleau",
    "titre_genre2": "Conseillère",
    "remuneration": "5555",
    "allocation": "2778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8333",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3376",
    "nom_corrige2": "Pierre Piché",
    "nom_famille": "Piché",
    "titre_genre2": "Conseiller",
    "remuneration": "5553",
    "allocation": "2776",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8329",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3377",
    "nom_corrige2": "Denise Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "5550",
    "allocation": "2774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "3378",
    "nom_corrige2": "Gaétan Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseiller",
    "remuneration": "5550",
    "allocation": "2774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "3379",
    "nom_corrige2": "Jérôme Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5550",
    "allocation": "2774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "3380",
    "nom_corrige2": "Alain Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseiller",
    "remuneration": "5550",
    "allocation": "2774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "3381",
    "nom_corrige2": "Marielle Farley",
    "nom_famille": "Farley",
    "titre_genre2": "Conseillère",
    "remuneration": "5549",
    "allocation": "2775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "3382",
    "nom_corrige2": "Éric Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "5549",
    "allocation": "2775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "3383",
    "nom_corrige2": "Isabelle Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseillère",
    "remuneration": "5549",
    "allocation": "2775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "3384",
    "nom_corrige2": "Jean-Françcois Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseiller",
    "remuneration": "5550",
    "allocation": "2774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8324",
    "ville": "Saint-Anselme",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4308"
  },
  {
    "ID": "3385",
    "nom_corrige2": "Jacinthe Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "8170",
    "allocation": "83",
    "remuneration2": "71",
    "allocation2": "0",
    "total": "8324",
    "ville": "Sainte-Christine-d'Auvergne",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "670"
  },
  {
    "ID": "3386",
    "nom_corrige2": "Danielle Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseillère",
    "remuneration": "8322",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8322",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "3387",
    "nom_corrige2": "Maryse Gougeon",
    "nom_famille": "Gougeon",
    "titre_genre2": "Conseillère",
    "remuneration": "8322",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8322",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "3388",
    "nom_corrige2": "Alexandre Lafleur",
    "nom_famille": "Lafleur",
    "titre_genre2": "Conseiller",
    "remuneration": "8322",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8322",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "3389",
    "nom_corrige2": "Yves Laurendeau",
    "nom_famille": "Laurendeau",
    "titre_genre2": "Conseiller",
    "remuneration": "8322",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8322",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "3390",
    "nom_corrige2": "Sylvie Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère",
    "remuneration": "8322",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8322",
    "ville": "Chénéville",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "871"
  },
  {
    "ID": "3391",
    "nom_corrige2": "ANNIE BOIVIN",
    "nom_famille": "BOIVIN",
    "titre_genre2": "Conseillère",
    "remuneration": "6361",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8317",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3392",
    "nom_corrige2": "Léon Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Maire",
    "remuneration": "3521",
    "allocation": "1761",
    "remuneration2": "2023",
    "allocation2": "1011",
    "total": "8316",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "3393",
    "nom_corrige2": "Mario Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseiller",
    "remuneration": "5539",
    "allocation": "2769",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8308",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3394",
    "nom_corrige2": "René Bessette",
    "nom_famille": "Bessette",
    "titre_genre2": "Conseiller",
    "remuneration": "5534",
    "allocation": "2767",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8301",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3395",
    "nom_corrige2": "Ginette Caza",
    "nom_famille": "Caza",
    "titre_genre2": "Conseillère",
    "remuneration": "5520",
    "allocation": "2760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8280",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "3396",
    "nom_corrige2": "Lyne Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Conseillère",
    "remuneration": "5520",
    "allocation": "2760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8280",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "3397",
    "nom_corrige2": "Anne-Marie Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "5520",
    "allocation": "2760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8280",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "3398",
    "nom_corrige2": "Audrey Caza",
    "nom_famille": "Caza",
    "titre_genre2": "Conseillère",
    "remuneration": "5520",
    "allocation": "2760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8280",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "3399",
    "nom_corrige2": "Karl Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Conseiller",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3400",
    "nom_corrige2": "Claude Paulin",
    "nom_famille": "Paulin",
    "titre_genre2": "Conseiller",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3401",
    "nom_corrige2": "Cheryl Labrie",
    "nom_famille": "Labrie",
    "titre_genre2": "Conseillère",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3402",
    "nom_corrige2": "Alexandre Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3403",
    "nom_corrige2": "Michel Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Conseiller",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3404",
    "nom_corrige2": "René Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseiller",
    "remuneration": "5518",
    "allocation": "2759",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8277",
    "ville": "Saint-François-Xavier-de-Brompton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2497"
  },
  {
    "ID": "3405",
    "nom_corrige2": "André Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Conseiller",
    "remuneration": "5516",
    "allocation": "2758",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8274",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3406",
    "nom_corrige2": "Alain Dumouchel",
    "nom_famille": "Dumouchel",
    "titre_genre2": "Conseiller",
    "remuneration": "5513",
    "allocation": "2757",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8270",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "3407",
    "nom_corrige2": "Sébastien Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "5513",
    "allocation": "2757",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8270",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "3408",
    "nom_corrige2": "Pierrette Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseillère",
    "remuneration": "5513",
    "allocation": "2757",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8270",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "3409",
    "nom_corrige2": "Jessica Maheu",
    "nom_famille": "Maheu",
    "titre_genre2": "Conseillère",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "3410",
    "nom_corrige2": "René Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "3411",
    "nom_corrige2": "Josyanne Plourde-Dolbec",
    "nom_famille": "Plourde-Dolbec",
    "titre_genre2": "Conseillère",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3412",
    "nom_corrige2": "Francis Vigneault",
    "nom_famille": "Vigneault",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3413",
    "nom_corrige2": "Gérald Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3414",
    "nom_corrige2": "Stéphanie Lafrenière-Milot",
    "nom_famille": "Lafrenière-Milot",
    "titre_genre2": "Conseillère",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Saint-Charles-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3415",
    "nom_corrige2": "Adolf Hilgendorff",
    "nom_famille": "Hilgendorff",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "3416",
    "nom_corrige2": "Clément Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseiller",
    "remuneration": "5507",
    "allocation": "2754",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8261",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "3417",
    "nom_corrige2": "Stéphane Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseiller",
    "remuneration": "5503",
    "allocation": "2752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8255",
    "ville": "L'Islet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3931"
  },
  {
    "ID": "3418",
    "nom_corrige2": "Claude Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "5567",
    "allocation": "2683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8250",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "3419",
    "nom_corrige2": "Huguette Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "5567",
    "allocation": "2683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8250",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "3420",
    "nom_corrige2": "Yves Boulianne",
    "nom_famille": "Boulianne",
    "titre_genre2": "Conseiller",
    "remuneration": "5567",
    "allocation": "2683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8250",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "3421",
    "nom_corrige2": "Yves Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "7845",
    "allocation": "385",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8230",
    "ville": "L'Ascension",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "906"
  },
  {
    "ID": "3422",
    "nom_corrige2": "LOUISE LUSSIER",
    "nom_famille": "LUSSIER",
    "titre_genre2": "Conseillère",
    "remuneration": "6267",
    "allocation": "1960",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8227",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "3423",
    "nom_corrige2": "Véronique Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "5484",
    "allocation": "2742",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8226",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3424",
    "nom_corrige2": "Jean-Paul Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Maire",
    "remuneration": "5477",
    "allocation": "2742",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8219",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "3425",
    "nom_corrige2": "Marco Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5447",
    "allocation": "2739",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8186",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3426",
    "nom_corrige2": "Charles Chateauvert",
    "nom_famille": "Chateauvert",
    "titre_genre2": "Conseiller",
    "remuneration": "5436",
    "allocation": "2738",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8174",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3427",
    "nom_corrige2": "MARIO PARENT",
    "nom_famille": "PARENT",
    "titre_genre2": "Conseiller",
    "remuneration": "6211",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8167",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3428",
    "nom_corrige2": "Gérald Grenon",
    "nom_famille": "Grenon",
    "titre_genre2": "Conseiller",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "914",
    "allocation2": "0",
    "total": "8162",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3429",
    "nom_corrige2": "Denis Lemoyne",
    "nom_famille": "Lemoyne",
    "titre_genre2": "Conseiller",
    "remuneration": "5440",
    "allocation": "2720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8160",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "3430",
    "nom_corrige2": "Violaine Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "5440",
    "allocation": "2720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8160",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "3431",
    "nom_corrige2": "Marc Blain",
    "nom_famille": "Blain",
    "titre_genre2": "Conseiller",
    "remuneration": "5440",
    "allocation": "2720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8160",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "3432",
    "nom_corrige2": "Charles Goyer",
    "nom_famille": "Goyer",
    "titre_genre2": "Conseiller",
    "remuneration": "5440",
    "allocation": "2720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8160",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "3433",
    "nom_corrige2": "Pierre-Yves Baril",
    "nom_famille": "Baril",
    "titre_genre2": "Conseiller",
    "remuneration": "5440",
    "allocation": "2720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8160",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "3434",
    "nom_corrige2": "Yves Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "5492",
    "allocation": "2664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8156",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3435",
    "nom_corrige2": "Guylaine Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "5703",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8155",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3436",
    "nom_corrige2": "Joanne Mayer",
    "nom_famille": "Mayer",
    "titre_genre2": "Conseillère",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3437",
    "nom_corrige2": "Luc Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseiller",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3438",
    "nom_corrige2": "Lee Angus",
    "nom_famille": "Angus",
    "titre_genre2": "Conseiller",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3439",
    "nom_corrige2": "Maureen Mcevoy",
    "nom_famille": "Mcevoy",
    "titre_genre2": "Conseillère",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3440",
    "nom_corrige2": "Maureen Rice",
    "nom_famille": "Rice",
    "titre_genre2": "Conseillère",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3441",
    "nom_corrige2": "Ghyslain Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseiller",
    "remuneration": "5432",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8148",
    "ville": "Low",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1056"
  },
  {
    "ID": "3442",
    "nom_corrige2": "Ginette Camiré",
    "nom_famille": "Camiré",
    "titre_genre2": "Conseillère",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3443",
    "nom_corrige2": "Sonia Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3444",
    "nom_corrige2": "Gilbert Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3445",
    "nom_corrige2": "Étienne Lemelin",
    "nom_famille": "Lemelin",
    "titre_genre2": "Conseiller",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3446",
    "nom_corrige2": "Anne-Marie Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3447",
    "nom_corrige2": "François-Xavier Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "5424",
    "allocation": "2712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8136",
    "ville": "Saint-Bernard",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2700"
  },
  {
    "ID": "3448",
    "nom_corrige2": "Normand Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "5423",
    "allocation": "2711",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8134",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "3449",
    "nom_corrige2": "Deborah Beattie",
    "nom_famille": "Beattie",
    "titre_genre2": "Conseillère",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3450",
    "nom_corrige2": "Jean-Marc Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseiller",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3451",
    "nom_corrige2": "Julie Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseillère",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3452",
    "nom_corrige2": "Maxime Arcand",
    "nom_famille": "Arcand",
    "titre_genre2": "Conseiller",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3453",
    "nom_corrige2": "Julia Ann Wilkins",
    "nom_famille": "Wilkins",
    "titre_genre2": "Conseillère",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3454",
    "nom_corrige2": "David Lisbona",
    "nom_famille": "Lisbona",
    "titre_genre2": "Conseiller",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3455",
    "nom_corrige2": "Julia Bourke",
    "nom_famille": "Bourke",
    "titre_genre2": "Conseillère",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3456",
    "nom_corrige2": "Gabriela Opas",
    "nom_famille": "Opas",
    "titre_genre2": "Conseillère",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3457",
    "nom_corrige2": "Jean-Pierre Charette",
    "nom_famille": "Charette",
    "titre_genre2": "Conseiller",
    "remuneration": "5408",
    "allocation": "2704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8112",
    "ville": "Ivry-sur-le-Lac",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "366"
  },
  {
    "ID": "3458",
    "nom_corrige2": "Marielle Gervais",
    "nom_famille": "Gervais",
    "titre_genre2": "Conseillère",
    "remuneration": "5392",
    "allocation": "2696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8088",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3459",
    "nom_corrige2": "Steve Robitaille",
    "nom_famille": "Robitaille",
    "titre_genre2": "Conseiller",
    "remuneration": "5392",
    "allocation": "2696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8088",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3460",
    "nom_corrige2": "Mélanie Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseillère",
    "remuneration": "5392",
    "allocation": "2696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8088",
    "ville": "Venise-en-Québec",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2142"
  },
  {
    "ID": "3461",
    "nom_corrige2": "Chad Whittaker",
    "nom_famille": "Whittaker",
    "titre_genre2": "Conseiller",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "823",
    "allocation2": "0",
    "total": "8071",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3462",
    "nom_corrige2": "Jean Gascon",
    "nom_famille": "Gascon",
    "titre_genre2": "Conseiller",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3463",
    "nom_corrige2": "France Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseillère",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3464",
    "nom_corrige2": "Saweay Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3465",
    "nom_corrige2": "Luc Robitaille",
    "nom_famille": "Robitaille",
    "titre_genre2": "Conseiller",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3466",
    "nom_corrige2": "Jean Murray",
    "nom_famille": "Murray",
    "titre_genre2": "Conseiller",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3467",
    "nom_corrige2": "Alain Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "5380",
    "allocation": "2690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8070",
    "ville": "Lac-Saint-Paul",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "543"
  },
  {
    "ID": "3468",
    "nom_corrige2": "SERGE TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseiller",
    "remuneration": "6111",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8067",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3469",
    "nom_corrige2": "Claude Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3470",
    "nom_corrige2": "Pierre-Luc Payette",
    "nom_famille": "Payette",
    "titre_genre2": "Conseiller",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3471",
    "nom_corrige2": "Jean Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Conseiller",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3472",
    "nom_corrige2": "Serge Rivest",
    "nom_famille": "Rivest",
    "titre_genre2": "Conseiller",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3473",
    "nom_corrige2": "Sophie Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Conseillère",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3474",
    "nom_corrige2": "Sylvain Loyer",
    "nom_famille": "Loyer",
    "titre_genre2": "Conseiller",
    "remuneration": "5372",
    "allocation": "2686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8058",
    "ville": "Saint-Liguori",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2158"
  },
  {
    "ID": "3475",
    "nom_corrige2": "Josée Busque",
    "nom_famille": "Busque",
    "titre_genre2": "Conseiller",
    "remuneration": "5270",
    "allocation": "2787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8057",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "3476",
    "nom_corrige2": "RICHARD POULIN",
    "nom_famille": "POULIN",
    "titre_genre2": "Conseiller",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3477",
    "nom_corrige2": "GHISLAIN LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3478",
    "nom_corrige2": "NORMAND DUCLOS",
    "nom_famille": "DUCLOS",
    "titre_genre2": "Conseiller",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3479",
    "nom_corrige2": "ÉRIC LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3480",
    "nom_corrige2": "MARIE-NOËL DUCLOS",
    "nom_famille": "DUCLOS",
    "titre_genre2": "Conseillère",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3481",
    "nom_corrige2": "REYNALD CORMIER",
    "nom_famille": "CORMIER",
    "titre_genre2": "Conseiller",
    "remuneration": "5370",
    "allocation": "2685",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8055",
    "ville": "Saint-Tite-des-Caps",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1488"
  },
  {
    "ID": "3482",
    "nom_corrige2": "Line Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3483",
    "nom_corrige2": "Laurence Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "5367",
    "allocation": "2683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "3484",
    "nom_corrige2": "Marie-Josée Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseillère",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3485",
    "nom_corrige2": "Noël Lanthier",
    "nom_famille": "Lanthier",
    "titre_genre2": "Conseiller",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3486",
    "nom_corrige2": "Nathalie Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Conseillère",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3487",
    "nom_corrige2": "Jessica Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3488",
    "nom_corrige2": "Steve Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "4025",
    "allocation": "4025",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8050",
    "ville": "Lantier",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "970"
  },
  {
    "ID": "3489",
    "nom_corrige2": "Lyne Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseillère",
    "remuneration": "5660",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8046",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3490",
    "nom_corrige2": "Jean-François Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "652",
    "allocation2": "326",
    "total": "8039",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3491",
    "nom_corrige2": "Lyssa Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseillère",
    "remuneration": "2327",
    "allocation": "1164",
    "remuneration2": "4541",
    "allocation2": "0",
    "total": "8032",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "3492",
    "nom_corrige2": "Julie Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "5384",
    "allocation": "2646",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8030",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3493",
    "nom_corrige2": "KARINE COALLIER",
    "nom_famille": "COALLIER",
    "titre_genre2": "Conseillère",
    "remuneration": "6167",
    "allocation": "1860",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8027",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "3494",
    "nom_corrige2": "DENIS ENGLISH",
    "nom_famille": "ENGLISH",
    "titre_genre2": "Conseiller",
    "remuneration": "6167",
    "allocation": "1860",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8027",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "3495",
    "nom_corrige2": "ANTHONY MANGIONE",
    "nom_famille": "MANGIONE",
    "titre_genre2": "Conseiller",
    "remuneration": "6167",
    "allocation": "1860",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8027",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "3496",
    "nom_corrige2": "Mireille Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseillère",
    "remuneration": "5348",
    "allocation": "2674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8022",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3497",
    "nom_corrige2": "Suzanne Béland",
    "nom_famille": "Béland",
    "titre_genre2": "Conseillère",
    "remuneration": "5348",
    "allocation": "2674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8022",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3498",
    "nom_corrige2": "Janny Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "5339",
    "allocation": "2669",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8008",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "3499",
    "nom_corrige2": "MÉLODIE BOISSY",
    "nom_famille": "BOISSY",
    "titre_genre2": "Conseillère",
    "remuneration": "6137",
    "allocation": "1860",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7997",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "3500",
    "nom_corrige2": "Monique Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "5328",
    "allocation": "2664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7992",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3501",
    "nom_corrige2": "Pierre Châteauneuf",
    "nom_famille": "Châteauneuf",
    "titre_genre2": "Conseiller",
    "remuneration": "5328",
    "allocation": "2664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7992",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3502",
    "nom_corrige2": "Sylvain Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseiller",
    "remuneration": "5328",
    "allocation": "2664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7992",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3503",
    "nom_corrige2": "Henriette Rivard Desbiens",
    "nom_famille": "Rivard",
    "titre_genre2": "Conseillère",
    "remuneration": "5328",
    "allocation": "2664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7992",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3504",
    "nom_corrige2": "Elizabeth Fee",
    "nom_famille": "Fee",
    "titre_genre2": "Conseillère",
    "remuneration": "5303",
    "allocation": "2667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7970",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "3505",
    "nom_corrige2": "Xavier Bouhy",
    "nom_famille": "Bouhy",
    "titre_genre2": "Conseiller",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3506",
    "nom_corrige2": "Nancy Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseillère",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3507",
    "nom_corrige2": "Francis Fecteau",
    "nom_famille": "Fecteau",
    "titre_genre2": "Conseiller",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3508",
    "nom_corrige2": "Patricia Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3509",
    "nom_corrige2": "Richard Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseiller",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3510",
    "nom_corrige2": "Dany Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "5310",
    "allocation": "2655",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7965",
    "ville": "Saint-Victor",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2371"
  },
  {
    "ID": "3511",
    "nom_corrige2": "Dial Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3512",
    "nom_corrige2": "Pierre Sarrazin",
    "nom_famille": "Sarrazin",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3513",
    "nom_corrige2": "Serge-Paul Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3514",
    "nom_corrige2": "Danny Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3515",
    "nom_corrige2": "Stéphane-Alexandre Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3516",
    "nom_corrige2": "Richard Bourdages",
    "nom_famille": "Bourdages",
    "titre_genre2": "Conseiller",
    "remuneration": "5304",
    "allocation": "2652",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7956",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1215"
  },
  {
    "ID": "3517",
    "nom_corrige2": "Guy Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "5005",
    "allocation": "2412",
    "remuneration2": "359",
    "allocation2": "179",
    "total": "7955",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "3518",
    "nom_corrige2": "Luc Darsigny",
    "nom_famille": "Darsigny",
    "titre_genre2": "Conseiller",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "217",
    "allocation2": "109",
    "total": "7954",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3519",
    "nom_corrige2": "Alex Bronsard",
    "nom_famille": "Bronsard",
    "titre_genre2": "Conseiller",
    "remuneration": "5299",
    "allocation": "2649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7948",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3520",
    "nom_corrige2": "Daniel Beaupré",
    "nom_famille": "Beaupré",
    "titre_genre2": "Conseiller",
    "remuneration": "5299",
    "allocation": "2649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7948",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3521",
    "nom_corrige2": "Dominique Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "5299",
    "allocation": "2649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7948",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3522",
    "nom_corrige2": "Mario Blanchard",
    "nom_famille": "Blanchard",
    "titre_genre2": "Conseiller",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3523",
    "nom_corrige2": "Mario Larochelle",
    "nom_famille": "Larochelle",
    "titre_genre2": "Conseiller",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3524",
    "nom_corrige2": "Jocelyn Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseiller",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3525",
    "nom_corrige2": "Pierre Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3526",
    "nom_corrige2": "Chantal Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseillère",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3527",
    "nom_corrige2": "Christian Riendeau",
    "nom_famille": "Riendeau",
    "titre_genre2": "Conseiller",
    "remuneration": "5287",
    "allocation": "2644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7931",
    "ville": "Saint-Paul-d'Abbotsford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2962"
  },
  {
    "ID": "3528",
    "nom_corrige2": "Claire Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "3307",
    "allocation": "1654",
    "remuneration2": "1980",
    "allocation2": "990",
    "total": "7931",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "3529",
    "nom_corrige2": "JULY BOISVERT",
    "nom_famille": "BOISVERT",
    "titre_genre2": "Conseillère",
    "remuneration": "5961",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7917",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3530",
    "nom_corrige2": "MARC DESROCHERS",
    "nom_famille": "DESROCHERS",
    "titre_genre2": "Conseiller",
    "remuneration": "5961",
    "allocation": "1956",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7917",
    "ville": "Mandeville",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2400"
  },
  {
    "ID": "3531",
    "nom_corrige2": "Richard Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "5350",
    "allocation": "2555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7905",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3532",
    "nom_corrige2": "Marion Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseillère",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3533",
    "nom_corrige2": "André Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseiller",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3534",
    "nom_corrige2": "Marc-André Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3535",
    "nom_corrige2": "Andréanne Lapointe Deblois",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3536",
    "nom_corrige2": "Olivier Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3537",
    "nom_corrige2": "Bruno Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "5267",
    "allocation": "2633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7900",
    "ville": "Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1780"
  },
  {
    "ID": "3538",
    "nom_corrige2": "Annie Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "5182",
    "allocation": "2716",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7898",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "3539",
    "nom_corrige2": "Rachel Alarie",
    "nom_famille": "Alarie",
    "titre_genre2": "Mairesse",
    "remuneration": "5261",
    "allocation": "2630",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7891",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "3540",
    "nom_corrige2": "Michel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "5255",
    "allocation": "2628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7883",
    "ville": "Tring-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1467"
  },
  {
    "ID": "3541",
    "nom_corrige2": "JASON GOURDE",
    "nom_famille": "GOURDE",
    "titre_genre2": "Conseiller",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3542",
    "nom_corrige2": "MARIO PICARD",
    "nom_famille": "PICARD",
    "titre_genre2": "Conseiller",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3543",
    "nom_corrige2": "MATTHEW POULIN",
    "nom_famille": "POULIN",
    "titre_genre2": "Conseiller",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3544",
    "nom_corrige2": "MIREILLE CAUX",
    "nom_famille": "CAUX",
    "titre_genre2": "Conseillère",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3545",
    "nom_corrige2": "ROGER SAMSON",
    "nom_famille": "SAMSON",
    "titre_genre2": "Conseiller",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3546",
    "nom_corrige2": "YVES JOLY",
    "nom_famille": "JOLY",
    "titre_genre2": "Conseiller",
    "remuneration": "5254",
    "allocation": "2627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7881",
    "ville": "Saint-Narcisse-de-Beaurivage",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1167"
  },
  {
    "ID": "3547",
    "nom_corrige2": "Yvan Hamelin",
    "nom_famille": "Hamelin",
    "titre_genre2": "Conseiller",
    "remuneration": "5249",
    "allocation": "2624",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7873",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3548",
    "nom_corrige2": "Pierre Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "5242",
    "allocation": "2621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7863",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3549",
    "nom_corrige2": "Elaine Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseillère",
    "remuneration": "5242",
    "allocation": "2621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7863",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3550",
    "nom_corrige2": "Alain Déry",
    "nom_famille": "Déry",
    "titre_genre2": "Conseiller",
    "remuneration": "5242",
    "allocation": "2621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7863",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3551",
    "nom_corrige2": "Philippe-David Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseiller",
    "remuneration": "5234",
    "allocation": "2617",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7851",
    "ville": "Waterville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2338"
  },
  {
    "ID": "3552",
    "nom_corrige2": "Marie Gervais",
    "nom_famille": "Gervais",
    "titre_genre2": "Conseillère",
    "remuneration": "4634",
    "allocation": "2319",
    "remuneration2": "595",
    "allocation2": "298",
    "total": "7846",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "3553",
    "nom_corrige2": "Valérie Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "5298",
    "allocation": "2529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7827",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "3554",
    "nom_corrige2": "Gaétan Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseiller",
    "remuneration": "5298",
    "allocation": "2529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7827",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "3555",
    "nom_corrige2": "Jérôme Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseiller",
    "remuneration": "5298",
    "allocation": "2529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7827",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "3556",
    "nom_corrige2": "Simon Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "5212",
    "allocation": "2606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7818",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "3557",
    "nom_corrige2": "Steven Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "5212",
    "allocation": "2606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7818",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "3558",
    "nom_corrige2": "Jean-Denis Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "5212",
    "allocation": "2606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7818",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "3559",
    "nom_corrige2": "Alain Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Conseiller",
    "remuneration": "5212",
    "allocation": "2606",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7818",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "3560",
    "nom_corrige2": "Claire Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseillère",
    "remuneration": "5204",
    "allocation": "2602",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7806",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "3561",
    "nom_corrige2": "Claude Groleau",
    "nom_famille": "Groleau",
    "titre_genre2": "Conseiller",
    "remuneration": "5204",
    "allocation": "2602",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7806",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "3562",
    "nom_corrige2": "Mario Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseiller",
    "remuneration": "5204",
    "allocation": "2602",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7806",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "3563",
    "nom_corrige2": "Élodie Brochu",
    "nom_famille": "Brochu",
    "titre_genre2": "Conseillère",
    "remuneration": "5204",
    "allocation": "2602",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7806",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "3564",
    "nom_corrige2": "Mario Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "5204",
    "allocation": "2602",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7806",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "3565",
    "nom_corrige2": "Marco Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseiller",
    "remuneration": "5203",
    "allocation": "2601",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7804",
    "ville": "Bolton-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1133"
  },
  {
    "ID": "3566",
    "nom_corrige2": "Nicolas Hamelin",
    "nom_famille": "Hamelin",
    "titre_genre2": "Conseiller",
    "remuneration": "5198",
    "allocation": "2599",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7797",
    "ville": "Lac-aux-Sables",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1346"
  },
  {
    "ID": "3567",
    "nom_corrige2": "René Proteau",
    "nom_famille": "Proteau",
    "titre_genre2": "Conseiller",
    "remuneration": "5195",
    "allocation": "2597",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7792",
    "ville": "Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "987"
  },
  {
    "ID": "3568",
    "nom_corrige2": "Marlène Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseillère",
    "remuneration": "5260",
    "allocation": "2525",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7785",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3569",
    "nom_corrige2": "Richard Sylvain",
    "nom_famille": "Sylvain",
    "titre_genre2": "Conseiller",
    "remuneration": "5190",
    "allocation": "2595",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7785",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3570",
    "nom_corrige2": "Pascal Rheault",
    "nom_famille": "Rheault",
    "titre_genre2": "Maire",
    "remuneration": "5743",
    "allocation": "2040",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7783",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "3571",
    "nom_corrige2": "Hélène Dufault",
    "nom_famille": "Dufault",
    "titre_genre2": "Conseillère",
    "remuneration": "5172",
    "allocation": "2586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7758",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3572",
    "nom_corrige2": "Pierre Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "5172",
    "allocation": "2586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7758",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3573",
    "nom_corrige2": "Michel Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "5172",
    "allocation": "2586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7758",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3574",
    "nom_corrige2": "Daniel Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "5172",
    "allocation": "2586",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7758",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3575",
    "nom_corrige2": "Sébastien Petitclerc",
    "nom_famille": "Petitclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3576",
    "nom_corrige2": "Jean-Paul Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3577",
    "nom_corrige2": "Isabelle Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3578",
    "nom_corrige2": "Casandra Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3579",
    "nom_corrige2": "David Gervais",
    "nom_famille": "Gervais",
    "titre_genre2": "Conseiller",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3580",
    "nom_corrige2": "Amélie Massé",
    "nom_famille": "Massé",
    "titre_genre2": "Conseillère",
    "remuneration": "5165",
    "allocation": "2582",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7747",
    "ville": "Preissac",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "972"
  },
  {
    "ID": "3581",
    "nom_corrige2": "Alain Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseiller",
    "remuneration": "5146",
    "allocation": "2573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7719",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "3582",
    "nom_corrige2": "Jean Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "4233",
    "allocation": "2117",
    "remuneration2": "909",
    "allocation2": "454",
    "total": "7713",
    "ville": "Lac-Sergent",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "549"
  },
  {
    "ID": "3583",
    "nom_corrige2": "André Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "5466",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7699",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "3584",
    "nom_corrige2": "Yves-André Beaulé",
    "nom_famille": "Beaulé",
    "titre_genre2": "Conseiller",
    "remuneration": "5132",
    "allocation": "2566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7698",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "3585",
    "nom_corrige2": "Johanne Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseillère",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3586",
    "nom_corrige2": "Jacques Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseiller",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3587",
    "nom_corrige2": "Yvan Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3588",
    "nom_corrige2": "Sylvie Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3589",
    "nom_corrige2": "Harold Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3590",
    "nom_corrige2": "Francis Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "7350",
    "allocation": "346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7696",
    "ville": "Saint-Frédéric",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1115"
  },
  {
    "ID": "3591",
    "nom_corrige2": "Doris Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Mairesse",
    "remuneration": "5127",
    "allocation": "2566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7693",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "3592",
    "nom_corrige2": "David Wilson",
    "nom_famille": "Wilson",
    "titre_genre2": "Conseiller",
    "remuneration": "4990",
    "allocation": "2674",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7664",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "3593",
    "nom_corrige2": "Nancy Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseillère",
    "remuneration": "5203",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7655",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3594",
    "nom_corrige2": "Brigitte Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "5260",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7646",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3595",
    "nom_corrige2": "Ginette Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "5260",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7646",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3596",
    "nom_corrige2": "Anthony Hallé",
    "nom_famille": "Hallé",
    "titre_genre2": "Conseiller",
    "remuneration": "5260",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7646",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3597",
    "nom_corrige2": "Stanley Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "5260",
    "allocation": "2386",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7646",
    "ville": "Saint-Jean-Port-Joli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3425"
  },
  {
    "ID": "3598",
    "nom_corrige2": "Thierry Dansereau",
    "nom_famille": "Dansereau",
    "titre_genre2": "Conseiller",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3599",
    "nom_corrige2": "Monique Malo",
    "nom_famille": "Malo",
    "titre_genre2": "Conseillère",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3600",
    "nom_corrige2": "Nil Béland",
    "nom_famille": "Béland",
    "titre_genre2": "Conseiller",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3601",
    "nom_corrige2": "Daphné Rodgers",
    "nom_famille": "Rodgers",
    "titre_genre2": "Conseillère",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3602",
    "nom_corrige2": "Miguel Dicaire",
    "nom_famille": "Dicaire",
    "titre_genre2": "Conseiller",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3603",
    "nom_corrige2": "Ann-Marielle Tinkler",
    "nom_famille": "Tinkler",
    "titre_genre2": "Conseillère",
    "remuneration": "5094",
    "allocation": "2547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7641",
    "ville": "Plaisance",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1221"
  },
  {
    "ID": "3604",
    "nom_corrige2": "Pierre Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7628",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3605",
    "nom_corrige2": "Sylvie Guévin",
    "nom_famille": "Guévin",
    "titre_genre2": "Conseillère",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7628",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3606",
    "nom_corrige2": "Pascale Pinette",
    "nom_famille": "Pinette",
    "titre_genre2": "Conseillère",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7628",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3607",
    "nom_corrige2": "Rock Provençal",
    "nom_famille": "Provençal",
    "titre_genre2": "Conseiller",
    "remuneration": "5085",
    "allocation": "2543",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7628",
    "ville": "Saint-Pie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "5918"
  },
  {
    "ID": "3608",
    "nom_corrige2": "Angèle Forest",
    "nom_famille": "Forest",
    "titre_genre2": "Conseillère",
    "remuneration": "5081",
    "allocation": "2541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7622",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "3609",
    "nom_corrige2": "Annie Préfontaine",
    "nom_famille": "Préfontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "5396",
    "allocation": "2223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7619",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "3610",
    "nom_corrige2": "GEORGES GUÉNARD",
    "nom_famille": "GUÉNARD",
    "titre_genre2": "Maire",
    "remuneration": "5079",
    "allocation": "2540",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7619",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "3611",
    "nom_corrige2": "Cindy Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3612",
    "nom_corrige2": "Marie-Christine Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseillère",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3613",
    "nom_corrige2": "Marc Lord",
    "nom_famille": "Lord",
    "titre_genre2": "Conseiller",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3614",
    "nom_corrige2": "Sylvain Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseiller",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3615",
    "nom_corrige2": "Tara-Lynn Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Conseillère",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3616",
    "nom_corrige2": "Mathieu Ferguson Dufour",
    "nom_famille": "Ferguson",
    "titre_genre2": "Conseiller",
    "remuneration": "5075",
    "allocation": "2537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7612",
    "ville": "Pointe-à-la-Croix",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "1342"
  },
  {
    "ID": "3617",
    "nom_corrige2": "Georges Halasz",
    "nom_famille": "Halasz",
    "titre_genre2": "Conseiller",
    "remuneration": "5072",
    "allocation": "2536",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7608",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "3618",
    "nom_corrige2": "Benoit Chevalier",
    "nom_famille": "Chevalier",
    "titre_genre2": "Maire",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "3619",
    "nom_corrige2": "Guy Bournival",
    "nom_famille": "Bournival",
    "titre_genre2": "Conseiller",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "3620",
    "nom_corrige2": "Manon Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "3621",
    "nom_corrige2": "Marcel Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "3622",
    "nom_corrige2": "Gérard Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "3623",
    "nom_corrige2": "Pierre Généreux",
    "nom_famille": "Généreux",
    "titre_genre2": "Conseiller",
    "remuneration": "5070",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7605",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "3624",
    "nom_corrige2": "André Courtemanche",
    "nom_famille": "Courtemanche",
    "titre_genre2": "Conseiller",
    "remuneration": "4668",
    "allocation": "2034",
    "remuneration2": "600",
    "allocation2": "300",
    "total": "7602",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "3625",
    "nom_corrige2": "Robert Chevrier",
    "nom_famille": "Chevrier",
    "titre_genre2": "Conseiller",
    "remuneration": "5039",
    "allocation": "2520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7559",
    "ville": "Sainte-Hélène-de-Bagot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1666"
  },
  {
    "ID": "3626",
    "nom_corrige2": "Marylou Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "5103",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7555",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3627",
    "nom_corrige2": "Huguette Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseillère",
    "remuneration": "5134",
    "allocation": "2414",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7548",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3628",
    "nom_corrige2": "Michael Allen",
    "nom_famille": "Allen",
    "titre_genre2": "Conseiller",
    "remuneration": "5022",
    "allocation": "2511",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7533",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3629",
    "nom_corrige2": "Hélène Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseillère",
    "remuneration": "5022",
    "allocation": "2511",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7533",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3630",
    "nom_corrige2": "Gregg Edwards",
    "nom_famille": "Edwards",
    "titre_genre2": "Conseiller",
    "remuneration": "5022",
    "allocation": "2511",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7533",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3631",
    "nom_corrige2": "Alain Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Maire",
    "remuneration": "5021",
    "allocation": "2511",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7532",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "3632",
    "nom_corrige2": "Jérôme Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3633",
    "nom_corrige2": "Francis Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3634",
    "nom_corrige2": "Donald Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3635",
    "nom_corrige2": "Marc-Antoine Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3636",
    "nom_corrige2": "Étienne Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3637",
    "nom_corrige2": "Marie-Andrée Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseillère",
    "remuneration": "5008",
    "allocation": "2505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Saint-Prosper",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3676"
  },
  {
    "ID": "3638",
    "nom_corrige2": "Lyne Ash",
    "nom_famille": "Ash",
    "titre_genre2": "Mairesse",
    "remuneration": "5009",
    "allocation": "2504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7513",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "3639",
    "nom_corrige2": "Richmond Viau",
    "nom_famille": "Viau",
    "titre_genre2": "Conseiller",
    "remuneration": "5006",
    "allocation": "2503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7509",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3640",
    "nom_corrige2": "Fanny Véronique Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "3641",
    "nom_corrige2": "Daniel Guindon",
    "nom_famille": "Guindon",
    "titre_genre2": "Conseiller",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3642",
    "nom_corrige2": "Pierre Métras",
    "nom_famille": "Métras",
    "titre_genre2": "Conseiller",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3643",
    "nom_corrige2": "Jacques de Foy",
    "nom_famille": "de",
    "titre_genre2": "Conseiller",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3644",
    "nom_corrige2": "Christian Gamache",
    "nom_famille": "Gamache",
    "titre_genre2": "Conseiller",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3645",
    "nom_corrige2": "Pierre Raîche",
    "nom_famille": "Raîche",
    "titre_genre2": "Conseiller",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3646",
    "nom_corrige2": "Roxanne Jeanson Bélisle",
    "nom_famille": "Jeanson",
    "titre_genre2": "Conseillère",
    "remuneration": "5004",
    "allocation": "2502",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7506",
    "ville": "Lac-du-Cerf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "550"
  },
  {
    "ID": "3647",
    "nom_corrige2": "Alain Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Conseiller",
    "remuneration": "9672",
    "allocation": "4836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14508",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "3648",
    "nom_corrige2": "Mathieu Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseiller",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "72",
    "allocation2": "36",
    "total": "7500",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3649",
    "nom_corrige2": "Réjean Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Maire",
    "remuneration": "5000",
    "allocation": "2500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7500",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "3650",
    "nom_corrige2": "Luc Tétreault",
    "nom_famille": "Tétreault",
    "titre_genre2": "Conseiller",
    "remuneration": "5083",
    "allocation": "2414",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7497",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3651",
    "nom_corrige2": "Rémi Tétreault",
    "nom_famille": "Tétreault",
    "titre_genre2": "Conseiller",
    "remuneration": "5083",
    "allocation": "2414",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7497",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3652",
    "nom_corrige2": "Jules Normandin",
    "nom_famille": "Normandin",
    "titre_genre2": "Conseiller",
    "remuneration": "5083",
    "allocation": "2414",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7497",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3653",
    "nom_corrige2": "Nathalie Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Mairesse",
    "remuneration": "4993",
    "allocation": "2500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7493",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "3654",
    "nom_corrige2": "Jaclin Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseiller",
    "remuneration": "7491",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7491",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "3655",
    "nom_corrige2": "Jérôme Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseiller",
    "remuneration": "4986",
    "allocation": "2493",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7479",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "3656",
    "nom_corrige2": "Paul Chamberlain",
    "nom_famille": "Chamberlain",
    "titre_genre2": "Conseiller",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3657",
    "nom_corrige2": "Lynne Lachapelle",
    "nom_famille": "Lachapelle",
    "titre_genre2": "Conseillère",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3658",
    "nom_corrige2": "Craig Gabie",
    "nom_famille": "Gabie",
    "titre_genre2": "Conseiller",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3659",
    "nom_corrige2": "Sylvain La France",
    "nom_famille": "La",
    "titre_genre2": "Conseiller",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3660",
    "nom_corrige2": "Matthew Orlando",
    "nom_famille": "Orlando",
    "titre_genre2": "Conseiller",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3661",
    "nom_corrige2": "Damien Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Conseiller",
    "remuneration": "4968",
    "allocation": "2496",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7464",
    "ville": "Kazabazua",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1030"
  },
  {
    "ID": "3662",
    "nom_corrige2": "Daniel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "796",
    "allocation2": "398",
    "total": "7460",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "3663",
    "nom_corrige2": "Diane Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseillère",
    "remuneration": "4973",
    "allocation": "2487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7460",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "3664",
    "nom_corrige2": "Juliette Melançon-Caillé",
    "nom_famille": "Melançon-Caillé",
    "titre_genre2": "Conseillère",
    "remuneration": "4973",
    "allocation": "2487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7460",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "3665",
    "nom_corrige2": "Cindy Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "4973",
    "allocation": "2487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7460",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "3666",
    "nom_corrige2": "Véronique St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseillère",
    "remuneration": "4973",
    "allocation": "2487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7460",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "3667",
    "nom_corrige2": "Benoît Tousignant",
    "nom_famille": "Tousignant",
    "titre_genre2": "Conseiller",
    "remuneration": "4973",
    "allocation": "2487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7460",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "3668",
    "nom_corrige2": "Gilles Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseiller",
    "remuneration": "5003",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7455",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3669",
    "nom_corrige2": "Michel Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4966",
    "allocation": "2483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7449",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3670",
    "nom_corrige2": "Maryse Joyal",
    "nom_famille": "Joyal",
    "titre_genre2": "Conseillère",
    "remuneration": "4966",
    "allocation": "2483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7449",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3671",
    "nom_corrige2": "Stéphane Roberge",
    "nom_famille": "Roberge",
    "titre_genre2": "Conseiller",
    "remuneration": "4966",
    "allocation": "2483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7449",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3672",
    "nom_corrige2": "Katrine Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseillère",
    "remuneration": "4966",
    "allocation": "2483",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7449",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3673",
    "nom_corrige2": "Marie-Joëlle Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Conseillère",
    "remuneration": "4908",
    "allocation": "2532",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7440",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "3674",
    "nom_corrige2": "JOHNNY CARRIER",
    "nom_famille": "CARRIER",
    "titre_genre2": "Conseiller",
    "remuneration": "4952",
    "allocation": "2476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7428",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "3675",
    "nom_corrige2": "FRÉDÉRIC VALLIÈRES",
    "nom_famille": "VALLIÈRES",
    "titre_genre2": "Conseiller",
    "remuneration": "4952",
    "allocation": "2476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7428",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "3676",
    "nom_corrige2": "CLÉMENT ROY",
    "nom_famille": "ROY",
    "titre_genre2": "Conseiller",
    "remuneration": "4952",
    "allocation": "2476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7428",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "3677",
    "nom_corrige2": "GHISLAIN LOWE",
    "nom_famille": "LOWE",
    "titre_genre2": "Conseiller",
    "remuneration": "4952",
    "allocation": "2476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7428",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "3678",
    "nom_corrige2": "PIERRE-LUC LANGEVIN",
    "nom_famille": "LANGEVIN",
    "titre_genre2": "Conseiller",
    "remuneration": "4952",
    "allocation": "2476",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7428",
    "ville": "Scott",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2709"
  },
  {
    "ID": "3679",
    "nom_corrige2": "Rémi Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3680",
    "nom_corrige2": "Francine Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3681",
    "nom_corrige2": "Johanne Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3682",
    "nom_corrige2": "Ghislain Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseiller",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3683",
    "nom_corrige2": "Danielle Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3684",
    "nom_corrige2": "Louis-René Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseiller",
    "remuneration": "4943",
    "allocation": "2472",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7415",
    "ville": "Cacouna",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1874"
  },
  {
    "ID": "3685",
    "nom_corrige2": "Line Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseillère",
    "remuneration": "5209",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7414",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3686",
    "nom_corrige2": "Caroline Paul",
    "nom_famille": "Paul",
    "titre_genre2": "Conseillère",
    "remuneration": "4941",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7411",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3687",
    "nom_corrige2": "France Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseillère",
    "remuneration": "4941",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7411",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3688",
    "nom_corrige2": "Audrey Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseillère",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3689",
    "nom_corrige2": "Jean-Paul Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3690",
    "nom_corrige2": "Roger East",
    "nom_famille": "East",
    "titre_genre2": "Conseiller",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3691",
    "nom_corrige2": "Mathieu Henri",
    "nom_famille": "Henri",
    "titre_genre2": "Conseiller",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3692",
    "nom_corrige2": "Jean-Claude Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3693",
    "nom_corrige2": "Joël Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "4939",
    "allocation": "2470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7409",
    "ville": "Saint-Ferdinand",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2087"
  },
  {
    "ID": "3694",
    "nom_corrige2": "Yvon Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "4839",
    "allocation": "2568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7407",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3695",
    "nom_corrige2": "Sonia Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseillère",
    "remuneration": "4839",
    "allocation": "2568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7407",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3696",
    "nom_corrige2": "Guy Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseiller",
    "remuneration": "4953",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7405",
    "ville": "Sainte-Perpétue",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1633"
  },
  {
    "ID": "3697",
    "nom_corrige2": "Julie Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3698",
    "nom_corrige2": "Richard Blouin",
    "nom_famille": "Blouin",
    "titre_genre2": "Conseiller",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3699",
    "nom_corrige2": "Sylvie St-Georges",
    "nom_famille": "St-Georges",
    "titre_genre2": "Conseillère",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3700",
    "nom_corrige2": "Stephen Subranni",
    "nom_famille": "Subranni",
    "titre_genre2": "Conseiller",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3701",
    "nom_corrige2": "Julie Croisetiere",
    "nom_famille": "Croisetiere",
    "titre_genre2": "Conseillère",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3702",
    "nom_corrige2": "Christian Paquin-Coutu",
    "nom_famille": "Paquin-Coutu",
    "titre_genre2": "Conseiller",
    "remuneration": "4934",
    "allocation": "2467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7401",
    "ville": "Saint-Gabriel",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2767"
  },
  {
    "ID": "3703",
    "nom_corrige2": "Pierre Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseiller",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7392",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3704",
    "nom_corrige2": "Kelly Huard",
    "nom_famille": "Huard",
    "titre_genre2": "Conseillère",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7392",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3705",
    "nom_corrige2": "Barbara Beugger",
    "nom_famille": "Beugger",
    "titre_genre2": "Conseillère",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7392",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3706",
    "nom_corrige2": "Claude Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseiller",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7392",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3707",
    "nom_corrige2": "Éric Jodoin",
    "nom_famille": "Jodoin",
    "titre_genre2": "Conseiller",
    "remuneration": "4928",
    "allocation": "2464",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7392",
    "ville": "Upton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2379"
  },
  {
    "ID": "3708",
    "nom_corrige2": "Réjean Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "4839",
    "allocation": "2535",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7374",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3709",
    "nom_corrige2": "Nancy Morais",
    "nom_famille": "Morais",
    "titre_genre2": "Conseillère",
    "remuneration": "4907",
    "allocation": "2453",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7360",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "3710",
    "nom_corrige2": "Réjean Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "4839",
    "allocation": "2518",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7357",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3711",
    "nom_corrige2": "Suzanne Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseillère",
    "remuneration": "4902",
    "allocation": "2451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7353",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "3712",
    "nom_corrige2": "Sylvain Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Maire",
    "remuneration": "4828",
    "allocation": "2414",
    "remuneration2": "72",
    "allocation2": "36",
    "total": "7350",
    "ville": "Saint-Valérien-de-Milton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1821"
  },
  {
    "ID": "3713",
    "nom_corrige2": "Karina Poudrier",
    "nom_famille": "Poudrier",
    "titre_genre2": "Conseillère",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "405",
    "allocation2": "526",
    "total": "7348",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "3714",
    "nom_corrige2": "ANDRÉ PERRAULT",
    "nom_famille": "PERRAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3715",
    "nom_corrige2": "MICHAEL DINNIGAN",
    "nom_famille": "DINNIGAN",
    "titre_genre2": "Conseiller",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3716",
    "nom_corrige2": "JULIE DUPUIS",
    "nom_famille": "DUPUIS",
    "titre_genre2": "Conseillère",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3717",
    "nom_corrige2": "ROBERT ARCOITE",
    "nom_famille": "ARCOITE",
    "titre_genre2": "Conseiller",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3718",
    "nom_corrige2": "MARCEL TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseiller",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3719",
    "nom_corrige2": "FRANÇOIS BARBEAU",
    "nom_famille": "BARBEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "4884",
    "allocation": "2442",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7326",
    "ville": "Sainte-Clotilde",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2809"
  },
  {
    "ID": "3720",
    "nom_corrige2": "Réjean Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "4081",
    "allocation": "2041",
    "remuneration2": "796",
    "allocation2": "398",
    "total": "7316",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "3721",
    "nom_corrige2": "Benoit Magny",
    "nom_famille": "Magny",
    "titre_genre2": "Conseiller",
    "remuneration": "4969",
    "allocation": "2346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7315",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3722",
    "nom_corrige2": "Melisa Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseillère",
    "remuneration": "4580",
    "allocation": "2722",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7302",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "3723",
    "nom_corrige2": "Alexandre Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "4839",
    "allocation": "2452",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7291",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3724",
    "nom_corrige2": "Laincy Fecteau",
    "nom_famille": "Fecteau",
    "titre_genre2": "Conseillère",
    "remuneration": "4519",
    "allocation": "2753",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7272",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "3725",
    "nom_corrige2": "Yannick Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "4841",
    "allocation": "2420",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7261",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "3726",
    "nom_corrige2": "Gilles Viens",
    "nom_famille": "Viens",
    "titre_genre2": "Conseiller",
    "remuneration": "4439",
    "allocation": "2219",
    "remuneration2": "400",
    "allocation2": "200",
    "total": "7258",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "3727",
    "nom_corrige2": "Gaëtan Lafrance",
    "nom_famille": "Lafrance",
    "titre_genre2": "Conseiller",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7248",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3728",
    "nom_corrige2": "David Adams",
    "nom_famille": "Adams",
    "titre_genre2": "Conseiller",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7248",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3729",
    "nom_corrige2": "David Branch",
    "nom_famille": "Branch",
    "titre_genre2": "Conseiller",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7248",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3730",
    "nom_corrige2": "Karine Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseillère",
    "remuneration": "4832",
    "allocation": "2416",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7248",
    "ville": "Clarenceville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1273"
  },
  {
    "ID": "3731",
    "nom_corrige2": "Nancy Vanasse",
    "nom_famille": "Vanasse",
    "titre_genre2": "Conseillère",
    "remuneration": "4831",
    "allocation": "2415",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7246",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3732",
    "nom_corrige2": "Sabrina Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "4458",
    "allocation": "2784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7242",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "3733",
    "nom_corrige2": "André Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "4458",
    "allocation": "2784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7242",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "3734",
    "nom_corrige2": "André Angers",
    "nom_famille": "Angers",
    "titre_genre2": "Conseiller",
    "remuneration": "4458",
    "allocation": "2784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7242",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "3735",
    "nom_corrige2": "Daniel Céleste",
    "nom_famille": "Céleste",
    "titre_genre2": "Maire",
    "remuneration": "4595",
    "allocation": "2642",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7237",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "3736",
    "nom_corrige2": "FRANCINE COUETTE",
    "nom_famille": "COUETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3737",
    "nom_corrige2": "KARINE GODBOUT",
    "nom_famille": "GODBOUT",
    "titre_genre2": "Conseillère",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3738",
    "nom_corrige2": "SÉBASTIEN THIBAULT",
    "nom_famille": "THIBAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3739",
    "nom_corrige2": "MARLÈNE BOURGAULT",
    "nom_famille": "BOURGAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3740",
    "nom_corrige2": "GAÉTAN ANCTIL",
    "nom_famille": "ANCTIL",
    "titre_genre2": "Conseiller",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3741",
    "nom_corrige2": "Richard Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4824",
    "allocation": "2412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7236",
    "ville": "Saint-Pamphile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2349"
  },
  {
    "ID": "3742",
    "nom_corrige2": "Suzanne Choinière",
    "nom_famille": "Choinière",
    "titre_genre2": "Conseillère",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3743",
    "nom_corrige2": "François Vadnais",
    "nom_famille": "Vadnais",
    "titre_genre2": "Conseiller",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3744",
    "nom_corrige2": "Bertrand Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3745",
    "nom_corrige2": "Gilbert Cabana",
    "nom_famille": "Cabana",
    "titre_genre2": "Conseiller",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3746",
    "nom_corrige2": "Alexandre Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3747",
    "nom_corrige2": "Benoît Isaia",
    "nom_famille": "Isaia",
    "titre_genre2": "Conseiller",
    "remuneration": "4932",
    "allocation": "2294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7226",
    "ville": "Saint-Alphonse-de-Granby",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "3423"
  },
  {
    "ID": "3748",
    "nom_corrige2": "Mario Hinse",
    "nom_famille": "Hinse",
    "titre_genre2": "Conseiller",
    "remuneration": "5777",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7225",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "3749",
    "nom_corrige2": "Sylvie Huot",
    "nom_famille": "Huot",
    "titre_genre2": "Conseillère",
    "remuneration": "4811",
    "allocation": "2405",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7216",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "3750",
    "nom_corrige2": "Véronique Papineau",
    "nom_famille": "Papineau",
    "titre_genre2": "Conseillère",
    "remuneration": "4808",
    "allocation": "2404",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7212",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "3751",
    "nom_corrige2": "Gérald Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Maire",
    "remuneration": "4806",
    "allocation": "2403",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7209",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "3752",
    "nom_corrige2": "Maude St-Hilaire",
    "nom_famille": "St-Hilaire",
    "titre_genre2": "Conseillère",
    "remuneration": "4804",
    "allocation": "2402",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7206",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3753",
    "nom_corrige2": "Gilles Allain",
    "nom_famille": "Allain",
    "titre_genre2": "Conseiller",
    "remuneration": "4803",
    "allocation": "2402",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7205",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "3754",
    "nom_corrige2": "Guylaine Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "4786",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7179",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "3755",
    "nom_corrige2": "Ginette Bourré",
    "nom_famille": "Bourré",
    "titre_genre2": "Conseillère",
    "remuneration": "4786",
    "allocation": "2393",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7179",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "3756",
    "nom_corrige2": "Fabien Lacorre",
    "nom_famille": "Lacorre",
    "titre_genre2": "Conseiller",
    "remuneration": "4784",
    "allocation": "2392",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7176",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "3757",
    "nom_corrige2": "Michel Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseiller",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3758",
    "nom_corrige2": "Yan Bussières",
    "nom_famille": "Bussières",
    "titre_genre2": "Conseiller",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3759",
    "nom_corrige2": "Joël Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3760",
    "nom_corrige2": "Stéphane Cournoyer",
    "nom_famille": "Cournoyer",
    "titre_genre2": "Conseiller",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3761",
    "nom_corrige2": "Annie Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseillère",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3762",
    "nom_corrige2": "Myriam Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Conseillère",
    "remuneration": "4782",
    "allocation": "2391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7173",
    "ville": "Saint-Robert",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1887"
  },
  {
    "ID": "3763",
    "nom_corrige2": "Guy Massicotte",
    "nom_famille": "Massicotte",
    "titre_genre2": "Conseiller",
    "remuneration": "4781",
    "allocation": "2390",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7171",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "3764",
    "nom_corrige2": "Diana-Joy Davies",
    "nom_famille": "Davies",
    "titre_genre2": "Mairesse",
    "remuneration": "4737",
    "allocation": "2428",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7165",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "3765",
    "nom_corrige2": "André Choinière",
    "nom_famille": "Choinière",
    "titre_genre2": "Conseiller",
    "remuneration": "4796",
    "allocation": "2023",
    "remuneration2": "227",
    "allocation2": "113",
    "total": "7159",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "3766",
    "nom_corrige2": "Bernard Groulx",
    "nom_famille": "Groulx",
    "titre_genre2": "Conseiller",
    "remuneration": "4769",
    "allocation": "2385",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7154",
    "ville": "Notre-Dame-de-l'Île-Perrot",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "11693"
  },
  {
    "ID": "3767",
    "nom_corrige2": "Jérémie Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "4761",
    "allocation": "2381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7142",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "3768",
    "nom_corrige2": "Guy Bruneau",
    "nom_famille": "Bruneau",
    "titre_genre2": "Conseiller",
    "remuneration": "4755",
    "allocation": "2377",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7132",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "3769",
    "nom_corrige2": "Jean-Pierre Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "4755",
    "allocation": "2377",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7132",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "3770",
    "nom_corrige2": "Pierre Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseiller",
    "remuneration": "4755",
    "allocation": "2377",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7132",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "3771",
    "nom_corrige2": "Marie Claude Labelle",
    "nom_famille": "Claude",
    "titre_genre2": "Conseillère",
    "remuneration": "4755",
    "allocation": "2377",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7132",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "3772",
    "nom_corrige2": "MICHEL DUBUC",
    "nom_famille": "DUBUC",
    "titre_genre2": "Conseiller",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3773",
    "nom_corrige2": "CARMYN GIRARD",
    "nom_famille": "GIRARD",
    "titre_genre2": "Conseiller",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3774",
    "nom_corrige2": "MARIE-CLAUDE ADAM",
    "nom_famille": "ADAM",
    "titre_genre2": "Conseillère",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3775",
    "nom_corrige2": "SIMON LEJOUR",
    "nom_famille": "LEJOUR",
    "titre_genre2": "Conseiller",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3776",
    "nom_corrige2": "Carole Ste Marie",
    "nom_famille": "Ste",
    "titre_genre2": "Conseillère",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3777",
    "nom_corrige2": "Vicky Landry Bergeron",
    "nom_famille": "Landry",
    "titre_genre2": "Conseillère",
    "remuneration": "4750",
    "allocation": "2375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7125",
    "ville": "Saint-Bernard-de-Lacolle",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1690"
  },
  {
    "ID": "3778",
    "nom_corrige2": "Dave Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "4747",
    "allocation": "2374",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7121",
    "ville": "Beaumont",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3146"
  },
  {
    "ID": "3779",
    "nom_corrige2": "Fabrice Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "5192",
    "allocation": "1927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7119",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "3780",
    "nom_corrige2": "Daniel Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseiller",
    "remuneration": "4742",
    "allocation": "2371",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7113",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "3781",
    "nom_corrige2": "Pierre-André Arès",
    "nom_famille": "Arès",
    "titre_genre2": "Conseiller",
    "remuneration": "5657",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7105",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "3782",
    "nom_corrige2": "Lina Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseillère",
    "remuneration": "4866",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7099",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "3783",
    "nom_corrige2": "Pierre Bertrand",
    "nom_famille": "Bertrand",
    "titre_genre2": "Conseiller",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "844",
    "allocation2": "0",
    "total": "7099",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "3784",
    "nom_corrige2": "Fanny Dupras-Rossier",
    "nom_famille": "Dupras-Rossier",
    "titre_genre2": "Mairesse",
    "remuneration": "4731",
    "allocation": "2366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7097",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "3785",
    "nom_corrige2": "Éric Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseiller",
    "remuneration": "4729",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7093",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3786",
    "nom_corrige2": "Isabelle Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseillère",
    "remuneration": "4729",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7093",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3787",
    "nom_corrige2": "Sabrina Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseillère",
    "remuneration": "4729",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7093",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3788",
    "nom_corrige2": "Billy Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "4729",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7093",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3789",
    "nom_corrige2": "Christian Malouin",
    "nom_famille": "Malouin",
    "titre_genre2": "Conseiller",
    "remuneration": "4729",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7093",
    "ville": "Chute-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1433"
  },
  {
    "ID": "3790",
    "nom_corrige2": "SYLVAIN LAMOTHE",
    "nom_famille": "LAMOTHE",
    "titre_genre2": "Conseiller",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7092",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3791",
    "nom_corrige2": "YVON PARENTEAU",
    "nom_famille": "PARENTEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7092",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3792",
    "nom_corrige2": "MARC ARSENEAULT",
    "nom_famille": "ARSENEAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7092",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3793",
    "nom_corrige2": "LOUISE MCMAHON",
    "nom_famille": "MCMAHON",
    "titre_genre2": "Conseillère",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7092",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3794",
    "nom_corrige2": "OLIVIER LEMIRE",
    "nom_famille": "LEMIRE",
    "titre_genre2": "Conseiller",
    "remuneration": "4728",
    "allocation": "2364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7092",
    "ville": "Saint-Célestin",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "916"
  },
  {
    "ID": "3795",
    "nom_corrige2": "Mélanie Guenet",
    "nom_famille": "Guenet",
    "titre_genre2": "Conseillère",
    "remuneration": "4720",
    "allocation": "2360",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7080",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3796",
    "nom_corrige2": "LÉO LEPAGE ST-AMAND",
    "nom_famille": "LEPAGE",
    "titre_genre2": "Conseiller",
    "remuneration": "4714",
    "allocation": "2357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7071",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "3797",
    "nom_corrige2": "DENIS VIEL",
    "nom_famille": "VIEL",
    "titre_genre2": "Conseiller",
    "remuneration": "4714",
    "allocation": "2357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7071",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "3798",
    "nom_corrige2": "RÉJEAN GAGNÉ",
    "nom_famille": "GAGNÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "4714",
    "allocation": "2357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7071",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "3799",
    "nom_corrige2": "LOUIS-MARIE D'ANJOU",
    "nom_famille": "D'ANJOU",
    "titre_genre2": "Conseiller",
    "remuneration": "4714",
    "allocation": "2357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7071",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "3800",
    "nom_corrige2": "GAÉTAN GAGNÉ",
    "nom_famille": "GAGNÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "4714",
    "allocation": "2357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7071",
    "ville": "Causapscal",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2242"
  },
  {
    "ID": "3801",
    "nom_corrige2": "Isabelle Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseillère",
    "remuneration": "4712",
    "allocation": "2356",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7068",
    "ville": "Saint-Lucien",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1873"
  },
  {
    "ID": "3802",
    "nom_corrige2": "Mélissa Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7061",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3803",
    "nom_corrige2": "Irène Drouin Dubreuil",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7061",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3804",
    "nom_corrige2": "Lydia Richer",
    "nom_famille": "Richer",
    "titre_genre2": "Conseillère",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7061",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3805",
    "nom_corrige2": "Stéphanie Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseillère",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7061",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3806",
    "nom_corrige2": "Lise Bachand",
    "nom_famille": "Bachand",
    "titre_genre2": "Conseillère",
    "remuneration": "4874",
    "allocation": "2187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7061",
    "ville": "Saint-Dominique",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2783"
  },
  {
    "ID": "3807",
    "nom_corrige2": "Éric Bussière",
    "nom_famille": "Bussière",
    "titre_genre2": "Conseiller",
    "remuneration": "4699",
    "allocation": "2350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7049",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "3808",
    "nom_corrige2": "Lyne Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "4699",
    "allocation": "2350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7049",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "3809",
    "nom_corrige2": "Martin Juneau",
    "nom_famille": "Juneau",
    "titre_genre2": "Conseiller",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3810",
    "nom_corrige2": "Mario Vallée",
    "nom_famille": "Vallée",
    "titre_genre2": "Conseiller",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3811",
    "nom_corrige2": "Benoît Durand",
    "nom_famille": "Durand",
    "titre_genre2": "Conseiller",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3812",
    "nom_corrige2": "Natacha Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseillère",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3813",
    "nom_corrige2": "Anick Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3814",
    "nom_corrige2": "Jean-Pierre Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "4697",
    "allocation": "2349",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7046",
    "ville": "Pointe-des-Cascades",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1813"
  },
  {
    "ID": "3815",
    "nom_corrige2": "Gaétan Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "782",
    "allocation": "391",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1173",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "3816",
    "nom_corrige2": "Ariane Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Conseillère",
    "remuneration": "4693",
    "allocation": "2347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7040",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "3817",
    "nom_corrige2": "Sébastien Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Conseiller",
    "remuneration": "4693",
    "allocation": "2347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7040",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "3818",
    "nom_corrige2": "Mario Langevin",
    "nom_famille": "Langevin",
    "titre_genre2": "Maire",
    "remuneration": "7626",
    "allocation": "3814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "11440",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "3819",
    "nom_corrige2": "Daniel Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "4692",
    "allocation": "2346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7038",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3820",
    "nom_corrige2": "Yanick Godon",
    "nom_famille": "Godon",
    "titre_genre2": "Conseiller",
    "remuneration": "4692",
    "allocation": "2346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7038",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3821",
    "nom_corrige2": "Roger Marceau",
    "nom_famille": "Marceau",
    "titre_genre2": "Conseiller",
    "remuneration": "4692",
    "allocation": "2346",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7038",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3822",
    "nom_corrige2": "Denis Bordeleau",
    "nom_famille": "Bordeleau",
    "titre_genre2": "Conseiller",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3823",
    "nom_corrige2": "Normand Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3824",
    "nom_corrige2": "Roman Pokorski",
    "nom_famille": "Pokorski",
    "titre_genre2": "Conseiller",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3825",
    "nom_corrige2": "Suzanne Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3826",
    "nom_corrige2": "Claude Thiffault",
    "nom_famille": "Thiffault",
    "titre_genre2": "Conseiller",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3827",
    "nom_corrige2": "Nathalie Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "4685",
    "allocation": "2343",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7028",
    "ville": "Saint-Adelphe",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "990"
  },
  {
    "ID": "3828",
    "nom_corrige2": "Nancy Letendre",
    "nom_famille": "Letendre",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "322",
    "allocation2": "161",
    "total": "7022",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3829",
    "nom_corrige2": "Gilbert Boileau",
    "nom_famille": "Boileau",
    "titre_genre2": "Conseiller",
    "remuneration": "4677",
    "allocation": "2338",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7015",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3830",
    "nom_corrige2": "Willy Mouzon",
    "nom_famille": "Mouzon",
    "titre_genre2": "Conseiller",
    "remuneration": "4809",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7014",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3831",
    "nom_corrige2": "François Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "4667",
    "allocation": "2333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7000",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "3832",
    "nom_corrige2": "Jean-Philippe Bibeau",
    "nom_famille": "Bibeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4667",
    "allocation": "2333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7000",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "3833",
    "nom_corrige2": "Diane Kirouac",
    "nom_famille": "Kirouac",
    "titre_genre2": "Conseillère",
    "remuneration": "4667",
    "allocation": "2333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7000",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "3834",
    "nom_corrige2": "Nicolas Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseiller",
    "remuneration": "4667",
    "allocation": "2333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7000",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "3835",
    "nom_corrige2": "Francis Lacharité",
    "nom_famille": "Lacharité",
    "titre_genre2": "Conseiller",
    "remuneration": "4667",
    "allocation": "2333",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7000",
    "ville": "Saint-Albert",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1777"
  },
  {
    "ID": "3836",
    "nom_corrige2": "Marie-Claude Samuel",
    "nom_famille": "Samuel",
    "titre_genre2": "Conseillère",
    "remuneration": "4659",
    "allocation": "2329",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6988",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3837",
    "nom_corrige2": "Hugo Massicotte",
    "nom_famille": "Massicotte",
    "titre_genre2": "Conseiller",
    "remuneration": "4659",
    "allocation": "2329",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6988",
    "ville": "Sainte-Geneviève-de-Batiscan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1076"
  },
  {
    "ID": "3838",
    "nom_corrige2": "Roger Bouthillette",
    "nom_famille": "Bouthillette",
    "titre_genre2": "Maire",
    "remuneration": "4651",
    "allocation": "2325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6976",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "3839",
    "nom_corrige2": "Michel Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Conseiller",
    "remuneration": "4651",
    "allocation": "2325",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6976",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "3840",
    "nom_corrige2": "Marco Dénommé",
    "nom_famille": "Dénommé",
    "titre_genre2": "Maire",
    "remuneration": "4638",
    "allocation": "2319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6957",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "3841",
    "nom_corrige2": "Michael Sudlow",
    "nom_famille": "Sudlow",
    "titre_genre2": "Conseiller",
    "remuneration": "4637",
    "allocation": "2318",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6955",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3842",
    "nom_corrige2": "Sylvain Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "4124",
    "allocation": "2062",
    "remuneration2": "506",
    "allocation2": "253",
    "total": "6945",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "3843",
    "nom_corrige2": "Éric Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseiller",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "796",
    "allocation2": "398",
    "total": "6939",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "3844",
    "nom_corrige2": "Noëlle-Ange Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseillère",
    "remuneration": "4622",
    "allocation": "2307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6929",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "3845",
    "nom_corrige2": "Kathleen Normand",
    "nom_famille": "Normand",
    "titre_genre2": "Conseillère",
    "remuneration": "4622",
    "allocation": "2307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6929",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "3846",
    "nom_corrige2": "Patrice Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "4622",
    "allocation": "2307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6929",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "3847",
    "nom_corrige2": "Bernard Boudreault",
    "nom_famille": "Boudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "4622",
    "allocation": "2307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6929",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "3848",
    "nom_corrige2": "Yoland Neault",
    "nom_famille": "Neault",
    "titre_genre2": "Conseiller",
    "remuneration": "2733",
    "allocation": "1366",
    "remuneration2": "1884",
    "allocation2": "942",
    "total": "6925",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "3849",
    "nom_corrige2": "Albert Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "4778",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6917",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "3850",
    "nom_corrige2": "Alain Grégoire",
    "nom_famille": "Grégoire",
    "titre_genre2": "Mairesse",
    "remuneration": "4741",
    "allocation": "2175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6916",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "3851",
    "nom_corrige2": "Pierre Mineau",
    "nom_famille": "Mineau",
    "titre_genre2": "Conseiller",
    "remuneration": "4603",
    "allocation": "2302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6905",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2138"
  },
  {
    "ID": "3852",
    "nom_corrige2": "Patrice Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "4666",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6899",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "3853",
    "nom_corrige2": "Sébastien Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "4666",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6899",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "3854",
    "nom_corrige2": "Mylène Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "4666",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6899",
    "ville": "Saint-Édouard-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1233"
  },
  {
    "ID": "3855",
    "nom_corrige2": "Bruneau Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "4602",
    "allocation": "2276",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6878",
    "ville": "Nantes",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1470"
  },
  {
    "ID": "3856",
    "nom_corrige2": "Marc Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "4577",
    "allocation": "2288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6865",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3857",
    "nom_corrige2": "Jean-Luc Payant",
    "nom_famille": "Payant",
    "titre_genre2": "Conseiller",
    "remuneration": "4577",
    "allocation": "2288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6865",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3858",
    "nom_corrige2": "Richard Beaudin",
    "nom_famille": "Beaudin",
    "titre_genre2": "Conseiller",
    "remuneration": "4577",
    "allocation": "2288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6865",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3859",
    "nom_corrige2": "Martin Lafond",
    "nom_famille": "Lafond",
    "titre_genre2": "Conseiller",
    "remuneration": "4577",
    "allocation": "2288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6865",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3860",
    "nom_corrige2": "Suzan Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseiller",
    "remuneration": "4577",
    "allocation": "2288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6865",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3861",
    "nom_corrige2": "CÉLINE LEPAGE",
    "nom_famille": "LEPAGE",
    "titre_genre2": "Conseillère",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "3862",
    "nom_corrige2": "DANIEL PARENT",
    "nom_famille": "PARENT",
    "titre_genre2": "Conseiller",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "3863",
    "nom_corrige2": "SONIA BEAUREGARD",
    "nom_famille": "BEAUREGARD",
    "titre_genre2": "Conseillère",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "3864",
    "nom_corrige2": "MARIO OUELLET",
    "nom_famille": "OUELLET",
    "titre_genre2": "Conseiller",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "3865",
    "nom_corrige2": "LUC TURCOTTE",
    "nom_famille": "TURCOTTE",
    "titre_genre2": "Conseiller",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "3866",
    "nom_corrige2": "Bélinda Drolet",
    "nom_famille": "Drolet",
    "titre_genre2": "Conseillère",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "3867",
    "nom_corrige2": "Jonathan Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseiller",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "3868",
    "nom_corrige2": "Annick Héon",
    "nom_famille": "Héon",
    "titre_genre2": "Conseillère",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "3869",
    "nom_corrige2": "Rémi Brassard",
    "nom_famille": "Brassard",
    "titre_genre2": "Conseiller",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "3870",
    "nom_corrige2": "Joanie Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "4566",
    "allocation": "2283",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6849",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "3871",
    "nom_corrige2": "Jean-Pierre Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Maire",
    "remuneration": "2693",
    "allocation": "1346",
    "remuneration2": "1870",
    "allocation2": "935",
    "total": "6844",
    "ville": "Sainte-Julienne",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "11932"
  },
  {
    "ID": "3872",
    "nom_corrige2": "Gilles Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "4557",
    "allocation": "2278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6835",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "3873",
    "nom_corrige2": "Audrey Charron Brosseau",
    "nom_famille": "Charron",
    "titre_genre2": "Conseillère",
    "remuneration": "4557",
    "allocation": "2278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6835",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "3874",
    "nom_corrige2": "Rébecca Plourde-Gagnon",
    "nom_famille": "Plourde-Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "4900",
    "allocation": "1927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6827",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "3875",
    "nom_corrige2": "Nelson Pilote",
    "nom_famille": "Pilote",
    "titre_genre2": "Maire",
    "remuneration": "4551",
    "allocation": "2275",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6826",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "3876",
    "nom_corrige2": "Josée Hamelin",
    "nom_famille": "Hamelin",
    "titre_genre2": "Conseillère",
    "remuneration": "4678",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6817",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "3877",
    "nom_corrige2": "Nicole Hémond",
    "nom_famille": "Hémond",
    "titre_genre2": "Conseillère",
    "remuneration": "4609",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6814",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3878",
    "nom_corrige2": "JEAN FRANÇOIS HAMEL",
    "nom_famille": "HAMEL",
    "titre_genre2": "Conseiller",
    "remuneration": "4533",
    "allocation": "2267",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6800",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "3879",
    "nom_corrige2": "Bob Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "4531",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6796",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3880",
    "nom_corrige2": "Josiane Martel-Ouellet",
    "nom_famille": "Martel-Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "4531",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6796",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3881",
    "nom_corrige2": "Stéphanie Dalpé",
    "nom_famille": "Dalpé",
    "titre_genre2": "Conseillère",
    "remuneration": "4531",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6796",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3882",
    "nom_corrige2": "Catherine Marsan-Loyer",
    "nom_famille": "Marsan-Loyer",
    "titre_genre2": "Conseillère",
    "remuneration": "4531",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6796",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3883",
    "nom_corrige2": "Marie Claude Aubin",
    "nom_famille": "Claude",
    "titre_genre2": "Conseillère",
    "remuneration": "4531",
    "allocation": "2265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6796",
    "ville": "Frelighsburg",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1297"
  },
  {
    "ID": "3884",
    "nom_corrige2": "François Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "862",
    "allocation2": "804",
    "total": "6796",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "3885",
    "nom_corrige2": "Mario Henderson",
    "nom_famille": "Henderson",
    "titre_genre2": "Conseiller",
    "remuneration": "4527",
    "allocation": "2263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6790",
    "ville": "Saint-Chrysostome",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2841"
  },
  {
    "ID": "3886",
    "nom_corrige2": "Gilles Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "4525",
    "allocation": "2263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6788",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "3887",
    "nom_corrige2": "André Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseiller",
    "remuneration": "4525",
    "allocation": "2263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6788",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "3888",
    "nom_corrige2": "Mélanie Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseillère",
    "remuneration": "4525",
    "allocation": "2263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6788",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "3889",
    "nom_corrige2": "Audrey Blondin-Lebel",
    "nom_famille": "Blondin-Lebel",
    "titre_genre2": "Conseillère",
    "remuneration": "4525",
    "allocation": "2263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6788",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "3890",
    "nom_corrige2": "Ronald Gonthier",
    "nom_famille": "Gonthier",
    "titre_genre2": "Conseiller",
    "remuneration": "4215",
    "allocation": "2108",
    "remuneration2": "309",
    "allocation2": "155",
    "total": "6787",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "3891",
    "nom_corrige2": "Stéphane Brideau",
    "nom_famille": "Brideau",
    "titre_genre2": "Conseiller",
    "remuneration": "4516",
    "allocation": "2258",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6774",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "3892",
    "nom_corrige2": "Jean-Claude Lecours",
    "nom_famille": "Lecours",
    "titre_genre2": "Conseiller",
    "remuneration": "4516",
    "allocation": "2258",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6774",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "3893",
    "nom_corrige2": "Jean-Claude Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "4516",
    "allocation": "2258",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6774",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "3894",
    "nom_corrige2": "Dominic Turmel",
    "nom_famille": "Turmel",
    "titre_genre2": "Conseiller",
    "remuneration": "4516",
    "allocation": "2258",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6774",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "3895",
    "nom_corrige2": "Audrey Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Conseillère",
    "remuneration": "4516",
    "allocation": "2258",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6774",
    "ville": "Saint-Janvier-de-Joly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1124"
  },
  {
    "ID": "3896",
    "nom_corrige2": "Catherine Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Conseillère",
    "remuneration": "4512",
    "allocation": "2256",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6768",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "3897",
    "nom_corrige2": "Sarah Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseillère",
    "remuneration": "4510",
    "allocation": "2255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6765",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3898",
    "nom_corrige2": "Rhéal Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "127",
    "allocation2": "63",
    "total": "6760",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3899",
    "nom_corrige2": "Philippe Bourdeau",
    "nom_famille": "Bourdeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4507",
    "allocation": "2253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6760",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "3900",
    "nom_corrige2": "Laurette Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "4988",
    "allocation": "1767",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6755",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "3901",
    "nom_corrige2": "GINETTE BARNABÉ",
    "nom_famille": "BARNABÉ",
    "titre_genre2": "Conseillère",
    "remuneration": "4500",
    "allocation": "2250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6750",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "3902",
    "nom_corrige2": "RENÉ LEBLANC",
    "nom_famille": "LEBLANC",
    "titre_genre2": "Conseiller",
    "remuneration": "4500",
    "allocation": "2250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6750",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "3903",
    "nom_corrige2": "Shawna Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseillère",
    "remuneration": "4489",
    "allocation": "2244",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6733",
    "ville": "L'Île-d'Anticosti",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "203"
  },
  {
    "ID": "3904",
    "nom_corrige2": "Isabelle Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "4489",
    "allocation": "2244",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6733",
    "ville": "L'Île-d'Anticosti",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "203"
  },
  {
    "ID": "3905",
    "nom_corrige2": "Marie-Pierre Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "4489",
    "allocation": "2244",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6733",
    "ville": "L'Île-d'Anticosti",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "203"
  },
  {
    "ID": "3906",
    "nom_corrige2": "France Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "4489",
    "allocation": "2244",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6733",
    "ville": "L'Île-d'Anticosti",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "203"
  },
  {
    "ID": "3907",
    "nom_corrige2": "Chantal Montminy",
    "nom_famille": "Montminy",
    "titre_genre2": "Conseillère",
    "remuneration": "4484",
    "allocation": "2242",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6726",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "3908",
    "nom_corrige2": "Manuel Bournival",
    "nom_famille": "Bournival",
    "titre_genre2": "Conseiller",
    "remuneration": "4480",
    "allocation": "2240",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6720",
    "ville": "Sainte-Clotilde-de-Horton",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1644"
  },
  {
    "ID": "3909",
    "nom_corrige2": "Bertrand Bastien",
    "nom_famille": "Bastien",
    "titre_genre2": "Conseiller",
    "remuneration": "4578",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6717",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "3910",
    "nom_corrige2": "Claudette Dupras",
    "nom_famille": "Dupras",
    "titre_genre2": "Conseillère",
    "remuneration": "4477",
    "allocation": "2238",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6715",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3911",
    "nom_corrige2": "Michel Lesage",
    "nom_famille": "Lesage",
    "titre_genre2": "Conseiller",
    "remuneration": "4477",
    "allocation": "2238",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6715",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3912",
    "nom_corrige2": "William Scott",
    "nom_famille": "Scott",
    "titre_genre2": "Conseiller",
    "remuneration": "4477",
    "allocation": "2238",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6715",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3913",
    "nom_corrige2": "Eric Fafard",
    "nom_famille": "Fafard",
    "titre_genre2": "Conseiller",
    "remuneration": "4477",
    "allocation": "2238",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6715",
    "ville": "Ogden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "793"
  },
  {
    "ID": "3914",
    "nom_corrige2": "Charles Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "4787",
    "allocation": "1927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6714",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "3915",
    "nom_corrige2": "Annie Sénéchal",
    "nom_famille": "Sénéchal",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3916",
    "nom_corrige2": "Jean-François Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3917",
    "nom_corrige2": "Josée Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3918",
    "nom_corrige2": "Carole Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3919",
    "nom_corrige2": "Pascale G. Malenfant",
    "nom_famille": "Malenfant",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3920",
    "nom_corrige2": "Natacha Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "4476",
    "allocation": "2229",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6705",
    "ville": "Sainte-Anne-de-la-Pocatière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1571"
  },
  {
    "ID": "3921",
    "nom_corrige2": "AUDE FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseillère",
    "remuneration": "4467",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6700",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "3922",
    "nom_corrige2": "BRUNO BOUTIN",
    "nom_famille": "BOUTIN",
    "titre_genre2": "Conseiller",
    "remuneration": "4467",
    "allocation": "2233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6700",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "3923",
    "nom_corrige2": "Sylvie Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseillère",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "200",
    "allocation2": "500",
    "total": "6700",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "3924",
    "nom_corrige2": "François Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "200",
    "allocation2": "500",
    "total": "6700",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "3925",
    "nom_corrige2": "Peter McHarg",
    "nom_famille": "McHarg",
    "titre_genre2": "Conseiller",
    "remuneration": "4464",
    "allocation": "2232",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6696",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3926",
    "nom_corrige2": "Jean-Philippe Cuénoud",
    "nom_famille": "Cuénoud",
    "titre_genre2": "Conseiller",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3927",
    "nom_corrige2": "Claude Vasseur",
    "nom_famille": "Vasseur",
    "titre_genre2": "Conseiller",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3928",
    "nom_corrige2": "Mario Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Conseiller",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3929",
    "nom_corrige2": "Luc Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Conseiller",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3930",
    "nom_corrige2": "Michel Lemaire",
    "nom_famille": "Lemaire",
    "titre_genre2": "Conseiller",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3931",
    "nom_corrige2": "Annie Soutière",
    "nom_famille": "Soutière",
    "titre_genre2": "Conseillère",
    "remuneration": "4457",
    "allocation": "2228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6685",
    "ville": "Sainte-Brigide-d'Iberville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1492"
  },
  {
    "ID": "3932",
    "nom_corrige2": "Josée Aubin",
    "nom_famille": "Aubin",
    "titre_genre2": "Conseillère",
    "remuneration": "4596",
    "allocation": "2080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6676",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "3933",
    "nom_corrige2": "Stéphane Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "4448",
    "allocation": "2222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6670",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "3934",
    "nom_corrige2": "Sylvie Brisson",
    "nom_famille": "Brisson",
    "titre_genre2": "Conseillère",
    "remuneration": "4545",
    "allocation": "2123",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6668",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "3935",
    "nom_corrige2": "Chantal Desharnais",
    "nom_famille": "Desharnais",
    "titre_genre2": "Conseillère",
    "remuneration": "4436",
    "allocation": "2230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6666",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "3936",
    "nom_corrige2": "Jasmin Desharnais",
    "nom_famille": "Desharnais",
    "titre_genre2": "Conseiller",
    "remuneration": "4436",
    "allocation": "2230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6666",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "3937",
    "nom_corrige2": "Carl Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseiller",
    "remuneration": "4420",
    "allocation": "2210",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6630",
    "ville": "Saint-Charles-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2642"
  },
  {
    "ID": "3938",
    "nom_corrige2": "Jean-Pierre Brien",
    "nom_famille": "Brien",
    "titre_genre2": "Conseiller",
    "remuneration": "5387",
    "allocation": "1236",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6623",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "3939",
    "nom_corrige2": "Philippe Dunn",
    "nom_famille": "Dunn",
    "titre_genre2": "Conseiller",
    "remuneration": "4409",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6614",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "3940",
    "nom_corrige2": "Steven Strong-Gallant",
    "nom_famille": "Strong-Gallant",
    "titre_genre2": "Conseiller",
    "remuneration": "4409",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6614",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3941",
    "nom_corrige2": "Sébastien Primeau",
    "nom_famille": "Primeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4409",
    "allocation": "2205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6614",
    "ville": "Très-Saint-Rédempteur",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1090"
  },
  {
    "ID": "3942",
    "nom_corrige2": "François Gastonguay",
    "nom_famille": "Gastonguay",
    "titre_genre2": "Conseiller",
    "remuneration": "4218",
    "allocation": "1969",
    "remuneration2": "281",
    "allocation2": "140",
    "total": "6608",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "3943",
    "nom_corrige2": "Roxanne Boudreault-Guimond",
    "nom_famille": "Boudreault-Guimond",
    "titre_genre2": "Conseillère",
    "remuneration": "4094",
    "allocation": "2047",
    "remuneration2": "464",
    "allocation2": "0",
    "total": "6605",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "3944",
    "nom_corrige2": "Paul Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Conseiller",
    "remuneration": "4395",
    "allocation": "2197",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6592",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "3945",
    "nom_corrige2": "Gilles Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseiller",
    "remuneration": "4395",
    "allocation": "2197",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6592",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "3946",
    "nom_corrige2": "Dominick Demers-Robichaud",
    "nom_famille": "Demers-Robichaud",
    "titre_genre2": "Conseiller",
    "remuneration": "4395",
    "allocation": "2197",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6592",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "3947",
    "nom_corrige2": "Michael Crook",
    "nom_famille": "Crook",
    "titre_genre2": "Conseiller",
    "remuneration": "4391",
    "allocation": "2195",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6586",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3948",
    "nom_corrige2": "Gilles Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "4389",
    "allocation": "2194",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6583",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "3949",
    "nom_corrige2": "LOUISE JEAN",
    "nom_famille": "JEAN",
    "titre_genre2": "Conseillère",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3950",
    "nom_corrige2": "DOMINIQUE TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseiller",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3951",
    "nom_corrige2": "CATHY TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseillère",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3952",
    "nom_corrige2": "GUYLAINE MOREL",
    "nom_famille": "MOREL",
    "titre_genre2": "Conseillère",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3953",
    "nom_corrige2": "MÉLINA HARVEY",
    "nom_famille": "HARVEY",
    "titre_genre2": "Conseillère",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3954",
    "nom_corrige2": "JEAN-CLAUDE Junior TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseiller",
    "remuneration": "4385",
    "allocation": "2192",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6577",
    "ville": "Saint-Hilarion",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1159"
  },
  {
    "ID": "3955",
    "nom_corrige2": "Denise Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "4382",
    "allocation": "2191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6573",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "3956",
    "nom_corrige2": "Éric Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6570",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3957",
    "nom_corrige2": "Charles Choquette",
    "nom_famille": "Choquette",
    "titre_genre2": "Conseiller",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6570",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3958",
    "nom_corrige2": "Benoit Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6570",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3959",
    "nom_corrige2": "Jonathan Alix",
    "nom_famille": "Alix",
    "titre_genre2": "Conseiller",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6570",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3960",
    "nom_corrige2": "Marie-Eve Goos",
    "nom_famille": "Goos",
    "titre_genre2": "Conseillère",
    "remuneration": "4380",
    "allocation": "2190",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6570",
    "ville": "Ange-Gardien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2950"
  },
  {
    "ID": "3961",
    "nom_corrige2": "Lynne Delorme",
    "nom_famille": "Delorme",
    "titre_genre2": "Conseillère",
    "remuneration": "4445",
    "allocation": "2123",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6568",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "3962",
    "nom_corrige2": "Darren Knox",
    "nom_famille": "Knox",
    "titre_genre2": "Conseiller",
    "remuneration": "4360",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6540",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "3963",
    "nom_corrige2": "Jennifer Quaile",
    "nom_famille": "Quaile",
    "titre_genre2": "Conseillère",
    "remuneration": "4360",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6540",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "3964",
    "nom_corrige2": "Penny Dubeau",
    "nom_famille": "Dubeau",
    "titre_genre2": "Conseillère",
    "remuneration": "4360",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6540",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "3965",
    "nom_corrige2": "Serge Sabourin",
    "nom_famille": "Sabourin",
    "titre_genre2": "Conseiller",
    "remuneration": "4360",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6540",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "3966",
    "nom_corrige2": "Robin Zacharias",
    "nom_famille": "Zacharias",
    "titre_genre2": "Conseiller",
    "remuneration": "4360",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6540",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "3967",
    "nom_corrige2": "Valérie Chicoine",
    "nom_famille": "Chicoine",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6539",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3968",
    "nom_corrige2": "Jocelyn Brière",
    "nom_famille": "Brière",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6539",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3969",
    "nom_corrige2": "Stéphanie Bonin",
    "nom_famille": "Bonin",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6539",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3970",
    "nom_corrige2": "Geneviève Allaire",
    "nom_famille": "Allaire",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6539",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3971",
    "nom_corrige2": "Marcel Sinclair",
    "nom_famille": "Sinclair",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6539",
    "ville": "Saint-Majorique-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1386"
  },
  {
    "ID": "3972",
    "nom_corrige2": "Yves Payette",
    "nom_famille": "Payette",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3973",
    "nom_corrige2": "Sandra Chandonnet",
    "nom_famille": "Chandonnet",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3974",
    "nom_corrige2": "Nancy Mccarthy",
    "nom_famille": "Mccarthy",
    "titre_genre2": "Conseillère",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3975",
    "nom_corrige2": "Jean-François Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3976",
    "nom_corrige2": "Donald Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3977",
    "nom_corrige2": "Pascal Brulé",
    "nom_famille": "Brulé",
    "titre_genre2": "Conseiller",
    "remuneration": "4359",
    "allocation": "2179",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6538",
    "ville": "Notre-Dame-de-Lourdes",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "824"
  },
  {
    "ID": "3978",
    "nom_corrige2": "Cédric Quirion",
    "nom_famille": "Quirion",
    "titre_genre2": "Conseiller",
    "remuneration": "4595",
    "allocation": "1936",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6531",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "3979",
    "nom_corrige2": "Alain Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "4595",
    "allocation": "1936",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6531",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "3980",
    "nom_corrige2": "Shawn Marier",
    "nom_famille": "Marier",
    "titre_genre2": "Conseiller",
    "remuneration": "4595",
    "allocation": "1936",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6531",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "3981",
    "nom_corrige2": "Stéphane Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "4034",
    "allocation": "2016",
    "remuneration2": "319",
    "allocation2": "160",
    "total": "6529",
    "ville": "Lac-Sergent",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "549"
  },
  {
    "ID": "3982",
    "nom_corrige2": "Alain Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "4410",
    "allocation": "2109",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6519",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "3983",
    "nom_corrige2": "Patrick Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "4354",
    "allocation": "2163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Ayer's Cliff",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1229"
  },
  {
    "ID": "3984",
    "nom_corrige2": "Martin Couillard",
    "nom_famille": "Couillard",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3985",
    "nom_corrige2": "Benjamin Bourcier",
    "nom_famille": "Bourcier",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3986",
    "nom_corrige2": "Guy Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3987",
    "nom_corrige2": "Jacques Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3988",
    "nom_corrige2": "Guy Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3989",
    "nom_corrige2": "Mathieu Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "4345",
    "allocation": "2172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6517",
    "ville": "Saint-Étienne-de-Beauharnois",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1056"
  },
  {
    "ID": "3990",
    "nom_corrige2": "Maureen Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseillère",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "45",
    "allocation2": "52",
    "total": "6514",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "3991",
    "nom_corrige2": "Lois Miller",
    "nom_famille": "Miller",
    "titre_genre2": "Conseillère",
    "remuneration": "4338",
    "allocation": "2169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6507",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "3992",
    "nom_corrige2": "Francis Grégoire",
    "nom_famille": "Grégoire",
    "titre_genre2": "Conseiller",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "724",
    "allocation2": "362",
    "total": "6505",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "3993",
    "nom_corrige2": "Gilles Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3994",
    "nom_corrige2": "Nathalie Jacob",
    "nom_famille": "Jacob",
    "titre_genre2": "Conseillère",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3995",
    "nom_corrige2": "Kim Mongrain",
    "nom_famille": "Mongrain",
    "titre_genre2": "Conseillère",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3996",
    "nom_corrige2": "Catherine Bourget",
    "nom_famille": "Bourget",
    "titre_genre2": "Conseillère",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3997",
    "nom_corrige2": "Michel Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseiller",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3998",
    "nom_corrige2": "Jocelyn Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "4336",
    "allocation": "2168",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6504",
    "ville": "Saint-Narcisse",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1884"
  },
  {
    "ID": "3999",
    "nom_corrige2": "Yvan Fréchette",
    "nom_famille": "Fréchette",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "500",
    "allocation2": "0",
    "total": "6500",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "4000",
    "nom_corrige2": "JEAN-MARC Benoît",
    "nom_famille": "Benoît",
    "titre_genre2": "Conseiller",
    "remuneration": "4333",
    "allocation": "2167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6500",
    "ville": "Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "889"
  },
  {
    "ID": "4001",
    "nom_corrige2": "Marcel Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "6496",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4002",
    "nom_corrige2": "Sylvain Lafrenaye",
    "nom_famille": "Lafrenaye",
    "titre_genre2": "Conseiller",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "714",
    "allocation2": "357",
    "total": "6490",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "4003",
    "nom_corrige2": "Guylaine Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4004",
    "nom_corrige2": "Sébastien Ricard",
    "nom_famille": "Ricard",
    "titre_genre2": "Conseiller",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4005",
    "nom_corrige2": "Myriam Arbour",
    "nom_famille": "Arbour",
    "titre_genre2": "Conseillère",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4006",
    "nom_corrige2": "Chantal Robichaud",
    "nom_famille": "Robichaud",
    "titre_genre2": "Conseillère",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4007",
    "nom_corrige2": "Danny Quesnel",
    "nom_famille": "Quesnel",
    "titre_genre2": "Conseiller",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4008",
    "nom_corrige2": "Catherine Venne",
    "nom_famille": "Venne",
    "titre_genre2": "Conseillère",
    "remuneration": "4322",
    "allocation": "2161",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6483",
    "ville": "Saint-Alexis",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1453"
  },
  {
    "ID": "4009",
    "nom_corrige2": "Mathieu Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseiller",
    "remuneration": "4552",
    "allocation": "1927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6479",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "4010",
    "nom_corrige2": "France Gignac",
    "nom_famille": "Gignac",
    "titre_genre2": "Conseillère",
    "remuneration": "4378",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6467",
    "ville": "Notre-Dame-du-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1034"
  },
  {
    "ID": "4011",
    "nom_corrige2": "Mario Biron",
    "nom_famille": "Biron",
    "titre_genre2": "Maire",
    "remuneration": "4311",
    "allocation": "2155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6466",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "4012",
    "nom_corrige2": "Colombe April",
    "nom_famille": "April",
    "titre_genre2": "Conseillère",
    "remuneration": "4309",
    "allocation": "2155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6464",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "4013",
    "nom_corrige2": "Jean-Pierre Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "4309",
    "allocation": "2155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6464",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "4014",
    "nom_corrige2": "Annie Lévesque-Lauzier",
    "nom_famille": "Lévesque-Lauzier",
    "titre_genre2": "Conseillère",
    "remuneration": "4309",
    "allocation": "2155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6464",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "4015",
    "nom_corrige2": "Bruno Gamache",
    "nom_famille": "Gamache",
    "titre_genre2": "Conseiller",
    "remuneration": "4309",
    "allocation": "2155",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6464",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "4016",
    "nom_corrige2": "GILBERT MARQUIS",
    "nom_famille": "MARQUIS",
    "titre_genre2": "Maire",
    "remuneration": "4413",
    "allocation": "2045",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6458",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "4017",
    "nom_corrige2": "Gaétan Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4018",
    "nom_corrige2": "Annie Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4019",
    "nom_corrige2": "Steve Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4020",
    "nom_corrige2": "Jean-François Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4021",
    "nom_corrige2": "Nancy Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseillère",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4022",
    "nom_corrige2": "Marie-Hélène Bouillon",
    "nom_famille": "Bouillon",
    "titre_genre2": "Conseillère",
    "remuneration": "4300",
    "allocation": "2150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6450",
    "ville": "Saint-Ulric",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1617"
  },
  {
    "ID": "4023",
    "nom_corrige2": "Lyne Dubuc",
    "nom_famille": "Dubuc",
    "titre_genre2": "Conseillère",
    "remuneration": "4296",
    "allocation": "2148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6444",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "4024",
    "nom_corrige2": "Gaetan Bastien",
    "nom_famille": "Bastien",
    "titre_genre2": "Conseiller",
    "remuneration": "4296",
    "allocation": "2148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6444",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "4025",
    "nom_corrige2": "Mario Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "4295",
    "allocation": "2148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6443",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "4026",
    "nom_corrige2": "René Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "4121",
    "allocation": "2061",
    "remuneration2": "176",
    "allocation2": "84",
    "total": "6442",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "4027",
    "nom_corrige2": "Éric Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseiller",
    "remuneration": "4143",
    "allocation": "1969",
    "remuneration2": "217",
    "allocation2": "109",
    "total": "6438",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "4028",
    "nom_corrige2": "Tom Thompson",
    "nom_famille": "Thompson",
    "titre_genre2": "Conseiller",
    "remuneration": "4289",
    "allocation": "2145",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6434",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "4029",
    "nom_corrige2": "Anthony Brown",
    "nom_famille": "Brown",
    "titre_genre2": "Conseiller",
    "remuneration": "4289",
    "allocation": "2145",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6434",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "4030",
    "nom_corrige2": "Jean-Pierre Arpin",
    "nom_famille": "Arpin",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "834",
    "allocation2": "417",
    "total": "6421",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4031",
    "nom_corrige2": "François Lupien",
    "nom_famille": "Lupien",
    "titre_genre2": "Conseiller",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6417",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "4032",
    "nom_corrige2": "Pierre Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6417",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "4033",
    "nom_corrige2": "Marie-Lyne Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseillère",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6417",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "4034",
    "nom_corrige2": "Éric Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "4278",
    "allocation": "2139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6417",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1036"
  },
  {
    "ID": "4035",
    "nom_corrige2": "Cindy Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseillère",
    "remuneration": "4277",
    "allocation": "2138",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6415",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4036",
    "nom_corrige2": "Aline Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "4277",
    "allocation": "2138",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6415",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4037",
    "nom_corrige2": "Simon Mayer",
    "nom_famille": "Mayer",
    "titre_genre2": "Conseiller",
    "remuneration": "4277",
    "allocation": "2138",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6415",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4038",
    "nom_corrige2": "Louise Peck",
    "nom_famille": "Peck",
    "titre_genre2": "Conseillère",
    "remuneration": "4273",
    "allocation": "2136",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6409",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "4039",
    "nom_corrige2": "Steven Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "4188",
    "allocation": "2215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6403",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "4040",
    "nom_corrige2": "Philippe Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "4188",
    "allocation": "2215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6403",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "4041",
    "nom_corrige2": "Patrick Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "4188",
    "allocation": "2215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6403",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "4042",
    "nom_corrige2": "Marie-Josée Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "4188",
    "allocation": "2215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6403",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "4043",
    "nom_corrige2": "Carl Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "4188",
    "allocation": "2215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6403",
    "ville": "Saint-Éphrem-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2420"
  },
  {
    "ID": "4044",
    "nom_corrige2": "Serge Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6400",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "4045",
    "nom_corrige2": "Patrick Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6400",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "4046",
    "nom_corrige2": "Sylvain T. Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseiller",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6400",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "4047",
    "nom_corrige2": "Georges Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseiller",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6400",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "4048",
    "nom_corrige2": "Jessyka Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseillère",
    "remuneration": "4267",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6400",
    "ville": "Saint-Flavien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1601"
  },
  {
    "ID": "4049",
    "nom_corrige2": "Claude Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4050",
    "nom_corrige2": "Nathalie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4051",
    "nom_corrige2": "Réal Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4052",
    "nom_corrige2": "Vital Dumais",
    "nom_famille": "Dumais",
    "titre_genre2": "Conseiller",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4053",
    "nom_corrige2": "Laurier Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4054",
    "nom_corrige2": "Josée Crane",
    "nom_famille": "Crane",
    "titre_genre2": "Conseillère",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Lac-Bouchette",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1169"
  },
  {
    "ID": "4055",
    "nom_corrige2": "Lison Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseillère",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "4056",
    "nom_corrige2": "Claude Archambault",
    "nom_famille": "Archambault",
    "titre_genre2": "Conseiller",
    "remuneration": "4266",
    "allocation": "2133",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6399",
    "ville": "Sainte-Pétronille",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1047"
  },
  {
    "ID": "4057",
    "nom_corrige2": "Félix Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Maire",
    "remuneration": "4259",
    "allocation": "2129",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6388",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "4058",
    "nom_corrige2": "Éric Hammal",
    "nom_famille": "Hammal",
    "titre_genre2": "Conseiller",
    "remuneration": "4258",
    "allocation": "2129",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6387",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "4059",
    "nom_corrige2": "Sophie Brasiola",
    "nom_famille": "Brasiola",
    "titre_genre2": "Conseillère",
    "remuneration": "4132",
    "allocation": "2244",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6376",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "4060",
    "nom_corrige2": "Marie-Josée Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseillère",
    "remuneration": "4250",
    "allocation": "2125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6375",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4061",
    "nom_corrige2": "Maryse Pagé",
    "nom_famille": "Pagé",
    "titre_genre2": "Conseillère",
    "remuneration": "4250",
    "allocation": "2125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6375",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4062",
    "nom_corrige2": "Anne-Marie Boudreau",
    "nom_famille": "Boudreau",
    "titre_genre2": "Conseillère",
    "remuneration": "4250",
    "allocation": "2125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6375",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4063",
    "nom_corrige2": "Marcel Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "3678",
    "allocation": "1839",
    "remuneration2": "571",
    "allocation2": "286",
    "total": "6374",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4064",
    "nom_corrige2": "Stéphane Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "4249",
    "allocation": "2124",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6373",
    "ville": "Bowman",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "703"
  },
  {
    "ID": "4065",
    "nom_corrige2": "Josseline  Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Mairesse",
    "remuneration": "4245",
    "allocation": "2122",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6367",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "4066",
    "nom_corrige2": "Léo Choquette",
    "nom_famille": "Choquette",
    "titre_genre2": "Conseiller",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "1006",
    "allocation2": "0",
    "total": "6359",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4067",
    "nom_corrige2": "Jean-Michel Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "4239",
    "allocation": "2119",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6358",
    "ville": "Saint-Édouard",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1402"
  },
  {
    "ID": "4068",
    "nom_corrige2": "Andy Maheux",
    "nom_famille": "Maheux",
    "titre_genre2": "Conseiller",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6345",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4069",
    "nom_corrige2": "René Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6345",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4070",
    "nom_corrige2": "Sonya Provost",
    "nom_famille": "Provost",
    "titre_genre2": "Conseillère",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6345",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4071",
    "nom_corrige2": "Mélanie Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseillère",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6345",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4072",
    "nom_corrige2": "Lucie Boulanger",
    "nom_famille": "Boulanger",
    "titre_genre2": "Conseillère",
    "remuneration": "4230",
    "allocation": "2115",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6345",
    "ville": "Frontenac",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1786"
  },
  {
    "ID": "4073",
    "nom_corrige2": "Pierre Reid",
    "nom_famille": "Reid",
    "titre_genre2": "Conseiller",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "600",
    "allocation2": "300",
    "total": "6345",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4074",
    "nom_corrige2": "Patrick Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4075",
    "nom_corrige2": "Simon Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseiller",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4076",
    "nom_corrige2": "Alexandre Lefrançois",
    "nom_famille": "Lefrançois",
    "titre_genre2": "Conseiller",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4077",
    "nom_corrige2": "Cydia Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4078",
    "nom_corrige2": "Johanne Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseillère",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4079",
    "nom_corrige2": "Marc LÉVESQUE",
    "nom_famille": "LÉVESQUE",
    "titre_genre2": "Conseiller",
    "remuneration": "4156",
    "allocation": "2186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6342",
    "ville": "Saint-Alexandre-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2339"
  },
  {
    "ID": "4080",
    "nom_corrige2": "Vincent Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "4227",
    "allocation": "2114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6341",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4081",
    "nom_corrige2": "Carl Boilard",
    "nom_famille": "Boilard",
    "titre_genre2": "Conseiller",
    "remuneration": "4227",
    "allocation": "2114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6341",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4082",
    "nom_corrige2": "Guylaine Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "4227",
    "allocation": "2114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6341",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4083",
    "nom_corrige2": "Dave Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "4227",
    "allocation": "2114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6341",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4084",
    "nom_corrige2": "Pierre Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "4227",
    "allocation": "2114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6341",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4085",
    "nom_corrige2": "Linda Cournoyer",
    "nom_famille": "Cournoyer",
    "titre_genre2": "Conseillère",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "642",
    "allocation2": "321",
    "total": "6337",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4086",
    "nom_corrige2": "Normand Litjens",
    "nom_famille": "Litjens",
    "titre_genre2": "Conseiller",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4087",
    "nom_corrige2": "Daniel Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseiller",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4088",
    "nom_corrige2": "Dany Duchesneau",
    "nom_famille": "Duchesneau",
    "titre_genre2": "Conseiller",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4089",
    "nom_corrige2": "Karen Crandall",
    "nom_famille": "Crandall",
    "titre_genre2": "Conseillère",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4090",
    "nom_corrige2": "Jennifer Merner",
    "nom_famille": "Merner",
    "titre_genre2": "Conseillère",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4091",
    "nom_corrige2": "Glenn Guthrie",
    "nom_famille": "Guthrie",
    "titre_genre2": "Conseiller",
    "remuneration": "4222",
    "allocation": "2110",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6332",
    "ville": "Saint-Armand",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1261"
  },
  {
    "ID": "4092",
    "nom_corrige2": "Chantal Melançon",
    "nom_famille": "Melançon",
    "titre_genre2": "Conseillère",
    "remuneration": "4218",
    "allocation": "2109",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6327",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "4093",
    "nom_corrige2": "Annie Verreault",
    "nom_famille": "Verreault",
    "titre_genre2": "Conseillère",
    "remuneration": "4877",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6325",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "4094",
    "nom_corrige2": "Danielle Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseillère",
    "remuneration": "4216",
    "allocation": "2108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6324",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4095",
    "nom_corrige2": "Yves Guérette",
    "nom_famille": "Guérette",
    "titre_genre2": "Conseiller",
    "remuneration": "3645",
    "allocation": "1822",
    "remuneration2": "571",
    "allocation2": "285",
    "total": "6323",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4096",
    "nom_corrige2": "André Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "4215",
    "allocation": "2108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6323",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "4097",
    "nom_corrige2": "Dany Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "4215",
    "allocation": "2108",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6323",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "4098",
    "nom_corrige2": "Marie-Danielle Hémond",
    "nom_famille": "Hémond",
    "titre_genre2": "Conseillère",
    "remuneration": "4300",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4099",
    "nom_corrige2": "Claude Beauchesne",
    "nom_famille": "Beauchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "4300",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4100",
    "nom_corrige2": "Sylvain Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4101",
    "nom_corrige2": "Philippe Verly",
    "nom_famille": "Verly",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4102",
    "nom_corrige2": "Raymond Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4103",
    "nom_corrige2": "Jonathan Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4104",
    "nom_corrige2": "Johanne Maurice",
    "nom_famille": "Maurice",
    "titre_genre2": "Conseillère",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4105",
    "nom_corrige2": "Gilles Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Maire",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "4106",
    "nom_corrige2": "Denis Bezeau",
    "nom_famille": "Bezeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4107",
    "nom_corrige2": "Eddy Boudreau",
    "nom_famille": "Boudreau",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6300",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4108",
    "nom_corrige2": "Eliott Levasseur",
    "nom_famille": "Levasseur",
    "titre_genre2": "Conseiller",
    "remuneration": "4199",
    "allocation": "2100",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6299",
    "ville": "Dégelis",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "2890"
  },
  {
    "ID": "4109",
    "nom_corrige2": "Josée Boulay",
    "nom_famille": "Boulay",
    "titre_genre2": "Conseillère",
    "remuneration": "4227",
    "allocation": "2063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6290",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4110",
    "nom_corrige2": "Nathalie Harton",
    "nom_famille": "Harton",
    "titre_genre2": "Conseillère",
    "remuneration": "3889",
    "allocation": "1944",
    "remuneration2": "303",
    "allocation2": "151",
    "total": "6287",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "4111",
    "nom_corrige2": "Jacques Damphousse",
    "nom_famille": "Damphousse",
    "titre_genre2": "Conseiller",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4112",
    "nom_corrige2": "Marco Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseiller",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4113",
    "nom_corrige2": "Jonathan Lacourse",
    "nom_famille": "Lacourse",
    "titre_genre2": "Conseiller",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4114",
    "nom_corrige2": "René Rinfret",
    "nom_famille": "Rinfret",
    "titre_genre2": "Conseiller",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4115",
    "nom_corrige2": "Carole Dumontier",
    "nom_famille": "Dumontier",
    "titre_genre2": "Conseillère",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4116",
    "nom_corrige2": "Robert Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Maire",
    "remuneration": "4183",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6274",
    "ville": "Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "2411"
  },
  {
    "ID": "4117",
    "nom_corrige2": "Soucy Chantal",
    "nom_famille": "Chantal",
    "titre_genre2": "Conseillère",
    "remuneration": "4182",
    "allocation": "2091",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6273",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4118",
    "nom_corrige2": "Francis Quirion",
    "nom_famille": "Quirion",
    "titre_genre2": "Conseiller",
    "remuneration": "4416",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6271",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "4119",
    "nom_corrige2": "Jean Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "550",
    "allocation2": "275",
    "total": "6270",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4120",
    "nom_corrige2": "Dominique Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "4178",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6267",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4121",
    "nom_corrige2": "Nancy Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "4219",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4122",
    "nom_corrige2": "Jonathan Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4123",
    "nom_corrige2": "Michel Massé",
    "nom_famille": "Massé",
    "titre_genre2": "Conseiller",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4124",
    "nom_corrige2": "Pierre Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseiller",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4125",
    "nom_corrige2": "Lynda Cusson",
    "nom_famille": "Cusson",
    "titre_genre2": "Conseillère",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4126",
    "nom_corrige2": "Mélanie Valois",
    "nom_famille": "Valois",
    "titre_genre2": "Conseillère",
    "remuneration": "4177",
    "allocation": "2089",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6266",
    "ville": "Roxton Falls",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4127",
    "nom_corrige2": "Normand Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "4235",
    "allocation": "2030",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6265",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4128",
    "nom_corrige2": "Denis V. Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "4817",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6265",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "4129",
    "nom_corrige2": "Marilyne Pichette",
    "nom_famille": "Pichette",
    "titre_genre2": "Conseillère",
    "remuneration": "4172",
    "allocation": "2086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6258",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "4130",
    "nom_corrige2": "Martin Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Conseiller",
    "remuneration": "4108",
    "allocation": "2053",
    "remuneration2": "64",
    "allocation2": "32",
    "total": "6257",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "4131",
    "nom_corrige2": "Denis Courte",
    "nom_famille": "Courte",
    "titre_genre2": "Conseiller",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6255",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "4132",
    "nom_corrige2": "Richard Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6255",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "4133",
    "nom_corrige2": "Suzanne Dyotte",
    "nom_famille": "Dyotte",
    "titre_genre2": "Conseillère",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6255",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "4134",
    "nom_corrige2": "Huguette Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6255",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "4135",
    "nom_corrige2": "Edith Crevier",
    "nom_famille": "Crevier",
    "titre_genre2": "Conseillère",
    "remuneration": "4170",
    "allocation": "2085",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6255",
    "ville": "Montcalm",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "642"
  },
  {
    "ID": "4136",
    "nom_corrige2": "Valérie Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "4249",
    "allocation": "2002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6251",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "4137",
    "nom_corrige2": "Janic Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseiller",
    "remuneration": "4249",
    "allocation": "2002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6251",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "4138",
    "nom_corrige2": "Nada Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseillère",
    "remuneration": "4249",
    "allocation": "2002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6251",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "4139",
    "nom_corrige2": "Guillaume Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "4249",
    "allocation": "2002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6251",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "4140",
    "nom_corrige2": "Marie-Chantal Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "4249",
    "allocation": "2002",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6251",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "4141",
    "nom_corrige2": "Marcel Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Maire",
    "remuneration": "4167",
    "allocation": "2083",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6250",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "4142",
    "nom_corrige2": "Dany Drolet",
    "nom_famille": "Drolet",
    "titre_genre2": "Conseillère",
    "remuneration": "3833",
    "allocation": "1917",
    "remuneration2": "500",
    "allocation2": "0",
    "total": "6250",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "4143",
    "nom_corrige2": "Kathleen Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseillère",
    "remuneration": "4320",
    "allocation": "1927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6247",
    "ville": "Saint-Nazaire",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2136"
  },
  {
    "ID": "4144",
    "nom_corrige2": "Margarita Lafontaine",
    "nom_famille": "Lafontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "4162",
    "allocation": "2081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6243",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "4145",
    "nom_corrige2": "Loren Allen",
    "nom_famille": "Allen",
    "titre_genre2": "Conseiller",
    "remuneration": "4162",
    "allocation": "2081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6243",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "4146",
    "nom_corrige2": "Eddy Whitcher",
    "nom_famille": "Whitcher",
    "titre_genre2": "Conseiller",
    "remuneration": "4162",
    "allocation": "2081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6243",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "4147",
    "nom_corrige2": "Gilles Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseiller",
    "remuneration": "4162",
    "allocation": "2081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6243",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "4148",
    "nom_corrige2": "Nancy Lanteigne",
    "nom_famille": "Lanteigne",
    "titre_genre2": "Conseillère",
    "remuneration": "4162",
    "allocation": "2081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6243",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "4149",
    "nom_corrige2": "Stéphane Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "4268",
    "allocation": "1969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6237",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "4150",
    "nom_corrige2": "Marie-Soleil Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseillère",
    "remuneration": "4154",
    "allocation": "2077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6231",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4151",
    "nom_corrige2": "Edwin Bond",
    "nom_famille": "Bond",
    "titre_genre2": "Conseiller",
    "remuneration": "4150",
    "allocation": "2075",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6225",
    "ville": "Rivière-au-Tonnerre",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "270"
  },
  {
    "ID": "4152",
    "nom_corrige2": "Dominique Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Conseillère",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4153",
    "nom_corrige2": "Henri-Paul Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4154",
    "nom_corrige2": "Martin Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseiller",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4155",
    "nom_corrige2": "Robert Blackburn",
    "nom_famille": "Blackburn",
    "titre_genre2": "Conseiller",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4156",
    "nom_corrige2": "Sophie Desportes",
    "nom_famille": "Desportes",
    "titre_genre2": "Conseillère",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4157",
    "nom_corrige2": "Adrien Belkin",
    "nom_famille": "Belkin",
    "titre_genre2": "Conseiller",
    "remuneration": "4148",
    "allocation": "2074",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6222",
    "ville": "Saint-Fulgence",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "2184"
  },
  {
    "ID": "4158",
    "nom_corrige2": "MICHÈLE FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseillère",
    "remuneration": "4169",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6216",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4159",
    "nom_corrige2": "Bertrand Bombardier",
    "nom_famille": "Bombardier",
    "titre_genre2": "Conseiller",
    "remuneration": "3636",
    "allocation": "1818",
    "remuneration2": "500",
    "allocation2": "250",
    "total": "6204",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "4160",
    "nom_corrige2": "Richard Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseiller",
    "remuneration": "4200",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6200",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4161",
    "nom_corrige2": "Guylaine Labbée",
    "nom_famille": "Labbée",
    "titre_genre2": "Mairesse",
    "remuneration": "4132",
    "allocation": "2066",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6198",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "4162",
    "nom_corrige2": "Mariette Sallafranque",
    "nom_famille": "Sallafranque",
    "titre_genre2": "Conseillère",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4163",
    "nom_corrige2": "Patrick Fleming",
    "nom_famille": "Fleming",
    "titre_genre2": "Conseiller",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4164",
    "nom_corrige2": "Ivan Schryer",
    "nom_famille": "Schryer",
    "titre_genre2": "Conseiller",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4165",
    "nom_corrige2": "Nancy McGuire",
    "nom_famille": "McGuire",
    "titre_genre2": "Conseillère",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4166",
    "nom_corrige2": "Brian Adam",
    "nom_famille": "Adam",
    "titre_genre2": "Conseiller",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4167",
    "nom_corrige2": "Robert Chafe",
    "nom_famille": "Chafe",
    "titre_genre2": "Conseiller",
    "remuneration": "4128",
    "allocation": "2064",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6192",
    "ville": "L'Isle-aux-Allumettes",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1338"
  },
  {
    "ID": "4168",
    "nom_corrige2": "Patricia Cox",
    "nom_famille": "Cox",
    "titre_genre2": "Conseillère",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4169",
    "nom_corrige2": "Michel Labrosse",
    "nom_famille": "Labrosse",
    "titre_genre2": "Conseiller",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4170",
    "nom_corrige2": "Claude Carrière",
    "nom_famille": "Carrière",
    "titre_genre2": "Conseiller",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4171",
    "nom_corrige2": "Marie Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4172",
    "nom_corrige2": "Jody Arzberger",
    "nom_famille": "Arzberger",
    "titre_genre2": "Conseillère",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4173",
    "nom_corrige2": "Pierre Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "4123",
    "allocation": "2062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6185",
    "ville": "Kipawa",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "461"
  },
  {
    "ID": "4174",
    "nom_corrige2": "Isabelle Marissal",
    "nom_famille": "Marissal",
    "titre_genre2": "Conseillère",
    "remuneration": "4121",
    "allocation": "2061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6182",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "4175",
    "nom_corrige2": "Céline Delorme Picken",
    "nom_famille": "Delorme",
    "titre_genre2": "Conseillère",
    "remuneration": "4121",
    "allocation": "2061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6182",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "4176",
    "nom_corrige2": "Julie Royer",
    "nom_famille": "Royer",
    "titre_genre2": "Conseillère",
    "remuneration": "4121",
    "allocation": "2061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6182",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "4177",
    "nom_corrige2": "Jo­ël Chagnon",
    "nom_famille": "Chagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "4121",
    "allocation": "2061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6182",
    "ville": "Stukely-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1209"
  },
  {
    "ID": "4178",
    "nom_corrige2": "Pauline Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4179",
    "nom_corrige2": "Isabelle Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseillère",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4180",
    "nom_corrige2": "Matthieu Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4181",
    "nom_corrige2": "André Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseiller",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4182",
    "nom_corrige2": "Marie-Ève Marcotte-Bussières",
    "nom_famille": "Marcotte-Bussières",
    "titre_genre2": "Conseillère",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4183",
    "nom_corrige2": "Camil Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseiller",
    "remuneration": "4116",
    "allocation": "2058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6174",
    "ville": "Val-Alain",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1012"
  },
  {
    "ID": "4184",
    "nom_corrige2": "Nathalie Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseillère",
    "remuneration": "4107",
    "allocation": "2061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6168",
    "ville": "North Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "690"
  },
  {
    "ID": "4185",
    "nom_corrige2": "Virginie Plumier",
    "nom_famille": "Plumier",
    "titre_genre2": "Conseillère",
    "remuneration": "4110",
    "allocation": "2055",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6165",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4186",
    "nom_corrige2": "Nathalie Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseillère",
    "remuneration": "4110",
    "allocation": "2055",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6165",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4187",
    "nom_corrige2": "Amélie Croteau",
    "nom_famille": "Croteau",
    "titre_genre2": "Conseillère",
    "remuneration": "4108",
    "allocation": "2053",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6161",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "4188",
    "nom_corrige2": "Steve Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "4108",
    "allocation": "2053",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6161",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "4189",
    "nom_corrige2": "Sébastien St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "4108",
    "allocation": "2053",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6161",
    "ville": "Chesterville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "945"
  },
  {
    "ID": "4190",
    "nom_corrige2": "Jacques Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "660",
    "allocation2": "330",
    "total": "6160",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4191",
    "nom_corrige2": "Catherine-Rose Laforest",
    "nom_famille": "Laforest",
    "titre_genre2": "Conseillère",
    "remuneration": "3852",
    "allocation": "2307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6159",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "4192",
    "nom_corrige2": "Marc Bussières",
    "nom_famille": "Bussières",
    "titre_genre2": "Conseiller",
    "remuneration": "4150",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6150",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4193",
    "nom_corrige2": "Rosanne Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseillère",
    "remuneration": "4094",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6141",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "4194",
    "nom_corrige2": "Marc Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "4094",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6141",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "4195",
    "nom_corrige2": "Vincent Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4094",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6141",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "4196",
    "nom_corrige2": "Daniel Smith",
    "nom_famille": "Smith",
    "titre_genre2": "Conseiller",
    "remuneration": "4093",
    "allocation": "2046",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6139",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "4197",
    "nom_corrige2": "Robert Charron",
    "nom_famille": "Charron",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "643",
    "allocation2": "321",
    "total": "6134",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4198",
    "nom_corrige2": "Alexandre Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseiller",
    "remuneration": "3224",
    "allocation": "1612",
    "remuneration2": "864",
    "allocation2": "432",
    "total": "6132",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4199",
    "nom_corrige2": "Helene Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseillère",
    "remuneration": "4211",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6129",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4200",
    "nom_corrige2": "Sylvie Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Conseillère",
    "remuneration": "4084",
    "allocation": "2041",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6125",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "4201",
    "nom_corrige2": "Éric Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "4081",
    "allocation": "2040",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6121",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4202",
    "nom_corrige2": "Valerie Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseillère",
    "remuneration": "4078",
    "allocation": "2039",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6117",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "4203",
    "nom_corrige2": "Lyne Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseillère",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4204",
    "nom_corrige2": "Rosaire Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4205",
    "nom_corrige2": "Stéphanie Vallée",
    "nom_famille": "Vallée",
    "titre_genre2": "Conseillère",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4206",
    "nom_corrige2": "Véronique Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseillère",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4207",
    "nom_corrige2": "François Boilard",
    "nom_famille": "Boilard",
    "titre_genre2": "Conseiller",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4208",
    "nom_corrige2": "Michel Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "4584",
    "allocation": "1528",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6112",
    "ville": "Saint-Fortunat",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "284"
  },
  {
    "ID": "4209",
    "nom_corrige2": "Nicolas Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "4064",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6111",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "4210",
    "nom_corrige2": "Éric Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseiller",
    "remuneration": "4064",
    "allocation": "2047",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6111",
    "ville": "Saint-Gervais",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2171"
  },
  {
    "ID": "4211",
    "nom_corrige2": "Lilian Steudler",
    "nom_famille": "Steudler",
    "titre_genre2": "Conseillère",
    "remuneration": "4070",
    "allocation": "2034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6104",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "4212",
    "nom_corrige2": "Michel Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "4070",
    "allocation": "2034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6104",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "4213",
    "nom_corrige2": "Adrien Steudler",
    "nom_famille": "Steudler",
    "titre_genre2": "Conseiller",
    "remuneration": "4070",
    "allocation": "2034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6104",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "4214",
    "nom_corrige2": "Nicolas Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "4070",
    "allocation": "2034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6104",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "4215",
    "nom_corrige2": "Louise Lafrance Lecours",
    "nom_famille": "Lafrance",
    "titre_genre2": "Conseillère",
    "remuneration": "4070",
    "allocation": "2034",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6104",
    "ville": "Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1426"
  },
  {
    "ID": "4216",
    "nom_corrige2": "Krystèle Boilard",
    "nom_famille": "Boilard",
    "titre_genre2": "Conseillère",
    "remuneration": "4100",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6100",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4217",
    "nom_corrige2": "Jacques Besner",
    "nom_famille": "Besner",
    "titre_genre2": "Conseiller",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4218",
    "nom_corrige2": "Marie-Andrée Clermont",
    "nom_famille": "Clermont",
    "titre_genre2": "Conseillère",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4219",
    "nom_corrige2": "Jacques Pilon",
    "nom_famille": "Pilon",
    "titre_genre2": "Conseiller",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4220",
    "nom_corrige2": "Josée Farand",
    "nom_famille": "Farand",
    "titre_genre2": "Conseillère",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4221",
    "nom_corrige2": "Denise Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4222",
    "nom_corrige2": "Manon Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseillère",
    "remuneration": "4063",
    "allocation": "2032",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6095",
    "ville": "Saint-Clet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1898"
  },
  {
    "ID": "4223",
    "nom_corrige2": "Line Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4224",
    "nom_corrige2": "Laval Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4225",
    "nom_corrige2": "Sonia Lehoux",
    "nom_famille": "Lehoux",
    "titre_genre2": "Conseillère",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4226",
    "nom_corrige2": "Gilbert Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4227",
    "nom_corrige2": "Steve Houley",
    "nom_famille": "Houley",
    "titre_genre2": "Conseiller",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4228",
    "nom_corrige2": "Eric Gobeil",
    "nom_famille": "Gobeil",
    "titre_genre2": "Conseiller",
    "remuneration": "4046",
    "allocation": "2023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6069",
    "ville": "Saint-Sylvestre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1011"
  },
  {
    "ID": "4229",
    "nom_corrige2": "Marianne Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "4042",
    "allocation": "2021",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6063",
    "ville": "Valcourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1071"
  },
  {
    "ID": "4230",
    "nom_corrige2": "Michel Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "4136",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6054",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4231",
    "nom_corrige2": "Michel Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "3785",
    "allocation": "1893",
    "remuneration2": "375",
    "allocation2": "0",
    "total": "6053",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4232",
    "nom_corrige2": "Jacques Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "4050",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6050",
    "ville": "Saint-Norbert-d'Arthabaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1248"
  },
  {
    "ID": "4233",
    "nom_corrige2": "Mélanie Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "400",
    "allocation2": "200",
    "total": "6045",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4234",
    "nom_corrige2": "Lorraine Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "4028",
    "allocation": "2014",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6042",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "4235",
    "nom_corrige2": "Marie Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseillère",
    "remuneration": "4028",
    "allocation": "2014",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6042",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "4236",
    "nom_corrige2": "Yves Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "4028",
    "allocation": "2014",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6042",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "4237",
    "nom_corrige2": "Léo-Paul Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "4028",
    "allocation": "2014",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6042",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "4238",
    "nom_corrige2": "Rémi Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "4028",
    "allocation": "2014",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6042",
    "ville": "Rivière-Ouelle",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "995"
  },
  {
    "ID": "4239",
    "nom_corrige2": "Carol Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Maire",
    "remuneration": "4021",
    "allocation": "2010",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6031",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "4240",
    "nom_corrige2": "Mario St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "4020",
    "allocation": "2010",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6030",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4241",
    "nom_corrige2": "Cynthia St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseillère",
    "remuneration": "4010",
    "allocation": "2005",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6015",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4242",
    "nom_corrige2": "Jean-Philippe Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseiller",
    "remuneration": "4010",
    "allocation": "2005",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6015",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4243",
    "nom_corrige2": "François Légaré",
    "nom_famille": "Légaré",
    "titre_genre2": "Conseiller",
    "remuneration": "4043",
    "allocation": "1969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "4244",
    "nom_corrige2": "Pascal Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4245",
    "nom_corrige2": "Bernard Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4246",
    "nom_corrige2": "Suzanne Larouche",
    "nom_famille": "Larouche",
    "titre_genre2": "Conseillère",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4247",
    "nom_corrige2": "Jacques Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4248",
    "nom_corrige2": "Jonathan Boily",
    "nom_famille": "Boily",
    "titre_genre2": "Conseiller",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4249",
    "nom_corrige2": "Bruno Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseiller",
    "remuneration": "4008",
    "allocation": "2004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6012",
    "ville": "Sainte-Monique",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "866"
  },
  {
    "ID": "4250",
    "nom_corrige2": "Daniel Arteau",
    "nom_famille": "Arteau",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Lac-Sergent",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "549"
  },
  {
    "ID": "4251",
    "nom_corrige2": "Thomas-Louis Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4252",
    "nom_corrige2": "Marco Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4253",
    "nom_corrige2": "Monique Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4254",
    "nom_corrige2": "Danick Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4255",
    "nom_corrige2": "Rémi Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4256",
    "nom_corrige2": "James Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "4000",
    "allocation": "2000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "6000",
    "ville": "Saint-Aimé-des-Lacs",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1113"
  },
  {
    "ID": "4257",
    "nom_corrige2": "Hugo Berthiaume",
    "nom_famille": "Berthiaume",
    "titre_genre2": "Conseiller",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "225",
    "allocation2": "113",
    "total": "5996",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4258",
    "nom_corrige2": "Jean-Claude Drolet",
    "nom_famille": "Drolet",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "550",
    "allocation2": "275",
    "total": "5995",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4259",
    "nom_corrige2": "Gilles Daraîche",
    "nom_famille": "Daraîche",
    "titre_genre2": "Conseiller",
    "remuneration": "4911",
    "allocation": "1084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5995",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "4260",
    "nom_corrige2": "Jean-Claude Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "3986",
    "allocation": "1993",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5979",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4261",
    "nom_corrige2": "Alexandre Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "3977",
    "allocation": "1989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5966",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "4262",
    "nom_corrige2": "Frédéric Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Conseiller",
    "remuneration": "3977",
    "allocation": "1989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5966",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "4263",
    "nom_corrige2": "Jean Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "3977",
    "allocation": "1989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5966",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "4264",
    "nom_corrige2": "Élisabeth Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseillère",
    "remuneration": "3977",
    "allocation": "1989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5966",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "4265",
    "nom_corrige2": "Sandrine Reix",
    "nom_famille": "Reix",
    "titre_genre2": "Conseillère",
    "remuneration": "3977",
    "allocation": "1989",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5966",
    "ville": "Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1196"
  },
  {
    "ID": "4266",
    "nom_corrige2": "Rémi Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Maire",
    "remuneration": "3977",
    "allocation": "1988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5965",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "4267",
    "nom_corrige2": "Vicky Boily",
    "nom_famille": "Boily",
    "titre_genre2": "Conseillère",
    "remuneration": "3962",
    "allocation": "1990",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5952",
    "ville": "Larouche",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1676"
  },
  {
    "ID": "4268",
    "nom_corrige2": "Vincent Delorme",
    "nom_famille": "Delorme",
    "titre_genre2": "Conseiller",
    "remuneration": "3964",
    "allocation": "1982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5946",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "4269",
    "nom_corrige2": "Harold Wubbolts",
    "nom_famille": "Wubbolts",
    "titre_genre2": "Conseiller",
    "remuneration": "3956",
    "allocation": "1978",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5934",
    "ville": "Ripon",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "1759"
  },
  {
    "ID": "4270",
    "nom_corrige2": "Adrienne Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseillère",
    "remuneration": "3951",
    "allocation": "1976",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5927",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "4271",
    "nom_corrige2": "Jean-Sébastien Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseiller",
    "remuneration": "3942",
    "allocation": "1971",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5913",
    "ville": "Hatley",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "781"
  },
  {
    "ID": "4272",
    "nom_corrige2": "Pascal Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "3943",
    "allocation": "1969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5912",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "4273",
    "nom_corrige2": "Alexandra Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseillère",
    "remuneration": "3940",
    "allocation": "1970",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5910",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4274",
    "nom_corrige2": "Marcelle Trottier",
    "nom_famille": "Trottier",
    "titre_genre2": "Conseillère",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "660",
    "allocation2": "340",
    "total": "5875",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4275",
    "nom_corrige2": "Suzette de Rome",
    "nom_famille": "de",
    "titre_genre2": "Conseillère",
    "remuneration": "3924",
    "allocation": "1944",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5868",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "4276",
    "nom_corrige2": "Yannick Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseiller",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4277",
    "nom_corrige2": "Denis Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4278",
    "nom_corrige2": "Marie-Christine Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4279",
    "nom_corrige2": "Dave Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4280",
    "nom_corrige2": "Marie-Ève Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4281",
    "nom_corrige2": "Robin Cotnoir",
    "nom_famille": "Cotnoir",
    "titre_genre2": "Conseiller",
    "remuneration": "3886",
    "allocation": "1943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5829",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4282",
    "nom_corrige2": "Denis Naud",
    "nom_famille": "Naud",
    "titre_genre2": "Conseiller",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "826",
    "allocation2": "413",
    "total": "5817",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4283",
    "nom_corrige2": "Nathalie Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseillère",
    "remuneration": "3864",
    "allocation": "1932",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5796",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "4284",
    "nom_corrige2": "Douglas Morrison",
    "nom_famille": "Morrison",
    "titre_genre2": "Conseiller",
    "remuneration": "3858",
    "allocation": "1929",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5787",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "4285",
    "nom_corrige2": "Gilles Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseiller",
    "remuneration": "3850",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5775",
    "ville": "Val-Joli",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1676"
  },
  {
    "ID": "4286",
    "nom_corrige2": "Lyne Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "3987",
    "allocation": "1776",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5763",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "4287",
    "nom_corrige2": "Yvan Bordeleau",
    "nom_famille": "Bordeleau",
    "titre_genre2": "Conseiller",
    "remuneration": "3836",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5754",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4288",
    "nom_corrige2": "Éloi Champigny",
    "nom_famille": "Champigny",
    "titre_genre2": "Conseiller",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5745",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "4289",
    "nom_corrige2": "Diane Daigneault",
    "nom_famille": "Daigneault",
    "titre_genre2": "Conseillère",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5745",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "4290",
    "nom_corrige2": "Jean-François Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5745",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "4291",
    "nom_corrige2": "Daniel Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5745",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "4292",
    "nom_corrige2": "Jérémie Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "3830",
    "allocation": "1915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5745",
    "ville": "Saint-Théodore-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1645"
  },
  {
    "ID": "4293",
    "nom_corrige2": "ROBERT SANFAÇON",
    "nom_famille": "SANFAÇON",
    "titre_genre2": "Conseiller",
    "remuneration": "3828",
    "allocation": "1914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5742",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4294",
    "nom_corrige2": "Lise Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseillère",
    "remuneration": "3827",
    "allocation": "1914",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5741",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "4295",
    "nom_corrige2": "Denis Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "3826",
    "allocation": "1913",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5739",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "4296",
    "nom_corrige2": "Catherine Després",
    "nom_famille": "Després",
    "titre_genre2": "Conseillère",
    "remuneration": "3826",
    "allocation": "1913",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5739",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "4297",
    "nom_corrige2": "Véronique Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseillère",
    "remuneration": "3826",
    "allocation": "1913",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5739",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "4298",
    "nom_corrige2": "Alexandre Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "3826",
    "allocation": "1913",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5739",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "4299",
    "nom_corrige2": "David Roux",
    "nom_famille": "Roux",
    "titre_genre2": "Conseiller",
    "remuneration": "3815",
    "allocation": "1907",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5722",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "4300",
    "nom_corrige2": "Myriam Falcon",
    "nom_famille": "Falcon",
    "titre_genre2": "Conseillère",
    "remuneration": "3971",
    "allocation": "1748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5719",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "4301",
    "nom_corrige2": "CHRISTIAN CARON",
    "nom_famille": "CARON",
    "titre_genre2": "Conseiller",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4302",
    "nom_corrige2": "ÉMILIE GARNEAU",
    "nom_famille": "GARNEAU",
    "titre_genre2": "Conseillère",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4303",
    "nom_corrige2": "FRANCIS MARCOTTE",
    "nom_famille": "MARCOTTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4304",
    "nom_corrige2": "CARMEN MARQUIS",
    "nom_famille": "MARQUIS",
    "titre_genre2": "Conseillère",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4305",
    "nom_corrige2": "JULIE QUINTIN",
    "nom_famille": "QUINTIN",
    "titre_genre2": "Conseillère",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4306",
    "nom_corrige2": "DENIS PICHÉ",
    "nom_famille": "PICHÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "3765",
    "allocation": "1948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5713",
    "ville": "Saint-Alban",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1224"
  },
  {
    "ID": "4307",
    "nom_corrige2": "Steeve Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4308",
    "nom_corrige2": "Yvan Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseiller",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4309",
    "nom_corrige2": "Lindsay Woo",
    "nom_famille": "Woo",
    "titre_genre2": "Conseillère",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4310",
    "nom_corrige2": "Marie-Claude Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseillère",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4311",
    "nom_corrige2": "Roger Noel",
    "nom_famille": "Noel",
    "titre_genre2": "Conseiller",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4312",
    "nom_corrige2": "Benoit Jr. Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseiller",
    "remuneration": "3807",
    "allocation": "1904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5711",
    "ville": "Saint-Philémon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "719"
  },
  {
    "ID": "4313",
    "nom_corrige2": "Sylvain Thibodeau",
    "nom_famille": "Thibodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4314",
    "nom_corrige2": "Francis Cliche",
    "nom_famille": "Cliche",
    "titre_genre2": "Conseiller",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4315",
    "nom_corrige2": "Thérèse Ménard Monty",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseillère",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4316",
    "nom_corrige2": "François Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseiller",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4317",
    "nom_corrige2": "Florian Ruckstuhl",
    "nom_famille": "Ruckstuhl",
    "titre_genre2": "Conseiller",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4318",
    "nom_corrige2": "Vicky Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseillère",
    "remuneration": "3806",
    "allocation": "1902",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5708",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1135"
  },
  {
    "ID": "4319",
    "nom_corrige2": "Carole Bourgeois",
    "nom_famille": "Bourgeois",
    "titre_genre2": "Conseillère",
    "remuneration": "3802",
    "allocation": "1901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5703",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "4320",
    "nom_corrige2": "Sylvie Leblond",
    "nom_famille": "Leblond",
    "titre_genre2": "Conseillère",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "155",
    "allocation2": "77",
    "total": "5701",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4321",
    "nom_corrige2": "LUC DUVAL",
    "nom_famille": "DUVAL",
    "titre_genre2": "Conseiller",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "381",
    "allocation2": "254",
    "total": "5700",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "4322",
    "nom_corrige2": "Rachel Fahlman",
    "nom_famille": "Fahlman",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "200",
    "allocation2": "500",
    "total": "5700",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "4323",
    "nom_corrige2": "Chantal St-Cyr",
    "nom_famille": "St-Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "2000",
    "remuneration2": "200",
    "allocation2": "500",
    "total": "5700",
    "ville": "Saint-Zéphirin-de-Courval",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "715"
  },
  {
    "ID": "4324",
    "nom_corrige2": "Frédéric Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "3800",
    "allocation": "1900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5700",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4325",
    "nom_corrige2": "Thérèse Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4326",
    "nom_corrige2": "Véronique Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Conseillère",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4327",
    "nom_corrige2": "Christiane Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4328",
    "nom_corrige2": "Lyne Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseillère",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4329",
    "nom_corrige2": "Yves Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4330",
    "nom_corrige2": "Claudine Marquis",
    "nom_famille": "Marquis",
    "titre_genre2": "Conseillère",
    "remuneration": "3793",
    "allocation": "1897",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5690",
    "ville": "Rivière-Bleue",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1246"
  },
  {
    "ID": "4331",
    "nom_corrige2": "Stéphane Lehoux",
    "nom_famille": "Lehoux",
    "titre_genre2": "Conseiller",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4332",
    "nom_corrige2": "Alain Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4333",
    "nom_corrige2": "Shirley McInnes",
    "nom_famille": "McInnes",
    "titre_genre2": "Conseillère",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4334",
    "nom_corrige2": "Sylvie Lehoux",
    "nom_famille": "Lehoux",
    "titre_genre2": "Conseillère",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4335",
    "nom_corrige2": "Tiffany Butler",
    "nom_famille": "Butler",
    "titre_genre2": "Conseillère",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4336",
    "nom_corrige2": "Johanne Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3772",
    "allocation": "1886",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5658",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "2699"
  },
  {
    "ID": "4337",
    "nom_corrige2": "JOANNE LABRANCHE",
    "nom_famille": "LABRANCHE",
    "titre_genre2": "Conseillère",
    "remuneration": "3761",
    "allocation": "1881",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5642",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4338",
    "nom_corrige2": "Frédéric Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "3760",
    "allocation": "1880",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5640",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "4339",
    "nom_corrige2": "Yvan Tardif",
    "nom_famille": "Tardif",
    "titre_genre2": "Conseiller",
    "remuneration": "3760",
    "allocation": "1880",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5640",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "4340",
    "nom_corrige2": "Claudia Labrie",
    "nom_famille": "Labrie",
    "titre_genre2": "Conseillère",
    "remuneration": "3760",
    "allocation": "1880",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5640",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "4341",
    "nom_corrige2": "Guy Marcoux",
    "nom_famille": "Marcoux",
    "titre_genre2": "Conseiller",
    "remuneration": "3760",
    "allocation": "1880",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5640",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "4342",
    "nom_corrige2": "Martin Thibeault",
    "nom_famille": "Thibeault",
    "titre_genre2": "Conseiller",
    "remuneration": "3754",
    "allocation": "1877",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5631",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "4343",
    "nom_corrige2": "Marilyne Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseillère",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "120",
    "allocation2": "60",
    "total": "5625",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4344",
    "nom_corrige2": "Alain Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Maire",
    "remuneration": "3898",
    "allocation": "1492",
    "remuneration2": "231",
    "allocation2": "0",
    "total": "5621",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "4345",
    "nom_corrige2": "Sabrina Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseillère",
    "remuneration": "3887",
    "allocation": "1726",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5613",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "4346",
    "nom_corrige2": "Suzanne Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "4157",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5605",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "4347",
    "nom_corrige2": "Suzanne Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseillère",
    "remuneration": "3789",
    "allocation": "1808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5597",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "4348",
    "nom_corrige2": "Guylaine Napert",
    "nom_famille": "Napert",
    "titre_genre2": "Conseillère",
    "remuneration": "3789",
    "allocation": "1808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5597",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "4349",
    "nom_corrige2": "Emmanuel Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseiller",
    "remuneration": "3789",
    "allocation": "1808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5597",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "4350",
    "nom_corrige2": "Allan McCaffrey",
    "nom_famille": "McCaffrey",
    "titre_genre2": "Conseiller",
    "remuneration": "3789",
    "allocation": "1808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5597",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "4351",
    "nom_corrige2": "Daniel Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "3789",
    "allocation": "1808",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5597",
    "ville": "Sainte-Agathe-de-Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1148"
  },
  {
    "ID": "4352",
    "nom_corrige2": "Véronique Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseillère",
    "remuneration": "3676",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5594",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4353",
    "nom_corrige2": "Isabelle Clément",
    "nom_famille": "Clément",
    "titre_genre2": "Conseillère",
    "remuneration": "3676",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5594",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4354",
    "nom_corrige2": "Diane Jacob",
    "nom_famille": "Jacob",
    "titre_genre2": "Conseillère",
    "remuneration": "3676",
    "allocation": "1918",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5594",
    "ville": "Hérouxville",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1409"
  },
  {
    "ID": "4355",
    "nom_corrige2": "Pierre Brunelle",
    "nom_famille": "Brunelle",
    "titre_genre2": "Conseiller",
    "remuneration": "3725",
    "allocation": "1863",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5588",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4356",
    "nom_corrige2": "Jean-Sébastien Savaria",
    "nom_famille": "Savaria",
    "titre_genre2": "Conseiller",
    "remuneration": "3678",
    "allocation": "1839",
    "remuneration2": "36",
    "allocation2": "18",
    "total": "5571",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4357",
    "nom_corrige2": "Anolise Brault",
    "nom_famille": "Brault",
    "titre_genre2": "Conseillère",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "100",
    "allocation2": "50",
    "total": "5569",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "4358",
    "nom_corrige2": "Sylvie Deblois",
    "nom_famille": "Deblois",
    "titre_genre2": "Conseillère",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4359",
    "nom_corrige2": "Bruno Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4360",
    "nom_corrige2": "Yves Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4361",
    "nom_corrige2": "Jean-Baptiste Alagnoux",
    "nom_famille": "Alagnoux",
    "titre_genre2": "Conseiller",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4362",
    "nom_corrige2": "Marc-Antoine Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4363",
    "nom_corrige2": "Richard Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "3710",
    "allocation": "1855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5565",
    "ville": "Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "921"
  },
  {
    "ID": "4364",
    "nom_corrige2": "Jean-François Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "3707",
    "allocation": "1853",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5560",
    "ville": "Saint-Rosaire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "915"
  },
  {
    "ID": "4365",
    "nom_corrige2": "Marie-Hélène Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseillère",
    "remuneration": "3509",
    "allocation": "1754",
    "remuneration2": "190",
    "allocation2": "95",
    "total": "5548",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4366",
    "nom_corrige2": "Yan Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "3842",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5545",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "4367",
    "nom_corrige2": "CARL DUBOIS",
    "nom_famille": "DUBOIS",
    "titre_genre2": "Conseiller",
    "remuneration": "3695",
    "allocation": "1847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5542",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4368",
    "nom_corrige2": "MARISOL BROCHU",
    "nom_famille": "BROCHU",
    "titre_genre2": "Conseillère",
    "remuneration": "3695",
    "allocation": "1847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5542",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4369",
    "nom_corrige2": "François Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Maire",
    "remuneration": "62607",
    "allocation": "17546",
    "remuneration2": "2767",
    "allocation2": "0",
    "total": "82920",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "4370",
    "nom_corrige2": "Roxane Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1666",
    "remuneration2": "305",
    "allocation2": "227",
    "total": "5531",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "4371",
    "nom_corrige2": "GUYLAINE OUELLET",
    "nom_famille": "OUELLET",
    "titre_genre2": "Conseillère",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4372",
    "nom_corrige2": "SYLVIE ROSSIGNOL",
    "nom_famille": "ROSSIGNOL",
    "titre_genre2": "Conseillère",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4373",
    "nom_corrige2": "PIERRE MUDIE",
    "nom_famille": "MUDIE",
    "titre_genre2": "Conseiller",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4374",
    "nom_corrige2": "MARIO MONGEON",
    "nom_famille": "MONGEON",
    "titre_genre2": "Conseiller",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4375",
    "nom_corrige2": "LINDA COUSINEAU",
    "nom_famille": "COUSINEAU",
    "titre_genre2": "Conseillère",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4376",
    "nom_corrige2": "SUZANNE CARON",
    "nom_famille": "CARON",
    "titre_genre2": "Conseillère",
    "remuneration": "3686",
    "allocation": "1843",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5529",
    "ville": "Lochaber-Partie-Ouest",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "927"
  },
  {
    "ID": "4377",
    "nom_corrige2": "Diane Provost",
    "nom_famille": "Provost",
    "titre_genre2": "Mairesse",
    "remuneration": "3672",
    "allocation": "1836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5508",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "4378",
    "nom_corrige2": "Roger Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "3670",
    "allocation": "1835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5505",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "4379",
    "nom_corrige2": "Carole Duplessis",
    "nom_famille": "Duplessis",
    "titre_genre2": "Conseillère",
    "remuneration": "3670",
    "allocation": "1835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5505",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "4380",
    "nom_corrige2": "Solange Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Conseillère",
    "remuneration": "3670",
    "allocation": "1835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5505",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "4381",
    "nom_corrige2": "Geneviève Maheux",
    "nom_famille": "Maheux",
    "titre_genre2": "Conseillère",
    "remuneration": "3670",
    "allocation": "1835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5505",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "4382",
    "nom_corrige2": "Frédéric Destrijker",
    "nom_famille": "Destrijker",
    "titre_genre2": "Conseiller",
    "remuneration": "3670",
    "allocation": "1835",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5505",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "4383",
    "nom_corrige2": "Marie-Danielle Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseillère",
    "remuneration": "3667",
    "allocation": "1834",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5501",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "4384",
    "nom_corrige2": "JAMES ALLAN",
    "nom_famille": "ALLAN",
    "titre_genre2": "Conseiller",
    "remuneration": "3661",
    "allocation": "1831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5492",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4385",
    "nom_corrige2": "NATHALIE DAOUST",
    "nom_famille": "DAOUST",
    "titre_genre2": "Conseillère",
    "remuneration": "3655",
    "allocation": "1827",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5482",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "4386",
    "nom_corrige2": "CARMEN FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseillère",
    "remuneration": "3655",
    "allocation": "1827",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5482",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "4387",
    "nom_corrige2": "ALAIN DELISLE",
    "nom_famille": "DELISLE",
    "titre_genre2": "Conseiller",
    "remuneration": "3655",
    "allocation": "1827",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5482",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "4388",
    "nom_corrige2": "CHARLI FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseiller",
    "remuneration": "3655",
    "allocation": "1827",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5482",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "4389",
    "nom_corrige2": "Jocelyn Lehouillier",
    "nom_famille": "Lehouillier",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4390",
    "nom_corrige2": "Gaston Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4391",
    "nom_corrige2": "Guylaine Lemelin",
    "nom_famille": "Lemelin",
    "titre_genre2": "Conseillère",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4392",
    "nom_corrige2": "René Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4393",
    "nom_corrige2": "Yves Béchard",
    "nom_famille": "Béchard",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Sainte-Claire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3641"
  },
  {
    "ID": "4394",
    "nom_corrige2": "Robert Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "4395",
    "nom_corrige2": "Jean-François Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "4396",
    "nom_corrige2": "Georges Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "4397",
    "nom_corrige2": "Denis Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Conseiller",
    "remuneration": "3646",
    "allocation": "1823",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5469",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "4398",
    "nom_corrige2": "Johanne Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseillère",
    "remuneration": "3645",
    "allocation": "1822",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5467",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4399",
    "nom_corrige2": "Gabriel Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "3645",
    "allocation": "1822",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5467",
    "ville": "Saint-Barnabé-Sud",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "906"
  },
  {
    "ID": "4400",
    "nom_corrige2": "François Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3642",
    "allocation": "1821",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5463",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4401",
    "nom_corrige2": "Marc Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseiller",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4402",
    "nom_corrige2": "Yves Bond",
    "nom_famille": "Bond",
    "titre_genre2": "Conseiller",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4403",
    "nom_corrige2": "Denys Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4404",
    "nom_corrige2": "Lee Brazel",
    "nom_famille": "Brazel",
    "titre_genre2": "Conseiller",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4405",
    "nom_corrige2": "Marie-Michèle Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseillère",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4406",
    "nom_corrige2": "Pierre Blouin",
    "nom_famille": "Blouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3641",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5461",
    "ville": "Saint-Isidore-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "712"
  },
  {
    "ID": "4407",
    "nom_corrige2": "Patrice Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4408",
    "nom_corrige2": "Yoland Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4409",
    "nom_corrige2": "Michel Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4410",
    "nom_corrige2": "Line Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseillère",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4411",
    "nom_corrige2": "Sylvain Duquet",
    "nom_famille": "Duquet",
    "titre_genre2": "Conseiller",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4412",
    "nom_corrige2": "Émilie Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "3640",
    "allocation": "1820",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5460",
    "ville": "Saint-Irénée",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "724"
  },
  {
    "ID": "4413",
    "nom_corrige2": "Réal Vel",
    "nom_famille": "Vel",
    "titre_genre2": "Conseiller",
    "remuneration": "4124",
    "allocation": "1324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5448",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "4414",
    "nom_corrige2": "Mario Dolbec",
    "nom_famille": "Dolbec",
    "titre_genre2": "Conseiller",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5445",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4415",
    "nom_corrige2": "Claudia Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseillère",
    "remuneration": "3630",
    "allocation": "1815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5445",
    "ville": "Westbury",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1097"
  },
  {
    "ID": "4416",
    "nom_corrige2": "Maude Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3628",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5442",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "4417",
    "nom_corrige2": "Lauréanne Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseillère",
    "remuneration": "3628",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5442",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "4418",
    "nom_corrige2": "Patrick Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "3628",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5442",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "4419",
    "nom_corrige2": "Gaétan Longchamp",
    "nom_famille": "Longchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "3628",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5442",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "4420",
    "nom_corrige2": "Dominique Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseiller",
    "remuneration": "3628",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5442",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "4421",
    "nom_corrige2": "Linda Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "3627",
    "allocation": "1813",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5440",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "4422",
    "nom_corrige2": "Réjean Lahaie",
    "nom_famille": "Lahaie",
    "titre_genre2": "Conseiller",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4423",
    "nom_corrige2": "Éric Roberge",
    "nom_famille": "Roberge",
    "titre_genre2": "Conseiller",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4424",
    "nom_corrige2": "Diane Moody",
    "nom_famille": "Moody",
    "titre_genre2": "Conseillère",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4425",
    "nom_corrige2": "Éric Senécal",
    "nom_famille": "Senécal",
    "titre_genre2": "Conseiller",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4426",
    "nom_corrige2": "Sylvie Brouillette-Ethier",
    "nom_famille": "Brouillette-Ethier",
    "titre_genre2": "Conseillère",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4427",
    "nom_corrige2": "Michel Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "3624",
    "allocation": "1812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5436",
    "ville": "Trois-Rives",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "405"
  },
  {
    "ID": "4428",
    "nom_corrige2": "Isabelle Sévigny",
    "nom_famille": "Sévigny",
    "titre_genre2": "Conseillère",
    "remuneration": "3563",
    "allocation": "1871",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5434",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4429",
    "nom_corrige2": "Michel - F. Vézina",
    "nom_famille": "Vézina",
    "titre_genre2": "Conseiller",
    "remuneration": "3563",
    "allocation": "1871",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5434",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4430",
    "nom_corrige2": "Marie-Josée Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseillère",
    "remuneration": "3619",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5428",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "4431",
    "nom_corrige2": "Pierre Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseiller",
    "remuneration": "3619",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5428",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "4432",
    "nom_corrige2": "Pierre Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3619",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5428",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "4433",
    "nom_corrige2": "Martin Tassé",
    "nom_famille": "Tassé",
    "titre_genre2": "Conseiller",
    "remuneration": "3619",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5428",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "4434",
    "nom_corrige2": "Peter L. Venezia",
    "nom_famille": "Venezia",
    "titre_genre2": "Conseiller",
    "remuneration": "3618",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5427",
    "ville": "Brébeuf",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1041"
  },
  {
    "ID": "4435",
    "nom_corrige2": "Jeffrey Garrett",
    "nom_famille": "Garrett",
    "titre_genre2": "Conseiller",
    "remuneration": "3618",
    "allocation": "1809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5427",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "4436",
    "nom_corrige2": "Alexandre Vermette",
    "nom_famille": "Vermette",
    "titre_genre2": "Conseiller",
    "remuneration": "3615",
    "allocation": "1807",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5422",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "4437",
    "nom_corrige2": "Bernard Beauchemin",
    "nom_famille": "Beauchemin",
    "titre_genre2": "Conseiller",
    "remuneration": "3615",
    "allocation": "1807",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5422",
    "ville": "Saint-Simon",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1453"
  },
  {
    "ID": "4438",
    "nom_corrige2": "Stéphane Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseiller",
    "remuneration": "3615",
    "allocation": "1805",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5420",
    "ville": "Roxton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1160"
  },
  {
    "ID": "4439",
    "nom_corrige2": "Richard Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5419",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "4440",
    "nom_corrige2": "Jacynthe Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5419",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "4441",
    "nom_corrige2": "Pierre Letendre",
    "nom_famille": "Letendre",
    "titre_genre2": "Conseiller",
    "remuneration": "3613",
    "allocation": "1806",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5419",
    "ville": "Saint-Jude",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1359"
  },
  {
    "ID": "4442",
    "nom_corrige2": "Nancy Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "3598",
    "allocation": "1799",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5397",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "4443",
    "nom_corrige2": "Alain Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseiller",
    "remuneration": "3598",
    "allocation": "1799",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5397",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "4444",
    "nom_corrige2": "Daniel Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseiller",
    "remuneration": "3598",
    "allocation": "1799",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5397",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "4445",
    "nom_corrige2": "François Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "3598",
    "allocation": "1799",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5397",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "4446",
    "nom_corrige2": "Michel Bourgault",
    "nom_famille": "Bourgault",
    "titre_genre2": "Conseiller",
    "remuneration": "3598",
    "allocation": "1799",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5397",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "4447",
    "nom_corrige2": "Régis Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "1896",
    "allocation": "948",
    "remuneration2": "1702",
    "allocation2": "851",
    "total": "5397",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "4448",
    "nom_corrige2": "Francis Ranger",
    "nom_famille": "Ranger",
    "titre_genre2": "Conseiller",
    "remuneration": "3594",
    "allocation": "1797",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5391",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4449",
    "nom_corrige2": "Sylvain Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "3590",
    "allocation": "1795",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5385",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4450",
    "nom_corrige2": "Jocelyne Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "3584",
    "allocation": "1792",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5376",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4451",
    "nom_corrige2": "Marco Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5374",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4452",
    "nom_corrige2": "Gilles Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseiller",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5374",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4453",
    "nom_corrige2": "Pier-Yves Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Conseiller",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5374",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4454",
    "nom_corrige2": "Patrick Chamberland",
    "nom_famille": "Chamberland",
    "titre_genre2": "Conseiller",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5374",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4455",
    "nom_corrige2": "Jolyanne De Tonnancour",
    "nom_famille": "De",
    "titre_genre2": "Conseillère",
    "remuneration": "3583",
    "allocation": "1791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5374",
    "ville": "Saint-David",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "914"
  },
  {
    "ID": "4456",
    "nom_corrige2": "Mireille Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "3576",
    "allocation": "1788",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5364",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "4457",
    "nom_corrige2": "Gisèle Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseillère",
    "remuneration": "3576",
    "allocation": "1788",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5364",
    "ville": "Brigham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "2352"
  },
  {
    "ID": "4458",
    "nom_corrige2": "Marjolaine Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4459",
    "nom_corrige2": "Vanessa Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseillère",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4460",
    "nom_corrige2": "France Thibodeau",
    "nom_famille": "Thibodeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4461",
    "nom_corrige2": "Simon Bourgault",
    "nom_famille": "Bourgault",
    "titre_genre2": "Conseiller",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4462",
    "nom_corrige2": "Véronique Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4463",
    "nom_corrige2": "Catherine Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3573",
    "allocation": "1787",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5360",
    "ville": "Saint-Adalbert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "495"
  },
  {
    "ID": "4464",
    "nom_corrige2": "Patrick Wenning",
    "nom_famille": "Wenning",
    "titre_genre2": "Conseiller",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5353",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4465",
    "nom_corrige2": "Josiane Fabry",
    "nom_famille": "Fabry",
    "titre_genre2": "Conseillère",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5353",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4466",
    "nom_corrige2": "André Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5353",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4467",
    "nom_corrige2": "Maxime Partenza",
    "nom_famille": "Partenza",
    "titre_genre2": "Conseiller",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5353",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4468",
    "nom_corrige2": "Michel Lord",
    "nom_famille": "Lord",
    "titre_genre2": "Conseiller",
    "remuneration": "3569",
    "allocation": "1784",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5353",
    "ville": "Henryville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1508"
  },
  {
    "ID": "4469",
    "nom_corrige2": "Suzanne Casavant",
    "nom_famille": "Casavant",
    "titre_genre2": "Conseillère",
    "remuneration": "4115",
    "allocation": "1236",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5351",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "4470",
    "nom_corrige2": "Carmen Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseillère",
    "remuneration": "3566",
    "allocation": "1783",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "4471",
    "nom_corrige2": "Michel Bonneville",
    "nom_famille": "Bonneville",
    "titre_genre2": "Conseiller",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4472",
    "nom_corrige2": "Francis Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseiller",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4473",
    "nom_corrige2": "Édith Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseillère",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4474",
    "nom_corrige2": "Jonathan Bolduc-Dufour",
    "nom_famille": "Bolduc-Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4475",
    "nom_corrige2": "Emmanuelle Prud'Homme",
    "nom_famille": "Prud'Homme",
    "titre_genre2": "Conseillère",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4476",
    "nom_corrige2": "Lyne Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "5349",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5349",
    "ville": "Saint-Sébastien",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "726"
  },
  {
    "ID": "4477",
    "nom_corrige2": "Line Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseillère",
    "remuneration": "3774",
    "allocation": "1571",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5345",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4478",
    "nom_corrige2": "André Kirouac",
    "nom_famille": "Kirouac",
    "titre_genre2": "Conseiller",
    "remuneration": "3774",
    "allocation": "1571",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5345",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4479",
    "nom_corrige2": "Patricia Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "3774",
    "allocation": "1571",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5345",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4480",
    "nom_corrige2": "Marcel Boulay",
    "nom_famille": "Boulay",
    "titre_genre2": "Conseiller",
    "remuneration": "3563",
    "allocation": "1781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5344",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4481",
    "nom_corrige2": "Nicolas Beaulne",
    "nom_famille": "Beaulne",
    "titre_genre2": "Conseiller",
    "remuneration": "3563",
    "allocation": "1781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5344",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4482",
    "nom_corrige2": "Lise Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "3563",
    "allocation": "1781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5344",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4483",
    "nom_corrige2": "Johanne Lacourse",
    "nom_famille": "Lacourse",
    "titre_genre2": "Conseillère",
    "remuneration": "3563",
    "allocation": "1781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5344",
    "ville": "Sainte-Angèle-de-Monnoir",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1785"
  },
  {
    "ID": "4484",
    "nom_corrige2": "ROGER GOSSELIN",
    "nom_famille": "GOSSELIN",
    "titre_genre2": "Conseiller",
    "remuneration": "3561",
    "allocation": "1781",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5342",
    "ville": "Kinnear's Mills",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "393"
  },
  {
    "ID": "4485",
    "nom_corrige2": "Alain Conraud",
    "nom_famille": "Conraud",
    "titre_genre2": "Conseiller",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "90",
    "allocation2": "107",
    "total": "5327",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "4486",
    "nom_corrige2": "Patricia St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Conseillère",
    "remuneration": "3552",
    "allocation": "1775",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5327",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "4487",
    "nom_corrige2": "Josette Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseillère",
    "remuneration": "3631",
    "allocation": "1678",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5309",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4488",
    "nom_corrige2": "René St-Louis",
    "nom_famille": "St-Louis",
    "titre_genre2": "Conseiller",
    "remuneration": "3800",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5300",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "4489",
    "nom_corrige2": "Patrick Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "3722",
    "allocation": "1571",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5293",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4490",
    "nom_corrige2": "Hélène Côté Lambert",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "3513",
    "allocation": "1758",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5271",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "4491",
    "nom_corrige2": "Daniel Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4492",
    "nom_corrige2": "Serge Dion",
    "nom_famille": "Dion",
    "titre_genre2": "Conseiller",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4493",
    "nom_corrige2": "Sylvain Dugas",
    "nom_famille": "Dugas",
    "titre_genre2": "Conseiller",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4494",
    "nom_corrige2": "Paulo Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4495",
    "nom_corrige2": "Réjean Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4496",
    "nom_corrige2": "Johanne Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseillère",
    "remuneration": "3517",
    "allocation": "1752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5269",
    "ville": "Longue-Rive",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "956"
  },
  {
    "ID": "4497",
    "nom_corrige2": "Martine Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseillère",
    "remuneration": "4175",
    "allocation": "1084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5259",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "4498",
    "nom_corrige2": "Léandre Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "4175",
    "allocation": "1084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5259",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "4499",
    "nom_corrige2": "Marie Provost",
    "nom_famille": "Provost",
    "titre_genre2": "Conseillère",
    "remuneration": "3502",
    "allocation": "1751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5253",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4500",
    "nom_corrige2": "Joël Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "3502",
    "allocation": "1751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5253",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4501",
    "nom_corrige2": "Sylvain Mallette",
    "nom_famille": "Mallette",
    "titre_genre2": "Conseiller",
    "remuneration": "3502",
    "allocation": "1751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5253",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "4502",
    "nom_corrige2": "Jacky Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "3669",
    "allocation": "1571",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5240",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4503",
    "nom_corrige2": "Stéphane Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "3700",
    "allocation": "1532",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5232",
    "ville": "Saint-Honoré-de-Shenley",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1523"
  },
  {
    "ID": "4504",
    "nom_corrige2": "Guylaine D'Amours",
    "nom_famille": "D'Amours",
    "titre_genre2": "Conseillère",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4505",
    "nom_corrige2": "Carl Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4506",
    "nom_corrige2": "Claude Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4507",
    "nom_corrige2": "Gérald Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseiller",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4508",
    "nom_corrige2": "Manon Belzile",
    "nom_famille": "Belzile",
    "titre_genre2": "Conseillère",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4509",
    "nom_corrige2": "Rémi Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "3486",
    "allocation": "1743",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5229",
    "ville": "Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1408"
  },
  {
    "ID": "4510",
    "nom_corrige2": "Nicole Charette",
    "nom_famille": "Charette",
    "titre_genre2": "Conseillère",
    "remuneration": "3639",
    "allocation": "1432",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "5222",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "4511",
    "nom_corrige2": "Christiane Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3532",
    "allocation": "1686",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5218",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "4512",
    "nom_corrige2": "Guylaine La Salle",
    "nom_famille": "La",
    "titre_genre2": "Conseillère",
    "remuneration": "3475",
    "allocation": "1738",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5213",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "4513",
    "nom_corrige2": "Pierre Jolicoeur",
    "nom_famille": "Jolicoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "3475",
    "allocation": "1738",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5213",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "4514",
    "nom_corrige2": "Aurel Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "3475",
    "allocation": "1738",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5213",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "4515",
    "nom_corrige2": "Louise Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "3475",
    "allocation": "1738",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5213",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "4516",
    "nom_corrige2": "Fernando Sanchez",
    "nom_famille": "Sanchez",
    "titre_genre2": "Conseiller",
    "remuneration": "3472",
    "allocation": "1736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5208",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4517",
    "nom_corrige2": "Jonatan Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "3472",
    "allocation": "1736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5208",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "4518",
    "nom_corrige2": "Benoit Gratton",
    "nom_famille": "Gratton",
    "titre_genre2": "Conseiller",
    "remuneration": "3467",
    "allocation": "1733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5200",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "4519",
    "nom_corrige2": "Maxime Bétournay",
    "nom_famille": "Bétournay",
    "titre_genre2": "Conseiller",
    "remuneration": "3467",
    "allocation": "1733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5200",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "4520",
    "nom_corrige2": "Gilles St-Amand",
    "nom_famille": "St-Amand",
    "titre_genre2": "Conseiller",
    "remuneration": "3467",
    "allocation": "1733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5200",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "4521",
    "nom_corrige2": "Francine Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseillère",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4522",
    "nom_corrige2": "Rénald Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4523",
    "nom_corrige2": "Denis Rochette",
    "nom_famille": "Rochette",
    "titre_genre2": "Conseiller",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4524",
    "nom_corrige2": "Romuald Gallant",
    "nom_famille": "Gallant",
    "titre_genre2": "Conseiller",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4525",
    "nom_corrige2": "Johanne Cormier",
    "nom_famille": "Cormier",
    "titre_genre2": "Conseillère",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4526",
    "nom_corrige2": "Noelline Gallant",
    "nom_famille": "Gallant",
    "titre_genre2": "Conseillère",
    "remuneration": "3464",
    "allocation": "1732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5196",
    "ville": "Aguanish",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "222"
  },
  {
    "ID": "4527",
    "nom_corrige2": "Martin Hallé",
    "nom_famille": "Hallé",
    "titre_genre2": "Conseiller",
    "remuneration": "3741",
    "allocation": "1451",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5192",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "4528",
    "nom_corrige2": "Jonathan Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseiller",
    "remuneration": "4233",
    "allocation": "943",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5176",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "4529",
    "nom_corrige2": "Jean Sioui",
    "nom_famille": "Sioui",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5170",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4530",
    "nom_corrige2": "Patrice Forcier",
    "nom_famille": "Forcier",
    "titre_genre2": "Conseiller",
    "remuneration": "3447",
    "allocation": "1723",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5170",
    "ville": "Saint-Louis",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "737"
  },
  {
    "ID": "4531",
    "nom_corrige2": "Sylvain Dansereau",
    "nom_famille": "Dansereau",
    "titre_genre2": "Conseiller",
    "remuneration": "3056",
    "allocation": "1528",
    "remuneration2": "388",
    "allocation2": "194",
    "total": "5166",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "4532",
    "nom_corrige2": "Harry Bird",
    "nom_famille": "Bird",
    "titre_genre2": "Conseiller",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4533",
    "nom_corrige2": "Anne-Marie Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4534",
    "nom_corrige2": "Nicolas Berger",
    "nom_famille": "Berger",
    "titre_genre2": "Conseiller",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4535",
    "nom_corrige2": "James Penny",
    "nom_famille": "Penny",
    "titre_genre2": "Conseiller",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4536",
    "nom_corrige2": "Alexandre Berger",
    "nom_famille": "Berger",
    "titre_genre2": "Conseiller",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4537",
    "nom_corrige2": "Joël Brulotte",
    "nom_famille": "Brulotte",
    "titre_genre2": "Conseiller",
    "remuneration": "3524",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5163",
    "ville": "Saint-Étienne-de-Bolton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "829"
  },
  {
    "ID": "4538",
    "nom_corrige2": "STEVE RICHARD",
    "nom_famille": "RICHARD",
    "titre_genre2": "Conseiller",
    "remuneration": "3426",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5139",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4539",
    "nom_corrige2": "DENIS BROUILLETTE",
    "nom_famille": "BROUILLETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3426",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5139",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4540",
    "nom_corrige2": "PATRICE BARIL",
    "nom_famille": "BARIL",
    "titre_genre2": "Conseiller",
    "remuneration": "3426",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5139",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4541",
    "nom_corrige2": "WILLIAM GUILLEMETTE",
    "nom_famille": "GUILLEMETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3426",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5139",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4542",
    "nom_corrige2": "STEPHANE GOULET",
    "nom_famille": "GOULET",
    "titre_genre2": "Conseiller",
    "remuneration": "3426",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5139",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4543",
    "nom_corrige2": "Alexandra Han",
    "nom_famille": "Han",
    "titre_genre2": "Conseillère",
    "remuneration": "3524",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5136",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4544",
    "nom_corrige2": "Philippe Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "3423",
    "allocation": "1712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5135",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "4545",
    "nom_corrige2": "Sylvain Pillenière",
    "nom_famille": "Pillenière",
    "titre_genre2": "Conseiller",
    "remuneration": "3423",
    "allocation": "1712",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5135",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "4546",
    "nom_corrige2": "Anthony Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseiller",
    "remuneration": "3422",
    "allocation": "1711",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5133",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4547",
    "nom_corrige2": "Christian Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseiller",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5130",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "4548",
    "nom_corrige2": "Sarah Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseillère",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5130",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "4549",
    "nom_corrige2": "Frédéric Marier",
    "nom_famille": "Marier",
    "titre_genre2": "Conseiller",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5130",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "4550",
    "nom_corrige2": "Nancy Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "3420",
    "allocation": "1710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5130",
    "ville": "Sainte-Brigitte-des-Saults",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "784"
  },
  {
    "ID": "4551",
    "nom_corrige2": "Rosaire Guénette",
    "nom_famille": "Guénette",
    "titre_genre2": "Maire",
    "remuneration": "3413",
    "allocation": "1706",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5119",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "4552",
    "nom_corrige2": "Louis Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "3411",
    "allocation": "1706",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5117",
    "ville": "Vallée-Jonction",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1906"
  },
  {
    "ID": "4553",
    "nom_corrige2": "Jacques Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "3409",
    "allocation": "1704",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5113",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4554",
    "nom_corrige2": "Diane Audit Goddard",
    "nom_famille": "Audit",
    "titre_genre2": "Conseillère",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4555",
    "nom_corrige2": "Luc St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Conseiller",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4556",
    "nom_corrige2": "Antonin Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseiller",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4557",
    "nom_corrige2": "William Darveau-Vaillancourt",
    "nom_famille": "Darveau-Vaillancourt",
    "titre_genre2": "Conseiller",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4558",
    "nom_corrige2": "Simon Larrivée",
    "nom_famille": "Larrivée",
    "titre_genre2": "Conseiller",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4559",
    "nom_corrige2": "Marilene Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "3407",
    "allocation": "1703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5110",
    "ville": "Ham-Sud",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "245"
  },
  {
    "ID": "4560",
    "nom_corrige2": "Marcel Mainville",
    "nom_famille": "Mainville",
    "titre_genre2": "Conseiller",
    "remuneration": "3541",
    "allocation": "1564",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5105",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "4561",
    "nom_corrige2": "JOHANE PATENAUDE",
    "nom_famille": "PATENAUDE",
    "titre_genre2": "Conseillère",
    "remuneration": "3416",
    "allocation": "1688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5104",
    "ville": "Beaulac-Garthby",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1026"
  },
  {
    "ID": "4562",
    "nom_corrige2": "Danielle D'Anjou",
    "nom_famille": "D'Anjou",
    "titre_genre2": "Conseillère",
    "remuneration": "3527",
    "allocation": "1573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5100",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4563",
    "nom_corrige2": "Julie Maurice",
    "nom_famille": "Maurice",
    "titre_genre2": "Conseillère",
    "remuneration": "3390",
    "allocation": "1695",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5085",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4564",
    "nom_corrige2": "Jocelyne Calvé",
    "nom_famille": "Calvé",
    "titre_genre2": "Conseillère",
    "remuneration": "3382",
    "allocation": "1691",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5073",
    "ville": "Saint-Didace",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "725"
  },
  {
    "ID": "4565",
    "nom_corrige2": "KRYSTEL HOULE-PLANTE",
    "nom_famille": "HOULE-PLANTE",
    "titre_genre2": "Conseillère",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5065",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "4566",
    "nom_corrige2": "MARIE-JOSÉE PLEAU",
    "nom_famille": "PLEAU",
    "titre_genre2": "Conseillère",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5065",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "4567",
    "nom_corrige2": "MARC PAYEUR",
    "nom_famille": "PAYEUR",
    "titre_genre2": "Conseiller",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5065",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "4568",
    "nom_corrige2": "ERIC FRÉCHETTE",
    "nom_famille": "FRÉCHETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3377",
    "allocation": "1688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5065",
    "ville": "Kingsey Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1976"
  },
  {
    "ID": "4569",
    "nom_corrige2": "Pierre Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "3368",
    "allocation": "1684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5052",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "4570",
    "nom_corrige2": "Nadine Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "3368",
    "allocation": "1684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5052",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "4571",
    "nom_corrige2": "Marin Groleau",
    "nom_famille": "Groleau",
    "titre_genre2": "Conseiller",
    "remuneration": "3368",
    "allocation": "1684",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5052",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "4572",
    "nom_corrige2": "Nancy Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseillère",
    "remuneration": "3370",
    "allocation": "1681",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5051",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "4573",
    "nom_corrige2": "Gaétan Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseiller",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "309",
    "allocation2": "155",
    "total": "5050",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4574",
    "nom_corrige2": "DENISE BÉLAND",
    "nom_famille": "BÉLAND",
    "titre_genre2": "Conseillère",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4575",
    "nom_corrige2": "JEANNIS CHARETTE",
    "nom_famille": "CHARETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4576",
    "nom_corrige2": "SYLVIE LESSARD",
    "nom_famille": "LESSARD",
    "titre_genre2": "Conseillère",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4577",
    "nom_corrige2": "JOSÉE BELLEMARE",
    "nom_famille": "BELLEMARE",
    "titre_genre2": "Conseillère",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4578",
    "nom_corrige2": "PHILIPPE DAUPHIN",
    "nom_famille": "DAUPHIN",
    "titre_genre2": "Conseiller",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4579",
    "nom_corrige2": "SYLVIE BÉLAND",
    "nom_famille": "BÉLAND",
    "titre_genre2": "Conseillère",
    "remuneration": "3366",
    "allocation": "1683",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5049",
    "ville": "Sainte-Ursule",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1363"
  },
  {
    "ID": "4580",
    "nom_corrige2": "Paul Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "3279",
    "allocation": "1640",
    "remuneration2": "125",
    "allocation2": "0",
    "total": "5044",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4581",
    "nom_corrige2": "Bianca  Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseillère",
    "remuneration": "3363",
    "allocation": "1681",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5044",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "4582",
    "nom_corrige2": "Alexandre Dubuc-Ringuette",
    "nom_famille": "Dubuc-Ringuette",
    "titre_genre2": "Conseiller",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4583",
    "nom_corrige2": "Chantale Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseillère",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4584",
    "nom_corrige2": "Guillaume Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4585",
    "nom_corrige2": "Sylvain Garant",
    "nom_famille": "Garant",
    "titre_genre2": "Conseiller",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4586",
    "nom_corrige2": "Émilie Legras",
    "nom_famille": "Legras",
    "titre_genre2": "Conseillère",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4587",
    "nom_corrige2": "Patricica René",
    "nom_famille": "René",
    "titre_genre2": "Conseillère",
    "remuneration": "3360",
    "allocation": "1680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5040",
    "ville": "Saint-Pierre-de-Broughton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "940"
  },
  {
    "ID": "4588",
    "nom_corrige2": "Denis Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "151",
    "allocation2": "76",
    "total": "5035",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4589",
    "nom_corrige2": "GUY BERGEVIN",
    "nom_famille": "BERGEVIN",
    "titre_genre2": "Conseiller",
    "remuneration": "3405",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5032",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4590",
    "nom_corrige2": "Ghislain Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4591",
    "nom_corrige2": "Donald Grimard",
    "nom_famille": "Grimard",
    "titre_genre2": "Conseiller",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4592",
    "nom_corrige2": "Richard Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4593",
    "nom_corrige2": "Jasmin Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4594",
    "nom_corrige2": "Line Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Conseillère",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4595",
    "nom_corrige2": "Geneviève Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "3350",
    "allocation": "1675",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5025",
    "ville": "Wotton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1438"
  },
  {
    "ID": "4596",
    "nom_corrige2": "Frédéric Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "La Guadeloupe",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1781"
  },
  {
    "ID": "4597",
    "nom_corrige2": "Gaétan Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4598",
    "nom_corrige2": "Jacqueline Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4599",
    "nom_corrige2": "Martin Bussières",
    "nom_famille": "Bussières",
    "titre_genre2": "Conseiller",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4600",
    "nom_corrige2": "Véronique Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseillère",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4601",
    "nom_corrige2": "Samantha Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseillère",
    "remuneration": "3346",
    "allocation": "1673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5019",
    "ville": "Sainte-Praxède",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "351"
  },
  {
    "ID": "4602",
    "nom_corrige2": "Jacques Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "3243",
    "allocation": "1622",
    "remuneration2": "100",
    "allocation2": "50",
    "total": "5015",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "4603",
    "nom_corrige2": "PASCAL LARAMÉE",
    "nom_famille": "LARAMÉE",
    "titre_genre2": "Conseiller",
    "remuneration": "3380",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5007",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4604",
    "nom_corrige2": "KARINE POIRIER",
    "nom_famille": "POIRIER",
    "titre_genre2": "Conseillère",
    "remuneration": "3380",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5007",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4605",
    "nom_corrige2": "Anne Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseillère",
    "remuneration": "9672",
    "allocation": "4836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14508",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "4606",
    "nom_corrige2": "Magella Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4607",
    "nom_corrige2": "Patricia Delarosbil",
    "nom_famille": "Delarosbil",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4608",
    "nom_corrige2": "Delisca Doucet",
    "nom_famille": "Doucet",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4609",
    "nom_corrige2": "Linda Delarosbil",
    "nom_famille": "Delarosbil",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4610",
    "nom_corrige2": "Colette Plusquellec",
    "nom_famille": "Plusquellec",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4611",
    "nom_corrige2": "Annick Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Hope",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "608"
  },
  {
    "ID": "4612",
    "nom_corrige2": "Pascal Cliche",
    "nom_famille": "Cliche",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "4613",
    "nom_corrige2": "Alexandra Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "4614",
    "nom_corrige2": "Jean Proteau",
    "nom_famille": "Proteau",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "4615",
    "nom_corrige2": "Claude Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "4616",
    "nom_corrige2": "Richard Viau",
    "nom_famille": "Viau",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "4617",
    "nom_corrige2": "Onil Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "4618",
    "nom_corrige2": "Pauline Dumoulin",
    "nom_famille": "Dumoulin",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "4619",
    "nom_corrige2": "Francis Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5000",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "4620",
    "nom_corrige2": "Maxime Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4999",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "4621",
    "nom_corrige2": "Yannis Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4999",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "4622",
    "nom_corrige2": "Patrice Goupil",
    "nom_famille": "Goupil",
    "titre_genre2": "Conseiller",
    "remuneration": "3333",
    "allocation": "1666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4999",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "4623",
    "nom_corrige2": "Danielle Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "3333",
    "allocation": "1666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4999",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "4624",
    "nom_corrige2": "Martine Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4625",
    "nom_corrige2": "Michel Kowalew",
    "nom_famille": "Kowalew",
    "titre_genre2": "Conseiller",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4626",
    "nom_corrige2": "Joannie Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4627",
    "nom_corrige2": "Claude Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4628",
    "nom_corrige2": "Dany Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4629",
    "nom_corrige2": "Gilles Harvey",
    "nom_famille": "Harvey",
    "titre_genre2": "Conseiller",
    "remuneration": "3328",
    "allocation": "1664",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4992",
    "ville": "Saint-Siméon",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1177"
  },
  {
    "ID": "4630",
    "nom_corrige2": "Philippe St-Jacques",
    "nom_famille": "St-Jacques",
    "titre_genre2": "Conseiller",
    "remuneration": "3324",
    "allocation": "1663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4987",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4631",
    "nom_corrige2": "Kim Bernatchez",
    "nom_famille": "Bernatchez",
    "titre_genre2": "Conseillère",
    "remuneration": "3324",
    "allocation": "1663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4987",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4632",
    "nom_corrige2": "François Beaumont",
    "nom_famille": "Beaumont",
    "titre_genre2": "Conseiller",
    "remuneration": "3324",
    "allocation": "1663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4987",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4633",
    "nom_corrige2": "Suzanne Guilbault",
    "nom_famille": "Guilbault",
    "titre_genre2": "Conseillère",
    "remuneration": "3324",
    "allocation": "1663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4987",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4634",
    "nom_corrige2": "Nyx Pilon",
    "nom_famille": "Pilon",
    "titre_genre2": "Conseiller",
    "remuneration": "3324",
    "allocation": "1663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4987",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4635",
    "nom_corrige2": "Anne Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "6453",
    "allocation": "3226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9679",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "4636",
    "nom_corrige2": "Joanie Mailloux",
    "nom_famille": "Mailloux",
    "titre_genre2": "Conseillère",
    "remuneration": "3374",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4986",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4637",
    "nom_corrige2": "Teddy Chiasson",
    "nom_famille": "Chiasson",
    "titre_genre2": "Conseiller",
    "remuneration": "3322",
    "allocation": "1661",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4983",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4638",
    "nom_corrige2": "Mathieu Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "3408",
    "allocation": "1573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4981",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "4639",
    "nom_corrige2": "Katherine Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "3408",
    "allocation": "1573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4981",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "4640",
    "nom_corrige2": "Nancy Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseillère",
    "remuneration": "3408",
    "allocation": "1573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4981",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "4641",
    "nom_corrige2": "Chantal Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "3408",
    "allocation": "1573",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4981",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "4642",
    "nom_corrige2": "Jacques Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Conseiller",
    "remuneration": "3307",
    "allocation": "1654",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4961",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "4643",
    "nom_corrige2": "Nicholas Lalonde",
    "nom_famille": "Lalonde",
    "titre_genre2": "Conseiller",
    "remuneration": "3307",
    "allocation": "1654",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4961",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "4644",
    "nom_corrige2": "Annie Bellemare",
    "nom_famille": "Bellemare",
    "titre_genre2": "Conseillère",
    "remuneration": "3307",
    "allocation": "1654",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4961",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "4645",
    "nom_corrige2": "Mario Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "3307",
    "allocation": "1654",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4961",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "4646",
    "nom_corrige2": "Renaud Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "4960",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4647",
    "nom_corrige2": "Robert Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "3300",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4950",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "4648",
    "nom_corrige2": "Amélie Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "3300",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4950",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "4649",
    "nom_corrige2": "Annie Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "3300",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4950",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "4650",
    "nom_corrige2": "Valérie Giguière",
    "nom_famille": "Giguière",
    "titre_genre2": "Conseillère",
    "remuneration": "3300",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4950",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "4651",
    "nom_corrige2": "Nathalie Lanthier",
    "nom_famille": "Lanthier",
    "titre_genre2": "Conseillère",
    "remuneration": "3629",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4948",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4652",
    "nom_corrige2": "Julie Robillard",
    "nom_famille": "Robillard",
    "titre_genre2": "Conseillère",
    "remuneration": "3298",
    "allocation": "1649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4947",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "4653",
    "nom_corrige2": "Lise Bourgeois-Doré",
    "nom_famille": "Bourgeois-Doré",
    "titre_genre2": "Conseillère",
    "remuneration": "3296",
    "allocation": "1648",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4944",
    "ville": "Lac-des-Plages",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "499"
  },
  {
    "ID": "4654",
    "nom_corrige2": "MÉLANIE COMTOIS",
    "nom_famille": "COMTOIS",
    "titre_genre2": "Conseillère",
    "remuneration": "3226",
    "allocation": "1713",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4939",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "822"
  },
  {
    "ID": "4655",
    "nom_corrige2": "Charles Collin",
    "nom_famille": "Collin",
    "titre_genre2": "Conseiller",
    "remuneration": "3324",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4936",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4656",
    "nom_corrige2": "Philippe Gaboury",
    "nom_famille": "Gaboury",
    "titre_genre2": "Conseiller",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4657",
    "nom_corrige2": "Rodrigue Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4658",
    "nom_corrige2": "Yohan Guillemette",
    "nom_famille": "Guillemette",
    "titre_genre2": "Conseiller",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4659",
    "nom_corrige2": "Stéphane Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4660",
    "nom_corrige2": "Lydia Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseillère",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4661",
    "nom_corrige2": "Marcel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "3008",
    "allocation": "1925",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4933",
    "ville": "Saint-Malachie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1595"
  },
  {
    "ID": "4662",
    "nom_corrige2": "Marie-Eve Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "3285",
    "allocation": "1643",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4928",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "4663",
    "nom_corrige2": "Martine Lanctot",
    "nom_famille": "Lanctot",
    "titre_genre2": "Conseillère",
    "remuneration": "3390",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4927",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "4664",
    "nom_corrige2": "Audrey-Claude Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseillère",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "33",
    "allocation2": "17",
    "total": "4925",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4665",
    "nom_corrige2": "Ghislain Quintal",
    "nom_famille": "Quintal",
    "titre_genre2": "Conseiller",
    "remuneration": "3371",
    "allocation": "1548",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4919",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "4666",
    "nom_corrige2": "André Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "3665",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4915",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4667",
    "nom_corrige2": "Jacques Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Conseiller",
    "remuneration": "2911",
    "allocation": "1093",
    "remuneration2": "605",
    "allocation2": "302",
    "total": "4911",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "4668",
    "nom_corrige2": "Gérard Jacques",
    "nom_famille": "Jacques",
    "titre_genre2": "Conseiller",
    "remuneration": "3151",
    "allocation": "1760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4911",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "4669",
    "nom_corrige2": "Marc Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "3273",
    "allocation": "1637",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4910",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "4670",
    "nom_corrige2": "René Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "3269",
    "allocation": "1634",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4903",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4671",
    "nom_corrige2": "GAÉTAN FORTIER",
    "nom_famille": "FORTIER",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4672",
    "nom_corrige2": "STEVE LEBLANC",
    "nom_famille": "LEBLANC",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4673",
    "nom_corrige2": "DOMINIC LAPOINTE",
    "nom_famille": "LAPOINTE",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4674",
    "nom_corrige2": "GILLES GAUVREAU",
    "nom_famille": "GAUVREAU",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4675",
    "nom_corrige2": "Benoît COUTURE",
    "nom_famille": "COUTURE",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4676",
    "nom_corrige2": "RÉMI BEAUCHESNE",
    "nom_famille": "BEAUCHESNE",
    "titre_genre2": "Conseiller",
    "remuneration": "3267",
    "allocation": "1633",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Ham-Nord",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "862"
  },
  {
    "ID": "4677",
    "nom_corrige2": "Nancy Dumas",
    "nom_famille": "Dumas",
    "titre_genre2": "Conseillère",
    "remuneration": "3650",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4900",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4678",
    "nom_corrige2": "Robin Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4679",
    "nom_corrige2": "Danielle Barrette",
    "nom_famille": "Barrette",
    "titre_genre2": "Conseillère",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4680",
    "nom_corrige2": "Caroline Kennedy",
    "nom_famille": "Kennedy",
    "titre_genre2": "Conseillère",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4681",
    "nom_corrige2": "Jonathan Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4682",
    "nom_corrige2": "Liliane Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4683",
    "nom_corrige2": "Roberto Emond",
    "nom_famille": "Emond",
    "titre_genre2": "Conseiller",
    "remuneration": "3263",
    "allocation": "1631",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4894",
    "ville": "Portneuf-sur-Mer",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "568"
  },
  {
    "ID": "4684",
    "nom_corrige2": "André Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4685",
    "nom_corrige2": "Rock Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4686",
    "nom_corrige2": "Alex Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4687",
    "nom_corrige2": "Marina Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseillère",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4688",
    "nom_corrige2": "Mélissa Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseillère",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4689",
    "nom_corrige2": "Carl Croteau",
    "nom_famille": "Croteau",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1632",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4887",
    "ville": "Saint-Adrien-d'Irlande",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "403"
  },
  {
    "ID": "4690",
    "nom_corrige2": "Francine Vallières Juteau",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseillère",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4691",
    "nom_corrige2": "Johanne Desabrais",
    "nom_famille": "Desabrais",
    "titre_genre2": "Conseillère",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4692",
    "nom_corrige2": "François Lamoureux",
    "nom_famille": "Lamoureux",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4693",
    "nom_corrige2": "Christian Marois",
    "nom_famille": "Marois",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4694",
    "nom_corrige2": "Sophie Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4695",
    "nom_corrige2": "Pierre Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "3255",
    "allocation": "1628",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4883",
    "ville": "Saint-Joachim-de-Shefford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1440"
  },
  {
    "ID": "4696",
    "nom_corrige2": "Sylvain Pronovost",
    "nom_famille": "Pronovost",
    "titre_genre2": "Conseiller",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4875",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4697",
    "nom_corrige2": "Colette Fréchette Beausoleil",
    "nom_famille": "Fréchette",
    "titre_genre2": "Conseillère",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4875",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4698",
    "nom_corrige2": "Nicolas Dujardin",
    "nom_famille": "Dujardin",
    "titre_genre2": "Conseiller",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4875",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4699",
    "nom_corrige2": "Geneviève Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "3250",
    "allocation": "1625",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4875",
    "ville": "Baie-du-Febvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "972"
  },
  {
    "ID": "4700",
    "nom_corrige2": "Jean-Paul Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "3246",
    "allocation": "1623",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4869",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "4701",
    "nom_corrige2": "Gilles Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseiller",
    "remuneration": "3246",
    "allocation": "1623",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4869",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "4702",
    "nom_corrige2": "Mélanie Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "3246",
    "allocation": "1623",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4869",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "4703",
    "nom_corrige2": "Hélène Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "3246",
    "allocation": "1623",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4869",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "4704",
    "nom_corrige2": "Jean-Yves D'Amboise",
    "nom_famille": "D'Amboise",
    "titre_genre2": "Conseiller",
    "remuneration": "3246",
    "allocation": "1623",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4869",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "4705",
    "nom_corrige2": "Serge Béchard",
    "nom_famille": "Béchard",
    "titre_genre2": "Conseiller",
    "remuneration": "3311",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4866",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "4706",
    "nom_corrige2": "Julie De Grâce",
    "nom_famille": "De",
    "titre_genre2": "Conseillère",
    "remuneration": "3242",
    "allocation": "1621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4863",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4707",
    "nom_corrige2": "Alain Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "3242",
    "allocation": "1621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4863",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4708",
    "nom_corrige2": "Erin Kane",
    "nom_famille": "Kane",
    "titre_genre2": "Conseillère",
    "remuneration": "3242",
    "allocation": "1621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4863",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4709",
    "nom_corrige2": "Pierre Robineau",
    "nom_famille": "Robineau",
    "titre_genre2": "Conseiller",
    "remuneration": "3242",
    "allocation": "1621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4863",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4710",
    "nom_corrige2": "Guy M Roussel",
    "nom_famille": "Roussel",
    "titre_genre2": "Conseiller",
    "remuneration": "3242",
    "allocation": "1621",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4863",
    "ville": "Mayo",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "627"
  },
  {
    "ID": "4711",
    "nom_corrige2": "Mélissa Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "3539",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4858",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4712",
    "nom_corrige2": "Colette Brulotte",
    "nom_famille": "Brulotte",
    "titre_genre2": "Conseillère",
    "remuneration": "3600",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4850",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4713",
    "nom_corrige2": "Gérald Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4714",
    "nom_corrige2": "Élisabeth Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseillère",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4715",
    "nom_corrige2": "Alain Déry",
    "nom_famille": "Déry",
    "titre_genre2": "Conseiller",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4716",
    "nom_corrige2": "Lorraine Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseillère",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4717",
    "nom_corrige2": "Dominique Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4718",
    "nom_corrige2": "Chloé Germain-Therrien",
    "nom_famille": "Germain-Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "3233",
    "allocation": "1616",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4849",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1028"
  },
  {
    "ID": "4719",
    "nom_corrige2": "Claudette Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseillère",
    "remuneration": "3407",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4847",
    "ville": "Girardville",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "987"
  },
  {
    "ID": "4720",
    "nom_corrige2": "Jacques Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "230",
    "allocation2": "115",
    "total": "4845",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4721",
    "nom_corrige2": "Nicolas Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3227",
    "allocation": "1613",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4840",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "4722",
    "nom_corrige2": "Peter Buzzell",
    "nom_famille": "Buzzell",
    "titre_genre2": "Conseiller",
    "remuneration": "3226",
    "allocation": "1613",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4839",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4723",
    "nom_corrige2": "Patrick Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "3224",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4836",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4724",
    "nom_corrige2": "Guillaume Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "3224",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4836",
    "ville": "Sainte-Eulalie",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1007"
  },
  {
    "ID": "4725",
    "nom_corrige2": "Marc-André Routhier",
    "nom_famille": "Routhier",
    "titre_genre2": "Conseiller",
    "remuneration": "3224",
    "allocation": "1612",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4836",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4726",
    "nom_corrige2": "Annabelle Aubin",
    "nom_famille": "Aubin",
    "titre_genre2": "Conseillère",
    "remuneration": "3366",
    "allocation": "1465",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4831",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "4727",
    "nom_corrige2": "Paul Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "3509",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4828",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4728",
    "nom_corrige2": "Kim Jones",
    "nom_famille": "Jones",
    "titre_genre2": "Conseillère",
    "remuneration": "3509",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4828",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4729",
    "nom_corrige2": "Sébastien Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "3325",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4825",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "4730",
    "nom_corrige2": "Frédéric Martineau",
    "nom_famille": "Martineau",
    "titre_genre2": "Conseiller",
    "remuneration": "3553",
    "allocation": "1264",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4817",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4731",
    "nom_corrige2": "Gino Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4809",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4732",
    "nom_corrige2": "Rémi Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4809",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4733",
    "nom_corrige2": "Diane Rancourt",
    "nom_famille": "Rancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4809",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4734",
    "nom_corrige2": "Patrick St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4809",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4735",
    "nom_corrige2": "Claude Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "3206",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4809",
    "ville": "Courcelles",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "811"
  },
  {
    "ID": "4736",
    "nom_corrige2": "Jean-Luc Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4808",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4737",
    "nom_corrige2": "Marcellin Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4808",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4738",
    "nom_corrige2": "Daniel Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4808",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4739",
    "nom_corrige2": "Robert Jolin",
    "nom_famille": "Jolin",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4808",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4740",
    "nom_corrige2": "Gilbert Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "3205",
    "allocation": "1603",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4808",
    "ville": "Saint-Robert-Bellarmin",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "4741",
    "nom_corrige2": "JAMES TEMPLETON",
    "nom_famille": "TEMPLETON",
    "titre_genre2": "Conseiller",
    "remuneration": "3180",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4807",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4742",
    "nom_corrige2": "DANNY ANDERSON",
    "nom_famille": "ANDERSON",
    "titre_genre2": "Conseiller",
    "remuneration": "3180",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4807",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4743",
    "nom_corrige2": "Georges Chapados",
    "nom_famille": "Chapados",
    "titre_genre2": "Conseiller",
    "remuneration": "3201",
    "allocation": "1600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4801",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "4744",
    "nom_corrige2": "Nancy Huard",
    "nom_famille": "Huard",
    "titre_genre2": "Conseillère",
    "remuneration": "3201",
    "allocation": "1600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4801",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "4745",
    "nom_corrige2": "Sylvie Lecourtois",
    "nom_famille": "Lecourtois",
    "titre_genre2": "Conseillère",
    "remuneration": "3201",
    "allocation": "1600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4801",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "4746",
    "nom_corrige2": "Johanne Horth",
    "nom_famille": "Horth",
    "titre_genre2": "Conseillère",
    "remuneration": "3201",
    "allocation": "1600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4801",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "4747",
    "nom_corrige2": "Francis Lehoux",
    "nom_famille": "Lehoux",
    "titre_genre2": "Conseiller",
    "remuneration": "3300",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4800",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "4748",
    "nom_corrige2": "MARLÈNE LANDRY",
    "nom_famille": "LANDRY",
    "titre_genre2": "Mairesse",
    "remuneration": "3200",
    "allocation": "1600",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4800",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "4749",
    "nom_corrige2": "Danny Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "3449",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4768",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4750",
    "nom_corrige2": "François Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "3178",
    "allocation": "1589",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4767",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "4751",
    "nom_corrige2": "Dominic Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "3178",
    "allocation": "1589",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4767",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4752",
    "nom_corrige2": "Sébastien Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "3178",
    "allocation": "1589",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4767",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4753",
    "nom_corrige2": "André Trudel",
    "nom_famille": "Trudel",
    "titre_genre2": "Conseiller",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4754",
    "nom_corrige2": "Pascal Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseiller",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4755",
    "nom_corrige2": "Aurèle Cadieux",
    "nom_famille": "Cadieux",
    "titre_genre2": "Conseiller",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4756",
    "nom_corrige2": "Manon Cadieux",
    "nom_famille": "Cadieux",
    "titre_genre2": "Conseillère",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4757",
    "nom_corrige2": "Éric Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4758",
    "nom_corrige2": "Mélanie Larente",
    "nom_famille": "Larente",
    "titre_genre2": "Conseillère",
    "remuneration": "3173",
    "allocation": "1587",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4760",
    "ville": "Mont-Saint-Michel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "615"
  },
  {
    "ID": "4759",
    "nom_corrige2": "Jean-Maurice Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseiller",
    "remuneration": "3170",
    "allocation": "1585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4755",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "4760",
    "nom_corrige2": "Marie Galipeau",
    "nom_famille": "Galipeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3170",
    "allocation": "1585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4755",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "4761",
    "nom_corrige2": "Judith Fouquet",
    "nom_famille": "Fouquet",
    "titre_genre2": "Conseillère",
    "remuneration": "3170",
    "allocation": "1585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4755",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "4762",
    "nom_corrige2": "Sylvie Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseillère",
    "remuneration": "3170",
    "allocation": "1585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4755",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "4763",
    "nom_corrige2": "Alyssa Ann Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "3170",
    "allocation": "1585",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4755",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "4764",
    "nom_corrige2": "Jasmine Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4765",
    "nom_corrige2": "Bernard Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "3500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4766",
    "nom_corrige2": "Sylvain Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "3500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4767",
    "nom_corrige2": "Daniel Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "3250",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "4768",
    "nom_corrige2": "Jacynthe Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseillère",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4769",
    "nom_corrige2": "Jean Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4770",
    "nom_corrige2": "Magella Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4771",
    "nom_corrige2": "Isabelle Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4772",
    "nom_corrige2": "Steeve Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "3167",
    "allocation": "1583",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4750",
    "ville": "Rivière-Éternité",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "413"
  },
  {
    "ID": "4773",
    "nom_corrige2": "Aline Alain",
    "nom_famille": "Alain",
    "titre_genre2": "Conseillère",
    "remuneration": "3163",
    "allocation": "1581",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4744",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "4774",
    "nom_corrige2": "Réjean Bournival",
    "nom_famille": "Bournival",
    "titre_genre2": "Conseiller",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4775",
    "nom_corrige2": "Cindy Cotten",
    "nom_famille": "Cotten",
    "titre_genre2": "Conseillère",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4776",
    "nom_corrige2": "Bertrand Julien",
    "nom_famille": "Julien",
    "titre_genre2": "Conseiller",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4777",
    "nom_corrige2": "Claude Lemens",
    "nom_famille": "Lemens",
    "titre_genre2": "Conseiller",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4778",
    "nom_corrige2": "Manon Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseillère",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4779",
    "nom_corrige2": "Normand Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "3230",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4743",
    "ville": "Laverlochère-Angliers",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "969"
  },
  {
    "ID": "4780",
    "nom_corrige2": "Valérie Camiré",
    "nom_famille": "Camiré",
    "titre_genre2": "Conseillère",
    "remuneration": "3389",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4708",
    "ville": "Saint-Télesphore",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "788"
  },
  {
    "ID": "4781",
    "nom_corrige2": "JONATHAN CRAIG",
    "nom_famille": "CRAIG",
    "titre_genre2": "Conseiller",
    "remuneration": "3080",
    "allocation": "1627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4707",
    "ville": "Très-Saint-Sacrement",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1263"
  },
  {
    "ID": "4782",
    "nom_corrige2": "Gaétan Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4783",
    "nom_corrige2": "Nicole Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseillère",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4784",
    "nom_corrige2": "Michelle Richer",
    "nom_famille": "Richer",
    "titre_genre2": "Conseillère",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4785",
    "nom_corrige2": "Paolo Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4786",
    "nom_corrige2": "Luc Van Velzen",
    "nom_famille": "Van",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4787",
    "nom_corrige2": "Pierre Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4706",
    "ville": "Saint-Valentin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "475"
  },
  {
    "ID": "4788",
    "nom_corrige2": "John Abraham",
    "nom_famille": "Abraham",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4705",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4789",
    "nom_corrige2": "Roland Barnabé",
    "nom_famille": "Barnabé",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4705",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4790",
    "nom_corrige2": "Lorraine Rochon",
    "nom_famille": "Rochon",
    "titre_genre2": "Conseillère",
    "remuneration": "3137",
    "allocation": "1568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4705",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4791",
    "nom_corrige2": "Gerald Teske",
    "nom_famille": "Teske",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4705",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4792",
    "nom_corrige2": "Jocelyn Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseiller",
    "remuneration": "3136",
    "allocation": "1568",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4704",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "4793",
    "nom_corrige2": "Jean-Marie Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "3135",
    "allocation": "1567",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4702",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "4794",
    "nom_corrige2": "Josée Letendre",
    "nom_famille": "Letendre",
    "titre_genre2": "Conseillère",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4795",
    "nom_corrige2": "Marc Ladouceur",
    "nom_famille": "Ladouceur",
    "titre_genre2": "Conseiller",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4796",
    "nom_corrige2": "Antoine Letendre",
    "nom_famille": "Letendre",
    "titre_genre2": "Conseiller",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4797",
    "nom_corrige2": "Julie Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4798",
    "nom_corrige2": "Linda Provencher",
    "nom_famille": "Provencher",
    "titre_genre2": "Conseillère",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4799",
    "nom_corrige2": "Patrice Pinard",
    "nom_famille": "Pinard",
    "titre_genre2": "Conseiller",
    "remuneration": "3132",
    "allocation": "1566",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4698",
    "ville": "Saint-Georges-de-Windsor",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "996"
  },
  {
    "ID": "4800",
    "nom_corrige2": "David Boissonneault",
    "nom_famille": "Boissonneault",
    "titre_genre2": "Conseiller",
    "remuneration": "3429",
    "allocation": "1264",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4693",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4801",
    "nom_corrige2": "Pierre-Yves Pettigrew Blanchet",
    "nom_famille": "Pettigrew",
    "titre_genre2": "Conseiller",
    "remuneration": "3429",
    "allocation": "1264",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4693",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4802",
    "nom_corrige2": "Patricia Rachofsky",
    "nom_famille": "Rachofsky",
    "titre_genre2": "Conseillère",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4803",
    "nom_corrige2": "Jean Joannes Asnong",
    "nom_famille": "Asnong",
    "titre_genre2": "Conseiller",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4804",
    "nom_corrige2": "Justin Raymond",
    "nom_famille": "Raymond",
    "titre_genre2": "Conseiller",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4805",
    "nom_corrige2": "David Gasser",
    "nom_famille": "Gasser",
    "titre_genre2": "Conseiller",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4806",
    "nom_corrige2": "Stéphan Duquette",
    "nom_famille": "Duquette",
    "titre_genre2": "Conseiller",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4807",
    "nom_corrige2": "Hélène Campbell",
    "nom_famille": "Campbell",
    "titre_genre2": "Conseillère",
    "remuneration": "3123",
    "allocation": "1562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4685",
    "ville": "Pike River",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "541"
  },
  {
    "ID": "4808",
    "nom_corrige2": "David Gouin",
    "nom_famille": "Gouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3175",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4675",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "4809",
    "nom_corrige2": "Charles Meunier",
    "nom_famille": "Meunier",
    "titre_genre2": "Conseiller",
    "remuneration": "3137",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4666",
    "ville": "Mulgrave-et-Derry",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "387"
  },
  {
    "ID": "4810",
    "nom_corrige2": "Denis Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4811",
    "nom_corrige2": "Stéphane Arbour",
    "nom_famille": "Arbour",
    "titre_genre2": "Conseiller",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4812",
    "nom_corrige2": "Manon Loyer",
    "nom_famille": "Loyer",
    "titre_genre2": "Conseillère",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4813",
    "nom_corrige2": "Benoit Duval",
    "nom_famille": "Duval",
    "titre_genre2": "Conseiller",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4814",
    "nom_corrige2": "Lyne Rivest",
    "nom_famille": "Rivest",
    "titre_genre2": "Conseillère",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4815",
    "nom_corrige2": "Jade Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseillère",
    "remuneration": "3110",
    "allocation": "1555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4665",
    "ville": "Saint-Pierre",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "295"
  },
  {
    "ID": "4816",
    "nom_corrige2": "Sandra Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseillère",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4817",
    "nom_corrige2": "Jean-Guy St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4818",
    "nom_corrige2": "Jean-Yves Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4819",
    "nom_corrige2": "Chantal Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4820",
    "nom_corrige2": "Melyssa Talbot Blais",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseillère",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4821",
    "nom_corrige2": "Isabelle Furlott",
    "nom_famille": "Furlott",
    "titre_genre2": "Conseillère",
    "remuneration": "3109",
    "allocation": "1554",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4663",
    "ville": "Saint-François-de-la-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1645"
  },
  {
    "ID": "4822",
    "nom_corrige2": "Gilles Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "571",
    "allocation2": "286",
    "total": "4652",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "4823",
    "nom_corrige2": "Gilbert Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseiller",
    "remuneration": "2835",
    "allocation": "1417",
    "remuneration2": "267",
    "allocation2": "133",
    "total": "4652",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "4824",
    "nom_corrige2": "SERGE BOUCHER",
    "nom_famille": "BOUCHER",
    "titre_genre2": "Conseiller",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4825",
    "nom_corrige2": "MARYSE COURCHESNE",
    "nom_famille": "COURCHESNE",
    "titre_genre2": "Conseillère",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4826",
    "nom_corrige2": "JACINTHE DRAINVILLE",
    "nom_famille": "DRAINVILLE",
    "titre_genre2": "Conseillère",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4827",
    "nom_corrige2": "STEPHANE LAMARRE",
    "nom_famille": "LAMARRE",
    "titre_genre2": "Conseiller",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4828",
    "nom_corrige2": "FRANÇOIS DRAINVILLE",
    "nom_famille": "DRAINVILLE",
    "titre_genre2": "Conseiller",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4829",
    "nom_corrige2": "ANDRÉ RONDEAU",
    "nom_famille": "RONDEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "3095",
    "allocation": "1547",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4642",
    "ville": "La Visitation-de-l'Île-Dupas",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "678"
  },
  {
    "ID": "4830",
    "nom_corrige2": "André Marcotte",
    "nom_famille": "Marcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "3220",
    "allocation": "1054",
    "remuneration2": "239",
    "allocation2": "120",
    "total": "4633",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "4831",
    "nom_corrige2": "Valérie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "3088",
    "allocation": "1544",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4632",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4832",
    "nom_corrige2": "Éric Chassé",
    "nom_famille": "Chassé",
    "titre_genre2": "Conseiller",
    "remuneration": "3105",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4631",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "4833",
    "nom_corrige2": "Réjean Veillette",
    "nom_famille": "Veillette",
    "titre_genre2": "Maire",
    "remuneration": "3080",
    "allocation": "1540",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4620",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "4834",
    "nom_corrige2": "Yvon Boulianne",
    "nom_famille": "Boulianne",
    "titre_genre2": "Conseiller",
    "remuneration": "3262",
    "allocation": "1357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4619",
    "ville": "L'Isle-aux-Coudres",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1098"
  },
  {
    "ID": "4835",
    "nom_corrige2": "Éric Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "3146",
    "allocation": "1473",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4619",
    "ville": "Saint-Ignace-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "752"
  },
  {
    "ID": "4836",
    "nom_corrige2": "Daniel Laflèche",
    "nom_famille": "Laflèche",
    "titre_genre2": "Conseiller",
    "remuneration": "3101",
    "allocation": "1517",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4618",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "4837",
    "nom_corrige2": "Marcel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Maire",
    "remuneration": "3075",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4612",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "4838",
    "nom_corrige2": "Éric Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3074",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4611",
    "ville": "Saints-Anges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1246"
  },
  {
    "ID": "4839",
    "nom_corrige2": "Roger Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3074",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4611",
    "ville": "Saints-Anges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1246"
  },
  {
    "ID": "4840",
    "nom_corrige2": "Nathalie Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "3074",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4611",
    "ville": "Saints-Anges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1246"
  },
  {
    "ID": "4841",
    "nom_corrige2": "Dolorès Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseillère",
    "remuneration": "3074",
    "allocation": "1537",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4611",
    "ville": "Saints-Anges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1246"
  },
  {
    "ID": "4842",
    "nom_corrige2": "Marcelino Jobin",
    "nom_famille": "Jobin",
    "titre_genre2": "Conseiller",
    "remuneration": "3078",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4607",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "4843",
    "nom_corrige2": "Caroline Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "3133",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4601",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4844",
    "nom_corrige2": "Jean-Louis Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4586",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4845",
    "nom_corrige2": "Simon Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseiller",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4586",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4846",
    "nom_corrige2": "Line Fradette",
    "nom_famille": "Fradette",
    "titre_genre2": "Conseillère",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4586",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4847",
    "nom_corrige2": "Normand Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4586",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4848",
    "nom_corrige2": "Annick Patoine",
    "nom_famille": "Patoine",
    "titre_genre2": "Conseillère",
    "remuneration": "3057",
    "allocation": "1529",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4586",
    "ville": "Saint-Damien-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1805"
  },
  {
    "ID": "4849",
    "nom_corrige2": "Jean-Francois Major",
    "nom_famille": "Major",
    "titre_genre2": "Conseiller",
    "remuneration": "3680",
    "allocation": "903",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4583",
    "ville": "Saint-Évariste-de-Forsyth",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "593"
  },
  {
    "ID": "4850",
    "nom_corrige2": "Guy Whissell",
    "nom_famille": "Whissell",
    "titre_genre2": "Conseiller",
    "remuneration": "3052",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4851",
    "nom_corrige2": "Stéphane Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "3052",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4852",
    "nom_corrige2": "Maryse Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "3052",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4853",
    "nom_corrige2": "Andrée-Anne Bock",
    "nom_famille": "Bock",
    "titre_genre2": "Conseillère",
    "remuneration": "3052",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4854",
    "nom_corrige2": "Johanne Larocque",
    "nom_famille": "Larocque",
    "titre_genre2": "Conseillère",
    "remuneration": "3052",
    "allocation": "1526",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Notre-Dame-de-la-Paix",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "695"
  },
  {
    "ID": "4855",
    "nom_corrige2": "Michel Trottier",
    "nom_famille": "Trottier",
    "titre_genre2": "Conseiller",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4856",
    "nom_corrige2": "Aaron Bass",
    "nom_famille": "Bass",
    "titre_genre2": "Conseiller",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4857",
    "nom_corrige2": "Georges Mayrand",
    "nom_famille": "Mayrand",
    "titre_genre2": "Conseiller",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4858",
    "nom_corrige2": "André Filteau",
    "nom_famille": "Filteau",
    "titre_genre2": "Conseiller",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4859",
    "nom_corrige2": "Danielle Duchesneau DuSablon",
    "nom_famille": "Duchesneau",
    "titre_genre2": "Conseillère",
    "remuneration": "3097",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4578",
    "ville": "Saint-Casimir",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1408"
  },
  {
    "ID": "4860",
    "nom_corrige2": "PASCAL LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "3047",
    "allocation": "1523",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4570",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "4861",
    "nom_corrige2": "Jayne Mcnaughton",
    "nom_famille": "Mcnaughton",
    "titre_genre2": "Conseillère",
    "remuneration": "3754",
    "allocation": "814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4568",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "4862",
    "nom_corrige2": "Louis-Gabriel Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "3091",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4566",
    "ville": "Saint-Antoine-de-Tilly",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1729"
  },
  {
    "ID": "4863",
    "nom_corrige2": "Stevens Perry Pelletier",
    "nom_famille": "Perry",
    "titre_genre2": "Conseiller",
    "remuneration": "3041",
    "allocation": "1521",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "4864",
    "nom_corrige2": "Maxime Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "3041",
    "allocation": "1521",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "4865",
    "nom_corrige2": "Johanne D'Amours",
    "nom_famille": "D'Amours",
    "titre_genre2": "Conseillère",
    "remuneration": "3041",
    "allocation": "1521",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "4866",
    "nom_corrige2": "Denis Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "3041",
    "allocation": "1521",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "4867",
    "nom_corrige2": "Geneviève Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "3041",
    "allocation": "1521",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "4868",
    "nom_corrige2": "Mario Nolet",
    "nom_famille": "Nolet",
    "titre_genre2": "Conseiller",
    "remuneration": "2814",
    "allocation": "1748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4562",
    "ville": "Saint-Joseph-de-Coleraine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1840"
  },
  {
    "ID": "4869",
    "nom_corrige2": "Gabriel Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "3041",
    "allocation": "1520",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4561",
    "ville": "Lorrainville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1221"
  },
  {
    "ID": "4870",
    "nom_corrige2": "Émile-Olivier Desgens",
    "nom_famille": "Desgens",
    "titre_genre2": "Conseiller",
    "remuneration": "3102",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4558",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "4871",
    "nom_corrige2": "Carl Massé",
    "nom_famille": "Massé",
    "titre_genre2": "Conseiller",
    "remuneration": "2887",
    "allocation": "1444",
    "remuneration2": "149",
    "allocation2": "74",
    "total": "4554",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "4872",
    "nom_corrige2": "Fannie Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseillère",
    "remuneration": "3052",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4552",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "4873",
    "nom_corrige2": "Julie L'Homme",
    "nom_famille": "L'Homme",
    "titre_genre2": "Conseillère",
    "remuneration": "2386",
    "allocation": "1093",
    "remuneration2": "714",
    "allocation2": "357",
    "total": "4550",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "4874",
    "nom_corrige2": "Francine Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseillère",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4875",
    "nom_corrige2": "Valérie Rancourt",
    "nom_famille": "Rancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4876",
    "nom_corrige2": "Claude Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseiller",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4877",
    "nom_corrige2": "Réal Rancourt",
    "nom_famille": "Rancourt",
    "titre_genre2": "Conseiller",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4878",
    "nom_corrige2": "Hugh Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4879",
    "nom_corrige2": "Priscillia L. Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "3033",
    "allocation": "1516",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4549",
    "ville": "Poularies",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "683"
  },
  {
    "ID": "4880",
    "nom_corrige2": "Jennylee Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseillère",
    "remuneration": "3029",
    "allocation": "1514",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4543",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "4881",
    "nom_corrige2": "Marc St-Louis",
    "nom_famille": "St-Louis",
    "titre_genre2": "Conseiller",
    "remuneration": "3025",
    "allocation": "1513",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4538",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "4882",
    "nom_corrige2": "Sylvain Hinse",
    "nom_famille": "Hinse",
    "titre_genre2": "Conseiller",
    "remuneration": "2897",
    "allocation": "1448",
    "remuneration2": "127",
    "allocation2": "64",
    "total": "4536",
    "ville": "Tingwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1486"
  },
  {
    "ID": "4883",
    "nom_corrige2": "Patrick Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "3013",
    "allocation": "1515",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4528",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "4884",
    "nom_corrige2": "André Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseiller",
    "remuneration": "2915",
    "allocation": "1457",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "4523",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "4885",
    "nom_corrige2": "Frédéric Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "3005",
    "allocation": "1515",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4520",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "4886",
    "nom_corrige2": "Richard Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Conseiller",
    "remuneration": "3005",
    "allocation": "1515",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4520",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "4887",
    "nom_corrige2": "Normand Lizotte",
    "nom_famille": "Lizotte",
    "titre_genre2": "Conseiller",
    "remuneration": "3005",
    "allocation": "1515",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4520",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "4888",
    "nom_corrige2": "Roberto Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "3005",
    "allocation": "1515",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4520",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "4889",
    "nom_corrige2": "Sylvain Clair",
    "nom_famille": "Clair",
    "titre_genre2": "Conseiller",
    "remuneration": "3011",
    "allocation": "1506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4517",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "4890",
    "nom_corrige2": "Karl Lindsay",
    "nom_famille": "Lindsay",
    "titre_genre2": "Conseiller",
    "remuneration": "3011",
    "allocation": "1506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4517",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "4891",
    "nom_corrige2": "Claude Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "3011",
    "allocation": "1506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4517",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "4892",
    "nom_corrige2": "Jeanot Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "3009",
    "allocation": "1505",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4514",
    "ville": "Palmarolle",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1407"
  },
  {
    "ID": "4893",
    "nom_corrige2": "Daniel Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "3009",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4513",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "4894",
    "nom_corrige2": "Étienne Ménard",
    "nom_famille": "Ménard",
    "titre_genre2": "Conseiller",
    "remuneration": "3007",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4511",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4895",
    "nom_corrige2": "Gino Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "3007",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4511",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4896",
    "nom_corrige2": "Samuel Larochelle",
    "nom_famille": "Larochelle",
    "titre_genre2": "Conseiller",
    "remuneration": "3007",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4511",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4897",
    "nom_corrige2": "Martine Rouillard",
    "nom_famille": "Rouillard",
    "titre_genre2": "Conseillère",
    "remuneration": "3007",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4511",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4898",
    "nom_corrige2": "Anne-Marie Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseillère",
    "remuneration": "3007",
    "allocation": "1504",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4511",
    "ville": "Saint-Magloire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "688"
  },
  {
    "ID": "4899",
    "nom_corrige2": "Brian George Cooke",
    "nom_famille": "Cooke",
    "titre_genre2": "Conseiller",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "4900",
    "nom_corrige2": "Jean-Philippe Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "2905",
    "allocation": "1453",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "4509",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "4901",
    "nom_corrige2": "Denis Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4902",
    "nom_corrige2": "Mélissa Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4903",
    "nom_corrige2": "Marc-André Ouellette",
    "nom_famille": "Ouellette",
    "titre_genre2": "Conseiller",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4904",
    "nom_corrige2": "Nancy Prescott",
    "nom_famille": "Prescott",
    "titre_genre2": "Conseillère",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4905",
    "nom_corrige2": "Guylaine Bhérer",
    "nom_famille": "Bhérer",
    "titre_genre2": "Conseillère",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4906",
    "nom_corrige2": "Eric Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "3006",
    "allocation": "1503",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4509",
    "ville": "Saint-Henri-de-Taillon",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "915"
  },
  {
    "ID": "4907",
    "nom_corrige2": "Jean Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4908",
    "nom_corrige2": "Christine Charlebois",
    "nom_famille": "Charlebois",
    "titre_genre2": "Conseillère",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4909",
    "nom_corrige2": "Claudy Malenfant",
    "nom_famille": "Malenfant",
    "titre_genre2": "Conseillère",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4910",
    "nom_corrige2": "Émile Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4911",
    "nom_corrige2": "Alain Forget",
    "nom_famille": "Forget",
    "titre_genre2": "Conseiller",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4912",
    "nom_corrige2": "Danny Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "3381",
    "allocation": "1127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4508",
    "ville": "Sainte-Rita",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "306"
  },
  {
    "ID": "4913",
    "nom_corrige2": "Marco Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "3003",
    "allocation": "1501",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4504",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "4914",
    "nom_corrige2": "Claude Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "3002",
    "allocation": "1501",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4503",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "4915",
    "nom_corrige2": "Yves Barriault",
    "nom_famille": "Barriault",
    "titre_genre2": "Conseiller",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4916",
    "nom_corrige2": "Steven Allain",
    "nom_famille": "Allain",
    "titre_genre2": "Conseiller",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4917",
    "nom_corrige2": "François Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4918",
    "nom_corrige2": "Caroline Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Conseillère",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4919",
    "nom_corrige2": "Valérie Cyr-Cayouette",
    "nom_famille": "Cyr-Cayouette",
    "titre_genre2": "Conseillère",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4920",
    "nom_corrige2": "Laurent St-Onge",
    "nom_famille": "St-Onge",
    "titre_genre2": "Conseiller",
    "remuneration": "3001",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4501",
    "ville": "Saint-Alphonse",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "730"
  },
  {
    "ID": "4921",
    "nom_corrige2": "Gaétan Petit",
    "nom_famille": "Petit",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "4922",
    "nom_corrige2": "Stephan Tellier",
    "nom_famille": "Tellier",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "4923",
    "nom_corrige2": "Michel Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "4924",
    "nom_corrige2": "Patrick Casaubon",
    "nom_famille": "Casaubon",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "4925",
    "nom_corrige2": "Gilles Tétrault",
    "nom_famille": "Tétrault",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4926",
    "nom_corrige2": "Sandra Lavoratore",
    "nom_famille": "Lavoratore",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4927",
    "nom_corrige2": "Gilles Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4928",
    "nom_corrige2": "Lucie Lacelle",
    "nom_famille": "Lacelle",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4929",
    "nom_corrige2": "Christiane Berniquez",
    "nom_famille": "Berniquez",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Pointe-Fortune",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "616"
  },
  {
    "ID": "4930",
    "nom_corrige2": "Julie Dechamplain",
    "nom_famille": "Dechamplain",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "1500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4500",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "4931",
    "nom_corrige2": "Lucette Hallée",
    "nom_famille": "Hallée",
    "titre_genre2": "Conseillère",
    "remuneration": "2860",
    "allocation": "1481",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "4492",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "4932",
    "nom_corrige2": "Pierre Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "360",
    "allocation2": "459",
    "total": "4488",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "4933",
    "nom_corrige2": "Michelle Payette",
    "nom_famille": "Payette",
    "titre_genre2": "Conseillère",
    "remuneration": "3324",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Bois-Franc",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "411"
  },
  {
    "ID": "4934",
    "nom_corrige2": "Roger Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4935",
    "nom_corrige2": "Alain Provençal",
    "nom_famille": "Provençal",
    "titre_genre2": "Conseiller",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4936",
    "nom_corrige2": "Lisette Gosselin Alix",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4937",
    "nom_corrige2": "Jonathan Larouche",
    "nom_famille": "Larouche",
    "titre_genre2": "Conseiller",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4938",
    "nom_corrige2": "Alexandre Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4939",
    "nom_corrige2": "Lyse Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "2990",
    "allocation": "1497",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4487",
    "ville": "Saint-Léon-de-Standon",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1068"
  },
  {
    "ID": "4940",
    "nom_corrige2": "Suzanne Lefrançois",
    "nom_famille": "Lefrançois",
    "titre_genre2": "Conseillère",
    "remuneration": "2980",
    "allocation": "1490",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4470",
    "ville": "Saint-Herménégilde",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "721"
  },
  {
    "ID": "4941",
    "nom_corrige2": "Roger Heath",
    "nom_famille": "Heath",
    "titre_genre2": "Conseiller",
    "remuneration": "2976",
    "allocation": "1488",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4464",
    "ville": "Dixville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "760"
  },
  {
    "ID": "4942",
    "nom_corrige2": "Anny Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4943",
    "nom_corrige2": "Mélissa Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4944",
    "nom_corrige2": "Katie Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4945",
    "nom_corrige2": "Martine Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4946",
    "nom_corrige2": "Corinne Marquis",
    "nom_famille": "Marquis",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4947",
    "nom_corrige2": "Karine Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseillère",
    "remuneration": "2975",
    "allocation": "1487",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4462",
    "ville": "Saint-Marc-du-Lac-Long",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "382"
  },
  {
    "ID": "4948",
    "nom_corrige2": "Gilles Lefort",
    "nom_famille": "Lefort",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4452",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "4949",
    "nom_corrige2": "Jocelyn Berneche",
    "nom_famille": "Berneche",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4452",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "4950",
    "nom_corrige2": "Loydy Brousseau",
    "nom_famille": "Brousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4452",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "4951",
    "nom_corrige2": "Pierre-Louis Gilbert-Gauthier",
    "nom_famille": "Gilbert-Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4452",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "4952",
    "nom_corrige2": "Gilles Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Conseiller",
    "remuneration": "2968",
    "allocation": "1484",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4452",
    "ville": "Duhamel-Ouest",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "891"
  },
  {
    "ID": "4953",
    "nom_corrige2": "Gaétane Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "2961",
    "allocation": "1481",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4442",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "4954",
    "nom_corrige2": "Geneviève Ruel",
    "nom_famille": "Ruel",
    "titre_genre2": "Conseillère",
    "remuneration": "3217",
    "allocation": "1222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4439",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4955",
    "nom_corrige2": "Lucie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "3217",
    "allocation": "1222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4439",
    "ville": "Lyster",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1662"
  },
  {
    "ID": "4956",
    "nom_corrige2": "Richard Lefrançois",
    "nom_famille": "Lefrançois",
    "titre_genre2": "Conseiller",
    "remuneration": "3224",
    "allocation": "1215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4439",
    "ville": "Saint-Jacques-de-Leeds",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "707"
  },
  {
    "ID": "4957",
    "nom_corrige2": "Ariel Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseillère",
    "remuneration": "3292",
    "allocation": "1146",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4438",
    "ville": "Saint-Louis-de-Gonzague",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "379"
  },
  {
    "ID": "4958",
    "nom_corrige2": "Sébastien Lamarre",
    "nom_famille": "Lamarre",
    "titre_genre2": "Conseiller",
    "remuneration": "2957",
    "allocation": "1478",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4435",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "4959",
    "nom_corrige2": "Gaétan St-Jean",
    "nom_famille": "St-Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "2986",
    "allocation": "1448",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4434",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "4960",
    "nom_corrige2": "Lucie Bourdon",
    "nom_famille": "Bourdon",
    "titre_genre2": "Conseillère",
    "remuneration": "3618",
    "allocation": "814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4432",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "4961",
    "nom_corrige2": "Christopher Hill",
    "nom_famille": "Hill",
    "titre_genre2": "Conseiller",
    "remuneration": "3618",
    "allocation": "814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4432",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "4962",
    "nom_corrige2": "Normand Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "2954",
    "allocation": "1477",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4431",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "4963",
    "nom_corrige2": "Suzy Bellerose",
    "nom_famille": "Bellerose",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4964",
    "nom_corrige2": "Martin Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseiller",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4965",
    "nom_corrige2": "Carl Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseiller",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4966",
    "nom_corrige2": "Pierre Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4967",
    "nom_corrige2": "Julie Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4968",
    "nom_corrige2": "Isabelle Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1480",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4430",
    "ville": "Laurierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1356"
  },
  {
    "ID": "4969",
    "nom_corrige2": "Linda Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "95",
    "allocation2": "48",
    "total": "4430",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "4970",
    "nom_corrige2": "Gilles Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "2950",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4425",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4971",
    "nom_corrige2": "Marilyne Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4425",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4972",
    "nom_corrige2": "Stéphanie Bard",
    "nom_famille": "Bard",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4425",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4973",
    "nom_corrige2": "Francine Bard",
    "nom_famille": "Bard",
    "titre_genre2": "Conseillère",
    "remuneration": "2950",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4425",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4974",
    "nom_corrige2": "Gabriel D'Anjou",
    "nom_famille": "D'Anjou",
    "titre_genre2": "Conseiller",
    "remuneration": "2950",
    "allocation": "1475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4425",
    "ville": "Saint-Gabriel-Lalemant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "663"
  },
  {
    "ID": "4975",
    "nom_corrige2": "GÉRALD BÉRARD",
    "nom_famille": "BÉRARD",
    "titre_genre2": "Conseiller",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4976",
    "nom_corrige2": "MAXIME CASTONGUAY",
    "nom_famille": "CASTONGUAY",
    "titre_genre2": "Conseiller",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4977",
    "nom_corrige2": "GERVAIS PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseiller",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4978",
    "nom_corrige2": "CLAUDE HUDON",
    "nom_famille": "HUDON",
    "titre_genre2": "Conseiller",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4979",
    "nom_corrige2": "ROXANE MARTINE COUTU",
    "nom_famille": "COUTU",
    "titre_genre2": "Conseillère",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4980",
    "nom_corrige2": "SYLVIE TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseillère",
    "remuneration": "2948",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4422",
    "ville": "Saint-Roch-des-Aulnaies",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "993"
  },
  {
    "ID": "4981",
    "nom_corrige2": "Michel Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2947",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4421",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "4982",
    "nom_corrige2": "GUY Gignac",
    "nom_famille": "Gignac",
    "titre_genre2": "Conseiller",
    "remuneration": "2947",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4421",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "4983",
    "nom_corrige2": "Manon Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "2947",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4421",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "4984",
    "nom_corrige2": "Joël Jobin",
    "nom_famille": "Jobin",
    "titre_genre2": "Conseiller",
    "remuneration": "2947",
    "allocation": "1474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4421",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "4985",
    "nom_corrige2": "Marie-Ève Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "2867",
    "allocation": "1553",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4420",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "4986",
    "nom_corrige2": "Jean-François Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseiller",
    "remuneration": "2867",
    "allocation": "1553",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4420",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "4987",
    "nom_corrige2": "Nicolas Guillemette",
    "nom_famille": "Guillemette",
    "titre_genre2": "Conseiller",
    "remuneration": "2867",
    "allocation": "1553",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4420",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "4988",
    "nom_corrige2": "Cédric Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "2867",
    "allocation": "1553",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4420",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "4989",
    "nom_corrige2": "Nancy Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "1778",
    "allocation": "1739",
    "remuneration2": "600",
    "allocation2": "300",
    "total": "4417",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "4990",
    "nom_corrige2": "Yvon Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4991",
    "nom_corrige2": "Lucie Coderre",
    "nom_famille": "Coderre",
    "titre_genre2": "Conseillère",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4992",
    "nom_corrige2": "Marco Scrosati",
    "nom_famille": "Scrosati",
    "titre_genre2": "Conseiller",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4993",
    "nom_corrige2": "Yves Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4994",
    "nom_corrige2": "Nicole Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4995",
    "nom_corrige2": "Étienne Hudon-Gagnon",
    "nom_famille": "Hudon-Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2949",
    "allocation": "1468",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4417",
    "ville": "Saint-Claude",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1203"
  },
  {
    "ID": "4996",
    "nom_corrige2": "Jean Poirier",
    "nom_famille": "Poirier",
    "titre_genre2": "Conseiller",
    "remuneration": "2940",
    "allocation": "1470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4410",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "4997",
    "nom_corrige2": "Bianca Vibert",
    "nom_famille": "Vibert",
    "titre_genre2": "Conseillère",
    "remuneration": "2940",
    "allocation": "1470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4410",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "4998",
    "nom_corrige2": "Pierre Vibert",
    "nom_famille": "Vibert",
    "titre_genre2": "Conseiller",
    "remuneration": "2940",
    "allocation": "1470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4410",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "4999",
    "nom_corrige2": "Jean Marc Collin",
    "nom_famille": "Collin",
    "titre_genre2": "Conseiller",
    "remuneration": "2940",
    "allocation": "1470",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4410",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "5000",
    "nom_corrige2": "Paul Lansbergen",
    "nom_famille": "Lansbergen",
    "titre_genre2": "Conseiller",
    "remuneration": "2939",
    "allocation": "1469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4408",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "5001",
    "nom_corrige2": "Édith Majeau",
    "nom_famille": "Majeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2939",
    "allocation": "1469",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4408",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "5002",
    "nom_corrige2": "Alphée Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Maire",
    "remuneration": "5866",
    "allocation": "2933",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "8799",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "5003",
    "nom_corrige2": "Jason Charland",
    "nom_famille": "Charland",
    "titre_genre2": "Conseiller",
    "remuneration": "2578",
    "allocation": "1814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4392",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "5004",
    "nom_corrige2": "Luc Viens",
    "nom_famille": "Viens",
    "titre_genre2": "Conseiller",
    "remuneration": "3159",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4389",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5005",
    "nom_corrige2": "NANCY LIZOTTE",
    "nom_famille": "LIZOTTE",
    "titre_genre2": "Conseillère",
    "remuneration": "2924",
    "allocation": "1462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4386",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "5006",
    "nom_corrige2": "NELSON THÉRIAULT",
    "nom_famille": "THÉRIAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "2924",
    "allocation": "1462",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4386",
    "ville": "Sainte-Irène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "341"
  },
  {
    "ID": "5007",
    "nom_corrige2": "Robin Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseiller",
    "remuneration": "2912",
    "allocation": "1466",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4378",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "5008",
    "nom_corrige2": "Stéphanie Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "2915",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4372",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "5009",
    "nom_corrige2": "Benoît Quirion",
    "nom_famille": "Quirion",
    "titre_genre2": "Conseiller",
    "remuneration": "2915",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4372",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "5010",
    "nom_corrige2": "Germain Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "2915",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4372",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "5011",
    "nom_corrige2": "Marthe Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "2915",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4372",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "5012",
    "nom_corrige2": "Gilles Héon",
    "nom_famille": "Héon",
    "titre_genre2": "Conseiller",
    "remuneration": "3605",
    "allocation": "1803",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "5408",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5013",
    "nom_corrige2": "Gabriel Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2913",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4370",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5014",
    "nom_corrige2": "Claude Leroux",
    "nom_famille": "Leroux",
    "titre_genre2": "Conseiller",
    "remuneration": "2913",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4370",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5015",
    "nom_corrige2": "Josée Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "2913",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4370",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5016",
    "nom_corrige2": "Stephan Rheault",
    "nom_famille": "Rheault",
    "titre_genre2": "Conseiller",
    "remuneration": "2913",
    "allocation": "1457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4370",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5017",
    "nom_corrige2": "Marco Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "2912",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4368",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "5018",
    "nom_corrige2": "Audrey Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseillère",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5019",
    "nom_corrige2": "Vincent Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5020",
    "nom_corrige2": "Sylvain Carbonneau",
    "nom_famille": "Carbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5021",
    "nom_corrige2": "Michel Pigeon",
    "nom_famille": "Pigeon",
    "titre_genre2": "Conseiller",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5022",
    "nom_corrige2": "Maryse Baillargeon",
    "nom_famille": "Baillargeon",
    "titre_genre2": "Conseillère",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5023",
    "nom_corrige2": "Eric Morency",
    "nom_famille": "Morency",
    "titre_genre2": "Conseiller",
    "remuneration": "2911",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4367",
    "ville": "Saint-Odilon-de-Cranbourne",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1367"
  },
  {
    "ID": "5024",
    "nom_corrige2": "Yannick Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2904",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4360",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "5025",
    "nom_corrige2": "Cynthia Gamache",
    "nom_famille": "Gamache",
    "titre_genre2": "Conseillère",
    "remuneration": "2904",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4360",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "5026",
    "nom_corrige2": "Josianne Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "2904",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4360",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "5027",
    "nom_corrige2": "Simon Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "2904",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4360",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "5028",
    "nom_corrige2": "Dany Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "2904",
    "allocation": "1456",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4360",
    "ville": "Saint-Modeste",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1164"
  },
  {
    "ID": "5029",
    "nom_corrige2": "Rock Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "2901",
    "allocation": "1450",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4351",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "5030",
    "nom_corrige2": "Guy Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseiller",
    "remuneration": "2940",
    "allocation": "1406",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4346",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "5031",
    "nom_corrige2": "Katy Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2940",
    "allocation": "1406",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4346",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "5032",
    "nom_corrige2": "Josée Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "2940",
    "allocation": "1406",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4346",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "5033",
    "nom_corrige2": "Guillaume Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5034",
    "nom_corrige2": "Jean-Noël Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Conseiller",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5035",
    "nom_corrige2": "Sébastien Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5036",
    "nom_corrige2": "Jérôme Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5037",
    "nom_corrige2": "Yves Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5038",
    "nom_corrige2": "Johanny Morneau-Briand",
    "nom_famille": "Morneau-Briand",
    "titre_genre2": "Conseillère",
    "remuneration": "2883",
    "allocation": "1454",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Saint-Louis-du-Ha! Ha!",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1265"
  },
  {
    "ID": "5039",
    "nom_corrige2": "Linda LEVESQUE",
    "nom_famille": "LEVESQUE",
    "titre_genre2": "Conseillère",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Packington",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "600"
  },
  {
    "ID": "5040",
    "nom_corrige2": "Carol Denis",
    "nom_famille": "Denis",
    "titre_genre2": "Conseillère",
    "remuneration": "2891",
    "allocation": "1446",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4337",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "5041",
    "nom_corrige2": "Cécile Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Conseillère",
    "remuneration": "2889",
    "allocation": "1445",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4334",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "5042",
    "nom_corrige2": "Dany Chapdelaine",
    "nom_famille": "Chapdelaine",
    "titre_genre2": "Conseiller",
    "remuneration": "2887",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4331",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "5043",
    "nom_corrige2": "Éric Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Conseiller",
    "remuneration": "2887",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4331",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "5044",
    "nom_corrige2": "Claude Jeanson",
    "nom_famille": "Jeanson",
    "titre_genre2": "Conseiller",
    "remuneration": "2887",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4331",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "5045",
    "nom_corrige2": "Valérie Fontaine-Martin",
    "nom_famille": "Fontaine-Martin",
    "titre_genre2": "Conseillère",
    "remuneration": "2887",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4331",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "5046",
    "nom_corrige2": "Joane Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5047",
    "nom_corrige2": "Simon Lafrenière",
    "nom_famille": "Lafrenière",
    "titre_genre2": "Conseiller",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5048",
    "nom_corrige2": "Jean Bellehumeur",
    "nom_famille": "Bellehumeur",
    "titre_genre2": "Conseiller",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5049",
    "nom_corrige2": "Frédéric Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5050",
    "nom_corrige2": "Claude Sévigny",
    "nom_famille": "Sévigny",
    "titre_genre2": "Conseiller",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5051",
    "nom_corrige2": "Lise Bellehumeur",
    "nom_famille": "Bellehumeur",
    "titre_genre2": "Conseillère",
    "remuneration": "2885",
    "allocation": "1444",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4329",
    "ville": "Chartierville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "291"
  },
  {
    "ID": "5052",
    "nom_corrige2": "Jesen Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseiller",
    "remuneration": "2904",
    "allocation": "1421",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4325",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "5053",
    "nom_corrige2": "Yvan Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseiller",
    "remuneration": "2880",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4320",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "5054",
    "nom_corrige2": "Réal Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "2880",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4320",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "5055",
    "nom_corrige2": "François Boulanger",
    "nom_famille": "Boulanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2880",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4320",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "5056",
    "nom_corrige2": "Jean-François Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseiller",
    "remuneration": "2880",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4320",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "5057",
    "nom_corrige2": "Jean-Guy Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseiller",
    "remuneration": "2880",
    "allocation": "1440",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4320",
    "ville": "Sainte-Cécile-de-Whitton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "905"
  },
  {
    "ID": "5058",
    "nom_corrige2": "Patrick Boisselle",
    "nom_famille": "Boisselle",
    "titre_genre2": "Conseiller",
    "remuneration": "2236",
    "allocation": "1093",
    "remuneration2": "660",
    "allocation2": "330",
    "total": "4319",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "5059",
    "nom_corrige2": "Henri Lampron",
    "nom_famille": "Lampron",
    "titre_genre2": "Conseiller",
    "remuneration": "2924",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4311",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5060",
    "nom_corrige2": "Chantal Lacoursière",
    "nom_famille": "Lacoursière",
    "titre_genre2": "Conseillère",
    "remuneration": "2873",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4310",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "5061",
    "nom_corrige2": "Mario Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseiller",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5062",
    "nom_corrige2": "Katy Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5063",
    "nom_corrige2": "Jean Lavigne",
    "nom_famille": "Lavigne",
    "titre_genre2": "Conseiller",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5064",
    "nom_corrige2": "Paul Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5065",
    "nom_corrige2": "Daniel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5066",
    "nom_corrige2": "David Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2870",
    "allocation": "1437",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4307",
    "ville": "Marston",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "776"
  },
  {
    "ID": "5067",
    "nom_corrige2": "Stéphane Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "2869",
    "allocation": "1435",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4304",
    "ville": "L'Isle-Verte",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1347"
  },
  {
    "ID": "5068",
    "nom_corrige2": "Sarah Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseillère",
    "remuneration": "2865",
    "allocation": "1432",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4297",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "5069",
    "nom_corrige2": "Paule Rochette",
    "nom_famille": "Rochette",
    "titre_genre2": "Conseillère",
    "remuneration": "2865",
    "allocation": "1432",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4297",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "5070",
    "nom_corrige2": "Mindy Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "2865",
    "allocation": "1432",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4297",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "5071",
    "nom_corrige2": "Catherine Demange",
    "nom_famille": "Demange",
    "titre_genre2": "Conseillère",
    "remuneration": "2865",
    "allocation": "1432",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4297",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "5072",
    "nom_corrige2": "Normand Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "3482",
    "allocation": "814",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4296",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "5073",
    "nom_corrige2": "Marcel Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4287",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "5074",
    "nom_corrige2": "André Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseiller",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4287",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "5075",
    "nom_corrige2": "Jean-Guy Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseiller",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4287",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "5076",
    "nom_corrige2": "Réjean Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseiller",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4287",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "5077",
    "nom_corrige2": "Mario Chiasson",
    "nom_famille": "Chiasson",
    "titre_genre2": "Conseiller",
    "remuneration": "2858",
    "allocation": "1429",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4287",
    "ville": "Sainte-Justine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1841"
  },
  {
    "ID": "5078",
    "nom_corrige2": "Ginette Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseillère",
    "remuneration": "2853",
    "allocation": "1427",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4280",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5079",
    "nom_corrige2": "Jonathan Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "2853",
    "allocation": "1427",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4280",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5080",
    "nom_corrige2": "Claude Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "2853",
    "allocation": "1427",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4280",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5081",
    "nom_corrige2": "Pier-Luc Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "2853",
    "allocation": "1427",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4280",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5082",
    "nom_corrige2": "Yvon Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "2933",
    "allocation": "1342",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4275",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "5083",
    "nom_corrige2": "Gilles Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "3220",
    "allocation": "1054",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4274",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "5084",
    "nom_corrige2": "Sabrina Turmel",
    "nom_famille": "Turmel",
    "titre_genre2": "Conseillère",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5085",
    "nom_corrige2": "Pierre-Paul Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseiller",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5086",
    "nom_corrige2": "Nicolas Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseiller",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5087",
    "nom_corrige2": "Frédéric Marcoux",
    "nom_famille": "Marcoux",
    "titre_genre2": "Conseiller",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5088",
    "nom_corrige2": "Frédéric Lehouillier",
    "nom_famille": "Lehouillier",
    "titre_genre2": "Conseiller",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5089",
    "nom_corrige2": "Stéphane Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseiller",
    "remuneration": "2848",
    "allocation": "1424",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4272",
    "ville": "Sainte-Marguerite",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1262"
  },
  {
    "ID": "5090",
    "nom_corrige2": "Réjean Boulanger",
    "nom_famille": "Boulanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2645",
    "allocation": "1322",
    "remuneration2": "202",
    "allocation2": "101",
    "total": "4270",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5091",
    "nom_corrige2": "Joey Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5092",
    "nom_corrige2": "Gilles Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5093",
    "nom_corrige2": "Jocelyn Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5094",
    "nom_corrige2": "Sandra Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseillère",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5095",
    "nom_corrige2": "Roger Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5096",
    "nom_corrige2": "Pierre Grondines",
    "nom_famille": "Grondines",
    "titre_genre2": "Conseiller",
    "remuneration": "2612",
    "allocation": "1650",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4262",
    "ville": "Saint-Zacharie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5097",
    "nom_corrige2": "Grégoire Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5098",
    "nom_corrige2": "Samuel Choquette",
    "nom_famille": "Choquette",
    "titre_genre2": "Conseiller",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5099",
    "nom_corrige2": "Janic Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5100",
    "nom_corrige2": "Caroline Chayer",
    "nom_famille": "Chayer",
    "titre_genre2": "Conseillère",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5101",
    "nom_corrige2": "Jean Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5102",
    "nom_corrige2": "Claude Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "2945",
    "allocation": "1314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4259",
    "ville": "Ferland-et-Boilleau",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "644"
  },
  {
    "ID": "5103",
    "nom_corrige2": "Isabelle Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "428",
    "allocation2": "214",
    "total": "4258",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5104",
    "nom_corrige2": "David Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseiller",
    "remuneration": "4237",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4237",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "5105",
    "nom_corrige2": "Richard Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseiller",
    "remuneration": "2815",
    "allocation": "1407",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4222",
    "ville": "Saint-Camille-de-Lellis",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "751"
  },
  {
    "ID": "5106",
    "nom_corrige2": "Antoine Quirion-Couture",
    "nom_famille": "Quirion-Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "2814",
    "allocation": "1407",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4221",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "5107",
    "nom_corrige2": "France Groulx",
    "nom_famille": "Groulx",
    "titre_genre2": "Conseillère",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5108",
    "nom_corrige2": "Luc Courville",
    "nom_famille": "Courville",
    "titre_genre2": "Conseiller",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5109",
    "nom_corrige2": "Émilie Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5110",
    "nom_corrige2": "Christine La Roche",
    "nom_famille": "La",
    "titre_genre2": "Conseillère",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5111",
    "nom_corrige2": "Dylan Bockus",
    "nom_famille": "Bockus",
    "titre_genre2": "Conseiller",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5112",
    "nom_corrige2": "Daniel Rivet",
    "nom_famille": "Rivet",
    "titre_genre2": "Conseiller",
    "remuneration": "2796",
    "allocation": "1398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4194",
    "ville": "Bedford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "743"
  },
  {
    "ID": "5113",
    "nom_corrige2": "Isabelle Bélanger-Fortin",
    "nom_famille": "Bélanger-Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "2613",
    "allocation": "1576",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4189",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "5114",
    "nom_corrige2": "Philippe Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2832",
    "allocation": "1335",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4167",
    "ville": "Sacré-Coeur",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1770"
  },
  {
    "ID": "5115",
    "nom_corrige2": "Mélanie  Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseillère",
    "remuneration": "2777",
    "allocation": "1389",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4166",
    "ville": "Villeroy",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "497"
  },
  {
    "ID": "5116",
    "nom_corrige2": "Claude Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "2776",
    "allocation": "1388",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4164",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5117",
    "nom_corrige2": "Jean-Pierre Pouliot",
    "nom_famille": "Pouliot",
    "titre_genre2": "Conseiller",
    "remuneration": "2775",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4162",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "5118",
    "nom_corrige2": "Mathieu Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseiller",
    "remuneration": "2774",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4161",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5119",
    "nom_corrige2": "Julien Chalifoux",
    "nom_famille": "Chalifoux",
    "titre_genre2": "Conseiller",
    "remuneration": "2774",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4161",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5120",
    "nom_corrige2": "Louise Paquin Bédard",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseillère",
    "remuneration": "2774",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4161",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5121",
    "nom_corrige2": "Patrick Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2774",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4161",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5122",
    "nom_corrige2": "Zacharie Cloutier-Julien",
    "nom_famille": "Cloutier-Julien",
    "titre_genre2": "Conseiller",
    "remuneration": "2774",
    "allocation": "1387",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4161",
    "ville": "Taschereau",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "926"
  },
  {
    "ID": "5123",
    "nom_corrige2": "Alain Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "2768",
    "allocation": "1383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4151",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "5124",
    "nom_corrige2": "Valmond Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "2768",
    "allocation": "1383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4151",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "5125",
    "nom_corrige2": "Jason Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "2768",
    "allocation": "1383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4151",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "5126",
    "nom_corrige2": "André Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "2768",
    "allocation": "1383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4151",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "5127",
    "nom_corrige2": "François Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "2768",
    "allocation": "1383",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4151",
    "ville": "Sacré-Coeur-de-Jésus",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "549"
  },
  {
    "ID": "5128",
    "nom_corrige2": "CLAUDIA BEAULIEU",
    "nom_famille": "BEAULIEU",
    "titre_genre2": "Conseillère",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5129",
    "nom_corrige2": "CAROLE DESBIENS",
    "nom_famille": "DESBIENS",
    "titre_genre2": "Conseillère",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5130",
    "nom_corrige2": "STÉPHANIE CARON",
    "nom_famille": "CARON",
    "titre_genre2": "Conseillère",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5131",
    "nom_corrige2": "NICHOLAS DUBÉ",
    "nom_famille": "DUBÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5132",
    "nom_corrige2": "RICHARD DUBÉ",
    "nom_famille": "DUBÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5133",
    "nom_corrige2": "JOCELYN PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseiller",
    "remuneration": "2762",
    "allocation": "1381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4143",
    "ville": "Saint-Honoré-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "762"
  },
  {
    "ID": "5134",
    "nom_corrige2": "Serge Denis",
    "nom_famille": "Denis",
    "titre_genre2": "Conseiller",
    "remuneration": "2756",
    "allocation": "1378",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4134",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "5135",
    "nom_corrige2": "Jean-Denis Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5136",
    "nom_corrige2": "Sabrina Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseillère",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5137",
    "nom_corrige2": "Johannie Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5138",
    "nom_corrige2": "Martin Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseiller",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5139",
    "nom_corrige2": "Frédéric Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseiller",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5140",
    "nom_corrige2": "Guy Privé",
    "nom_famille": "Privé",
    "titre_genre2": "Maire",
    "remuneration": "2745",
    "allocation": "1373",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4118",
    "ville": "Sainte-Hedwidge",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "900"
  },
  {
    "ID": "5141",
    "nom_corrige2": "Simon Langeveld",
    "nom_famille": "Langeveld",
    "titre_genre2": "Conseiller",
    "remuneration": "2743",
    "allocation": "1371",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4114",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "5142",
    "nom_corrige2": "Martine LEVESQUE",
    "nom_famille": "LEVESQUE",
    "titre_genre2": "Conseillère",
    "remuneration": "2739",
    "allocation": "1370",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4109",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "5143",
    "nom_corrige2": "Pascal Gonnin",
    "nom_famille": "Gonnin",
    "titre_genre2": "Conseiller",
    "remuneration": "3135",
    "allocation": "971",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4106",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "5144",
    "nom_corrige2": "Yvon Paulin",
    "nom_famille": "Paulin",
    "titre_genre2": "Conseiller",
    "remuneration": "2733",
    "allocation": "1366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4099",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "5145",
    "nom_corrige2": "Sylvain Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "2733",
    "allocation": "1366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4099",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "5146",
    "nom_corrige2": "Chantal Séguin",
    "nom_famille": "Séguin",
    "titre_genre2": "Conseillère",
    "remuneration": "2733",
    "allocation": "1366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4099",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "5147",
    "nom_corrige2": "Louis Touchette",
    "nom_famille": "Touchette",
    "titre_genre2": "Conseiller",
    "remuneration": "2733",
    "allocation": "1366",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4099",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "5148",
    "nom_corrige2": "Carole Dansereau",
    "nom_famille": "Dansereau",
    "titre_genre2": "Conseillère",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5149",
    "nom_corrige2": "Jean-Pierre Morlot",
    "nom_famille": "Morlot",
    "titre_genre2": "Conseiller",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5150",
    "nom_corrige2": "Roger Santerre",
    "nom_famille": "Santerre",
    "titre_genre2": "Conseiller",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5151",
    "nom_corrige2": "Daniel Lanoue",
    "nom_famille": "Lanoue",
    "titre_genre2": "Conseiller",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5152",
    "nom_corrige2": "Micheline Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5153",
    "nom_corrige2": "Robert Gaboriault",
    "nom_famille": "Gaboriault",
    "titre_genre2": "Conseiller",
    "remuneration": "2729",
    "allocation": "1364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4093",
    "ville": "Notre-Dame-de-Stanbridge",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "665"
  },
  {
    "ID": "5154",
    "nom_corrige2": "Vincent Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "2859",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4089",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5155",
    "nom_corrige2": "CAROLINE DUMONT",
    "nom_famille": "DUMONT",
    "titre_genre2": "Conseillère",
    "remuneration": "2785",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4086",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5156",
    "nom_corrige2": "KARINE DECHAMPLAIN",
    "nom_famille": "DECHAMPLAIN",
    "titre_genre2": "Conseillère",
    "remuneration": "2785",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4086",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5157",
    "nom_corrige2": "Patrick Feeny",
    "nom_famille": "Feeny",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5158",
    "nom_corrige2": "Gilles Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5159",
    "nom_corrige2": "Pierre Laramée",
    "nom_famille": "Laramée",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5160",
    "nom_corrige2": "Jeannot Emond",
    "nom_famille": "Emond",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5161",
    "nom_corrige2": "Jean-René Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5162",
    "nom_corrige2": "Yvan St-Amour",
    "nom_famille": "St-Amour",
    "titre_genre2": "Conseiller",
    "remuneration": "2798",
    "allocation": "1278",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4076",
    "ville": "Egan-Sud",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "498"
  },
  {
    "ID": "5163",
    "nom_corrige2": "AGLAÉE D'AUTEUIL",
    "nom_famille": "D'AUTEUIL",
    "titre_genre2": "Conseillère",
    "remuneration": "2716",
    "allocation": "1358",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4074",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5164",
    "nom_corrige2": "Caroline Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "2706",
    "allocation": "1353",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4059",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "5165",
    "nom_corrige2": "Sylvain Sénéchal",
    "nom_famille": "Sénéchal",
    "titre_genre2": "Conseiller",
    "remuneration": "2705",
    "allocation": "1353",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4058",
    "ville": "Notre-Dame-des-Neiges",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1082"
  },
  {
    "ID": "5166",
    "nom_corrige2": "Carole Santerre",
    "nom_famille": "Santerre",
    "titre_genre2": "Mairesse",
    "remuneration": "2704",
    "allocation": "1352",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4056",
    "ville": "Saints-Anges",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1246"
  },
  {
    "ID": "5167",
    "nom_corrige2": "Patrick Godin",
    "nom_famille": "Godin",
    "titre_genre2": "Conseiller",
    "remuneration": "2960",
    "allocation": "1093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4053",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "5168",
    "nom_corrige2": "Patrick Wolput",
    "nom_famille": "Wolput",
    "titre_genre2": "Conseiller",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "145",
    "allocation2": "72",
    "total": "4039",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5169",
    "nom_corrige2": "NORMAND HENLEY",
    "nom_famille": "HENLEY",
    "titre_genre2": "Conseiller",
    "remuneration": "2735",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4036",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5170",
    "nom_corrige2": "DIANE SOUCY",
    "nom_famille": "SOUCY",
    "titre_genre2": "Conseillère",
    "remuneration": "2735",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4036",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5171",
    "nom_corrige2": "Paul Olsen",
    "nom_famille": "Olsen",
    "titre_genre2": "Conseiller",
    "remuneration": "2690",
    "allocation": "1345",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4035",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "5172",
    "nom_corrige2": "Sébastien Bazinet",
    "nom_famille": "Bazinet",
    "titre_genre2": "Conseiller",
    "remuneration": "18810",
    "allocation": "9405",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "28215",
    "ville": "Rivière-Rouge",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "4665"
  },
  {
    "ID": "5173",
    "nom_corrige2": "Gertrude Blackned-Cavalier",
    "nom_famille": "Blackned-Cavalier",
    "titre_genre2": "Conseillère",
    "remuneration": "2831",
    "allocation": "1198",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4029",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "5174",
    "nom_corrige2": "Rose Lawlor",
    "nom_famille": "Lawlor",
    "titre_genre2": "Conseillère",
    "remuneration": "2721",
    "allocation": "1302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4023",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5175",
    "nom_corrige2": "Tanya Garrick Rhicard",
    "nom_famille": "Garrick",
    "titre_genre2": "Conseillère",
    "remuneration": "2721",
    "allocation": "1302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4023",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5176",
    "nom_corrige2": "Tommy Gagné-Dubé",
    "nom_famille": "Gagné-Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1223",
    "remuneration2": "360",
    "allocation2": "180",
    "total": "4022",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "5177",
    "nom_corrige2": "Laurent Marchal",
    "nom_famille": "Marchal",
    "titre_genre2": "Conseiller",
    "remuneration": "2721",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4022",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5178",
    "nom_corrige2": "Marcus Flynn",
    "nom_famille": "Flynn",
    "titre_genre2": "Conseiller",
    "remuneration": "2721",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4022",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5179",
    "nom_corrige2": "Robert Young",
    "nom_famille": "Young",
    "titre_genre2": "Conseiller",
    "remuneration": "2721",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4022",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5180",
    "nom_corrige2": "Laurie-Ann Foucrault",
    "nom_famille": "Foucrault",
    "titre_genre2": "Conseillère",
    "remuneration": "2721",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4022",
    "ville": "Stanbridge East",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "875"
  },
  {
    "ID": "5181",
    "nom_corrige2": "Richard E Dubeau",
    "nom_famille": "Dubeau",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1130",
    "remuneration2": "632",
    "allocation2": "0",
    "total": "4021",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5182",
    "nom_corrige2": "Kévin Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2731",
    "allocation": "1286",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4017",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5183",
    "nom_corrige2": "Tania Rouillier",
    "nom_famille": "Rouillier",
    "titre_genre2": "Conseillère",
    "remuneration": "2676",
    "allocation": "1332",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4008",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "5184",
    "nom_corrige2": "Noémie Ash",
    "nom_famille": "Ash",
    "titre_genre2": "Conseillère",
    "remuneration": "2676",
    "allocation": "1332",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4008",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "5185",
    "nom_corrige2": "François Clouâtre",
    "nom_famille": "Clouâtre",
    "titre_genre2": "Conseiller",
    "remuneration": "2676",
    "allocation": "1332",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4008",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "5186",
    "nom_corrige2": "Pierre Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "2676",
    "allocation": "1332",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4008",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "5187",
    "nom_corrige2": "Jacqueline Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseillère",
    "remuneration": "2667",
    "allocation": "1334",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4001",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "5188",
    "nom_corrige2": "Patrice Vaugeois",
    "nom_famille": "Vaugeois",
    "titre_genre2": "Conseiller",
    "remuneration": "2667",
    "allocation": "1334",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4001",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "5189",
    "nom_corrige2": "Nancy Castonguay Demers",
    "nom_famille": "Castonguay",
    "titre_genre2": "Conseillère",
    "remuneration": "2667",
    "allocation": "1334",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4001",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "5190",
    "nom_corrige2": "Sylvie Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseillère",
    "remuneration": "2667",
    "allocation": "1334",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4001",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "5191",
    "nom_corrige2": "Jasmin Dubois",
    "nom_famille": "Dubois",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "5192",
    "nom_corrige2": "Claude Laprise",
    "nom_famille": "Laprise",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "5193",
    "nom_corrige2": "Josy Belzil",
    "nom_famille": "Belzil",
    "titre_genre2": "Conseillère",
    "remuneration": "3000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "5194",
    "nom_corrige2": "Jules Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "5195",
    "nom_corrige2": "Marc-André Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "3000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "4000",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "5196",
    "nom_corrige2": "Véronique Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "2759",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3989",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5197",
    "nom_corrige2": "Mélissa Boucher Caron",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "2695",
    "allocation": "1289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3984",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "5198",
    "nom_corrige2": "Sylvain (Jude) Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseiller",
    "remuneration": "3098",
    "allocation": "874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3972",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5199",
    "nom_corrige2": "Richard Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseiller",
    "remuneration": "2642",
    "allocation": "1320",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3962",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "5200",
    "nom_corrige2": "SERGE IMBEAULT",
    "nom_famille": "IMBEAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "2640",
    "allocation": "1321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3961",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5201",
    "nom_corrige2": "SUZIE LACOMBE",
    "nom_famille": "LACOMBE",
    "titre_genre2": "Conseillère",
    "remuneration": "2640",
    "allocation": "1321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3961",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5202",
    "nom_corrige2": "LISE PINEAULT",
    "nom_famille": "PINEAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "2640",
    "allocation": "1321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3961",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5203",
    "nom_corrige2": "JEAN-MARC FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseiller",
    "remuneration": "2640",
    "allocation": "1321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3961",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5204",
    "nom_corrige2": "SERGE LÉVESQUE",
    "nom_famille": "LÉVESQUE",
    "titre_genre2": "Conseiller",
    "remuneration": "2640",
    "allocation": "1321",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3961",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5205",
    "nom_corrige2": "Geneviève Marchand",
    "nom_famille": "Marchand",
    "titre_genre2": "Conseillère",
    "remuneration": "2636",
    "allocation": "1324",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3960",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5206",
    "nom_corrige2": "Alex Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Conseiller",
    "remuneration": "2639",
    "allocation": "1320",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3959",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5207",
    "nom_corrige2": "Michel Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseiller",
    "remuneration": "2639",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3958",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5208",
    "nom_corrige2": "Frédéric Bonin",
    "nom_famille": "Bonin",
    "titre_genre2": "Conseiller",
    "remuneration": "2639",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3958",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5209",
    "nom_corrige2": "Roger Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2639",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3958",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5210",
    "nom_corrige2": "Stéphane Leblond",
    "nom_famille": "Leblond",
    "titre_genre2": "Conseiller",
    "remuneration": "2639",
    "allocation": "1319",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3958",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5211",
    "nom_corrige2": "Brigitte Claveau",
    "nom_famille": "Claveau",
    "titre_genre2": "Conseillère",
    "remuneration": "2638",
    "allocation": "1320",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3958",
    "ville": "Saint-Lazare-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1370"
  },
  {
    "ID": "5212",
    "nom_corrige2": "Ghislain Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2634",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3951",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "5213",
    "nom_corrige2": "Brent Maxwell",
    "nom_famille": "Maxwell",
    "titre_genre2": "Conseiller",
    "remuneration": "2634",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3951",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "5214",
    "nom_corrige2": "Hélène Cimon",
    "nom_famille": "Cimon",
    "titre_genre2": "Conseillère",
    "remuneration": "2634",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3951",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "5215",
    "nom_corrige2": "Pascal Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2634",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3951",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "5216",
    "nom_corrige2": "Gisèle Carrier",
    "nom_famille": "Carrier",
    "titre_genre2": "Conseillère",
    "remuneration": "2634",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3951",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "5217",
    "nom_corrige2": "AUBERT TURCOTTE",
    "nom_famille": "TURCOTTE",
    "titre_genre2": "Conseiller",
    "remuneration": "2633",
    "allocation": "1317",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3950",
    "ville": "Saint-Léon-le-Grand",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "988"
  },
  {
    "ID": "5218",
    "nom_corrige2": "GRÉGOIRE BERGERON",
    "nom_famille": "BERGERON",
    "titre_genre2": "Conseiller",
    "remuneration": "2250",
    "allocation": "1125",
    "remuneration2": "381",
    "allocation2": "191",
    "total": "3947",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "5219",
    "nom_corrige2": "Marc Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2691",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3939",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5220",
    "nom_corrige2": "Sylvain (L-G) Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseiller",
    "remuneration": "1973",
    "allocation": "874",
    "remuneration2": "720",
    "allocation2": "360",
    "total": "3927",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5221",
    "nom_corrige2": "Daniel Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseiller",
    "remuneration": "2615",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3922",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "5222",
    "nom_corrige2": "Steve Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "2615",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3922",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "5223",
    "nom_corrige2": "Kathie Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseillère",
    "remuneration": "2615",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3922",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "5224",
    "nom_corrige2": "Sébastien Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "2615",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3922",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "5225",
    "nom_corrige2": "Martine Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5226",
    "nom_corrige2": "René Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5227",
    "nom_corrige2": "Sylvie Charette",
    "nom_famille": "Charette",
    "titre_genre2": "Conseillère",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5228",
    "nom_corrige2": "Sylvie Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5229",
    "nom_corrige2": "Laurent Marcotte",
    "nom_famille": "Marcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5230",
    "nom_corrige2": "Jacques Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseiller",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Berry",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "530"
  },
  {
    "ID": "5231",
    "nom_corrige2": "MATHIEU LAVIGNE",
    "nom_famille": "LAVIGNE",
    "titre_genre2": "Conseiller",
    "remuneration": "2614",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3921",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5232",
    "nom_corrige2": "Keven Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseiller",
    "remuneration": "2720",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3920",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "5233",
    "nom_corrige2": "Rodrigue Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "2613",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3920",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "5234",
    "nom_corrige2": "Philippe Boileau",
    "nom_famille": "Boileau",
    "titre_genre2": "Conseiller",
    "remuneration": "2613",
    "allocation": "1307",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3920",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "5235",
    "nom_corrige2": "MARIE-CLAUDE SAUVÉ",
    "nom_famille": "SAUVÉ",
    "titre_genre2": "Conseillère",
    "remuneration": "2611",
    "allocation": "1306",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3917",
    "ville": "Saint-Zénon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1253"
  },
  {
    "ID": "5236",
    "nom_corrige2": "Sylvia Gallant",
    "nom_famille": "Gallant",
    "titre_genre2": "Conseillère",
    "remuneration": "2606",
    "allocation": "1303",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3909",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "5237",
    "nom_corrige2": "Véronique Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseillère",
    "remuneration": "2618",
    "allocation": "1291",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3909",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "5238",
    "nom_corrige2": "Christiane Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "2618",
    "allocation": "1291",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3909",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "5239",
    "nom_corrige2": "Pascale Brouillette",
    "nom_famille": "Brouillette",
    "titre_genre2": "Conseillère",
    "remuneration": "2618",
    "allocation": "1291",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3909",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "5240",
    "nom_corrige2": "Stéphane Fraser",
    "nom_famille": "Fraser",
    "titre_genre2": "Conseiller",
    "remuneration": "2618",
    "allocation": "1291",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3909",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "5241",
    "nom_corrige2": "Jean-Yves Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "2597",
    "allocation": "1311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3908",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5242",
    "nom_corrige2": "Mélodie Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseillère",
    "remuneration": "2597",
    "allocation": "1311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3908",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5243",
    "nom_corrige2": "Lucien Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "2596",
    "allocation": "1308",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3904",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5244",
    "nom_corrige2": "Dominique Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "2601",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3902",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "5245",
    "nom_corrige2": "Ghislain Faucher",
    "nom_famille": "Faucher",
    "titre_genre2": "Conseiller",
    "remuneration": "2601",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3902",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "5246",
    "nom_corrige2": "Mathieu Laliberté",
    "nom_famille": "Laliberté",
    "titre_genre2": "Conseiller",
    "remuneration": "2601",
    "allocation": "1300",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3901",
    "ville": "Stanstead-Est",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "636"
  },
  {
    "ID": "5247",
    "nom_corrige2": "Michel Rivard",
    "nom_famille": "Rivard",
    "titre_genre2": "Conseiller",
    "remuneration": "2872",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3892",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "5248",
    "nom_corrige2": "Nancy Malenfant",
    "nom_famille": "Malenfant",
    "titre_genre2": "Conseillère",
    "remuneration": "2585",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3886",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5249",
    "nom_corrige2": "Yvan Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "2872",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3892",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "5250",
    "nom_corrige2": "François Binet",
    "nom_famille": "Binet",
    "titre_genre2": "Conseiller",
    "remuneration": "2872",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3892",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "5251",
    "nom_corrige2": "Régis Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "2872",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3892",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "5252",
    "nom_corrige2": "Johanne Rheault",
    "nom_famille": "Rheault",
    "titre_genre2": "Conseillère",
    "remuneration": "2872",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3892",
    "ville": "Sainte-Gertrude-Manneville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "776"
  },
  {
    "ID": "5253",
    "nom_corrige2": "Sophie Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5254",
    "nom_corrige2": "Charles-Étienne Beaudet",
    "nom_famille": "Beaudet",
    "titre_genre2": "Conseiller",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5255",
    "nom_corrige2": "Anthony Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5256",
    "nom_corrige2": "Rémi Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseiller",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5257",
    "nom_corrige2": "Johanne Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Mairesse",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5258",
    "nom_corrige2": "Maxime Guimond",
    "nom_famille": "Guimond",
    "titre_genre2": "Maire",
    "remuneration": "2588",
    "allocation": "1294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3882",
    "ville": "Leclercville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "484"
  },
  {
    "ID": "5259",
    "nom_corrige2": "PASCAL D'ASTOUS",
    "nom_famille": "D'ASTOUS",
    "titre_genre2": "Conseiller",
    "remuneration": "2455",
    "allocation": "1228",
    "remuneration2": "132",
    "allocation2": "66",
    "total": "3881",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5260",
    "nom_corrige2": "Jacques Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "2585",
    "allocation": "1292",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3877",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5261",
    "nom_corrige2": "Marc Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "2585",
    "allocation": "1292",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3877",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5262",
    "nom_corrige2": "Gino Isabel",
    "nom_famille": "Isabel",
    "titre_genre2": "Conseiller",
    "remuneration": "2569",
    "allocation": "1302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3871",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "5263",
    "nom_corrige2": "Gilles Forcier",
    "nom_famille": "Forcier",
    "titre_genre2": "Conseiller",
    "remuneration": "2578",
    "allocation": "1289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3867",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "5264",
    "nom_corrige2": "Raymond Paulhus",
    "nom_famille": "Paulhus",
    "titre_genre2": "Conseiller",
    "remuneration": "2578",
    "allocation": "1289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3867",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "5265",
    "nom_corrige2": "Sylvie Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseillère",
    "remuneration": "2578",
    "allocation": "1289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3867",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "5266",
    "nom_corrige2": "Yanick Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseiller",
    "remuneration": "2578",
    "allocation": "1289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3867",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "5267",
    "nom_corrige2": "Lisa Irving",
    "nom_famille": "Irving",
    "titre_genre2": "Conseillère",
    "remuneration": "2576",
    "allocation": "1288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3864",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5268",
    "nom_corrige2": "Mylène Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Conseillère",
    "remuneration": "2572",
    "allocation": "1286",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3858",
    "ville": "Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "618"
  },
  {
    "ID": "5269",
    "nom_corrige2": "Sylvain Boisselle",
    "nom_famille": "Boisselle",
    "titre_genre2": "Conseiller",
    "remuneration": "2760",
    "allocation": "1093",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3853",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "5270",
    "nom_corrige2": "Janye Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "2568",
    "allocation": "1284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3852",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5271",
    "nom_corrige2": "Robert Péloquin",
    "nom_famille": "Péloquin",
    "titre_genre2": "Conseiller",
    "remuneration": "2568",
    "allocation": "1284",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3852",
    "ville": "Lotbinière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "830"
  },
  {
    "ID": "5272",
    "nom_corrige2": "Roger Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2561",
    "allocation": "1286",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3847",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5273",
    "nom_corrige2": "Sophie Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "2561",
    "allocation": "1281",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3842",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5274",
    "nom_corrige2": "Lise Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "2558",
    "allocation": "1279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3837",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "5275",
    "nom_corrige2": "Chantal Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseillère",
    "remuneration": "2558",
    "allocation": "1279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3837",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "5276",
    "nom_corrige2": "David Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2558",
    "allocation": "1279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3837",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "5277",
    "nom_corrige2": "Louis Bigué",
    "nom_famille": "Bigué",
    "titre_genre2": "Conseiller",
    "remuneration": "2558",
    "allocation": "1279",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3837",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "5278",
    "nom_corrige2": "Johanne Sabourin",
    "nom_famille": "Sabourin",
    "titre_genre2": "Conseillère",
    "remuneration": "2561",
    "allocation": "1266",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3827",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "5279",
    "nom_corrige2": "Léonard Gaudette",
    "nom_famille": "Gaudette",
    "titre_genre2": "Conseillère",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "140",
    "allocation2": "70",
    "total": "3826",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5280",
    "nom_corrige2": "Mickaël L. Giguère",
    "nom_famille": "Giguère",
    "titre_genre2": "Conseiller",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3822",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5281",
    "nom_corrige2": "Simon Dufault",
    "nom_famille": "Dufault",
    "titre_genre2": "Conseiller",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3822",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5282",
    "nom_corrige2": "Pierre Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3822",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5283",
    "nom_corrige2": "Francine Brasseur",
    "nom_famille": "Brasseur",
    "titre_genre2": "Conseillère",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3822",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5284",
    "nom_corrige2": "Gilbert Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "2548",
    "allocation": "1274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3822",
    "ville": "Sainte-Christine",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "767"
  },
  {
    "ID": "5285",
    "nom_corrige2": "Pierre Lantagne",
    "nom_famille": "Lantagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "95",
    "allocation2": "48",
    "total": "3821",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5286",
    "nom_corrige2": "Nancy Rouillard",
    "nom_famille": "Rouillard",
    "titre_genre2": "Conseillère",
    "remuneration": "2236",
    "allocation": "1118",
    "remuneration2": "309",
    "allocation2": "155",
    "total": "3818",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5287",
    "nom_corrige2": "Yvon Lantagne",
    "nom_famille": "Lantagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2531",
    "allocation": "1266",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3797",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "5288",
    "nom_corrige2": "Mathieu Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "2531",
    "allocation": "1266",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3797",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "5289",
    "nom_corrige2": "Jocelyn Lantagne",
    "nom_famille": "Lantagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2531",
    "allocation": "1266",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3797",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "5290",
    "nom_corrige2": "Gaetan Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "2531",
    "allocation": "1266",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3797",
    "ville": "Saint-Marc-de-Figuery",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "957"
  },
  {
    "ID": "5291",
    "nom_corrige2": "Véronique Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseillère",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3795",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "5292",
    "nom_corrige2": "Isabelle Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseillère",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3795",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "5293",
    "nom_corrige2": "Mélanie Hardy",
    "nom_famille": "Hardy",
    "titre_genre2": "Conseillère",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3795",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "5294",
    "nom_corrige2": "William Mcmahon",
    "nom_famille": "Mcmahon",
    "titre_genre2": "Conseiller",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3795",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "5295",
    "nom_corrige2": "Sylvie Viens",
    "nom_famille": "Viens",
    "titre_genre2": "Conseillère",
    "remuneration": "2530",
    "allocation": "1265",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3795",
    "ville": "Saint-Marcel-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "528"
  },
  {
    "ID": "5296",
    "nom_corrige2": "Bradford Cooke",
    "nom_famille": "Cooke",
    "titre_genre2": "Conseiller",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5297",
    "nom_corrige2": "Josée Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseillère",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5298",
    "nom_corrige2": "Sébastien Daudlin",
    "nom_famille": "Daudlin",
    "titre_genre2": "Conseiller",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5299",
    "nom_corrige2": "Sébastien Desormeaux",
    "nom_famille": "Desormeaux",
    "titre_genre2": "Conseiller",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5300",
    "nom_corrige2": "Guy Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5301",
    "nom_corrige2": "Martin Meilleur",
    "nom_famille": "Meilleur",
    "titre_genre2": "Conseiller",
    "remuneration": "2520",
    "allocation": "1260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3780",
    "ville": "Namur",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "618"
  },
  {
    "ID": "5302",
    "nom_corrige2": "Daibhid Fraser",
    "nom_famille": "Fraser",
    "titre_genre2": "Conseiller",
    "remuneration": "2582",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3773",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5303",
    "nom_corrige2": "MARC MICHAUD",
    "nom_famille": "MICHAUD",
    "titre_genre2": "Conseiller",
    "remuneration": "2471",
    "allocation": "1301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3772",
    "ville": "Saint-Zénon-du-Lac-Humqui",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "344"
  },
  {
    "ID": "5304",
    "nom_corrige2": "Jean Collard",
    "nom_famille": "Collard",
    "titre_genre2": "Conseiller",
    "remuneration": "2005",
    "allocation": "1003",
    "remuneration2": "507",
    "allocation2": "253",
    "total": "3768",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5305",
    "nom_corrige2": "Christiane Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseillère",
    "remuneration": "2357",
    "allocation": "1179",
    "remuneration2": "155",
    "allocation2": "77",
    "total": "3768",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5306",
    "nom_corrige2": "Julie Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "2296",
    "allocation": "1148",
    "remuneration2": "214",
    "allocation2": "107",
    "total": "3765",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5307",
    "nom_corrige2": "Joëlle Hénault",
    "nom_famille": "Hénault",
    "titre_genre2": "Conseillère",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "5308",
    "nom_corrige2": "MICHEL VEILLEUX",
    "nom_famille": "VEILLEUX",
    "titre_genre2": "Conseiller",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5309",
    "nom_corrige2": "ISABELLE PAQUET",
    "nom_famille": "PAQUET",
    "titre_genre2": "Conseillère",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5310",
    "nom_corrige2": "CHRISTIAN LESSARD",
    "nom_famille": "LESSARD",
    "titre_genre2": "Conseiller",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5311",
    "nom_corrige2": "DENIS GOSSELIN",
    "nom_famille": "GOSSELIN",
    "titre_genre2": "Conseiller",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5312",
    "nom_corrige2": "Win Le Phan",
    "nom_famille": "Le",
    "titre_genre2": "Conseillère",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5313",
    "nom_corrige2": "STÉPHANE AUCLAIR",
    "nom_famille": "AUCLAIR",
    "titre_genre2": "Conseiller",
    "remuneration": "2509",
    "allocation": "1255",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Notre-Dame-des-Pins",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1777"
  },
  {
    "ID": "5314",
    "nom_corrige2": "Gilles Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "2534",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3764",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5315",
    "nom_corrige2": "Sylvie Brassard",
    "nom_famille": "Brassard",
    "titre_genre2": "Conseillère",
    "remuneration": "2656",
    "allocation": "1106",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3762",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5316",
    "nom_corrige2": "Denis Vel",
    "nom_famille": "Vel",
    "titre_genre2": "Conseiller",
    "remuneration": "2879",
    "allocation": "883",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3762",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "5317",
    "nom_corrige2": "Jayson Byrns",
    "nom_famille": "Byrns",
    "titre_genre2": "Conseiller",
    "remuneration": "2507",
    "allocation": "1253",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3760",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "5318",
    "nom_corrige2": "Olivier Picard",
    "nom_famille": "Picard",
    "titre_genre2": "Conseiller",
    "remuneration": "25344",
    "allocation": "12672",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "38016",
    "ville": "Sorel-Tracy",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "36093"
  },
  {
    "ID": "5319",
    "nom_corrige2": "Gilles Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Conseiller",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5320",
    "nom_corrige2": "Claudy Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5321",
    "nom_corrige2": "Lise Blanchette",
    "nom_famille": "Blanchette",
    "titre_genre2": "Conseillère",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5322",
    "nom_corrige2": "Alain Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5323",
    "nom_corrige2": "Rachel Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5324",
    "nom_corrige2": "Claude Deschamps",
    "nom_famille": "Deschamps",
    "titre_genre2": "Conseiller",
    "remuneration": "2500",
    "allocation": "1250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3750",
    "ville": "Saint-Eusèbe",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "610"
  },
  {
    "ID": "5325",
    "nom_corrige2": "Paul Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseiller",
    "remuneration": "2497",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3745",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5326",
    "nom_corrige2": "Claude Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "2497",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3745",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5327",
    "nom_corrige2": "Steeve Santerre",
    "nom_famille": "Santerre",
    "titre_genre2": "Conseiller",
    "remuneration": "2497",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3745",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5328",
    "nom_corrige2": "Marc Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2497",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3745",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5329",
    "nom_corrige2": "Joël Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2497",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3745",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5330",
    "nom_corrige2": "GILLES BEAULIEU",
    "nom_famille": "BEAULIEU",
    "titre_genre2": "Conseiller",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5331",
    "nom_corrige2": "GILLES PLOURDE",
    "nom_famille": "PLOURDE",
    "titre_genre2": "Conseiller",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5332",
    "nom_corrige2": "BERNARD FORTIN",
    "nom_famille": "FORTIN",
    "titre_genre2": "Conseiller",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5333",
    "nom_corrige2": "MATTHIEU GAGNÉ",
    "nom_famille": "GAGNÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5334",
    "nom_corrige2": "JULIE NADEAU",
    "nom_famille": "NADEAU",
    "titre_genre2": "Conseillère",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5335",
    "nom_corrige2": "MARIE-JOSÉE CARON",
    "nom_famille": "CARON",
    "titre_genre2": "Conseillère",
    "remuneration": "2496",
    "allocation": "1248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3744",
    "ville": "Saint-Bruno-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "546"
  },
  {
    "ID": "5336",
    "nom_corrige2": "René Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "101",
    "allocation2": "50",
    "total": "3740",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5337",
    "nom_corrige2": "Marc Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5338",
    "nom_corrige2": "Robin Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5339",
    "nom_corrige2": "Yannick Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5340",
    "nom_corrige2": "Marc Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5341",
    "nom_corrige2": "Régis Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5342",
    "nom_corrige2": "Sébastien Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "2493",
    "allocation": "1247",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3740",
    "ville": "Saint-Arsène",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1250"
  },
  {
    "ID": "5343",
    "nom_corrige2": "Jean-René Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2160",
    "allocation": "1080",
    "remuneration2": "330",
    "allocation2": "165",
    "total": "3735",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5344",
    "nom_corrige2": "SYLVAIN PROULX",
    "nom_famille": "PROULX",
    "titre_genre2": "Conseiller",
    "remuneration": "2512",
    "allocation": "1222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3734",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5345",
    "nom_corrige2": "Marc Foisy",
    "nom_famille": "Foisy",
    "titre_genre2": "Conseiller",
    "remuneration": "2487",
    "allocation": "1243",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3730",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "5346",
    "nom_corrige2": "Hugo Laporte",
    "nom_famille": "Laporte",
    "titre_genre2": "Conseiller",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "71",
    "allocation2": "36",
    "total": "3723",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5347",
    "nom_corrige2": "CLAUDE LAPOINTE",
    "nom_famille": "LAPOINTE",
    "titre_genre2": "Conseillère",
    "remuneration": "2475",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3712",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5348",
    "nom_corrige2": "JACQUES L'HEUREUX",
    "nom_famille": "L'HEUREUX",
    "titre_genre2": "Conseiller",
    "remuneration": "2475",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3712",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5349",
    "nom_corrige2": "FRANCIS TARDIF",
    "nom_famille": "TARDIF",
    "titre_genre2": "Conseiller",
    "remuneration": "2475",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3712",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5350",
    "nom_corrige2": "PASCAL LAVERDIÈRE",
    "nom_famille": "LAVERDIÈRE",
    "titre_genre2": "Conseiller",
    "remuneration": "2475",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3712",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5351",
    "nom_corrige2": "Marie-Paule Boudreault",
    "nom_famille": "Boudreault",
    "titre_genre2": "Conseillère",
    "remuneration": "2474",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3711",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5352",
    "nom_corrige2": "Rémy Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "2474",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3711",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5353",
    "nom_corrige2": "Gaétan Goyette",
    "nom_famille": "Goyette",
    "titre_genre2": "Conseiller",
    "remuneration": "2469",
    "allocation": "1235",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3704",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "5354",
    "nom_corrige2": "André Gélinas",
    "nom_famille": "Gélinas",
    "titre_genre2": "Conseiller",
    "remuneration": "2469",
    "allocation": "1235",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3704",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "5355",
    "nom_corrige2": "Yanick Hamel",
    "nom_famille": "Hamel",
    "titre_genre2": "Conseiller",
    "remuneration": "2469",
    "allocation": "1235",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3704",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "5356",
    "nom_corrige2": "André Beauchemin",
    "nom_famille": "Beauchemin",
    "titre_genre2": "Conseiller",
    "remuneration": "2469",
    "allocation": "1235",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3704",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "5357",
    "nom_corrige2": "Annie Grandmont",
    "nom_famille": "Grandmont",
    "titre_genre2": "Conseillère",
    "remuneration": "2469",
    "allocation": "1235",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3704",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "5358",
    "nom_corrige2": "Jean-Yves Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "2495",
    "allocation": "1207",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3702",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5359",
    "nom_corrige2": "Danye Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "2464",
    "allocation": "1237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3701",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5360",
    "nom_corrige2": "Suzanne Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "2259",
    "allocation": "1223",
    "remuneration2": "144",
    "allocation2": "72",
    "total": "3698",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "5361",
    "nom_corrige2": "Pierre Bellerose",
    "nom_famille": "Bellerose",
    "titre_genre2": "Conseiller",
    "remuneration": "2542",
    "allocation": "1153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3695",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "5362",
    "nom_corrige2": "Joël Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "2542",
    "allocation": "1153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3695",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "5363",
    "nom_corrige2": "Enzo Marceau",
    "nom_famille": "Marceau",
    "titre_genre2": "Conseiller",
    "remuneration": "2542",
    "allocation": "1153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3695",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "5364",
    "nom_corrige2": "Christiane Bonneau",
    "nom_famille": "Bonneau",
    "titre_genre2": "Conseillère",
    "remuneration": "2542",
    "allocation": "1153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3695",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "5365",
    "nom_corrige2": "Adrien Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "2542",
    "allocation": "1153",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3695",
    "ville": "Saint-Camille",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "572"
  },
  {
    "ID": "5366",
    "nom_corrige2": "Jacques Pelchat",
    "nom_famille": "Pelchat",
    "titre_genre2": "Conseiller",
    "remuneration": "2481",
    "allocation": "1210",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3691",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5367",
    "nom_corrige2": "Éric Poisson",
    "nom_famille": "Poisson",
    "titre_genre2": "Conseiller",
    "remuneration": "2459",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3689",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5368",
    "nom_corrige2": "Dominique Gingras",
    "nom_famille": "Gingras",
    "titre_genre2": "Conseiller",
    "remuneration": "2459",
    "allocation": "1230",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3689",
    "ville": "Saint-Pierre-Baptiste",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "573"
  },
  {
    "ID": "5369",
    "nom_corrige2": "LORRAINE MICHAUD",
    "nom_famille": "MICHAUD",
    "titre_genre2": "Conseillère",
    "remuneration": "2455",
    "allocation": "1228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3683",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5370",
    "nom_corrige2": "STÉPHANIE RIOUX",
    "nom_famille": "RIOUX",
    "titre_genre2": "Conseillère",
    "remuneration": "2455",
    "allocation": "1228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3683",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5371",
    "nom_corrige2": "MARIE-LINE D'ASTOUS",
    "nom_famille": "D'ASTOUS",
    "titre_genre2": "Conseillère",
    "remuneration": "2455",
    "allocation": "1228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3683",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5372",
    "nom_corrige2": "GERMAIN THERRIAULT",
    "nom_famille": "THERRIAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "2455",
    "allocation": "1228",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3683",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5373",
    "nom_corrige2": "Mario Boudreau",
    "nom_famille": "Boudreau",
    "titre_genre2": "Conseiller",
    "remuneration": "2524",
    "allocation": "1158",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3682",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5374",
    "nom_corrige2": "Gaétan Légaré",
    "nom_famille": "Légaré",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5375",
    "nom_corrige2": "Denise Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseillère",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5376",
    "nom_corrige2": "Eve-Lyne Marcotte",
    "nom_famille": "Marcotte",
    "titre_genre2": "Conseillère",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5377",
    "nom_corrige2": "Steven R Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5378",
    "nom_corrige2": "Bernard Philipps",
    "nom_famille": "Philipps",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5379",
    "nom_corrige2": "Maxime Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5380",
    "nom_corrige2": "Christian Lamontagne",
    "nom_famille": "Lamontagne",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5381",
    "nom_corrige2": "Madeleine Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseillère",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5382",
    "nom_corrige2": "Sylvia Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5383",
    "nom_corrige2": "Josiane Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseillère",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Sainte-Rose-de-Watford",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "761"
  },
  {
    "ID": "5384",
    "nom_corrige2": "Claude Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "2452",
    "allocation": "1226",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3678",
    "ville": "Shawinigan",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "51508"
  },
  {
    "ID": "5385",
    "nom_corrige2": "Germain Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseiller",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5386",
    "nom_corrige2": "Anne Marie Yeates Dubeau",
    "nom_famille": "Yeates",
    "titre_genre2": "Conseillère",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5387",
    "nom_corrige2": "Jacqueline Désindes",
    "nom_famille": "Désindes",
    "titre_genre2": "Conseillère",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5388",
    "nom_corrige2": "Jeffrey Bowker",
    "nom_famille": "Bowker",
    "titre_genre2": "Conseiller",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5389",
    "nom_corrige2": "Timothy Morrison",
    "nom_famille": "Morrison",
    "titre_genre2": "Conseiller",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5390",
    "nom_corrige2": "Amanda Hamel",
    "nom_famille": "Hamel",
    "titre_genre2": "Conseillère",
    "remuneration": "2465",
    "allocation": "1212",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3677",
    "ville": "Newport",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "750"
  },
  {
    "ID": "5391",
    "nom_corrige2": "Luc Duval",
    "nom_famille": "Duval",
    "titre_genre2": "Conseiller",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5392",
    "nom_corrige2": "Charles Smith",
    "nom_famille": "Smith",
    "titre_genre2": "Conseiller",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5393",
    "nom_corrige2": "Josianne Chayer",
    "nom_famille": "Chayer",
    "titre_genre2": "Conseillère",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5394",
    "nom_corrige2": "Francis Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5395",
    "nom_corrige2": "Sylvain Lafortune",
    "nom_famille": "Lafortune",
    "titre_genre2": "Conseiller",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5396",
    "nom_corrige2": "Jean Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2450",
    "allocation": "1225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3675",
    "ville": "Saint-Roch-Ouest",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "319"
  },
  {
    "ID": "5397",
    "nom_corrige2": "Céline Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3669",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "5398",
    "nom_corrige2": "Michel Lalonde",
    "nom_famille": "Lalonde",
    "titre_genre2": "Conseiller",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3669",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "5399",
    "nom_corrige2": "Mike Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3669",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "5400",
    "nom_corrige2": "Julien Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3669",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "5401",
    "nom_corrige2": "Michel Bélisle",
    "nom_famille": "Bélisle",
    "titre_genre2": "Conseiller",
    "remuneration": "2446",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3669",
    "ville": "L'Avenir",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1449"
  },
  {
    "ID": "5402",
    "nom_corrige2": "Ghislain Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "2357",
    "allocation": "1311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3668",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5403",
    "nom_corrige2": "CLAUDE LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "2444",
    "allocation": "1222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3666",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5404",
    "nom_corrige2": "ANDRÉ TESSIER",
    "nom_famille": "TESSIER",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "405",
    "allocation2": "429",
    "total": "3652",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5405",
    "nom_corrige2": "Pierre Carignan",
    "nom_famille": "Carignan",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "576",
    "allocation2": "288",
    "total": "3648",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5406",
    "nom_corrige2": "Laurier Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "95",
    "allocation2": "47",
    "total": "3643",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5407",
    "nom_corrige2": "Maureen Murphy",
    "nom_famille": "Murphy",
    "titre_genre2": "Conseillère",
    "remuneration": "2428",
    "allocation": "1214",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3642",
    "ville": "Melbourne",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1140"
  },
  {
    "ID": "5408",
    "nom_corrige2": "Michael Krohn",
    "nom_famille": "Krohn",
    "titre_genre2": "Conseiller",
    "remuneration": "2960",
    "allocation": "678",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3638",
    "ville": "Hemmingford",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "849"
  },
  {
    "ID": "5409",
    "nom_corrige2": "Jade Veillette",
    "nom_famille": "Veillette",
    "titre_genre2": "Conseillère",
    "remuneration": "2411",
    "allocation": "1209",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3620",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "5410",
    "nom_corrige2": "Christine Langelier",
    "nom_famille": "Langelier",
    "titre_genre2": "Conseillère",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3616",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5411",
    "nom_corrige2": "Vanessa Lemoine",
    "nom_famille": "Lemoine",
    "titre_genre2": "Conseillère",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3616",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5412",
    "nom_corrige2": "Jean-Paul Chandonnet",
    "nom_famille": "Chandonnet",
    "titre_genre2": "Conseiller",
    "remuneration": "2411",
    "allocation": "1205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3616",
    "ville": "Saint-Bernard-de-Michaudville",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "612"
  },
  {
    "ID": "5413",
    "nom_corrige2": "AUDREY CHAREST",
    "nom_famille": "CHAREST",
    "titre_genre2": "Conseillère",
    "remuneration": "2410",
    "allocation": "1205",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3615",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5414",
    "nom_corrige2": "Patrick Salvas",
    "nom_famille": "Salvas",
    "titre_genre2": "Conseiller",
    "remuneration": "2406",
    "allocation": "1203",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3609",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5415",
    "nom_corrige2": "Philippe Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2406",
    "allocation": "1203",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3609",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5416",
    "nom_corrige2": "Sylvie Fafard",
    "nom_famille": "Fafard",
    "titre_genre2": "Conseillère",
    "remuneration": "2406",
    "allocation": "1203",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3609",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5417",
    "nom_corrige2": "Steve Arès",
    "nom_famille": "Arès",
    "titre_genre2": "Conseiller",
    "remuneration": "2402",
    "allocation": "1201",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3603",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "5418",
    "nom_corrige2": "Michaël Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "2295",
    "allocation": "1148",
    "remuneration2": "157",
    "allocation2": "0",
    "total": "3600",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "5419",
    "nom_corrige2": "Mélissa Gosselin-Dubé",
    "nom_famille": "Gosselin-Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5420",
    "nom_corrige2": "Jean-François Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5421",
    "nom_corrige2": "Marie-Ève Larouche",
    "nom_famille": "Larouche",
    "titre_genre2": "Conseillère",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5422",
    "nom_corrige2": "Gilles Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5423",
    "nom_corrige2": "Normand Vigneau",
    "nom_famille": "Vigneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5424",
    "nom_corrige2": "Noëlla Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2400",
    "allocation": "1200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3600",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5425",
    "nom_corrige2": "Marie Myre",
    "nom_famille": "Myre",
    "titre_genre2": "Conseillère",
    "remuneration": "2381",
    "allocation": "1218",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3599",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5426",
    "nom_corrige2": "Bianka Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3589",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5427",
    "nom_corrige2": "Linda Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3589",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5428",
    "nom_corrige2": "Francine Ross",
    "nom_famille": "Ross",
    "titre_genre2": "Conseillère",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3589",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5429",
    "nom_corrige2": "Michel Rancourt",
    "nom_famille": "Rancourt",
    "titre_genre2": "Conseiller",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3589",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5430",
    "nom_corrige2": "Louiselle Gazaille Rouillard",
    "nom_famille": "Gazaille",
    "titre_genre2": "Conseillère",
    "remuneration": "2393",
    "allocation": "1196",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3589",
    "ville": "Milan",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "326"
  },
  {
    "ID": "5431",
    "nom_corrige2": "Daniel Favreau",
    "nom_famille": "Favreau",
    "titre_genre2": "Conseiller",
    "remuneration": "2385",
    "allocation": "1193",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3578",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "5432",
    "nom_corrige2": "Sylvie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "2382",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3573",
    "ville": "Notre-Dame-du-Portage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1183"
  },
  {
    "ID": "5433",
    "nom_corrige2": "Justin Nieuwenhof",
    "nom_famille": "Nieuwenhof",
    "titre_genre2": "Conseiller",
    "remuneration": "2381",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3572",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5434",
    "nom_corrige2": "Marc Myre",
    "nom_famille": "Myre",
    "titre_genre2": "Conseiller",
    "remuneration": "2381",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3572",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5435",
    "nom_corrige2": "Michel Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "2381",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3572",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5436",
    "nom_corrige2": "Raymond Lazure",
    "nom_famille": "Lazure",
    "titre_genre2": "Conseiller",
    "remuneration": "2381",
    "allocation": "1191",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3572",
    "ville": "Dundee",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "395"
  },
  {
    "ID": "5437",
    "nom_corrige2": "Michel Duheme",
    "nom_famille": "Duheme",
    "titre_genre2": "Conseiller",
    "remuneration": "2377",
    "allocation": "1189",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3566",
    "ville": "Godmanchester",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1557"
  },
  {
    "ID": "5438",
    "nom_corrige2": "Mireille Decelles",
    "nom_famille": "Decelles",
    "titre_genre2": "Conseillère",
    "remuneration": "2377",
    "allocation": "1189",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3566",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "5439",
    "nom_corrige2": "Richard Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "2257",
    "allocation": "1128",
    "remuneration2": "120",
    "allocation2": "60",
    "total": "3565",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "5440",
    "nom_corrige2": "Janet Ryan",
    "nom_famille": "Ryan",
    "titre_genre2": "Conseillère",
    "remuneration": "2372",
    "allocation": "1186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3558",
    "ville": "Baie-D'Urfé",
    "arrondissement": "",
    "region_adm": "Montréal",
    "population": "3889"
  },
  {
    "ID": "5441",
    "nom_corrige2": "Katrine Normandeau",
    "nom_famille": "Normandeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2371",
    "allocation": "1186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3557",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "5442",
    "nom_corrige2": "Georgette Clermont",
    "nom_famille": "Clermont",
    "titre_genre2": "Conseillère",
    "remuneration": "2371",
    "allocation": "1186",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3557",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "5443",
    "nom_corrige2": "Émilie Belzile",
    "nom_famille": "Belzile",
    "titre_genre2": "Conseillère",
    "remuneration": "2295",
    "allocation": "1148",
    "remuneration2": "100",
    "allocation2": "0",
    "total": "3543",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "5444",
    "nom_corrige2": "Jean-Daniel Scheurer",
    "nom_famille": "Scheurer",
    "titre_genre2": "Conseiller",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "90",
    "allocation2": "45",
    "total": "3541",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5445",
    "nom_corrige2": "Rémi Lagacé",
    "nom_famille": "Lagacé",
    "titre_genre2": "Conseiller",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5446",
    "nom_corrige2": "Martial Pitre",
    "nom_famille": "Pitre",
    "titre_genre2": "Conseiller",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5447",
    "nom_corrige2": "René Lambert",
    "nom_famille": "Lambert",
    "titre_genre2": "Conseiller",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5448",
    "nom_corrige2": "Danie Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseillère",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5449",
    "nom_corrige2": "Mélissa Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5450",
    "nom_corrige2": "Annick Lacroix-Maranda",
    "nom_famille": "Lacroix-Maranda",
    "titre_genre2": "Conseillère",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "5451",
    "nom_corrige2": "Nadine Gallant",
    "nom_famille": "Gallant",
    "titre_genre2": "Conseillère",
    "remuneration": "2360",
    "allocation": "1180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3540",
    "ville": "Saint-François-d'Assise",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "653"
  },
  {
    "ID": "5452",
    "nom_corrige2": "Linda Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "2351",
    "allocation": "1175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3526",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5453",
    "nom_corrige2": "Renald Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseiller",
    "remuneration": "2351",
    "allocation": "1175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3526",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5454",
    "nom_corrige2": "Richard Boivin",
    "nom_famille": "Boivin",
    "titre_genre2": "Conseiller",
    "remuneration": "2351",
    "allocation": "1175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3526",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5455",
    "nom_corrige2": "Réal Cameron",
    "nom_famille": "Cameron",
    "titre_genre2": "Conseiller",
    "remuneration": "2351",
    "allocation": "1175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3526",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5456",
    "nom_corrige2": "Rachelle Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseillère",
    "remuneration": "2351",
    "allocation": "1175",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3526",
    "ville": "Stornoway",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "533"
  },
  {
    "ID": "5457",
    "nom_corrige2": "Yannick St-Onge",
    "nom_famille": "St-Onge",
    "titre_genre2": "Conseiller",
    "remuneration": "2338",
    "allocation": "1169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3507",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5458",
    "nom_corrige2": "Albert Lacroix",
    "nom_famille": "Lacroix",
    "titre_genre2": "Conseiller",
    "remuneration": "2338",
    "allocation": "1169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3507",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5459",
    "nom_corrige2": "Louiselle Trottier",
    "nom_famille": "Trottier",
    "titre_genre2": "Conseillère",
    "remuneration": "2338",
    "allocation": "1169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3507",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5460",
    "nom_corrige2": "Norman Heppell",
    "nom_famille": "Heppell",
    "titre_genre2": "Conseiller",
    "remuneration": "2338",
    "allocation": "1169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3507",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5461",
    "nom_corrige2": "Marc Antoine Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "2338",
    "allocation": "1169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3507",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5462",
    "nom_corrige2": "Yvon Desrosiers",
    "nom_famille": "Desrosiers",
    "titre_genre2": "Conseiller",
    "remuneration": "2350",
    "allocation": "1152",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3502",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "5463",
    "nom_corrige2": "Nancy Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseillère",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5464",
    "nom_corrige2": "Jocelyn Béliveau",
    "nom_famille": "Béliveau",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5465",
    "nom_corrige2": "Jessica Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5466",
    "nom_corrige2": "Joey Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5467",
    "nom_corrige2": "Marie-Josée Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Saint-Benjamin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1096"
  },
  {
    "ID": "5468",
    "nom_corrige2": "Lucie Bourgault",
    "nom_famille": "Bourgault",
    "titre_genre2": "Conseillère",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5469",
    "nom_corrige2": "Yves Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5470",
    "nom_corrige2": "Guylaine Chouinard",
    "nom_famille": "Chouinard",
    "titre_genre2": "Conseillère",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5471",
    "nom_corrige2": "Guy Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5472",
    "nom_corrige2": "Lucien Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5473",
    "nom_corrige2": "Réjean Morneau",
    "nom_famille": "Morneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2334",
    "allocation": "1167",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3501",
    "ville": "Sainte-Félicité",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "5474",
    "nom_corrige2": "Chantal Dansereau",
    "nom_famille": "Dansereau",
    "titre_genre2": "Conseillère",
    "remuneration": "2330",
    "allocation": "1165",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3495",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "5475",
    "nom_corrige2": "Éric Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "2328",
    "allocation": "1164",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3492",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "5476",
    "nom_corrige2": "Line Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseillère",
    "remuneration": "2327",
    "allocation": "1164",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3491",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "5477",
    "nom_corrige2": "Benjamin Cousineau",
    "nom_famille": "Cousineau",
    "titre_genre2": "Conseiller",
    "remuneration": "2327",
    "allocation": "1164",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3491",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "5478",
    "nom_corrige2": "Nicole Isabelle",
    "nom_famille": "Isabelle",
    "titre_genre2": "Conseillère",
    "remuneration": "2327",
    "allocation": "1164",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3491",
    "ville": "Sainte-Edwidge-de-Clifton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "544"
  },
  {
    "ID": "5479",
    "nom_corrige2": "Carole Touchette",
    "nom_famille": "Touchette",
    "titre_genre2": "Conseillère",
    "remuneration": "2326",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3489",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5480",
    "nom_corrige2": "Pierre-Paul Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseiller",
    "remuneration": "2326",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3489",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5481",
    "nom_corrige2": "Eric Thibaudeau",
    "nom_famille": "Thibaudeau",
    "titre_genre2": "Conseiller",
    "remuneration": "2326",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3489",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5482",
    "nom_corrige2": "Stefan Steiner",
    "nom_famille": "Steiner",
    "titre_genre2": "Conseiller",
    "remuneration": "2326",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3489",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5483",
    "nom_corrige2": "Chantal Laviolette",
    "nom_famille": "Laviolette",
    "titre_genre2": "Conseillère",
    "remuneration": "2326",
    "allocation": "1163",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3489",
    "ville": "Lochaber",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "450"
  },
  {
    "ID": "5484",
    "nom_corrige2": "Geneviève Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseillère",
    "remuneration": "2326",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3483",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5485",
    "nom_corrige2": "Sylvain Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "2326",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3483",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5486",
    "nom_corrige2": "Éric Morency",
    "nom_famille": "Morency",
    "titre_genre2": "Conseiller",
    "remuneration": "2326",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3483",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5487",
    "nom_corrige2": "Renée Laventure",
    "nom_famille": "Laventure",
    "titre_genre2": "Conseillère",
    "remuneration": "2259",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3482",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "5488",
    "nom_corrige2": "Jonathan Sylvestre",
    "nom_famille": "Sylvestre",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3482",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "5489",
    "nom_corrige2": "Raphaël Ayotte",
    "nom_famille": "Ayotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1223",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3482",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "5490",
    "nom_corrige2": "MARJOLAINE LACHANCE",
    "nom_famille": "LACHANCE",
    "titre_genre2": "Conseillère",
    "remuneration": "2320",
    "allocation": "1160",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3480",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5491",
    "nom_corrige2": "Jean Malo",
    "nom_famille": "Malo",
    "titre_genre2": "Conseiller",
    "remuneration": "2314",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3471",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5492",
    "nom_corrige2": "Allyson Bigot",
    "nom_famille": "Bigot",
    "titre_genre2": "Conseillère",
    "remuneration": "2314",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3471",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5493",
    "nom_corrige2": "Vincent Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseiller",
    "remuneration": "2314",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3471",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5494",
    "nom_corrige2": "Lucie Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseillère",
    "remuneration": "2314",
    "allocation": "1157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3471",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5495",
    "nom_corrige2": "MICHEL MOREAU",
    "nom_famille": "MOREAU",
    "titre_genre2": "Conseiller",
    "remuneration": "2308",
    "allocation": "1154",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3462",
    "ville": "Dosquet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "997"
  },
  {
    "ID": "5496",
    "nom_corrige2": "Mathieu Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "2320",
    "allocation": "710",
    "remuneration2": "286",
    "allocation2": "143",
    "total": "3459",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5497",
    "nom_corrige2": "Serge Delongchamp",
    "nom_famille": "Delongchamp",
    "titre_genre2": "Conseiller",
    "remuneration": "2306",
    "allocation": "1147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3453",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5498",
    "nom_corrige2": "Frédérique Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "2306",
    "allocation": "1147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3453",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5499",
    "nom_corrige2": "Amélie Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "2301",
    "allocation": "1151",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3452",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "5500",
    "nom_corrige2": "Patrice Moore",
    "nom_famille": "Moore",
    "titre_genre2": "Conseiller",
    "remuneration": "2301",
    "allocation": "1151",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3452",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "5501",
    "nom_corrige2": "Line Toupin",
    "nom_famille": "Toupin",
    "titre_genre2": "Conseillère",
    "remuneration": "2301",
    "allocation": "1151",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3452",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "5502",
    "nom_corrige2": "Gaby Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5503",
    "nom_corrige2": "Patricia Gardner",
    "nom_famille": "Gardner",
    "titre_genre2": "Conseillère",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5504",
    "nom_corrige2": "Jonathan Henri",
    "nom_famille": "Henri",
    "titre_genre2": "Conseiller",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5505",
    "nom_corrige2": "Sylvain Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5506",
    "nom_corrige2": "Christiane Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseillère",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5507",
    "nom_corrige2": "Marie-Pierre Dubeau",
    "nom_famille": "Dubeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Martinville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "460"
  },
  {
    "ID": "5508",
    "nom_corrige2": "Marius Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseiller",
    "remuneration": "2300",
    "allocation": "1150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3450",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "5509",
    "nom_corrige2": "Lucie Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "2296",
    "allocation": "1148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3444",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5510",
    "nom_corrige2": "Cynthia Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseillère",
    "remuneration": "2295",
    "allocation": "1148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3443",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "5511",
    "nom_corrige2": "Claudia Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "2295",
    "allocation": "1148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3443",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "5512",
    "nom_corrige2": "Jérémy Robert",
    "nom_famille": "Robert",
    "titre_genre2": "Conseiller",
    "remuneration": "2295",
    "allocation": "1148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3443",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "5513",
    "nom_corrige2": "Gail Anne Daoust",
    "nom_famille": "Daoust",
    "titre_genre2": "Conseillère",
    "remuneration": "2295",
    "allocation": "1147",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3442",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "5514",
    "nom_corrige2": "Mathilde Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseillère",
    "remuneration": "2025",
    "allocation": "1413",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3438",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "5515",
    "nom_corrige2": "ANDRÉ THIBODEAU",
    "nom_famille": "THIBODEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "2285",
    "allocation": "1143",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3428",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "5516",
    "nom_corrige2": "CATHERINE BELLEAU-ARSENAULT",
    "nom_famille": "BELLEAU-ARSENAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "2285",
    "allocation": "1143",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3428",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "5517",
    "nom_corrige2": "JULIEN FOURNIER",
    "nom_famille": "FOURNIER",
    "titre_genre2": "Conseiller",
    "remuneration": "2285",
    "allocation": "1143",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3428",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "5518",
    "nom_corrige2": "GENEVIÈVE BERGERON",
    "nom_famille": "BERGERON",
    "titre_genre2": "Conseillère",
    "remuneration": "2285",
    "allocation": "1143",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3428",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "5519",
    "nom_corrige2": "Cédric Métayer",
    "nom_famille": "Métayer",
    "titre_genre2": "Conseiller",
    "remuneration": "2281",
    "allocation": "1140",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3421",
    "ville": "Sainte-Brigitte-de-Laval",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "8595"
  },
  {
    "ID": "5520",
    "nom_corrige2": "Réjean Albert",
    "nom_famille": "Albert",
    "titre_genre2": "Conseiller",
    "remuneration": "2279",
    "allocation": "1139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3418",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "5521",
    "nom_corrige2": "Fernand Albert",
    "nom_famille": "Albert",
    "titre_genre2": "Conseiller",
    "remuneration": "2279",
    "allocation": "1139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3418",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "5522",
    "nom_corrige2": "Marguerite Albert",
    "nom_famille": "Albert",
    "titre_genre2": "Conseillère",
    "remuneration": "2279",
    "allocation": "1139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3418",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "5523",
    "nom_corrige2": "Armelle Kermarec",
    "nom_famille": "Kermarec",
    "titre_genre2": "Conseillère",
    "remuneration": "2279",
    "allocation": "1139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3418",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "5524",
    "nom_corrige2": "Josiane Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "1778",
    "allocation": "1639",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3417",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "5525",
    "nom_corrige2": "Alain Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "2277",
    "allocation": "1139",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3416",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "457"
  },
  {
    "ID": "5526",
    "nom_corrige2": "Gerald Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Maire",
    "remuneration": "1810",
    "allocation": "905",
    "remuneration2": "464",
    "allocation2": "232",
    "total": "3411",
    "ville": "Havelock",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "749"
  },
  {
    "ID": "5527",
    "nom_corrige2": "Francis Labrecque",
    "nom_famille": "Labrecque",
    "titre_genre2": "Conseiller",
    "remuneration": "2289",
    "allocation": "1118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3407",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5528",
    "nom_corrige2": "Louise Fay",
    "nom_famille": "Fay",
    "titre_genre2": "Conseillère",
    "remuneration": "2374",
    "allocation": "1187",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3561",
    "ville": "Saint-Boniface",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "5278"
  },
  {
    "ID": "5529",
    "nom_corrige2": "Céline Jutras",
    "nom_famille": "Jutras",
    "titre_genre2": "Conseillère",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3406",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5530",
    "nom_corrige2": "Louis Véronneau",
    "nom_famille": "Véronneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3406",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5531",
    "nom_corrige2": "Pierre Grandmont",
    "nom_famille": "Grandmont",
    "titre_genre2": "Conseiller",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3406",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5532",
    "nom_corrige2": "Mathieu Biron-Coderre",
    "nom_famille": "Biron-Coderre",
    "titre_genre2": "Conseiller",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3406",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5533",
    "nom_corrige2": "François Tessier",
    "nom_famille": "Tessier",
    "titre_genre2": "Conseiller",
    "remuneration": "2272",
    "allocation": "1134",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3406",
    "ville": "Saint-Pie-de-Guire",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "463"
  },
  {
    "ID": "5534",
    "nom_corrige2": "Stéphanie Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "2263",
    "allocation": "1135",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3398",
    "ville": "Inverness",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "948"
  },
  {
    "ID": "5535",
    "nom_corrige2": "Chantal Bilodeau",
    "nom_famille": "Bilodeau",
    "titre_genre2": "Conseillère",
    "remuneration": "2263",
    "allocation": "1132",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3395",
    "ville": "Maddington Falls",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "434"
  },
  {
    "ID": "5536",
    "nom_corrige2": "Stéphane Carrière",
    "nom_famille": "Carrière",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1130",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3389",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5537",
    "nom_corrige2": "Danny Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1130",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3389",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5538",
    "nom_corrige2": "Tamara Rathwell",
    "nom_famille": "Rathwell",
    "titre_genre2": "Conseillère",
    "remuneration": "2259",
    "allocation": "1130",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3389",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5539",
    "nom_corrige2": "Simon Laforest",
    "nom_famille": "Laforest",
    "titre_genre2": "Conseiller",
    "remuneration": "2259",
    "allocation": "1130",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3389",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5540",
    "nom_corrige2": "Érick Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "2253",
    "allocation": "1126",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3379",
    "ville": "Saint-Alphonse-Rodriguez",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "3451"
  },
  {
    "ID": "5541",
    "nom_corrige2": "EVELYNE LAMPRON",
    "nom_famille": "LAMPRON",
    "titre_genre2": "Conseillère",
    "remuneration": "2250",
    "allocation": "1125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3375",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "5542",
    "nom_corrige2": "PATRICK MATHIS",
    "nom_famille": "MATHIS",
    "titre_genre2": "Conseiller",
    "remuneration": "2250",
    "allocation": "1125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3375",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "5543",
    "nom_corrige2": "Sylvain Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "2250",
    "allocation": "1125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3375",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "5544",
    "nom_corrige2": "MARIE-FRANCE PLANTE",
    "nom_famille": "PLANTE",
    "titre_genre2": "Conseillère",
    "remuneration": "2250",
    "allocation": "1125",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3375",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "5545",
    "nom_corrige2": "Sébastien Alix",
    "nom_famille": "Alix",
    "titre_genre2": "Conseiller",
    "remuneration": "2248",
    "allocation": "1124",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3372",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "5546",
    "nom_corrige2": "Virginie Ashby",
    "nom_famille": "Ashby",
    "titre_genre2": "Conseillère",
    "remuneration": "2244",
    "allocation": "1122",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3366",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5547",
    "nom_corrige2": "Sylvain Naud",
    "nom_famille": "Naud",
    "titre_genre2": "Conseiller",
    "remuneration": "2160",
    "allocation": "1080",
    "remuneration2": "83",
    "allocation2": "41",
    "total": "3364",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5548",
    "nom_corrige2": "GAÉTAN LEFEBVRE",
    "nom_famille": "LEFEBVRE",
    "titre_genre2": "Conseiller",
    "remuneration": "1564",
    "allocation": "782",
    "remuneration2": "405",
    "allocation2": "609",
    "total": "3360",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "5549",
    "nom_corrige2": "Gabriel Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "2236",
    "allocation": "1118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3354",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5550",
    "nom_corrige2": "André Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseiller",
    "remuneration": "2236",
    "allocation": "1118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3354",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5551",
    "nom_corrige2": "Eric Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseiller",
    "remuneration": "2236",
    "allocation": "1118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3354",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5552",
    "nom_corrige2": "Sylvie Lefbvre",
    "nom_famille": "Lefbvre",
    "titre_genre2": "Conseillère",
    "remuneration": "2236",
    "allocation": "1118",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3354",
    "ville": "Notre-Dame-Auxiliatrice-de-Buckland",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "757"
  },
  {
    "ID": "5553",
    "nom_corrige2": "Jean-François Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5554",
    "nom_corrige2": "François Proulx",
    "nom_famille": "Proulx",
    "titre_genre2": "Conseiller",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5555",
    "nom_corrige2": "Marie-Pier Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5556",
    "nom_corrige2": "Gaston Lessard",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5557",
    "nom_corrige2": "Francis Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5558",
    "nom_corrige2": "Patricia Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseillère",
    "remuneration": "2229",
    "allocation": "1114",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3343",
    "ville": "Saint-Séverin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "282"
  },
  {
    "ID": "5559",
    "nom_corrige2": "Caroline Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "1688",
    "allocation": "1651",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3339",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "5560",
    "nom_corrige2": "Sophie Catherine Chapleau",
    "nom_famille": "Catherine",
    "titre_genre2": "Conseillère",
    "remuneration": "2225",
    "allocation": "1112",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3337",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5561",
    "nom_corrige2": "Neil Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseiller",
    "remuneration": "2225",
    "allocation": "1112",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3337",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5562",
    "nom_corrige2": "Nathalie Vermette",
    "nom_famille": "Vermette",
    "titre_genre2": "Conseillère",
    "remuneration": "2225",
    "allocation": "1112",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3337",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5563",
    "nom_corrige2": "Caroline Cusson",
    "nom_famille": "Cusson",
    "titre_genre2": "Conseillère",
    "remuneration": "2225",
    "allocation": "1112",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3337",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5564",
    "nom_corrige2": "Melissa Brock",
    "nom_famille": "Brock",
    "titre_genre2": "Conseillère",
    "remuneration": "2225",
    "allocation": "1112",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3337",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5565",
    "nom_corrige2": "Yvon Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "2222",
    "allocation": "1111",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3333",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5566",
    "nom_corrige2": "Isabelle Harmegnies",
    "nom_famille": "Harmegnies",
    "titre_genre2": "Conseillère",
    "remuneration": "2222",
    "allocation": "1111",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3333",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "5567",
    "nom_corrige2": "David Trépanier",
    "nom_famille": "Trépanier",
    "titre_genre2": "Conseiller",
    "remuneration": "2214",
    "allocation": "1107",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3321",
    "ville": "Sainte-Clotilde-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "597"
  },
  {
    "ID": "5568",
    "nom_corrige2": "Luce Morneau",
    "nom_famille": "Morneau",
    "titre_genre2": "Conseillère",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5569",
    "nom_corrige2": "Lucia Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseillère",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5570",
    "nom_corrige2": "Vicky Labonté",
    "nom_famille": "Labonté",
    "titre_genre2": "Conseillère",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5571",
    "nom_corrige2": "Benoit Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5572",
    "nom_corrige2": "Stéphanie Dubreuil",
    "nom_famille": "Dubreuil",
    "titre_genre2": "Conseillère",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5573",
    "nom_corrige2": "Cynthia Bois",
    "nom_famille": "Bois",
    "titre_genre2": "Conseillère",
    "remuneration": "2211",
    "allocation": "1105",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3316",
    "ville": "Tourville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "568"
  },
  {
    "ID": "5574",
    "nom_corrige2": "Alex Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "2206",
    "allocation": "1103",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3309",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5575",
    "nom_corrige2": "Miguel Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5576",
    "nom_corrige2": "Jérôme Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseiller",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5577",
    "nom_corrige2": "Alain Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5578",
    "nom_corrige2": "Annabelle Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5579",
    "nom_corrige2": "Luc St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5580",
    "nom_corrige2": "Véronique Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "2193",
    "allocation": "1096",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3289",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1101"
  },
  {
    "ID": "5581",
    "nom_corrige2": "Sylvie Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "2177",
    "allocation": "1088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3265",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5582",
    "nom_corrige2": "Jacques O. Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "2177",
    "allocation": "1088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3265",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5583",
    "nom_corrige2": "Alain Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseiller",
    "remuneration": "2177",
    "allocation": "1088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3265",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5584",
    "nom_corrige2": "Mario Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "2177",
    "allocation": "1088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3265",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5585",
    "nom_corrige2": "Pierre Denis",
    "nom_famille": "Denis",
    "titre_genre2": "Conseiller",
    "remuneration": "2177",
    "allocation": "1088",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3265",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5586",
    "nom_corrige2": "Pierre Marcoux",
    "nom_famille": "Marcoux",
    "titre_genre2": "Conseiller",
    "remuneration": "2174",
    "allocation": "1087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3261",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "5587",
    "nom_corrige2": "Guillaume Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "2174",
    "allocation": "1087",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3261",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "5588",
    "nom_corrige2": "Hélène Durette",
    "nom_famille": "Durette",
    "titre_genre2": "Conseillère",
    "remuneration": "2205",
    "allocation": "1055",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3260",
    "ville": "Saint-Elzéar-de-Témiscouata",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "320"
  },
  {
    "ID": "5589",
    "nom_corrige2": "André Renaud",
    "nom_famille": "Renaud",
    "titre_genre2": "Conseiller",
    "remuneration": "2173",
    "allocation": "1086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3259",
    "ville": "Saint-Esprit",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2262"
  },
  {
    "ID": "5590",
    "nom_corrige2": "Josée Chrétien",
    "nom_famille": "Chrétien",
    "titre_genre2": "Conseillère",
    "remuneration": "2172",
    "allocation": "1086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3258",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5591",
    "nom_corrige2": "Chantal Mainville",
    "nom_famille": "Mainville",
    "titre_genre2": "Conseillère",
    "remuneration": "2172",
    "allocation": "1086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3258",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5592",
    "nom_corrige2": "Fernand Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2172",
    "allocation": "1086",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3258",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5593",
    "nom_corrige2": "Frank Pappas",
    "nom_famille": "Pappas",
    "titre_genre2": "Conseiller",
    "remuneration": "2169",
    "allocation": "1084",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3253",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "5594",
    "nom_corrige2": "Dale Rathwell",
    "nom_famille": "Rathwell",
    "titre_genre2": "Conseiller",
    "remuneration": "2166",
    "allocation": "1083",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3249",
    "ville": "Arundel",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "563"
  },
  {
    "ID": "5595",
    "nom_corrige2": "Denis Lefèvre",
    "nom_famille": "Lefèvre",
    "titre_genre2": "Conseiller",
    "remuneration": "2163",
    "allocation": "1081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3244",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "5596",
    "nom_corrige2": "Alexandra Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "2163",
    "allocation": "1081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3244",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "5597",
    "nom_corrige2": "Martial Lugez",
    "nom_famille": "Lugez",
    "titre_genre2": "Conseiller",
    "remuneration": "2163",
    "allocation": "1081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3244",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "5598",
    "nom_corrige2": "Serge Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "2163",
    "allocation": "1081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3244",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "5599",
    "nom_corrige2": "Sylvain Chabot",
    "nom_famille": "Chabot",
    "titre_genre2": "Conseiller",
    "remuneration": "2163",
    "allocation": "1081",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3244",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "5600",
    "nom_corrige2": "Mathieu Fecteau",
    "nom_famille": "Fecteau",
    "titre_genre2": "Conseiller",
    "remuneration": "2160",
    "allocation": "1080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3240",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5601",
    "nom_corrige2": "Raphaël Benoit",
    "nom_famille": "Benoit",
    "titre_genre2": "Conseiller",
    "remuneration": "2160",
    "allocation": "1080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3240",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5602",
    "nom_corrige2": "Marie-Ève Moisan",
    "nom_famille": "Moisan",
    "titre_genre2": "Conseillère",
    "remuneration": "2160",
    "allocation": "1080",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3240",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5603",
    "nom_corrige2": "Philippe Delage",
    "nom_famille": "Delage",
    "titre_genre2": "Conseillère",
    "remuneration": "2157",
    "allocation": "1078",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3235",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "5604",
    "nom_corrige2": "Roger Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5605",
    "nom_corrige2": "Éric Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5606",
    "nom_corrige2": "Jocelyn Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5607",
    "nom_corrige2": "Samuel Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5608",
    "nom_corrige2": "Gisèle Saindon",
    "nom_famille": "Saindon",
    "titre_genre2": "Conseillère",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5609",
    "nom_corrige2": "Jonathan Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "2154",
    "allocation": "1077",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3231",
    "ville": "Saint-Éloi",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "294"
  },
  {
    "ID": "5610",
    "nom_corrige2": "Sylvain Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "2146",
    "allocation": "1073",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3219",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "5611",
    "nom_corrige2": "Jean-Marie Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2144",
    "allocation": "1072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3216",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "5612",
    "nom_corrige2": "Dominic Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2143",
    "allocation": "1072",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3215",
    "ville": "Saint-Eugène",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1198"
  },
  {
    "ID": "5613",
    "nom_corrige2": "Coralie Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Benoît-Labre",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1680"
  },
  {
    "ID": "5614",
    "nom_corrige2": "Martine Vignola",
    "nom_famille": "Vignola",
    "titre_genre2": "Conseillère",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5615",
    "nom_corrige2": "Sébastien Noël",
    "nom_famille": "Noël",
    "titre_genre2": "Conseiller",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5616",
    "nom_corrige2": "Manon Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5617",
    "nom_corrige2": "Jean-Pierre Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5618",
    "nom_corrige2": "Eric Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "2140",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3210",
    "ville": "Saint-Marcellin",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "374"
  },
  {
    "ID": "5619",
    "nom_corrige2": "Cynthia Ferland",
    "nom_famille": "Ferland",
    "titre_genre2": "Conseillère",
    "remuneration": "2139",
    "allocation": "1070",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3209",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5620",
    "nom_corrige2": "Patrice Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "2137",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3205",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "5621",
    "nom_corrige2": "CHRISTIAN MARTEL",
    "nom_famille": "MARTEL",
    "titre_genre2": "Conseiller",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5622",
    "nom_corrige2": "NANCY GRIMARD",
    "nom_famille": "GRIMARD",
    "titre_genre2": "Conseillère",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5623",
    "nom_corrige2": "ANDRÉ BOUGIE",
    "nom_famille": "BOUGIE",
    "titre_genre2": "Conseiller",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5624",
    "nom_corrige2": "JEAN-DANIEL LAVERTU",
    "nom_famille": "LAVERTU",
    "titre_genre2": "Conseiller",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5625",
    "nom_corrige2": "JEANNOT PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseiller",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5626",
    "nom_corrige2": "JESSIKA BOISVERT",
    "nom_famille": "BOISVERT",
    "titre_genre2": "Conseillère",
    "remuneration": "2136",
    "allocation": "1068",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3204",
    "ville": "Sainte-Élizabeth-de-Warwick",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "392"
  },
  {
    "ID": "5627",
    "nom_corrige2": "Alain Bachand",
    "nom_famille": "Bachand",
    "titre_genre2": "Conseiller",
    "remuneration": "2133",
    "allocation": "1067",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3200",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "5628",
    "nom_corrige2": "Mario Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "2124",
    "allocation": "1063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3187",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "5629",
    "nom_corrige2": "Jérôme Boissonneault",
    "nom_famille": "Boissonneault",
    "titre_genre2": "Conseiller",
    "remuneration": "2124",
    "allocation": "1063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3187",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "5630",
    "nom_corrige2": "Vincent Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "2124",
    "allocation": "1063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3187",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "5631",
    "nom_corrige2": "Claudia Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseillère",
    "remuneration": "2124",
    "allocation": "1063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3187",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "5632",
    "nom_corrige2": "Richard Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseiller",
    "remuneration": "2124",
    "allocation": "1063",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3187",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "5633",
    "nom_corrige2": "Marcel Élément",
    "nom_famille": "Élément",
    "titre_genre2": "Conseiller",
    "remuneration": "2123",
    "allocation": "1061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3184",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5634",
    "nom_corrige2": "Lise Garant",
    "nom_famille": "Garant",
    "titre_genre2": "Conseillère",
    "remuneration": "2123",
    "allocation": "1061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3184",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5635",
    "nom_corrige2": "Michel Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseiller",
    "remuneration": "2123",
    "allocation": "1061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3184",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5636",
    "nom_corrige2": "Jasmin Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2123",
    "allocation": "1061",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3184",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5637",
    "nom_corrige2": "Denis Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2116",
    "allocation": "1058",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3174",
    "ville": "Saint-François-de-l'Île-d'Orléans",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "573"
  },
  {
    "ID": "5638",
    "nom_corrige2": "Sylvain Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5639",
    "nom_corrige2": "Justin Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5640",
    "nom_corrige2": "Alexandre Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseiller",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5641",
    "nom_corrige2": "Nathalie Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5642",
    "nom_corrige2": "Charles Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseiller",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5643",
    "nom_corrige2": "Sarah Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "2114",
    "allocation": "1057",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3171",
    "ville": "Sainte-Séraphine",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "398"
  },
  {
    "ID": "5644",
    "nom_corrige2": "Ronald Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "2170",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5645",
    "nom_corrige2": "Rémi Kelley",
    "nom_famille": "Kelley",
    "titre_genre2": "Conseiller",
    "remuneration": "2170",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5646",
    "nom_corrige2": "Sylvie Germain",
    "nom_famille": "Germain",
    "titre_genre2": "Conseillère",
    "remuneration": "2170",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5647",
    "nom_corrige2": "Pascal Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseiller",
    "remuneration": "2170",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5648",
    "nom_corrige2": "Denise Lessard Morin",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseillère",
    "remuneration": "2170",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Dupuy",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "927"
  },
  {
    "ID": "5649",
    "nom_corrige2": "Renald Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5650",
    "nom_corrige2": "Pâquerette Thériault",
    "nom_famille": "Thériault",
    "titre_genre2": "Conseillère",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5651",
    "nom_corrige2": "Vallier Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5652",
    "nom_corrige2": "Caroline Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseillère",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5653",
    "nom_corrige2": "Guillaume Tardif",
    "nom_famille": "Tardif",
    "titre_genre2": "Conseiller",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5654",
    "nom_corrige2": "Nicolas Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "2109",
    "allocation": "1056",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3165",
    "ville": "Saint-Épiphane",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "872"
  },
  {
    "ID": "5655",
    "nom_corrige2": "Pierre Lizotte",
    "nom_famille": "Lizotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2104",
    "allocation": "1052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3156",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "5656",
    "nom_corrige2": "Denis Boies",
    "nom_famille": "Boies",
    "titre_genre2": "Conseiller",
    "remuneration": "2104",
    "allocation": "1052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3156",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "5657",
    "nom_corrige2": "Alain Bois",
    "nom_famille": "Bois",
    "titre_genre2": "Conseiller",
    "remuneration": "2104",
    "allocation": "1052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3156",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "5658",
    "nom_corrige2": "Marc-André Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "2104",
    "allocation": "1052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3156",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "5659",
    "nom_corrige2": "René Castonguay",
    "nom_famille": "Castonguay",
    "titre_genre2": "Conseiller",
    "remuneration": "2104",
    "allocation": "1052",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3156",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "5660",
    "nom_corrige2": "Gérald Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "2283",
    "allocation": "867",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3150",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5661",
    "nom_corrige2": "Michel Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseiller",
    "remuneration": "2273",
    "allocation": "874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3147",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5662",
    "nom_corrige2": "Jean Légaré",
    "nom_famille": "Légaré",
    "titre_genre2": "Conseiller",
    "remuneration": "2094",
    "allocation": "1041",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3135",
    "ville": "Val-Racine",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "172"
  },
  {
    "ID": "5663",
    "nom_corrige2": "Ziv Przytyk",
    "nom_famille": "Przytyk",
    "titre_genre2": "Conseiller",
    "remuneration": "2087",
    "allocation": "1044",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3131",
    "ville": "Barnston-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "573"
  },
  {
    "ID": "5664",
    "nom_corrige2": "Normand Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "2086",
    "allocation": "1043",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3129",
    "ville": "Saint-Alexis-de-Matapédia",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "493"
  },
  {
    "ID": "5665",
    "nom_corrige2": "Anne Harrisson",
    "nom_famille": "Harrisson",
    "titre_genre2": "Conseillère",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5666",
    "nom_corrige2": "Marc Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5667",
    "nom_corrige2": "Alain Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseiller",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5668",
    "nom_corrige2": "Frédéric Lemieux",
    "nom_famille": "Lemieux",
    "titre_genre2": "Conseiller",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5669",
    "nom_corrige2": "Laurie Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseillère",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5670",
    "nom_corrige2": "Glad'ys Aubé",
    "nom_famille": "Aubé",
    "titre_genre2": "Conseillère",
    "remuneration": "2085",
    "allocation": "1042",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3127",
    "ville": "Saint-Vallier",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1080"
  },
  {
    "ID": "5671",
    "nom_corrige2": "Claire Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseillère",
    "remuneration": "2083",
    "allocation": "1041",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3124",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "5672",
    "nom_corrige2": "Nancy Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "2083",
    "allocation": "1041",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3124",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "5673",
    "nom_corrige2": "Jean-Claude Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseiller",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "503",
    "allocation2": "295",
    "total": "3121",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "5674",
    "nom_corrige2": "Réjean Sini",
    "nom_famille": "Sini",
    "titre_genre2": "Conseiller",
    "remuneration": "2074",
    "allocation": "1037",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3111",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "5675",
    "nom_corrige2": "Christian Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "2072",
    "allocation": "1036",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3108",
    "ville": "Sainte-Hénédine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1452"
  },
  {
    "ID": "5676",
    "nom_corrige2": "David Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "1571",
    "allocation": "1534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3105",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "5677",
    "nom_corrige2": "Alain Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "1571",
    "allocation": "1534",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3105",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "5678",
    "nom_corrige2": "Norman Rainville",
    "nom_famille": "Rainville",
    "titre_genre2": "Conseiller",
    "remuneration": "1896",
    "allocation": "948",
    "remuneration2": "155",
    "allocation2": "77",
    "total": "3076",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "5679",
    "nom_corrige2": "DEAVE D'ASTOUS",
    "nom_famille": "D'ASTOUS",
    "titre_genre2": "Conseiller",
    "remuneration": "2046",
    "allocation": "1023",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3069",
    "ville": "Saint-Eugène-de-Ladrière",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "400"
  },
  {
    "ID": "5680",
    "nom_corrige2": "Michel Ayotte",
    "nom_famille": "Ayotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2041",
    "allocation": "1020",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3061",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5681",
    "nom_corrige2": "Robert Rocheleau",
    "nom_famille": "Rocheleau",
    "titre_genre2": "Conseiller",
    "remuneration": "2301",
    "allocation": "751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3052",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5682",
    "nom_corrige2": "Rita Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseillère",
    "remuneration": "2301",
    "allocation": "751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3052",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5683",
    "nom_corrige2": "Ghislain Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Conseiller",
    "remuneration": "2026",
    "allocation": "1026",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3052",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "5684",
    "nom_corrige2": "Audrey Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "2030",
    "allocation": "1015",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3045",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "5685",
    "nom_corrige2": "France Tardif",
    "nom_famille": "Tardif",
    "titre_genre2": "Conseillère",
    "remuneration": "2027",
    "allocation": "1013",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3040",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "5686",
    "nom_corrige2": "Jacques Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5687",
    "nom_corrige2": "Gabriel Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5688",
    "nom_corrige2": "Clément Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5689",
    "nom_corrige2": "Frédéric Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5690",
    "nom_corrige2": "Lorraine Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5691",
    "nom_corrige2": "Réal Petitclerc",
    "nom_famille": "Petitclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "2017",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3025",
    "ville": "Saint-Marcel",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "439"
  },
  {
    "ID": "5692",
    "nom_corrige2": "Linda Pomerleau",
    "nom_famille": "Pomerleau",
    "titre_genre2": "Conseillère",
    "remuneration": "2016",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3024",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5693",
    "nom_corrige2": "Véronique Lemire",
    "nom_famille": "Lemire",
    "titre_genre2": "Conseillère",
    "remuneration": "2016",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3024",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5694",
    "nom_corrige2": "Claude Cardinal",
    "nom_famille": "Cardinal",
    "titre_genre2": "Conseillère",
    "remuneration": "2016",
    "allocation": "1008",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3024",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5695",
    "nom_corrige2": "Danielle Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "1955",
    "allocation": "1067",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3022",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "5696",
    "nom_corrige2": "Guy Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "1955",
    "allocation": "1067",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3022",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "5697",
    "nom_corrige2": "Nicole Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "2012",
    "allocation": "1006",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3018",
    "ville": "Clerval",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "399"
  },
  {
    "ID": "5698",
    "nom_corrige2": "Alain Castonguay",
    "nom_famille": "Castonguay",
    "titre_genre2": "Conseiller",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5699",
    "nom_corrige2": "Marco Lizotte",
    "nom_famille": "Lizotte",
    "titre_genre2": "Conseiller",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5700",
    "nom_corrige2": "Jean-Marie Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5701",
    "nom_corrige2": "Roland Lévesque",
    "nom_famille": "Lévesque",
    "titre_genre2": "Conseiller",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5702",
    "nom_corrige2": "Kristina Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5703",
    "nom_corrige2": "Jean-Charles Jean",
    "nom_famille": "Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "2008",
    "allocation": "1004",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3012",
    "ville": "Saint-Philippe-de-Néri",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "800"
  },
  {
    "ID": "5704",
    "nom_corrige2": "Alexandre Houle",
    "nom_famille": "Houle",
    "titre_genre2": "Conseiller",
    "remuneration": "2005",
    "allocation": "1003",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3008",
    "ville": "Saint-Nazaire-d'Acton",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "896"
  },
  {
    "ID": "5705",
    "nom_corrige2": "Jean Simon Levert",
    "nom_famille": "Levert",
    "titre_genre2": "Maire",
    "remuneration": "29062",
    "allocation": "14531",
    "remuneration2": "4678",
    "allocation2": "2339",
    "total": "50610",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "5706",
    "nom_corrige2": "Carol Oster",
    "nom_famille": "Oster",
    "titre_genre2": "Conseillère",
    "remuneration": "9672",
    "allocation": "4836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14508",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "5707",
    "nom_corrige2": "Colin Shattler",
    "nom_famille": "Shattler",
    "titre_genre2": "Conseiller",
    "remuneration": "6500",
    "allocation": "3250",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "9750",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "5708",
    "nom_corrige2": "Guy Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "9672",
    "allocation": "4836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14508",
    "ville": "Mont-Blanc",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3900"
  },
  {
    "ID": "5709",
    "nom_corrige2": "Erick Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "5710",
    "nom_corrige2": "Sylvain Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "5711",
    "nom_corrige2": "André Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "5712",
    "nom_corrige2": "Daniel Morais",
    "nom_famille": "Morais",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "5713",
    "nom_corrige2": "Pierre Bourassa",
    "nom_famille": "Bourassa",
    "titre_genre2": "Conseiller",
    "remuneration": "2123",
    "allocation": "874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2997",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5714",
    "nom_corrige2": "Marjolaine Morasse",
    "nom_famille": "Morasse",
    "titre_genre2": "Conseillère",
    "remuneration": "1989",
    "allocation": "997",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "5715",
    "nom_corrige2": "Marie-Claude Durand",
    "nom_famille": "Durand",
    "titre_genre2": "Conseillère",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5716",
    "nom_corrige2": "Samuel Lanoie",
    "nom_famille": "Lanoie",
    "titre_genre2": "Conseiller",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5717",
    "nom_corrige2": "Christian Lupien",
    "nom_famille": "Lupien",
    "titre_genre2": "Conseiller",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5718",
    "nom_corrige2": "Austin Leavey",
    "nom_famille": "Leavey",
    "titre_genre2": "Conseiller",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5719",
    "nom_corrige2": "Steve Courchesne",
    "nom_famille": "Courchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5720",
    "nom_corrige2": "Robert Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseiller",
    "remuneration": "1991",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2986",
    "ville": "Saint-Edmond-de-Grantham",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "781"
  },
  {
    "ID": "5721",
    "nom_corrige2": "Donald Bergevin",
    "nom_famille": "Bergevin",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5722",
    "nom_corrige2": "David Drummond",
    "nom_famille": "Drummond",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5723",
    "nom_corrige2": "Matthew Wallace",
    "nom_famille": "Wallace",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5724",
    "nom_corrige2": "Justin Moss",
    "nom_famille": "Moss",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5725",
    "nom_corrige2": "Markus Liebl",
    "nom_famille": "Liebl",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5726",
    "nom_corrige2": "James Gaw",
    "nom_famille": "Gaw",
    "titre_genre2": "Conseiller",
    "remuneration": "1990",
    "allocation": "995",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2985",
    "ville": "Elgin",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "397"
  },
  {
    "ID": "5727",
    "nom_corrige2": "Linda Mcduff",
    "nom_famille": "Mcduff",
    "titre_genre2": "Conseillère",
    "remuneration": "1882",
    "allocation": "941",
    "remuneration2": "107",
    "allocation2": "54",
    "total": "2984",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "5728",
    "nom_corrige2": "Julie Hébert",
    "nom_famille": "Hébert",
    "titre_genre2": "Conseillère",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "433",
    "allocation2": "217",
    "total": "2984",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "5729",
    "nom_corrige2": "Mario Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "1986",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2978",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "5730",
    "nom_corrige2": "Jacques Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "1986",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2978",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "5731",
    "nom_corrige2": "Hervé Voyer",
    "nom_famille": "Voyer",
    "titre_genre2": "Conseiller",
    "remuneration": "1986",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2978",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "5732",
    "nom_corrige2": "Andrew Caddell",
    "nom_famille": "Caddell",
    "titre_genre2": "Conseiller",
    "remuneration": "1986",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2978",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "5733",
    "nom_corrige2": "Luc Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseiller",
    "remuneration": "2566",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2978",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "5734",
    "nom_corrige2": "Daniel Lamarche",
    "nom_famille": "Lamarche",
    "titre_genre2": "Conseiller",
    "remuneration": "1984",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2976",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "5735",
    "nom_corrige2": "Michel Lindsay",
    "nom_famille": "Lindsay",
    "titre_genre2": "Conseiller",
    "remuneration": "1984",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2976",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5736",
    "nom_corrige2": "Lucien Beaudry",
    "nom_famille": "Beaudry",
    "titre_genre2": "Conseiller",
    "remuneration": "1984",
    "allocation": "992",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2976",
    "ville": "Saint-Hilaire-de-Dorset",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "99"
  },
  {
    "ID": "5737",
    "nom_corrige2": "Christine Doré",
    "nom_famille": "Doré",
    "titre_genre2": "Conseillère",
    "remuneration": "2972",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2972",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "5738",
    "nom_corrige2": "Caroline Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseillère",
    "remuneration": "1980",
    "allocation": "990",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2970",
    "ville": "Saint-Léonard-de-Portneuf",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "1180"
  },
  {
    "ID": "5739",
    "nom_corrige2": "Dany Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5740",
    "nom_corrige2": "Daniel Brisson",
    "nom_famille": "Brisson",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5741",
    "nom_corrige2": "Jason Tousignant",
    "nom_famille": "Tousignant",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5742",
    "nom_corrige2": "Cathy Michel",
    "nom_famille": "Michel",
    "titre_genre2": "Conseillère",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5743",
    "nom_corrige2": "Samuel Castonguay",
    "nom_famille": "Castonguay",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5744",
    "nom_corrige2": "Jean-François Bienvenue",
    "nom_famille": "Bienvenue",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Parisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "520"
  },
  {
    "ID": "5745",
    "nom_corrige2": "André Bujold",
    "nom_famille": "Bujold",
    "titre_genre2": "Conseiller",
    "remuneration": "1976",
    "allocation": "988",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2964",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "5746",
    "nom_corrige2": "Josée Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseillère",
    "remuneration": "1972",
    "allocation": "986",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2958",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "5747",
    "nom_corrige2": "Sylvain Claveau",
    "nom_famille": "Claveau",
    "titre_genre2": "Conseiller",
    "remuneration": "1972",
    "allocation": "986",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2958",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "5748",
    "nom_corrige2": "Francis Dompierre",
    "nom_famille": "Dompierre",
    "titre_genre2": "Conseiller",
    "remuneration": "1972",
    "allocation": "986",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2958",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "5749",
    "nom_corrige2": "Mélanie Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "2957",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2957",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "5750",
    "nom_corrige2": "Frédéric Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "2957",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2957",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "5751",
    "nom_corrige2": "France Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "1971",
    "allocation": "985",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2956",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "5752",
    "nom_corrige2": "Maxime Guillot",
    "nom_famille": "Guillot",
    "titre_genre2": "Conseiller",
    "remuneration": "2087",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2955",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5753",
    "nom_corrige2": "Yves Bourassa",
    "nom_famille": "Bourassa",
    "titre_genre2": "Conseiller",
    "remuneration": "1966",
    "allocation": "983",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2949",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5754",
    "nom_corrige2": "Simon Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "1965",
    "allocation": "982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2947",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "5755",
    "nom_corrige2": "Étienne Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "1965",
    "allocation": "982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2947",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "5756",
    "nom_corrige2": "Patrick Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "1965",
    "allocation": "982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2947",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "5757",
    "nom_corrige2": "Ariane Sergerie",
    "nom_famille": "Sergerie",
    "titre_genre2": "Conseillère",
    "remuneration": "1965",
    "allocation": "982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2947",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "5758",
    "nom_corrige2": "Anthony Rousseau",
    "nom_famille": "Rousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "1965",
    "allocation": "982",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2947",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "5759",
    "nom_corrige2": "Robert Karim",
    "nom_famille": "Karim",
    "titre_genre2": "Conseiller",
    "remuneration": "2025",
    "allocation": "920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2945",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "5760",
    "nom_corrige2": "Simon Bois",
    "nom_famille": "Bois",
    "titre_genre2": "Conseiller",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5761",
    "nom_corrige2": "Josée Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseillère",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5762",
    "nom_corrige2": "Luc Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5763",
    "nom_corrige2": "Vicky Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5764",
    "nom_corrige2": "Serge Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseiller",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5765",
    "nom_corrige2": "Michel Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1963",
    "allocation": "981",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2944",
    "ville": "Lac-des-Aigles",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "505"
  },
  {
    "ID": "5766",
    "nom_corrige2": "Lucie Gravel",
    "nom_famille": "Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "1960",
    "allocation": "980",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2940",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5767",
    "nom_corrige2": "Gilles Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "1656",
    "allocation": "828",
    "remuneration2": "300",
    "allocation2": "150",
    "total": "2934",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "5768",
    "nom_corrige2": "François Page",
    "nom_famille": "Page",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "288",
    "allocation2": "144",
    "total": "2932",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5769",
    "nom_corrige2": "Frédéric Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "930",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2930",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "5770",
    "nom_corrige2": "Charles Garon",
    "nom_famille": "Garon",
    "titre_genre2": "Conseiller",
    "remuneration": "2000",
    "allocation": "930",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2930",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "5771",
    "nom_corrige2": "Manon Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "2000",
    "allocation": "930",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2930",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "5772",
    "nom_corrige2": "Claudine Vouligny",
    "nom_famille": "Vouligny",
    "titre_genre2": "Conseillère",
    "remuneration": "2048",
    "allocation": "874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2922",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5773",
    "nom_corrige2": "Pierre Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1944",
    "allocation": "972",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2916",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "5774",
    "nom_corrige2": "ALEXANDRE GEOFFROY",
    "nom_famille": "GEOFFROY",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "45",
    "allocation2": "46",
    "total": "2909",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5775",
    "nom_corrige2": "JEAN-LUC LAPLANTE",
    "nom_famille": "LAPLANTE",
    "titre_genre2": "Conseiller",
    "remuneration": "1939",
    "allocation": "969",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2908",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "5776",
    "nom_corrige2": "Cindy Saint-Jean",
    "nom_famille": "Saint-Jean",
    "titre_genre2": "Conseillère",
    "remuneration": "1304",
    "allocation": "1311",
    "remuneration2": "194",
    "allocation2": "97",
    "total": "2906",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5777",
    "nom_corrige2": "Sylvie Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "1932",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2898",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5778",
    "nom_corrige2": "Monique Scholz",
    "nom_famille": "Scholz",
    "titre_genre2": "Conseillère",
    "remuneration": "1932",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2898",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5779",
    "nom_corrige2": "Chantal Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseillère",
    "remuneration": "1932",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2898",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5780",
    "nom_corrige2": "Maryse Briand",
    "nom_famille": "Briand",
    "titre_genre2": "Conseillère",
    "remuneration": "1932",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2898",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5781",
    "nom_corrige2": "Martin Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "1932",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2898",
    "ville": "Hampden",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "192"
  },
  {
    "ID": "5782",
    "nom_corrige2": "Bernard Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseiller",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5783",
    "nom_corrige2": "Ghislain Privé",
    "nom_famille": "Privé",
    "titre_genre2": "Conseiller",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5784",
    "nom_corrige2": "Bruno St-Germain",
    "nom_famille": "St-Germain",
    "titre_genre2": "Conseiller",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5785",
    "nom_corrige2": "Laurence Frenette",
    "nom_famille": "Frenette",
    "titre_genre2": "Conseillère",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5786",
    "nom_corrige2": "Suzanne Nault",
    "nom_famille": "Nault",
    "titre_genre2": "Conseillère",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5787",
    "nom_corrige2": "Benoît Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "1931",
    "allocation": "966",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2897",
    "ville": "Béthanie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "323"
  },
  {
    "ID": "5788",
    "nom_corrige2": "Pierre Sévégny",
    "nom_famille": "Sévégny",
    "titre_genre2": "Conseiller",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5789",
    "nom_corrige2": "Michel Beauchesne",
    "nom_famille": "Beauchesne",
    "titre_genre2": "Conseiller",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5790",
    "nom_corrige2": "Monique Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseillère",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5791",
    "nom_corrige2": "Yves Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5792",
    "nom_corrige2": "Christian Desrochers",
    "nom_famille": "Desrochers",
    "titre_genre2": "Conseiller",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5793",
    "nom_corrige2": "Donatien Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "1930",
    "allocation": "965",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2895",
    "ville": "Sainte-Marie-de-Blandford",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "448"
  },
  {
    "ID": "5794",
    "nom_corrige2": "Andréanne Rouleau",
    "nom_famille": "Rouleau",
    "titre_genre2": "Conseillère",
    "remuneration": "1925",
    "allocation": "963",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2888",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "5795",
    "nom_corrige2": "Annie Labbé",
    "nom_famille": "Labbé",
    "titre_genre2": "Conseillère",
    "remuneration": "1993",
    "allocation": "889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2882",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "5796",
    "nom_corrige2": "Géraldine Catherine Plante-Desbiens",
    "nom_famille": "Catherine",
    "titre_genre2": "Conseillère",
    "remuneration": "1918",
    "allocation": "959",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2877",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "5797",
    "nom_corrige2": "Joannie Tremblay-Miller",
    "nom_famille": "Tremblay-Miller",
    "titre_genre2": "Conseillère",
    "remuneration": "1453",
    "allocation": "1418",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2871",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "5798",
    "nom_corrige2": "Maurice Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "1981",
    "allocation": "889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2870",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "5799",
    "nom_corrige2": "Michel Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "1987",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2855",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5800",
    "nom_corrige2": "Caroline Sanfaçon",
    "nom_famille": "Sanfaçon",
    "titre_genre2": "Conseillère",
    "remuneration": "1973",
    "allocation": "874",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2847",
    "ville": "La Visitation-de-Yamaska",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "336"
  },
  {
    "ID": "5801",
    "nom_corrige2": "Denis Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "1896",
    "allocation": "948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2844",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "5802",
    "nom_corrige2": "Réjean Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "1896",
    "allocation": "948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2844",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "5803",
    "nom_corrige2": "Huguette Laflamme",
    "nom_famille": "Laflamme",
    "titre_genre2": "Conseillère",
    "remuneration": "1896",
    "allocation": "948",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2844",
    "ville": "La Durantaye",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "829"
  },
  {
    "ID": "5804",
    "nom_corrige2": "Christiane Leblond",
    "nom_famille": "Leblond",
    "titre_genre2": "Conseillère",
    "remuneration": "1894",
    "allocation": "947",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2841",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "5805",
    "nom_corrige2": "Marielle Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "1892",
    "allocation": "946",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2838",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "5806",
    "nom_corrige2": "Sophie Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "1892",
    "allocation": "946",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2838",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "5807",
    "nom_corrige2": "Réjean Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseiller",
    "remuneration": "1892",
    "allocation": "946",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2838",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "5808",
    "nom_corrige2": "Noémi Soulard",
    "nom_famille": "Soulard",
    "titre_genre2": "Conseillère",
    "remuneration": "1892",
    "allocation": "946",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2838",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "5809",
    "nom_corrige2": "Richard Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1882",
    "allocation": "941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2823",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "5810",
    "nom_corrige2": "Maryse Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "1882",
    "allocation": "941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2823",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "5811",
    "nom_corrige2": "Bernard Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1882",
    "allocation": "941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2823",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "5812",
    "nom_corrige2": "Thierry Beloin",
    "nom_famille": "Beloin",
    "titre_genre2": "Conseiller",
    "remuneration": "1882",
    "allocation": "941",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2823",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "5813",
    "nom_corrige2": "ROGER TESSIER",
    "nom_famille": "TESSIER",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2818",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5814",
    "nom_corrige2": "SÉBASTIEN RICHARD",
    "nom_famille": "RICHARD",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2818",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5815",
    "nom_corrige2": "DENIS LAROCHE",
    "nom_famille": "LAROCHE",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2818",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5816",
    "nom_corrige2": "ROBERT PELLETIER",
    "nom_famille": "PELLETIER",
    "titre_genre2": "Conseiller",
    "remuneration": "1879",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2818",
    "ville": "Lefebvre",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "979"
  },
  {
    "ID": "5817",
    "nom_corrige2": "René Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Conseiller",
    "remuneration": "1878",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2817",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "5818",
    "nom_corrige2": "Yves Frappier",
    "nom_famille": "Frappier",
    "titre_genre2": "Conseiller",
    "remuneration": "1878",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2817",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "5819",
    "nom_corrige2": "Charles Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "1878",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2817",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "5820",
    "nom_corrige2": "Armande Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "1878",
    "allocation": "939",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2817",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "5821",
    "nom_corrige2": "Lina Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "1876",
    "allocation": "938",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2814",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5822",
    "nom_corrige2": "Sonia Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "1868",
    "allocation": "934",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2802",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "5823",
    "nom_corrige2": "Diane Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseillère",
    "remuneration": "1868",
    "allocation": "934",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2802",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "5824",
    "nom_corrige2": "Maxime Anctil",
    "nom_famille": "Anctil",
    "titre_genre2": "Conseiller",
    "remuneration": "1868",
    "allocation": "934",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2802",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "5825",
    "nom_corrige2": "Nancy Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "1868",
    "allocation": "934",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2802",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "5826",
    "nom_corrige2": "Guylaine Kenney",
    "nom_famille": "Kenney",
    "titre_genre2": "Conseillère",
    "remuneration": "1868",
    "allocation": "934",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2802",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "5827",
    "nom_corrige2": "Claude Dupont",
    "nom_famille": "Dupont",
    "titre_genre2": "Conseiller",
    "remuneration": "1866",
    "allocation": "933",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2799",
    "ville": "Val-des-Bois",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "917"
  },
  {
    "ID": "5828",
    "nom_corrige2": "Éric Chastenay",
    "nom_famille": "Chastenay",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2784",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5829",
    "nom_corrige2": "Michel Deshaies",
    "nom_famille": "Deshaies",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2784",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5830",
    "nom_corrige2": "Jean-Marie Dionne",
    "nom_famille": "Dionne",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2784",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5831",
    "nom_corrige2": "Sébastien Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2784",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5832",
    "nom_corrige2": "Pierre-Luc Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Conseiller",
    "remuneration": "1883",
    "allocation": "901",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2784",
    "ville": "Sainte-Cécile-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "385"
  },
  {
    "ID": "5833",
    "nom_corrige2": "Gratien Aubé",
    "nom_famille": "Aubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1855",
    "allocation": "928",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2783",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5834",
    "nom_corrige2": "Conrad Guay",
    "nom_famille": "Guay",
    "titre_genre2": "Conseiller",
    "remuneration": "1855",
    "allocation": "928",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2783",
    "ville": "Notre-Dame-des-Monts",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "800"
  },
  {
    "ID": "5835",
    "nom_corrige2": "Virginia Wilson",
    "nom_famille": "Wilson",
    "titre_genre2": "Conseillère",
    "remuneration": "1854",
    "allocation": "927",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2781",
    "ville": "East Farnham",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "622"
  },
  {
    "ID": "5836",
    "nom_corrige2": "Bradley Duke",
    "nom_famille": "Duke",
    "titre_genre2": "Conseiller",
    "remuneration": "1840",
    "allocation": "920",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2760",
    "ville": "Saint-Anicet",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2817"
  },
  {
    "ID": "5837",
    "nom_corrige2": "Julie Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5838",
    "nom_corrige2": "Catherine Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseillère",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5839",
    "nom_corrige2": "Maxime Alexandre",
    "nom_famille": "Alexandre",
    "titre_genre2": "Conseiller",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5840",
    "nom_corrige2": "Francine Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5841",
    "nom_corrige2": "Marie-Ève Michaudville",
    "nom_famille": "Michaudville",
    "titre_genre2": "Conseillère",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5842",
    "nom_corrige2": "Jacinthe Thiboutot",
    "nom_famille": "Thiboutot",
    "titre_genre2": "Conseillère",
    "remuneration": "1837",
    "allocation": "919",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2756",
    "ville": "Saint-Germain-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "297"
  },
  {
    "ID": "5843",
    "nom_corrige2": "Simon Villeneuve",
    "nom_famille": "Villeneuve",
    "titre_genre2": "Conseiller",
    "remuneration": "1832",
    "allocation": "916",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2748",
    "ville": "Saint-Nérée-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "770"
  },
  {
    "ID": "5844",
    "nom_corrige2": "Serge Turcotte",
    "nom_famille": "Turcotte",
    "titre_genre2": "Conseiller",
    "remuneration": "1778",
    "allocation": "964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "5845",
    "nom_corrige2": "Éric Mc Kay",
    "nom_famille": "Mc",
    "titre_genre2": "Conseiller",
    "remuneration": "1778",
    "allocation": "964",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Maricourt",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "432"
  },
  {
    "ID": "5846",
    "nom_corrige2": "Micheline Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5847",
    "nom_corrige2": "Normand St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Conseiller",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5848",
    "nom_corrige2": "Réjean Hudon",
    "nom_famille": "Hudon",
    "titre_genre2": "Conseiller",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5849",
    "nom_corrige2": "Michel Hallé",
    "nom_famille": "Hallé",
    "titre_genre2": "Conseiller",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5850",
    "nom_corrige2": "Franciska Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5851",
    "nom_corrige2": "Hélène Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseillère",
    "remuneration": "1827",
    "allocation": "915",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2742",
    "ville": "Saint-Cléophas",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "333"
  },
  {
    "ID": "5852",
    "nom_corrige2": "Donald Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "1852",
    "allocation": "889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2741",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "5853",
    "nom_corrige2": "Jeannot Alix",
    "nom_famille": "Alix",
    "titre_genre2": "Conseiller",
    "remuneration": "1254",
    "allocation": "627",
    "remuneration2": "576",
    "allocation2": "278",
    "total": "2735",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "5854",
    "nom_corrige2": "Patrick",
    "nom_famille": "Lavallée",
    "titre_genre2": "Lavallée",
    "remuneration": "Conseiller",
    "allocation": "1818",
    "remuneration2": "908",
    "allocation2": "0",
    "total": "0",
    "ville": "2726",
    "arrondissement": "L'Isle-Verte",
    "region_adm": "",
    "population": "Bas-Saint-Laurent"
  },
  {
    "ID": "5855",
    "nom_corrige2": "Josianne Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseillère",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5856",
    "nom_corrige2": "Guy Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5857",
    "nom_corrige2": "Benoit St-Jean",
    "nom_famille": "St-Jean",
    "titre_genre2": "Conseiller",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5858",
    "nom_corrige2": "Alain Parent",
    "nom_famille": "Parent",
    "titre_genre2": "Conseiller",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5859",
    "nom_corrige2": "Ghislaine Chamberland",
    "nom_famille": "Chamberland",
    "titre_genre2": "Conseillère",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5860",
    "nom_corrige2": "Hélène Méthot",
    "nom_famille": "Méthot",
    "titre_genre2": "Conseillère",
    "remuneration": "1816",
    "allocation": "908",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2724",
    "ville": "Saint-André-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "668"
  },
  {
    "ID": "5861",
    "nom_corrige2": "Lise Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "1814",
    "allocation": "907",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2721",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "5862",
    "nom_corrige2": "Josée Prévost",
    "nom_famille": "Prévost",
    "titre_genre2": "Conseillère",
    "remuneration": "1808",
    "allocation": "904",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2712",
    "ville": "Nédélec",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "364"
  },
  {
    "ID": "5863",
    "nom_corrige2": "Léo Cossette",
    "nom_famille": "Cossette",
    "titre_genre2": "Conseiller",
    "remuneration": "1951",
    "allocation": "751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2702",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5864",
    "nom_corrige2": "Bruno Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1800",
    "allocation": "900",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2700",
    "ville": "Authier-Nord",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "302"
  },
  {
    "ID": "5865",
    "nom_corrige2": "Émilie Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "2700",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2700",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "5866",
    "nom_corrige2": "Russel Girard",
    "nom_famille": "Girard",
    "titre_genre2": "Conseiller",
    "remuneration": "2700",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2700",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "5867",
    "nom_corrige2": "Mylène Blackburn",
    "nom_famille": "Blackburn",
    "titre_genre2": "Conseillère",
    "remuneration": "2700",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2700",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "5868",
    "nom_corrige2": "Francis Fillion",
    "nom_famille": "Fillion",
    "titre_genre2": "Conseiller",
    "remuneration": "1785",
    "allocation": "893",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2678",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "5869",
    "nom_corrige2": "Genade Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Maire",
    "remuneration": "1783",
    "allocation": "891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2674",
    "ville": "Saint-Godefroi",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "355"
  },
  {
    "ID": "5870",
    "nom_corrige2": "yvon Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseiller",
    "remuneration": "1781",
    "allocation": "891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2672",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "5871",
    "nom_corrige2": "Maryse Racine",
    "nom_famille": "Racine",
    "titre_genre2": "Conseillère",
    "remuneration": "1781",
    "allocation": "891",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2672",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "5872",
    "nom_corrige2": "Fernand Manseau",
    "nom_famille": "Manseau",
    "titre_genre2": "Conseiller",
    "remuneration": "1784",
    "allocation": "888",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2672",
    "ville": "Saint-Édouard-de-Fabre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "659"
  },
  {
    "ID": "5873",
    "nom_corrige2": "Sylvain Grégoire",
    "nom_famille": "Grégoire",
    "titre_genre2": "Conseiller",
    "remuneration": "1780",
    "allocation": "890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2670",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "5874",
    "nom_corrige2": "Nicholas Paradis-Naud",
    "nom_famille": "Paradis-Naud",
    "titre_genre2": "Conseiller",
    "remuneration": "1780",
    "allocation": "890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2670",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "5875",
    "nom_corrige2": "Pascal Hétu",
    "nom_famille": "Hétu",
    "titre_genre2": "Conseiller",
    "remuneration": "1780",
    "allocation": "890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2670",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "5876",
    "nom_corrige2": "Christiane Vaillancourt",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "1780",
    "allocation": "890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2670",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "5877",
    "nom_corrige2": "Gilles Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "1780",
    "allocation": "890",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2670",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "5878",
    "nom_corrige2": "Claude Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseiller",
    "remuneration": "1674",
    "allocation": "837",
    "remuneration2": "157",
    "allocation2": "0",
    "total": "2668",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "5879",
    "nom_corrige2": "Marlène Maranda",
    "nom_famille": "Maranda",
    "titre_genre2": "Conseillère",
    "remuneration": "1778",
    "allocation": "889",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2667",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "5880",
    "nom_corrige2": "Yves Laroche",
    "nom_famille": "Laroche",
    "titre_genre2": "Conseiller",
    "remuneration": "1841",
    "allocation": "790",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2631",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "5881",
    "nom_corrige2": "Linda Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseillère",
    "remuneration": "1920",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2630",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5882",
    "nom_corrige2": "France Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseillère",
    "remuneration": "1920",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2630",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5883",
    "nom_corrige2": "Michel Desjardins",
    "nom_famille": "Desjardins",
    "titre_genre2": "Conseiller",
    "remuneration": "1920",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2630",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5884",
    "nom_corrige2": "Éric Langlois",
    "nom_famille": "Langlois",
    "titre_genre2": "Conseiller",
    "remuneration": "1920",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2630",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5885",
    "nom_corrige2": "Katy Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseillère",
    "remuneration": "1920",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2630",
    "ville": "Sainte-Apolline-de-Patton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "535"
  },
  {
    "ID": "5886",
    "nom_corrige2": "Gilberte Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5887",
    "nom_corrige2": "Géraldine Chrétien",
    "nom_famille": "Chrétien",
    "titre_genre2": "Conseillère",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5888",
    "nom_corrige2": "Denise Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseillère",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5889",
    "nom_corrige2": "Valérie Potvin",
    "nom_famille": "Potvin",
    "titre_genre2": "Conseillère",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5890",
    "nom_corrige2": "Jacques Joncas",
    "nom_famille": "Joncas",
    "titre_genre2": "Conseiller",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5891",
    "nom_corrige2": "Jennyfer Ruel",
    "nom_famille": "Ruel",
    "titre_genre2": "Conseillère",
    "remuneration": "1745",
    "allocation": "873",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2618",
    "ville": "Albertville",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "227"
  },
  {
    "ID": "5892",
    "nom_corrige2": "Réjeanne Raymond-Roussel",
    "nom_famille": "Raymond-Roussel",
    "titre_genre2": "Conseillère",
    "remuneration": "1304",
    "allocation": "1311",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2615",
    "ville": "Mont-Carmel",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1146"
  },
  {
    "ID": "5893",
    "nom_corrige2": "Marc Champagne",
    "nom_famille": "Champagne",
    "titre_genre2": "Conseiller",
    "remuneration": "1741",
    "allocation": "870",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2611",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "5894",
    "nom_corrige2": "Marc Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "1737",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2605",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5895",
    "nom_corrige2": "Yannick Pressé",
    "nom_famille": "Pressé",
    "titre_genre2": "Conseiller",
    "remuneration": "1737",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2605",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5896",
    "nom_corrige2": "Éric Guillot",
    "nom_famille": "Guillot",
    "titre_genre2": "Conseiller",
    "remuneration": "1737",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2605",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5897",
    "nom_corrige2": "James Kingston",
    "nom_famille": "Kingston",
    "titre_genre2": "Conseiller",
    "remuneration": "1737",
    "allocation": "868",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2605",
    "ville": "Fortierville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "643"
  },
  {
    "ID": "5898",
    "nom_corrige2": "Annie Levasseur",
    "nom_famille": "Levasseur",
    "titre_genre2": "Conseillère",
    "remuneration": "1732",
    "allocation": "866",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2598",
    "ville": "Sainte-Hélène-de-Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "891"
  },
  {
    "ID": "5899",
    "nom_corrige2": "Richard Bizier",
    "nom_famille": "Bizier",
    "titre_genre2": "Conseiller",
    "remuneration": "1331",
    "allocation": "666",
    "remuneration2": "400",
    "allocation2": "200",
    "total": "2597",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "5900",
    "nom_corrige2": "Adrien Paradis",
    "nom_famille": "Paradis",
    "titre_genre2": "Conseiller",
    "remuneration": "1727",
    "allocation": "865",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2592",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5901",
    "nom_corrige2": "Jérôme  Petit",
    "nom_famille": "Petit",
    "titre_genre2": "Conseiller",
    "remuneration": "1719",
    "allocation": "860",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2579",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "5902",
    "nom_corrige2": "Manon Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseillère",
    "remuneration": "1718",
    "allocation": "859",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2577",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "5903",
    "nom_corrige2": "MARIE VAILLANCOURT LAPORTE",
    "nom_famille": "VAILLANCOURT",
    "titre_genre2": "Conseillère",
    "remuneration": "1714",
    "allocation": "857",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2571",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "5904",
    "nom_corrige2": "Roch Gohier",
    "nom_famille": "Gohier",
    "titre_genre2": "Conseiller",
    "remuneration": "1709",
    "allocation": "855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2564",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "5905",
    "nom_corrige2": "Tammy Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseillère",
    "remuneration": "1709",
    "allocation": "855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2564",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "5906",
    "nom_corrige2": "Edgard Boilard",
    "nom_famille": "Boilard",
    "titre_genre2": "Conseiller",
    "remuneration": "1709",
    "allocation": "855",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2564",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "5907",
    "nom_corrige2": "Joël Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "1801",
    "allocation": "751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2552",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5908",
    "nom_corrige2": "Fanny Goulet",
    "nom_famille": "Goulet",
    "titre_genre2": "Conseillère",
    "remuneration": "1699",
    "allocation": "850",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2549",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "5909",
    "nom_corrige2": "JEAN-FRANÇOIS VEILLEUX",
    "nom_famille": "VEILLEUX",
    "titre_genre2": "Conseiller",
    "remuneration": "1564",
    "allocation": "782",
    "remuneration2": "200",
    "allocation2": "0",
    "total": "2546",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "5910",
    "nom_corrige2": "STEFANO GIANOLI",
    "nom_famille": "GIANOLI",
    "titre_genre2": "Conseiller",
    "remuneration": "1564",
    "allocation": "782",
    "remuneration2": "200",
    "allocation2": "0",
    "total": "2546",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "5911",
    "nom_corrige2": "ROBERT CHAREST",
    "nom_famille": "CHAREST",
    "titre_genre2": "Conseiller",
    "remuneration": "1694",
    "allocation": "847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2541",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "5912",
    "nom_corrige2": "MONIQUE BLANCHETTE",
    "nom_famille": "BLANCHETTE",
    "titre_genre2": "Conseillère",
    "remuneration": "1694",
    "allocation": "847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2541",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "5913",
    "nom_corrige2": "CATHY SANTERRE",
    "nom_famille": "SANTERRE",
    "titre_genre2": "Conseillère",
    "remuneration": "1694",
    "allocation": "847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2541",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "5914",
    "nom_corrige2": "JEAN-PIERRE BEAUPRÉ",
    "nom_famille": "BEAUPRÉ",
    "titre_genre2": "Conseiller",
    "remuneration": "1694",
    "allocation": "847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2541",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "5915",
    "nom_corrige2": "GUY PLOURDE",
    "nom_famille": "PLOURDE",
    "titre_genre2": "Conseiller",
    "remuneration": "1691",
    "allocation": "847",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2538",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "5916",
    "nom_corrige2": "Marc Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseiller",
    "remuneration": "1682",
    "allocation": "841",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2523",
    "ville": "Plessisville",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "2707"
  },
  {
    "ID": "5917",
    "nom_corrige2": "Denis Sansoucy",
    "nom_famille": "Sansoucy",
    "titre_genre2": "Conseiller",
    "remuneration": "1674",
    "allocation": "837",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2511",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "5918",
    "nom_corrige2": "Germain Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseiller",
    "remuneration": "1671",
    "allocation": "836",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2507",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "5919",
    "nom_corrige2": "Thérèse Bouley",
    "nom_famille": "Bouley",
    "titre_genre2": "Conseillère",
    "remuneration": "1751",
    "allocation": "751",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2502",
    "ville": "Moffet",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "204"
  },
  {
    "ID": "5920",
    "nom_corrige2": "Saul Bergeron",
    "nom_famille": "Bergeron",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5921",
    "nom_corrige2": "René St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5922",
    "nom_corrige2": "Line Pellerin",
    "nom_famille": "Pellerin",
    "titre_genre2": "Conseillère",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5923",
    "nom_corrige2": "Liliane St-Hilaire",
    "nom_famille": "St-Hilaire",
    "titre_genre2": "Conseillère",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5924",
    "nom_corrige2": "Benoit Lussier",
    "nom_famille": "Lussier",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "Aston-Jonction",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "441"
  },
  {
    "ID": "5925",
    "nom_corrige2": "Luc St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "5926",
    "nom_corrige2": "Louis Baribeau",
    "nom_famille": "Baribeau",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "5927",
    "nom_corrige2": "Patrick Cyr",
    "nom_famille": "Cyr",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "5928",
    "nom_corrige2": "Pascal Bellefeuille",
    "nom_famille": "Bellefeuille",
    "titre_genre2": "Conseiller",
    "remuneration": "1667",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2500",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "5929",
    "nom_corrige2": "Angèle Auger",
    "nom_famille": "Auger",
    "titre_genre2": "Conseillère",
    "remuneration": "1666",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2499",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5930",
    "nom_corrige2": "Ghislain Desaulniers",
    "nom_famille": "Desaulniers",
    "titre_genre2": "Conseiller",
    "remuneration": "1666",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2499",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5931",
    "nom_corrige2": "Cindy Demers",
    "nom_famille": "Demers",
    "titre_genre2": "Conseillère",
    "remuneration": "1666",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2499",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5932",
    "nom_corrige2": "François Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseiller",
    "remuneration": "1666",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2499",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5933",
    "nom_corrige2": "Nathalie Gaudette",
    "nom_famille": "Gaudette",
    "titre_genre2": "Conseillère",
    "remuneration": "1666",
    "allocation": "833",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2499",
    "ville": "Authier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "260"
  },
  {
    "ID": "5934",
    "nom_corrige2": "ROCK ARPIN",
    "nom_famille": "ARPIN",
    "titre_genre2": "Conseiller",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Béarn",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "715"
  },
  {
    "ID": "5935",
    "nom_corrige2": "Cathy Fontaine",
    "nom_famille": "Fontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5936",
    "nom_corrige2": "Bertrand Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5937",
    "nom_corrige2": "Marie-Josée Hudon",
    "nom_famille": "Hudon",
    "titre_genre2": "Conseillère",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5938",
    "nom_corrige2": "Dan Drapeau",
    "nom_famille": "Drapeau",
    "titre_genre2": "Conseiller",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5939",
    "nom_corrige2": "Patrick Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5940",
    "nom_corrige2": "François Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseiller",
    "remuneration": "1664",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2496",
    "ville": "Saint-Onésime-d'Ixworth",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "552"
  },
  {
    "ID": "5941",
    "nom_corrige2": "Robert Tailleur",
    "nom_famille": "Tailleur",
    "titre_genre2": "Conseiller",
    "remuneration": "1663",
    "allocation": "832",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2495",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "5942",
    "nom_corrige2": "René Laterreur",
    "nom_famille": "Laterreur",
    "titre_genre2": "Conseiller",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5943",
    "nom_corrige2": "Gaston Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseiller",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5944",
    "nom_corrige2": "Éric Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5945",
    "nom_corrige2": "Nathalie Beaumont",
    "nom_famille": "Beaumont",
    "titre_genre2": "Conseillère",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5946",
    "nom_corrige2": "Claudette Blanchet",
    "nom_famille": "Blanchet",
    "titre_genre2": "Conseillère",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5947",
    "nom_corrige2": "Diane Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseillère",
    "remuneration": "1663",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2494",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "5948",
    "nom_corrige2": "Serge Boulet",
    "nom_famille": "Boulet",
    "titre_genre2": "Conseiller",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5949",
    "nom_corrige2": "Chantal St-Laurent",
    "nom_famille": "St-Laurent",
    "titre_genre2": "Conseillère",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5950",
    "nom_corrige2": "Maxim Boutot",
    "nom_famille": "Boutot",
    "titre_genre2": "Conseiller",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5951",
    "nom_corrige2": "Claude Gallant",
    "nom_famille": "Gallant",
    "titre_genre2": "Conseiller",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5952",
    "nom_corrige2": "Lyne Arpin",
    "nom_famille": "Arpin",
    "titre_genre2": "Conseillère",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5953",
    "nom_corrige2": "Richard Dupuis",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "1662",
    "allocation": "831",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2493",
    "ville": "Saint-Jean-de-la-Lande",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "256"
  },
  {
    "ID": "5954",
    "nom_corrige2": "Onil Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "1660",
    "allocation": "830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2490",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "5955",
    "nom_corrige2": "Yvon Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "1660",
    "allocation": "830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2490",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "5956",
    "nom_corrige2": "Joey Gaudet",
    "nom_famille": "Gaudet",
    "titre_genre2": "Conseiller",
    "remuneration": "1660",
    "allocation": "830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2490",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "5957",
    "nom_corrige2": "Anik Longpré",
    "nom_famille": "Longpré",
    "titre_genre2": "Conseillère",
    "remuneration": "1660",
    "allocation": "830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2490",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "5958",
    "nom_corrige2": "Jessica Aumond Beaupré",
    "nom_famille": "Aumond",
    "titre_genre2": "Conseillère",
    "remuneration": "1660",
    "allocation": "830",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2490",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "5959",
    "nom_corrige2": "Francine Bigras",
    "nom_famille": "Bigras",
    "titre_genre2": "Conseillère",
    "remuneration": "1658",
    "allocation": "829",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2487",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "5960",
    "nom_corrige2": "Sylvie Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "1658",
    "allocation": "829",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2487",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "5961",
    "nom_corrige2": "Brigitte Martin",
    "nom_famille": "Martin",
    "titre_genre2": "Conseillère",
    "remuneration": "1658",
    "allocation": "829",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2487",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "5962",
    "nom_corrige2": "Pierre Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseiller",
    "remuneration": "1658",
    "allocation": "829",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2487",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "5963",
    "nom_corrige2": "Michael Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseiller",
    "remuneration": "1656",
    "allocation": "828",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2484",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "5964",
    "nom_corrige2": "Réjeanne Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "1656",
    "allocation": "828",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2484",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "5965",
    "nom_corrige2": "Mathieu Jeanson",
    "nom_famille": "Jeanson",
    "titre_genre2": "Conseiller",
    "remuneration": "1656",
    "allocation": "828",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2484",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "5966",
    "nom_corrige2": "MYRIAM NORMANDIN",
    "nom_famille": "NORMANDIN",
    "titre_genre2": "Conseillère",
    "remuneration": "1564",
    "allocation": "782",
    "remuneration2": "45",
    "allocation2": "61",
    "total": "2452",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "5967",
    "nom_corrige2": "Olivier Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "5968",
    "nom_corrige2": "Pierre Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5969",
    "nom_corrige2": "Stéphane Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseiller",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5970",
    "nom_corrige2": "Sony Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5971",
    "nom_corrige2": "Marie-Rose Plourde",
    "nom_famille": "Plourde",
    "titre_genre2": "Conseillère",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5972",
    "nom_corrige2": "Bernard Tardif",
    "nom_famille": "Tardif",
    "titre_genre2": "Conseiller",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5973",
    "nom_corrige2": "Renée Soucy",
    "nom_famille": "Soucy",
    "titre_genre2": "Conseillère",
    "remuneration": "1630",
    "allocation": "815",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2445",
    "ville": "Saint-François-Xavier-de-Viger",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "247"
  },
  {
    "ID": "5974",
    "nom_corrige2": "Viky Goyette",
    "nom_famille": "Goyette",
    "titre_genre2": "Conseillère",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5975",
    "nom_corrige2": "Stéphanie Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseillère",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5976",
    "nom_corrige2": "Bruno Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseiller",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5977",
    "nom_corrige2": "Cathy Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5978",
    "nom_corrige2": "Robert Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseiller",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5979",
    "nom_corrige2": "Michael Dupuis Souligny",
    "nom_famille": "Dupuis",
    "titre_genre2": "Conseiller",
    "remuneration": "1551",
    "allocation": "892",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2443",
    "ville": "Clermont",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "499"
  },
  {
    "ID": "5980",
    "nom_corrige2": "Lily Paquette",
    "nom_famille": "Paquette",
    "titre_genre2": "Conseillère",
    "remuneration": "2439",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2439",
    "ville": "Hébertville-Station",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "1366"
  },
  {
    "ID": "5981",
    "nom_corrige2": "Nataly Ruel",
    "nom_famille": "Ruel",
    "titre_genre2": "Conseillère",
    "remuneration": "1625",
    "allocation": "812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2437",
    "ville": "Ragueneau",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1335"
  },
  {
    "ID": "5982",
    "nom_corrige2": "Nancy Clark",
    "nom_famille": "Clark",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5983",
    "nom_corrige2": "Katrina Keating",
    "nom_famille": "Keating",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5984",
    "nom_corrige2": "Johanne Clark",
    "nom_famille": "Clark",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5985",
    "nom_corrige2": "Kathy Burke",
    "nom_famille": "Burke",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5986",
    "nom_corrige2": "Marlene Boudreau",
    "nom_famille": "Boudreau",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5987",
    "nom_corrige2": "Miranda Matthews",
    "nom_famille": "Matthews",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "809",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2415",
    "ville": "Grosse-Île",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "478"
  },
  {
    "ID": "5988",
    "nom_corrige2": "Annie Dussault",
    "nom_famille": "Dussault",
    "titre_genre2": "Conseillère",
    "remuneration": "1606",
    "allocation": "803",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2409",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "5989",
    "nom_corrige2": "Christian Chaumont",
    "nom_famille": "Chaumont",
    "titre_genre2": "Conseiller",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5990",
    "nom_corrige2": "Marie-Claude Saucier",
    "nom_famille": "Saucier",
    "titre_genre2": "Conseillère",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5991",
    "nom_corrige2": "Gabrielle Trigaux",
    "nom_famille": "Trigaux",
    "titre_genre2": "Conseillère",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5992",
    "nom_corrige2": "Nicole Marcheterre",
    "nom_famille": "Marcheterre",
    "titre_genre2": "Conseillère",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5993",
    "nom_corrige2": "Denis Forest",
    "nom_famille": "Forest",
    "titre_genre2": "Conseiller",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5994",
    "nom_corrige2": "Kate Johannie Murray St-Pierre",
    "nom_famille": "Murray",
    "titre_genre2": "Conseillère",
    "remuneration": "1602",
    "allocation": "801",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2403",
    "ville": "Baie-des-Sables",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "622"
  },
  {
    "ID": "5995",
    "nom_corrige2": "Jean-Louis Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Conseiller",
    "remuneration": "1595",
    "allocation": "798",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2393",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "5996",
    "nom_corrige2": "Martine Frenette",
    "nom_famille": "Frenette",
    "titre_genre2": "Conseillère",
    "remuneration": "1595",
    "allocation": "798",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2393",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "5997",
    "nom_corrige2": "Martin Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "1595",
    "allocation": "798",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2393",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "5998",
    "nom_corrige2": "Mélanie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "1576",
    "allocation": "812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2388",
    "ville": "Saint-Joseph-des-Érables",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "423"
  },
  {
    "ID": "5999",
    "nom_corrige2": "Christian Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1576",
    "allocation": "812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2388",
    "ville": "Saint-Joseph-des-Érables",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "423"
  },
  {
    "ID": "6000",
    "nom_corrige2": "Joanie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "1576",
    "allocation": "812",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2388",
    "ville": "Saint-Joseph-des-Érables",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "423"
  },
  {
    "ID": "6001",
    "nom_corrige2": "Jennifer Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseillère",
    "remuneration": "1581",
    "allocation": "791",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2372",
    "ville": "Saint-Elzéar",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "465"
  },
  {
    "ID": "6002",
    "nom_corrige2": "GUY GENDRON",
    "nom_famille": "GENDRON",
    "titre_genre2": "Conseiller",
    "remuneration": "1690",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2372",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6003",
    "nom_corrige2": "GAÉTAN LANDRY",
    "nom_famille": "LANDRY",
    "titre_genre2": "Conseiller",
    "remuneration": "1690",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2372",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6004",
    "nom_corrige2": "Nathalie Deladurantaye",
    "nom_famille": "Deladurantaye",
    "titre_genre2": "Conseillère",
    "remuneration": "1578",
    "allocation": "789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2367",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6005",
    "nom_corrige2": "Michel Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "1578",
    "allocation": "789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2367",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6006",
    "nom_corrige2": "Jules Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "1578",
    "allocation": "789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2367",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6007",
    "nom_corrige2": "Gérald Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseiller",
    "remuneration": "1578",
    "allocation": "789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2367",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6008",
    "nom_corrige2": "Jenny Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "1578",
    "allocation": "789",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2367",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "6009",
    "nom_corrige2": "Karole Thibault",
    "nom_famille": "Thibault",
    "titre_genre2": "Conseillère",
    "remuneration": "1576",
    "allocation": "788",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2364",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "6010",
    "nom_corrige2": "Denis Patry",
    "nom_famille": "Patry",
    "titre_genre2": "Conseiller",
    "remuneration": "1576",
    "allocation": "788",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2364",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "6011",
    "nom_corrige2": "Benoît PAQUETTE",
    "nom_famille": "PAQUETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "1564",
    "allocation": "785",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2349",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "6012",
    "nom_corrige2": "HUGUES GENDRON",
    "nom_famille": "GENDRON",
    "titre_genre2": "Conseiller",
    "remuneration": "1665",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2347",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6013",
    "nom_corrige2": "JOHANNE GAGNÉ",
    "nom_famille": "GAGNÉ",
    "titre_genre2": "Conseillère",
    "remuneration": "1665",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2347",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6014",
    "nom_corrige2": "STÉPHANE VINCELETTE",
    "nom_famille": "VINCELETTE",
    "titre_genre2": "Conseiller",
    "remuneration": "1564",
    "allocation": "782",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2346",
    "ville": "Saint-Elphège",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "275"
  },
  {
    "ID": "6015",
    "nom_corrige2": "Michel Allard",
    "nom_famille": "Allard",
    "titre_genre2": "Conseiller",
    "remuneration": "1560",
    "allocation": "780",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2340",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6016",
    "nom_corrige2": "Marie-Josée Bibeau",
    "nom_famille": "Bibeau",
    "titre_genre2": "Conseillère",
    "remuneration": "1560",
    "allocation": "780",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2340",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6017",
    "nom_corrige2": "Gilles Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "1560",
    "allocation": "780",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2340",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6018",
    "nom_corrige2": "Bernard Coutu",
    "nom_famille": "Coutu",
    "titre_genre2": "Conseiller",
    "remuneration": "1560",
    "allocation": "780",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2340",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6019",
    "nom_corrige2": "Line Rondeau",
    "nom_famille": "Rondeau",
    "titre_genre2": "Conseillère",
    "remuneration": "1560",
    "allocation": "780",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2340",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6020",
    "nom_corrige2": "Gilles Larivière",
    "nom_famille": "Larivière",
    "titre_genre2": "Conseiller",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2334",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "6021",
    "nom_corrige2": "Katy Campeau",
    "nom_famille": "Campeau",
    "titre_genre2": "Conseillère",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2334",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "6022",
    "nom_corrige2": "François Bégin",
    "nom_famille": "Bégin",
    "titre_genre2": "Conseiller",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2334",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "6023",
    "nom_corrige2": "Jean-Yves Busque",
    "nom_famille": "Busque",
    "titre_genre2": "Conseiller",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2334",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "6024",
    "nom_corrige2": "Chantal Poulin",
    "nom_famille": "Poulin",
    "titre_genre2": "Conseillère",
    "remuneration": "1556",
    "allocation": "778",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2334",
    "ville": "Saint-Simon-les-Mines",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "619"
  },
  {
    "ID": "6025",
    "nom_corrige2": "GENEVIÈVE VERREAULT",
    "nom_famille": "VERREAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "1553",
    "allocation": "776",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2329",
    "ville": "Saint-Vianney",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "445"
  },
  {
    "ID": "6026",
    "nom_corrige2": "France Loignon",
    "nom_famille": "Loignon",
    "titre_genre2": "Conseillère",
    "remuneration": "1531",
    "allocation": "796",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2327",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6027",
    "nom_corrige2": "Steeve Raby",
    "nom_famille": "Raby",
    "titre_genre2": "Conseiller",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2323",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "6028",
    "nom_corrige2": "Denis Laprise",
    "nom_famille": "Laprise",
    "titre_genre2": "Conseiller",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2323",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "6029",
    "nom_corrige2": "Madeleine Vermette",
    "nom_famille": "Vermette",
    "titre_genre2": "Conseillère",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2323",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "6030",
    "nom_corrige2": "Lydiane Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseillère",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2323",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "6031",
    "nom_corrige2": "Éric Talbot",
    "nom_famille": "Talbot",
    "titre_genre2": "Conseiller",
    "remuneration": "1549",
    "allocation": "774",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2323",
    "ville": "Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "345"
  },
  {
    "ID": "6032",
    "nom_corrige2": "Hélène Larose",
    "nom_famille": "Larose",
    "titre_genre2": "Conseillère",
    "remuneration": "1546",
    "allocation": "773",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2319",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6033",
    "nom_corrige2": "Jocelyn Marleau",
    "nom_famille": "Marleau",
    "titre_genre2": "Conseiller",
    "remuneration": "1546",
    "allocation": "773",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2319",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6034",
    "nom_corrige2": "Michaël Darveau",
    "nom_famille": "Darveau",
    "titre_genre2": "Conseiller",
    "remuneration": "1546",
    "allocation": "773",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2319",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6035",
    "nom_corrige2": "Joël Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "1546",
    "allocation": "773",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2319",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6036",
    "nom_corrige2": "André St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "1674",
    "allocation": "637",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2311",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "6037",
    "nom_corrige2": "Louis-David Coutu",
    "nom_famille": "Coutu",
    "titre_genre2": "Conseiller",
    "remuneration": "1537",
    "allocation": "769",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2306",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "6038",
    "nom_corrige2": "Claude Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "1250",
    "allocation": "625",
    "remuneration2": "285",
    "allocation2": "143",
    "total": "2303",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "6039",
    "nom_corrige2": "Jean Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseiller",
    "remuneration": "1299",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2299",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6040",
    "nom_corrige2": "Michael Deblois",
    "nom_famille": "Deblois",
    "titre_genre2": "Conseiller",
    "remuneration": "1529",
    "allocation": "764",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2293",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "6041",
    "nom_corrige2": "Pierre Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseiller",
    "remuneration": "1528",
    "allocation": "764",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2292",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "6042",
    "nom_corrige2": "Claude Lafond",
    "nom_famille": "Lafond",
    "titre_genre2": "Conseiller",
    "remuneration": "1524",
    "allocation": "761",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2285",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "6043",
    "nom_corrige2": "Serge Blais",
    "nom_famille": "Blais",
    "titre_genre2": "Conseiller",
    "remuneration": "1520",
    "allocation": "760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2280",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "6044",
    "nom_corrige2": "Sarto Pelletier",
    "nom_famille": "Pelletier",
    "titre_genre2": "Conseiller",
    "remuneration": "1520",
    "allocation": "760",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2280",
    "ville": "Lac-Frontière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "190"
  },
  {
    "ID": "6045",
    "nom_corrige2": "MARIE-PIER LEBLANC",
    "nom_famille": "LEBLANC",
    "titre_genre2": "Conseillère",
    "remuneration": "1590",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2272",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6046",
    "nom_corrige2": "Carole Viel",
    "nom_famille": "Viel",
    "titre_genre2": "Conseillère",
    "remuneration": "1506",
    "allocation": "753",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2259",
    "ville": "Lejeune",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "254"
  },
  {
    "ID": "6047",
    "nom_corrige2": "Pierre Pépin",
    "nom_famille": "Pépin",
    "titre_genre2": "Conseiller",
    "remuneration": "1504",
    "allocation": "752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2256",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "6048",
    "nom_corrige2": "René Belhumeur",
    "nom_famille": "Belhumeur",
    "titre_genre2": "Conseiller",
    "remuneration": "1504",
    "allocation": "752",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2256",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "6049",
    "nom_corrige2": "Johanne Vaillancourt Beaudoin",
    "nom_famille": "Vaillancourt",
    "titre_genre2": "Conseillère",
    "remuneration": "2000",
    "allocation": "1000",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "3000",
    "ville": "Blanc-Sablon",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1102"
  },
  {
    "ID": "6050",
    "nom_corrige2": "Réjean Gouin",
    "nom_famille": "Gouin",
    "titre_genre2": "Conseiller",
    "remuneration": "1500",
    "allocation": "750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2250",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "6051",
    "nom_corrige2": "Serge Turmel",
    "nom_famille": "Turmel",
    "titre_genre2": "Conseiller",
    "remuneration": "1500",
    "allocation": "750",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2250",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "6052",
    "nom_corrige2": "Roch Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseiller",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6053",
    "nom_corrige2": "Louis-Jérôme Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseiller",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6054",
    "nom_corrige2": "Adam Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6055",
    "nom_corrige2": "Linda Giroux",
    "nom_famille": "Giroux",
    "titre_genre2": "Conseillère",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6056",
    "nom_corrige2": "Anne Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseillère",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6057",
    "nom_corrige2": "Denis LEVESQUE",
    "nom_famille": "LEVESQUE",
    "titre_genre2": "Conseiller",
    "remuneration": "1497",
    "allocation": "749",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2246",
    "ville": "Lac-Poulin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "149"
  },
  {
    "ID": "6058",
    "nom_corrige2": "Réal Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6059",
    "nom_corrige2": "Gilbert Leclerc",
    "nom_famille": "Leclerc",
    "titre_genre2": "Conseiller",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6060",
    "nom_corrige2": "Marcel Pilote",
    "nom_famille": "Pilote",
    "titre_genre2": "Conseiller",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6061",
    "nom_corrige2": "Cécile St-Amand",
    "nom_famille": "St-Amand",
    "titre_genre2": "Conseillère",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6062",
    "nom_corrige2": "François Pilote",
    "nom_famille": "Pilote",
    "titre_genre2": "Conseiller",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6063",
    "nom_corrige2": "Rachid Aniss",
    "nom_famille": "Aniss",
    "titre_genre2": "Conseiller",
    "remuneration": "1496",
    "allocation": "748",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2244",
    "ville": "Saint-Alexandre-des-Lacs",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "281"
  },
  {
    "ID": "6064",
    "nom_corrige2": "Gérard Fecteau",
    "nom_famille": "Fecteau",
    "titre_genre2": "Conseiller",
    "remuneration": "1494",
    "allocation": "747",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2241",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "6065",
    "nom_corrige2": "René Drouin",
    "nom_famille": "Drouin",
    "titre_genre2": "Conseiller",
    "remuneration": "1418",
    "allocation": "819",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2237",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6066",
    "nom_corrige2": "Christian Drapeau",
    "nom_famille": "Drapeau",
    "titre_genre2": "Conseiller",
    "remuneration": "1489",
    "allocation": "745",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2234",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "6067",
    "nom_corrige2": "David Veilleux",
    "nom_famille": "Veilleux",
    "titre_genre2": "Conseiller",
    "remuneration": "9512",
    "allocation": "4756",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "14268",
    "ville": "Beauceville",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "6321"
  },
  {
    "ID": "6068",
    "nom_corrige2": "Marcel Tringle",
    "nom_famille": "Tringle",
    "titre_genre2": "Conseiller",
    "remuneration": "1477",
    "allocation": "739",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2216",
    "ville": "Saint-Athanase",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "318"
  },
  {
    "ID": "6069",
    "nom_corrige2": "Yvan Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1472",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2208",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "6070",
    "nom_corrige2": "Adrien Francoeur",
    "nom_famille": "Francoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "1471",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2207",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6071",
    "nom_corrige2": "Henry Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "1471",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2207",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6072",
    "nom_corrige2": "Jean Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Conseiller",
    "remuneration": "1471",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2207",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6073",
    "nom_corrige2": "Chantal Corriveau",
    "nom_famille": "Corriveau",
    "titre_genre2": "Conseillère",
    "remuneration": "1471",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2207",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6074",
    "nom_corrige2": "Jean-Raymond Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "1471",
    "allocation": "736",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2207",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6075",
    "nom_corrige2": "François Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseiller",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6076",
    "nom_corrige2": "Luc Gignac",
    "nom_famille": "Gignac",
    "titre_genre2": "Conseiller",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6077",
    "nom_corrige2": "Huguette Chalifour",
    "nom_famille": "Chalifour",
    "titre_genre2": "Conseillère",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6078",
    "nom_corrige2": "Raymond Groleau",
    "nom_famille": "Groleau",
    "titre_genre2": "Conseiller",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6079",
    "nom_corrige2": "David Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6080",
    "nom_corrige2": "Caroline Gignac",
    "nom_famille": "Gignac",
    "titre_genre2": "Conseillère",
    "remuneration": "1469",
    "allocation": "734",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2203",
    "ville": "Saint-Gilbert",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "292"
  },
  {
    "ID": "6081",
    "nom_corrige2": "Jean-Paul Landry",
    "nom_famille": "Landry",
    "titre_genre2": "Conseiller",
    "remuneration": "1465",
    "allocation": "733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2198",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "6082",
    "nom_corrige2": "Patrick Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseiller",
    "remuneration": "1465",
    "allocation": "733",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2198",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "6083",
    "nom_corrige2": "Manon Thivierge",
    "nom_famille": "Thivierge",
    "titre_genre2": "Conseillère",
    "remuneration": "1463",
    "allocation": "732",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2195",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "6084",
    "nom_corrige2": "Keven Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseiller",
    "remuneration": "1458",
    "allocation": "729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2187",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "6085",
    "nom_corrige2": "Marie Mercier",
    "nom_famille": "Mercier",
    "titre_genre2": "Conseillère",
    "remuneration": "1458",
    "allocation": "729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2187",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "6086",
    "nom_corrige2": "Marie-Soleil Beauregard",
    "nom_famille": "Beauregard",
    "titre_genre2": "Conseillère",
    "remuneration": "1457",
    "allocation": "729",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2186",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "6087",
    "nom_corrige2": "Nathalie Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseillère",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6088",
    "nom_corrige2": "André Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6089",
    "nom_corrige2": "Julie Paquin",
    "nom_famille": "Paquin",
    "titre_genre2": "Conseiller",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6090",
    "nom_corrige2": "Cécile Pichette",
    "nom_famille": "Pichette",
    "titre_genre2": "Conseillère",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6091",
    "nom_corrige2": "Diane Lefebvre",
    "nom_famille": "Lefebvre",
    "titre_genre2": "Conseillère",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6092",
    "nom_corrige2": "Pierrette Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "1455",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2182",
    "ville": "Belleterre",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "304"
  },
  {
    "ID": "6093",
    "nom_corrige2": "Kathleen Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "1453",
    "allocation": "727",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2180",
    "ville": "Otter Lake",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "968"
  },
  {
    "ID": "6094",
    "nom_corrige2": "François Grondin",
    "nom_famille": "Grondin",
    "titre_genre2": "Conseiller",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6095",
    "nom_corrige2": "Marcel Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6096",
    "nom_corrige2": "Patrice Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6097",
    "nom_corrige2": "Linda Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6098",
    "nom_corrige2": "Katy Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseillère",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6099",
    "nom_corrige2": "Gino Vachon",
    "nom_famille": "Vachon",
    "titre_genre2": "Conseiller",
    "remuneration": "1449",
    "allocation": "725",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2174",
    "ville": "Saint-Jules",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "530"
  },
  {
    "ID": "6100",
    "nom_corrige2": "Jonathan Bérard",
    "nom_famille": "Bérard",
    "titre_genre2": "Conseiller",
    "remuneration": "1448",
    "allocation": "724",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2172",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "6101",
    "nom_corrige2": "Jacques Caron",
    "nom_famille": "Caron",
    "titre_genre2": "Conseiller",
    "remuneration": "1446",
    "allocation": "723",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2169",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6102",
    "nom_corrige2": "Caroline Pelchat",
    "nom_famille": "Pelchat",
    "titre_genre2": "Conseillère",
    "remuneration": "1446",
    "allocation": "723",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2169",
    "ville": "Notre-Dame-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "411"
  },
  {
    "ID": "6103",
    "nom_corrige2": "Yves Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1440",
    "allocation": "720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2160",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "6104",
    "nom_corrige2": "Marilyne Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "1121",
    "allocation": "607",
    "remuneration2": "288",
    "allocation2": "144",
    "total": "2160",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "6105",
    "nom_corrige2": "Roseline Laplante",
    "nom_famille": "Laplante",
    "titre_genre2": "Conseillère",
    "remuneration": "1439",
    "allocation": "720",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2159",
    "ville": "Saint-Juste-du-Lac",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "588"
  },
  {
    "ID": "6106",
    "nom_corrige2": "Johane Thibeault",
    "nom_famille": "Thibeault",
    "titre_genre2": "Conseillère",
    "remuneration": "1437",
    "allocation": "718",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2155",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6107",
    "nom_corrige2": "France Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "1437",
    "allocation": "718",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2155",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6108",
    "nom_corrige2": "Nancy Savard",
    "nom_famille": "Savard",
    "titre_genre2": "Conseillère",
    "remuneration": "1437",
    "allocation": "718",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2155",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6109",
    "nom_corrige2": "Yannick Charbonneau",
    "nom_famille": "Charbonneau",
    "titre_genre2": "Conseiller",
    "remuneration": "1437",
    "allocation": "718",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2155",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6110",
    "nom_corrige2": "Catherine Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseillère",
    "remuneration": "1437",
    "allocation": "718",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2155",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6111",
    "nom_corrige2": "Keven Croteau",
    "nom_famille": "Croteau",
    "titre_genre2": "Conseiller",
    "remuneration": "1092",
    "allocation": "1062",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2154",
    "ville": "Colombier",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "694"
  },
  {
    "ID": "6112",
    "nom_corrige2": "Josée Laverdière",
    "nom_famille": "Laverdière",
    "titre_genre2": "Conseillère",
    "remuneration": "1420",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2130",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "6113",
    "nom_corrige2": "Maude Coulombe",
    "nom_famille": "Coulombe",
    "titre_genre2": "Conseillère",
    "remuneration": "1420",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2130",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "6114",
    "nom_corrige2": "Katy Grenier",
    "nom_famille": "Grenier",
    "titre_genre2": "Conseillère",
    "remuneration": "1420",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2130",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "6115",
    "nom_corrige2": "Martin Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "1420",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2130",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "6116",
    "nom_corrige2": "Patrick Larochelle",
    "nom_famille": "Larochelle",
    "titre_genre2": "Conseiller",
    "remuneration": "1420",
    "allocation": "710",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2130",
    "ville": "Saint-Félix-de-Dalquier",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "964"
  },
  {
    "ID": "6117",
    "nom_corrige2": "Marie-Jeanne Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "1418",
    "allocation": "709",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2127",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6118",
    "nom_corrige2": "Lise Tremblay",
    "nom_famille": "Tremblay",
    "titre_genre2": "Conseillère",
    "remuneration": "1416",
    "allocation": "708",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2124",
    "ville": "Honfleur",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "887"
  },
  {
    "ID": "6119",
    "nom_corrige2": "William Lagrange",
    "nom_famille": "Lagrange",
    "titre_genre2": "Conseiller",
    "remuneration": "1405",
    "allocation": "703",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2108",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "6120",
    "nom_corrige2": "Joane Rochon",
    "nom_famille": "Rochon",
    "titre_genre2": "Conseillère",
    "remuneration": "1401",
    "allocation": "701",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2102",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "6121",
    "nom_corrige2": "Richard Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "1401",
    "allocation": "701",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2102",
    "ville": "Saint-Cyprien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "505"
  },
  {
    "ID": "6122",
    "nom_corrige2": "Marc Lajoie",
    "nom_famille": "Lajoie",
    "titre_genre2": "Conseiller",
    "remuneration": "1403",
    "allocation": "699",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2102",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "6123",
    "nom_corrige2": "Rémi Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6124",
    "nom_corrige2": "Jimmy Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseiller",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6125",
    "nom_corrige2": "Laurier Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseiller",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6126",
    "nom_corrige2": "Clermont Bossé",
    "nom_famille": "Bossé",
    "titre_genre2": "Conseiller",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6127",
    "nom_corrige2": "Marie-Anne Fortin",
    "nom_famille": "Fortin",
    "titre_genre2": "Conseillère",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6128",
    "nom_corrige2": "Denyse Lacombe",
    "nom_famille": "Lacombe",
    "titre_genre2": "Conseillère",
    "remuneration": "1400",
    "allocation": "700",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2100",
    "ville": "Launay",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "215"
  },
  {
    "ID": "6129",
    "nom_corrige2": "Mario Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "1398",
    "allocation": "699",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2097",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6130",
    "nom_corrige2": "Danielle Joly",
    "nom_famille": "Joly",
    "titre_genre2": "Conseillère",
    "remuneration": "1392",
    "allocation": "696",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2088",
    "ville": "Saint-Aimé-du-Lac-des-Îles",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "835"
  },
  {
    "ID": "6131",
    "nom_corrige2": "Issé Said Waïs",
    "nom_famille": "Said",
    "titre_genre2": "Conseiller",
    "remuneration": "1389",
    "allocation": "694",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2083",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "6132",
    "nom_corrige2": "Huguette Gauthier Roy",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseillère",
    "remuneration": "1386",
    "allocation": "693",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2079",
    "ville": "Saint-Omer",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "268"
  },
  {
    "ID": "6133",
    "nom_corrige2": "Gérald Mazerolle",
    "nom_famille": "Mazerolle",
    "titre_genre2": "Conseiller",
    "remuneration": "1385",
    "allocation": "692",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2077",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6134",
    "nom_corrige2": "Nadia Beaupré-L'Heureux",
    "nom_famille": "Beaupré-L'Heureux",
    "titre_genre2": "Conseillère",
    "remuneration": "1383",
    "allocation": "692",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2075",
    "ville": "Guérin",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "311"
  },
  {
    "ID": "6135",
    "nom_corrige2": "Hugues Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6136",
    "nom_corrige2": "Camille Sasseville",
    "nom_famille": "Sasseville",
    "titre_genre2": "Conseillère",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6137",
    "nom_corrige2": "Véronique Belley",
    "nom_famille": "Belley",
    "titre_genre2": "Conseillère",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6138",
    "nom_corrige2": "Alain Sasseville",
    "nom_famille": "Sasseville",
    "titre_genre2": "Conseiller",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6139",
    "nom_corrige2": "Dario Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseiller",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6140",
    "nom_corrige2": "Alexandre Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseiller",
    "remuneration": "1380",
    "allocation": "690",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2070",
    "ville": "Saint-Eugène-d'Argentenay",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "480"
  },
  {
    "ID": "6141",
    "nom_corrige2": "Claude Arsenault",
    "nom_famille": "Arsenault",
    "titre_genre2": "Conseiller",
    "remuneration": "1377",
    "allocation": "689",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2066",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6142",
    "nom_corrige2": "Hedvika Brgles",
    "nom_famille": "Brgles",
    "titre_genre2": "Conseillère",
    "remuneration": "1377",
    "allocation": "689",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2066",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6143",
    "nom_corrige2": "Martine Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseillère",
    "remuneration": "1377",
    "allocation": "689",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2066",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6144",
    "nom_corrige2": "Marjolaine Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseillère",
    "remuneration": "1377",
    "allocation": "689",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2066",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6145",
    "nom_corrige2": "Chrystelle Balen",
    "nom_famille": "Balen",
    "titre_genre2": "Conseillère",
    "remuneration": "1375",
    "allocation": "688",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2063",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "6146",
    "nom_corrige2": "Alain Dery",
    "nom_famille": "Dery",
    "titre_genre2": "Conseiller",
    "remuneration": "1550",
    "allocation": "512",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Michel-des-Saints",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "2560"
  },
  {
    "ID": "6147",
    "nom_corrige2": "Francine Garneau",
    "nom_famille": "Garneau",
    "titre_genre2": "Conseillère",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6148",
    "nom_corrige2": "Denis Tanguay",
    "nom_famille": "Tanguay",
    "titre_genre2": "Conseiller",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6149",
    "nom_corrige2": "Lorie Gosselin Côté",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseillère",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6150",
    "nom_corrige2": "Luc Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6151",
    "nom_corrige2": "Marie-Andrée Lapierre",
    "nom_famille": "Lapierre",
    "titre_genre2": "Conseillère",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6152",
    "nom_corrige2": "Nadia Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseillère",
    "remuneration": "1375",
    "allocation": "687",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2062",
    "ville": "Saint-Nazaire-de-Dorchester",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "368"
  },
  {
    "ID": "6153",
    "nom_corrige2": "Johanne Roseberry",
    "nom_famille": "Roseberry",
    "titre_genre2": "Conseillère",
    "remuneration": "1365",
    "allocation": "682",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2047",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "6154",
    "nom_corrige2": "Patrick Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "1361",
    "allocation": "681",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2042",
    "ville": "Lac-Etchemin",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3959"
  },
  {
    "ID": "6155",
    "nom_corrige2": "Roxanne Gendron",
    "nom_famille": "Gendron",
    "titre_genre2": "Conseillère",
    "remuneration": "1360",
    "allocation": "680",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2040",
    "ville": "Lebel-sur-Quévillon",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "2114"
  },
  {
    "ID": "6156",
    "nom_corrige2": "Christina Perron",
    "nom_famille": "Perron",
    "titre_genre2": "Conseillère",
    "remuneration": "1359",
    "allocation": "679",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2038",
    "ville": "Saint-Marc-des-Carrières",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "3028"
  },
  {
    "ID": "6157",
    "nom_corrige2": "Chantal Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6158",
    "nom_corrige2": "Pascal Maheux",
    "nom_famille": "Maheux",
    "titre_genre2": "Conseiller",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6159",
    "nom_corrige2": "Line Lachapelle",
    "nom_famille": "Lachapelle",
    "titre_genre2": "Conseillère",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6160",
    "nom_corrige2": "Gilles Perreault",
    "nom_famille": "Perreault",
    "titre_genre2": "Conseiller",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6161",
    "nom_corrige2": "Lucie Rodrigue",
    "nom_famille": "Rodrigue",
    "titre_genre2": "Conseillère",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6162",
    "nom_corrige2": "Dave Bolduc",
    "nom_famille": "Bolduc",
    "titre_genre2": "Conseiller",
    "remuneration": "1353",
    "allocation": "676",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2029",
    "ville": "Saint-Alfred",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "545"
  },
  {
    "ID": "6163",
    "nom_corrige2": "Jean-Guy Brousseau",
    "nom_famille": "Brousseau",
    "titre_genre2": "Conseiller",
    "remuneration": "1345",
    "allocation": "673",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2018",
    "ville": "L'Île-du-Grand-Calumet",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "660"
  },
  {
    "ID": "6164",
    "nom_corrige2": "Daniel Rioux",
    "nom_famille": "Rioux",
    "titre_genre2": "Conseiller",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6165",
    "nom_corrige2": "Sébastien Beaulieu",
    "nom_famille": "Beaulieu",
    "titre_genre2": "Conseiller",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6166",
    "nom_corrige2": "Raymond Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseiller",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6167",
    "nom_corrige2": "Daniel Dumont",
    "nom_famille": "Dumont",
    "titre_genre2": "Conseiller",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6168",
    "nom_corrige2": "Simon Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6169",
    "nom_corrige2": "Linda Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "1341",
    "allocation": "671",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2012",
    "ville": "Biencourt",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "444"
  },
  {
    "ID": "6170",
    "nom_corrige2": "France Lepage",
    "nom_famille": "Lepage",
    "titre_genre2": "Conseillère",
    "remuneration": "1340",
    "allocation": "670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2010",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6171",
    "nom_corrige2": "Gisèle Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseillère",
    "remuneration": "1340",
    "allocation": "670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2010",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6172",
    "nom_corrige2": "Gérard Richard",
    "nom_famille": "Richard",
    "titre_genre2": "Conseiller",
    "remuneration": "1340",
    "allocation": "670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2010",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6173",
    "nom_corrige2": "Hélène Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseillère",
    "remuneration": "1340",
    "allocation": "670",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2010",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6174",
    "nom_corrige2": "Stéphan Dubé",
    "nom_famille": "Dubé",
    "titre_genre2": "Conseiller",
    "remuneration": "1339",
    "allocation": "669",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2008",
    "ville": "Auclair",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "462"
  },
  {
    "ID": "6175",
    "nom_corrige2": "Pierrette Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "1335",
    "allocation": "667",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "2002",
    "ville": "Saint-Dominique-du-Rosaire",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "440"
  },
  {
    "ID": "6176",
    "nom_corrige2": "NICOLAS PARIS-LAFRANCE",
    "nom_famille": "PARIS-LAFRANCE",
    "titre_genre2": "Conseiller",
    "remuneration": "1333",
    "allocation": "666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1999",
    "ville": "Sainte-Hélène-de-Chester",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "413"
  },
  {
    "ID": "6177",
    "nom_corrige2": "Etienne Prévost",
    "nom_famille": "Prévost",
    "titre_genre2": "Conseiller",
    "remuneration": "1331",
    "allocation": "666",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1997",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "6178",
    "nom_corrige2": "Ghislain Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseiller",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6179",
    "nom_corrige2": "Monia Cloutier",
    "nom_famille": "Cloutier",
    "titre_genre2": "Conseillère",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6180",
    "nom_corrige2": "Yvon Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6181",
    "nom_corrige2": "Claudette Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6182",
    "nom_corrige2": "Florent Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseiller",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6183",
    "nom_corrige2": "Raymonde Petitclerc",
    "nom_famille": "Petitclerc",
    "titre_genre2": "Conseillère",
    "remuneration": "1326",
    "allocation": "663",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1989",
    "ville": "Sainte-Hélène-de-Mancebourg",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "371"
  },
  {
    "ID": "6184",
    "nom_corrige2": "Daniel St-Arnaud",
    "nom_famille": "St-Arnaud",
    "titre_genre2": "Conseiller",
    "remuneration": "1298",
    "allocation": "649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1947",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "6185",
    "nom_corrige2": "Joannie Boutin",
    "nom_famille": "Boutin",
    "titre_genre2": "Conseillère",
    "remuneration": "1298",
    "allocation": "649",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1947",
    "ville": "Sainte-Sabine",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "359"
  },
  {
    "ID": "6186",
    "nom_corrige2": "Josée Lavoie",
    "nom_famille": "Lavoie",
    "titre_genre2": "Conseillère",
    "remuneration": "1294",
    "allocation": "647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1941",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6187",
    "nom_corrige2": "Martial Gauthier",
    "nom_famille": "Gauthier",
    "titre_genre2": "Conseiller",
    "remuneration": "1294",
    "allocation": "647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1941",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6188",
    "nom_corrige2": "Tony Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "1294",
    "allocation": "647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1941",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6189",
    "nom_corrige2": "Marlène Deschesnes",
    "nom_famille": "Deschesnes",
    "titre_genre2": "Conseillère",
    "remuneration": "1294",
    "allocation": "647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1941",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6190",
    "nom_corrige2": "Carolle Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "1294",
    "allocation": "647",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1941",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6191",
    "nom_corrige2": "Ambroise Lycke",
    "nom_famille": "Lycke",
    "titre_genre2": "Conseillère",
    "remuneration": "1288",
    "allocation": "644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1932",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6192",
    "nom_corrige2": "Yvan Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseiller",
    "remuneration": "1275",
    "allocation": "638",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1913",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "6193",
    "nom_corrige2": "Donald Courcy",
    "nom_famille": "Courcy",
    "titre_genre2": "Conseiller",
    "remuneration": "1267",
    "allocation": "634",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1901",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "6194",
    "nom_corrige2": "Mark Cross",
    "nom_famille": "Cross",
    "titre_genre2": "Conseiller",
    "remuneration": "1255",
    "allocation": "627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1882",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "6195",
    "nom_corrige2": "Mario Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseiller",
    "remuneration": "1254",
    "allocation": "627",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1881",
    "ville": "Rougemont",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2805"
  },
  {
    "ID": "6196",
    "nom_corrige2": "Mario Bellemare",
    "nom_famille": "Bellemare",
    "titre_genre2": "Conseiller",
    "remuneration": "1250",
    "allocation": "625",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1875",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "6197",
    "nom_corrige2": "Sylvie Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "1244",
    "allocation": "622",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1866",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "6198",
    "nom_corrige2": "RÉJEAN COUSINEAU",
    "nom_famille": "COUSINEAU",
    "titre_genre2": "Conseiller",
    "remuneration": "1860",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1860",
    "ville": "Saint-Patrice-de-Sherrington",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2430"
  },
  {
    "ID": "6199",
    "nom_corrige2": "Patrick Matton",
    "nom_famille": "Matton",
    "titre_genre2": "Conseiller",
    "remuneration": "1226",
    "allocation": "613",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1839",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6200",
    "nom_corrige2": "Janick Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseillère",
    "remuneration": "1159",
    "allocation": "644",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1803",
    "ville": "Saint-Eugène-de-Guigues",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "470"
  },
  {
    "ID": "6201",
    "nom_corrige2": "Donald Dryburgh",
    "nom_famille": "Dryburgh",
    "titre_genre2": "Conseiller",
    "remuneration": "1194",
    "allocation": "598",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1792",
    "ville": "Notre-Dame-de-Montauban",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "764"
  },
  {
    "ID": "6202",
    "nom_corrige2": "Steve Deschênes",
    "nom_famille": "Deschênes",
    "titre_genre2": "Conseiller",
    "remuneration": "1179",
    "allocation": "590",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1769",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "6203",
    "nom_corrige2": "Michel Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "1176",
    "allocation": "588",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1764",
    "ville": "Fugèreville",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "332"
  },
  {
    "ID": "6204",
    "nom_corrige2": "Fabien Couture",
    "nom_famille": "Couture",
    "titre_genre2": "Conseiller",
    "remuneration": "1263",
    "allocation": "499",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1762",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6205",
    "nom_corrige2": "Albert Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseiller",
    "remuneration": "1181",
    "allocation": "565",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1746",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6206",
    "nom_corrige2": "Odette Ouellet",
    "nom_famille": "Ouellet",
    "titre_genre2": "Conseillère",
    "remuneration": "1181",
    "allocation": "565",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1746",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6207",
    "nom_corrige2": "Guillaume Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseiller",
    "remuneration": "1181",
    "allocation": "565",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1746",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6208",
    "nom_corrige2": "Yvan Poitras",
    "nom_famille": "Poitras",
    "titre_genre2": "Conseiller",
    "remuneration": "1181",
    "allocation": "565",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1746",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6209",
    "nom_corrige2": "Daniel Coutu",
    "nom_famille": "Coutu",
    "titre_genre2": "Conseiller",
    "remuneration": "1160",
    "allocation": "581",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1741",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "6210",
    "nom_corrige2": "Caroline Belleau-Poirier",
    "nom_famille": "Belleau-Poirier",
    "titre_genre2": "Conseillère",
    "remuneration": "1162",
    "allocation": "577",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1739",
    "ville": "Chapais",
    "arrondissement": "",
    "region_adm": "Nord-du-Québec",
    "population": "1537"
  },
  {
    "ID": "6211",
    "nom_corrige2": "Nancy Guénette",
    "nom_famille": "Guénette",
    "titre_genre2": "Conseillère",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6212",
    "nom_corrige2": "Manon Beaudet",
    "nom_famille": "Beaudet",
    "titre_genre2": "Conseillère",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6213",
    "nom_corrige2": "Léopold Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6214",
    "nom_corrige2": "Lyne Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseillère",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6215",
    "nom_corrige2": "Stéphane Leduc",
    "nom_famille": "Leduc",
    "titre_genre2": "Conseiller",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6216",
    "nom_corrige2": "Sonia Marcotte",
    "nom_famille": "Marcotte",
    "titre_genre2": "Conseillère",
    "remuneration": "1138",
    "allocation": "569",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1707",
    "ville": "Champneuf",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "124"
  },
  {
    "ID": "6217",
    "nom_corrige2": "SUZANNE TREMBLAY",
    "nom_famille": "TREMBLAY",
    "titre_genre2": "Conseillère",
    "remuneration": "1125",
    "allocation": "562",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1687",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "6218",
    "nom_corrige2": "Maggie Lapointe",
    "nom_famille": "Lapointe",
    "titre_genre2": "Conseillère",
    "remuneration": "1111",
    "allocation": "556",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1667",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "6219",
    "nom_corrige2": "Marie Forcier",
    "nom_famille": "Forcier",
    "titre_genre2": "Conseillère",
    "remuneration": "1111",
    "allocation": "556",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1667",
    "ville": "Lac-Drolet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1087"
  },
  {
    "ID": "6220",
    "nom_corrige2": "Ghislaine Baribeau",
    "nom_famille": "Baribeau",
    "titre_genre2": "Conseillère",
    "remuneration": "1111",
    "allocation": "555",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1666",
    "ville": "La Motte",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "492"
  },
  {
    "ID": "6221",
    "nom_corrige2": "Quentin Kelhetter",
    "nom_famille": "Kelhetter",
    "titre_genre2": "Conseiller",
    "remuneration": "1100",
    "allocation": "550",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1650",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "6222",
    "nom_corrige2": "Joanne Costo",
    "nom_famille": "Costo",
    "titre_genre2": "Conseillère",
    "remuneration": "1100",
    "allocation": "550",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1650",
    "ville": "Deschaillons-sur-Saint-Laurent",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "907"
  },
  {
    "ID": "6223",
    "nom_corrige2": "Sylvie Charest",
    "nom_famille": "Charest",
    "titre_genre2": "Conseillère",
    "remuneration": "1099",
    "allocation": "549",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1648",
    "ville": "Saint-André-de-Restigouche",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "151"
  },
  {
    "ID": "6224",
    "nom_corrige2": "Daniel Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseiller",
    "remuneration": "1082",
    "allocation": "565",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1647",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6225",
    "nom_corrige2": "Kathleen Côté",
    "nom_famille": "Côté",
    "titre_genre2": "Conseillère",
    "remuneration": "1082",
    "allocation": "541",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1623",
    "ville": "Saint-Luc-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "451"
  },
  {
    "ID": "6226",
    "nom_corrige2": "Patrick Moisan",
    "nom_famille": "Moisan",
    "titre_genre2": "Conseiller",
    "remuneration": "1100",
    "allocation": "500",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Saint-Julien",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "394"
  },
  {
    "ID": "6227",
    "nom_corrige2": "SYLVAIN BOILY",
    "nom_famille": "BOILY",
    "titre_genre2": "Conseiller",
    "remuneration": "1067",
    "allocation": "533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6228",
    "nom_corrige2": "DANY THÉRIAULT",
    "nom_famille": "THÉRIAULT",
    "titre_genre2": "Conseiller",
    "remuneration": "1067",
    "allocation": "533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6229",
    "nom_corrige2": "SYLVAIN CARRIER",
    "nom_famille": "CARRIER",
    "titre_genre2": "Conseiller",
    "remuneration": "1067",
    "allocation": "533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6230",
    "nom_corrige2": "LINE LANDRY",
    "nom_famille": "LANDRY",
    "titre_genre2": "Conseillère",
    "remuneration": "1067",
    "allocation": "533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6231",
    "nom_corrige2": "VINCENT GILBERT",
    "nom_famille": "GILBERT",
    "titre_genre2": "Conseiller",
    "remuneration": "1067",
    "allocation": "533",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1600",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6232",
    "nom_corrige2": "Clément Melançon",
    "nom_famille": "Melançon",
    "titre_genre2": "Conseiller",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6233",
    "nom_corrige2": "Stéphane Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseiller",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6234",
    "nom_corrige2": "Micheline Gagné",
    "nom_famille": "Gagné",
    "titre_genre2": "Conseillère",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6235",
    "nom_corrige2": "Claude Garant",
    "nom_famille": "Garant",
    "titre_genre2": "Conseiller",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6236",
    "nom_corrige2": "Marcel Moreau",
    "nom_famille": "Moreau",
    "titre_genre2": "Conseiller",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6237",
    "nom_corrige2": "Manon Fluet",
    "nom_famille": "Fluet",
    "titre_genre2": "Conseillère",
    "remuneration": "1062",
    "allocation": "531",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1593",
    "ville": "Saint-Lambert",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "201"
  },
  {
    "ID": "6238",
    "nom_corrige2": "Richard Turgeon",
    "nom_famille": "Turgeon",
    "titre_genre2": "Conseiller",
    "remuneration": "1038",
    "allocation": "519",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1557",
    "ville": "Val-Brillant",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "941"
  },
  {
    "ID": "6239",
    "nom_corrige2": "Alain Lavallée",
    "nom_famille": "Lavallée",
    "titre_genre2": "Conseiller",
    "remuneration": "1015",
    "allocation": "507",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1522",
    "ville": "Saint-Marc-sur-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2296"
  },
  {
    "ID": "6240",
    "nom_corrige2": "Laurent Laverdière",
    "nom_famille": "Laverdière",
    "titre_genre2": "Maire",
    "remuneration": "1013",
    "allocation": "506",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1519",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6241",
    "nom_corrige2": "Benoit Mathieu",
    "nom_famille": "Mathieu",
    "titre_genre2": "Conseiller",
    "remuneration": "1166",
    "allocation": "351",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1517",
    "ville": "Saint-Michel-de-Bellechasse",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1870"
  },
  {
    "ID": "6242",
    "nom_corrige2": "Claude Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseiller",
    "remuneration": "1098",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1510",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "6243",
    "nom_corrige2": "Karinne Lebel",
    "nom_famille": "Lebel",
    "titre_genre2": "Conseillère",
    "remuneration": "1484",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1484",
    "ville": "Saint-Jean-Baptiste",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "3380"
  },
  {
    "ID": "6244",
    "nom_corrige2": "Sylvain Dubuc",
    "nom_famille": "Dubuc",
    "titre_genre2": "Conseiller",
    "remuneration": "987",
    "allocation": "493",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1480",
    "ville": "Sainte-Julie",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "31030"
  },
  {
    "ID": "6245",
    "nom_corrige2": "Corinne Boucher",
    "nom_famille": "Boucher",
    "titre_genre2": "Conseillère",
    "remuneration": "955",
    "allocation": "518",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1473",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "6246",
    "nom_corrige2": "André Gonthier",
    "nom_famille": "Gonthier",
    "titre_genre2": "Conseiller",
    "remuneration": "982",
    "allocation": "491",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1473",
    "ville": "Barraute",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "1997"
  },
  {
    "ID": "6247",
    "nom_corrige2": "Claude Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "982",
    "allocation": "491",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1473",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "6248",
    "nom_corrige2": "Marie-Lise Daigle",
    "nom_famille": "Daigle",
    "titre_genre2": "Conseillère",
    "remuneration": "1120",
    "allocation": "352",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1472",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "6249",
    "nom_corrige2": "Coralie Dufresne",
    "nom_famille": "Dufresne",
    "titre_genre2": "Conseillère",
    "remuneration": "1035",
    "allocation": "435",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1470",
    "ville": "Saint-Sixte",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "539"
  },
  {
    "ID": "6250",
    "nom_corrige2": "Dany Chénard",
    "nom_famille": "Chénard",
    "titre_genre2": "Conseiller",
    "remuneration": "1000",
    "allocation": "453",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1453",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6251",
    "nom_corrige2": "Pauline Samson",
    "nom_famille": "Samson",
    "titre_genre2": "Conseillère",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "227",
    "allocation2": "114",
    "total": "1446",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6252",
    "nom_corrige2": "Karoline Létourneau",
    "nom_famille": "Létourneau",
    "titre_genre2": "Conseillère",
    "remuneration": "946",
    "allocation": "474",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1420",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "6253",
    "nom_corrige2": "Vincent Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "945",
    "allocation": "473",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1418",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6254",
    "nom_corrige2": "Tony Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseiller",
    "remuneration": "945",
    "allocation": "473",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1418",
    "ville": "Saint-Philibert",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "348"
  },
  {
    "ID": "6255",
    "nom_corrige2": "Eden Lauzon",
    "nom_famille": "Lauzon",
    "titre_genre2": "Conseillère",
    "remuneration": "962",
    "allocation": "441",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1403",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "6256",
    "nom_corrige2": "Marielle Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseillère",
    "remuneration": "934",
    "allocation": "467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1401",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "6257",
    "nom_corrige2": "Nelson Sirois",
    "nom_famille": "Sirois",
    "titre_genre2": "Conseiller",
    "remuneration": "934",
    "allocation": "467",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1401",
    "ville": "Saint-Moïse",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "574"
  },
  {
    "ID": "6258",
    "nom_corrige2": "Marie-Andrée Vanzeveren",
    "nom_famille": "Vanzeveren",
    "titre_genre2": "Conseillère",
    "remuneration": "978",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1390",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "6259",
    "nom_corrige2": "Vanessa Robidas-Gravel",
    "nom_famille": "Robidas-Gravel",
    "titre_genre2": "Conseillère",
    "remuneration": "917",
    "allocation": "459",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1376",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "6260",
    "nom_corrige2": "Samuel Fortier",
    "nom_famille": "Fortier",
    "titre_genre2": "Conseiller",
    "remuneration": "902",
    "allocation": "457",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1359",
    "ville": "Disraeli",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1151"
  },
  {
    "ID": "6261",
    "nom_corrige2": "Jean Pronovost",
    "nom_famille": "Pronovost",
    "titre_genre2": "Conseiller",
    "remuneration": "878",
    "allocation": "439",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1317",
    "ville": "Saint-Jean-de-Brébeuf",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "387"
  },
  {
    "ID": "6262",
    "nom_corrige2": "Bruno Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseiller",
    "remuneration": "1294",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1294",
    "ville": "Saint-Edmond-les-Plaines",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "373"
  },
  {
    "ID": "6263",
    "nom_corrige2": "Isabelle Loignon",
    "nom_famille": "Loignon",
    "titre_genre2": "Conseillère",
    "remuneration": "878",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1290",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "6264",
    "nom_corrige2": "André Audet",
    "nom_famille": "Audet",
    "titre_genre2": "Conseiller",
    "remuneration": "864",
    "allocation": "420",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1284",
    "ville": "Saint-Augustin-de-Woburn",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "683"
  },
  {
    "ID": "6265",
    "nom_corrige2": "Manon Foster",
    "nom_famille": "Foster",
    "titre_genre2": "Conseillère",
    "remuneration": "764",
    "allocation": "518",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1282",
    "ville": "Baie-Sainte-Catherine",
    "arrondissement": "",
    "region_adm": "Capitale-Nationale",
    "population": "175"
  },
  {
    "ID": "6266",
    "nom_corrige2": "Jessy Belley",
    "nom_famille": "Belley",
    "titre_genre2": "Conseillère",
    "remuneration": "838",
    "allocation": "419",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1257",
    "ville": "Saint-Stanislas",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "386"
  },
  {
    "ID": "6267",
    "nom_corrige2": "Marie-Pier Therrien",
    "nom_famille": "Therrien",
    "titre_genre2": "Conseillère",
    "remuneration": "833",
    "allocation": "417",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1250",
    "ville": "Saint-Adrien",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "566"
  },
  {
    "ID": "6268",
    "nom_corrige2": "Susan Veroff",
    "nom_famille": "Veroff",
    "titre_genre2": "Conseillère",
    "remuneration": "1250",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1250",
    "ville": "Saint-Jacques-le-Majeur-de-Wolfestown",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "191"
  },
  {
    "ID": "6269",
    "nom_corrige2": "Robert Desmarais",
    "nom_famille": "Desmarais",
    "titre_genre2": "Conseiller",
    "remuneration": "829",
    "allocation": "414",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1243",
    "ville": "Sainte-Marie-Salomé",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "1242"
  },
  {
    "ID": "6270",
    "nom_corrige2": "Vincent Grandmont",
    "nom_famille": "Grandmont",
    "titre_genre2": "Conseiller",
    "remuneration": "761",
    "allocation": "475",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1236",
    "ville": "Notre-Dame-du-Bon-Conseil",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1681"
  },
  {
    "ID": "6271",
    "nom_corrige2": "Nathalie Lacasse",
    "nom_famille": "Lacasse",
    "titre_genre2": "Conseillère",
    "remuneration": "823",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1235",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "6272",
    "nom_corrige2": "Jacques Inkel",
    "nom_famille": "Inkel",
    "titre_genre2": "Conseiller",
    "remuneration": "823",
    "allocation": "412",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1235",
    "ville": "Saint-Venant-de-Paquette",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "103"
  },
  {
    "ID": "6273",
    "nom_corrige2": "Laurentia Duguay",
    "nom_famille": "Duguay",
    "titre_genre2": "Conseillère",
    "remuneration": "245",
    "allocation": "980",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1225",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "6274",
    "nom_corrige2": "Michel Bernatchez",
    "nom_famille": "Bernatchez",
    "titre_genre2": "Conseiller",
    "remuneration": "815",
    "allocation": "408",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1223",
    "ville": "Saint-Paulin",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "1594"
  },
  {
    "ID": "6275",
    "nom_corrige2": "Luc Grenon",
    "nom_famille": "Grenon",
    "titre_genre2": "Conseiller",
    "remuneration": "801",
    "allocation": "400",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1201",
    "ville": "Sainte-Lucie-des-Laurentides",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "1475"
  },
  {
    "ID": "6276",
    "nom_corrige2": "Michel Paquet",
    "nom_famille": "Paquet",
    "titre_genre2": "Conseiller",
    "remuneration": "797",
    "allocation": "398",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1195",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6277",
    "nom_corrige2": "Martine Labrosse",
    "nom_famille": "Labrosse",
    "titre_genre2": "Conseillère",
    "remuneration": "792",
    "allocation": "396",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1188",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "6278",
    "nom_corrige2": "Michel Patenaude",
    "nom_famille": "Patenaude",
    "titre_genre2": "Conseiller",
    "remuneration": "792",
    "allocation": "396",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1188",
    "ville": "Lac-Saguay",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "476"
  },
  {
    "ID": "6279",
    "nom_corrige2": "Gaétan Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "785",
    "allocation": "392",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1177",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "6280",
    "nom_corrige2": "Robert Piché",
    "nom_famille": "Piché",
    "titre_genre2": "Conseiller",
    "remuneration": "4693",
    "allocation": "2347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "7040",
    "ville": "Aumond",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "819"
  },
  {
    "ID": "6281",
    "nom_corrige2": "CATHY PERREAULT",
    "nom_famille": "PERREAULT",
    "titre_genre2": "Conseillère",
    "remuneration": "832",
    "allocation": "341",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1173",
    "ville": "Saint-Noël",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "398"
  },
  {
    "ID": "6282",
    "nom_corrige2": "Jean-François Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "812",
    "allocation": "353",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1165",
    "ville": "Sainte-Anne-de-la-Rochelle",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "611"
  },
  {
    "ID": "6283",
    "nom_corrige2": "Patricia Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseillère",
    "remuneration": "770",
    "allocation": "385",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1155",
    "ville": "Normandin",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "3050"
  },
  {
    "ID": "6284",
    "nom_corrige2": "Jécika Mongrain",
    "nom_famille": "Mongrain",
    "titre_genre2": "Conseillère",
    "remuneration": "767",
    "allocation": "384",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1151",
    "ville": "Saint-Prosper-de-Champlain",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "502"
  },
  {
    "ID": "6285",
    "nom_corrige2": "Normand Bissonnette",
    "nom_famille": "Bissonnette",
    "titre_genre2": "Conseiller",
    "remuneration": "762",
    "allocation": "381",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1143",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "6286",
    "nom_corrige2": "Philippe Gosselin",
    "nom_famille": "Gosselin",
    "titre_genre2": "Conseiller",
    "remuneration": "753",
    "allocation": "376",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1129",
    "ville": "Ulverton",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "452"
  },
  {
    "ID": "6287",
    "nom_corrige2": "Michel Lemay",
    "nom_famille": "Lemay",
    "titre_genre2": "Conseiller",
    "remuneration": "750",
    "allocation": "375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1125",
    "ville": "Saint-Édouard-de-Maskinongé",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "741"
  },
  {
    "ID": "6288",
    "nom_corrige2": "CLAUDIA DOUCET",
    "nom_famille": "DOUCET",
    "titre_genre2": "Conseillère",
    "remuneration": "750",
    "allocation": "375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1125",
    "ville": "Saint-Samuel",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "813"
  },
  {
    "ID": "6289",
    "nom_corrige2": "Mathieu Fournier",
    "nom_famille": "Fournier",
    "titre_genre2": "Conseiller",
    "remuneration": "750",
    "allocation": "375",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1125",
    "ville": "Sainte-Sophie-de-Lévrard",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "747"
  },
  {
    "ID": "6290",
    "nom_corrige2": "Keven Jolin",
    "nom_famille": "Jolin",
    "titre_genre2": "Conseiller",
    "remuneration": "717",
    "allocation": "388",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Armagh",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1477"
  },
  {
    "ID": "6291",
    "nom_corrige2": "Sylvie Bernatchez",
    "nom_famille": "Bernatchez",
    "titre_genre2": "Conseillère",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6292",
    "nom_corrige2": "Étienne Tougas",
    "nom_famille": "Tougas",
    "titre_genre2": "Conseiller",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6293",
    "nom_corrige2": "Richard Campbell",
    "nom_famille": "Campbell",
    "titre_genre2": "Conseiller",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6294",
    "nom_corrige2": "Donald Tougas",
    "nom_famille": "Tougas",
    "titre_genre2": "Conseiller",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6295",
    "nom_corrige2": "Chantal Vallières Brodeur",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseillère",
    "remuneration": "811",
    "allocation": "294",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1105",
    "ville": "Stanbridge Station",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "277"
  },
  {
    "ID": "6296",
    "nom_corrige2": "Nancy Legault",
    "nom_famille": "Legault",
    "titre_genre2": "Conseillère",
    "remuneration": "728",
    "allocation": "364",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1092",
    "ville": "Landrienne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "931"
  },
  {
    "ID": "6297",
    "nom_corrige2": "Gaston Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "722",
    "allocation": "361",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1083",
    "ville": "Saint-Jean-de-Dieu",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "1692"
  },
  {
    "ID": "6298",
    "nom_corrige2": "Réal Delorme",
    "nom_famille": "Delorme",
    "titre_genre2": "Conseiller",
    "remuneration": "722",
    "allocation": "361",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1083",
    "ville": "Lawrenceville",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "627"
  },
  {
    "ID": "6299",
    "nom_corrige2": "Nancy Lafontaine",
    "nom_famille": "Lafontaine",
    "titre_genre2": "Conseillère",
    "remuneration": "716",
    "allocation": "358",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1074",
    "ville": "Piopolis",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "365"
  },
  {
    "ID": "6300",
    "nom_corrige2": "Johanne Caissy",
    "nom_famille": "Caissy",
    "titre_genre2": "Conseillère",
    "remuneration": "713",
    "allocation": "357",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1070",
    "ville": "Sainte-Florence",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "361"
  },
  {
    "ID": "6301",
    "nom_corrige2": "Roger Bernard",
    "nom_famille": "Bernard",
    "titre_genre2": "Conseiller",
    "remuneration": "700",
    "allocation": "350",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1050",
    "ville": "Saint-Joseph-de-Beauce",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "4989"
  },
  {
    "ID": "6302",
    "nom_corrige2": "Marie-Blanche Richer",
    "nom_famille": "Richer",
    "titre_genre2": "Conseillère",
    "remuneration": "694",
    "allocation": "347",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1041",
    "ville": "Bolton-Ouest",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "669"
  },
  {
    "ID": "6303",
    "nom_corrige2": "Josée Dallaire",
    "nom_famille": "Dallaire",
    "titre_genre2": "Conseillère",
    "remuneration": "780",
    "allocation": "260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "1040",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6304",
    "nom_corrige2": "Raymond Malo",
    "nom_famille": "Malo",
    "titre_genre2": "Conseiller",
    "remuneration": "662",
    "allocation": "331",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "993",
    "ville": "Kamouraska",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "627"
  },
  {
    "ID": "6305",
    "nom_corrige2": "Jinny Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "655",
    "allocation": "327",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "982",
    "ville": "Saint-Donat",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "886"
  },
  {
    "ID": "6306",
    "nom_corrige2": "Joceline D'Amour",
    "nom_famille": "D'Amour",
    "titre_genre2": "Conseillère",
    "remuneration": "667",
    "allocation": "310",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "977",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6307",
    "nom_corrige2": "André Asselin",
    "nom_famille": "Asselin",
    "titre_genre2": "Conseiller",
    "remuneration": "667",
    "allocation": "310",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "977",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6308",
    "nom_corrige2": "Rogé Francoeur",
    "nom_famille": "Francoeur",
    "titre_genre2": "Conseiller",
    "remuneration": "667",
    "allocation": "310",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "977",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6309",
    "nom_corrige2": "Raymond Saint-Aubin",
    "nom_famille": "Saint-Aubin",
    "titre_genre2": "Conseiller",
    "remuneration": "636",
    "allocation": "318",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "954",
    "ville": "Sainte-Marguerite-du-Lac-Masson",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "3545"
  },
  {
    "ID": "6310",
    "nom_corrige2": "Jacques Michaud",
    "nom_famille": "Michaud",
    "titre_genre2": "Conseiller",
    "remuneration": "631",
    "allocation": "316",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "947",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "6311",
    "nom_corrige2": "Byanca Bouffard",
    "nom_famille": "Bouffard",
    "titre_genre2": "Conseillère",
    "remuneration": "627",
    "allocation": "314",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "941",
    "ville": "Audet",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "771"
  },
  {
    "ID": "6312",
    "nom_corrige2": "Yves Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "627",
    "allocation": "313",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "940",
    "ville": "Frampton",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "1366"
  },
  {
    "ID": "6313",
    "nom_corrige2": "Olivier Plante",
    "nom_famille": "Plante",
    "titre_genre2": "Conseiller",
    "remuneration": "650",
    "allocation": "260",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "910",
    "ville": "Saint-Cléophas-de-Brandon",
    "arrondissement": "",
    "region_adm": "Lanaudière",
    "population": "249"
  },
  {
    "ID": "6314",
    "nom_corrige2": "Goderic Purcell",
    "nom_famille": "Purcell",
    "titre_genre2": "Conseiller",
    "remuneration": "605",
    "allocation": "302",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "907",
    "ville": "Saint-Ludger",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "1050"
  },
  {
    "ID": "6315",
    "nom_corrige2": "Serge Beaudoin",
    "nom_famille": "Beaudoin",
    "titre_genre2": "Conseiller",
    "remuneration": "601",
    "allocation": "301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "902",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6316",
    "nom_corrige2": "Michel Marquis",
    "nom_famille": "Marquis",
    "titre_genre2": "Conseiller",
    "remuneration": "601",
    "allocation": "301",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "902",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6317",
    "nom_corrige2": "Gervais Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseiller",
    "remuneration": "598",
    "allocation": "298",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "896",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "6318",
    "nom_corrige2": "Marie-Laure Bélanger",
    "nom_famille": "Bélanger",
    "titre_genre2": "Conseillère",
    "remuneration": "570",
    "allocation": "308",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "878",
    "ville": "Manseau",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "836"
  },
  {
    "ID": "6319",
    "nom_corrige2": "Ginette Sheehy",
    "nom_famille": "Sheehy",
    "titre_genre2": "Conseillère",
    "remuneration": "576",
    "allocation": "289",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "865",
    "ville": "Huberdeau",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "901"
  },
  {
    "ID": "6320",
    "nom_corrige2": "Geneviève Gilbert",
    "nom_famille": "Gilbert",
    "titre_genre2": "Conseillère",
    "remuneration": "577",
    "allocation": "288",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "865",
    "ville": "La Patrie",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "813"
  },
  {
    "ID": "6321",
    "nom_corrige2": "Nannie Hamel",
    "nom_famille": "Hamel",
    "titre_genre2": "Conseillère",
    "remuneration": "574",
    "allocation": "287",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "861",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6322",
    "nom_corrige2": "Steven Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseiller",
    "remuneration": "574",
    "allocation": "287",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "861",
    "ville": "Belcourt",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "222"
  },
  {
    "ID": "6323",
    "nom_corrige2": "Edith Simard",
    "nom_famille": "Simard",
    "titre_genre2": "Conseillère",
    "remuneration": "563",
    "allocation": "267",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "830",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "6324",
    "nom_corrige2": "Glen Currie",
    "nom_famille": "Currie",
    "titre_genre2": "Conseiller",
    "remuneration": "548",
    "allocation": "274",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "822",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "6325",
    "nom_corrige2": "David Letendre",
    "nom_famille": "Letendre",
    "titre_genre2": "Conseiller",
    "remuneration": "543",
    "allocation": "271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "814",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "6326",
    "nom_corrige2": "Véronik Rioux-Pin",
    "nom_famille": "Rioux-Pin",
    "titre_genre2": "Conseillère",
    "remuneration": "543",
    "allocation": "271",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "814",
    "ville": "Sainte-Françoise",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "397"
  },
  {
    "ID": "6327",
    "nom_corrige2": "GENEVIÈVE CHIASSON",
    "nom_famille": "CHIASSON",
    "titre_genre2": "Conseillère",
    "remuneration": "533",
    "allocation": "267",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "800",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6328",
    "nom_corrige2": "Éric Comeau",
    "nom_famille": "Comeau",
    "titre_genre2": "Conseiller",
    "remuneration": "526",
    "allocation": "263",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "789",
    "ville": "La Corne",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "815"
  },
  {
    "ID": "6329",
    "nom_corrige2": "Jocelyne Bouchard",
    "nom_famille": "Bouchard",
    "titre_genre2": "Conseillère",
    "remuneration": "517",
    "allocation": "259",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "776",
    "ville": "Pointe-aux-Outardes",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "1285"
  },
  {
    "ID": "6330",
    "nom_corrige2": "Johanne Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseillère",
    "remuneration": "496",
    "allocation": "248",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "744",
    "ville": "Saint-Côme-Linière",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "3343"
  },
  {
    "ID": "6331",
    "nom_corrige2": "Isabelle Jetté",
    "nom_famille": "Jetté",
    "titre_genre2": "Conseillère",
    "remuneration": "560",
    "allocation": "176",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "736",
    "ville": "Val-des-Lacs",
    "arrondissement": "",
    "region_adm": "Laurentides",
    "population": "746"
  },
  {
    "ID": "6332",
    "nom_corrige2": "Alain Garon",
    "nom_famille": "Garon",
    "titre_genre2": "Conseiller",
    "remuneration": "500",
    "allocation": "227",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "727",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6333",
    "nom_corrige2": "Martin Loubier",
    "nom_famille": "Loubier",
    "titre_genre2": "Conseiller",
    "remuneration": "481",
    "allocation": "241",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "722",
    "ville": "Lingwick",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "459"
  },
  {
    "ID": "6334",
    "nom_corrige2": "Blaise Boisvert",
    "nom_famille": "Boisvert",
    "titre_genre2": "Conseiller",
    "remuneration": "473",
    "allocation": "237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "710",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "6335",
    "nom_corrige2": "Chantal Godbout",
    "nom_famille": "Godbout",
    "titre_genre2": "Conseillère",
    "remuneration": "473",
    "allocation": "237",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "710",
    "ville": "La Reine",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "340"
  },
  {
    "ID": "6336",
    "nom_corrige2": "Claude Vibert",
    "nom_famille": "Vibert",
    "titre_genre2": "Conseiller",
    "remuneration": "466",
    "allocation": "233",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "699",
    "ville": "Longue-Pointe-de-Mingan",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "431"
  },
  {
    "ID": "6337",
    "nom_corrige2": "Robert Meyer",
    "nom_famille": "Meyer",
    "titre_genre2": "Conseiller",
    "remuneration": "449",
    "allocation": "225",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "674",
    "ville": "Boileau",
    "arrondissement": "",
    "region_adm": "Outaouais",
    "population": "367"
  },
  {
    "ID": "6338",
    "nom_corrige2": "JEAN-CLAUDE CHOUINARD",
    "nom_famille": "CHOUINARD",
    "titre_genre2": "Conseiller",
    "remuneration": "444",
    "allocation": "222",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "666",
    "ville": "Sainte-Marguerite-Marie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "175"
  },
  {
    "ID": "6339",
    "nom_corrige2": "Michaël Lessard Lacroix",
    "nom_famille": "Lessard",
    "titre_genre2": "Conseiller",
    "remuneration": "436",
    "allocation": "218",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "654",
    "ville": "Saint-René",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "894"
  },
  {
    "ID": "6340",
    "nom_corrige2": "Michel Néron",
    "nom_famille": "Néron",
    "titre_genre2": "Conseiller",
    "remuneration": "433",
    "allocation": "217",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "650",
    "ville": "Saint-Charles-de-Bourget",
    "arrondissement": "",
    "region_adm": "Saguenay-Lac-Saint-Jean",
    "population": "835"
  },
  {
    "ID": "6341",
    "nom_corrige2": "Manon Reed",
    "nom_famille": "Reed",
    "titre_genre2": "Conseillère",
    "remuneration": "430",
    "allocation": "215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "645",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "6342",
    "nom_corrige2": "Samuel St-Pierre",
    "nom_famille": "St-Pierre",
    "titre_genre2": "Conseiller",
    "remuneration": "430",
    "allocation": "215",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "645",
    "ville": "Saint-Bonaventure",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "1047"
  },
  {
    "ID": "6343",
    "nom_corrige2": "André Nadeau",
    "nom_famille": "Nadeau",
    "titre_genre2": "Conseiller",
    "remuneration": "627",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "627",
    "ville": "East Hereford",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "288"
  },
  {
    "ID": "6344",
    "nom_corrige2": "Jacques Mccollough",
    "nom_famille": "Mccollough",
    "titre_genre2": "Conseiller",
    "remuneration": "401",
    "allocation": "200",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "601",
    "ville": "Saint-Théophile",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "678"
  },
  {
    "ID": "6345",
    "nom_corrige2": "Marc Vallières",
    "nom_famille": "Vallières",
    "titre_genre2": "Conseiller",
    "remuneration": "568",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "568",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "6346",
    "nom_corrige2": "Robert Morissette",
    "nom_famille": "Morissette",
    "titre_genre2": "Conseiller",
    "remuneration": "366",
    "allocation": "183",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "549",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "6347",
    "nom_corrige2": "Stéphane Leblanc",
    "nom_famille": "Leblanc",
    "titre_genre2": "Conseiller",
    "remuneration": "366",
    "allocation": "183",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "549",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "6348",
    "nom_corrige2": "Roger Bérubé",
    "nom_famille": "Bérubé",
    "titre_genre2": "Conseiller",
    "remuneration": "362",
    "allocation": "181",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "543",
    "ville": "Saint-Joseph-de-Lepage",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "545"
  },
  {
    "ID": "6349",
    "nom_corrige2": "Steeve Coll",
    "nom_famille": "Coll",
    "titre_genre2": "Conseiller",
    "remuneration": "357",
    "allocation": "183",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "540",
    "ville": "Saint-Roch-de-Richelieu",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "2580"
  },
  {
    "ID": "6350",
    "nom_corrige2": "Jean-Denis Paré",
    "nom_famille": "Paré",
    "titre_genre2": "Conseiller",
    "remuneration": "359",
    "allocation": "180",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "539",
    "ville": "Saint-Urbain-Premier",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "1394"
  },
  {
    "ID": "6351",
    "nom_corrige2": "Mélanie Caron-Croisetière",
    "nom_famille": "Caron-Croisetière",
    "titre_genre2": "Conseillère",
    "remuneration": "538",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "538",
    "ville": "Sainte-Germaine-Boulé",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "994"
  },
  {
    "ID": "6352",
    "nom_corrige2": "Valérie Desbiens",
    "nom_famille": "Desbiens",
    "titre_genre2": "Conseillère",
    "remuneration": "355",
    "allocation": "178",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "533",
    "ville": "Godbout",
    "arrondissement": "",
    "region_adm": "Côte-Nord",
    "population": "262"
  },
  {
    "ID": "6353",
    "nom_corrige2": "Martin Berger",
    "nom_famille": "Berger",
    "titre_genre2": "Conseiller",
    "remuneration": "346",
    "allocation": "182",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "528",
    "ville": "Saint-Aimé",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "480"
  },
  {
    "ID": "6354",
    "nom_corrige2": "Jean-William Ayotte",
    "nom_famille": "Ayotte",
    "titre_genre2": "Conseiller",
    "remuneration": "344",
    "allocation": "172",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "516",
    "ville": "Cloridorme",
    "arrondissement": "",
    "region_adm": "Gaspésie-Îles-de-la-Madeleine",
    "population": "647"
  },
  {
    "ID": "6355",
    "nom_corrige2": "Sylvain Lachance",
    "nom_famille": "Lachance",
    "titre_genre2": "Conseiller",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6356",
    "nom_corrige2": "Jean Doyon",
    "nom_famille": "Doyon",
    "titre_genre2": "Conseiller",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6357",
    "nom_corrige2": "Dominic Gonthier",
    "nom_famille": "Gonthier",
    "titre_genre2": "Conseiller",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6358",
    "nom_corrige2": "Stéphanie Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseillère",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6359",
    "nom_corrige2": "Sara Dufour",
    "nom_famille": "Dufour",
    "titre_genre2": "Conseillère",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6360",
    "nom_corrige2": "Andrée Ann Gaudreault",
    "nom_famille": "Gaudreault",
    "titre_genre2": "Conseillère",
    "remuneration": "338",
    "allocation": "169",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "507",
    "ville": "Saint-Fabien-de-Panet",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "961"
  },
  {
    "ID": "6361",
    "nom_corrige2": "Arnaud Caron-Daneault",
    "nom_famille": "Caron-Daneault",
    "titre_genre2": "Conseiller",
    "remuneration": "324",
    "allocation": "162",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "486",
    "ville": "Sainte-Louise",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "723"
  },
  {
    "ID": "6362",
    "nom_corrige2": "André Casavant",
    "nom_famille": "Casavant",
    "titre_genre2": "Conseiller",
    "remuneration": "317",
    "allocation": "158",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "475",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "6363",
    "nom_corrige2": "Nathalie Emond",
    "nom_famille": "Emond",
    "titre_genre2": "Conseillère",
    "remuneration": "317",
    "allocation": "158",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "475",
    "ville": "Saint-Sylvère",
    "arrondissement": "",
    "region_adm": "Centre-du-Québec",
    "population": "793"
  },
  {
    "ID": "6364",
    "nom_corrige2": "Serge Morin",
    "nom_famille": "Morin",
    "titre_genre2": "Conseiller",
    "remuneration": "313",
    "allocation": "157",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "470",
    "ville": "Chazel",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "293"
  },
  {
    "ID": "6365",
    "nom_corrige2": "Valérie Descôteaux",
    "nom_famille": "Descôteaux",
    "titre_genre2": "Conseillère",
    "remuneration": "300",
    "allocation": "150",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "450",
    "ville": "Bonsecours",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "677"
  },
  {
    "ID": "6366",
    "nom_corrige2": "François Gagnon",
    "nom_famille": "Gagnon",
    "titre_genre2": "Conseiller",
    "remuneration": "296",
    "allocation": "148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "444",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "6367",
    "nom_corrige2": "Josée Bédard",
    "nom_famille": "Bédard",
    "titre_genre2": "Conseillère",
    "remuneration": "296",
    "allocation": "148",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "444",
    "ville": "Sainte-Aurélie",
    "arrondissement": "",
    "region_adm": "Chaudière-Appalaches",
    "population": "852"
  },
  {
    "ID": "6368",
    "nom_corrige2": "Sébastien Roy",
    "nom_famille": "Roy",
    "titre_genre2": "Conseiller",
    "remuneration": "254",
    "allocation": "127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "381",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "6369",
    "nom_corrige2": "Mathieu Guillemette",
    "nom_famille": "Guillemette",
    "titre_genre2": "Conseiller",
    "remuneration": "254",
    "allocation": "127",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "381",
    "ville": "Roquemaure",
    "arrondissement": "",
    "region_adm": "Abitibi-Témiscamingue",
    "population": "409"
  },
  {
    "ID": "6370",
    "nom_corrige2": "Michèle Marquis",
    "nom_famille": "Marquis",
    "titre_genre2": "Conseillère",
    "remuneration": "255",
    "allocation": "116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "371",
    "ville": "Saint-Denis-De La Bouteillerie",
    "arrondissement": "",
    "region_adm": "Bas-Saint-Laurent",
    "population": "516"
  },
  {
    "ID": "6371",
    "nom_corrige2": "Gilles Isabel",
    "nom_famille": "Isabel",
    "titre_genre2": "Conseiller",
    "remuneration": "232",
    "allocation": "116",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "348",
    "ville": "Saint-Romain",
    "arrondissement": "",
    "region_adm": "Estrie",
    "population": "707"
  },
  {
    "ID": "6372",
    "nom_corrige2": "Suzie Breton",
    "nom_famille": "Breton",
    "titre_genre2": "Conseillère",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "L'Île-Cadieux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "128"
  },
  {
    "ID": "6373",
    "nom_corrige2": "Daniel Martel",
    "nom_famille": "Martel",
    "titre_genre2": "Maire",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "L'Île-Cadieux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "128"
  },
  {
    "ID": "6374",
    "nom_corrige2": "Martin Charland",
    "nom_famille": "Charland",
    "titre_genre2": "Conseiller",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "L'Île-Cadieux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "128"
  },
  {
    "ID": "6375",
    "nom_corrige2": "Brian Falus",
    "nom_famille": "Falus",
    "titre_genre2": "Conseiller",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "L'Île-Cadieux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "128"
  },
  {
    "ID": "6376",
    "nom_corrige2": "Larry Bernier",
    "nom_famille": "Bernier",
    "titre_genre2": "Maire",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "Lac-Édouard",
    "arrondissement": "",
    "region_adm": "Mauricie",
    "population": "184"
  },
  {
    "ID": "6377",
    "nom_corrige2": "Marion Bichoff",
    "nom_famille": "Bichoff",
    "titre_genre2": "Conseillère",
    "remuneration": "0",
    "allocation": "0",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "0",
    "ville": "L'Île-Cadieux",
    "arrondissement": "",
    "region_adm": "Montérégie",
    "population": "128"
  }
]